var affiliate_whitelabel_promo =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpaffiliate_whitelabel_promo"];
/******/ 	window["webpackJsonpaffiliate_whitelabel_promo"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		5: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "chunks/ch." + chunkId + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/mcst/dist/affiliate-whitelabel-promo/e01d9d030b1891ed280d/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 26);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/sprite.png", __webpack_require__.p + "images/sprite.png");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader 
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	}),
	getElement = (function(fn) {
		var memo = {};
		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				memo[selector] = fn.call(this, selector);
			}
			return memo[selector]
		};
	})(function (styleTarget) {
		return document.querySelector(styleTarget)
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [],
	fixUrls = __webpack_require__(35);

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (typeof options.insertInto === "undefined") options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var styleTarget = getElement(options.insertInto)
	if (!styleTarget) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			styleTarget.insertBefore(styleElement, styleTarget.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			styleTarget.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		styleTarget.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	options.attrs.type = "text/css";

	attachTagAttrs(styleElement, options.attrs);
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	attachTagAttrs(linkElement, options.attrs);
	insertStyleElement(options, linkElement);
	return linkElement;
}

function attachTagAttrs(element, attrs) {
	Object.keys(attrs).forEach(function (key) {
		element.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement, options);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
	and there is no publicPath defined then lets turn convertToAbsoluteUrls
	on by default.  Otherwise default to the convertToAbsoluteUrls option
	directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls){
		css = fixUrls(css);
	}

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/montserrat-hairline-webfont.woff", __webpack_require__.p + "fonts/21S8MeN.woff");

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/montserrat-hairline-webfont.ttf", __webpack_require__.p + "fonts/3kTksFZ.ttf");

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/montserrat-hairline-webfont.svg", __webpack_require__.p + "fonts/montserrat-hairline-webfont.svg");

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/woodfordbourne-italic-webfont.woff", __webpack_require__.p + "fonts/2OPdAho.woff");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/woodfordbourne-italic-webfont.ttf", __webpack_require__.p + "fonts/18EBqYn.ttf");

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/woodfordbourne-italic-webfont.svg", __webpack_require__.p + "fonts/woodfordbourne-italic-webfont.svg");

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/woodfordbourne-regular-webfont.woff", __webpack_require__.p + "fonts/29nw5zR.woff");

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/woodfordbourne-regular-webfont.ttf", __webpack_require__.p + "fonts/2ndGGSc.ttf");

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("fonts/woodfordbourne-regular-webfont.svg", __webpack_require__.p + "fonts/woodfordbourne-regular-webfont.svg");

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Widget 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/jQuery.widget/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(12) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

var widget_uuid = 0,
	widget_slice = Array.prototype.slice;

$.cleanData = (function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; (elem = elems[i]) != null; i++ ) {
			try {

				// Only trigger remove when necessary to save time
				events = $._data( elem, "events" );
				if ( events && events.remove ) {
					$( elem ).triggerHandler( "remove" );
				}

			// http://bugs.jquery.com/ticket/8235
			} catch ( e ) {}
		}
		orig( elems );
	};
})( $.cleanData );

$.widget = function( name, base, prototype ) {
	var fullName, existingConstructor, constructor, basePrototype,
		// proxiedPrototype allows the provided prototype to remain unmodified
		// so that it can be used as a mixin for multiple widgets (#8876)
		proxiedPrototype = {},
		namespace = name.split( "." )[ 0 ];

	name = name.split( "." )[ 1 ];
	fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	// create selector for plugin
	$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {
		// allow instantiation without "new" keyword
		if ( !this._createWidget ) {
			return new constructor( options, element );
		}

		// allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};
	// extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,
		// copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),
		// track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	});

	basePrototype = new base();
	// we need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( !$.isFunction( value ) ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = (function() {
			var _super = function() {
					return base.prototype[ prop ].apply( this, arguments );
				},
				_superApply = function( args ) {
					return base.prototype[ prop ].apply( this, args );
				};
			return function() {
				var __super = this._super,
					__superApply = this._superApply,
					returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		})();
	});
	constructor.prototype = $.widget.extend( basePrototype, {
		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? (basePrototype.widgetEventPrefix || name) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	});

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
		});
		// remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widget_slice.call( arguments, 1 ),
		inputIndex = 0,
		inputLength = input.length,
		key,
		value;
	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :
						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );
				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string",
			args = widget_slice.call( arguments, 1 ),
			returnValue = this;

		if ( isMethodCall ) {
			this.each(function() {
				var methodValue,
					instance = $.data( this, fullName );
				if ( options === "instance" ) {
					returnValue = instance;
					return false;
				}
				if ( !instance ) {
					return $.error( "cannot call methods on " + name + " prior to initialization; " +
						"attempted to call method '" + options + "'" );
				}
				if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
					return $.error( "no such method '" + options + "' for " + name + " widget instance" );
				}
				methodValue = instance[ options ].apply( instance, args );
				if ( methodValue !== instance && methodValue !== undefined ) {
					returnValue = methodValue && methodValue.jquery ?
						returnValue.pushStack( methodValue.get() ) :
						methodValue;
					return false;
				}
			});
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat(args) );
			}

			this.each(function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			});
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",
	options: {
		disabled: false,

		// callbacks
		create: null
	},
	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widget_uuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			});
			this.document = $( element.style ?
				// element within the document
				element.ownerDocument :
				// element is window or document
				element.document || element );
			this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();
		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},
	_getCreateOptions: $.noop,
	_getCreateEventData: $.noop,
	_create: $.noop,
	_init: $.noop,

	destroy: function() {
		this._destroy();
		// we can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.unbind( this.eventNamespace )
			.removeData( this.widgetFullName )
			// support: jquery <1.6.3
			// http://bugs.jquery.com/ticket/9413
			.removeData( $.camelCase( this.widgetFullName ) );
		this.widget()
			.unbind( this.eventNamespace )
			.removeAttr( "aria-disabled" )
			.removeClass(
				this.widgetFullName + "-disabled " +
				"ui-state-disabled" );

		// clean up events and states
		this.bindings.unbind( this.eventNamespace );
		this.hoverable.removeClass( "ui-state-hover" );
		this.focusable.removeClass( "ui-state-focus" );
	},
	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key,
			parts,
			curOption,
			i;

		if ( arguments.length === 0 ) {
			// don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {
			// handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},
	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},
	_setOption: function( key, value ) {
		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this.widget()
				.toggleClass( this.widgetFullName + "-disabled", !!value );

			// If the widget is becoming disabled, then nothing is interactive
			if ( value ) {
				this.hoverable.removeClass( "ui-state-hover" );
				this.focusable.removeClass( "ui-state-focus" );
			}
		}

		return this;
	},

	enable: function() {
		return this._setOptions({ disabled: false });
	},
	disable: function() {
		return this._setOptions({ disabled: true });
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement,
			instance = this;

		// no suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// no element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {
				// allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
							$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ ),
				eventName = match[1] + instance.eventNamespace,
				selector = match[2];
			if ( selector ) {
				delegateElement.delegate( selector, eventName, handlerProxy );
			} else {
				element.bind( eventName, handlerProxy );
			}
		});
	},

	_off: function( element, eventName ) {
		eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.unbind( eventName ).undelegate( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				$( event.currentTarget ).addClass( "ui-state-hover" );
			},
			mouseleave: function( event ) {
				$( event.currentTarget ).removeClass( "ui-state-hover" );
			}
		});
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				$( event.currentTarget ).addClass( "ui-state-focus" );
			},
			focusout: function( event ) {
				$( event.currentTarget ).removeClass( "ui-state-focus" );
			}
		});
	},

	_trigger: function( type, event, data ) {
		var prop, orig,
			callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();
		// the original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( $.isFunction( callback ) &&
			callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}
		var hasOptions,
			effectName = !options ?
				method :
				options === true || typeof options === "number" ?
					defaultEffect :
					options.effect || defaultEffect;
		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		}
		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;
		if ( options.delay ) {
			element.delay( options.delay );
		}
		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue(function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			});
		}
	};
});

return $.widget;

}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Core 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(12) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

// $.ui might exist from components with no dependencies, e.g., $.ui.position
$.ui = $.ui || {};

$.extend( $.ui, {
	version: "1.11.4",

	keyCode: {
		BACKSPACE: 8,
		COMMA: 188,
		DELETE: 46,
		DOWN: 40,
		END: 35,
		ENTER: 13,
		ESCAPE: 27,
		HOME: 36,
		LEFT: 37,
		PAGE_DOWN: 34,
		PAGE_UP: 33,
		PERIOD: 190,
		RIGHT: 39,
		SPACE: 32,
		TAB: 9,
		UP: 38
	}
});

// plugins
$.fn.extend({
	scrollParent: function( includeHidden ) {
		var position = this.css( "position" ),
			excludeStaticParent = position === "absolute",
			overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
			scrollParent = this.parents().filter( function() {
				var parent = $( this );
				if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
					return false;
				}
				return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) + parent.css( "overflow-x" ) );
			}).eq( 0 );

		return position === "fixed" || !scrollParent.length ? $( this[ 0 ].ownerDocument || document ) : scrollParent;
	},

	uniqueId: (function() {
		var uuid = 0;

		return function() {
			return this.each(function() {
				if ( !this.id ) {
					this.id = "ui-id-" + ( ++uuid );
				}
			});
		};
	})(),

	removeUniqueId: function() {
		return this.each(function() {
			if ( /^ui-id-\d+$/.test( this.id ) ) {
				$( this ).removeAttr( "id" );
			}
		});
	}
});

// selectors
function focusable( element, isTabIndexNotNaN ) {
	var map, mapName, img,
		nodeName = element.nodeName.toLowerCase();
	if ( "area" === nodeName ) {
		map = element.parentNode;
		mapName = map.name;
		if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
			return false;
		}
		img = $( "img[usemap='#" + mapName + "']" )[ 0 ];
		return !!img && visible( img );
	}
	return ( /^(input|select|textarea|button|object)$/.test( nodeName ) ?
		!element.disabled :
		"a" === nodeName ?
			element.href || isTabIndexNotNaN :
			isTabIndexNotNaN) &&
		// the element and all of its ancestors must be visible
		visible( element );
}

function visible( element ) {
	return $.expr.filters.visible( element ) &&
		!$( element ).parents().addBack().filter(function() {
			return $.css( this, "visibility" ) === "hidden";
		}).length;
}

$.extend( $.expr[ ":" ], {
	data: $.expr.createPseudo ?
		$.expr.createPseudo(function( dataName ) {
			return function( elem ) {
				return !!$.data( elem, dataName );
			};
		}) :
		// support: jQuery <1.8
		function( elem, i, match ) {
			return !!$.data( elem, match[ 3 ] );
		},

	focusable: function( element ) {
		return focusable( element, !isNaN( $.attr( element, "tabindex" ) ) );
	},

	tabbable: function( element ) {
		var tabIndex = $.attr( element, "tabindex" ),
			isTabIndexNaN = isNaN( tabIndex );
		return ( isTabIndexNaN || tabIndex >= 0 ) && focusable( element, !isTabIndexNaN );
	}
});

// support: jQuery <1.8
if ( !$( "<a>" ).outerWidth( 1 ).jquery ) {
	$.each( [ "Width", "Height" ], function( i, name ) {
		var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
			type = name.toLowerCase(),
			orig = {
				innerWidth: $.fn.innerWidth,
				innerHeight: $.fn.innerHeight,
				outerWidth: $.fn.outerWidth,
				outerHeight: $.fn.outerHeight
			};

		function reduce( elem, size, border, margin ) {
			$.each( side, function() {
				size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
				if ( border ) {
					size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
				}
				if ( margin ) {
					size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
				}
			});
			return size;
		}

		$.fn[ "inner" + name ] = function( size ) {
			if ( size === undefined ) {
				return orig[ "inner" + name ].call( this );
			}

			return this.each(function() {
				$( this ).css( type, reduce( this, size ) + "px" );
			});
		};

		$.fn[ "outer" + name] = function( size, margin ) {
			if ( typeof size !== "number" ) {
				return orig[ "outer" + name ].call( this, size );
			}

			return this.each(function() {
				$( this).css( type, reduce( this, size, true, margin ) + "px" );
			});
		};
	});
}

// support: jQuery <1.8
if ( !$.fn.addBack ) {
	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

// support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
if ( $( "<a>" ).data( "a-b", "a" ).removeData( "a-b" ).data( "a-b" ) ) {
	$.fn.removeData = (function( removeData ) {
		return function( key ) {
			if ( arguments.length ) {
				return removeData.call( this, $.camelCase( key ) );
			} else {
				return removeData.call( this );
			}
		};
	})( $.fn.removeData );
}

// deprecated
$.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );

$.fn.extend({
	focus: (function( orig ) {
		return function( delay, fn ) {
			return typeof delay === "number" ?
				this.each(function() {
					var elem = this;
					setTimeout(function() {
						$( elem ).focus();
						if ( fn ) {
							fn.call( elem );
						}
					}, delay );
				}) :
				orig.apply( this, arguments );
		};
	})( $.fn.focus ),

	disableSelection: (function() {
		var eventType = "onselectstart" in document.createElement( "div" ) ?
			"selectstart" :
			"mousedown";

		return function() {
			return this.bind( eventType + ".ui-disableSelection", function( event ) {
				event.preventDefault();
			});
		};
	})(),

	enableSelection: function() {
		return this.unbind( ".ui-disableSelection" );
	},

	zIndex: function( zIndex ) {
		if ( zIndex !== undefined ) {
			return this.css( "zIndex", zIndex );
		}

		if ( this.length ) {
			var elem = $( this[ 0 ] ), position, value;
			while ( elem.length && elem[ 0 ] !== document ) {
				// Ignore z-index if position is set to a value where z-index is ignored by the browser
				// This makes behavior of this function consistent across browsers
				// WebKit always returns auto if the element is positioned
				position = elem.css( "position" );
				if ( position === "absolute" || position === "relative" || position === "fixed" ) {
					// IE returns 0 when zIndex is not specified
					// other browsers return a string
					// we ignore the case of nested elements with an explicit value of 0
					// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
					value = parseInt( elem.css( "zIndex" ), 10 );
					if ( !isNaN( value ) && value !== 0 ) {
						return value;
					}
				}
				elem = elem.parent();
			}
		}

		return 0;
	}
});

// $.ui.plugin is deprecated. Use $.widget() extensions instead.
$.ui.plugin = {
	add: function( module, option, set ) {
		var i,
			proto = $.ui[ module ].prototype;
		for ( i in set ) {
			proto.plugins[ i ] = proto.plugins[ i ] || [];
			proto.plugins[ i ].push( [ option, set[ i ] ] );
		}
	},
	call: function( instance, name, args, allowDisconnected ) {
		var i,
			set = instance.plugins[ name ];

		if ( !set ) {
			return;
		}

		if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode || instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
			return;
		}

		for ( i = 0; i < set.length; i++ ) {
			if ( instance.options[ set[ i ][ 0 ] ] ) {
				set[ i ][ 1 ].apply( instance.element, args );
			}
		}
	}
};

}));


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Mouse 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/mouse/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(12),
			__webpack_require__(13)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

var mouseHandled = false;
$( document ).mouseup( function() {
	mouseHandled = false;
});

return $.widget("ui.mouse", {
	version: "1.11.4",
	options: {
		cancel: "input,textarea,button,select,option",
		distance: 1,
		delay: 0
	},
	_mouseInit: function() {
		var that = this;

		this.element
			.bind("mousedown." + this.widgetName, function(event) {
				return that._mouseDown(event);
			})
			.bind("click." + this.widgetName, function(event) {
				if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
					$.removeData(event.target, that.widgetName + ".preventClickEvent");
					event.stopImmediatePropagation();
					return false;
				}
			});

		this.started = false;
	},

	// TODO: make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	_mouseDestroy: function() {
		this.element.unbind("." + this.widgetName);
		if ( this._mouseMoveDelegate ) {
			this.document
				.unbind("mousemove." + this.widgetName, this._mouseMoveDelegate)
				.unbind("mouseup." + this.widgetName, this._mouseUpDelegate);
		}
	},

	_mouseDown: function(event) {
		// don't let more than one widget handle mouseStart
		if ( mouseHandled ) {
			return;
		}

		this._mouseMoved = false;

		// we may have missed mouseup (out of window)
		(this._mouseStarted && this._mouseUp(event));

		this._mouseDownEvent = event;

		var that = this,
			btnIsLeft = (event.which === 1),
			// event.target.nodeName works around a bug in IE 8 with
			// disabled inputs (#7620)
			elIsCancel = (typeof this.options.cancel === "string" && event.target.nodeName ? $(event.target).closest(this.options.cancel).length : false);
		if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
			return true;
		}

		this.mouseDelayMet = !this.options.delay;
		if (!this.mouseDelayMet) {
			this._mouseDelayTimer = setTimeout(function() {
				that.mouseDelayMet = true;
			}, this.options.delay);
		}

		if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
			this._mouseStarted = (this._mouseStart(event) !== false);
			if (!this._mouseStarted) {
				event.preventDefault();
				return true;
			}
		}

		// Click event may never have fired (Gecko & Opera)
		if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) {
			$.removeData(event.target, this.widgetName + ".preventClickEvent");
		}

		// these delegates are required to keep context
		this._mouseMoveDelegate = function(event) {
			return that._mouseMove(event);
		};
		this._mouseUpDelegate = function(event) {
			return that._mouseUp(event);
		};

		this.document
			.bind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.bind( "mouseup." + this.widgetName, this._mouseUpDelegate );

		event.preventDefault();

		mouseHandled = true;
		return true;
	},

	_mouseMove: function(event) {
		// Only check for mouseups outside the document if you've moved inside the document
		// at least once. This prevents the firing of mouseup in the case of IE<9, which will
		// fire a mousemove event if content is placed under the cursor. See #7778
		// Support: IE <9
		if ( this._mouseMoved ) {
			// IE mouseup check - mouseup happened when mouse was out of window
			if ($.ui.ie && ( !document.documentMode || document.documentMode < 9 ) && !event.button) {
				return this._mouseUp(event);

			// Iframe mouseup check - mouseup occurred in another document
			} else if ( !event.which ) {
				return this._mouseUp( event );
			}
		}

		if ( event.which || event.button ) {
			this._mouseMoved = true;
		}

		if (this._mouseStarted) {
			this._mouseDrag(event);
			return event.preventDefault();
		}

		if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
			this._mouseStarted =
				(this._mouseStart(this._mouseDownEvent, event) !== false);
			(this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event));
		}

		return !this._mouseStarted;
	},

	_mouseUp: function(event) {
		this.document
			.unbind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.unbind( "mouseup." + this.widgetName, this._mouseUpDelegate );

		if (this._mouseStarted) {
			this._mouseStarted = false;

			if (event.target === this._mouseDownEvent.target) {
				$.data(event.target, this.widgetName + ".preventClickEvent", true);
			}

			this._mouseStop(event);
		}

		mouseHandled = false;
		return false;
	},

	_mouseDistanceMet: function(event) {
		return (Math.max(
				Math.abs(this._mouseDownEvent.pageX - event.pageX),
				Math.abs(this._mouseDownEvent.pageY - event.pageY)
			) >= this.options.distance
		);
	},

	_mouseDelayMet: function(/* event */) {
		return this.mouseDelayMet;
	},

	// These are placeholder methods, to be overriden by extending plugin
	_mouseStart: function(/* event */) {},
	_mouseDrag: function(/* event */) {},
	_mouseStop: function(/* event */) {},
	_mouseCapture: function(/* event */) { return true; }
});

}));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	'use strict';

	return {
		getShortUid: function getShortUid() {
			var _udid = function _udid(_exoUid) {
				return _exoUid.split('|')[1];
			};

			if (!fox.exodentity || !fox.exodentity._included || !fox.exodentity.getSavedUid()) {
				return fox.site.wait(fox.site, 'exodentity_fingerprint_recieved', { prefix: 'root_exodentity' }).then(function (data) {
					return _udid(data.params.fingerprint);
				});
			}

			return fox.Promise.resolve(_udid(fox.exodentity.getSavedUid()));
		}
	};
};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	if (typeof execScript === "function")
		execScript(src);
	else
		eval.call(null, src);
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/models/avatar.gif", __webpack_require__.p + "images/models/avatar.gif");

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Dialog 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/dialog/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(12),
			__webpack_require__(14),
			__webpack_require__(13),
			__webpack_require__(40),
			__webpack_require__(41),
			__webpack_require__(15),
			__webpack_require__(20),
			__webpack_require__(42)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

return $.widget( "ui.dialog", {
	version: "1.11.4",
	options: {
		appendTo: "body",
		autoOpen: true,
		buttons: [],
		closeOnEscape: true,
		closeText: "Close",
		dialogClass: "",
		draggable: true,
		hide: null,
		height: "auto",
		maxHeight: null,
		maxWidth: null,
		minHeight: 150,
		minWidth: 150,
		modal: false,
		position: {
			my: "center",
			at: "center",
			of: window,
			collision: "fit",
			// Ensure the titlebar is always visible
			using: function( pos ) {
				var topOffset = $( this ).css( pos ).offset().top;
				if ( topOffset < 0 ) {
					$( this ).css( "top", pos.top - topOffset );
				}
			}
		},
		resizable: true,
		show: null,
		title: null,
		width: 300,

		// callbacks
		beforeClose: null,
		close: null,
		drag: null,
		dragStart: null,
		dragStop: null,
		focus: null,
		open: null,
		resize: null,
		resizeStart: null,
		resizeStop: null
	},

	sizeRelatedOptions: {
		buttons: true,
		height: true,
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true,
		width: true
	},

	resizableRelatedOptions: {
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true
	},

	_create: function() {
		this.originalCss = {
			display: this.element[ 0 ].style.display,
			width: this.element[ 0 ].style.width,
			minHeight: this.element[ 0 ].style.minHeight,
			maxHeight: this.element[ 0 ].style.maxHeight,
			height: this.element[ 0 ].style.height
		};
		this.originalPosition = {
			parent: this.element.parent(),
			index: this.element.parent().children().index( this.element )
		};
		this.originalTitle = this.element.attr( "title" );
		this.options.title = this.options.title || this.originalTitle;

		this._createWrapper();

		this.element
			.show()
			.removeAttr( "title" )
			.addClass( "ui-dialog-content ui-widget-content" )
			.appendTo( this.uiDialog );

		this._createTitlebar();
		this._createButtonPane();

		if ( this.options.draggable && $.fn.draggable ) {
			this._makeDraggable();
		}
		if ( this.options.resizable && $.fn.resizable ) {
			this._makeResizable();
		}

		this._isOpen = false;

		this._trackFocus();
	},

	_init: function() {
		if ( this.options.autoOpen ) {
			this.open();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;
		if ( element && (element.jquery || element.nodeType) ) {
			return $( element );
		}
		return this.document.find( element || "body" ).eq( 0 );
	},

	_destroy: function() {
		var next,
			originalPosition = this.originalPosition;

		this._untrackInstance();
		this._destroyOverlay();

		this.element
			.removeUniqueId()
			.removeClass( "ui-dialog-content ui-widget-content" )
			.css( this.originalCss )
			// Without detaching first, the following becomes really slow
			.detach();

		this.uiDialog.stop( true, true ).remove();

		if ( this.originalTitle ) {
			this.element.attr( "title", this.originalTitle );
		}

		next = originalPosition.parent.children().eq( originalPosition.index );
		// Don't try to place the dialog next to itself (#8613)
		if ( next.length && next[ 0 ] !== this.element[ 0 ] ) {
			next.before( this.element );
		} else {
			originalPosition.parent.append( this.element );
		}
	},

	widget: function() {
		return this.uiDialog;
	},

	disable: $.noop,
	enable: $.noop,

	close: function( event ) {
		var activeElement,
			that = this;

		if ( !this._isOpen || this._trigger( "beforeClose", event ) === false ) {
			return;
		}

		this._isOpen = false;
		this._focusedElement = null;
		this._destroyOverlay();
		this._untrackInstance();

		if ( !this.opener.filter( ":focusable" ).focus().length ) {

			// support: IE9
			// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
			try {
				activeElement = this.document[ 0 ].activeElement;

				// Support: IE9, IE10
				// If the <body> is blurred, IE will switch windows, see #4520
				if ( activeElement && activeElement.nodeName.toLowerCase() !== "body" ) {

					// Hiding a focused element doesn't trigger blur in WebKit
					// so in case we have nothing to focus on, explicitly blur the active element
					// https://bugs.webkit.org/show_bug.cgi?id=47182
					$( activeElement ).blur();
				}
			} catch ( error ) {}
		}

		this._hide( this.uiDialog, this.options.hide, function() {
			that._trigger( "close", event );
		});
	},

	isOpen: function() {
		return this._isOpen;
	},

	moveToTop: function() {
		this._moveToTop();
	},

	_moveToTop: function( event, silent ) {
		var moved = false,
			zIndices = this.uiDialog.siblings( ".ui-front:visible" ).map(function() {
				return +$( this ).css( "z-index" );
			}).get(),
			zIndexMax = Math.max.apply( null, zIndices );

		if ( zIndexMax >= +this.uiDialog.css( "z-index" ) ) {
			this.uiDialog.css( "z-index", zIndexMax + 1 );
			moved = true;
		}

		if ( moved && !silent ) {
			this._trigger( "focus", event );
		}
		return moved;
	},

	open: function() {
		var that = this;
		if ( this._isOpen ) {
			if ( this._moveToTop() ) {
				this._focusTabbable();
			}
			return;
		}

		this._isOpen = true;
		this.opener = $( this.document[ 0 ].activeElement );

		this._size();
		this._position();
		this._createOverlay();
		this._moveToTop( null, true );

		// Ensure the overlay is moved to the top with the dialog, but only when
		// opening. The overlay shouldn't move after the dialog is open so that
		// modeless dialogs opened after the modal dialog stack properly.
		if ( this.overlay ) {
			this.overlay.css( "z-index", this.uiDialog.css( "z-index" ) - 1 );
		}

		this._show( this.uiDialog, this.options.show, function() {
			that._focusTabbable();
			that._trigger( "focus" );
		});

		// Track the dialog immediately upon openening in case a focus event
		// somehow occurs outside of the dialog before an element inside the
		// dialog is focused (#10152)
		this._makeFocusTarget();

		this._trigger( "open" );
	},

	_focusTabbable: function() {
		// Set focus to the first match:
		// 1. An element that was focused previously
		// 2. First element inside the dialog matching [autofocus]
		// 3. Tabbable element inside the content element
		// 4. Tabbable element inside the buttonpane
		// 5. The close button
		// 6. The dialog itself
		var hasFocus = this._focusedElement;
		if ( !hasFocus ) {
			hasFocus = this.element.find( "[autofocus]" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.element.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogButtonPane.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogTitlebarClose.filter( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialog;
		}
		hasFocus.eq( 0 ).focus();
	},

	_keepFocus: function( event ) {
		function checkFocus() {
			var activeElement = this.document[0].activeElement,
				isActive = this.uiDialog[0] === activeElement ||
					$.contains( this.uiDialog[0], activeElement );
			if ( !isActive ) {
				this._focusTabbable();
			}
		}
		event.preventDefault();
		checkFocus.call( this );
		// support: IE
		// IE <= 8 doesn't prevent moving focus even with event.preventDefault()
		// so we check again later
		this._delay( checkFocus );
	},

	_createWrapper: function() {
		this.uiDialog = $("<div>")
			.addClass( "ui-dialog ui-widget ui-widget-content ui-corner-all ui-front " +
				this.options.dialogClass )
			.hide()
			.attr({
				// Setting tabIndex makes the div focusable
				tabIndex: -1,
				role: "dialog"
			})
			.appendTo( this._appendTo() );

		this._on( this.uiDialog, {
			keydown: function( event ) {
				if ( this.options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode &&
						event.keyCode === $.ui.keyCode.ESCAPE ) {
					event.preventDefault();
					this.close( event );
					return;
				}

				// prevent tabbing out of dialogs
				if ( event.keyCode !== $.ui.keyCode.TAB || event.isDefaultPrevented() ) {
					return;
				}
				var tabbables = this.uiDialog.find( ":tabbable" ),
					first = tabbables.filter( ":first" ),
					last = tabbables.filter( ":last" );

				if ( ( event.target === last[0] || event.target === this.uiDialog[0] ) && !event.shiftKey ) {
					this._delay(function() {
						first.focus();
					});
					event.preventDefault();
				} else if ( ( event.target === first[0] || event.target === this.uiDialog[0] ) && event.shiftKey ) {
					this._delay(function() {
						last.focus();
					});
					event.preventDefault();
				}
			},
			mousedown: function( event ) {
				if ( this._moveToTop( event ) ) {
					this._focusTabbable();
				}
			}
		});

		// We assume that any existing aria-describedby attribute means
		// that the dialog content is marked up properly
		// otherwise we brute force the content as the description
		if ( !this.element.find( "[aria-describedby]" ).length ) {
			this.uiDialog.attr({
				"aria-describedby": this.element.uniqueId().attr( "id" )
			});
		}
	},

	_createTitlebar: function() {
		var uiDialogTitle;

		this.uiDialogTitlebar = $( "<div>" )
			.addClass( "ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix" )
			.prependTo( this.uiDialog );
		this._on( this.uiDialogTitlebar, {
			mousedown: function( event ) {
				// Don't prevent click on close button (#8838)
				// Focusing a dialog that is partially scrolled out of view
				// causes the browser to scroll it into view, preventing the click event
				if ( !$( event.target ).closest( ".ui-dialog-titlebar-close" ) ) {
					// Dialog isn't getting focus when dragging (#8063)
					this.uiDialog.focus();
				}
			}
		});

		// support: IE
		// Use type="button" to prevent enter keypresses in textboxes from closing the
		// dialog in IE (#9312)
		this.uiDialogTitlebarClose = $( "<button type='button'></button>" )
			.button({
				label: this.options.closeText,
				icons: {
					primary: "ui-icon-closethick"
				},
				text: false
			})
			.addClass( "ui-dialog-titlebar-close" )
			.appendTo( this.uiDialogTitlebar );
		this._on( this.uiDialogTitlebarClose, {
			click: function( event ) {
				event.preventDefault();
				this.close( event );
			}
		});

		uiDialogTitle = $( "<span>" )
			.uniqueId()
			.addClass( "ui-dialog-title" )
			.prependTo( this.uiDialogTitlebar );
		this._title( uiDialogTitle );

		this.uiDialog.attr({
			"aria-labelledby": uiDialogTitle.attr( "id" )
		});
	},

	_title: function( title ) {
		if ( !this.options.title ) {
			title.html( "&#160;" );
		}
		title.text( this.options.title );
	},

	_createButtonPane: function() {
		this.uiDialogButtonPane = $( "<div>" )
			.addClass( "ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" );

		this.uiButtonSet = $( "<div>" )
			.addClass( "ui-dialog-buttonset" )
			.appendTo( this.uiDialogButtonPane );

		this._createButtons();
	},

	_createButtons: function() {
		var that = this,
			buttons = this.options.buttons;

		// if we already have a button pane, remove it
		this.uiDialogButtonPane.remove();
		this.uiButtonSet.empty();

		if ( $.isEmptyObject( buttons ) || ($.isArray( buttons ) && !buttons.length) ) {
			this.uiDialog.removeClass( "ui-dialog-buttons" );
			return;
		}

		$.each( buttons, function( name, props ) {
			var click, buttonOptions;
			props = $.isFunction( props ) ?
				{ click: props, text: name } :
				props;
			// Default to a non-submitting button
			props = $.extend( { type: "button" }, props );
			// Change the context for the click callback to be the main element
			click = props.click;
			props.click = function() {
				click.apply( that.element[ 0 ], arguments );
			};
			buttonOptions = {
				icons: props.icons,
				text: props.showText
			};
			delete props.icons;
			delete props.showText;
			$( "<button></button>", props )
				.button( buttonOptions )
				.appendTo( that.uiButtonSet );
		});
		this.uiDialog.addClass( "ui-dialog-buttons" );
		this.uiDialogButtonPane.appendTo( this.uiDialog );
	},

	_makeDraggable: function() {
		var that = this,
			options = this.options;

		function filteredUi( ui ) {
			return {
				position: ui.position,
				offset: ui.offset
			};
		}

		this.uiDialog.draggable({
			cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
			handle: ".ui-dialog-titlebar",
			containment: "document",
			start: function( event, ui ) {
				$( this ).addClass( "ui-dialog-dragging" );
				that._blockFrames();
				that._trigger( "dragStart", event, filteredUi( ui ) );
			},
			drag: function( event, ui ) {
				that._trigger( "drag", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var left = ui.offset.left - that.document.scrollLeft(),
					top = ui.offset.top - that.document.scrollTop();

				options.position = {
					my: "left top",
					at: "left" + (left >= 0 ? "+" : "") + left + " " +
						"top" + (top >= 0 ? "+" : "") + top,
					of: that.window
				};
				$( this ).removeClass( "ui-dialog-dragging" );
				that._unblockFrames();
				that._trigger( "dragStop", event, filteredUi( ui ) );
			}
		});
	},

	_makeResizable: function() {
		var that = this,
			options = this.options,
			handles = options.resizable,
			// .ui-resizable has position: relative defined in the stylesheet
			// but dialogs have to use absolute or fixed positioning
			position = this.uiDialog.css("position"),
			resizeHandles = typeof handles === "string" ?
				handles	:
				"n,e,s,w,se,sw,ne,nw";

		function filteredUi( ui ) {
			return {
				originalPosition: ui.originalPosition,
				originalSize: ui.originalSize,
				position: ui.position,
				size: ui.size
			};
		}

		this.uiDialog.resizable({
			cancel: ".ui-dialog-content",
			containment: "document",
			alsoResize: this.element,
			maxWidth: options.maxWidth,
			maxHeight: options.maxHeight,
			minWidth: options.minWidth,
			minHeight: this._minHeight(),
			handles: resizeHandles,
			start: function( event, ui ) {
				$( this ).addClass( "ui-dialog-resizing" );
				that._blockFrames();
				that._trigger( "resizeStart", event, filteredUi( ui ) );
			},
			resize: function( event, ui ) {
				that._trigger( "resize", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var offset = that.uiDialog.offset(),
					left = offset.left - that.document.scrollLeft(),
					top = offset.top - that.document.scrollTop();

				options.height = that.uiDialog.height();
				options.width = that.uiDialog.width();
				options.position = {
					my: "left top",
					at: "left" + (left >= 0 ? "+" : "") + left + " " +
						"top" + (top >= 0 ? "+" : "") + top,
					of: that.window
				};
				$( this ).removeClass( "ui-dialog-resizing" );
				that._unblockFrames();
				that._trigger( "resizeStop", event, filteredUi( ui ) );
			}
		})
		.css( "position", position );
	},

	_trackFocus: function() {
		this._on( this.widget(), {
			focusin: function( event ) {
				this._makeFocusTarget();
				this._focusedElement = $( event.target );
			}
		});
	},

	_makeFocusTarget: function() {
		this._untrackInstance();
		this._trackingInstances().unshift( this );
	},

	_untrackInstance: function() {
		var instances = this._trackingInstances(),
			exists = $.inArray( this, instances );
		if ( exists !== -1 ) {
			instances.splice( exists, 1 );
		}
	},

	_trackingInstances: function() {
		var instances = this.document.data( "ui-dialog-instances" );
		if ( !instances ) {
			instances = [];
			this.document.data( "ui-dialog-instances", instances );
		}
		return instances;
	},

	_minHeight: function() {
		var options = this.options;

		return options.height === "auto" ?
			options.minHeight :
			Math.min( options.minHeight, options.height );
	},

	_position: function() {
		// Need to show the dialog to get the actual offset in the position plugin
		var isVisible = this.uiDialog.is( ":visible" );
		if ( !isVisible ) {
			this.uiDialog.show();
		}
		this.uiDialog.position( this.options.position );
		if ( !isVisible ) {
			this.uiDialog.hide();
		}
	},

	_setOptions: function( options ) {
		var that = this,
			resize = false,
			resizableOptions = {};

		$.each( options, function( key, value ) {
			that._setOption( key, value );

			if ( key in that.sizeRelatedOptions ) {
				resize = true;
			}
			if ( key in that.resizableRelatedOptions ) {
				resizableOptions[ key ] = value;
			}
		});

		if ( resize ) {
			this._size();
			this._position();
		}
		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", resizableOptions );
		}
	},

	_setOption: function( key, value ) {
		var isDraggable, isResizable,
			uiDialog = this.uiDialog;

		if ( key === "dialogClass" ) {
			uiDialog
				.removeClass( this.options.dialogClass )
				.addClass( value );
		}

		if ( key === "disabled" ) {
			return;
		}

		this._super( key, value );

		if ( key === "appendTo" ) {
			this.uiDialog.appendTo( this._appendTo() );
		}

		if ( key === "buttons" ) {
			this._createButtons();
		}

		if ( key === "closeText" ) {
			this.uiDialogTitlebarClose.button({
				// Ensure that we always pass a string
				label: "" + value
			});
		}

		if ( key === "draggable" ) {
			isDraggable = uiDialog.is( ":data(ui-draggable)" );
			if ( isDraggable && !value ) {
				uiDialog.draggable( "destroy" );
			}

			if ( !isDraggable && value ) {
				this._makeDraggable();
			}
		}

		if ( key === "position" ) {
			this._position();
		}

		if ( key === "resizable" ) {
			// currently resizable, becoming non-resizable
			isResizable = uiDialog.is( ":data(ui-resizable)" );
			if ( isResizable && !value ) {
				uiDialog.resizable( "destroy" );
			}

			// currently resizable, changing handles
			if ( isResizable && typeof value === "string" ) {
				uiDialog.resizable( "option", "handles", value );
			}

			// currently non-resizable, becoming resizable
			if ( !isResizable && value !== false ) {
				this._makeResizable();
			}
		}

		if ( key === "title" ) {
			this._title( this.uiDialogTitlebar.find( ".ui-dialog-title" ) );
		}
	},

	_size: function() {
		// If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
		// divs will both have width and height set, so we need to reset them
		var nonContentHeight, minContentHeight, maxContentHeight,
			options = this.options;

		// Reset content sizing
		this.element.show().css({
			width: "auto",
			minHeight: 0,
			maxHeight: "none",
			height: 0
		});

		if ( options.minWidth > options.width ) {
			options.width = options.minWidth;
		}

		// reset wrapper sizing
		// determine the height of all the non-content elements
		nonContentHeight = this.uiDialog.css({
				height: "auto",
				width: options.width
			})
			.outerHeight();
		minContentHeight = Math.max( 0, options.minHeight - nonContentHeight );
		maxContentHeight = typeof options.maxHeight === "number" ?
			Math.max( 0, options.maxHeight - nonContentHeight ) :
			"none";

		if ( options.height === "auto" ) {
			this.element.css({
				minHeight: minContentHeight,
				maxHeight: maxContentHeight,
				height: "auto"
			});
		} else {
			this.element.height( Math.max( 0, options.height - nonContentHeight ) );
		}

		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", "minHeight", this._minHeight() );
		}
	},

	_blockFrames: function() {
		this.iframeBlocks = this.document.find( "iframe" ).map(function() {
			var iframe = $( this );

			return $( "<div>" )
				.css({
					position: "absolute",
					width: iframe.outerWidth(),
					height: iframe.outerHeight()
				})
				.appendTo( iframe.parent() )
				.offset( iframe.offset() )[0];
		});
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_allowInteraction: function( event ) {
		if ( $( event.target ).closest( ".ui-dialog" ).length ) {
			return true;
		}

		// TODO: Remove hack when datepicker implements
		// the .ui-front logic (#8989)
		return !!$( event.target ).closest( ".ui-datepicker" ).length;
	},

	_createOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		// We use a delay in case the overlay is created from an
		// event that we're going to be cancelling (#2804)
		var isOpening = true;
		this._delay(function() {
			isOpening = false;
		});

		if ( !this.document.data( "ui-dialog-overlays" ) ) {

			// Prevent use of anchors and inputs
			// Using _on() for an event handler shared across many instances is
			// safe because the dialogs stack and must be closed in reverse order
			this._on( this.document, {
				focusin: function( event ) {
					if ( isOpening ) {
						return;
					}

					if ( !this._allowInteraction( event ) ) {
						event.preventDefault();
						this._trackingInstances()[ 0 ]._focusTabbable();
					}
				}
			});
		}

		this.overlay = $( "<div>" )
			.addClass( "ui-widget-overlay ui-front" )
			.appendTo( this._appendTo() );
		this._on( this.overlay, {
			mousedown: "_keepFocus"
		});
		this.document.data( "ui-dialog-overlays",
			(this.document.data( "ui-dialog-overlays" ) || 0) + 1 );
	},

	_destroyOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		if ( this.overlay ) {
			var overlays = this.document.data( "ui-dialog-overlays" ) - 1;

			if ( !overlays ) {
				this.document
					.unbind( "focusin" )
					.removeData( "ui-dialog-overlays" );
			} else {
				this.document.data( "ui-dialog-overlays", overlays );
			}

			this.overlay.remove();
			this.overlay = null;
		}
	}
});

}));


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Position 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/position/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(12) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {
(function() {

$.ui = $.ui || {};

var cachedScrollbarWidth, supportsOffsetFractions,
	max = Math.max,
	abs = Math.abs,
	round = Math.round,
	rhorizontal = /left|center|right/,
	rvertical = /top|center|bottom/,
	roffset = /[\+\-]\d+(\.[\d]+)?%?/,
	rposition = /^\w+/,
	rpercent = /%$/,
	_position = $.fn.position;

function getOffsets( offsets, width, height ) {
	return [
		parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
		parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
	];
}

function parseCss( element, property ) {
	return parseInt( $.css( element, property ), 10 ) || 0;
}

function getDimensions( elem ) {
	var raw = elem[0];
	if ( raw.nodeType === 9 ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: 0, left: 0 }
		};
	}
	if ( $.isWindow( raw ) ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
		};
	}
	if ( raw.preventDefault ) {
		return {
			width: 0,
			height: 0,
			offset: { top: raw.pageY, left: raw.pageX }
		};
	}
	return {
		width: elem.outerWidth(),
		height: elem.outerHeight(),
		offset: elem.offset()
	};
}

$.position = {
	scrollbarWidth: function() {
		if ( cachedScrollbarWidth !== undefined ) {
			return cachedScrollbarWidth;
		}
		var w1, w2,
			div = $( "<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>" ),
			innerDiv = div.children()[0];

		$( "body" ).append( div );
		w1 = innerDiv.offsetWidth;
		div.css( "overflow", "scroll" );

		w2 = innerDiv.offsetWidth;

		if ( w1 === w2 ) {
			w2 = div[0].clientWidth;
		}

		div.remove();

		return (cachedScrollbarWidth = w1 - w2);
	},
	getScrollInfo: function( within ) {
		var overflowX = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-x" ),
			overflowY = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-y" ),
			hasOverflowX = overflowX === "scroll" ||
				( overflowX === "auto" && within.width < within.element[0].scrollWidth ),
			hasOverflowY = overflowY === "scroll" ||
				( overflowY === "auto" && within.height < within.element[0].scrollHeight );
		return {
			width: hasOverflowY ? $.position.scrollbarWidth() : 0,
			height: hasOverflowX ? $.position.scrollbarWidth() : 0
		};
	},
	getWithinInfo: function( element ) {
		var withinElement = $( element || window ),
			isWindow = $.isWindow( withinElement[0] ),
			isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9;
		return {
			element: withinElement,
			isWindow: isWindow,
			isDocument: isDocument,
			offset: withinElement.offset() || { left: 0, top: 0 },
			scrollLeft: withinElement.scrollLeft(),
			scrollTop: withinElement.scrollTop(),

			// support: jQuery 1.6.x
			// jQuery 1.6 doesn't support .outerWidth/Height() on documents or windows
			width: isWindow || isDocument ? withinElement.width() : withinElement.outerWidth(),
			height: isWindow || isDocument ? withinElement.height() : withinElement.outerHeight()
		};
	}
};

$.fn.position = function( options ) {
	if ( !options || !options.of ) {
		return _position.apply( this, arguments );
	}

	// make a copy, we don't want to modify arguments
	options = $.extend( {}, options );

	var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
		target = $( options.of ),
		within = $.position.getWithinInfo( options.within ),
		scrollInfo = $.position.getScrollInfo( within ),
		collision = ( options.collision || "flip" ).split( " " ),
		offsets = {};

	dimensions = getDimensions( target );
	if ( target[0].preventDefault ) {
		// force left top to allow flipping
		options.at = "left top";
	}
	targetWidth = dimensions.width;
	targetHeight = dimensions.height;
	targetOffset = dimensions.offset;
	// clone to reuse original targetOffset later
	basePosition = $.extend( {}, targetOffset );

	// force my and at to have valid horizontal and vertical positions
	// if a value is missing or invalid, it will be converted to center
	$.each( [ "my", "at" ], function() {
		var pos = ( options[ this ] || "" ).split( " " ),
			horizontalOffset,
			verticalOffset;

		if ( pos.length === 1) {
			pos = rhorizontal.test( pos[ 0 ] ) ?
				pos.concat( [ "center" ] ) :
				rvertical.test( pos[ 0 ] ) ?
					[ "center" ].concat( pos ) :
					[ "center", "center" ];
		}
		pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
		pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

		// calculate offsets
		horizontalOffset = roffset.exec( pos[ 0 ] );
		verticalOffset = roffset.exec( pos[ 1 ] );
		offsets[ this ] = [
			horizontalOffset ? horizontalOffset[ 0 ] : 0,
			verticalOffset ? verticalOffset[ 0 ] : 0
		];

		// reduce to just the positions without the offsets
		options[ this ] = [
			rposition.exec( pos[ 0 ] )[ 0 ],
			rposition.exec( pos[ 1 ] )[ 0 ]
		];
	});

	// normalize collision option
	if ( collision.length === 1 ) {
		collision[ 1 ] = collision[ 0 ];
	}

	if ( options.at[ 0 ] === "right" ) {
		basePosition.left += targetWidth;
	} else if ( options.at[ 0 ] === "center" ) {
		basePosition.left += targetWidth / 2;
	}

	if ( options.at[ 1 ] === "bottom" ) {
		basePosition.top += targetHeight;
	} else if ( options.at[ 1 ] === "center" ) {
		basePosition.top += targetHeight / 2;
	}

	atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
	basePosition.left += atOffset[ 0 ];
	basePosition.top += atOffset[ 1 ];

	return this.each(function() {
		var collisionPosition, using,
			elem = $( this ),
			elemWidth = elem.outerWidth(),
			elemHeight = elem.outerHeight(),
			marginLeft = parseCss( this, "marginLeft" ),
			marginTop = parseCss( this, "marginTop" ),
			collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) + scrollInfo.width,
			collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) + scrollInfo.height,
			position = $.extend( {}, basePosition ),
			myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

		if ( options.my[ 0 ] === "right" ) {
			position.left -= elemWidth;
		} else if ( options.my[ 0 ] === "center" ) {
			position.left -= elemWidth / 2;
		}

		if ( options.my[ 1 ] === "bottom" ) {
			position.top -= elemHeight;
		} else if ( options.my[ 1 ] === "center" ) {
			position.top -= elemHeight / 2;
		}

		position.left += myOffset[ 0 ];
		position.top += myOffset[ 1 ];

		// if the browser doesn't support fractions, then round for consistent results
		if ( !supportsOffsetFractions ) {
			position.left = round( position.left );
			position.top = round( position.top );
		}

		collisionPosition = {
			marginLeft: marginLeft,
			marginTop: marginTop
		};

		$.each( [ "left", "top" ], function( i, dir ) {
			if ( $.ui.position[ collision[ i ] ] ) {
				$.ui.position[ collision[ i ] ][ dir ]( position, {
					targetWidth: targetWidth,
					targetHeight: targetHeight,
					elemWidth: elemWidth,
					elemHeight: elemHeight,
					collisionPosition: collisionPosition,
					collisionWidth: collisionWidth,
					collisionHeight: collisionHeight,
					offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
					my: options.my,
					at: options.at,
					within: within,
					elem: elem
				});
			}
		});

		if ( options.using ) {
			// adds feedback as second argument to using callback, if present
			using = function( props ) {
				var left = targetOffset.left - position.left,
					right = left + targetWidth - elemWidth,
					top = targetOffset.top - position.top,
					bottom = top + targetHeight - elemHeight,
					feedback = {
						target: {
							element: target,
							left: targetOffset.left,
							top: targetOffset.top,
							width: targetWidth,
							height: targetHeight
						},
						element: {
							element: elem,
							left: position.left,
							top: position.top,
							width: elemWidth,
							height: elemHeight
						},
						horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
						vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
					};
				if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
					feedback.horizontal = "center";
				}
				if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
					feedback.vertical = "middle";
				}
				if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
					feedback.important = "horizontal";
				} else {
					feedback.important = "vertical";
				}
				options.using.call( this, props, feedback );
			};
		}

		elem.offset( $.extend( position, { using: using } ) );
	});
};

$.ui.position = {
	fit: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
				outerWidth = within.width,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = withinOffset - collisionPosLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
				newOverRight;

			// element is wider than within
			if ( data.collisionWidth > outerWidth ) {
				// element is initially over the left side of within
				if ( overLeft > 0 && overRight <= 0 ) {
					newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
					position.left += overLeft - newOverRight;
				// element is initially over right side of within
				} else if ( overRight > 0 && overLeft <= 0 ) {
					position.left = withinOffset;
				// element is initially over both left and right sides of within
				} else {
					if ( overLeft > overRight ) {
						position.left = withinOffset + outerWidth - data.collisionWidth;
					} else {
						position.left = withinOffset;
					}
				}
			// too far left -> align with left edge
			} else if ( overLeft > 0 ) {
				position.left += overLeft;
			// too far right -> align with right edge
			} else if ( overRight > 0 ) {
				position.left -= overRight;
			// adjust based on position and margin
			} else {
				position.left = max( position.left - collisionPosLeft, position.left );
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
				outerHeight = data.within.height,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = withinOffset - collisionPosTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
				newOverBottom;

			// element is taller than within
			if ( data.collisionHeight > outerHeight ) {
				// element is initially over the top of within
				if ( overTop > 0 && overBottom <= 0 ) {
					newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
					position.top += overTop - newOverBottom;
				// element is initially over bottom of within
				} else if ( overBottom > 0 && overTop <= 0 ) {
					position.top = withinOffset;
				// element is initially over both top and bottom of within
				} else {
					if ( overTop > overBottom ) {
						position.top = withinOffset + outerHeight - data.collisionHeight;
					} else {
						position.top = withinOffset;
					}
				}
			// too far up -> align with top
			} else if ( overTop > 0 ) {
				position.top += overTop;
			// too far down -> align with bottom edge
			} else if ( overBottom > 0 ) {
				position.top -= overBottom;
			// adjust based on position and margin
			} else {
				position.top = max( position.top - collisionPosTop, position.top );
			}
		}
	},
	flip: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.left + within.scrollLeft,
				outerWidth = within.width,
				offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = collisionPosLeft - offsetLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
				myOffset = data.my[ 0 ] === "left" ?
					-data.elemWidth :
					data.my[ 0 ] === "right" ?
						data.elemWidth :
						0,
				atOffset = data.at[ 0 ] === "left" ?
					data.targetWidth :
					data.at[ 0 ] === "right" ?
						-data.targetWidth :
						0,
				offset = -2 * data.offset[ 0 ],
				newOverRight,
				newOverLeft;

			if ( overLeft < 0 ) {
				newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
				if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
					position.left += myOffset + atOffset + offset;
				}
			} else if ( overRight > 0 ) {
				newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
				if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
					position.left += myOffset + atOffset + offset;
				}
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.top + within.scrollTop,
				outerHeight = within.height,
				offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = collisionPosTop - offsetTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
				top = data.my[ 1 ] === "top",
				myOffset = top ?
					-data.elemHeight :
					data.my[ 1 ] === "bottom" ?
						data.elemHeight :
						0,
				atOffset = data.at[ 1 ] === "top" ?
					data.targetHeight :
					data.at[ 1 ] === "bottom" ?
						-data.targetHeight :
						0,
				offset = -2 * data.offset[ 1 ],
				newOverTop,
				newOverBottom;
			if ( overTop < 0 ) {
				newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
				if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
					position.top += myOffset + atOffset + offset;
				}
			} else if ( overBottom > 0 ) {
				newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
				if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
					position.top += myOffset + atOffset + offset;
				}
			}
		}
	},
	flipfit: {
		left: function() {
			$.ui.position.flip.left.apply( this, arguments );
			$.ui.position.fit.left.apply( this, arguments );
		},
		top: function() {
			$.ui.position.flip.top.apply( this, arguments );
			$.ui.position.fit.top.apply( this, arguments );
		}
	}
};

// fraction support test
(function() {
	var testElement, testElementParent, testElementStyle, offsetLeft, i,
		body = document.getElementsByTagName( "body" )[ 0 ],
		div = document.createElement( "div" );

	//Create a "fake body" for testing based on method used in jQuery.support
	testElement = document.createElement( body ? "div" : "body" );
	testElementStyle = {
		visibility: "hidden",
		width: 0,
		height: 0,
		border: 0,
		margin: 0,
		background: "none"
	};
	if ( body ) {
		$.extend( testElementStyle, {
			position: "absolute",
			left: "-1000px",
			top: "-1000px"
		});
	}
	for ( i in testElementStyle ) {
		testElement.style[ i ] = testElementStyle[ i ];
	}
	testElement.appendChild( div );
	testElementParent = body || document.documentElement;
	testElementParent.insertBefore( testElement, testElementParent.firstChild );

	div.style.cssText = "position: absolute; left: 10.7432222px;";

	offsetLeft = $( div ).offset().left;
	supportsOffsetFractions = offsetLeft > 10 && offsetLeft < 11;

	testElement.innerHTML = "";
	testElementParent.removeChild( testElement );
})();

})();

return $.ui.position;

}));


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/iframe/images/promo-iframe-comix.jpg", __webpack_require__.p + "components/iframe/images/promo-iframe-comix.jpg");

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	return {
		delay: function delay() {
			var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;

			return new fox.Promise(function (resolve) {
				setTimeout(resolve, delay);
			});
		}
	};
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/preloader-conic.png", __webpack_require__.p + "images/preloader-conic.png");

/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = function (fox, staticUrl) {
	if (staticUrl) {
		__webpack_require__.p = __webpack_require__.p.replace(/^.*?\/dist\/+/, staticUrl + (staticUrl.slice(-1) === '/' ? '' : '/'));
	}

	__webpack_require__(27)(fox);

	function getDeps (context) {
		context.keys().forEach(function (m) {
			var module = context(m);
			if (typeof module === "function") {
				module(fox, __webpack_require__.p);
			}
		});
	}
	
	var contexts = [];

	contexts.push(__webpack_require__(32));

	contexts.push(__webpack_require__(38));

	contexts.push(__webpack_require__(167));

	contexts.push(__webpack_require__(172));

	contexts.push(__webpack_require__(193));


	contexts.forEach(getDeps);
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = function (fox, staticUrl) {
	if (staticUrl) {
		__webpack_require__.p = __webpack_require__.p.replace(/^.*?\/dist\/+/, staticUrl + (staticUrl.slice(-1) === '/' ? '' : '/'));
	}


	function getDeps (context) {
		context.keys().forEach(function (m) {
			var module = context(m);
			if (typeof module === "function") {
				module(fox, __webpack_require__.p);
			}
		});
	}
	
	var contexts = [];

	contexts.push(__webpack_require__(28));

	contexts.push(__webpack_require__(30));


	contexts.forEach(getDeps);
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ga.js": 29
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.googleAnalytics.widget":[{"value":"mcGoogleAnalytics","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"@root","_fox_":1}],"handleWom.logoutSuccess.widget":[{"value":"#logoutApi","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101024},"path":"@root","_fox_":1}],"handleWom.logoutSuccess.event":[{"value":"success","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101025},"path":"@root","_fox_":1}],"handleWom.logoutSuccess.callback":[{"value":function () {
var ga = fox.wom.selectFirst('@root #googleAnalytics');
ga.trackEvent({'eventCategory': 'User', 'eventAction': 'logout'});
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101029},"path":"@root","_fox_":1}]},"@root #router":{"hooks.onStopExecute":[{"value":function () {
var counterCalls = 0;
var currentPage = this._passedRoute.path;
var self = this;
var callback = function callback () {
counterCalls++;
var loaded = typeof _gaScriptLoaded !== 'undefined' ?
_gaScriptLoaded :
false
if (!loaded && counterCalls < 5) {
return setTimeout(callback, 2000);
}
self.rwom1('@root #googleAnalytics').trackPageview(currentPage, false);
}();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101020},"path":"@root #router","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./mcgoogleanalytics.js": 31
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';
	
	fox.registerWidget('mcGoogleAnalytics', {
		/**
		 * Track pageview.
		 * @param {string} page Name of tracked page
		 * @param {boolean} logPage If true, send navigator information to api logger.log
		 * @return {void}
		 */
		trackPageview: function(page, logPage) {
			this.callParent('trackPageview', [page]);

			if (fox.isEmpty(fox.site.member) && (fox.getEnv('affiliateArea') || fox.getEnv('globalSubscription'))) {
				var api = this.getApi('affTrack', {method: 'affiliate.track'});
				var data = {
					page: page
				};

				var foxref = null;

				if (foxref = fox.cookie.get('foxref')) {
					data.refCode = foxref;
				}

				api.send(data, false);
			}

			var permissionManager = fox.wom.selectFirst('~.PermissionManager');

			var isMember = permissionManager
				? !fox.isEmpty(permissionManager.getMemberInfo())
				: !fox.isEmpty(fox.site.member)
			;

			if (isMember && logPage) {
				var page = fox.Navigator.getAll()[0];

				if (!fox.inArray(['scene', 'gallery', 'product'], page)) {
					return;
				}

				var api = this.getApi('loggerLog', {method: 'logger.log'});

				api.send({
					index: 'McUserActivity',
					path: fox.Navigator.getAll()
				}, false);	
			}
		},

		/**
		 * Set default google dimensions for tracker with name "trackerName"
		 * @param {string} trackerName
		 * return {void}
		 */
		_setTrackerDimensions: function(trackerName) {
			this.callParent('_setTrackerDimensions', arguments);

			var foxref = fox.cookie.get('foxref');
			var acode = fox.cookie.get('acode');
			var parsedUrl, getParams;

			if (!acode) {
				parsedUrl = fox.Navigator.parseUrl(document.location);

				if (parsedUrl.search) {
					getParams = fox.Navigator.parseSearch(parsedUrl.search);

					if (getParams['acode']) {
						acode = getParams['acode'];
					}
				}
			}

			ga(trackerName + '.set', 'dimension2', fox.isEmpty(foxref) ? "" : foxref);
			ga(trackerName + '.set', 'dimension3', fox.isEmpty(acode) ? "" : acode);
		}

	}, 'googleAnalytics');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./owl.carousel.min.css": 33,
	"./owl.theme.default.min.css": 36
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(34);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?minimize!./owl.carousel.min.css", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js?minimize!./owl.carousel.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".owl-carousel .animated{animation-duration:1s;animation-fill-mode:both}.owl-carousel .owl-animated-in{z-index:0}.owl-carousel .owl-animated-out{z-index:1}.owl-carousel .fadeOut{animation-name:fadeOut}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.owl-height{transition:height .5s ease-in-out}.owl-carousel{display:none;width:100%;-webkit-tap-highlight-color:transparent;position:relative;z-index:1}.owl-carousel .owl-stage{position:relative;-ms-touch-action:pan-Y}.owl-carousel .owl-stage:after{content:\".\";display:block;clear:both;visibility:hidden;line-height:0;height:0}.owl-carousel .owl-stage-outer{position:relative;overflow:hidden;-webkit-transform:translateZ(0)}.owl-carousel .owl-item{position:relative;min-height:1px;float:left;-webkit-backface-visibility:hidden;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none}.owl-carousel .owl-item img{display:block;width:100%;-webkit-transform-style:preserve-3d}.owl-carousel .owl-dots.disabled,.owl-carousel .owl-nav.disabled{display:none}.owl-carousel .owl-dot,.owl-carousel .owl-nav .owl-next,.owl-carousel .owl-nav .owl-prev{cursor:pointer;cursor:hand;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.owl-carousel.owl-loaded{display:block}.owl-carousel.owl-loading{opacity:0;display:block}.owl-carousel.owl-hidden{opacity:0}.owl-carousel.owl-refresh .owl-item{display:none}.owl-carousel.owl-drag .owl-item{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.owl-carousel.owl-grab{cursor:move;cursor:-o-grab;cursor:-ms-grab;cursor:grab}.owl-carousel.owl-rtl{direction:rtl}.owl-carousel.owl-rtl .owl-item{float:right}.no-js .owl-carousel{display:block}.owl-carousel .owl-item .owl-lazy{opacity:0;transition:opacity .4s ease}.owl-carousel .owl-item img{transform-style:preserve-3d}.owl-carousel .owl-video-wrapper{position:relative;height:100%;background:#000}.owl-carousel .owl-video-play-icon{position:absolute;height:80px;width:80px;left:50%;top:50%;margin-left:-40px;margin-top:-40px;cursor:pointer;z-index:1;-webkit-backface-visibility:hidden;transition:scale .1s ease}.owl-carousel .owl-video-play-icon:hover{transition:scale(1.3,1.3)}.owl-carousel .owl-video-playing .owl-video-play-icon,.owl-carousel .owl-video-playing .owl-video-tn{display:none}.owl-carousel .owl-video-tn{opacity:0;height:100%;background-position:50%;background-repeat:no-repeat;background-size:contain;transition:opacity .4s ease}.owl-carousel .owl-video-frame{position:relative;z-index:1;height:100%;width:100%}", ""]);

// exports


/***/ }),
/* 35 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(37);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?minimize!./owl.theme.default.min.css", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js?minimize!./owl.theme.default.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".owl-theme .owl-nav{margin-top:10px;text-align:center;-webkit-tap-highlight-color:transparent}.owl-theme .owl-nav [class*=owl-]{color:#fff;font-size:14px;margin:5px;padding:4px 7px;background:#d6d6d6;display:inline-block;cursor:pointer;border-radius:3px}.owl-theme .owl-nav [class*=owl-]:hover{background:#869791;color:#fff;text-decoration:none}.owl-theme .owl-nav .disabled{opacity:.5;cursor:default}.owl-theme .owl-nav.disabled+.owl-dots{margin-top:10px}.owl-theme .owl-dots{text-align:center;-webkit-tap-highlight-color:transparent}.owl-theme .owl-dots .owl-dot{display:inline-block;zoom:1;*display:inline}.owl-theme .owl-dots .owl-dot span{width:10px;height:10px;margin:5px 7px;background:#d6d6d6;display:block;-webkit-backface-visibility:visible;transition:opacity .2s ease;border-radius:30px}.owl-theme .owl-dots .owl-dot.active span,.owl-theme .owl-dots .owl-dot:hover span{background:#869791}", ""]);

// exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dependencies.js": 39,
	"./publisher.js": 140,
	"./stylus.js": 145
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	
	__webpack_require__(14);
	__webpack_require__(13);
	__webpack_require__(19);
	__webpack_require__(43);

	__webpack_require__(44);
	__webpack_require__(46);
	__webpack_require__(48)(fox);
	__webpack_require__(49)(fox);
	__webpack_require__(50)(fox);
	__webpack_require__(51)(fox);
	__webpack_require__(52)(fox);
	__webpack_require__(53)(fox);
	__webpack_require__(54)(fox);
	__webpack_require__(55)(fox);
	__webpack_require__(56)(fox);

	__webpack_require__(61)(fox);
	__webpack_require__(62)(fox);
	__webpack_require__(63)(fox);

	__webpack_require__(64)(fox);
	__webpack_require__(65)(fox);
	__webpack_require__(66)(fox);
	__webpack_require__(67)(fox);
	__webpack_require__(68)(fox);
	__webpack_require__(69)(fox);
	__webpack_require__(70)(fox);
	__webpack_require__(71)(fox);
	__webpack_require__(72)(fox);
	__webpack_require__(73)(fox);
	__webpack_require__(74)(fox);

	__webpack_require__(75);

	__webpack_require__(79)(fox);
	__webpack_require__(80)(fox);
	__webpack_require__(86);

	__webpack_require__(88)(fox);
	__webpack_require__(91)(fox);
	__webpack_require__(101)(fox);
	__webpack_require__(105)(fox);
	__webpack_require__(106)(fox);
	//require('../../../../model/promo2/components/login-wizard')(fox);
	__webpack_require__(113)(fox);
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Button 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/button/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(12),
			__webpack_require__(14),
			__webpack_require__(13)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

var lastActive,
	baseClasses = "ui-button ui-widget ui-state-default ui-corner-all",
	typeClasses = "ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only",
	formResetHandler = function() {
		var form = $( this );
		setTimeout(function() {
			form.find( ":ui-button" ).button( "refresh" );
		}, 1 );
	},
	radioGroup = function( radio ) {
		var name = radio.name,
			form = radio.form,
			radios = $( [] );
		if ( name ) {
			name = name.replace( /'/g, "\\'" );
			if ( form ) {
				radios = $( form ).find( "[name='" + name + "'][type=radio]" );
			} else {
				radios = $( "[name='" + name + "'][type=radio]", radio.ownerDocument )
					.filter(function() {
						return !this.form;
					});
			}
		}
		return radios;
	};

$.widget( "ui.button", {
	version: "1.11.4",
	defaultElement: "<button>",
	options: {
		disabled: null,
		text: true,
		label: null,
		icons: {
			primary: null,
			secondary: null
		}
	},
	_create: function() {
		this.element.closest( "form" )
			.unbind( "reset" + this.eventNamespace )
			.bind( "reset" + this.eventNamespace, formResetHandler );

		if ( typeof this.options.disabled !== "boolean" ) {
			this.options.disabled = !!this.element.prop( "disabled" );
		} else {
			this.element.prop( "disabled", this.options.disabled );
		}

		this._determineButtonType();
		this.hasTitle = !!this.buttonElement.attr( "title" );

		var that = this,
			options = this.options,
			toggleButton = this.type === "checkbox" || this.type === "radio",
			activeClass = !toggleButton ? "ui-state-active" : "";

		if ( options.label === null ) {
			options.label = (this.type === "input" ? this.buttonElement.val() : this.buttonElement.html());
		}

		this._hoverable( this.buttonElement );

		this.buttonElement
			.addClass( baseClasses )
			.attr( "role", "button" )
			.bind( "mouseenter" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return;
				}
				if ( this === lastActive ) {
					$( this ).addClass( "ui-state-active" );
				}
			})
			.bind( "mouseleave" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return;
				}
				$( this ).removeClass( activeClass );
			})
			.bind( "click" + this.eventNamespace, function( event ) {
				if ( options.disabled ) {
					event.preventDefault();
					event.stopImmediatePropagation();
				}
			});

		// Can't use _focusable() because the element that receives focus
		// and the element that gets the ui-state-focus class are different
		this._on({
			focus: function() {
				this.buttonElement.addClass( "ui-state-focus" );
			},
			blur: function() {
				this.buttonElement.removeClass( "ui-state-focus" );
			}
		});

		if ( toggleButton ) {
			this.element.bind( "change" + this.eventNamespace, function() {
				that.refresh();
			});
		}

		if ( this.type === "checkbox" ) {
			this.buttonElement.bind( "click" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return false;
				}
			});
		} else if ( this.type === "radio" ) {
			this.buttonElement.bind( "click" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return false;
				}
				$( this ).addClass( "ui-state-active" );
				that.buttonElement.attr( "aria-pressed", "true" );

				var radio = that.element[ 0 ];
				radioGroup( radio )
					.not( radio )
					.map(function() {
						return $( this ).button( "widget" )[ 0 ];
					})
					.removeClass( "ui-state-active" )
					.attr( "aria-pressed", "false" );
			});
		} else {
			this.buttonElement
				.bind( "mousedown" + this.eventNamespace, function() {
					if ( options.disabled ) {
						return false;
					}
					$( this ).addClass( "ui-state-active" );
					lastActive = this;
					that.document.one( "mouseup", function() {
						lastActive = null;
					});
				})
				.bind( "mouseup" + this.eventNamespace, function() {
					if ( options.disabled ) {
						return false;
					}
					$( this ).removeClass( "ui-state-active" );
				})
				.bind( "keydown" + this.eventNamespace, function(event) {
					if ( options.disabled ) {
						return false;
					}
					if ( event.keyCode === $.ui.keyCode.SPACE || event.keyCode === $.ui.keyCode.ENTER ) {
						$( this ).addClass( "ui-state-active" );
					}
				})
				// see #8559, we bind to blur here in case the button element loses
				// focus between keydown and keyup, it would be left in an "active" state
				.bind( "keyup" + this.eventNamespace + " blur" + this.eventNamespace, function() {
					$( this ).removeClass( "ui-state-active" );
				});

			if ( this.buttonElement.is("a") ) {
				this.buttonElement.keyup(function(event) {
					if ( event.keyCode === $.ui.keyCode.SPACE ) {
						// TODO pass through original event correctly (just as 2nd argument doesn't work)
						$( this ).click();
					}
				});
			}
		}

		this._setOption( "disabled", options.disabled );
		this._resetButton();
	},

	_determineButtonType: function() {
		var ancestor, labelSelector, checked;

		if ( this.element.is("[type=checkbox]") ) {
			this.type = "checkbox";
		} else if ( this.element.is("[type=radio]") ) {
			this.type = "radio";
		} else if ( this.element.is("input") ) {
			this.type = "input";
		} else {
			this.type = "button";
		}

		if ( this.type === "checkbox" || this.type === "radio" ) {
			// we don't search against the document in case the element
			// is disconnected from the DOM
			ancestor = this.element.parents().last();
			labelSelector = "label[for='" + this.element.attr("id") + "']";
			this.buttonElement = ancestor.find( labelSelector );
			if ( !this.buttonElement.length ) {
				ancestor = ancestor.length ? ancestor.siblings() : this.element.siblings();
				this.buttonElement = ancestor.filter( labelSelector );
				if ( !this.buttonElement.length ) {
					this.buttonElement = ancestor.find( labelSelector );
				}
			}
			this.element.addClass( "ui-helper-hidden-accessible" );

			checked = this.element.is( ":checked" );
			if ( checked ) {
				this.buttonElement.addClass( "ui-state-active" );
			}
			this.buttonElement.prop( "aria-pressed", checked );
		} else {
			this.buttonElement = this.element;
		}
	},

	widget: function() {
		return this.buttonElement;
	},

	_destroy: function() {
		this.element
			.removeClass( "ui-helper-hidden-accessible" );
		this.buttonElement
			.removeClass( baseClasses + " ui-state-active " + typeClasses )
			.removeAttr( "role" )
			.removeAttr( "aria-pressed" )
			.html( this.buttonElement.find(".ui-button-text").html() );

		if ( !this.hasTitle ) {
			this.buttonElement.removeAttr( "title" );
		}
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "disabled" ) {
			this.widget().toggleClass( "ui-state-disabled", !!value );
			this.element.prop( "disabled", !!value );
			if ( value ) {
				if ( this.type === "checkbox" || this.type === "radio" ) {
					this.buttonElement.removeClass( "ui-state-focus" );
				} else {
					this.buttonElement.removeClass( "ui-state-focus ui-state-active" );
				}
			}
			return;
		}
		this._resetButton();
	},

	refresh: function() {
		//See #8237 & #8828
		var isDisabled = this.element.is( "input, button" ) ? this.element.is( ":disabled" ) : this.element.hasClass( "ui-button-disabled" );

		if ( isDisabled !== this.options.disabled ) {
			this._setOption( "disabled", isDisabled );
		}
		if ( this.type === "radio" ) {
			radioGroup( this.element[0] ).each(function() {
				if ( $( this ).is( ":checked" ) ) {
					$( this ).button( "widget" )
						.addClass( "ui-state-active" )
						.attr( "aria-pressed", "true" );
				} else {
					$( this ).button( "widget" )
						.removeClass( "ui-state-active" )
						.attr( "aria-pressed", "false" );
				}
			});
		} else if ( this.type === "checkbox" ) {
			if ( this.element.is( ":checked" ) ) {
				this.buttonElement
					.addClass( "ui-state-active" )
					.attr( "aria-pressed", "true" );
			} else {
				this.buttonElement
					.removeClass( "ui-state-active" )
					.attr( "aria-pressed", "false" );
			}
		}
	},

	_resetButton: function() {
		if ( this.type === "input" ) {
			if ( this.options.label ) {
				this.element.val( this.options.label );
			}
			return;
		}
		var buttonElement = this.buttonElement.removeClass( typeClasses ),
			buttonText = $( "<span></span>", this.document[0] )
				.addClass( "ui-button-text" )
				.html( this.options.label )
				.appendTo( buttonElement.empty() )
				.text(),
			icons = this.options.icons,
			multipleIcons = icons.primary && icons.secondary,
			buttonClasses = [];

		if ( icons.primary || icons.secondary ) {
			if ( this.options.text ) {
				buttonClasses.push( "ui-button-text-icon" + ( multipleIcons ? "s" : ( icons.primary ? "-primary" : "-secondary" ) ) );
			}

			if ( icons.primary ) {
				buttonElement.prepend( "<span class='ui-button-icon-primary ui-icon " + icons.primary + "'></span>" );
			}

			if ( icons.secondary ) {
				buttonElement.append( "<span class='ui-button-icon-secondary ui-icon " + icons.secondary + "'></span>" );
			}

			if ( !this.options.text ) {
				buttonClasses.push( multipleIcons ? "ui-button-icons-only" : "ui-button-icon-only" );

				if ( !this.hasTitle ) {
					buttonElement.attr( "title", $.trim( buttonText ) );
				}
			}
		} else {
			buttonClasses.push( "ui-button-text-only" );
		}
		buttonElement.addClass( buttonClasses.join( " " ) );
	}
});

$.widget( "ui.buttonset", {
	version: "1.11.4",
	options: {
		items: "button, input[type=button], input[type=submit], input[type=reset], input[type=checkbox], input[type=radio], a, :data(ui-button)"
	},

	_create: function() {
		this.element.addClass( "ui-buttonset" );
	},

	_init: function() {
		this.refresh();
	},

	_setOption: function( key, value ) {
		if ( key === "disabled" ) {
			this.buttons.button( "option", key, value );
		}

		this._super( key, value );
	},

	refresh: function() {
		var rtl = this.element.css( "direction" ) === "rtl",
			allButtons = this.element.find( this.options.items ),
			existingButtons = allButtons.filter( ":ui-button" );

		// Initialize new buttons
		allButtons.not( ":ui-button" ).button();

		// Refresh existing buttons
		existingButtons.button( "refresh" );

		this.buttons = allButtons
			.map(function() {
				return $( this ).button( "widget" )[ 0 ];
			})
				.removeClass( "ui-corner-all ui-corner-left ui-corner-right" )
				.filter( ":first" )
					.addClass( rtl ? "ui-corner-right" : "ui-corner-left" )
				.end()
				.filter( ":last" )
					.addClass( rtl ? "ui-corner-left" : "ui-corner-right" )
				.end()
			.end();
	},

	_destroy: function() {
		this.element.removeClass( "ui-buttonset" );
		this.buttons
			.map(function() {
				return $( this ).button( "widget" )[ 0 ];
			})
				.removeClass( "ui-corner-left ui-corner-right" )
			.end()
			.button( "destroy" );
	}
});

return $.ui.button;

}));


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Draggable 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/draggable/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(12),
			__webpack_require__(14),
			__webpack_require__(15),
			__webpack_require__(13)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

$.widget("ui.draggable", $.ui.mouse, {
	version: "1.11.4",
	widgetEventPrefix: "drag",
	options: {
		addClasses: true,
		appendTo: "parent",
		axis: false,
		connectToSortable: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		grid: false,
		handle: false,
		helper: "original",
		iframeFix: false,
		opacity: false,
		refreshPositions: false,
		revert: false,
		revertDuration: 500,
		scope: "default",
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		snap: false,
		snapMode: "both",
		snapTolerance: 20,
		stack: false,
		zIndex: false,

		// callbacks
		drag: null,
		start: null,
		stop: null
	},
	_create: function() {

		if ( this.options.helper === "original" ) {
			this._setPositionRelative();
		}
		if (this.options.addClasses){
			this.element.addClass("ui-draggable");
		}
		if (this.options.disabled){
			this.element.addClass("ui-draggable-disabled");
		}
		this._setHandleClassName();

		this._mouseInit();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "handle" ) {
			this._removeHandleClassName();
			this._setHandleClassName();
		}
	},

	_destroy: function() {
		if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
			this.destroyOnClear = true;
			return;
		}
		this.element.removeClass( "ui-draggable ui-draggable-dragging ui-draggable-disabled" );
		this._removeHandleClassName();
		this._mouseDestroy();
	},

	_mouseCapture: function(event) {
		var o = this.options;

		this._blurActiveElement( event );

		// among others, prevent a drag on a resizable-handle
		if (this.helper || o.disabled || $(event.target).closest(".ui-resizable-handle").length > 0) {
			return false;
		}

		//Quit if we're not on a valid handle
		this.handle = this._getHandle(event);
		if (!this.handle) {
			return false;
		}

		this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );

		return true;

	},

	_blockFrames: function( selector ) {
		this.iframeBlocks = this.document.find( selector ).map(function() {
			var iframe = $( this );

			return $( "<div>" )
				.css( "position", "absolute" )
				.appendTo( iframe.parent() )
				.outerWidth( iframe.outerWidth() )
				.outerHeight( iframe.outerHeight() )
				.offset( iframe.offset() )[ 0 ];
		});
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_blurActiveElement: function( event ) {
		var document = this.document[ 0 ];

		// Only need to blur if the event occurred on the draggable itself, see #10527
		if ( !this.handleElement.is( event.target ) ) {
			return;
		}

		// support: IE9
		// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
		try {

			// Support: IE9, IE10
			// If the <body> is blurred, IE will switch windows, see #9520
			if ( document.activeElement && document.activeElement.nodeName.toLowerCase() !== "body" ) {

				// Blur any element that currently has focus, see #4261
				$( document.activeElement ).blur();
			}
		} catch ( error ) {}
	},

	_mouseStart: function(event) {

		var o = this.options;

		//Create and append the visible helper
		this.helper = this._createHelper(event);

		this.helper.addClass("ui-draggable-dragging");

		//Cache the helper size
		this._cacheHelperProportions();

		//If ddmanager is used for droppables, set the global draggable
		if ($.ui.ddmanager) {
			$.ui.ddmanager.current = this;
		}

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Store the helper's css position
		this.cssPosition = this.helper.css( "position" );
		this.scrollParent = this.helper.scrollParent( true );
		this.offsetParent = this.helper.offsetParent();
		this.hasFixedAncestor = this.helper.parents().filter(function() {
				return $( this ).css( "position" ) === "fixed";
			}).length > 0;

		//The element's absolute position on the page minus margins
		this.positionAbs = this.element.offset();
		this._refreshOffsets( event );

		//Generate the original position
		this.originalPosition = this.position = this._generatePosition( event, false );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		(o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));

		//Set a containment if given in the options
		this._setContainment();

		//Trigger event + callbacks
		if (this._trigger("start", event) === false) {
			this._clear();
			return false;
		}

		//Recache the helper size
		this._cacheHelperProportions();

		//Prepare the droppable offsets
		if ($.ui.ddmanager && !o.dropBehaviour) {
			$.ui.ddmanager.prepareOffsets(this, event);
		}

		// Reset helper's right/bottom css if they're set and set explicit width/height instead
		// as this prevents resizing of elements with right/bottom set (see #7772)
		this._normalizeRightBottom();

		this._mouseDrag(event, true); //Execute the drag once - this causes the helper not to be visible before getting its correct position

		//If the ddmanager is used for droppables, inform the manager that dragging has started (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStart(this, event);
		}

		return true;
	},

	_refreshOffsets: function( event ) {
		this.offset = {
			top: this.positionAbs.top - this.margins.top,
			left: this.positionAbs.left - this.margins.left,
			scroll: false,
			parent: this._getParentOffset(),
			relative: this._getRelativeOffset()
		};

		this.offset.click = {
			left: event.pageX - this.offset.left,
			top: event.pageY - this.offset.top
		};
	},

	_mouseDrag: function(event, noPropagation) {
		// reset any necessary cached properties (see #5009)
		if ( this.hasFixedAncestor ) {
			this.offset.parent = this._getParentOffset();
		}

		//Compute the helpers position
		this.position = this._generatePosition( event, true );
		this.positionAbs = this._convertPositionTo("absolute");

		//Call plugins and callbacks and use the resulting position if something is returned
		if (!noPropagation) {
			var ui = this._uiHash();
			if (this._trigger("drag", event, ui) === false) {
				this._mouseUp({});
				return false;
			}
			this.position = ui.position;
		}

		this.helper[ 0 ].style.left = this.position.left + "px";
		this.helper[ 0 ].style.top = this.position.top + "px";

		if ($.ui.ddmanager) {
			$.ui.ddmanager.drag(this, event);
		}

		return false;
	},

	_mouseStop: function(event) {

		//If we are using droppables, inform the manager about the drop
		var that = this,
			dropped = false;
		if ($.ui.ddmanager && !this.options.dropBehaviour) {
			dropped = $.ui.ddmanager.drop(this, event);
		}

		//if a drop comes from outside (a sortable)
		if (this.dropped) {
			dropped = this.dropped;
			this.dropped = false;
		}

		if ((this.options.revert === "invalid" && !dropped) || (this.options.revert === "valid" && dropped) || this.options.revert === true || ($.isFunction(this.options.revert) && this.options.revert.call(this.element, dropped))) {
			$(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function() {
				if (that._trigger("stop", event) !== false) {
					that._clear();
				}
			});
		} else {
			if (this._trigger("stop", event) !== false) {
				this._clear();
			}
		}

		return false;
	},

	_mouseUp: function( event ) {
		this._unblockFrames();

		//If the ddmanager is used for droppables, inform the manager that dragging has stopped (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStop(this, event);
		}

		// Only need to focus if the event occurred on the draggable itself, see #10527
		if ( this.handleElement.is( event.target ) ) {
			// The interaction is over; whether or not the click resulted in a drag, focus the element
			this.element.focus();
		}

		return $.ui.mouse.prototype._mouseUp.call(this, event);
	},

	cancel: function() {

		if (this.helper.is(".ui-draggable-dragging")) {
			this._mouseUp({});
		} else {
			this._clear();
		}

		return this;

	},

	_getHandle: function(event) {
		return this.options.handle ?
			!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
			true;
	},

	_setHandleClassName: function() {
		this.handleElement = this.options.handle ?
			this.element.find( this.options.handle ) : this.element;
		this.handleElement.addClass( "ui-draggable-handle" );
	},

	_removeHandleClassName: function() {
		this.handleElement.removeClass( "ui-draggable-handle" );
	},

	_createHelper: function(event) {

		var o = this.options,
			helperIsFunction = $.isFunction( o.helper ),
			helper = helperIsFunction ?
				$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
				( o.helper === "clone" ?
					this.element.clone().removeAttr( "id" ) :
					this.element );

		if (!helper.parents("body").length) {
			helper.appendTo((o.appendTo === "parent" ? this.element[0].parentNode : o.appendTo));
		}

		// http://bugs.jqueryui.com/ticket/9446
		// a helper function can return the original element
		// which wouldn't have been set to relative in _create
		if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
			this._setPositionRelative();
		}

		if (helper[0] !== this.element[0] && !(/(fixed|absolute)/).test(helper.css("position"))) {
			helper.css("position", "absolute");
		}

		return helper;

	},

	_setPositionRelative: function() {
		if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
			this.element[ 0 ].style.position = "relative";
		}
	},

	_adjustOffsetFromHelper: function(obj) {
		if (typeof obj === "string") {
			obj = obj.split(" ");
		}
		if ($.isArray(obj)) {
			obj = { left: +obj[0], top: +obj[1] || 0 };
		}
		if ("left" in obj) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ("right" in obj) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ("top" in obj) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ("bottom" in obj) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_isRootNode: function( element ) {
		return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		var po = this.offsetParent.offset(),
			document = this.document[ 0 ];

		// This is a special case where we need to modify a offset calculated on start, since the following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
		//    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
		if (this.cssPosition === "absolute" && this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
			left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
		};

	},

	_getRelativeOffset: function() {
		if ( this.cssPosition !== "relative" ) {
			return { top: 0, left: 0 };
		}

		var p = this.element.position(),
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: p.top - ( parseInt(this.helper.css( "top" ), 10) || 0 ) + ( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
			left: p.left - ( parseInt(this.helper.css( "left" ), 10) || 0 ) + ( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
		};

	},

	_cacheMargins: function() {
		this.margins = {
			left: (parseInt(this.element.css("marginLeft"), 10) || 0),
			top: (parseInt(this.element.css("marginTop"), 10) || 0),
			right: (parseInt(this.element.css("marginRight"), 10) || 0),
			bottom: (parseInt(this.element.css("marginBottom"), 10) || 0)
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var isUserScrollable, c, ce,
			o = this.options,
			document = this.document[ 0 ];

		this.relativeContainer = null;

		if ( !o.containment ) {
			this.containment = null;
			return;
		}

		if ( o.containment === "window" ) {
			this.containment = [
				$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
				$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
				$( window ).scrollLeft() + $( window ).width() - this.helperProportions.width - this.margins.left,
				$( window ).scrollTop() + ( $( window ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment === "document") {
			this.containment = [
				0,
				0,
				$( document ).width() - this.helperProportions.width - this.margins.left,
				( $( document ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment.constructor === Array ) {
			this.containment = o.containment;
			return;
		}

		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}

		c = $( o.containment );
		ce = c[ 0 ];

		if ( !ce ) {
			return;
		}

		isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );

		this.containment = [
			( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
			( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
			( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
				( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
				this.helperProportions.width -
				this.margins.left -
				this.margins.right,
			( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
				( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
				this.helperProportions.height -
				this.margins.top -
				this.margins.bottom
		];
		this.relativeContainer = c;
	},

	_convertPositionTo: function(d, pos) {

		if (!pos) {
			pos = this.position;
		}

		var mod = d === "absolute" ? 1 : -1,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: (
				pos.top	+																// The absolute mouse position
				this.offset.relative.top * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.top * mod -										// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.offset.scroll.top : ( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod)
			),
			left: (
				pos.left +																// The absolute mouse position
				this.offset.relative.left * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.left * mod	-										// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.offset.scroll.left : ( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod)
			)
		};

	},

	_generatePosition: function( event, constrainPosition ) {

		var containment, co, top, left,
			o = this.options,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
			pageX = event.pageX,
			pageY = event.pageY;

		// Cache the scroll
		if ( !scrollIsRootNode || !this.offset.scroll ) {
			this.offset.scroll = {
				top: this.scrollParent.scrollTop(),
				left: this.scrollParent.scrollLeft()
			};
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		// If we are not dragging yet, we won't check for options
		if ( constrainPosition ) {
			if ( this.containment ) {
				if ( this.relativeContainer ){
					co = this.relativeContainer.offset();
					containment = [
						this.containment[ 0 ] + co.left,
						this.containment[ 1 ] + co.top,
						this.containment[ 2 ] + co.left,
						this.containment[ 3 ] + co.top
					];
				} else {
					containment = this.containment;
				}

				if (event.pageX - this.offset.click.left < containment[0]) {
					pageX = containment[0] + this.offset.click.left;
				}
				if (event.pageY - this.offset.click.top < containment[1]) {
					pageY = containment[1] + this.offset.click.top;
				}
				if (event.pageX - this.offset.click.left > containment[2]) {
					pageX = containment[2] + this.offset.click.left;
				}
				if (event.pageY - this.offset.click.top > containment[3]) {
					pageY = containment[3] + this.offset.click.top;
				}
			}

			if (o.grid) {
				//Check for grid elements set to 0 to prevent divide by 0 error causing invalid argument errors in IE (see ticket #6950)
				top = o.grid[1] ? this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1] : this.originalPageY;
				pageY = containment ? ((top - this.offset.click.top >= containment[1] || top - this.offset.click.top > containment[3]) ? top : ((top - this.offset.click.top >= containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;

				left = o.grid[0] ? this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0] : this.originalPageX;
				pageX = containment ? ((left - this.offset.click.left >= containment[0] || left - this.offset.click.left > containment[2]) ? left : ((left - this.offset.click.left >= containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
			}

			if ( o.axis === "y" ) {
				pageX = this.originalPageX;
			}

			if ( o.axis === "x" ) {
				pageY = this.originalPageY;
			}
		}

		return {
			top: (
				pageY -																	// The absolute mouse position
				this.offset.click.top	-												// Click offset (relative to the element)
				this.offset.relative.top -												// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.top +												// The offsetParent's offset without borders (offset + border)
				( this.cssPosition === "fixed" ? -this.offset.scroll.top : ( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
			),
			left: (
				pageX -																	// The absolute mouse position
				this.offset.click.left -												// Click offset (relative to the element)
				this.offset.relative.left -												// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.left +												// The offsetParent's offset without borders (offset + border)
				( this.cssPosition === "fixed" ? -this.offset.scroll.left : ( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
			)
		};

	},

	_clear: function() {
		this.helper.removeClass("ui-draggable-dragging");
		if (this.helper[0] !== this.element[0] && !this.cancelHelperRemoval) {
			this.helper.remove();
		}
		this.helper = null;
		this.cancelHelperRemoval = false;
		if ( this.destroyOnClear ) {
			this.destroy();
		}
	},

	_normalizeRightBottom: function() {
		if ( this.options.axis !== "y" && this.helper.css( "right" ) !== "auto" ) {
			this.helper.width( this.helper.width() );
			this.helper.css( "right", "auto" );
		}
		if ( this.options.axis !== "x" && this.helper.css( "bottom" ) !== "auto" ) {
			this.helper.height( this.helper.height() );
			this.helper.css( "bottom", "auto" );
		}
	},

	// From now on bulk stuff - mainly helpers

	_trigger: function( type, event, ui ) {
		ui = ui || this._uiHash();
		$.ui.plugin.call( this, type, [ event, ui, this ], true );

		// Absolute position and offset (see #6884 ) have to be recalculated after plugins
		if ( /^(drag|start|stop)/.test( type ) ) {
			this.positionAbs = this._convertPositionTo( "absolute" );
			ui.offset = this.positionAbs;
		}
		return $.Widget.prototype._trigger.call( this, type, event, ui );
	},

	plugins: {},

	_uiHash: function() {
		return {
			helper: this.helper,
			position: this.position,
			originalPosition: this.originalPosition,
			offset: this.positionAbs
		};
	}

});

$.ui.plugin.add( "draggable", "connectToSortable", {
	start: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		});

		draggable.sortables = [];
		$( draggable.options.connectToSortable ).each(function() {
			var sortable = $( this ).sortable( "instance" );

			if ( sortable && !sortable.options.disabled ) {
				draggable.sortables.push( sortable );

				// refreshPositions is called at drag start to refresh the containerCache
				// which is used in drag. This ensures it's initialized and synchronized
				// with any changes that might have happened on the page since initialization.
				sortable.refreshPositions();
				sortable._trigger("activate", event, uiSortable);
			}
		});
	},
	stop: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		});

		draggable.cancelHelperRemoval = false;

		$.each( draggable.sortables, function() {
			var sortable = this;

			if ( sortable.isOver ) {
				sortable.isOver = 0;

				// Allow this sortable to handle removing the helper
				draggable.cancelHelperRemoval = true;
				sortable.cancelHelperRemoval = false;

				// Use _storedCSS To restore properties in the sortable,
				// as this also handles revert (#9675) since the draggable
				// may have modified them in unexpected ways (#8809)
				sortable._storedCSS = {
					position: sortable.placeholder.css( "position" ),
					top: sortable.placeholder.css( "top" ),
					left: sortable.placeholder.css( "left" )
				};

				sortable._mouseStop(event);

				// Once drag has ended, the sortable should return to using
				// its original helper, not the shared helper from draggable
				sortable.options.helper = sortable.options._helper;
			} else {
				// Prevent this Sortable from removing the helper.
				// However, don't set the draggable to remove the helper
				// either as another connected Sortable may yet handle the removal.
				sortable.cancelHelperRemoval = true;

				sortable._trigger( "deactivate", event, uiSortable );
			}
		});
	},
	drag: function( event, ui, draggable ) {
		$.each( draggable.sortables, function() {
			var innermostIntersecting = false,
				sortable = this;

			// Copy over variables that sortable's _intersectsWith uses
			sortable.positionAbs = draggable.positionAbs;
			sortable.helperProportions = draggable.helperProportions;
			sortable.offset.click = draggable.offset.click;

			if ( sortable._intersectsWith( sortable.containerCache ) ) {
				innermostIntersecting = true;

				$.each( draggable.sortables, function() {
					// Copy over variables that sortable's _intersectsWith uses
					this.positionAbs = draggable.positionAbs;
					this.helperProportions = draggable.helperProportions;
					this.offset.click = draggable.offset.click;

					if ( this !== sortable &&
							this._intersectsWith( this.containerCache ) &&
							$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
						innermostIntersecting = false;
					}

					return innermostIntersecting;
				});
			}

			if ( innermostIntersecting ) {
				// If it intersects, we use a little isOver variable and set it once,
				// so that the move-in stuff gets fired only once.
				if ( !sortable.isOver ) {
					sortable.isOver = 1;

					// Store draggable's parent in case we need to reappend to it later.
					draggable._parent = ui.helper.parent();

					sortable.currentItem = ui.helper
						.appendTo( sortable.element )
						.data( "ui-sortable-item", true );

					// Store helper option to later restore it
					sortable.options._helper = sortable.options.helper;

					sortable.options.helper = function() {
						return ui.helper[ 0 ];
					};

					// Fire the start events of the sortable with our passed browser event,
					// and our own helper (so it doesn't create a new one)
					event.target = sortable.currentItem[ 0 ];
					sortable._mouseCapture( event, true );
					sortable._mouseStart( event, true, true );

					// Because the browser event is way off the new appended portlet,
					// modify necessary variables to reflect the changes
					sortable.offset.click.top = draggable.offset.click.top;
					sortable.offset.click.left = draggable.offset.click.left;
					sortable.offset.parent.left -= draggable.offset.parent.left -
						sortable.offset.parent.left;
					sortable.offset.parent.top -= draggable.offset.parent.top -
						sortable.offset.parent.top;

					draggable._trigger( "toSortable", event );

					// Inform draggable that the helper is in a valid drop zone,
					// used solely in the revert option to handle "valid/invalid".
					draggable.dropped = sortable.element;

					// Need to refreshPositions of all sortables in the case that
					// adding to one sortable changes the location of the other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					});

					// hack so receive/update callbacks work (mostly)
					draggable.currentItem = draggable.element;
					sortable.fromOutside = draggable;
				}

				if ( sortable.currentItem ) {
					sortable._mouseDrag( event );
					// Copy the sortable's position because the draggable's can potentially reflect
					// a relative position, while sortable is always absolute, which the dragged
					// element has now become. (#8809)
					ui.position = sortable.position;
				}
			} else {
				// If it doesn't intersect with the sortable, and it intersected before,
				// we fake the drag stop of the sortable, but make sure it doesn't remove
				// the helper by using cancelHelperRemoval.
				if ( sortable.isOver ) {

					sortable.isOver = 0;
					sortable.cancelHelperRemoval = true;

					// Calling sortable's mouseStop would trigger a revert,
					// so revert must be temporarily false until after mouseStop is called.
					sortable.options._revert = sortable.options.revert;
					sortable.options.revert = false;

					sortable._trigger( "out", event, sortable._uiHash( sortable ) );
					sortable._mouseStop( event, true );

					// restore sortable behaviors that were modfied
					// when the draggable entered the sortable area (#9481)
					sortable.options.revert = sortable.options._revert;
					sortable.options.helper = sortable.options._helper;

					if ( sortable.placeholder ) {
						sortable.placeholder.remove();
					}

					// Restore and recalculate the draggable's offset considering the sortable
					// may have modified them in unexpected ways. (#8809, #10669)
					ui.helper.appendTo( draggable._parent );
					draggable._refreshOffsets( event );
					ui.position = draggable._generatePosition( event, true );

					draggable._trigger( "fromSortable", event );

					// Inform draggable that the helper is no longer in a valid drop zone
					draggable.dropped = false;

					// Need to refreshPositions of all sortables just in case removing
					// from one sortable changes the location of other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					});
				}
			}
		});
	}
});

$.ui.plugin.add("draggable", "cursor", {
	start: function( event, ui, instance ) {
		var t = $( "body" ),
			o = instance.options;

		if (t.css("cursor")) {
			o._cursor = t.css("cursor");
		}
		t.css("cursor", o.cursor);
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if (o._cursor) {
			$("body").css("cursor", o._cursor);
		}
	}
});

$.ui.plugin.add("draggable", "opacity", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;
		if (t.css("opacity")) {
			o._opacity = t.css("opacity");
		}
		t.css("opacity", o.opacity);
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if (o._opacity) {
			$(ui.helper).css("opacity", o._opacity);
		}
	}
});

$.ui.plugin.add("draggable", "scroll", {
	start: function( event, ui, i ) {
		if ( !i.scrollParentNotHidden ) {
			i.scrollParentNotHidden = i.helper.scrollParent( false );
		}

		if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] && i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
			i.overflowOffset = i.scrollParentNotHidden.offset();
		}
	},
	drag: function( event, ui, i  ) {

		var o = i.options,
			scrolled = false,
			scrollParent = i.scrollParentNotHidden[ 0 ],
			document = i.document[ 0 ];

		if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
			if ( !o.axis || o.axis !== "x" ) {
				if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY < o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
				} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
				}
			}

			if ( !o.axis || o.axis !== "y" ) {
				if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX < o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
				} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
				}
			}

		} else {

			if (!o.axis || o.axis !== "x") {
				if (event.pageY - $(document).scrollTop() < o.scrollSensitivity) {
					scrolled = $(document).scrollTop($(document).scrollTop() - o.scrollSpeed);
				} else if ($(window).height() - (event.pageY - $(document).scrollTop()) < o.scrollSensitivity) {
					scrolled = $(document).scrollTop($(document).scrollTop() + o.scrollSpeed);
				}
			}

			if (!o.axis || o.axis !== "y") {
				if (event.pageX - $(document).scrollLeft() < o.scrollSensitivity) {
					scrolled = $(document).scrollLeft($(document).scrollLeft() - o.scrollSpeed);
				} else if ($(window).width() - (event.pageX - $(document).scrollLeft()) < o.scrollSensitivity) {
					scrolled = $(document).scrollLeft($(document).scrollLeft() + o.scrollSpeed);
				}
			}

		}

		if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
			$.ui.ddmanager.prepareOffsets(i, event);
		}

	}
});

$.ui.plugin.add("draggable", "snap", {
	start: function( event, ui, i ) {

		var o = i.options;

		i.snapElements = [];

		$(o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap).each(function() {
			var $t = $(this),
				$o = $t.offset();
			if (this !== i.element[0]) {
				i.snapElements.push({
					item: this,
					width: $t.outerWidth(), height: $t.outerHeight(),
					top: $o.top, left: $o.left
				});
			}
		});

	},
	drag: function( event, ui, inst ) {

		var ts, bs, ls, rs, l, r, t, b, i, first,
			o = inst.options,
			d = o.snapTolerance,
			x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
			y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;

		for (i = inst.snapElements.length - 1; i >= 0; i--){

			l = inst.snapElements[i].left - inst.margins.left;
			r = l + inst.snapElements[i].width;
			t = inst.snapElements[i].top - inst.margins.top;
			b = t + inst.snapElements[i].height;

			if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d || !$.contains( inst.snapElements[ i ].item.ownerDocument, inst.snapElements[ i ].item ) ) {
				if (inst.snapElements[i].snapping) {
					(inst.options.snap.release && inst.options.snap.release.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
				}
				inst.snapElements[i].snapping = false;
				continue;
			}

			if (o.snapMode !== "inner") {
				ts = Math.abs(t - y2) <= d;
				bs = Math.abs(b - y1) <= d;
				ls = Math.abs(l - x2) <= d;
				rs = Math.abs(r - x1) <= d;
				if (ts) {
					ui.position.top = inst._convertPositionTo("relative", { top: t - inst.helperProportions.height, left: 0 }).top;
				}
				if (bs) {
					ui.position.top = inst._convertPositionTo("relative", { top: b, left: 0 }).top;
				}
				if (ls) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l - inst.helperProportions.width }).left;
				}
				if (rs) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r }).left;
				}
			}

			first = (ts || bs || ls || rs);

			if (o.snapMode !== "outer") {
				ts = Math.abs(t - y1) <= d;
				bs = Math.abs(b - y2) <= d;
				ls = Math.abs(l - x1) <= d;
				rs = Math.abs(r - x2) <= d;
				if (ts) {
					ui.position.top = inst._convertPositionTo("relative", { top: t, left: 0 }).top;
				}
				if (bs) {
					ui.position.top = inst._convertPositionTo("relative", { top: b - inst.helperProportions.height, left: 0 }).top;
				}
				if (ls) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l }).left;
				}
				if (rs) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r - inst.helperProportions.width }).left;
				}
			}

			if (!inst.snapElements[i].snapping && (ts || bs || ls || rs || first)) {
				(inst.options.snap.snap && inst.options.snap.snap.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
			}
			inst.snapElements[i].snapping = (ts || bs || ls || rs || first);

		}

	}
});

$.ui.plugin.add("draggable", "stack", {
	start: function( event, ui, instance ) {
		var min,
			o = instance.options,
			group = $.makeArray($(o.stack)).sort(function(a, b) {
				return (parseInt($(a).css("zIndex"), 10) || 0) - (parseInt($(b).css("zIndex"), 10) || 0);
			});

		if (!group.length) { return; }

		min = parseInt($(group[0]).css("zIndex"), 10) || 0;
		$(group).each(function(i) {
			$(this).css("zIndex", min + i);
		});
		this.css("zIndex", (min + group.length));
	}
});

$.ui.plugin.add("draggable", "zIndex", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;

		if (t.css("zIndex")) {
			o._zIndex = t.css("zIndex");
		}
		t.css("zIndex", o.zIndex);
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;

		if (o._zIndex) {
			$(ui.helper).css("zIndex", o._zIndex);
		}
	}
});

return $.ui.draggable;

}));


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Resizable 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/resizable/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(12),
			__webpack_require__(14),
			__webpack_require__(15),
			__webpack_require__(13)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

$.widget("ui.resizable", $.ui.mouse, {
	version: "1.11.4",
	widgetEventPrefix: "resize",
	options: {
		alsoResize: false,
		animate: false,
		animateDuration: "slow",
		animateEasing: "swing",
		aspectRatio: false,
		autoHide: false,
		containment: false,
		ghost: false,
		grid: false,
		handles: "e,s,se",
		helper: false,
		maxHeight: null,
		maxWidth: null,
		minHeight: 10,
		minWidth: 10,
		// See #7960
		zIndex: 90,

		// callbacks
		resize: null,
		start: null,
		stop: null
	},

	_num: function( value ) {
		return parseInt( value, 10 ) || 0;
	},

	_isNumber: function( value ) {
		return !isNaN( parseInt( value, 10 ) );
	},

	_hasScroll: function( el, a ) {

		if ( $( el ).css( "overflow" ) === "hidden") {
			return false;
		}

		var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
			has = false;

		if ( el[ scroll ] > 0 ) {
			return true;
		}

		// TODO: determine which cases actually cause this to happen
		// if the element doesn't have the scroll set, see if it's possible to
		// set the scroll
		el[ scroll ] = 1;
		has = ( el[ scroll ] > 0 );
		el[ scroll ] = 0;
		return has;
	},

	_create: function() {

		var n, i, handle, axis, hname,
			that = this,
			o = this.options;
		this.element.addClass("ui-resizable");

		$.extend(this, {
			_aspectRatio: !!(o.aspectRatio),
			aspectRatio: o.aspectRatio,
			originalElement: this.element,
			_proportionallyResizeElements: [],
			_helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
		});

		// Wrap the element if it cannot hold child nodes
		if (this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)) {

			this.element.wrap(
				$("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({
					position: this.element.css("position"),
					width: this.element.outerWidth(),
					height: this.element.outerHeight(),
					top: this.element.css("top"),
					left: this.element.css("left")
				})
			);

			this.element = this.element.parent().data(
				"ui-resizable", this.element.resizable( "instance" )
			);

			this.elementIsWrapper = true;

			this.element.css({
				marginLeft: this.originalElement.css("marginLeft"),
				marginTop: this.originalElement.css("marginTop"),
				marginRight: this.originalElement.css("marginRight"),
				marginBottom: this.originalElement.css("marginBottom")
			});
			this.originalElement.css({
				marginLeft: 0,
				marginTop: 0,
				marginRight: 0,
				marginBottom: 0
			});
			// support: Safari
			// Prevent Safari textarea resize
			this.originalResizeStyle = this.originalElement.css("resize");
			this.originalElement.css("resize", "none");

			this._proportionallyResizeElements.push( this.originalElement.css({
				position: "static",
				zoom: 1,
				display: "block"
			}) );

			// support: IE9
			// avoid IE jump (hard set the margin)
			this.originalElement.css({ margin: this.originalElement.css("margin") });

			this._proportionallyResize();
		}

		this.handles = o.handles ||
			( !$(".ui-resizable-handle", this.element).length ?
				"e,s,se" : {
					n: ".ui-resizable-n",
					e: ".ui-resizable-e",
					s: ".ui-resizable-s",
					w: ".ui-resizable-w",
					se: ".ui-resizable-se",
					sw: ".ui-resizable-sw",
					ne: ".ui-resizable-ne",
					nw: ".ui-resizable-nw"
				} );

		this._handles = $();
		if ( this.handles.constructor === String ) {

			if ( this.handles === "all") {
				this.handles = "n,e,s,w,se,sw,ne,nw";
			}

			n = this.handles.split(",");
			this.handles = {};

			for (i = 0; i < n.length; i++) {

				handle = $.trim(n[i]);
				hname = "ui-resizable-" + handle;
				axis = $("<div class='ui-resizable-handle " + hname + "'></div>");

				axis.css({ zIndex: o.zIndex });

				// TODO : What's going on here?
				if ("se" === handle) {
					axis.addClass("ui-icon ui-icon-gripsmall-diagonal-se");
				}

				this.handles[handle] = ".ui-resizable-" + handle;
				this.element.append(axis);
			}

		}

		this._renderAxis = function(target) {

			var i, axis, padPos, padWrapper;

			target = target || this.element;

			for (i in this.handles) {

				if (this.handles[i].constructor === String) {
					this.handles[i] = this.element.children( this.handles[ i ] ).first().show();
				} else if ( this.handles[ i ].jquery || this.handles[ i ].nodeType ) {
					this.handles[ i ] = $( this.handles[ i ] );
					this._on( this.handles[ i ], { "mousedown": that._mouseDown });
				}

				if (this.elementIsWrapper && this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)) {

					axis = $(this.handles[i], this.element);

					padWrapper = /sw|ne|nw|se|n|s/.test(i) ? axis.outerHeight() : axis.outerWidth();

					padPos = [ "padding",
						/ne|nw|n/.test(i) ? "Top" :
						/se|sw|s/.test(i) ? "Bottom" :
						/^e$/.test(i) ? "Right" : "Left" ].join("");

					target.css(padPos, padWrapper);

					this._proportionallyResize();
				}

				this._handles = this._handles.add( this.handles[ i ] );
			}
		};

		// TODO: make renderAxis a prototype function
		this._renderAxis(this.element);

		this._handles = this._handles.add( this.element.find( ".ui-resizable-handle" ) );
		this._handles.disableSelection();

		this._handles.mouseover(function() {
			if (!that.resizing) {
				if (this.className) {
					axis = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i);
				}
				that.axis = axis && axis[1] ? axis[1] : "se";
			}
		});

		if (o.autoHide) {
			this._handles.hide();
			$(this.element)
				.addClass("ui-resizable-autohide")
				.mouseenter(function() {
					if (o.disabled) {
						return;
					}
					$(this).removeClass("ui-resizable-autohide");
					that._handles.show();
				})
				.mouseleave(function() {
					if (o.disabled) {
						return;
					}
					if (!that.resizing) {
						$(this).addClass("ui-resizable-autohide");
						that._handles.hide();
					}
				});
		}

		this._mouseInit();
	},

	_destroy: function() {

		this._mouseDestroy();

		var wrapper,
			_destroy = function(exp) {
				$(exp)
					.removeClass("ui-resizable ui-resizable-disabled ui-resizable-resizing")
					.removeData("resizable")
					.removeData("ui-resizable")
					.unbind(".resizable")
					.find(".ui-resizable-handle")
						.remove();
			};

		// TODO: Unwrap at same DOM position
		if (this.elementIsWrapper) {
			_destroy(this.element);
			wrapper = this.element;
			this.originalElement.css({
				position: wrapper.css("position"),
				width: wrapper.outerWidth(),
				height: wrapper.outerHeight(),
				top: wrapper.css("top"),
				left: wrapper.css("left")
			}).insertAfter( wrapper );
			wrapper.remove();
		}

		this.originalElement.css("resize", this.originalResizeStyle);
		_destroy(this.originalElement);

		return this;
	},

	_mouseCapture: function(event) {
		var i, handle,
			capture = false;

		for (i in this.handles) {
			handle = $(this.handles[i])[0];
			if (handle === event.target || $.contains(handle, event.target)) {
				capture = true;
			}
		}

		return !this.options.disabled && capture;
	},

	_mouseStart: function(event) {

		var curleft, curtop, cursor,
			o = this.options,
			el = this.element;

		this.resizing = true;

		this._renderProxy();

		curleft = this._num(this.helper.css("left"));
		curtop = this._num(this.helper.css("top"));

		if (o.containment) {
			curleft += $(o.containment).scrollLeft() || 0;
			curtop += $(o.containment).scrollTop() || 0;
		}

		this.offset = this.helper.offset();
		this.position = { left: curleft, top: curtop };

		this.size = this._helper ? {
				width: this.helper.width(),
				height: this.helper.height()
			} : {
				width: el.width(),
				height: el.height()
			};

		this.originalSize = this._helper ? {
				width: el.outerWidth(),
				height: el.outerHeight()
			} : {
				width: el.width(),
				height: el.height()
			};

		this.sizeDiff = {
			width: el.outerWidth() - el.width(),
			height: el.outerHeight() - el.height()
		};

		this.originalPosition = { left: curleft, top: curtop };
		this.originalMousePosition = { left: event.pageX, top: event.pageY };

		this.aspectRatio = (typeof o.aspectRatio === "number") ?
			o.aspectRatio :
			((this.originalSize.width / this.originalSize.height) || 1);

		cursor = $(".ui-resizable-" + this.axis).css("cursor");
		$("body").css("cursor", cursor === "auto" ? this.axis + "-resize" : cursor);

		el.addClass("ui-resizable-resizing");
		this._propagate("start", event);
		return true;
	},

	_mouseDrag: function(event) {

		var data, props,
			smp = this.originalMousePosition,
			a = this.axis,
			dx = (event.pageX - smp.left) || 0,
			dy = (event.pageY - smp.top) || 0,
			trigger = this._change[a];

		this._updatePrevProperties();

		if (!trigger) {
			return false;
		}

		data = trigger.apply(this, [ event, dx, dy ]);

		this._updateVirtualBoundaries(event.shiftKey);
		if (this._aspectRatio || event.shiftKey) {
			data = this._updateRatio(data, event);
		}

		data = this._respectSize(data, event);

		this._updateCache(data);

		this._propagate("resize", event);

		props = this._applyChanges();

		if ( !this._helper && this._proportionallyResizeElements.length ) {
			this._proportionallyResize();
		}

		if ( !$.isEmptyObject( props ) ) {
			this._updatePrevProperties();
			this._trigger( "resize", event, this.ui() );
			this._applyChanges();
		}

		return false;
	},

	_mouseStop: function(event) {

		this.resizing = false;
		var pr, ista, soffseth, soffsetw, s, left, top,
			o = this.options, that = this;

		if (this._helper) {

			pr = this._proportionallyResizeElements;
			ista = pr.length && (/textarea/i).test(pr[0].nodeName);
			soffseth = ista && this._hasScroll(pr[0], "left") ? 0 : that.sizeDiff.height;
			soffsetw = ista ? 0 : that.sizeDiff.width;

			s = {
				width: (that.helper.width()  - soffsetw),
				height: (that.helper.height() - soffseth)
			};
			left = (parseInt(that.element.css("left"), 10) +
				(that.position.left - that.originalPosition.left)) || null;
			top = (parseInt(that.element.css("top"), 10) +
				(that.position.top - that.originalPosition.top)) || null;

			if (!o.animate) {
				this.element.css($.extend(s, { top: top, left: left }));
			}

			that.helper.height(that.size.height);
			that.helper.width(that.size.width);

			if (this._helper && !o.animate) {
				this._proportionallyResize();
			}
		}

		$("body").css("cursor", "auto");

		this.element.removeClass("ui-resizable-resizing");

		this._propagate("stop", event);

		if (this._helper) {
			this.helper.remove();
		}

		return false;

	},

	_updatePrevProperties: function() {
		this.prevPosition = {
			top: this.position.top,
			left: this.position.left
		};
		this.prevSize = {
			width: this.size.width,
			height: this.size.height
		};
	},

	_applyChanges: function() {
		var props = {};

		if ( this.position.top !== this.prevPosition.top ) {
			props.top = this.position.top + "px";
		}
		if ( this.position.left !== this.prevPosition.left ) {
			props.left = this.position.left + "px";
		}
		if ( this.size.width !== this.prevSize.width ) {
			props.width = this.size.width + "px";
		}
		if ( this.size.height !== this.prevSize.height ) {
			props.height = this.size.height + "px";
		}

		this.helper.css( props );

		return props;
	},

	_updateVirtualBoundaries: function(forceAspectRatio) {
		var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
			o = this.options;

		b = {
			minWidth: this._isNumber(o.minWidth) ? o.minWidth : 0,
			maxWidth: this._isNumber(o.maxWidth) ? o.maxWidth : Infinity,
			minHeight: this._isNumber(o.minHeight) ? o.minHeight : 0,
			maxHeight: this._isNumber(o.maxHeight) ? o.maxHeight : Infinity
		};

		if (this._aspectRatio || forceAspectRatio) {
			pMinWidth = b.minHeight * this.aspectRatio;
			pMinHeight = b.minWidth / this.aspectRatio;
			pMaxWidth = b.maxHeight * this.aspectRatio;
			pMaxHeight = b.maxWidth / this.aspectRatio;

			if (pMinWidth > b.minWidth) {
				b.minWidth = pMinWidth;
			}
			if (pMinHeight > b.minHeight) {
				b.minHeight = pMinHeight;
			}
			if (pMaxWidth < b.maxWidth) {
				b.maxWidth = pMaxWidth;
			}
			if (pMaxHeight < b.maxHeight) {
				b.maxHeight = pMaxHeight;
			}
		}
		this._vBoundaries = b;
	},

	_updateCache: function(data) {
		this.offset = this.helper.offset();
		if (this._isNumber(data.left)) {
			this.position.left = data.left;
		}
		if (this._isNumber(data.top)) {
			this.position.top = data.top;
		}
		if (this._isNumber(data.height)) {
			this.size.height = data.height;
		}
		if (this._isNumber(data.width)) {
			this.size.width = data.width;
		}
	},

	_updateRatio: function( data ) {

		var cpos = this.position,
			csize = this.size,
			a = this.axis;

		if (this._isNumber(data.height)) {
			data.width = (data.height * this.aspectRatio);
		} else if (this._isNumber(data.width)) {
			data.height = (data.width / this.aspectRatio);
		}

		if (a === "sw") {
			data.left = cpos.left + (csize.width - data.width);
			data.top = null;
		}
		if (a === "nw") {
			data.top = cpos.top + (csize.height - data.height);
			data.left = cpos.left + (csize.width - data.width);
		}

		return data;
	},

	_respectSize: function( data ) {

		var o = this._vBoundaries,
			a = this.axis,
			ismaxw = this._isNumber(data.width) && o.maxWidth && (o.maxWidth < data.width),
			ismaxh = this._isNumber(data.height) && o.maxHeight && (o.maxHeight < data.height),
			isminw = this._isNumber(data.width) && o.minWidth && (o.minWidth > data.width),
			isminh = this._isNumber(data.height) && o.minHeight && (o.minHeight > data.height),
			dw = this.originalPosition.left + this.originalSize.width,
			dh = this.position.top + this.size.height,
			cw = /sw|nw|w/.test(a), ch = /nw|ne|n/.test(a);
		if (isminw) {
			data.width = o.minWidth;
		}
		if (isminh) {
			data.height = o.minHeight;
		}
		if (ismaxw) {
			data.width = o.maxWidth;
		}
		if (ismaxh) {
			data.height = o.maxHeight;
		}

		if (isminw && cw) {
			data.left = dw - o.minWidth;
		}
		if (ismaxw && cw) {
			data.left = dw - o.maxWidth;
		}
		if (isminh && ch) {
			data.top = dh - o.minHeight;
		}
		if (ismaxh && ch) {
			data.top = dh - o.maxHeight;
		}

		// Fixing jump error on top/left - bug #2330
		if (!data.width && !data.height && !data.left && data.top) {
			data.top = null;
		} else if (!data.width && !data.height && !data.top && data.left) {
			data.left = null;
		}

		return data;
	},

	_getPaddingPlusBorderDimensions: function( element ) {
		var i = 0,
			widths = [],
			borders = [
				element.css( "borderTopWidth" ),
				element.css( "borderRightWidth" ),
				element.css( "borderBottomWidth" ),
				element.css( "borderLeftWidth" )
			],
			paddings = [
				element.css( "paddingTop" ),
				element.css( "paddingRight" ),
				element.css( "paddingBottom" ),
				element.css( "paddingLeft" )
			];

		for ( ; i < 4; i++ ) {
			widths[ i ] = ( parseInt( borders[ i ], 10 ) || 0 );
			widths[ i ] += ( parseInt( paddings[ i ], 10 ) || 0 );
		}

		return {
			height: widths[ 0 ] + widths[ 2 ],
			width: widths[ 1 ] + widths[ 3 ]
		};
	},

	_proportionallyResize: function() {

		if (!this._proportionallyResizeElements.length) {
			return;
		}

		var prel,
			i = 0,
			element = this.helper || this.element;

		for ( ; i < this._proportionallyResizeElements.length; i++) {

			prel = this._proportionallyResizeElements[i];

			// TODO: Seems like a bug to cache this.outerDimensions
			// considering that we are in a loop.
			if (!this.outerDimensions) {
				this.outerDimensions = this._getPaddingPlusBorderDimensions( prel );
			}

			prel.css({
				height: (element.height() - this.outerDimensions.height) || 0,
				width: (element.width() - this.outerDimensions.width) || 0
			});

		}

	},

	_renderProxy: function() {

		var el = this.element, o = this.options;
		this.elementOffset = el.offset();

		if (this._helper) {

			this.helper = this.helper || $("<div style='overflow:hidden;'></div>");

			this.helper.addClass(this._helper).css({
				width: this.element.outerWidth() - 1,
				height: this.element.outerHeight() - 1,
				position: "absolute",
				left: this.elementOffset.left + "px",
				top: this.elementOffset.top + "px",
				zIndex: ++o.zIndex //TODO: Don't modify option
			});

			this.helper
				.appendTo("body")
				.disableSelection();

		} else {
			this.helper = this.element;
		}

	},

	_change: {
		e: function(event, dx) {
			return { width: this.originalSize.width + dx };
		},
		w: function(event, dx) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { left: sp.left + dx, width: cs.width - dx };
		},
		n: function(event, dx, dy) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { top: sp.top + dy, height: cs.height - dy };
		},
		s: function(event, dx, dy) {
			return { height: this.originalSize.height + dy };
		},
		se: function(event, dx, dy) {
			return $.extend(this._change.s.apply(this, arguments),
				this._change.e.apply(this, [ event, dx, dy ]));
		},
		sw: function(event, dx, dy) {
			return $.extend(this._change.s.apply(this, arguments),
				this._change.w.apply(this, [ event, dx, dy ]));
		},
		ne: function(event, dx, dy) {
			return $.extend(this._change.n.apply(this, arguments),
				this._change.e.apply(this, [ event, dx, dy ]));
		},
		nw: function(event, dx, dy) {
			return $.extend(this._change.n.apply(this, arguments),
				this._change.w.apply(this, [ event, dx, dy ]));
		}
	},

	_propagate: function(n, event) {
		$.ui.plugin.call(this, n, [ event, this.ui() ]);
		(n !== "resize" && this._trigger(n, event, this.ui()));
	},

	plugins: {},

	ui: function() {
		return {
			originalElement: this.originalElement,
			element: this.element,
			helper: this.helper,
			position: this.position,
			size: this.size,
			originalSize: this.originalSize,
			originalPosition: this.originalPosition
		};
	}

});

/*
 * Resizable Extensions
 */

$.ui.plugin.add("resizable", "animate", {

	stop: function( event ) {
		var that = $(this).resizable( "instance" ),
			o = that.options,
			pr = that._proportionallyResizeElements,
			ista = pr.length && (/textarea/i).test(pr[0].nodeName),
			soffseth = ista && that._hasScroll(pr[0], "left") ? 0 : that.sizeDiff.height,
			soffsetw = ista ? 0 : that.sizeDiff.width,
			style = { width: (that.size.width - soffsetw), height: (that.size.height - soffseth) },
			left = (parseInt(that.element.css("left"), 10) +
				(that.position.left - that.originalPosition.left)) || null,
			top = (parseInt(that.element.css("top"), 10) +
				(that.position.top - that.originalPosition.top)) || null;

		that.element.animate(
			$.extend(style, top && left ? { top: top, left: left } : {}), {
				duration: o.animateDuration,
				easing: o.animateEasing,
				step: function() {

					var data = {
						width: parseInt(that.element.css("width"), 10),
						height: parseInt(that.element.css("height"), 10),
						top: parseInt(that.element.css("top"), 10),
						left: parseInt(that.element.css("left"), 10)
					};

					if (pr && pr.length) {
						$(pr[0]).css({ width: data.width, height: data.height });
					}

					// propagating resize, and updating values for each animation step
					that._updateCache(data);
					that._propagate("resize", event);

				}
			}
		);
	}

});

$.ui.plugin.add( "resizable", "containment", {

	start: function() {
		var element, p, co, ch, cw, width, height,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			el = that.element,
			oc = o.containment,
			ce = ( oc instanceof $ ) ? oc.get( 0 ) : ( /parent/.test( oc ) ) ? el.parent().get( 0 ) : oc;

		if ( !ce ) {
			return;
		}

		that.containerElement = $( ce );

		if ( /document/.test( oc ) || oc === document ) {
			that.containerOffset = {
				left: 0,
				top: 0
			};
			that.containerPosition = {
				left: 0,
				top: 0
			};

			that.parentData = {
				element: $( document ),
				left: 0,
				top: 0,
				width: $( document ).width(),
				height: $( document ).height() || document.body.parentNode.scrollHeight
			};
		} else {
			element = $( ce );
			p = [];
			$([ "Top", "Right", "Left", "Bottom" ]).each(function( i, name ) {
				p[ i ] = that._num( element.css( "padding" + name ) );
			});

			that.containerOffset = element.offset();
			that.containerPosition = element.position();
			that.containerSize = {
				height: ( element.innerHeight() - p[ 3 ] ),
				width: ( element.innerWidth() - p[ 1 ] )
			};

			co = that.containerOffset;
			ch = that.containerSize.height;
			cw = that.containerSize.width;
			width = ( that._hasScroll ( ce, "left" ) ? ce.scrollWidth : cw );
			height = ( that._hasScroll ( ce ) ? ce.scrollHeight : ch ) ;

			that.parentData = {
				element: ce,
				left: co.left,
				top: co.top,
				width: width,
				height: height
			};
		}
	},

	resize: function( event ) {
		var woset, hoset, isParent, isOffsetRelative,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cp = that.position,
			pRatio = that._aspectRatio || event.shiftKey,
			cop = {
				top: 0,
				left: 0
			},
			ce = that.containerElement,
			continueResize = true;

		if ( ce[ 0 ] !== document && ( /static/ ).test( ce.css( "position" ) ) ) {
			cop = co;
		}

		if ( cp.left < ( that._helper ? co.left : 0 ) ) {
			that.size.width = that.size.width +
				( that._helper ?
					( that.position.left - co.left ) :
					( that.position.left - cop.left ) );

			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
			that.position.left = o.helper ? co.left : 0;
		}

		if ( cp.top < ( that._helper ? co.top : 0 ) ) {
			that.size.height = that.size.height +
				( that._helper ?
					( that.position.top - co.top ) :
					that.position.top );

			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
			that.position.top = that._helper ? co.top : 0;
		}

		isParent = that.containerElement.get( 0 ) === that.element.parent().get( 0 );
		isOffsetRelative = /relative|absolute/.test( that.containerElement.css( "position" ) );

		if ( isParent && isOffsetRelative ) {
			that.offset.left = that.parentData.left + that.position.left;
			that.offset.top = that.parentData.top + that.position.top;
		} else {
			that.offset.left = that.element.offset().left;
			that.offset.top = that.element.offset().top;
		}

		woset = Math.abs( that.sizeDiff.width +
			(that._helper ?
				that.offset.left - cop.left :
				(that.offset.left - co.left)) );

		hoset = Math.abs( that.sizeDiff.height +
			(that._helper ?
				that.offset.top - cop.top :
				(that.offset.top - co.top)) );

		if ( woset + that.size.width >= that.parentData.width ) {
			that.size.width = that.parentData.width - woset;
			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
		}

		if ( hoset + that.size.height >= that.parentData.height ) {
			that.size.height = that.parentData.height - hoset;
			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
		}

		if ( !continueResize ) {
			that.position.left = that.prevPosition.left;
			that.position.top = that.prevPosition.top;
			that.size.width = that.prevSize.width;
			that.size.height = that.prevSize.height;
		}
	},

	stop: function() {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cop = that.containerPosition,
			ce = that.containerElement,
			helper = $( that.helper ),
			ho = helper.offset(),
			w = helper.outerWidth() - that.sizeDiff.width,
			h = helper.outerHeight() - that.sizeDiff.height;

		if ( that._helper && !o.animate && ( /relative/ ).test( ce.css( "position" ) ) ) {
			$( this ).css({
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			});
		}

		if ( that._helper && !o.animate && ( /static/ ).test( ce.css( "position" ) ) ) {
			$( this ).css({
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			});
		}
	}
});

$.ui.plugin.add("resizable", "alsoResize", {

	start: function() {
		var that = $(this).resizable( "instance" ),
			o = that.options;

		$(o.alsoResize).each(function() {
			var el = $(this);
			el.data("ui-resizable-alsoresize", {
				width: parseInt(el.width(), 10), height: parseInt(el.height(), 10),
				left: parseInt(el.css("left"), 10), top: parseInt(el.css("top"), 10)
			});
		});
	},

	resize: function(event, ui) {
		var that = $(this).resizable( "instance" ),
			o = that.options,
			os = that.originalSize,
			op = that.originalPosition,
			delta = {
				height: (that.size.height - os.height) || 0,
				width: (that.size.width - os.width) || 0,
				top: (that.position.top - op.top) || 0,
				left: (that.position.left - op.left) || 0
			};

			$(o.alsoResize).each(function() {
				var el = $(this), start = $(this).data("ui-resizable-alsoresize"), style = {},
					css = el.parents(ui.originalElement[0]).length ?
							[ "width", "height" ] :
							[ "width", "height", "top", "left" ];

				$.each(css, function(i, prop) {
					var sum = (start[prop] || 0) + (delta[prop] || 0);
					if (sum && sum >= 0) {
						style[prop] = sum || null;
					}
				});

				el.css(style);
			});
	},

	stop: function() {
		$(this).removeData("resizable-alsoresize");
	}
});

$.ui.plugin.add("resizable", "ghost", {

	start: function() {

		var that = $(this).resizable( "instance" ), o = that.options, cs = that.size;

		that.ghost = that.originalElement.clone();
		that.ghost
			.css({
				opacity: 0.25,
				display: "block",
				position: "relative",
				height: cs.height,
				width: cs.width,
				margin: 0,
				left: 0,
				top: 0
			})
			.addClass("ui-resizable-ghost")
			.addClass(typeof o.ghost === "string" ? o.ghost : "");

		that.ghost.appendTo(that.helper);

	},

	resize: function() {
		var that = $(this).resizable( "instance" );
		if (that.ghost) {
			that.ghost.css({
				position: "relative",
				height: that.size.height,
				width: that.size.width
			});
		}
	},

	stop: function() {
		var that = $(this).resizable( "instance" );
		if (that.ghost && that.helper) {
			that.helper.get(0).removeChild(that.ghost.get(0));
		}
	}

});

$.ui.plugin.add("resizable", "grid", {

	resize: function() {
		var outerDimensions,
			that = $(this).resizable( "instance" ),
			o = that.options,
			cs = that.size,
			os = that.originalSize,
			op = that.originalPosition,
			a = that.axis,
			grid = typeof o.grid === "number" ? [ o.grid, o.grid ] : o.grid,
			gridX = (grid[0] || 1),
			gridY = (grid[1] || 1),
			ox = Math.round((cs.width - os.width) / gridX) * gridX,
			oy = Math.round((cs.height - os.height) / gridY) * gridY,
			newWidth = os.width + ox,
			newHeight = os.height + oy,
			isMaxWidth = o.maxWidth && (o.maxWidth < newWidth),
			isMaxHeight = o.maxHeight && (o.maxHeight < newHeight),
			isMinWidth = o.minWidth && (o.minWidth > newWidth),
			isMinHeight = o.minHeight && (o.minHeight > newHeight);

		o.grid = grid;

		if (isMinWidth) {
			newWidth += gridX;
		}
		if (isMinHeight) {
			newHeight += gridY;
		}
		if (isMaxWidth) {
			newWidth -= gridX;
		}
		if (isMaxHeight) {
			newHeight -= gridY;
		}

		if (/^(se|s|e)$/.test(a)) {
			that.size.width = newWidth;
			that.size.height = newHeight;
		} else if (/^(ne)$/.test(a)) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.top = op.top - oy;
		} else if (/^(sw)$/.test(a)) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.left = op.left - ox;
		} else {
			if ( newHeight - gridY <= 0 || newWidth - gridX <= 0) {
				outerDimensions = that._getPaddingPlusBorderDimensions( this );
			}

			if ( newHeight - gridY > 0 ) {
				that.size.height = newHeight;
				that.position.top = op.top - oy;
			} else {
				newHeight = gridY - outerDimensions.height;
				that.size.height = newHeight;
				that.position.top = op.top + os.height - newHeight;
			}
			if ( newWidth - gridX > 0 ) {
				that.size.width = newWidth;
				that.position.left = op.left - ox;
			} else {
				newWidth = gridX - outerDimensions.width;
				that.size.width = newWidth;
				that.position.left = op.left + os.width - newWidth;
			}
		}
	}

});

return $.ui.resizable;

}));


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Tooltip 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/tooltip/
 */
(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(12),
			__webpack_require__(14),
			__webpack_require__(13),
			__webpack_require__(20)
		], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

return $.widget( "ui.tooltip", {
	version: "1.11.4",
	options: {
		content: function() {
			// support: IE<9, Opera in jQuery <1.7
			// .text() can't accept undefined, so coerce to a string
			var title = $( this ).attr( "title" ) || "";
			// Escape title, since we're going from an attribute to raw HTML
			return $( "<a>" ).text( title ).html();
		},
		hide: true,
		// Disabled elements have inconsistent behavior across browsers (#8661)
		items: "[title]:not([disabled])",
		position: {
			my: "left top+15",
			at: "left bottom",
			collision: "flipfit flip"
		},
		show: true,
		tooltipClass: null,
		track: false,

		// callbacks
		close: null,
		open: null
	},

	_addDescribedBy: function( elem, id ) {
		var describedby = (elem.attr( "aria-describedby" ) || "").split( /\s+/ );
		describedby.push( id );
		elem
			.data( "ui-tooltip-id", id )
			.attr( "aria-describedby", $.trim( describedby.join( " " ) ) );
	},

	_removeDescribedBy: function( elem ) {
		var id = elem.data( "ui-tooltip-id" ),
			describedby = (elem.attr( "aria-describedby" ) || "").split( /\s+/ ),
			index = $.inArray( id, describedby );

		if ( index !== -1 ) {
			describedby.splice( index, 1 );
		}

		elem.removeData( "ui-tooltip-id" );
		describedby = $.trim( describedby.join( " " ) );
		if ( describedby ) {
			elem.attr( "aria-describedby", describedby );
		} else {
			elem.removeAttr( "aria-describedby" );
		}
	},

	_create: function() {
		this._on({
			mouseover: "open",
			focusin: "open"
		});

		// IDs of generated tooltips, needed for destroy
		this.tooltips = {};

		// IDs of parent tooltips where we removed the title attribute
		this.parents = {};

		if ( this.options.disabled ) {
			this._disable();
		}

		// Append the aria-live region so tooltips announce correctly
		this.liveRegion = $( "<div>" )
			.attr({
				role: "log",
				"aria-live": "assertive",
				"aria-relevant": "additions"
			})
			.addClass( "ui-helper-hidden-accessible" )
			.appendTo( this.document[ 0 ].body );
	},

	_setOption: function( key, value ) {
		var that = this;

		if ( key === "disabled" ) {
			this[ value ? "_disable" : "_enable" ]();
			this.options[ key ] = value;
			// disable element style changes
			return;
		}

		this._super( key, value );

		if ( key === "content" ) {
			$.each( this.tooltips, function( id, tooltipData ) {
				that._updateContent( tooltipData.element );
			});
		}
	},

	_disable: function() {
		var that = this;

		// close open tooltips
		$.each( this.tooltips, function( id, tooltipData ) {
			var event = $.Event( "blur" );
			event.target = event.currentTarget = tooltipData.element[ 0 ];
			that.close( event, true );
		});

		// remove title attributes to prevent native tooltips
		this.element.find( this.options.items ).addBack().each(function() {
			var element = $( this );
			if ( element.is( "[title]" ) ) {
				element
					.data( "ui-tooltip-title", element.attr( "title" ) )
					.removeAttr( "title" );
			}
		});
	},

	_enable: function() {
		// restore title attributes
		this.element.find( this.options.items ).addBack().each(function() {
			var element = $( this );
			if ( element.data( "ui-tooltip-title" ) ) {
				element.attr( "title", element.data( "ui-tooltip-title" ) );
			}
		});
	},

	open: function( event ) {
		var that = this,
			target = $( event ? event.target : this.element )
				// we need closest here due to mouseover bubbling,
				// but always pointing at the same event target
				.closest( this.options.items );

		// No element to show a tooltip for or the tooltip is already open
		if ( !target.length || target.data( "ui-tooltip-id" ) ) {
			return;
		}

		if ( target.attr( "title" ) ) {
			target.data( "ui-tooltip-title", target.attr( "title" ) );
		}

		target.data( "ui-tooltip-open", true );

		// kill parent tooltips, custom or native, for hover
		if ( event && event.type === "mouseover" ) {
			target.parents().each(function() {
				var parent = $( this ),
					blurEvent;
				if ( parent.data( "ui-tooltip-open" ) ) {
					blurEvent = $.Event( "blur" );
					blurEvent.target = blurEvent.currentTarget = this;
					that.close( blurEvent, true );
				}
				if ( parent.attr( "title" ) ) {
					parent.uniqueId();
					that.parents[ this.id ] = {
						element: this,
						title: parent.attr( "title" )
					};
					parent.attr( "title", "" );
				}
			});
		}

		this._registerCloseHandlers( event, target );
		this._updateContent( target, event );
	},

	_updateContent: function( target, event ) {
		var content,
			contentOption = this.options.content,
			that = this,
			eventType = event ? event.type : null;

		if ( typeof contentOption === "string" ) {
			return this._open( event, target, contentOption );
		}

		content = contentOption.call( target[0], function( response ) {

			// IE may instantly serve a cached response for ajax requests
			// delay this call to _open so the other call to _open runs first
			that._delay(function() {

				// Ignore async response if tooltip was closed already
				if ( !target.data( "ui-tooltip-open" ) ) {
					return;
				}

				// jQuery creates a special event for focusin when it doesn't
				// exist natively. To improve performance, the native event
				// object is reused and the type is changed. Therefore, we can't
				// rely on the type being correct after the event finished
				// bubbling, so we set it back to the previous value. (#8740)
				if ( event ) {
					event.type = eventType;
				}
				this._open( event, target, response );
			});
		});
		if ( content ) {
			this._open( event, target, content );
		}
	},

	_open: function( event, target, content ) {
		var tooltipData, tooltip, delayedShow, a11yContent,
			positionOption = $.extend( {}, this.options.position );

		if ( !content ) {
			return;
		}

		// Content can be updated multiple times. If the tooltip already
		// exists, then just update the content and bail.
		tooltipData = this._find( target );
		if ( tooltipData ) {
			tooltipData.tooltip.find( ".ui-tooltip-content" ).html( content );
			return;
		}

		// if we have a title, clear it to prevent the native tooltip
		// we have to check first to avoid defining a title if none exists
		// (we don't want to cause an element to start matching [title])
		//
		// We use removeAttr only for key events, to allow IE to export the correct
		// accessible attributes. For mouse events, set to empty string to avoid
		// native tooltip showing up (happens only when removing inside mouseover).
		if ( target.is( "[title]" ) ) {
			if ( event && event.type === "mouseover" ) {
				target.attr( "title", "" );
			} else {
				target.removeAttr( "title" );
			}
		}

		tooltipData = this._tooltip( target );
		tooltip = tooltipData.tooltip;
		this._addDescribedBy( target, tooltip.attr( "id" ) );
		tooltip.find( ".ui-tooltip-content" ).html( content );

		// Support: Voiceover on OS X, JAWS on IE <= 9
		// JAWS announces deletions even when aria-relevant="additions"
		// Voiceover will sometimes re-read the entire log region's contents from the beginning
		this.liveRegion.children().hide();
		if ( content.clone ) {
			a11yContent = content.clone();
			a11yContent.removeAttr( "id" ).find( "[id]" ).removeAttr( "id" );
		} else {
			a11yContent = content;
		}
		$( "<div>" ).html( a11yContent ).appendTo( this.liveRegion );

		function position( event ) {
			positionOption.of = event;
			if ( tooltip.is( ":hidden" ) ) {
				return;
			}
			tooltip.position( positionOption );
		}
		if ( this.options.track && event && /^mouse/.test( event.type ) ) {
			this._on( this.document, {
				mousemove: position
			});
			// trigger once to override element-relative positioning
			position( event );
		} else {
			tooltip.position( $.extend({
				of: target
			}, this.options.position ) );
		}

		tooltip.hide();

		this._show( tooltip, this.options.show );
		// Handle tracking tooltips that are shown with a delay (#8644). As soon
		// as the tooltip is visible, position the tooltip using the most recent
		// event.
		if ( this.options.show && this.options.show.delay ) {
			delayedShow = this.delayedShow = setInterval(function() {
				if ( tooltip.is( ":visible" ) ) {
					position( positionOption.of );
					clearInterval( delayedShow );
				}
			}, $.fx.interval );
		}

		this._trigger( "open", event, { tooltip: tooltip } );
	},

	_registerCloseHandlers: function( event, target ) {
		var events = {
			keyup: function( event ) {
				if ( event.keyCode === $.ui.keyCode.ESCAPE ) {
					var fakeEvent = $.Event(event);
					fakeEvent.currentTarget = target[0];
					this.close( fakeEvent, true );
				}
			}
		};

		// Only bind remove handler for delegated targets. Non-delegated
		// tooltips will handle this in destroy.
		if ( target[ 0 ] !== this.element[ 0 ] ) {
			events.remove = function() {
				this._removeTooltip( this._find( target ).tooltip );
			};
		}

		if ( !event || event.type === "mouseover" ) {
			events.mouseleave = "close";
		}
		if ( !event || event.type === "focusin" ) {
			events.focusout = "close";
		}
		this._on( true, target, events );
	},

	close: function( event ) {
		var tooltip,
			that = this,
			target = $( event ? event.currentTarget : this.element ),
			tooltipData = this._find( target );

		// The tooltip may already be closed
		if ( !tooltipData ) {

			// We set ui-tooltip-open immediately upon open (in open()), but only set the
			// additional data once there's actually content to show (in _open()). So even if the
			// tooltip doesn't have full data, we always remove ui-tooltip-open in case we're in
			// the period between open() and _open().
			target.removeData( "ui-tooltip-open" );
			return;
		}

		tooltip = tooltipData.tooltip;

		// disabling closes the tooltip, so we need to track when we're closing
		// to avoid an infinite loop in case the tooltip becomes disabled on close
		if ( tooltipData.closing ) {
			return;
		}

		// Clear the interval for delayed tracking tooltips
		clearInterval( this.delayedShow );

		// only set title if we had one before (see comment in _open())
		// If the title attribute has changed since open(), don't restore
		if ( target.data( "ui-tooltip-title" ) && !target.attr( "title" ) ) {
			target.attr( "title", target.data( "ui-tooltip-title" ) );
		}

		this._removeDescribedBy( target );

		tooltipData.hiding = true;
		tooltip.stop( true );
		this._hide( tooltip, this.options.hide, function() {
			that._removeTooltip( $( this ) );
		});

		target.removeData( "ui-tooltip-open" );
		this._off( target, "mouseleave focusout keyup" );

		// Remove 'remove' binding only on delegated targets
		if ( target[ 0 ] !== this.element[ 0 ] ) {
			this._off( target, "remove" );
		}
		this._off( this.document, "mousemove" );

		if ( event && event.type === "mouseleave" ) {
			$.each( this.parents, function( id, parent ) {
				$( parent.element ).attr( "title", parent.title );
				delete that.parents[ id ];
			});
		}

		tooltipData.closing = true;
		this._trigger( "close", event, { tooltip: tooltip } );
		if ( !tooltipData.hiding ) {
			tooltipData.closing = false;
		}
	},

	_tooltip: function( element ) {
		var tooltip = $( "<div>" )
				.attr( "role", "tooltip" )
				.addClass( "ui-tooltip ui-widget ui-corner-all ui-widget-content " +
					( this.options.tooltipClass || "" ) ),
			id = tooltip.uniqueId().attr( "id" );

		$( "<div>" )
			.addClass( "ui-tooltip-content" )
			.appendTo( tooltip );

		tooltip.appendTo( this.document[0].body );

		return this.tooltips[ id ] = {
			element: element,
			tooltip: tooltip
		};
	},

	_find: function( target ) {
		var id = target.data( "ui-tooltip-id" );
		return id ? this.tooltips[ id ] : null;
	},

	_removeTooltip: function( tooltip ) {
		tooltip.remove();
		delete this.tooltips[ tooltip.attr( "id" ) ];
	},

	_destroy: function() {
		var that = this;

		// close open tooltips
		$.each( this.tooltips, function( id, tooltipData ) {
			// Delegate to close method to handle common cleanup
			var event = $.Event( "blur" ),
				element = tooltipData.element;
			event.target = event.currentTarget = element[ 0 ];
			that.close( event, true );

			// Remove immediately; destroying an open tooltip doesn't use the
			// hide animation
			$( "#" + id ).remove();

			// Restore the title
			if ( element.data( "ui-tooltip-title" ) ) {
				// If the title attribute has changed since open(), don't restore
				if ( !element.attr( "title" ) ) {
					element.attr( "title", element.data( "ui-tooltip-title" ) );
				}
				element.removeData( "ui-tooltip-title" );
			}
		});
		this.liveRegion.remove();
	}
});

}));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(45))

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = "/* == jquery mousewheel plugin == Version: 3.1.11, License: MIT License (MIT) */\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof exports?module.exports=a:a(jQuery)}(function(a){function b(b){var g=b||window.event,h=i.call(arguments,1),j=0,l=0,m=0,n=0,o=0,p=0;if(b=a.event.fix(g),b.type=\"mousewheel\",\"detail\"in g&&(m=-1*g.detail),\"wheelDelta\"in g&&(m=g.wheelDelta),\"wheelDeltaY\"in g&&(m=g.wheelDeltaY),\"wheelDeltaX\"in g&&(l=-1*g.wheelDeltaX),\"axis\"in g&&g.axis===g.HORIZONTAL_AXIS&&(l=-1*m,m=0),j=0===m?l:m,\"deltaY\"in g&&(m=-1*g.deltaY,j=m),\"deltaX\"in g&&(l=g.deltaX,0===m&&(j=-1*l)),0!==m||0!==l){if(1===g.deltaMode){var q=a.data(this,\"mousewheel-line-height\");j*=q,m*=q,l*=q}else if(2===g.deltaMode){var r=a.data(this,\"mousewheel-page-height\");j*=r,m*=r,l*=r}if(n=Math.max(Math.abs(m),Math.abs(l)),(!f||f>n)&&(f=n,d(g,n)&&(f/=40)),d(g,n)&&(j/=40,l/=40,m/=40),j=Math[j>=1?\"floor\":\"ceil\"](j/f),l=Math[l>=1?\"floor\":\"ceil\"](l/f),m=Math[m>=1?\"floor\":\"ceil\"](m/f),k.settings.normalizeOffset&&this.getBoundingClientRect){var s=this.getBoundingClientRect();o=b.clientX-s.left,p=b.clientY-s.top}return b.deltaX=l,b.deltaY=m,b.deltaFactor=f,b.offsetX=o,b.offsetY=p,b.deltaMode=0,h.unshift(b,j,l,m),e&&clearTimeout(e),e=setTimeout(c,200),(a.event.dispatch||a.event.handle).apply(this,h)}}function c(){f=null}function d(a,b){return k.settings.adjustOldDeltas&&\"mousewheel\"===a.type&&b%120===0}var e,f,g=[\"wheel\",\"mousewheel\",\"DOMMouseScroll\",\"MozMousePixelScroll\"],h=\"onwheel\"in document||document.documentMode>=9?[\"wheel\"]:[\"mousewheel\",\"DomMouseScroll\",\"MozMousePixelScroll\"],i=Array.prototype.slice;if(a.event.fixHooks)for(var j=g.length;j;)a.event.fixHooks[g[--j]]=a.event.mouseHooks;var k=a.event.special.mousewheel={version:\"3.1.11\",setup:function(){if(this.addEventListener)for(var c=h.length;c;)this.addEventListener(h[--c],b,!1);else this.onmousewheel=b;a.data(this,\"mousewheel-line-height\",k.getLineHeight(this)),a.data(this,\"mousewheel-page-height\",k.getPageHeight(this))},teardown:function(){if(this.removeEventListener)for(var c=h.length;c;)this.removeEventListener(h[--c],b,!1);else this.onmousewheel=null;a.removeData(this,\"mousewheel-line-height\"),a.removeData(this,\"mousewheel-page-height\")},getLineHeight:function(b){var c=a(b)[\"offsetParent\"in a.fn?\"offsetParent\":\"parent\"]();return c.length||(c=a(\"body\")),parseInt(c.css(\"fontSize\"),10)},getPageHeight:function(b){return a(b).height()},settings:{adjustOldDeltas:!0,normalizeOffset:!0}};a.fn.extend({mousewheel:function(a){return a?this.bind(\"mousewheel\",a):this.trigger(\"mousewheel\")},unmousewheel:function(a){return this.unbind(\"mousewheel\",a)}})});\n/* == malihu jquery custom scrollbar plugin == Version: 3.0.5, License: MIT License (MIT) */\n!function(e,t,o){!function(t){var a=\"function\"==typeof define&&define.amd,n=\"https:\"==o.location.protocol?\"https:\":\"http:\",r=\"cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.1.11/jquery.mousewheel.min.js\";a||e.event.special.mousewheel||e(\"head\").append(decodeURI(\"%3Cscript src=\"+n+\"//\"+r+\"%3E%3C/script%3E\")),t()}(function(){var a=\"mCustomScrollbar\",n=\"mCS\",r=\".mCustomScrollbar\",i={setWidth:!1,setHeight:!1,setTop:0,setLeft:0,axis:\"y\",scrollbarPosition:\"inside\",scrollInertia:950,autoDraggerLength:!0,autoHideScrollbar:!1,autoExpandScrollbar:!1,alwaysShowScrollbar:0,snapAmount:null,snapOffset:0,mouseWheel:{enable:!0,scrollAmount:\"auto\",axis:\"y\",preventDefault:!1,deltaFactor:\"auto\",normalizeDelta:!1,invert:!1,disableOver:[\"select\",\"option\",\"keygen\",\"datalist\",\"textarea\"]},scrollButtons:{enable:!1,scrollType:\"stepless\",scrollAmount:\"auto\"},keyboard:{enable:!0,scrollType:\"stepless\",scrollAmount:\"auto\"},contentTouchScroll:25,advanced:{autoExpandHorizontalScroll:!1,autoScrollOnFocus:\"input,textarea,select,button,datalist,keygen,a[tabindex],area,object,[contenteditable='true']\",updateOnContentResize:!0,updateOnImageLoad:!0,updateOnSelectorChange:!1,releaseDraggableSelectors:!1},theme:\"light\",callbacks:{onInit:!1,onScrollStart:!1,onScroll:!1,onTotalScroll:!1,onTotalScrollBack:!1,whileScrolling:!1,onTotalScrollOffset:0,onTotalScrollBackOffset:0,alwaysTriggerOffsets:!0,onOverflowY:!1,onOverflowX:!1,onOverflowYNone:!1,onOverflowXNone:!1},live:!1,liveSelector:null},l=0,s={},c=function(e){s[e]&&(clearTimeout(s[e]),h._delete.call(null,s[e]))},d=t.attachEvent&&!t.addEventListener?1:0,u=!1,f={init:function(t){var t=e.extend(!0,{},i,t),o=h._selector.call(this);if(t.live){var a=t.liveSelector||this.selector||r,d=e(a);if(\"off\"===t.live)return void c(a);s[a]=setTimeout(function(){d.mCustomScrollbar(t),\"once\"===t.live&&d.length&&c(a)},500)}else c(a);return t.setWidth=t.set_width?t.set_width:t.setWidth,t.setHeight=t.set_height?t.set_height:t.setHeight,t.axis=t.horizontalScroll?\"x\":h._findAxis.call(null,t.axis),t.scrollInertia=t.scrollInertia>0&&t.scrollInertia<17?17:t.scrollInertia,\"object\"!=typeof t.mouseWheel&&1==t.mouseWheel&&(t.mouseWheel={enable:!0,scrollAmount:\"auto\",axis:\"y\",preventDefault:!1,deltaFactor:\"auto\",normalizeDelta:!1,invert:!1}),t.mouseWheel.scrollAmount=t.mouseWheelPixels?t.mouseWheelPixels:t.mouseWheel.scrollAmount,t.mouseWheel.normalizeDelta=t.advanced.normalizeMouseWheelDelta?t.advanced.normalizeMouseWheelDelta:t.mouseWheel.normalizeDelta,t.scrollButtons.scrollType=h._findScrollButtonsType.call(null,t.scrollButtons.scrollType),h._theme.call(null,t),e(o).each(function(){var o=e(this);if(!o.data(n)){o.data(n,{idx:++l,opt:t,scrollRatio:{y:null,x:null},overflowed:null,contentReset:{y:null,x:null},bindEvents:!1,tweenRunning:!1,sequential:{},langDir:o.css(\"direction\"),cbOffsets:null,trigger:null});var a=o.data(n).opt,r=o.data(\"mcs-axis\"),i=o.data(\"mcs-scrollbar-position\"),s=o.data(\"mcs-theme\");r&&(a.axis=r),i&&(a.scrollbarPosition=i),s&&(a.theme=s,h._theme.call(null,a)),h._pluginMarkup.call(this),f.update.call(null,o)}})},update:function(t){var o=t||h._selector.call(this);return e(o).each(function(){var t=e(this);if(t.data(n)){var o=t.data(n),a=o.opt,r=e(\"#mCSB_\"+o.idx+\"_container\"),i=[e(\"#mCSB_\"+o.idx+\"_dragger_vertical\"),e(\"#mCSB_\"+o.idx+\"_dragger_horizontal\")];if(!r.length)return;o.tweenRunning&&h._stop.call(null,t),t.hasClass(\"mCS_disabled\")&&t.removeClass(\"mCS_disabled\"),t.hasClass(\"mCS_destroyed\")&&t.removeClass(\"mCS_destroyed\"),h._maxHeight.call(this),h._expandContentHorizontally.call(this),\"y\"===a.axis||a.advanced.autoExpandHorizontalScroll||r.css(\"width\",h._contentWidth(r.children())),o.overflowed=h._overflowed.call(this),h._scrollbarVisibility.call(this),a.autoDraggerLength&&h._setDraggerLength.call(this),h._scrollRatio.call(this),h._bindEvents.call(this);var l=[Math.abs(r[0].offsetTop),Math.abs(r[0].offsetLeft)];\"x\"!==a.axis&&(o.overflowed[0]?i[0].height()>i[0].parent().height()?h._resetContentPosition.call(this):(h._scrollTo.call(this,t,l[0].toString(),{dir:\"y\",dur:0,overwrite:\"none\"}),o.contentReset.y=null):(h._resetContentPosition.call(this),\"y\"===a.axis?h._unbindEvents.call(this):\"yx\"===a.axis&&o.overflowed[1]&&h._scrollTo.call(this,t,l[1].toString(),{dir:\"x\",dur:0,overwrite:\"none\"}))),\"y\"!==a.axis&&(o.overflowed[1]?i[1].width()>i[1].parent().width()?h._resetContentPosition.call(this):(h._scrollTo.call(this,t,l[1].toString(),{dir:\"x\",dur:0,overwrite:\"none\"}),o.contentReset.x=null):(h._resetContentPosition.call(this),\"x\"===a.axis?h._unbindEvents.call(this):\"yx\"===a.axis&&o.overflowed[0]&&h._scrollTo.call(this,t,l[0].toString(),{dir:\"y\",dur:0,overwrite:\"none\"}))),h._autoUpdate.call(this)}})},scrollTo:function(t,o){if(\"undefined\"!=typeof t&&null!=t){var a=h._selector.call(this);return e(a).each(function(){var a=e(this);if(a.data(n)){var r=a.data(n),i=r.opt,l={trigger:\"external\",scrollInertia:i.scrollInertia,scrollEasing:\"mcsEaseInOut\",moveDragger:!1,timeout:60,callbacks:!0,onStart:!0,onUpdate:!0,onComplete:!0},s=e.extend(!0,{},l,o),c=h._arr.call(this,t),d=s.scrollInertia>0&&s.scrollInertia<17?17:s.scrollInertia;c[0]=h._to.call(this,c[0],\"y\"),c[1]=h._to.call(this,c[1],\"x\"),s.moveDragger&&(c[0]*=r.scrollRatio.y,c[1]*=r.scrollRatio.x),s.dur=d,setTimeout(function(){null!==c[0]&&\"undefined\"!=typeof c[0]&&\"x\"!==i.axis&&r.overflowed[0]&&(s.dir=\"y\",s.overwrite=\"all\",h._scrollTo.call(this,a,c[0].toString(),s)),null!==c[1]&&\"undefined\"!=typeof c[1]&&\"y\"!==i.axis&&r.overflowed[1]&&(s.dir=\"x\",s.overwrite=\"none\",h._scrollTo.call(this,a,c[1].toString(),s))},s.timeout)}})}},stop:function(){var t=h._selector.call(this);return e(t).each(function(){var t=e(this);t.data(n)&&h._stop.call(null,t)})},disable:function(t){var o=h._selector.call(this);return e(o).each(function(){var o=e(this);if(o.data(n)){{var a=o.data(n);a.opt}h._autoUpdate.call(this,\"remove\"),h._unbindEvents.call(this),t&&h._resetContentPosition.call(this),h._scrollbarVisibility.call(this,!0),o.addClass(\"mCS_disabled\")}})},destroy:function(){var t=h._selector.call(this);return e(t).each(function(){var o=e(this);if(o.data(n)){var r=o.data(n),i=r.opt,l=e(\"#mCSB_\"+r.idx),s=e(\"#mCSB_\"+r.idx+\"_container\"),d=e(\".mCSB_\"+r.idx+\"_scrollbar\");i.live&&c(t),h._autoUpdate.call(this,\"remove\"),h._unbindEvents.call(this),h._resetContentPosition.call(this),o.removeData(n),h._delete.call(null,this.mcs),d.remove(),l.replaceWith(s.contents()),o.removeClass(a+\" _\"+n+\"_\"+r.idx+\" mCS-autoHide mCS-dir-rtl mCS_no_scrollbar mCS_disabled\").addClass(\"mCS_destroyed\")}})}},h={_selector:function(){return\"object\"!=typeof e(this)||e(this).length<1?r:this},_theme:function(t){var o=[\"rounded\",\"rounded-dark\",\"rounded-dots\",\"rounded-dots-dark\"],a=[\"rounded-dots\",\"rounded-dots-dark\",\"3d\",\"3d-dark\",\"3d-thick\",\"3d-thick-dark\",\"inset\",\"inset-dark\",\"inset-2\",\"inset-2-dark\",\"inset-3\",\"inset-3-dark\"],n=[\"minimal\",\"minimal-dark\"],r=[\"minimal\",\"minimal-dark\"],i=[\"minimal\",\"minimal-dark\"];t.autoDraggerLength=e.inArray(t.theme,o)>-1?!1:t.autoDraggerLength,t.autoExpandScrollbar=e.inArray(t.theme,a)>-1?!1:t.autoExpandScrollbar,t.scrollButtons.enable=e.inArray(t.theme,n)>-1?!1:t.scrollButtons.enable,t.autoHideScrollbar=e.inArray(t.theme,r)>-1?!0:t.autoHideScrollbar,t.scrollbarPosition=e.inArray(t.theme,i)>-1?\"outside\":t.scrollbarPosition},_findAxis:function(e){return\"yx\"===e||\"xy\"===e||\"auto\"===e?\"yx\":\"x\"===e||\"horizontal\"===e?\"x\":\"y\"},_findScrollButtonsType:function(e){return\"stepped\"===e||\"pixels\"===e||\"step\"===e||\"click\"===e?\"stepped\":\"stepless\"},_pluginMarkup:function(){var t=e(this),o=t.data(n),r=o.opt,i=r.autoExpandScrollbar?\" mCSB_scrollTools_onDrag_expand\":\"\",l=[\"<div id='mCSB_\"+o.idx+\"_scrollbar_vertical' class='mCSB_scrollTools mCSB_\"+o.idx+\"_scrollbar mCS-\"+r.theme+\" mCSB_scrollTools_vertical\"+i+\"'><div class='mCSB_draggerContainer'><div id='mCSB_\"+o.idx+\"_dragger_vertical' class='mCSB_dragger' style='position:absolute;' oncontextmenu='return false;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>\",\"<div id='mCSB_\"+o.idx+\"_scrollbar_horizontal' class='mCSB_scrollTools mCSB_\"+o.idx+\"_scrollbar mCS-\"+r.theme+\" mCSB_scrollTools_horizontal\"+i+\"'><div class='mCSB_draggerContainer'><div id='mCSB_\"+o.idx+\"_dragger_horizontal' class='mCSB_dragger' style='position:absolute;' oncontextmenu='return false;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>\"],s=\"yx\"===r.axis?\"mCSB_vertical_horizontal\":\"x\"===r.axis?\"mCSB_horizontal\":\"mCSB_vertical\",c=\"yx\"===r.axis?l[0]+l[1]:\"x\"===r.axis?l[1]:l[0],d=\"yx\"===r.axis?\"<div id='mCSB_\"+o.idx+\"_container_wrapper' class='mCSB_container_wrapper' />\":\"\",u=r.autoHideScrollbar?\" mCS-autoHide\":\"\",f=\"x\"!==r.axis&&\"rtl\"===o.langDir?\" mCS-dir-rtl\":\"\";r.setWidth&&t.css(\"width\",r.setWidth),r.setHeight&&t.css(\"height\",r.setHeight),r.setLeft=\"y\"!==r.axis&&\"rtl\"===o.langDir?\"989999px\":r.setLeft,t.addClass(a+\" _\"+n+\"_\"+o.idx+u+f).wrapInner(\"<div id='mCSB_\"+o.idx+\"' class='mCustomScrollBox mCS-\"+r.theme+\" \"+s+\"'><div id='mCSB_\"+o.idx+\"_container' class='mCSB_container' style='position:relative; top:\"+r.setTop+\"; left:\"+r.setLeft+\";' dir=\"+o.langDir+\" /></div>\");var _=e(\"#mCSB_\"+o.idx),m=e(\"#mCSB_\"+o.idx+\"_container\");\"y\"===r.axis||r.advanced.autoExpandHorizontalScroll||m.css(\"width\",h._contentWidth(m.children())),\"outside\"===r.scrollbarPosition?(\"static\"===t.css(\"position\")&&t.css(\"position\",\"relative\"),t.css(\"overflow\",\"visible\"),_.addClass(\"mCSB_outside\").after(c)):(_.addClass(\"mCSB_inside\").append(c),m.wrap(d)),h._scrollButtons.call(this);var p=[e(\"#mCSB_\"+o.idx+\"_dragger_vertical\"),e(\"#mCSB_\"+o.idx+\"_dragger_horizontal\")];p[0].css(\"min-height\",p[0].height()),p[1].css(\"min-width\",p[1].width())},_contentWidth:function(t){return Math.max.apply(Math,t.map(function(){return e(this).outerWidth(!0)}).get())},_expandContentHorizontally:function(){var t=e(this),o=t.data(n),a=o.opt,r=e(\"#mCSB_\"+o.idx+\"_container\");a.advanced.autoExpandHorizontalScroll&&\"y\"!==a.axis&&r.css({position:\"absolute\",width:\"auto\"}).wrap(\"<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />\").css({width:Math.ceil(r[0].getBoundingClientRect().right+.4)-Math.floor(r[0].getBoundingClientRect().left),position:\"relative\"}).unwrap()},_scrollButtons:function(){var t=e(this),o=t.data(n),a=o.opt,r=e(\".mCSB_\"+o.idx+\"_scrollbar:first\"),i=[\"<a href='#' class='mCSB_buttonUp' oncontextmenu='return false;' />\",\"<a href='#' class='mCSB_buttonDown' oncontextmenu='return false;' />\",\"<a href='#' class='mCSB_buttonLeft' oncontextmenu='return false;' />\",\"<a href='#' class='mCSB_buttonRight' oncontextmenu='return false;' />\"],l=[\"x\"===a.axis?i[2]:i[0],\"x\"===a.axis?i[3]:i[1],i[2],i[3]];a.scrollButtons.enable&&r.prepend(l[0]).append(l[1]).next(\".mCSB_scrollTools\").prepend(l[2]).append(l[3])},_maxHeight:function(){var t=e(this),o=t.data(n),a=(o.opt,e(\"#mCSB_\"+o.idx)),r=t.css(\"max-height\"),i=-1!==r.indexOf(\"%\"),l=t.css(\"box-sizing\");if(\"none\"!==r){var s=i?t.parent().height()*parseInt(r)/100:parseInt(r);\"border-box\"===l&&(s-=t.innerHeight()-t.height()+(t.outerHeight()-t.innerHeight())),a.css(\"max-height\",Math.round(s))}},_setDraggerLength:function(){var t=e(this),o=t.data(n),a=e(\"#mCSB_\"+o.idx),r=e(\"#mCSB_\"+o.idx+\"_container\"),i=[e(\"#mCSB_\"+o.idx+\"_dragger_vertical\"),e(\"#mCSB_\"+o.idx+\"_dragger_horizontal\")],l=[a.height()/r.outerHeight(!1),a.width()/r.outerWidth(!1)],s=[parseInt(i[0].css(\"min-height\")),Math.round(l[0]*i[0].parent().height()),parseInt(i[1].css(\"min-width\")),Math.round(l[1]*i[1].parent().width())],c=d&&s[1]<s[0]?s[0]:s[1],u=d&&s[3]<s[2]?s[2]:s[3];i[0].css({height:c,\"max-height\":i[0].parent().height()-10}).find(\".mCSB_dragger_bar\").css({\"line-height\":s[0]+\"px\"}),i[1].css({width:u,\"max-width\":i[1].parent().width()-10})},_scrollRatio:function(){var t=e(this),o=t.data(n),a=e(\"#mCSB_\"+o.idx),r=e(\"#mCSB_\"+o.idx+\"_container\"),i=[e(\"#mCSB_\"+o.idx+\"_dragger_vertical\"),e(\"#mCSB_\"+o.idx+\"_dragger_horizontal\")],l=[r.outerHeight(!1)-a.height(),r.outerWidth(!1)-a.width()],s=[l[0]/(i[0].parent().height()-i[0].height()),l[1]/(i[1].parent().width()-i[1].width())];o.scrollRatio={y:s[0],x:s[1]}},_onDragClasses:function(e,t,o){var a=o?\"mCSB_dragger_onDrag_expanded\":\"\",n=[\"mCSB_dragger_onDrag\",\"mCSB_scrollTools_onDrag\"],r=e.closest(\".mCSB_scrollTools\");\"active\"===t?(e.toggleClass(n[0]+\" \"+a),r.toggleClass(n[1]),e[0]._draggable=e[0]._draggable?0:1):e[0]._draggable||(\"hide\"===t?(e.removeClass(n[0]),r.removeClass(n[1])):(e.addClass(n[0]),r.addClass(n[1])))},_overflowed:function(){var t=e(this),o=t.data(n),a=e(\"#mCSB_\"+o.idx),r=e(\"#mCSB_\"+o.idx+\"_container\"),i=null==o.overflowed?r.height():r.outerHeight(!1),l=null==o.overflowed?r.width():r.outerWidth(!1);return[i>a.height(),l>a.width()]},_resetContentPosition:function(){var t=e(this),o=t.data(n),a=o.opt,r=e(\"#mCSB_\"+o.idx),i=e(\"#mCSB_\"+o.idx+\"_container\"),l=[e(\"#mCSB_\"+o.idx+\"_dragger_vertical\"),e(\"#mCSB_\"+o.idx+\"_dragger_horizontal\")];if(h._stop(t),(\"x\"!==a.axis&&!o.overflowed[0]||\"y\"===a.axis&&o.overflowed[0])&&(l[0].add(i).css(\"top\",0),h._scrollTo(t,\"_resetY\")),\"y\"!==a.axis&&!o.overflowed[1]||\"x\"===a.axis&&o.overflowed[1]){var s=dx=0;\"rtl\"===o.langDir&&(s=r.width()-i.outerWidth(!1),dx=Math.abs(s/o.scrollRatio.x)),i.css(\"left\",s),l[1].css(\"left\",dx),h._scrollTo(t,\"_resetX\")}},_bindEvents:function(){function t(){i=setTimeout(function(){e.event.special.mousewheel?(clearTimeout(i),h._mousewheel.call(o[0])):t()},1e3)}var o=e(this),a=o.data(n),r=a.opt;if(!a.bindEvents){if(h._draggable.call(this),r.contentTouchScroll&&h._contentDraggable.call(this),r.mouseWheel.enable){var i;t()}h._draggerRail.call(this),h._wrapperScroll.call(this),r.advanced.autoScrollOnFocus&&h._focus.call(this),r.scrollButtons.enable&&h._buttons.call(this),r.keyboard.enable&&h._keyboard.call(this),a.bindEvents=!0}},_unbindEvents:function(){var t=e(this),a=t.data(n),r=a.opt,i=n+\"_\"+a.idx,l=\".mCSB_\"+a.idx+\"_scrollbar\",s=e(\"#mCSB_\"+a.idx+\",#mCSB_\"+a.idx+\"_container,#mCSB_\"+a.idx+\"_container_wrapper,\"+l+\" .mCSB_draggerContainer,#mCSB_\"+a.idx+\"_dragger_vertical,#mCSB_\"+a.idx+\"_dragger_horizontal,\"+l+\">a\"),c=e(\"#mCSB_\"+a.idx+\"_container\");r.advanced.releaseDraggableSelectors&&s.add(e(r.advanced.releaseDraggableSelectors)),a.bindEvents&&(e(o).unbind(\".\"+i),s.each(function(){e(this).unbind(\".\"+i)}),clearTimeout(t[0]._focusTimeout),h._delete.call(null,t[0]._focusTimeout),clearTimeout(a.sequential.step),h._delete.call(null,a.sequential.step),clearTimeout(c[0].onCompleteTimeout),h._delete.call(null,c[0].onCompleteTimeout),a.bindEvents=!1)},_scrollbarVisibility:function(t){var o=e(this),a=o.data(n),r=a.opt,i=e(\"#mCSB_\"+a.idx+\"_container_wrapper\"),l=i.length?i:e(\"#mCSB_\"+a.idx+\"_container\"),s=[e(\"#mCSB_\"+a.idx+\"_scrollbar_vertical\"),e(\"#mCSB_\"+a.idx+\"_scrollbar_horizontal\")],c=[s[0].find(\".mCSB_dragger\"),s[1].find(\".mCSB_dragger\")];\"x\"!==r.axis&&(a.overflowed[0]&&!t?(s[0].add(c[0]).add(s[0].children(\"a\")).css(\"display\",\"block\"),l.removeClass(\"mCS_no_scrollbar_y mCS_y_hidden\")):(r.alwaysShowScrollbar?(2!==r.alwaysShowScrollbar&&c[0].add(s[0].children(\"a\")).css(\"display\",\"none\"),l.removeClass(\"mCS_y_hidden\")):(s[0].css(\"display\",\"none\"),l.addClass(\"mCS_y_hidden\")),l.addClass(\"mCS_no_scrollbar_y\"))),\"y\"!==r.axis&&(a.overflowed[1]&&!t?(s[1].add(c[1]).add(s[1].children(\"a\")).css(\"display\",\"block\"),l.removeClass(\"mCS_no_scrollbar_x mCS_x_hidden\")):(r.alwaysShowScrollbar?(2!==r.alwaysShowScrollbar&&c[1].add(s[1].children(\"a\")).css(\"display\",\"none\"),l.removeClass(\"mCS_x_hidden\")):(s[1].css(\"display\",\"none\"),l.addClass(\"mCS_x_hidden\")),l.addClass(\"mCS_no_scrollbar_x\"))),a.overflowed[0]||a.overflowed[1]?o.removeClass(\"mCS_no_scrollbar\"):o.addClass(\"mCS_no_scrollbar\")},_coordinates:function(e){var t=e.type;switch(t){case\"pointerdown\":case\"MSPointerDown\":case\"pointermove\":case\"MSPointerMove\":case\"pointerup\":case\"MSPointerUp\":return[e.originalEvent.pageY,e.originalEvent.pageX,!1];case\"touchstart\":case\"touchmove\":case\"touchend\":var o=e.originalEvent.touches[0]||e.originalEvent.changedTouches[0],a=e.originalEvent.touches.length||e.originalEvent.changedTouches.length;return[o.pageY,o.pageX,a>1];default:return[e.pageY,e.pageX,!1]}},_draggable:function(){function t(e){var t=p.find(\"iframe\");if(t.length){var o=e?\"auto\":\"none\";t.css(\"pointer-events\",o)}}function a(e,t,o,a){if(p[0].idleTimer=f.scrollInertia<233?250:0,r.attr(\"id\")===m[1])var n=\"x\",i=(r[0].offsetLeft-t+a)*c.scrollRatio.x;else var n=\"y\",i=(r[0].offsetTop-e+o)*c.scrollRatio.y;h._scrollTo(s,i.toString(),{dir:n,drag:!0})}var r,i,l,s=e(this),c=s.data(n),f=c.opt,_=n+\"_\"+c.idx,m=[\"mCSB_\"+c.idx+\"_dragger_vertical\",\"mCSB_\"+c.idx+\"_dragger_horizontal\"],p=e(\"#mCSB_\"+c.idx+\"_container\"),g=e(\"#\"+m[0]+\",#\"+m[1]),v=f.advanced.releaseDraggableSelectors?g.add(e(f.advanced.releaseDraggableSelectors)):g;g.bind(\"mousedown.\"+_+\" touchstart.\"+_+\" pointerdown.\"+_+\" MSPointerDown.\"+_,function(a){if(a.stopImmediatePropagation(),a.preventDefault(),h._mouseBtnLeft(a)){u=!0,d&&(o.onselectstart=function(){return!1}),t(!1),h._stop(s),r=e(this);var n=r.offset(),c=h._coordinates(a)[0]-n.top,_=h._coordinates(a)[1]-n.left,m=r.height()+n.top,p=r.width()+n.left;m>c&&c>0&&p>_&&_>0&&(i=c,l=_),h._onDragClasses(r,\"active\",f.autoExpandScrollbar)}}).bind(\"touchmove.\"+_,function(e){e.stopImmediatePropagation(),e.preventDefault();var t=r.offset(),o=h._coordinates(e)[0]-t.top,n=h._coordinates(e)[1]-t.left;a(i,l,o,n)}),e(o).bind(\"mousemove.\"+_+\" pointermove.\"+_+\" MSPointerMove.\"+_,function(e){if(r){var t=r.offset(),o=h._coordinates(e)[0]-t.top,n=h._coordinates(e)[1]-t.left;if(i===o)return;a(i,l,o,n)}}).add(v).bind(\"mouseup.\"+_+\" touchend.\"+_+\" pointerup.\"+_+\" MSPointerUp.\"+_,function(){r&&(h._onDragClasses(r,\"active\",f.autoExpandScrollbar),r=null),u=!1,d&&(o.onselectstart=null),t(!0)})},_contentDraggable:function(){function t(e,t){var o=[1.5*t,2*t,t/1.5,t/2];return e>90?t>4?o[0]:o[3]:e>60?t>3?o[3]:o[2]:e>30?t>8?o[1]:t>6?o[0]:t>4?t:o[2]:t>8?t:o[3]}function o(e,t,o,a,n,r){e&&h._scrollTo(g,e.toString(),{dur:t,scrollEasing:o,dir:a,overwrite:n,drag:r})}var a,r,i,l,s,c,d,f,_,m,p,g=e(this),v=g.data(n),x=v.opt,S=n+\"_\"+v.idx,C=e(\"#mCSB_\"+v.idx),b=e(\"#mCSB_\"+v.idx+\"_container\"),w=[e(\"#mCSB_\"+v.idx+\"_dragger_vertical\"),e(\"#mCSB_\"+v.idx+\"_dragger_horizontal\")],y=[],B=[],T=0,M=\"yx\"===x.axis?\"none\":\"all\",k=[];b.bind(\"touchstart.\"+S+\" pointerdown.\"+S+\" MSPointerDown.\"+S,function(e){if(h._pointerTouch(e)&&!u&&!h._coordinates(e)[2]){var t=b.offset();a=h._coordinates(e)[0]-t.top,r=h._coordinates(e)[1]-t.left,k=[h._coordinates(e)[0],h._coordinates(e)[1]]}}).bind(\"touchmove.\"+S+\" pointermove.\"+S+\" MSPointerMove.\"+S,function(e){if(h._pointerTouch(e)&&!u&&!h._coordinates(e)[2]){e.stopImmediatePropagation(),c=h._getTime();var t=C.offset(),n=h._coordinates(e)[0]-t.top,i=h._coordinates(e)[1]-t.left,l=\"mcsLinearOut\";if(y.push(n),B.push(i),k[2]=Math.abs(h._coordinates(e)[0]-k[0]),k[3]=Math.abs(h._coordinates(e)[1]-k[1]),v.overflowed[0])var s=w[0].parent().height()-w[0].height(),d=a-n>0&&n-a>-(s*v.scrollRatio.y)&&(2*k[3]<k[2]||\"yx\"===x.axis);if(v.overflowed[1])var f=w[1].parent().width()-w[1].width(),_=r-i>0&&i-r>-(f*v.scrollRatio.x)&&(2*k[2]<k[3]||\"yx\"===x.axis);(d||_)&&e.preventDefault(),m=\"yx\"===x.axis?[a-n,r-i]:\"x\"===x.axis?[null,r-i]:[a-n,null],b[0].idleTimer=250,v.overflowed[0]&&o(m[0],T,l,\"y\",\"all\",!0),v.overflowed[1]&&o(m[1],T,l,\"x\",M,!0)}}),C.bind(\"touchstart.\"+S+\" pointerdown.\"+S+\" MSPointerDown.\"+S,function(e){if(h._pointerTouch(e)&&!u&&!h._coordinates(e)[2]){e.stopImmediatePropagation(),h._stop(g),s=h._getTime();var t=C.offset();i=h._coordinates(e)[0]-t.top,l=h._coordinates(e)[1]-t.left,y=[],B=[]}}).bind(\"touchend.\"+S+\" pointerup.\"+S+\" MSPointerUp.\"+S,function(e){if(h._pointerTouch(e)&&!u&&!h._coordinates(e)[2]){e.stopImmediatePropagation(),d=h._getTime();var a=C.offset(),n=h._coordinates(e)[0]-a.top,r=h._coordinates(e)[1]-a.left;if(!(d-c>30)){_=1e3/(d-s);var g=\"mcsEaseOut\",S=2.5>_,w=S?[y[y.length-2],B[B.length-2]]:[0,0];f=S?[n-w[0],r-w[1]]:[n-i,r-l];var T=[Math.abs(f[0]),Math.abs(f[1])];_=S?[Math.abs(f[0]/4),Math.abs(f[1]/4)]:[_,_];var k=[Math.abs(b[0].offsetTop)-f[0]*t(T[0]/_[0],_[0]),Math.abs(b[0].offsetLeft)-f[1]*t(T[1]/_[1],_[1])];m=\"yx\"===x.axis?[k[0],k[1]]:\"x\"===x.axis?[null,k[1]]:[k[0],null],p=[4*T[0]+x.scrollInertia,4*T[1]+x.scrollInertia];var O=parseInt(x.contentTouchScroll)||0;m[0]=T[0]>O?m[0]:0,m[1]=T[1]>O?m[1]:0,v.overflowed[0]&&o(m[0],p[0],g,\"y\",M,!1),v.overflowed[1]&&o(m[1],p[1],g,\"x\",M,!1)}}})},_mousewheel:function(){function t(e){var t=null;try{var o=e.contentDocument||e.contentWindow.document;t=o.body.innerHTML}catch(a){}return null!==t}var o=e(this),a=o.data(n);if(a){var r=a.opt,i=n+\"_\"+a.idx,l=e(\"#mCSB_\"+a.idx),s=[e(\"#mCSB_\"+a.idx+\"_dragger_vertical\"),e(\"#mCSB_\"+a.idx+\"_dragger_horizontal\")],c=e(\"#mCSB_\"+a.idx+\"_container\").find(\"iframe\"),u=l;c.length&&c.each(function(){var o=this;t(o)&&(u=u.add(e(o).contents().find(\"body\")))}),u.bind(\"mousewheel.\"+i,function(t,n){if(h._stop(o),!h._disableMousewheel(o,t.target)){var i=\"auto\"!==r.mouseWheel.deltaFactor?parseInt(r.mouseWheel.deltaFactor):d&&t.deltaFactor<100?100:t.deltaFactor||100;if(\"x\"===r.axis||\"x\"===r.mouseWheel.axis)var c=\"x\",u=[Math.round(i*a.scrollRatio.x),parseInt(r.mouseWheel.scrollAmount)],f=\"auto\"!==r.mouseWheel.scrollAmount?u[1]:u[0]>=l.width()?.9*l.width():u[0],_=Math.abs(e(\"#mCSB_\"+a.idx+\"_container\")[0].offsetLeft),m=s[1][0].offsetLeft,p=s[1].parent().width()-s[1].width(),g=t.deltaX||t.deltaY||n;else var c=\"y\",u=[Math.round(i*a.scrollRatio.y),parseInt(r.mouseWheel.scrollAmount)],f=\"auto\"!==r.mouseWheel.scrollAmount?u[1]:u[0]>=l.height()?.9*l.height():u[0],_=Math.abs(e(\"#mCSB_\"+a.idx+\"_container\")[0].offsetTop),m=s[0][0].offsetTop,p=s[0].parent().height()-s[0].height(),g=t.deltaY||n;\"y\"===c&&!a.overflowed[0]||\"x\"===c&&!a.overflowed[1]||(r.mouseWheel.invert&&(g=-g),r.mouseWheel.normalizeDelta&&(g=0>g?-1:1),(g>0&&0!==m||0>g&&m!==p||r.mouseWheel.preventDefault)&&(t.stopImmediatePropagation(),t.preventDefault()),h._scrollTo(o,(_-g*f).toString(),{dir:c}))}})}},_disableMousewheel:function(t,o){var a=o.nodeName.toLowerCase(),r=t.data(n).opt.mouseWheel.disableOver,i=[\"select\",\"textarea\"];return e.inArray(a,r)>-1&&!(e.inArray(a,i)>-1&&!e(o).is(\":focus\"))},_draggerRail:function(){var t=e(this),o=t.data(n),a=n+\"_\"+o.idx,r=e(\"#mCSB_\"+o.idx+\"_container\"),i=r.parent(),l=e(\".mCSB_\"+o.idx+\"_scrollbar .mCSB_draggerContainer\");l.bind(\"touchstart.\"+a+\" pointerdown.\"+a+\" MSPointerDown.\"+a,function(){u=!0}).bind(\"touchend.\"+a+\" pointerup.\"+a+\" MSPointerUp.\"+a,function(){u=!1}).bind(\"click.\"+a,function(a){if(e(a.target).hasClass(\"mCSB_draggerContainer\")||e(a.target).hasClass(\"mCSB_draggerRail\")){h._stop(t);var n=e(this),l=n.find(\".mCSB_dragger\");if(n.parent(\".mCSB_scrollTools_horizontal\").length>0){if(!o.overflowed[1])return;var s=\"x\",c=a.pageX>l.offset().left?-1:1,d=Math.abs(r[0].offsetLeft)-.9*c*i.width()}else{if(!o.overflowed[0])return;var s=\"y\",c=a.pageY>l.offset().top?-1:1,d=Math.abs(r[0].offsetTop)-.9*c*i.height()}h._scrollTo(t,d.toString(),{dir:s,scrollEasing:\"mcsEaseInOut\"})}})},_focus:function(){var t=e(this),a=t.data(n),r=a.opt,i=n+\"_\"+a.idx,l=e(\"#mCSB_\"+a.idx+\"_container\"),s=l.parent();l.bind(\"focusin.\"+i,function(){var a=e(o.activeElement),n=l.find(\".mCustomScrollBox\").length,i=0;a.is(r.advanced.autoScrollOnFocus)&&(h._stop(t),clearTimeout(t[0]._focusTimeout),t[0]._focusTimer=n?(i+17)*n:0,t[0]._focusTimeout=setTimeout(function(){var e=[a.offset().top-l.offset().top,a.offset().left-l.offset().left],o=[l[0].offsetTop,l[0].offsetLeft],n=[o[0]+e[0]>=0&&o[0]+e[0]<s.height()-a.outerHeight(!1),o[1]+e[1]>=0&&o[0]+e[1]<s.width()-a.outerWidth(!1)],c=\"yx\"!==r.axis||n[0]||n[1]?\"all\":\"none\";\"x\"===r.axis||n[0]||h._scrollTo(t,e[0].toString(),{dir:\"y\",scrollEasing:\"mcsEaseInOut\",overwrite:c,dur:i}),\"y\"===r.axis||n[1]||h._scrollTo(t,e[1].toString(),{dir:\"x\",scrollEasing:\"mcsEaseInOut\",overwrite:c,dur:i})},t[0]._focusTimer))})},_wrapperScroll:function(){var t=e(this),o=t.data(n),a=n+\"_\"+o.idx,r=e(\"#mCSB_\"+o.idx+\"_container\").parent();r.bind(\"scroll.\"+a,function(){(0!==r.scrollTop()||0!==r.scrollLeft())&&e(\".mCSB_\"+o.idx+\"_scrollbar\").css(\"visibility\",\"hidden\")})},_buttons:function(){var t=e(this),o=t.data(n),a=o.opt,r=o.sequential,i=n+\"_\"+o.idx,l=(e(\"#mCSB_\"+o.idx+\"_container\"),\".mCSB_\"+o.idx+\"_scrollbar\"),s=e(l+\">a\");s.bind(\"mousedown.\"+i+\" touchstart.\"+i+\" pointerdown.\"+i+\" MSPointerDown.\"+i+\" mouseup.\"+i+\" touchend.\"+i+\" pointerup.\"+i+\" MSPointerUp.\"+i+\" mouseout.\"+i+\" pointerout.\"+i+\" MSPointerOut.\"+i+\" click.\"+i,function(n){function i(e,o){r.scrollAmount=a.snapAmount||a.scrollButtons.scrollAmount,h._sequentialScroll.call(this,t,e,o)}if(n.preventDefault(),h._mouseBtnLeft(n)){var l=e(this).attr(\"class\");switch(r.type=a.scrollButtons.scrollType,n.type){case\"mousedown\":case\"touchstart\":case\"pointerdown\":case\"MSPointerDown\":if(\"stepped\"===r.type)return;u=!0,o.tweenRunning=!1,i(\"on\",l);break;case\"mouseup\":case\"touchend\":case\"pointerup\":case\"MSPointerUp\":case\"mouseout\":case\"pointerout\":case\"MSPointerOut\":if(\"stepped\"===r.type)return;u=!1,r.dir&&i(\"off\",l);break;case\"click\":if(\"stepped\"!==r.type||o.tweenRunning)return;i(\"on\",l)}}})},_keyboard:function(){var t=e(this),a=t.data(n),r=a.opt,i=a.sequential,l=n+\"_\"+a.idx,s=e(\"#mCSB_\"+a.idx),c=e(\"#mCSB_\"+a.idx+\"_container\"),d=c.parent(),u=\"input,textarea,select,datalist,keygen,[contenteditable='true']\";s.attr(\"tabindex\",\"0\").bind(\"blur.\"+l+\" keydown.\"+l+\" keyup.\"+l,function(n){function l(e,o){i.type=r.keyboard.scrollType,i.scrollAmount=r.snapAmount||r.keyboard.scrollAmount,\"stepped\"===i.type&&a.tweenRunning||h._sequentialScroll.call(this,t,e,o)}switch(n.type){case\"blur\":a.tweenRunning&&i.dir&&l(\"off\",null);break;case\"keydown\":case\"keyup\":var s=n.keyCode?n.keyCode:n.which,f=\"on\";if(\"x\"!==r.axis&&(38===s||40===s)||\"y\"!==r.axis&&(37===s||39===s)){if((38===s||40===s)&&!a.overflowed[0]||(37===s||39===s)&&!a.overflowed[1])return;\"keyup\"===n.type&&(f=\"off\"),e(o.activeElement).is(u)||(n.preventDefault(),n.stopImmediatePropagation(),l(f,s))}else if(33===s||34===s){if((a.overflowed[0]||a.overflowed[1])&&(n.preventDefault(),n.stopImmediatePropagation()),\"keyup\"===n.type){h._stop(t);var _=34===s?-1:1;if(\"x\"===r.axis||\"yx\"===r.axis&&a.overflowed[1]&&!a.overflowed[0])var m=\"x\",p=Math.abs(c[0].offsetLeft)-.9*_*d.width();else var m=\"y\",p=Math.abs(c[0].offsetTop)-.9*_*d.height();h._scrollTo(t,p.toString(),{dir:m,scrollEasing:\"mcsEaseInOut\"})}}else if((35===s||36===s)&&!e(o.activeElement).is(u)&&((a.overflowed[0]||a.overflowed[1])&&(n.preventDefault(),n.stopImmediatePropagation()),\"keyup\"===n.type)){if(\"x\"===r.axis||\"yx\"===r.axis&&a.overflowed[1]&&!a.overflowed[0])var m=\"x\",p=35===s?Math.abs(d.width()-c.outerWidth(!1)):0;else var m=\"y\",p=35===s?Math.abs(d.height()-c.outerHeight(!1)):0;h._scrollTo(t,p.toString(),{dir:m,scrollEasing:\"mcsEaseInOut\"})}}})},_sequentialScroll:function(t,o,a){function r(e){var o=\"stepped\"!==c.type,a=e?o?s.scrollInertia/1.5:s.scrollInertia:1e3/60,n=e?o?7.5:40:2.5,i=[Math.abs(d[0].offsetTop),Math.abs(d[0].offsetLeft)],u=[l.scrollRatio.y>10?10:l.scrollRatio.y,l.scrollRatio.x>10?10:l.scrollRatio.x],f=\"x\"===c.dir[0]?i[1]+c.dir[1]*u[1]*n:i[0]+c.dir[1]*u[0]*n,_=\"x\"===c.dir[0]?i[1]+c.dir[1]*parseInt(c.scrollAmount):i[0]+c.dir[1]*parseInt(c.scrollAmount),m=\"auto\"!==c.scrollAmount?_:f,p=e?o?\"mcsLinearOut\":\"mcsEaseInOut\":\"mcsLinear\",g=e?!0:!1;return e&&17>a&&(m=\"x\"===c.dir[0]?i[1]:i[0]),h._scrollTo(t,m.toString(),{dir:c.dir[0],scrollEasing:p,dur:a,onComplete:g}),e?void(c.dir=!1):(clearTimeout(c.step),void(c.step=setTimeout(function(){r()},a)))}function i(){clearTimeout(c.step),h._stop(t)}var l=t.data(n),s=l.opt,c=l.sequential,d=e(\"#mCSB_\"+l.idx+\"_container\"),u=\"stepped\"===c.type?!0:!1;switch(o){case\"on\":if(c.dir=[\"mCSB_buttonRight\"===a||\"mCSB_buttonLeft\"===a||39===a||37===a?\"x\":\"y\",\"mCSB_buttonUp\"===a||\"mCSB_buttonLeft\"===a||38===a||37===a?-1:1],h._stop(t),h._isNumeric(a)&&\"stepped\"===c.type)return;r(u);break;case\"off\":i(),(u||l.tweenRunning&&c.dir)&&r(!0)}},_arr:function(t){var o=e(this).data(n).opt,a=[];return\"function\"==typeof t&&(t=t()),t instanceof Array?a=t.length>1?[t[0],t[1]]:\"x\"===o.axis?[null,t[0]]:[t[0],null]:(a[0]=t.y?t.y:t.x||\"x\"===o.axis?null:t,a[1]=t.x?t.x:t.y||\"y\"===o.axis?null:t),\"function\"==typeof a[0]&&(a[0]=a[0]()),\"function\"==typeof a[1]&&(a[1]=a[1]()),a},_to:function(t,o){if(null!=t&&\"undefined\"!=typeof t){var a=e(this),r=a.data(n),i=r.opt,l=e(\"#mCSB_\"+r.idx+\"_container\"),s=l.parent(),c=typeof t;o||(o=\"x\"===i.axis?\"x\":\"y\");var d=\"x\"===o?l.outerWidth(!1):l.outerHeight(!1),u=\"x\"===o?l.offset().left:l.offset().top,_=\"x\"===o?l[0].offsetLeft:l[0].offsetTop,m=\"x\"===o?\"left\":\"top\";switch(c){case\"function\":return t();case\"object\":if(t.nodeType)var p=\"x\"===o?e(t).offset().left:e(t).offset().top;else if(t.jquery){if(!t.length)return;var p=\"x\"===o?t.offset().left:t.offset().top}return p-u;case\"string\":case\"number\":if(h._isNumeric.call(null,t))return Math.abs(t);if(-1!==t.indexOf(\"%\"))return Math.abs(d*parseInt(t)/100);if(-1!==t.indexOf(\"-=\"))return Math.abs(_-parseInt(t.split(\"-=\")[1]));if(-1!==t.indexOf(\"+=\")){var g=_+parseInt(t.split(\"+=\")[1]);return g>=0?0:Math.abs(g)}if(-1!==t.indexOf(\"px\")&&h._isNumeric.call(null,t.split(\"px\")[0]))return Math.abs(t.split(\"px\")[0]);if(\"top\"===t||\"left\"===t)return 0;if(\"bottom\"===t)return Math.abs(s.height()-l.outerHeight(!1));if(\"right\"===t)return Math.abs(s.width()-l.outerWidth(!1));if(\"first\"===t||\"last\"===t){var v=l.find(\":\"+t),p=\"x\"===o?e(v).offset().left:e(v).offset().top;return p-u}if(e(t).length){var p=\"x\"===o?e(t).offset().left:e(t).offset().top;return p-u}return l.css(m,t),void f.update.call(null,a[0])}}},_autoUpdate:function(t){function o(){clearTimeout(u[0].autoUpdate),u[0].autoUpdate=setTimeout(function(){return d.advanced.updateOnSelectorChange&&(_=i(),_!==S)?(l(),void(S=_)):(d.advanced.updateOnContentResize&&(m=[u.outerHeight(!1),u.outerWidth(!1),g.height(),g.width(),x()[0],x()[1]],(m[0]!==C[0]||m[1]!==C[1]||m[2]!==C[2]||m[3]!==C[3]||m[4]!==C[4]||m[5]!==C[5])&&(l(),C=m)),d.advanced.updateOnImageLoad&&(p=a(),p!==b&&(u.find(\"img\").each(function(){r(this.src)}),b=p)),void((d.advanced.updateOnSelectorChange||d.advanced.updateOnContentResize||d.advanced.updateOnImageLoad)&&o()))},60)}function a(){var e=0;return d.advanced.updateOnImageLoad&&(e=u.find(\"img\").length),e}function r(e){function t(e,t){return function(){return t.apply(e,arguments)}}function o(){this.onload=null,l()}var a=new Image;a.onload=t(a,o),a.src=e}function i(){d.advanced.updateOnSelectorChange===!0&&(d.advanced.updateOnSelectorChange=\"*\");var t=0,o=u.find(d.advanced.updateOnSelectorChange);return d.advanced.updateOnSelectorChange&&o.length>0&&o.each(function(){t+=e(this).height()+e(this).width()}),t}function l(){clearTimeout(u[0].autoUpdate),f.update.call(null,s[0])}var s=e(this),c=s.data(n),d=c.opt,u=e(\"#mCSB_\"+c.idx+\"_container\");if(t)return clearTimeout(u[0].autoUpdate),void h._delete.call(null,u[0].autoUpdate);var _,m,p,g=u.parent(),v=[e(\"#mCSB_\"+c.idx+\"_scrollbar_vertical\"),e(\"#mCSB_\"+c.idx+\"_scrollbar_horizontal\")],x=function(){return[v[0].is(\":visible\")?v[0].outerHeight(!0):0,v[1].is(\":visible\")?v[1].outerWidth(!0):0]},S=i(),C=[u.outerHeight(!1),u.outerWidth(!1),g.height(),g.width(),x()[0],x()[1]],b=a();o()},_snapAmount:function(e,t,o){return Math.round(e/t)*t-o},_stop:function(t){var o=t.data(n),a=e(\"#mCSB_\"+o.idx+\"_container,#mCSB_\"+o.idx+\"_container_wrapper,#mCSB_\"+o.idx+\"_dragger_vertical,#mCSB_\"+o.idx+\"_dragger_horizontal\");a.each(function(){h._stopTween.call(this)})},_scrollTo:function(t,o,a){function r(e){return s&&c.callbacks[e]&&\"function\"==typeof c.callbacks[e]}function i(){return[c.callbacks.alwaysTriggerOffsets||S>=C[0]+w,c.callbacks.alwaysTriggerOffsets||-y>=S]}function l(){var e=[_[0].offsetTop,_[0].offsetLeft],o=[v[0].offsetTop,v[0].offsetLeft],n=[_.outerHeight(!1),_.outerWidth(!1)],r=[f.height(),f.width()];t[0].mcs={content:_,top:e[0],left:e[1],draggerTop:o[0],draggerLeft:o[1],topPct:Math.round(100*Math.abs(e[0])/(Math.abs(n[0])-r[0])),leftPct:Math.round(100*Math.abs(e[1])/(Math.abs(n[1])-r[1])),direction:a.dir}}var s=t.data(n),c=s.opt,d={trigger:\"internal\",dir:\"y\",scrollEasing:\"mcsEaseOut\",drag:!1,dur:c.scrollInertia,overwrite:\"all\",callbacks:!0,onStart:!0,onUpdate:!0,onComplete:!0},a=e.extend(d,a),u=[a.dur,a.drag?0:a.dur],f=e(\"#mCSB_\"+s.idx),_=e(\"#mCSB_\"+s.idx+\"_container\"),m=_.parent(),p=c.callbacks.onTotalScrollOffset?h._arr.call(t,c.callbacks.onTotalScrollOffset):[0,0],g=c.callbacks.onTotalScrollBackOffset?h._arr.call(t,c.callbacks.onTotalScrollBackOffset):[0,0];\nif(s.trigger=a.trigger,(0!==m.scrollTop()||0!==m.scrollLeft())&&(e(\".mCSB_\"+s.idx+\"_scrollbar\").css(\"visibility\",\"visible\"),m.scrollTop(0).scrollLeft(0)),\"_resetY\"!==o||s.contentReset.y||(r(\"onOverflowYNone\")&&c.callbacks.onOverflowYNone.call(t[0]),s.contentReset.y=1),\"_resetX\"!==o||s.contentReset.x||(r(\"onOverflowXNone\")&&c.callbacks.onOverflowXNone.call(t[0]),s.contentReset.x=1),\"_resetY\"!==o&&\"_resetX\"!==o){switch(!s.contentReset.y&&t[0].mcs||!s.overflowed[0]||(r(\"onOverflowY\")&&c.callbacks.onOverflowY.call(t[0]),s.contentReset.x=null),!s.contentReset.x&&t[0].mcs||!s.overflowed[1]||(r(\"onOverflowX\")&&c.callbacks.onOverflowX.call(t[0]),s.contentReset.x=null),c.snapAmount&&(o=h._snapAmount(o,c.snapAmount,c.snapOffset)),a.dir){case\"x\":var v=e(\"#mCSB_\"+s.idx+\"_dragger_horizontal\"),x=\"left\",S=_[0].offsetLeft,C=[f.width()-_.outerWidth(!1),v.parent().width()-v.width()],b=[o,0===o?0:o/s.scrollRatio.x],w=p[1],y=g[1],B=w>0?w/s.scrollRatio.x:0,T=y>0?y/s.scrollRatio.x:0;break;case\"y\":var v=e(\"#mCSB_\"+s.idx+\"_dragger_vertical\"),x=\"top\",S=_[0].offsetTop,C=[f.height()-_.outerHeight(!1),v.parent().height()-v.height()],b=[o,0===o?0:o/s.scrollRatio.y],w=p[0],y=g[0],B=w>0?w/s.scrollRatio.y:0,T=y>0?y/s.scrollRatio.y:0}b[1]<0||0===b[0]&&0===b[1]?b=[0,0]:b[1]>=C[1]?b=[C[0],C[1]]:b[0]=-b[0],t[0].mcs||(l(),r(\"onInit\")&&c.callbacks.onInit.call(t[0])),clearTimeout(_[0].onCompleteTimeout),(s.tweenRunning||!(0===S&&b[0]>=0||S===C[0]&&b[0]<=C[0]))&&(h._tweenTo.call(null,v[0],x,Math.round(b[1]),u[1],a.scrollEasing),h._tweenTo.call(null,_[0],x,Math.round(b[0]),u[0],a.scrollEasing,a.overwrite,{onStart:function(){a.callbacks&&a.onStart&&!s.tweenRunning&&(r(\"onScrollStart\")&&(l(),c.callbacks.onScrollStart.call(t[0])),s.tweenRunning=!0,h._onDragClasses(v),s.cbOffsets=i())},onUpdate:function(){a.callbacks&&a.onUpdate&&r(\"whileScrolling\")&&(l(),c.callbacks.whileScrolling.call(t[0]))},onComplete:function(){if(a.callbacks&&a.onComplete){\"yx\"===c.axis&&clearTimeout(_[0].onCompleteTimeout);var e=_[0].idleTimer||0;_[0].onCompleteTimeout=setTimeout(function(){r(\"onScroll\")&&(l(),c.callbacks.onScroll.call(t[0])),r(\"onTotalScroll\")&&b[1]>=C[1]-B&&s.cbOffsets[0]&&(l(),c.callbacks.onTotalScroll.call(t[0])),r(\"onTotalScrollBack\")&&b[1]<=T&&s.cbOffsets[1]&&(l(),c.callbacks.onTotalScrollBack.call(t[0])),s.tweenRunning=!1,_[0].idleTimer=0,h._onDragClasses(v,\"hide\")},e)}}}))}},_tweenTo:function(e,o,a,n,r,i,l){function s(){w.stop||(S||p.call(),S=h._getTime()-x,c(),S>=w.time&&(w.time=S>w.time?S+_-(S-w.time):S+_-1,w.time<S+1&&(w.time=S+1)),w.time<n?w.id=m(s):v.call())}function c(){n>0?(w.currVal=f(w.time,C,y,n,r),b[o]=Math.round(w.currVal)+\"px\"):b[o]=a+\"px\",g.call()}function d(){_=1e3/60,w.time=S+_,m=t.requestAnimationFrame?t.requestAnimationFrame:function(e){return c(),setTimeout(e,.01)},w.id=m(s)}function u(){null!=w.id&&(t.requestAnimationFrame?t.cancelAnimationFrame(w.id):clearTimeout(w.id),w.id=null)}function f(e,t,o,a,n){switch(n){case\"linear\":case\"mcsLinear\":return o*e/a+t;case\"mcsLinearOut\":return e/=a,e--,o*Math.sqrt(1-e*e)+t;case\"easeInOutSmooth\":return e/=a/2,1>e?o/2*e*e+t:(e--,-o/2*(e*(e-2)-1)+t);case\"easeInOutStrong\":return e/=a/2,1>e?o/2*Math.pow(2,10*(e-1))+t:(e--,o/2*(-Math.pow(2,-10*e)+2)+t);case\"easeInOut\":case\"mcsEaseInOut\":return e/=a/2,1>e?o/2*e*e*e+t:(e-=2,o/2*(e*e*e+2)+t);case\"easeOutSmooth\":return e/=a,e--,-o*(e*e*e*e-1)+t;case\"easeOutStrong\":return o*(-Math.pow(2,-10*e/a)+1)+t;case\"easeOut\":case\"mcsEaseOut\":default:var r=(e/=a)*e,i=r*e;return t+o*(.499999999999997*i*r+-2.5*r*r+5.5*i+-6.5*r+4*e)}}e._malihuTween||(e._malihuTween={top:{},left:{}});var _,m,l=l||{},p=l.onStart||function(){},g=l.onUpdate||function(){},v=l.onComplete||function(){},x=h._getTime(),S=0,C=e.offsetTop,b=e.style,w=e._malihuTween[o];\"left\"===o&&(C=e.offsetLeft);var y=a-C;w.stop=0,\"none\"!==i&&u(),d()},_getTime:function(){return t.performance&&t.performance.now?t.performance.now():t.performance&&t.performance.webkitNow?t.performance.webkitNow():Date.now?Date.now():(new Date).getTime()},_stopTween:function(){var e=this;e._malihuTween||(e._malihuTween={top:{},left:{}}),e._malihuTween.top.id&&(t.requestAnimationFrame?t.cancelAnimationFrame(e._malihuTween.top.id):clearTimeout(e._malihuTween.top.id),e._malihuTween.top.id=null,e._malihuTween.top.stop=1),e._malihuTween.left.id&&(t.requestAnimationFrame?t.cancelAnimationFrame(e._malihuTween.left.id):clearTimeout(e._malihuTween.left.id),e._malihuTween.left.id=null,e._malihuTween.left.stop=1)},_delete:function(e){try{delete e}catch(t){e=null}},_mouseBtnLeft:function(e){return!(e.which&&1!==e.which)},_pointerTouch:function(e){var t=e.originalEvent.pointerType;return!(t&&\"touch\"!==t&&2!==t)},_isNumeric:function(e){return!isNaN(parseFloat(e))&&isFinite(e)}};e.fn[a]=function(t){return f[t]?f[t].apply(this,Array.prototype.slice.call(arguments,1)):\"object\"!=typeof t&&t?void e.error(\"Method \"+t+\" does not exist\"):f.init.apply(this,arguments)},e[a]=function(t){return f[t]?f[t].apply(this,Array.prototype.slice.call(arguments,1)):\"object\"!=typeof t&&t?void e.error(\"Method \"+t+\" does not exist\"):f.init.apply(this,arguments)},e[a].defaults=i,t[a]=!0,e(t).load(function(){e(r)[a]()})})}(jQuery,window,document);"

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(47);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!./jquery.mCustomScrollbar.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!./jquery.mCustomScrollbar.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".mCustomScrollbar{-ms-touch-action:none;touch-action:none}.mCustomScrollbar.mCS_no_scrollbar{-ms-touch-action:auto;touch-action:auto}.mCustomScrollBox{position:relative;overflow:hidden;height:100%;max-width:100%;outline:none;direction:ltr}.mCSB_container{overflow:hidden;width:auto;height:auto}.mCSB_inside>.mCSB_container{margin-right:30px}.mCSB_container.mCS_no_scrollbar_y.mCS_y_hidden{margin-right:0}.mCS-dir-rtl>.mCSB_inside>.mCSB_container{margin-right:0;margin-left:30px}.mCS-dir-rtl>.mCSB_inside>.mCSB_container.mCS_no_scrollbar_y.mCS_y_hidden{margin-left:0}.mCSB_scrollTools{position:absolute;width:16px;height:auto;left:auto;top:0;right:0;bottom:0}.mCSB_outside+.mCSB_scrollTools{right:-26px}.mCS-dir-rtl>.mCSB_inside>.mCSB_scrollTools,.mCS-dir-rtl>.mCSB_outside+.mCSB_scrollTools{right:auto;left:0}.mCS-dir-rtl>.mCSB_outside+.mCSB_scrollTools{left:-26px}.mCSB_scrollTools .mCSB_draggerContainer{position:absolute;top:0;left:0;bottom:0;right:0;height:auto}.mCSB_scrollTools a+.mCSB_draggerContainer{margin:20px 0}.mCSB_scrollTools .mCSB_draggerRail{width:2px;height:100%;margin:0 auto;border-radius:16px}.mCSB_scrollTools .mCSB_dragger{cursor:pointer;width:100%;height:30px;z-index:1}.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{position:relative;width:4px;height:100%;margin:0 auto;border-radius:16px;text-align:center}.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{width:12px}.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{width:8px}.mCSB_scrollTools .mCSB_buttonDown,.mCSB_scrollTools .mCSB_buttonUp{display:block;position:absolute;height:20px;width:100%;overflow:hidden;margin:0 auto;cursor:pointer}.mCSB_scrollTools .mCSB_buttonDown{bottom:0}.mCSB_horizontal.mCSB_inside>.mCSB_container{margin-right:0;margin-bottom:30px}.mCSB_horizontal.mCSB_outside>.mCSB_container{min-height:100%}.mCSB_horizontal>.mCSB_container.mCS_no_scrollbar_x.mCS_x_hidden{margin-bottom:0}.mCSB_scrollTools.mCSB_scrollTools_horizontal{width:auto;height:16px;top:auto;right:0;bottom:0;left:0}.mCustomScrollBox+.mCSB_scrollTools+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox+.mCSB_scrollTools.mCSB_scrollTools_horizontal{bottom:-26px}.mCSB_scrollTools.mCSB_scrollTools_horizontal a+.mCSB_draggerContainer{margin:0 20px}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:2px;margin:7px 0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_dragger{width:30px;height:100%;left:0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:4px;margin:6px auto}.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{height:12px;margin:2px auto}.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{height:8px;margin:4px 0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonLeft,.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonRight{display:block;position:absolute;width:20px;height:100%;overflow:hidden;margin:0 auto;cursor:pointer}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonLeft{left:0}.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonRight{right:0}.mCSB_container_wrapper{position:absolute;height:auto;width:auto;overflow:hidden;top:0;left:0;right:0;bottom:0;margin-right:30px;margin-bottom:30px}.mCSB_container_wrapper>.mCSB_container{padding-right:30px;padding-bottom:30px}.mCSB_vertical_horizontal>.mCSB_scrollTools.mCSB_scrollTools_vertical{bottom:20px}.mCSB_vertical_horizontal>.mCSB_scrollTools.mCSB_scrollTools_horizontal{right:20px}.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden+.mCSB_scrollTools.mCSB_scrollTools_vertical{bottom:0}.mCS-dir-rtl>.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden+.mCSB_scrollTools~.mCSB_scrollTools.mCSB_scrollTools_horizontal{right:0}.mCS-dir-rtl>.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_scrollTools.mCSB_scrollTools_horizontal{left:20px}.mCS-dir-rtl>.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden+.mCSB_scrollTools~.mCSB_scrollTools.mCSB_scrollTools_horizontal{left:0}.mCS-dir-rtl>.mCSB_inside>.mCSB_container_wrapper{margin-right:0;margin-left:30px}.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden>.mCSB_container{padding-right:0;box-sizing:border-box}.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden>.mCSB_container{padding-bottom:0;box-sizing:border-box}.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden{margin-right:0;margin-left:0}.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside>.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden{margin-bottom:0}.mCSB_scrollTools,.mCSB_scrollTools .mCSB_buttonDown,.mCSB_scrollTools .mCSB_buttonLeft,.mCSB_scrollTools .mCSB_buttonRight,.mCSB_scrollTools .mCSB_buttonUp,.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{transition:opacity .2s ease-in-out,background-color .2s ease-in-out}.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger_bar,.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerRail,.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger_bar,.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerRail{transition:width .2s ease-out .2s,height .2s ease-out .2s,margin-left .2s ease-out .2s,margin-right .2s ease-out .2s,margin-top .2s ease-out .2s,margin-bottom .2s ease-out .2s,opacity .2s ease-in-out,background-color .2s ease-in-out}.mCSB_scrollTools{opacity:.75;filter:\"alpha(opacity=75)\";-ms-filter:\"alpha(opacity=75)\"}.mCS-autoHide>.mCustomScrollBox>.mCSB_scrollTools,.mCS-autoHide>.mCustomScrollBox~.mCSB_scrollTools{opacity:0;filter:\"alpha(opacity=0)\";-ms-filter:\"alpha(opacity=0)\"}.mCS-autoHide:hover>.mCustomScrollBox>.mCSB_scrollTools,.mCS-autoHide:hover>.mCustomScrollBox~.mCSB_scrollTools,.mCustomScrollbar>.mCustomScrollBox>.mCSB_scrollTools.mCSB_scrollTools_onDrag,.mCustomScrollbar>.mCustomScrollBox~.mCSB_scrollTools.mCSB_scrollTools_onDrag,.mCustomScrollBox:hover>.mCSB_scrollTools,.mCustomScrollBox:hover~.mCSB_scrollTools{opacity:1;filter:\"alpha(opacity=100)\";-ms-filter:\"alpha(opacity=100)\"}.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.4);filter:\"alpha(opacity=40)\";-ms-filter:\"alpha(opacity=40)\"}.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.75);filter:\"alpha(opacity=75)\";-ms-filter:\"alpha(opacity=75)\"}.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.85);filter:\"alpha(opacity=85)\";-ms-filter:\"alpha(opacity=85)\"}.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.9);filter:\"alpha(opacity=90)\";-ms-filter:\"alpha(opacity=90)\"}.mCSB_scrollTools .mCSB_buttonDown,.mCSB_scrollTools .mCSB_buttonLeft,.mCSB_scrollTools .mCSB_buttonRight,.mCSB_scrollTools .mCSB_buttonUp{background-repeat:no-repeat;opacity:.4;filter:\"alpha(opacity=40)\";-ms-filter:\"alpha(opacity=40)\"}.mCSB_scrollTools .mCSB_buttonUp{background-position:0 0}.mCSB_scrollTools .mCSB_buttonDown{background-position:0 -20px}.mCSB_scrollTools .mCSB_buttonLeft{background-position:0 -40px}.mCSB_scrollTools .mCSB_buttonRight{background-position:0 -56px}.mCSB_scrollTools .mCSB_buttonDown:hover,.mCSB_scrollTools .mCSB_buttonLeft:hover,.mCSB_scrollTools .mCSB_buttonRight:hover,.mCSB_scrollTools .mCSB_buttonUp:hover{opacity:.75;filter:\"alpha(opacity=75)\";-ms-filter:\"alpha(opacity=75)\"}.mCSB_scrollTools .mCSB_buttonDown:active,.mCSB_scrollTools .mCSB_buttonLeft:active,.mCSB_scrollTools .mCSB_buttonRight:active,.mCSB_scrollTools .mCSB_buttonUp:active{opacity:.9;filter:\"alpha(opacity=90)\";-ms-filter:\"alpha(opacity=90)\"}.mCS-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.15)}.mCS-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:rgba(0,0,0,.85)}.mCS-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:rgba(0,0,0,.9)}.mCS-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-80px 0}.mCS-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-80px -20px}.mCS-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-80px -40px}.mCS-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-80px -56px}.mCS-dark-2.mCSB_scrollTools .mCSB_draggerRail,.mCS-light-2.mCSB_scrollTools .mCSB_draggerRail{width:4px;background-color:#fff;background-color:hsla(0,0%,100%,.1);border-radius:1px}.mCS-dark-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-light-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:4px;background-color:#fff;background-color:hsla(0,0%,100%,.75);border-radius:1px}.mCS-dark-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-dark-2.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-light-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-light-2.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:4px;margin:6px auto}.mCS-light-2.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.85)}.mCS-light-2.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-light-2.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.9)}.mCS-light-2.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px 0}.mCS-light-2.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -20px}.mCS-light-2.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -40px}.mCS-light-2.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -56px}.mCS-dark-2.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.1);border-radius:1px}.mCS-dark-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75);border-radius:1px}.mCS-dark-2.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-dark-2.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-dark-2.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px 0}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -20px}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -40px}.mCS-dark-2.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -56px}.mCS-dark-thick.mCSB_scrollTools .mCSB_draggerRail,.mCS-light-thick.mCSB_scrollTools .mCSB_draggerRail{width:4px;background-color:#fff;background-color:hsla(0,0%,100%,.1);border-radius:2px}.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-light-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:6px;background-color:#fff;background-color:hsla(0,0%,100%,.75);border-radius:2px}.mCS-dark-thick.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-light-thick.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:4px;margin:6px 0}.mCS-dark-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-light-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:6px;margin:5px auto}.mCS-light-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.85)}.mCS-light-thick.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-light-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.9)}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonUp{background-position:-16px 0}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonDown{background-position:-16px -20px}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonLeft{background-position:-20px -40px}.mCS-light-thick.mCSB_scrollTools .mCSB_buttonRight{background-position:-20px -56px}.mCS-dark-thick.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.1);border-radius:2px}.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75);border-radius:2px}.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonUp{background-position:-96px 0}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonDown{background-position:-96px -20px}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonLeft{background-position:-100px -40px}.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonRight{background-position:-100px -56px}.mCS-light-thin.mCSB_scrollTools .mCSB_draggerRail{background-color:#fff;background-color:hsla(0,0%,100%,.1)}.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-light-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:2px}.mCS-dark-thin.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-light-thin.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%}.mCS-dark-thin.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-light-thin.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:2px;margin:7px auto}.mCS-dark-thin.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.15)}.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonUp{background-position:-80px 0}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonDown{background-position:-80px -20px}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonLeft{background-position:-80px -40px}.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonRight{background-position:-80px -56px}.mCS-rounded.mCSB_scrollTools .mCSB_draggerRail{background-color:#fff;background-color:hsla(0,0%,100%,.15)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger,.mCS-rounded-dots.mCSB_scrollTools .mCSB_dragger,.mCS-rounded.mCSB_scrollTools .mCSB_dragger{height:14px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:14px;margin:0 1px}.mCS-rounded-dark.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-rounded.mCSB_scrollTools_horizontal .mCSB_dragger{width:14px}.mCS-rounded-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{height:14px;margin:1px 0}.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{width:16px;height:16px;margin:-1px 0}.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{width:4px}.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded .mCSB_dragger_bar,.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_dragger .mCSB_dragger_bar{height:16px;width:16px;margin:0 -1px}.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{height:4px;margin:6px 0}.mCS-rounded.mCSB_scrollTools .mCSB_buttonUp{background-position:0 -72px}.mCS-rounded.mCSB_scrollTools .mCSB_buttonDown{background-position:0 -92px}.mCS-rounded.mCSB_scrollTools .mCSB_buttonLeft{background-position:0 -112px}.mCS-rounded.mCSB_scrollTools .mCSB_buttonRight{background-position:0 -128px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.15)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-80px -72px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-80px -92px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-80px -112px}.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-80px -128px}.mCS-rounded-dots-dark.mCSB_scrollTools_vertical .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools_vertical .mCSB_draggerRail{width:4px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_draggerRail{background-color:transparent;background-position:50%}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools .mCSB_draggerRail{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAANElEQVQYV2NkIAAYiVbw//9/Y6DiM1ANJoyMjGdBbLgJQAX/kU0DKgDLkaQAvxW4HEvQFwCRcxIJK1XznAAAAABJRU5ErkJggg==\");background-repeat:repeat-y;opacity:.3;filter:\"alpha(opacity=30)\";-ms-filter:\"alpha(opacity=30)\"}.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_draggerRail{height:4px;margin:6px 0;background-repeat:repeat-x}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonUp{background-position:-16px -72px}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonDown{background-position:-16px -92px}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonLeft{background-position:-20px -112px}.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonRight{background-position:-20px -128px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAALElEQVQYV2NkIAAYSVFgDFR8BqrBBEifBbGRTfiPZhpYjiQFBK3A6l6CvgAAE9kGCd1mvgEAAAAASUVORK5CYII=\")}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-96px -72px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-96px -92px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-100px -112px}.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-100px -128px}.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-repeat:repeat-y;background-image:linear-gradient(90deg,hsla(0,0%,100%,.5) 0,hsla(0,0%,100%,0))}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{background-repeat:repeat-x;background-image:linear-gradient(180deg,hsla(0,0%,100%,.5) 0,hsla(0,0%,100%,0))}.mCS-3d-dark.mCSB_scrollTools_vertical .mCSB_dragger,.mCS-3d.mCSB_scrollTools_vertical .mCSB_dragger{height:70px}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger{width:70px}.mCS-3d-dark.mCSB_scrollTools,.mCS-3d.mCSB_scrollTools{opacity:1;filter:\"alpha(opacity=30)\";-ms-filter:\"alpha(opacity=30)\"}.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_draggerRail{border-radius:16px}.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-3d.mCSB_scrollTools .mCSB_draggerRail{width:8px;background-color:#000;background-color:rgba(0,0,0,.2);box-shadow:inset 1px 0 1px rgba(0,0,0,.5),inset -1px 0 1px hsla(0,0%,100%,.2)}.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#555}.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:8px}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-3d.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:8px;margin:4px 0;box-shadow:inset 0 1px 1px rgba(0,0,0,.5),inset 0 -1px 1px hsla(0,0%,100%,.2)}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{width:100%;height:8px;margin:4px auto}.mCS-3d.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-3d.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-3d.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-3d.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.1);box-shadow:inset 1px 0 1px rgba(0,0,0,.1)}.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail{box-shadow:inset 0 1px 1px rgba(0,0,0,.1)}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCS-3d-thick-dark.mCSB_scrollTools,.mCS-3d-thick.mCSB_scrollTools{opacity:1;filter:\"alpha(opacity=30)\";-ms-filter:\"alpha(opacity=30)\"}.mCS-3d-thick-dark.mCSB_scrollTools,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerContainer,.mCS-3d-thick.mCSB_scrollTools,.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerContainer{border-radius:7px}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{border-radius:5px}.mCSB_inside+.mCS-3d-thick-dark.mCSB_scrollTools_vertical,.mCSB_inside+.mCS-3d-thick.mCSB_scrollTools_vertical{right:1px}.mCS-3d-thick-dark.mCSB_scrollTools_vertical,.mCS-3d-thick.mCSB_scrollTools_vertical{box-shadow:inset 1px 0 1px rgba(0,0,0,.1),inset 0 0 14px rgba(0,0,0,.5)}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal,.mCS-3d-thick.mCSB_scrollTools_horizontal{bottom:1px;box-shadow:inset 0 1px 1px rgba(0,0,0,.1),inset 0 0 14px rgba(0,0,0,.5)}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 1px 0 0 hsla(0,0%,100%,.4);width:12px;margin:2px;position:absolute;height:auto;top:0;bottom:0;left:0;right:0}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.4)}.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#555}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{height:12px;width:auto}.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerContainer{background-color:#000;background-color:rgba(0,0,0,.05);box-shadow:inset 1px 1px 16px rgba(0,0,0,.1)}.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-3d-thick-dark.mCSB_scrollTools{box-shadow:inset 0 0 14px rgba(0,0,0,.2)}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal{box-shadow:inset 0 1px 1px rgba(0,0,0,.1),inset 0 0 14px rgba(0,0,0,.2)}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 1px 0 0 hsla(0,0%,100%,.4),inset -1px 0 0 rgba(0,0,0,.2)}.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.4),inset 0 -1px 0 rgba(0,0,0,.2)}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#777}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerContainer{background-color:#fff;background-color:rgba(0,0,0,.05);box-shadow:inset 1px 1px 16px rgba(0,0,0,.1)}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCSB_outside+.mCS-minimal-dark.mCSB_scrollTools_vertical,.mCSB_outside+.mCS-minimal.mCSB_scrollTools_vertical{right:0;margin:12px 0}.mCustomScrollBox.mCS-minimal+.mCSB_scrollTools+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox.mCS-minimal+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox.mCS-minimal-dark+.mCSB_scrollTools+.mCSB_scrollTools.mCSB_scrollTools_horizontal,.mCustomScrollBox.mCS-minimal-dark+.mCSB_scrollTools.mCSB_scrollTools_horizontal{bottom:0;margin:0 12px}.mCS-dir-rtl>.mCSB_outside+.mCS-minimal-dark.mCSB_scrollTools_vertical,.mCS-dir-rtl>.mCSB_outside+.mCS-minimal.mCSB_scrollTools_vertical{left:0;right:auto}.mCS-minimal-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-minimal.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent}.mCS-minimal-dark.mCSB_scrollTools_vertical .mCSB_dragger,.mCS-minimal.mCSB_scrollTools_vertical .mCSB_dragger{height:50px}.mCS-minimal-dark.mCSB_scrollTools_horizontal .mCSB_dragger,.mCS-minimal.mCSB_scrollTools_horizontal .mCSB_dragger{width:50px}.mCS-minimal.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.2);filter:\"alpha(opacity=20)\";-ms-filter:\"alpha(opacity=20)\"}.mCS-minimal.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-minimal.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.5);filter:\"alpha(opacity=50)\";-ms-filter:\"alpha(opacity=50)\"}.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.2);filter:\"alpha(opacity=20)\";-ms-filter:\"alpha(opacity=20)\"}.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.5);filter:\"alpha(opacity=50)\";-ms-filter:\"alpha(opacity=50)\"}.mCS-dark-3.mCSB_scrollTools .mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools .mCSB_draggerRail{width:6px;background-color:#000;background-color:rgba(0,0,0,.2)}.mCS-dark-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-light-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:6px}.mCS-dark-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-dark-3.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-light-3.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:6px;margin:5px 0}.mCS-dark-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-dark-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{width:12px}.mCS-dark-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-dark-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger.mCSB_dragger_onDrag_expanded+.mCSB_draggerRail,.mCS-light-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerContainer:hover .mCSB_draggerRail{height:12px;margin:2px 0}.mCS-light-3.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-light-3.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-light-3.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-light-3.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-dark-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-dark-3.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-dark-3.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-dark-3.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-dark-3.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.1)}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-dark-3.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-2.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-3.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset.mCSB_scrollTools .mCSB_draggerRail{width:12px;background-color:#000;background-color:rgba(0,0,0,.2)}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{width:6px;margin:3px 5px;position:absolute;height:auto;top:0;bottom:0;left:0;right:0}.mCS-inset-2-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,.mCS-inset.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar{height:6px;margin:5px 3px;position:absolute;width:auto;top:0;bottom:0;left:0;right:0}.mCS-inset-2-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-2.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-3-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-3.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,.mCS-inset.mCSB_scrollTools_horizontal .mCSB_draggerRail{width:100%;height:12px;margin:2px 0}.mCS-inset-2.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset.mCSB_scrollTools .mCSB_buttonUp{background-position:-32px -72px}.mCS-inset-2.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset.mCSB_scrollTools .mCSB_buttonDown{background-position:-32px -92px}.mCS-inset-2.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset.mCSB_scrollTools .mCSB_buttonLeft{background-position:-40px -112px}.mCS-inset-2.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset-3.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset.mCSB_scrollTools .mCSB_buttonRight{background-position:-40px -128px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.1)}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonUp,.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonUp{background-position:-112px -72px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonDown,.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonDown{background-position:-112px -92px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonLeft,.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonLeft{background-position:-120px -112px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonRight,.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonRight{background-position:-120px -128px}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail,.mCS-inset-2.mCSB_scrollTools .mCSB_draggerRail{background-color:transparent;border-color:#fff;border:1px solid hsla(0,0%,100%,.2);box-sizing:border-box}.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail{border-color:#000;border-color:rgba(0,0,0,.2)}.mCS-inset-3.mCSB_scrollTools .mCSB_draggerRail{background-color:#fff;background-color:hsla(0,0%,100%,.6)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail{background-color:#000;background-color:rgba(0,0,0,.6)}.mCS-inset-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.75)}.mCS-inset-3.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.85)}.mCS-inset-3.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-3.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#000;background-color:rgba(0,0,0,.9)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.75)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.85)}.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar{background-color:#fff;background-color:hsla(0,0%,100%,.9)}", ""]);

// exports


/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Widget Control Select */

(function(fox, undefined) {
    'use strict';

    fox.registerWidget('Control_Select', {
        configure: function(options) {
            this.registerOptions('', {
                autoRender: true,
                template: 'control_select',
                currentValuePlace: '.select-link',
                select: {
                    container: '.mc-select',

                    //object of attributes for <select> element
                    //{id, name, 'class', etc...}
                    attributes: null,

                    //array of objects like
                    //[{title:'title', value:'value', [selected: true, hidden: true]},{title:'title2', value:'value2']

                    options: null
                },

                //generate years options limited by array
                //[startYear, endYear]
                yearsLimit: false,

                //generate months select
                months: false,

                //genearate dates select
                days: false,

                'handleDom.change': {
                    target: '[name]',
                    event: 'change',
                    callback: '_change'
                },

                'hooks.onAddedToDom': 'change'
            });

            this.callParent('configure', arguments);
        },

        running: function () {
            this._prepareOptions();
            this.callParent('running', arguments);
        },

        createSelect: function () {
            var select = document.createElement('select');
            var container = this.getOption('select.container');
            //hack for translations
            if (this.getOption('months')) {
                this._prepareOptions();
            }
            
            fox.each(this.selectAttributes, function (value, attr) {
                select[attr] = value;
            }, this);

            fox.each(this.selectOptions, function (opts, i) {
                var option = document.createElement('option');

                option.innerText = fox.isFunction(opts.title) ? opts.title.call(null) : opts.title;
                option.value = opts.value;

                if (opts.selected && this.value === undefined) {
                    option.selected = true;
                    this.value = option.value;
                }

                if (this.value !== undefined && this.value === option.value) {
                    option.selected = true;
                }

                if (opts.hidden) {
                    option.style.display = 'none';
                }

                if(opts.disabled){
                    option.disabled = true;
                }

                if (opts.alterText) {
                    option.setAttribute('data-alter-text', opts.alterText);
                }

                select.appendChild(option);
            }, this);

            if (!select.name) {
                select.name = this.alias;
            }

            if (container) {
                this.dom1(container).appendChild(select);

                return;
            }

            this.fragment.appendChild(select);
        },

        rendering: function () {
            var addClass = this.getOption('addClass');
            
            if (addClass) {
                this.setTemplateOptions({addClass: addClass});
            }
            
            this.callParent('rendering', arguments);

            if (!this.selectOptions || !fox.count(this.selectOptions)) {
                //console.warn('No options defined');
                return;
            }

            this.hookWrapper('createSelect');
        },

        _change: function (el) {
            this.selectedOption = el.options[el.selectedIndex];

            this._setValue(this.selectedOption.value);
        },

        _setValue: function (value, skipEvent) {
            skipEvent = fox.isEmpty(skipEvent) ? false : skipEvent;

            if (value === this.value) {
                return;
            }

            this.value = value;
            this.hookWrapper('change');

            if (!skipEvent) {
                this.dispatchEvent('change', value);

                if (this.api) {
                    this.hookWrapper('send', {value: value});
                }
            }

            this.dispatchEvent('setValue', value);
        },

        _markOption: function (value) {
            fox.each(this.getSelectOptions(), function (option) {
                option.selected = false;

                if (option.value === value) {
                    option.selected = true;
                }
            }, this);
        },

        _prepareOptions: function (value) {
            var options = this.getOption('select.options');
            var yearsLimit = this.getOption('yearsLimit');
            var months = this.getOption('months');
            var days = this.getOption('days');

            this.selectAttributes = this.getOption('select.attributes');

            if (yearsLimit) {
                options = this._generateYears(yearsLimit);
            }

            if (months) {
                options = this._generateMonths();
            }

            if (days) {
                options = this._generateDays();
            }

            this.selectOptions = options;
        },

        change: function () {
            if (!this._indom) {
                return;
            }

            if ((this._indom === true) && !this.element.length) {
                console.warn('no element for select with name="' + this.alias + '"');

                return;
            }

            var place = this.dom1(this.getOption('currentValuePlace'));
            var selected = this.getSelectedOption();
            if (!selected) return;
            var txt = selected.innerText || selected.innerHTML;
            var alterText = selected.getAttribute('data-alter-text');

            if (alterText) {
                txt = alterText;
            }

            place.innerText = txt;

            fox.dom.removeClass('default', place.parentNode);

            if (selected.value < 0 || selected.value === '0') {
                fox.dom.addClass('default', place.parentNode);
            }
        },

        getSelectElement: function () {
            return this.dom1('[name="' + (this.getOption('select.attributes.name') || this.alias) + '"]');
        },

        getSelectOptions: function () {
            return fox.dom.select('option', this.getSelectElement());
        },

        getSelectedOption: function () {
            var el = false;

            fox.each(this.getSelectOptions(), function (option) {
                if (option.selected) {
                    el = option;
                }
            }, this);

            return el;
        },

        getValue: function () {
            return this.value;
        },

        setValue: function (value, skipEvent) {
            value = value.toString && value.toString() || value;
            this._markOption(value);
            this._setValue(value, skipEvent);
        },

        insertOptions: function (options, skipEvent) {
            var select = this.getSelectElement();

            if (!select) {
                console.warn('no select element');
                return;
            }

            fox.each(options, function (opts, i) {
                var option = document.createElement('option');

                option.innerText = fox.isFunction(opts.title) ? opts.title.call(null) : opts.title;
                option.value = opts.value;

                if (opts.selected) {
                    option.selected = true;
                    this.value = option.value;
                }

                if (opts.disabled) {
                    option.disabled = true;
                }

                select.appendChild(option);
            }, this);

            this._setValue(this.value, skipEvent);

        },

        rebuildSelect: function(options) {
            if (fox.isEmpty(options)) {
                return;
            }

            this.selectOptions = options;
            this.render();
        },

        _generateYears: function (arr) {
            var years = [];

            years.push({title: 'Year', value: '', selected: true, hidden: true});

            for (var i = arr[1]; i >= arr[0]; i--) {
                years.unshift({title: i, value: i});
            }

            return years;
        },

        _generateMonths: function () {
            var months = [];
            var monthNames = fox.utils.getMonthsArray();

            months.push({title: 'Month', value: '', selected: true, hidden: true});

            for (var i = 12; i > 0; i--) {
                months.unshift({title: monthNames[i - 1], value: (i < 10 ? '0' + i : i)});
            }

            return months;
        },

        _generateDays: function () {
            var days = [];

            days.push({title: 'Day', value: '', selected: true, hidden: true});

            for (var i = 31; i > 0; i--) {
                days.unshift({title: i, value: (i < 10 ? '0' + i : i)});
            }

            return days;
        },

        _toggleDisabling: function (state) {
            var select;

            if (this.isEmbedded()) {
                select = this.getSelectElement();
                select.disabled = state;

                return this.dispatchEvent(state && 'disabled' || 'enabled');
            }

            return this.wait('addedToDom').then(function () {
                return this._toggleDisabling(state);
            }.bind(this));
        },

        disable: function () {
            return this._toggleDisabling(true);
        },

        enable: function  () {
            return this._toggleDisabling(false);
        },

        reset: function () {
            this.value = undefined;
            this.render();
        }

    }, 'Widget');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, undefined) {
	'use strict';

	fox.registerWidget('Control_Select_Dynamic', {

		configure: function(options) {
			this.registerOptions('', {
				manualRender: true,
				customOptions: null,
				widgets: {
					dl: {
						widget: 'Datalayer',
						method: 'Site.getAvailiableSexualOrientations'
					}
				},
				handleWom: {
					dlLoaded: {
						widget: '#dl',
						event: ['loaded', 'success'],
						callback: '_handleDlLoad'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.dl = this.rwom1('#dl');
			this.getDataFromServer();

			this.callParent('running', arguments);
		},

		activate: function () {
			this.callParent('activate', arguments);

			if (this.getOption('loadOnActivate')) {
				this.getDataFromServer();
			} else {
				this.render();
			}
		},

		deactivate: function () {
			this.callParent('deactivate', arguments);

			this.value = null;
		},

		_handleDlLoad: function (response, dl, e) {
			var options = this.apiIsDl() ?  dl.getCollection() : response.answer.response;

			if (fox.isObject(options)) {
				options = fox.toArray(options);
			}

			this.selectOptions = options;
			this.hookWrapper('prepareSelectOptions');
			this.setOption('select.options', this.selectOptions);

			this.render();
		},

		setValue: function (value, skipEvent) {
			if (this._indom) {
				this.callParent('setValue', arguments);

				return;
			}

			this.waitEvent(this, 'addedToDom', function () {
				this.setValue(value, skipEvent);
			}.bind(this));
		},

		getDataFromServer: function () {
			if (this.apiIsDl()) {
				this.dl.load();

				return;
			}
			
			this.dl.send({});
		},

		prepareSelectOptions: function () {
			var opts = this.getOption('customOptions') || [];
			fox.each(this.selectOptions, function (data) {
				var title = data.name || data.alias
				opts.push({
					title: this.getTranslation ? this.getTranslation(title) : title,
					value: data.id
				});
			}, this);

			this.selectOptions = opts;
		},

		apiIsDl: function () {
			return fox.oop.instanceOf(this.dl, 'Datalayer');
		}

	}, 'Control_Select');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Controller[newSelect] .Control_Select":{"template":[{"value":"control_select_new","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101002},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"select.container":[{"value":".mc-form-field.dropdown","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"currentValuePlace":[{"value":".current-value","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"templateOptions.openAt":[{"value":"bottom","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"hooks.onStopCreateSelect":[{"value":function () {
var list = document.createElement('ul');
list.setAttribute('class', 'dropdown-list');
fox.each(this.dom('select option'), function (o) {
var item = document.createElement('li');
item.setAttribute('data-value', o.value);
item.setAttribute('class', 'option-item');
if (o.style.display === 'none') item.style.display = 'none';
item.innerHTML = o.innerHTML;
if (o.getAttribute('data-alter-text')) {
item.setAttribute('data-alter-text', o.getAttribute('data-alter-text'));
}
if (this.value !== undefined && o.value == this.value) {
item.setAttribute('class', 'option-item selected');
}
list.appendChild(item);
}.bind(this));
this.dom1(this.getOption('select.container')).appendChild(list);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101024},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleWom.addedToDom.event":[{"value":"addedToDom","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101027},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleWom.addedToDom.widget":[{"value":"@this","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101028},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleWom.addedToDom.callback":[{"value":function () {
__webpack_require__.e/* require.ensure */(4).then((function(require) {
__webpack_require__(24);
fox.jQuery(this.dom1('.dropdown-list')).mCustomScrollbar({
theme: 'minimal-dark'
});
}.bind(this)).bind(null, __webpack_require__)).catch(__webpack_require__.oe)
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101038},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleWom.updateDropItems.event":[{"value":"setValue","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101040},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleWom.updateDropItems.widget":[{"value":"@this","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleWom.updateDropItems.callback":[{"value":function (value) {
$(this.dom('.option-item.selected')).removeClass('selected');
$(this.dom('.option-item[data-value="' + value + '"]')).addClass('selected');
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101045},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleDom.selectItem.event":[{"value":"click","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101048},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleDom.selectItem.target":[{"value":".option-item","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101049},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleDom.selectItem.eventChecker":[{"value":function (e) {
var result = !e.currentTarget.classList.contains('disabled');
if (!result) {
e.preventDefault();
e.stopPropagation();
}
return result;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101058},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleDom.selectItem.callback":[{"value":function (el) {
var value = el.getAttribute('data-value');
this.setValue(value);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101062},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleDom.toggleSelect.event":[{"value":"click","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101064},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleDom.toggleSelect.target":[{"value":".dropdown","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101065},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleDom.toggleSelect.callback":[{"value":function (el, alias, w, e) {
var OPENED = 'opened';
var $ = fox.jQuery;
jQuery.Event(e).stopPropagation();
var _handler = function (e) {
var container = $(el);
if (!container.is(e.target) &&
container.has(e.target).length === 0 &&
container.hasClass(OPENED)) {
container.removeClass(OPENED);
$(document.body).off('click', _handler);
}
}
if ($(el).hasClass('disabled'))
return false;
if (!$(el).hasClass(OPENED)) {
$(document.body).on('click', _handler);
$(el).addClass(OPENED);
} else {
$(document.body).off('click', _handler);
$(el).removeClass(OPENED);
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101090},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// ContentPager Widget

(function (fox, $) {
	'use strict';

	fox.registerWidget('ContentPager', {

		configure: function () {
			this.registerOptions('', {
				'embed.container': '#content-pager',
				'tpl.container': 'content_pager',
				autoRender: true,
				pagesCount: 5,
				scrollToTop: true,
				rppShow: false,
				newSelect: true,
				'handleDom.setPage.target': '.pagination .ch-page',
				'handleDom.jumpToPage': {
					event: 'keyup',
					target: '#jump-to-page',
					callback: '_handleEnterKey'
				},
				'handleDom.jumpToPageClick': {
					event: 'click',
					target: '.goto-page',
					callback: '_handleIconClick'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this._active = true;
			this.visual = !!this.getOption('tpl.container');

			this.callParent('init', arguments);

			var rpp = Number(this.dl.getRpp());
			var range = fox.utils.getRange(10, 50, 10);

			if (range.indexOf(rpp) === -1) {
				range.unshift(false);
			}

			if (this.getOption('rppShow')) {
				this.embedWidget('rpp', 'Control_Select', {
					'embed.container': '#pager-rpp-switcher',
					'select.options': range.map(function (v) {
						var option = {
							title: (v || rpp) + ' records per page',
							value: v || rpp
						};

						if (!v || rpp === v) option.selected = true;

						return option;
					}, this),
					'handleWom.setRpp': {
						event: 'change',
						widget: '@this',
						callback: '@parent:_handleRppChange'
					}
				});
			}
		},

		jumpToPage: function (page) {
			if (!page || page > this._pagerData.total || !fox.isNumeric(page)) {
				return;
			}

			this.changePage(page);
		},

		_handleEnterKey: function () {
			if (event.keyCode === 13) {
				this.changePage(this.getTargetPage());
			}
		},

		addedToDom: function () {
			var jDoc;

			jDoc = $(document);

			this.inputElem = this.dom1('input#jump-to-page');

			if (!this.getOption('scrollToTop')) return false;

			if (jDoc.scrollTop() > jDoc.height() * 0.2) {
				$('body, html').animate({
					scrollTop: 0
				}, 500);
			}
		},

		_handleRppChange: function(rpp) {
			this.dl.setRpp(rpp).load();
		},

		_handleIconClick: function () {
			this.jumpToPage(this.getTargetPage());
		},

		getTargetPage: function () {
			return this.inputElem.value;
		}

	}, 'Grid_Pager');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';
	
	var _Promise = fox.RSVP.Promise;

	fox.registerWidget('PromisePreloader', {
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				template: 'big_preloader'
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this._readyToEmbed = false;

			this.callParent('running', arguments);
		},

		show: function (promise) {
			if (!(promise instanceof _Promise)) return _Promise.resolve(false);

			function retPromise (promise) {
				this.render();

				return promise;
			}

			this._readyToEmbed = true;

			var resPromise = this.wait('addedToDom').then(function () {
				this._readyToEmbed = false;

				return promise;
			}.bind(this)).then(function (resp) {
				if (this.isEmbedded()) this.removeFromDom();
				
				this.visualParent.render();

				return resp;
			}.bind(this));

			if (!this.isActive()) return this.wait('activate').then(retPromise.bind(this, resPromise));

			return retPromise.call(this, resPromise);
		}
	});
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// SidebarSlider Widget

(function (fox, $) {
	"use strict";
	fox.registerWidget('SidebarSlider', {

		configure: function (argument) {
			this.isDefaultState = true;

			this.registerOptions('', {
				targetSelector: '.part-navigator',
				targetWidget: '@parent'
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.offset = this.requireOption('scrollOffset');
			this.bottomOffset = this.getOption('bottomScrollOffset') || 45;
			this.targetWidget = this.wom1(this.requireOption('targetWidget'));

			if (!this.targetWidget) {
				return;
			}

			this.handleEvent(this.targetWidget, 'addedToDom', this.getElement);

			this.callParent('init', arguments);
		},

		running: function () {
			$(window).on('scroll', {widget: this}, this._handleSlide);
		},

		/*activate: function () {
			$(window).on('scroll', {widget: this}, this._handleSlide);

			this.callParent('activate', arguments);
		},

		deactivate: function () {
			$(window).off('scroll', this._handleSlide);
			this.isDefaultState = true;

			this.callParent('deactivate', arguments);
		},*/

		_handleSlide: function (e) {
			var widget = e.data.widget;
			var top = widget.getPageOffset();
			var pageHeight = $('body > div').eq(0).height();
			var winHeight = $(window).height();

			widget.dispatchEvent('scrolling', {top: top});

			if (widget.isDefaultState) {
				if (top >= widget.offset) {
					widget.isDefaultState = false;
					widget.dispatchEvent('slideStart');
					widget.hookWrapper('slideStart');

					return;
				}

				return;
			}

			if (top < widget.offset) {
				widget.isDefaultState = true;
				widget.dispatchEvent('slideEnd');
				widget.hookWrapper('slideEnd');
			}

			if (!widget.bottomOffset) {
				return;
			}

			if (widget.isBottomReached) {
				if ((pageHeight - top - $(window).height()) > widget.bottomOffset) {
					//console.warn('bottomOffsetPassed');

					widget.isBottomReached = false;
					widget.dispatchEvent('bottomOffsetPassed');
					widget.hookWrapper('bottomOffsetPassed');
				}

				return;
			}

			if ((pageHeight - top - $(window).height()) <= widget.bottomOffset) {
				widget.isBottomReached = true;
				widget.dispatchEvent('bottomOffsetReached');
				widget.hookWrapper('bottomOffsetReached');
			}
		},

		getElement: function (obj, w, alias) {
			this.slidableElement = w.dom(this.requireOption('targetSelector'));

			fox.each(this.slidableElement, function (elm) {
				fox.dom.addClass('fox-sidebar', elm);
			});

			this._handleSlide({data: {widget: this}});
		},

		getElementHeight: function() {
			return $(this.requireOption('targetSelector')).outerHeight(true);
		},

		getPageOffset: function () {
			return window.scrollY || window.pageYOffset; // window.pageYOffset for IE
		},

		slideStart: function () {
			fox.each(this.slidableElement, function (elm) {
				elm = $(elm);
				var mainContainer = $('#mc-page-container');
				if ($(window).height() > elm.height() && elm.height() < mainContainer.height()){
					elm.addClass('slide');
					elm.css('width', elm.parent().width());
				}
			});
		},

		slideEnd: function () {
			fox.each(this.slidableElement, function (elm) {
				elm = $(elm);
				if (elm.hasClass('slide')){
					elm.removeClass('slide');
					elm.css('width', '');
				}
			});
		},

		bottomOffsetReached: function (argument) {
			fox.each(this.slidableElement, function (elm) {
				elm = $(elm);

				if (elm.height() >  $(window).height()) {
					elm.addClass('stick-to-bottom');
				}

				elm.addClass('bottom-reached');
			});
		},

		bottomOffsetPassed: function (argument) {
			fox.each(this.slidableElement, function (elm) {
				elm = $(elm);

				if (elm.height() >  $(window).height()) {
					elm.removeClass('stick-to-bottom');
				}

				elm.removeClass('bottom-reached');
			});
		},

		setOffset: function (offset) {
			this.offset = offset;
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// AnchorNavigator Widget

(function (fox, $) {
	"use strict";
	fox.registerWidget('AnchorNavigator', {

		init: function () {
			this.addDomHandler({
				event: 'click',
				target: this.requireOption('clickTarget'),
				targetWidget: this.requireOption('targetWidget'),
				callback: 'navigate'
			}, 'navigate');
		
			this.callParent('init', arguments);
		},

		navigate: function (el, evAlias, performer) {
			var id, $el, $target;

			$el = $(el);
			id = $el.data('target');
			$target = $(performer.dom1(['#', id].join('')));

			$el.parent()
				.find('.active')
				.removeClass('active');

			$el.addClass('active');

			if ($target) {
				$('body, html').animate({
					scrollTop: $(document).width() > 1194 ? $target.offset().top - 155 : $target.offset().top
				}, 500);
			}
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {

	"use strict";

	fox.registerWidget('Passrecovery', {

		configure: function(options) {			
			this.registerOptions('', {
				templateOptions: {
					success: true
				}
			});

			this.callParent('configure', arguments);
		},
		
		init: function() {
			this.embedWidget('forgotPassword', 'PasswordRecovery', {
				container: '.guest-form',
				'handleDom.submit': {
					target: '#form-submit',
					event: 'click',
					callback: 'changePassword'
				}
			});

			return this.callParent('init', arguments);
		},

		running: function() {
			this.forgotPassword = this.requireEmbeddedWidget('forgotPassword');
			this.forgotPassword.validateHash(fox.Navigator.get(1) || 'aasd');

			this.handleEvent(this.forgotPassword, 'validateHash', fox.bind(this.answerValidateHash, this));
		},

		addedToDom: function () {
			fox.dom.on('click', fox.dom.selectFirst('#form-submit', this.element), fox.bind(this.changePassword, this));
		},

		changePassword: function() {
			var password = fox.trim(this.dom1('#password').value),
				confirm = fox.trim(this.dom1('#confirm').value),
				isValid = true,
				msg = 'Password is empty.';

				if (fox.isEmpty(password) || fox.isEmpty(password)) {
					isValid = false;
				}

				if (password !== confirm) {
					isValid = false;
					msg = 'The password do not match.';
				}

				if (!isValid) {
					this.toggleError(true, msg);

					return;
				}

				this.toggleError(false, msg);
				this.forgotPassword.changePassword(this.hash, password, confirm);
				this.waitEvent(this.forgotPassword, 'changePassword', fox.bind(this.answerChangePassword, this));
				this.waitEvent(this.forgotPassword.wom1('#change'), ['failure'], fox.bind(this.answerChangePassword, this));
		},

		toggleError: function(state, msg) {
			var msgElement = !!this.getOption('errorContainer') ? this.dom('.error-container') : this.dom1('#info-forgot'),
				fields = ['password', 'confirm'];
			if(fox.isArray(msgElement)){
				fields.forEach(function(name) {
					var	elm = this.dom1('#'.concat(name));
					elm.nextElementSibling.children[0].innerHTML = msg || '';
					fox.dom[state === true ? 'addClass' : 'removeClass']('error', elm.parentNode);
				}.bind(this));
			}else{
				var p = msgElement.parentElement;
				fields.forEach(function(name) {
					var	elm = this.dom1('#'.concat(name));
					
					fox.dom[state === true ? 'addClass' : 'removeClass']('error', elm.parentNode);
				}.bind(this));

				if (state) {
					msgElement.innerText = msg || '';
					p.style.display = '';

					return;
				}
				msgElement.innerText = '';
				p.style.display = 'none';
			}

			
		},

		answerValidateHash: function(answer, alias, w) {
			this.setTemplateOptions('success', answer.success);
			this.setOption('templateOptions.success', answer.success);
			this.render();

			if (answer.success) {
				this.hash = answer.hash;
			}
		},

		answerChangePassword: function(resp) {
			var msg;
			var answer = resp.answer;
			// var infoForgotElm = fox.dom.selectFirst('#info-forgot', this.element),
			// 	passwordElm = fox.dom.selectFirst('#password', this.element),
			// 	confirmElm = fox.dom.selectFirst('#confirm', this.element),
			// 	fieldsElm = fox.dom.selectFirst('.fields', this.element),
			// 	buttonsElm = fox.dom.selectFirst('.buttons', this.element),
			// 	msg = 'Your account password was successfully changed. Please login <a href="/login">here</a>.';

			// infoForgotElm.parentElement.style.display = 'block';
			// infoForgotElm.innerHTML = msg;
			// passwordElm.value = '';
			// confirmElm.value = '';

			// if (answer.status) {
			// 	fieldsElm.style.display = 'none';
			// 	buttonsElm.style.display = 'none';
			// }

			if (resp.success == true) {
				this.toggleError(false);

				['password', 'confirm'].forEach(function(name) {
					var	elm = this.dom1('#'.concat(name));

					elm.value = '';
				}.bind(this));

				this.dom1('.info-text').innerHTML = 'Your account password was successfully changed. Please login <a href="/login">here</a>.';

				fox.dom.selectFirst('.fields', this.element).style.display = 'none';
				fox.dom.selectFirst('.buttons', this.element).style.display = 'none';

				return;
			}

			msg = answer.reason;

			if (answer.code === 111) {
				msg = 'New password cannot match your 3 previous ones';
			}

			this.toggleError(true, msg);
		}

	});
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';
	__webpack_require__(57);
	__webpack_require__(60);
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(58);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../node_modules/stylus-loader/index.js??ref--6-3!./_intercom.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../node_modules/stylus-loader/index.js??ref--6-3!./_intercom.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "body #intercom-container .intercom-borderless-frame{bottom:105px}body #intercom-container .intercom-messenger-frame{bottom:115px}#launcher-intercom{width:126px;height:121px;max-width:27vw;max-height:32vw;position:fixed;z-index:10001;display:none;right:0;bottom:0;background-image:url(" + __webpack_require__(59) + ");background-repeat:no-repeat;-ms-background-size:cover;background-size:cover}#launcher-intercom.open{background-position:-126px 0;animation:intercomOpacity 1s linear}@keyframes intercomOpacity{0%{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}to{-ms-filter:none;filter:none;opacity:1}}", ""]);

// exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("intercom/images/ico-chat-sprite_valentine.png", __webpack_require__.p + "_/_/_/_/_/common-components/intercom/images/ico-chat-sprite_valentine.png");

/***/ }),
/* 60 */
/***/ (function(module, exports) {

(function(fox, window) {
	"use strict";

	fox.registerWidget('Intercom', {
		configure: function(options) {
			this._currentState = null;
			this._embedded = false;

			this.registerOptions('', {
				listenWidgets: null,
				listenEvents: ['activate', 'running'],
				widgetOption: 'intercomEnabled',
				defaultState: true,
				customLauncher: false//'#launcher-intercom' //uncoment for use custom launcher
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			var settings = fox.getEnv('intercomSettings') || window.intercomSettings || false;

			if (!settings) return;

			if(this.getOption('customLauncher') !== false) {
				fox.setEnv('intercomSettings', fox.merge(settings, {
					hide_default_launcher: true,
					custom_launcher_selector: '#launcher-intercom'
				}));
			}

			this.setEventListenWidgets();

			this.callParent('running', arguments);
		},

		setEventListenWidgets: function () {
			var lw = this.getOption('listenWidgets');
			if (lw) {
				this.handleEvent(lw, this.getOption('listenEvents'), 'handleEnabledState');
			}
		},

		handleEnabledState: function(o, w) {
			if (w.getOption(this.getOption('widgetOption')) === false) {
				this.disableIC();
			} else if (w.getOption(this.getOption('widgetOption')) === true) {
				this.enableIC();
			} else {
				if (this.getOption('defaultState')) {
					this.enableIC();
				} else {
					this.disableIC();
				}
			}
		},

		disableIC: function() {
			if (this._currentState === false) return;

			if (this._embedded) {
				window.Intercom('shutdown');
				if(this.getOption('customLauncher') !== false) {
					this.showLauncher(false);
				}
				this._currentState = false;
			}
		},

		enableIC: function() {
			if (this._currentState === true) return;

			if (this._embedded) {
				window.Intercom('reattach_activator');
				if(this.getOption('customLauncher') !== false) {
					this.showLauncher(true);
				}
				window.Intercom('update', fox.getEnv('intercomSettings'));
			} else {
				this.embedIC();
				this._embedded = true;
			}

			this._currentState = true;
		},

		embedIC: function() {
			var d = document;
			var i = function () {
				i.c(arguments);
			};
			i.q = [];
			i.c = function (args) {
				i.q.push(args);
			};
			window.Intercom = i;
			var s = d.createElement('script');
			var app_id = fox.getEnv('intercomSettings.app_id');
			s.type = 'text/javascript';
			s.async = true;

			if(this.getOption('customLauncher') !== false) {
				if (!fox.dom.selectFirst('#launcher-intercom')) {
					var self = this;
					var launcher;
					launcher = document.createElement('a');
					launcher.setAttribute('id', self.getOption('customLauncher').substr(1));
					launcher.setAttribute('href', 'mailto:' + app_id + '@intercom-mail.com');
					document.body.appendChild(launcher);

					s.onload = function() {
						self.eventSwitcher();
					};
				}
			}

			s.src = 'https://widget.intercom.io/widget/' + app_id;
			var x = d.getElementsByTagName('script')[0];
			x.parentNode.insertBefore(s, x);
			window.Intercom('update', fox.getEnv('intercomSettings'));
		},

		eventSwitcher: function() {
			this.showLauncher(true);

			window.Intercom('onShow', function() {
				fox.dom.selectFirst('#launcher-intercom').classList.add('open');
			});
			window.Intercom('onHide', function() { 
				fox.dom.selectFirst('#launcher-intercom').classList.remove('open');
			});
		},

		showLauncher: function(b) {
			var el = this.getOption('customLauncher');

			if (b) {
				fox.dom.selectFirst(el).style.display = 'block';
			} else {
				fox.dom.selectFirst(el).style.display = 'none';
			}
		}
	}, 'Controller');
})(fox, window);

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("control_select", [["div",{"class":"guiDropDownSelect mc-select"},[["a",{"class":"select-link mar-right-15px gray-link"}]]]]);
fox.registerTemplate("control_select_new", [["div",{"class":"mc-form-field dropdown dl-&&0&& &&1&&"},[["span",{"class":"current-value","data-fox-alias":"1","data-fox-context":"control_select_new"},[["textNode",{"text":"Select item"}]]],["textNode",{"text":" "}],["span",{"class":"drop-arrow"}]],[["openAt","class"],["block","class"]]]]);
fox.registerTemplate("control_multiselect_new", [["div",{"class":"mc-form-field multis dropdown dl-&&0&& &&1&&"},[["span",{"class":"current-value","data-fox-alias":"1","data-fox-context":"control_multiselect_new"},[["textNode",{"text":"Select item"}]]]],[["openAt","class"],["block","class"]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("big_preloader", [["div",{"class":"mc-preloader-wrapper"},[["div",{"id":"spin-wrap"},[["span",{"class":"loading-text","data-fox-alias":"1","data-fox-context":"big_preloader"},[["textNode",{"text":"Loading..."}]]],["div",{"id":"spin"}]]]]]]);
fox.registerTemplate("small_preloader", [["div",{"id":"spin-wrap","class":"sm"},[["div",{"id":"spin"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("content_pager", [["ul",{"class":"mc-tabs pagination flex-child"},[["li",{"class":"ch-page tab-item prev page-stepper"},[["if",{"notempty":"","addclass":"visible","addattr":"data-page:&&1&&"},[],[["prev","notempty",true],["prev","__internal"]]]]],["if",{"notempty":""},[["li",{"class":"ch-page tab-item","data-page":"1"},[["textNode",{"text":"1"}]]],["li",{"class":"tab-item"},[["span",{"class":"spacer"},[["textNode",{"text":"..."}]]]]]],[["startSpacer","notempty",true]]],["foreach",{"from":"","item":"page"},[["li",{"class":"ch-page tab-item","data-page":""},[["span",{},[],[["page.page","__text",true]]],["textNode",{"text":" "}],["if",{"notempty":"","addclass":"active"},[],[["page.current","notempty",true]]]],[["page.page","data-page",true]]]],[["pages","from",true]]],["if",{"notempty":""},[["li",{"class":"tab-item"},[["span",{"class":"spacer"},[["textNode",{"text":"..."}]]]]],["li",{"class":"ch-page tab-item","data-page":""},[["span",{},[],[["total","__text",true]]]],[["total","data-page",true]]]],[["endSpacer","notempty",true]]],["li",{"class":"ch-page tab-item next page-stepper"},[["if",{"notempty":"","addclass":"visible","addattr":"data-page:&&1&&"},[],[["next","notempty",true],["next","__internal"]]]]]]],["div",{"class":"ta-r flex-child"},[["div",{"id":"pager-rpp-switcher","class":"rpp-switcher"}],["div",{"class":"mc-page-switcher"},[["input",{"id":"jump-to-page","class":"page-select","type":"text"}],["textNode",{"text":" "}],["button",{"class":"goto-page","data-fox-alias":"2","data-fox-context":"content_pager"},[["textNode",{"text":"Jump to page"}]]]]]]]]);
fox.registerTemplate("content_pager_simple", [["ul",{"class":"mc-tabs pagination flex-child"},[["li",{"class":"ch-page tab-item prev page-stepper"},[["if",{"notempty":"","addclass":"visible","addattr":"data-page:&&1&&"},[],[["prev","notempty",true],["prev","__internal"]]]]],["if",{"notempty":""},[["li",{"class":"ch-page tab-item","data-page":"1"},[["textNode",{"text":"1"}]]],["li",{"class":"tab-item"},[["span",{"class":"spacer"},[["textNode",{"text":"..."}]]]]]],[["startSpacer","notempty",true]]],["foreach",{"from":"","item":"page"},[["li",{"class":"ch-page tab-item","data-page":""},[["span",{},[],[["page.page","__text",true]]],["textNode",{"text":" "}],["if",{"notempty":"","addclass":"active"},[],[["page.current","notempty",true]]]],[["page.page","data-page",true]]]],[["pages","from",true]]],["if",{"notempty":""},[["li",{"class":"tab-item"},[["span",{"class":"spacer"},[["textNode",{"text":"..."}]]]]],["li",{"class":"ch-page tab-item","data-page":""},[["span",{},[],[["total","__text",true]]]],[["total","data-page",true]]]],[["endSpacer","notempty",true]]],["li",{"class":"ch-page tab-item next page-stepper"},[["if",{"notempty":"","addclass":"visible","addattr":"data-page:&&1&&"},[],[["next","notempty",true],["next","__internal"]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// SitePage_Faq

(function (fox) {
	 "use strict";
	fox.registerWidget('Promo_Faq', {

		configure: function () {

			if (!fox.objectGet(fox.i18n, 'lang') && !fox.objectGet(fox.i18n, 'defaultLang')) {
				fox.i18n = {};
				fox.i18n.lang = 'en';
			}

			this._blockPrefix = 'faqblock-';
			this._loadedLang = fox.i18n.lang;

			this.registerOptions('', {
				//container: '.promo-page-container',
				template: 'promo_faq',
				titleFaq: '',
				widgets: {
					main: {
						widget: 'Widget',
						autoRender: true,
						container: '.main-block',
						template: 'faq_main',
						group: 'faq',
						widgets: {
							dlFaq: {
								widget: 'Datalayer',
								method: 'faq.get',
								fields: ['id', 'title', 'contents.content', 'tags.title', 'tags.isTop'],
								transitParameters: {
									status: 2,
									lang: fox.i18n.lang
								}
							}
						}
					},

					result: {
						widget: 'Widget',
						autoRender: true,
						container: '.main-block',
						template: 'faq_result',
						group: 'faq',
						active: false,

						widgets: {
							searchDl: {
								widget: 'Datalayer',
								fields: ['id', 'title', 'contents.content'],
								transitParameters: {
									status: 2,
									lang: fox.i18n.lang
								},
								limit: 10
							},

							searchResult: {
								widget: 'Grid',
								autoRender: true,
								dataLayer: '@parent #searchDl',
								externalLoad: true,
								container: '.exp-block.result',
								template: 'faq_search_result',
								list: {
									container: '.fqb-list',
									'tpl.row': 'faq_post_item',
									'tpl.emptyRow': 'faq_search_nodata'
								}
							}
						}
					},

					tags: {
						widget: 'Widget',
						autoRender: true,
						container: '.fq-block.tags',
						template: 'faq_tags',
						widgets: {
							list: {
								widget: 'List',
								autoRender: true,
								container: '.fqb-tags-list',
								'tpl.row': 'faq_tags_item'
							}
						}
					},
					askQuestion: {
						widget: 'Faq_Question',
						autoRender: true,
						container: '.fq-block.ask',
						template: 'faq_question'
					}
				},

				handleWom: {
					showTag: {
						widget: fox.Navigator,
						event: 'modified_tag',
						callback: '_handleTagChange'
					},

					handleResultWidgetActivation: {
						widget: '@this',
						event: ['backLinkAvailable', 'backLinkUnavailable'],
						callback: '_handleSwitch'
					},

					handleSearchDlLoad: {
						widget: '#result #searchDl',
						event: 'loaded',
						callback: '_handleSearchDlLoad'
					},

					handleLangSwitch: {
						widget: '@root ~.Promo_Header #langSwitcher',
						event: 'langSwitched',
						callback: '_switchLang'
					},

					handleFaqLoad: {
						event: 'loaded',
						widget: '#main #dlFaq',
						callback: '_handleFaqLoaded'
					}
				},

				handleDom: {
					searchHandler: {
						target: '.fq-search-input',
						event: 'input',
						callback: '_handleSearch'
					},
					backLinkHandler: {
						target: '.back-link',
						event: 'click',
						callback: '_handleBackLink'
					},
					toggleItemVisibility: {
						targetWidget: '~.Grid #list',
						target: '.toggle',
						event: 'click',
						callback: '_toggleItemVisibility'
					},
					toggleAllItemsVisibility: {
						targetWidget: '~.Grid',
						target: '.exp',
						event: 'click',
						callback: '_toggleAllItemsVisibility'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {

			this.templateOptions = {
				titleFaq: this.options.titleFaq
			};

			this._handleTagChange();
			this.callParent('running', arguments);
		},

		activate: function () {
			if (this._loadedLang !== fox.i18n.lang) {
				fox.each(Object.keys(this.wom1('#main').options.widgets), function (w) {
					if (w.lastIndexOf(this._blockPrefix, 0) === 0) {
						this.wom1('#main #' + w)._readyToEmbed = false;
					}
				}, this);
				this.wom1('#result #searchResult')._readyToEmbed = false;
				this.wom1('#tags #list')._readyToEmbed = false;
			}

			this._handleTagChange();
			this._switchLang();
			this.callParent('activate', arguments);
		},

		_handleFaqLoaded: function(obj, dl) {
			var posts = dl.getCollection(),
				postsByTag = {top: {}, usual: {}},
				tags = [];

			for (var i = 0; i < posts.length; i++) {
				var post = posts[i];
				if (!fox.isEmpty(post.tags.collection)) {
					for (var tag in post.tags.collection) {
						var title = post.tags.collection[tag].title,
							isTop = post.tags.collection[tag].isTop,
							group = isTop ? 'top' : 'usual';

						if (!postsByTag[group].hasOwnProperty(title)) {
							postsByTag[group][title] = [];
							tags.push({alias: title});
						}

						postsByTag[group][title].push(post);
					}
				}
			}

			this._renderFaqs(postsByTag);
			this._renderCategories(tags);
		},

		_renderFaqs: function(postsByTag) {
			var main = this.wom1('#main');
			var groupOrder = ['top', 'usual'];
			var i;

			fox.each(Object.keys(main.options.widgets), function(w) {
				if (w.lastIndexOf(this._blockPrefix, 0) === 0) {
					this.wom1('#main #' + w).removeFromDom();
					main.removeEmbeddedWidget(w);
				}
			}, this);

			function _renderBlock (posts, tag) {
				var tagHash = new Date().getTime() + '_' + parseInt(Math.random()*10000000);
				var faqBlock = main.embedWidget(this._blockPrefix + tagHash, 'Widget', {
					autoRender: true,
					container: '.faqs',
					template: 'faq_block',
					'embed.location': 'lastChild',
					handleDom: {
						toggleAllItemsVisibility: {
							target: '.exp',
							event: 'click',
							callback: fox.bind(this._toggleAllItemsVisibility, this)
						}
					}
				});

				faqBlock.setTemplateOptions({
					title: tag,
					alias: this._blockPrefix + tagHash,
					isTop: groupOrder[i] === 'top'
				});

				faqBlock.embedWidget('list', 'List', {
					autoRender: true,
					container: '.fqb-list',
					'tpl.row': 'faq_post_item',
					'tpl.emptyRow': 'faq_nodata',
					collection: posts,
					handleDom: {
						toggleItemVisibility: {
							target: '.toggle',
							event: 'click',
							callback: fox.bind(this._toggleItemVisibility, this)
						}
					}
				});

				faqBlock.run();
			}

			for (i=0; i < groupOrder.length; i++) {
				fox.each(postsByTag[groupOrder[i]], _renderBlock, this);
			}
		},

		_renderCategories: function(categories) {
			var tagsList = this.wom1('#tags #list');
			tagsList.setCollection(categories);

			if (!tagsList._readyToEmbed) {
				tagsList._readyToEmbed = true;
				tagsList.render();
			}
		},

		_toggleItemVisibility: function (el, alias, w, e) {
			el = fox.dom.wrap(el);
			var isOpened = el.hasClass('opened');

			el[(isOpened ? 'removeClass' : 'addClass')]('opened');
		},

		_toggleAllItemsVisibility: function (el, ev,  w) {
			var alias = w.getAlias();
			var block = fox.dom.selectFirst('.fqb-list[data-alias="' + alias + '"]', this.element);
			var txtBlock = fox.dom.selectFirst('.txt', el);

			if (!block) {
				return;
			}

			var items = fox.dom.select('.toggle', block);
			var isOpened = fox.dom.hasClass('opened', block);
			var operation = (isOpened ? 'removeClass' : 'addClass');
			var txt = (isOpened ? 'Expand all' : 'Collapse all');

			fox.each(items, function (item) {
				fox.dom[operation]('opened', item);
			}, this);

			fox.dom[operation]('opened', block);
			fox.dom[operation]('opened', el);
			txtBlock.innerHTML = txt;
		},

		_handleTagChange: function () {
			var tag = fox.Navigator.get('tag');
			
			if (!tag) {
				this.showAllArticles(true);
				return;
			}

			this.showArticlesByTag(tag);
		},

		showAllArticles: function (dnReload) {
			var w = this.wom1('#main');

			if (!w) {
				return;
			}

			this.wom1('#main #dlFaq').load(dnReload);

			this.switchEmbeddedWidget('main');
			this._isAllShowed = true;
			this.dispatchEvent('backLinkUnavailable');
		},

		showArticlesByTag: function (tag) {
			var w = this.wom1('#result');

			if (!w) {
				return;
			}

			this.wom1('#result #searchResult')._readyToEmbed = false;

			var dl = w.rwom1('#searchDl');
			dl.setMethod('faq.get');
			dl.setTransitParameter('tags', tag);
			dl.setTransitParameter('lang', fox.i18n.lang);
			dl.load();

			this.switchEmbeddedWidget('result');
			this.dispatchEvent('backLinkAvailable');
			this._isAllShowed = false;
		},

		_handleSwitch: function (obj, w, ev) {
			var state = ev === 'backLinkAvailable';
			if (this.isEmbedded()) {
				this.toggleBackLink(state);
			} else {
				this.wait('addedToDom').then(function () {
					this.toggleBackLink(state);
				}.bind(this));
			}
		},

		toggleBackLink: function (state) {
			if (this.element) {
				var link = fox.dom.selectFirst('.back-link', this.element[0]);

				if (!link) {
					return;
				}

				fox.dom[(state ? 'addClass' : 'removeClass')]('show', link);
			}
		},

		_handleSearch: function (el) {
			if (this._searchTimeout) {
				clearTimeout(this._searchTimeout);
			}

			if (!el.value.length && !this._isAllShowed) {
				this.showAllArticles(true);
				return;
			}

			if (el.value.length >= 3) {
				this._searchTimeout = setTimeout(function() { this.search(el.value); }.bind(this), 1000);
			}
		},

		search: function (str) {
			this.wom1('#result #searchResult')._readyToEmbed = false;

			var dl = this.rwom1('#result #searchDl');
			dl.setMethod('faq.searchPost');
			dl.setTransitParameter('phrase', str);
			dl.setTransitParameter('lang', fox.i18n.lang);
			dl.load();

			this.switchEmbeddedWidget('result');
			this.dispatchEvent('backLinkAvailable');
			this._isAllShowed = false;
		},

		_handleBackLink: function () {
			if (!this._isAllShowed) {
				this.showAllArticles(true);
			}

			fox.site.gotoPage('faq');
		},

		_switchLang: function() {
			if (this._loadedLang !== fox.i18n.lang) {
				this.wom1('#main #dlFaq').setTransitParameter('lang', fox.i18n.lang);
				this.wom1('#result #searchDl').setTransitParameter('lang', fox.i18n.lang);

				if (this._isAllShowed) {
					this.wom1('#main #dlFaq').load();
				} else {
					this.wom1('#result #searchDl').load();
				}

				this._loadedLang = fox.i18n.lang;
			}
		},

		_handleSearchDlLoad: function() {
			var resultGrid = this.wom1('#result #searchResult');

			if (!resultGrid._readyToEmbed) {
				resultGrid._readyToEmbed = true;
				resultGrid.render();
			}
		}
	});

})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	"use strict";
	fox.registerWidget('Faq_Question', {
		
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				widgets: {
					sendApi: {
						widget: 'Api',
						method: 'faq.sendQuestion'
					},

					captcha: {
						widget: 'Captcha',
						container: '.cp'
					}
				},

				handleWom: {
					succesSending: {
						widget: '#sendApi',
						event: 'success',
						callback: 'showSuccess'
					},
					errorSending: {
						widget: '#sendApi',
						event: 'failure',
						callback: '_handleError'
					}
				},

				handleDom: {
					send: {
						target: '.send',
						event: 'click',
						callback: '_submit'
					},
					input: {
						target: '.fields2send',
						event: 'input',
						callback: '_hideError'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		_collectData: function () {
			var result = {};
			
			var fields = fox.dom.select('.fields2send', this.element[0]);
			var captchaId = this.rwom1('#captcha').captchaId;

			fox.each(fields, function (field) {
				if (field.value && field.value.length) {
					result[field.name] = field.value;
				} else {
					this._toggleError(field.name, true);
				}				
			}, this);

			if (captchaId) {
				result.captchaId = captchaId;
			}
			
			return result;
		},

		_submit: function () {
			if (!fox.site.member) {
				var check = fox.dom.sel1('#consent_tos');
				if (check._node.checked) {
					this.send();
					return true;
				} else {
					check.addClass('error');
					fox.site.wait(check, 'click', function (elt) {
						elt.removeClass('error');
					});
					return false;
				}
			}
			this.send();
		},

		send: function () {
			this.data = this._collectData();
			var api = this.rwom1('#sendApi');

			api.send(this.data, false);
		},

		_toggleError: function (name, state) {
			var field = fox.dom.selectFirst('[name="' + name + '"]', this.element[0]);

			if (!field) {
				return;
			}

			fox.dom[(state ? 'addClass' : 'removeClass')]('error', field);
		},

		_hideError: function (el) {
			this._toggleError(el.name, false);
		},

		showSuccess: function () {
			fox.each(this.data, function (val, key) {
				this._toggleError(key, false);
			}, this);

			var block = fox.dom.selectFirst('.fqb-content.form', this.element[0]);

			fox.dom.addClass('success', block);

			window.setTimeout(fox.bind(function () {
				fox.dom.removeClass('show', block);
			}, this), 3000);

			this.dispatchEvent('success');
		},

		_handleError: function (response) {
			if (response.answer.code === 2) {
				this._toggleError('captcha', true);
			}
		}

	}, 'Widget');
})(fox);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_faq", [["div",{"class":"faq-section"},[["if",{"notempty":""},[["div",{"class":"faq-title","data-fox-alias":"3","data-fox-context":"promo_faq"},[["span",{},[],[["titleFaq","__text",true]]]]]],[["titleFaq","notempty",true]]],["div",{"class":"h-bottom"},[["div",{"class":"fq-h-wrapper clearfix"},[["a",{"class":"back-link","data-fox-alias":"1","data-fox-context":"promo_faq"},[["textNode",{"text":"Back to FAQ"}]]]]]]],["div",{"class":"fq-h-wrapper"},[["div",{"class":"right-sidebar top"},[["div",{"class":"sd-block fq-block search"},[["div",{"class":"fqb-title clearfix hide-if-mobile"},[["span",{"class":"","data-fox-alias":"2","data-fox-context":"promo_faq"},[["textNode",{"text":"Search"}]]]]],["div",{"class":"fqb-content"},[["div",{"class":"fqb-ask-form fields"},[["div",{"class":"row"},[["div",{"class":"fqb-input icon search"},[["input",{"type":"text","name":"search","placeholder":"Type and hit Enter","class":"fqb-field fields2send fq-search-input"}],["div",{"class":"styled"}]]]]]]]]]]],["div",{"class":"sd-block fq-block tags hide-if-mobile"}]]],["div",{"class":"main-block"}],["div",{"class":"sep"}],["div",{"class":"right-sidebar bottom"},[["div",{"class":"sd-block fq-block ask"}]]],["div",{"class":"clear"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("faq_question", [["div",{"class":"fqb-title clearfix"},[["span",{"class":"","data-fox-alias":"1","data-fox-context":"faq_question"},[["textNode",{"text":"Ask your question"}]]]]],["div",{"class":"fqb-content form"},[["div",{"class":"fqb-ask-form fields"},[["div",{"class":"row"},[["div",{"class":"fqb-input icon name"},[["input",{"type":"text","name":"name","placeholder":"Your name","class":"fqb-field fields2send"}],["div",{"class":"styled"}]]]]],["div",{"class":"row"},[["div",{"class":"fqb-input icon email"},[["input",{"type":"text","name":"email","placeholder":"Your email","class":"fqb-field fields2send"}],["div",{"class":"styled"}]]]]],["div",{"class":"row"},[["div",{"class":"fqb-input captcha"},[["input",{"type":"text","name":"captcha","placeholder":"Enter text from image","class":"fqb-field fields2send"}],["div",{"class":"styled"},[["span",{"class":"cp"}]]]]]]],["div",{"class":"row"},[["div",{"class":"fqb-input"},[["textarea",{"name":"question","placeholder":"Enter text of your question","class":"fqb-field fields2send"}],["div",{"class":"styled"},[["span",{"class":"cp"}]]]]]]],["div",{"class":"row _flex _row-n"},[["div",{"class":"checkbox-wrapp mc-field _m-r-5"},[["input",{"class":"fields2send not-empty","type":"checkbox","name":"consent_tos","id":"consent_tos"}],["textNode",{"text":" "}],["span",{"class":"checkbox"},[["span",{"class":"arr"}]]],["div",{"class":"tooltip validation-error-box"},[["div",{"class":"css3-holder message"},[["textNode",{"text":" You must agree to the Website Operator Agreement "}]]]]]]],["label",{"for":"consent_tos","class":"tos-text","style":"font-size:11px"},[["span",{},[["textNode",{"text":" By checking this box, I certify that I am at least 18-years old, have the capacity to enter into legally binding contracts, and have read and agree to the "}]]],["textNode",{"text":" "}],["span",{"onclick":"event.stopPropagation();"},[["a",{"target":"_blank","href":"/operator-agreement"},[["textNode",{"text":" Operator Agreement"}]]]]]]]]],["div",{"class":"row"},[["a",{"class":"fqb-btn blue send","data-fox-alias":"2","data-fox-context":"faq_question"},[["textNode",{"text":"Send your question"}]]]]]]],["div",{"class":"fqb-ask-form fqb-success-msg","data-fox-alias":"3","data-fox-context":"faq_question"},[["strong",{},[["textNode",{"text":"Thank you for contacting us!"}]]],["textNode",{"text":" "}],["br"],["br"],["textNode",{"text":" We greatly appreciate you taking the time to write to us. "}],["br"],["textNode",{"text":" Please allow at least 24 hours to process your request. "}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("faq_block", [["div",{"class":"exp-block fq-block"},[["if",{"empty":"","addclass":"blue"},[["else",{"addclass":"green"}]],[["isTop","empty",true]]],["div",{"class":"fqb-title clearfix"},[["span",{"class":""},[["span",{},[],[["title","__text",true]]]]],["textNode",{"text":" "}],["span",{"class":"exp fright"},[["span",{"class":"txt","data-fox-alias":"1","data-fox-context":"faq_block"},[["textNode",{"text":"Expand all"}]]],["textNode",{"text":" "}],["span",{"class":"ring"}]]]]],["div",{"class":"fqb-content"},[["ol",{"class":"fqb-list","data-alias":""},[],[["alias","data-alias",true]]]]]]]]);
fox.registerTemplate("faq_post_item", [["li",{"class":"toggle"},[["div",{"class":"fq-p-title"},[["span",{},[["span",{},[],[["title","__text",true]]]]],["textNode",{"text":" "}],["span",{"class":"fq-expander"}]]],["div",{"class":"fq-p-content"},[["foreach",{"from":"","item":"item"},[["div",{"class":"cont"},[["textNode",{"text":" "}],["span",{},[],[["item.content","__text",true,[{"name":"html","params":[]}]]]],["textNode",{"text":" "}]]]],[["contents","from",true]]]]]]]]);
fox.registerTemplate("faq_nodata", [["li",{"class":"empty","data-fox-alias":"1","data-fox-context":"faq_nodata"},[["textNode",{"text":" Sorry, we haven't covered this topic yet. "}],["a",{"href":"mailto:support@modelcentro.com"},[["textNode",{"text":"Send us an email"}]]]]]]);
fox.registerTemplate("faq_search_nodata", [["li",{"class":"empty","data-fox-alias":"1","data-fox-context":"faq_search_nodata"},[["textNode",{"text":" Sorry, we haven't covered this topic yet. "}],["a",{"href":"mailto:support@modelcentro.com"},[["textNode",{"text":"Send us an email"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("faq_main", [["div",{"class":"faqs"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("faq_result", [["div",{"class":"exp-block fq-block blue result"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("faq_search_result", [["div",{"class":"fqb-title clearfix","data-alias":"searchResult"},[["span",{"class":"","data-fox-alias":"1","data-fox-context":"faq_search_result"},[["textNode",{"text":"Search result"}]]],["textNode",{"text":" "}],["span",{"class":"exp fright"},[["span",{"class":"txt","data-fox-alias":"2","data-fox-context":"faq_search_result"},[["textNode",{"text":"Expand all"}]]],["textNode",{"text":" "}],["span",{"class":"ring"}]]]]],["div",{"class":"fqb-content"},[["ol",{"class":"fqb-list","data-alias":"searchResult"}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("faq_tags", [["div",{"class":"tags-wrapper"},[["div",{"class":"fqb-title clearfix"},[["span",{"class":"","data-fox-alias":"1","data-fox-context":"faq_tags"},[["textNode",{"text":"Categories"}]]]]],["div",{"class":"fqb-content"},[["ul",{"class":"fqb-tags-list"}]]]]]]);
fox.registerTemplate("faq_tags_item", [["li",{},[["a",{"href":"/faq/tag=&&0&&"},[["span",{},[],[["alias","__text",true]]]],[["alias","href"]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_termsofuse", [["div",{"class":"layout-width single-page"},[["h2",{"class":"sp-title padd-left"},[["span",{},[["textNode",{"text":"ModelCentro"}],["sup",{},[["textNode",{"text":"TM"}]]]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Terms-of-Use Agreement"}]]],["div",{"class":"sp-up-time"},[["textNode",{"text":"Last Modified: May 11, 2018"}]]]]],["div",{"class":"sp-main-content-wrapp"},[["div",{"class":"col sp-left"},[["p",{},[["strong",{},[["textNode",{"text":"Acceptance of the Terms of Use"}]]]]],["p",{},[["textNode",{"text":"These terms of use are entered into between you and Centro Publisher Limited, a limited company formed under the laws of the British Virgin Islands (the "}],["strong",{},[["textNode",{"text":"“Company”"}]]],["textNode",{"text":"). The following agreement, together with any documents it expressly incorporates by reference (collectively, this "}],["strong",{},[["textNode",{"text":"“agreement”"}]]],["textNode",{"text":"), govern your access to and use of "}],["a",{"href":"https://www.modelcentro.com","target":"_blank","rel":"nofollow"},[["textNode",{"text":"www.modelcentro.com"}]]],["textNode",{"text":", including any content, functionality, and services offered on or through "}],["a",{"href":"https://www.modelcentro.com","target":"_blank","rel":"nofollow"},[["textNode",{"text":"www.modelcentro.com"}]]],["textNode",{"text":" (the "}],["strong",{},[["textNode",{"text":"“Website”"}]]],["textNode",{"text":"), whether as a guest or a registered user."}]]],["p",{},[["textNode",{"text":"Please read this agreement carefully before you start to use the Website. "}],["strong",{},[["textNode",{"text":"By using the Website or by clicking to accept or agree to this agreement when this option is made available to you, you accept and agree to be bound and abide by this agreement and the Company’s Privacy Policy, found at "}],["a",{"href":"https://modelcentro.com/privacyPolicy","target":"_blank","rel":"nofollow"},[["textNode",{"text":"https://modelcentro.com/privacyPolicy"}]]],["textNode",{"text":", incorporated by reference."}]]],["textNode",{"text":" If you do not want to agree to this agreement or the Privacy Policy, you must not access or use the Website."}]]],["p",{},[["textNode",{"text":"This Website is offered and available to users who are 18-years old or older. By using this Website, you state that you are of legal age to form a binding contract with the Company and meet all the foregoing eligibility requirements, if any. If you do not meet all these requirements, you must not access or use the Website."}]]],["p",{},[["strong",{},[["textNode",{"text":"Changes to the Agreement"}]]]]],["p",{},[["textNode",{"text":"The Company may revise and update this agreement on one or more occasions in its sole discretion. All changes are effective immediately when the Company posts them and apply to all access to and use of the Website from then on. But any changes to the dispute resolution provisions stated in Governing Law and Jurisdiction will not apply to any disputes for which the parties have actual notice on or before the date the change is posted on the Website."}]]],["p",{},[["textNode",{"text":"Your continued use of the Website after the posting of the revised agreement means that you accept and agree to the changes. You are expected to check this page often, so you are aware of any changes, as they are binding on you."}]]],["p",{},[["strong",{},[["textNode",{"text":"Accessing the Website and Account Security"}]]]]],["p",{},[["textNode",{"text":"The Company may withdraw or amend this Website, and any service or material the Company provides on the Website, in its sole discretion without notice. The Company will not be liable if for any reason all or any part of the Website is unavailable at any time or for any period. From time to time, the Company may restrict access to some parts of the Website, or the entire Website, to users, including registered users."}]]],["p",{},[["textNode",{"text":"You are responsible for:"}]]],["div",{"class":"marg-left"},[["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":"Making all arrangements necessary for you to have access to the Website."}]]],["li",{},[["textNode",{"text":"Ensuring that all persons who access the Website through your Internet connection are aware of this agreement and comply with it."}]]]]]]],["p",{},[["textNode",{"text":"To access the Website or some of the resources it offers, you may be asked to provide certain registration details or other information. It is a condition of your use of the Website that all the information you provide on the Website is correct, current, and complete. You acknowledge that all information you provide to register with this Website or otherwise, including through the use of any interactive features on the Website, is governed by the "}],["a",{"href":"https://modelcentro.com/privacyPolicy","target":"_blank","rel":"nofollow"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":", and you consent to all actions the Company takes with respect to your information consistent with the Privacy Policy."}]]],["p",{},[["textNode",{"text":"If you choose, or are provided with, a username, password, or any other piece of information as part of the Company’s security procedures, you must treat this information as confidential, and you must not disclose it to any other person or entity. You also acknowledge that your account is personal to you and will not provide any other person with access to this Website or parts of it using your username, password, or other security information. You will promptly notify the Company of any unauthorized access to or use of your username or password or any other breach of security. You also will ensure that you exit from your account at the end of each session. You should use particular caution when accessing your account from a public or shared computer so that others are not able to view or record your password or other personal information."}]]],["p",{},[["textNode",{"text":"The Company may disable any username, password, or other identifier, whether chosen by you or provided by the Company, at any time in its sole discretion for any or no reason, including if, in the Company’s opinion, you have violated any part of this agreement."}]]],["p",{},[["strong",{},[["textNode",{"text":"Intellectual-Property Rights"}]]]]],["p",{},[["textNode",{"text":"The Website and its entire contents, features, and functionality (including all information, software, text, displays, images, video, and audio, and the design, selection, and arrangement of it) are owned by the Company, its licensors, or other providers of that material and are protected by United States and international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws."}]]],["p",{},[["textNode",{"text":"This agreement permits you to use the Website for your personal, noncommercial use only ("}],["span",{"class":"warning"},[["textNode",{"text":"unauthorized commercial uses do not include commercial uses allowed under the"}]]],["textNode",{"text":" "}],["a",{"href":"https://modelcentro.com/operator-agreement","rel":"nofollow","target":"_blank"},[["textNode",{"text":"ModelCentro Operator Agreement"}]]],["textNode",{"text":"). You must not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on the Website, except as follows:"}]]],["div",{"class":"marg-left"},[["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":"Your computer may temporarily store copies of those materials in RAM incidental to your accessing and viewing those materials."}]]],["li",{},[["textNode",{"text":"You may store files that are automatically cached by your Web browser for display enhancement purposes."}]]],["li",{},[["textNode",{"text":"You may print or download one copy of a reasonable number of pages of the Website for your own personal, noncommercial use and not for further reproduction, publication, or distribution."}]]],["li",{},[["textNode",{"text":"If the Company provides desktop, mobile, or other applications for download, you may download a single copy to your computer or mobile device solely for your own personal, noncommercial use, on condition that you agree to be bound by the Company’s end user license agreement for those applications."}]]],["li",{},[["textNode",{"text":"If the Company provides social media features with certain content, you may take those actions as are enabled by those features."}]]]]],["p",{},[["textNode",{"text":"You must not:"}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":"Modify copies of any materials from this Website."}]]],["li",{},[["textNode",{"text":"Use any illustrations, photographs, video or audio sequences, or any graphics separately from the accompanying text."}]]],["li",{},[["textNode",{"text":"Delete or alter any copyright, trademark, or other proprietary rights notices from copies of materials from this Website."}]]]]]]],["p",{},[["textNode",{"text":"You must not access or use for any commercial purposes any part of the Website or any services or materials available through the Website ("}],["span",{"class":"warning"},[["textNode",{"text":"unauthorized commercial uses do not include commercial uses allowed under the"}]]],["textNode",{"text":" "}],["a",{"href":"https://modelcentro.com/operator-agreement","rel":"nofollow","target":"_blank"},[["textNode",{"text":"ModelCentro Operator Agreement"}]]],["textNode",{"text":")."}]]],["p",{},[["textNode",{"text":"If you print, copy, modify, download, or otherwise use or provide any other person with access to any part of the Website in breach of this agreement, your right to use the Website will stop immediately and you must, at the Company’s option, return or destroy any copies of the materials you have made. No interest in or to the Website or any content on the Website is transferred to you, and all rights not expressly granted are reserved by the Company. Any use of the Website not expressly permitted by this agreement is a breach of this agreement and may violate copyright, trademark, and other laws."}]]],["p",{},[["strong",{},[["textNode",{"text":"Trademarks"}]]]]],["p",{},[["textNode",{"text":"The Company name, the terms ADULTCENTRO, MODELCENTRO, FANCENTRO, AND MCPROFITS, the Company logo, and all related names, logos, product and service names, designs, and slogans are trademarks of the Company or its affiliates or licensors. You must not use those marks without the Company’s written permission. All other names, logos, product and service names, designs, and slogans on this Website are the trademarks of their respective owners."}]]],["p",{},[["strong",{},[["textNode",{"text":"Prohibited Uses"}]]]]],["p",{},[["textNode",{"text":"You may use the Website only for lawful purposes and in accordance with this agreement. You must not use the Website:"}]]],["div",{"class":"marg-left"},[["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":"In any way that violates any applicable federal, state, local, or international law or regulation (including any laws regarding the export of data or software to and from the US or other countries)."}]]],["li",{},[["textNode",{"text":"To exploit, harm, or attempt to exploit or harm minors in any way by exposing them to inappropriate content, asking for personally identifiable information, or otherwise."}]]],["li",{},[["textNode",{"text":"To send, knowingly receive, upload, download, use, or re-use any material that does not comply with the Content Standards stated in this agreement."}]]],["li",{},[["textNode",{"text":"To transmit, or procure the sending of, any advertising or promotional material without the Company’s written consent, including any “junk mail,” “chain letter,” “spam,” or any other similar solicitation."}]]],["li",{},[["textNode",{"text":"To impersonate or attempt to impersonate the Company, a Company employee, another user, or any other person or entity (including by using email addresses or usernames associated with any of the foregoing)."}]]],["li",{},[["textNode",{"text":"To engage in any other conduct that restricts or inhibits anyone’s use or enjoyment of the Website, or which, as determined by the Company, may harm the Company or users of the Website or expose them to liability. "}]]]]]]],["p",{},[["textNode",{"text":"Additionally, you must not:"}]]],["div",{"class":"marg-left"},[["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":"Use the Website in any manner that could disable, overburden, damage, or impair the Website or interfere with any other party’s use of the Website, including their ability to engage in real time activities through the Website."}]]],["li",{},[["textNode",{"text":"Use any robot, spider, or other automatic device, process, or means to access the Website for any purpose, including monitoring or copying any of the material on the Website."}]]],["li",{},[["textNode",{"text":"Use any manual process to monitor or copy any of the material on the Website or for any other unauthorized purpose without the Company’s written consent."}]]],["li",{},[["textNode",{"text":"Use any device, software, or routine that interferes with the proper working of the Website."}]]],["li",{},[["textNode",{"text":"Introduce any viruses, trojan horses, worms, logic bombs, or other material that is malicious or technologically harmful."}]]],["li",{},[["textNode",{"text":"Attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of the Website, the server on which the Website is stored, or any server, computer, or database connected to the Website."}]]],["li",{},[["textNode",{"text":"Attack the Website via a denial-of-service attack or a distributed denial-of-service attack."}]]],["li",{},[["textNode",{"text":"Otherwise try to interfere with the proper working of the Website."}]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"User Contributions"}]]]]],["p",{},[["textNode",{"text":"The Website may contain message boards, chat rooms, personal web pages or profiles, forums, bulletin boards, and other interactive features (collectively, "}],["strong",{},[["textNode",{"text":"“Interactive Services”"}]]],["textNode",{"text":") that allow users to post, submit, publish, display, or transmit to other users or other persons ("}],["strong",{},[["textNode",{"text":"“post”"}]]],["textNode",{"text":") content or materials (collectively, "}],["strong",{},[["textNode",{"text":"“User Contributions”"}]]],["textNode",{"text":") on or through the Website."}]]],["p",{},[["textNode",{"text":"All User Contributions must comply with the Content Standards stated in this agreement."}]]],["p",{},[["textNode",{"text":"Any User Contribution you post to the Website will be considered nonconfidential and nonproprietary. By providing any User Contribution on the Website, you hereby grant the Company and its affiliates and service providers, and each of their and the Company’s respective licensees, successors, and assigns a license to use, reproduce, modify, perform, display, distribute, and otherwise disclose to third parties any such material for any purpose."}]]],["p",{},[["textNode",{"text":"You state that:"}]]],["div",{"class":"marg-left"},[["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":"You own or control all rights in and to the User Contributions and have the right to grant the license granted above to the Company and its affiliates and service providers, and each of their and the Company’s respective licensees, successors, and assigns."}]]],["li",{},[["textNode",{"text":"All your User Contributions do and will comply with this agreement."}]]]]]]],["p",{},[["textNode",{"text":"You acknowledge that you are responsible for any User Contributions you submit or contribute, and you, not the Company, have fully responsibility for that content, including its legality, reliability, accuracy, and appropriateness."}]]],["p",{},[["textNode",{"text":"The Company is not responsible, or liable to any third party, for the content or accuracy of any User Contributions posted by you or any other user of the Website."}]]],["p",{},[["strong",{},[["textNode",{"text":"Monitoring and Enforcement; Termination"}]]]]],["p",{},[["textNode",{"text":"The Company may:"}]]],["div",{"class":"marg-left"},[["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":"Remove or refuse to post any User Contributions for any or no reason in its sole discretion."}]]],["li",{},[["textNode",{"text":"Take any action with respect to any User Contribution that it considers necessary or appropriate in its sole discretion, including if it believes that that User Contribution violates this agreement, including the Content Standards, infringes any intellectual-property right or other right of any person or entity, threatens the personal safety of users of the Website or the public, or could create liability for the Company."}]]],["li",{},[["textNode",{"text":"Disclose your identity or other information about you to any third party who claims that material posted by you violates their rights, including their intellectual-property rights or their right to privacy."}]]],["li",{},[["textNode",{"text":"Take appropriate legal action, including referral to law enforcement, for any illegal or unauthorized use of the Website."}]]],["li",{},[["textNode",{"text":"Terminate or suspend your access to all or part of the Website for any reason, including any violation of this agreement."}]]]]]]],["p",{},[["textNode",{"text":"The Company will fully cooperate with any law enforcement authorities or court order requesting or directing it to disclose the identity or other information of anyone posting any materials on or through the Website. "}],["strong",{},[["textNode",{"text":"You waive and hold harmless the Company and its affiliates, licensees, and service providers from any claims resulting from any action taken by any of the foregoing parties during or as a result of its investigations and from any actions taken as a consequence of investigations by either those parties or law enforcement authorities."}]]]]],["p",{},[["textNode",{"text":"However, the Company cannot and does not undertake to review all material before it is posted on the Website and cannot ensure prompt removal of objectionable material after it has been posted. Accordingly, the Company assumes no liability for any action or inaction regarding transmissions, communications, or content provided by any user or third party. The Company has no liability or responsibility to anyone for performance or nonperformance of the activities described in this section."}]]],["p",{},[["strong",{},[["textNode",{"text":"Content Standards"}]]]]],["p",{},[["textNode",{"text":"These content standards apply to all User Contributions and use of Interactive Services. User Contributions must in their entirety comply with all applicable federal, state, local, and international laws and regulations. User Contributions must not:"}]]],["div",{"class":"marg-left"},[["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":"Contain any material which is defamatory, obscene, indecent, abusive, offensive, harassing, violent, hateful, inflammatory, or otherwise objectionable."}]]],["li",{},[["textNode",{"text":"Promote violence or discrimination based on race, sex, religion, nationality, disability, sexual orientation, or age."}]]],["li",{},[["textNode",{"text":"Depict or portray incest, rape or nonconsensual sex, extreme violence, torture, nonconsensual pain, blood, cutting, erotic asphyxiation, torture, necrophilia, sadomasochistic abuse or bondage, genital mutilation, bestiality, urination, defecation, enema play, vomiting, or menstrual bleeding."}]]],["li",{},[["textNode",{"text":"Promote child pornography or depict nudity or sexuality by an age-inappropriate-looking individual (i.e., someone who looks younger than 18-years old, regardless of their actual age, including an individual who is portrayed or otherwise made to appear as a person under 18-years old by virtue of the script, make-up, demeanor, costuming, settings, or props)."}]]],["li",{},[["textNode",{"text":"Promote involuntary or revenge pornography, including photographs, videos, or digital images of a person in a state of nudity or engaged in any act of sexual conduct, taken or posted without that person’s permission."}]]],["li",{},[["textNode",{"text":"Infringe any patent, trademark, trade secret, copyright, or other intellectual property or other rights of any other person."}]]],["li",{},[["textNode",{"text":"Violate the legal rights (including the rights of publicity and privacy) of others or contain any material that could give rise to any civil or criminal liability under applicable laws or regulations or that otherwise may be in conflict with this agreement and the "}],["a",{"href":"https://modelcentro.com/privacyPolicy","target":"_blank","rel":"nofollow"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":"."}]]],["li",{},[["textNode",{"text":"Be likely to deceive any person."}]]],["li",{},[["textNode",{"text":"Promote any illegal activity, or advocate, promote, or assist any unlawful act, including promoting, offering, or advertising prostitution or escort services."}]]],["li",{},[["textNode",{"text":"Cause annoyance, inconvenience, or needless anxiety or be likely to upset, embarrass, alarm, or annoy any other person."}]]],["li",{},[["textNode",{"text":"Impersonate any person; or misrepresent your identity or affiliation with any person or organization."}]]],["li",{},[["textNode",{"text":"Involve commercial activities or sales, such as contests, sweepstakes, and other sales promotions, barter, or advertising."}]]],["li",{},[["textNode",{"text":"Give the impression that they emanate from or are endorsed by the Company or any other person or entity, if this is not the case."}]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"Copyright Infringement"}]]]]],["p",{},[["textNode",{"text":"If you believe that any User Contributions violate your copyright, please see the "}],["a",{"href":"https://modelcentro.com/copyright-policy","target":"_blank"},[["textNode",{"text":"Copyright Policy"}]]],["textNode",{"text":" for instructions on sending the Company a notice of copyright infringement. It is the Company’s policy to terminate the user accounts of repeat infringers."}]]],["p",{},[["strong",{},[["textNode",{"text":"Reliance on Information Posted"}]]]]],["p",{},[["textNode",{"text":"The information presented on or through the Website is made available solely for general information purposes. The Company is not making any warranty about the accuracy, completeness, or usefulness of this information. Any reliance you place on that information is strictly at your own risk. The Company disclaims all liability and responsibility arising from any reliance placed on those materials by you or any other visitor to the Website, or by anyone who may be informed of any of its contents."}]]],["p",{},[["textNode",{"text":"This Website may include content provided by third parties, including materials provided by other users, bloggers, and third-party licensors, syndicators, aggregators, or reporting services. All statements or opinions expressed in these materials, and all articles and responses to questions and other content, other than the content provided by the Company, are solely the opinions and the responsibility of the person or entity providing those materials. These materials do not necessarily reflect the opinion of the Company. The Company is not responsible, or liable to you or any third party, for the content or accuracy of any materials provided by any third parties."}]]],["p",{},[["strong",{},[["textNode",{"text":"Changes to the Website"}]]]]],["p",{},[["textNode",{"text":"The Company may update the content on this Website on one or more occasions, but its content is not necessarily complete or up-to-date. Any of the material on the Website may be out of date at any given time, and the Company is not required to update that material."}]]],["p",{},[["strong",{},[["textNode",{"text":"Information About You and Your Visits to the Website"}]]]]],["p",{},[["textNode",{"text":"All information the Company collects on this Website is subject to its "}],["a",{"href":"https://modelcentro.com/privacyPolicy","target":"_blank","rel":"nofollow"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":". By using the Website, you consent to all actions taken by the Company with respect to your information in compliance with the Privacy Policy."}]]],["p",{},[["strong",{},[["textNode",{"text":"Other Terms and Conditions"}]]]]],["p",{},[["textNode",{"text":"Additional terms and conditions may also apply to specific portions, services, or features of the Website, including the "}],["a",{"href":"https://modelcentro.com/operator-agreement","target":"_blank"},[["textNode",{"text":"ModelCentro Operator Agreement"}]]],["textNode",{"text":". Any additional terms and conditions are incorporated by this reference into this agreement."}]]],["p",{},[["strong",{},[["textNode",{"text":"Linking to the Website"}]]]]],["p",{},[["textNode",{"text":"You may link to the Website’s homepage, on condition that you do so in a way that is fair and legal and does not damage the Company’s reputation or take advantage of it, but you must not establish a link in a way that suggests any form of association, approval, or endorsement on the Company’s part without the Company’s express written consent."}]]],["p",{},[["strong",{},[["textNode",{"text":"Links from the Website"}]]]]],["p",{},[["textNode",{"text":"If the Website contains links to other websites and resources provided by third parties, these links are provided for your convenience only. This includes links contained in advertisements, including banner advertisements and sponsored links. The Company has no control over the contents of those websites or resources and accept no responsibility for them or for any loss or damage that may arise from your use of them. If you decide to access any of the third-party websites linked to this Website, you do so entirely at your own risk and subject to the terms and conditions of use for those websites."}]]],["p",{},[["strong",{},[["textNode",{"text":"Geographic Restrictions"}]]]]],["p",{},[["textNode",{"text":"The owner of the Website is based in the British Virgin Islands. The Company makes no claims that the Website or any of its content is accessible or appropriate outside the British Virgin Islands. Access to the Website may not be legal by certain persons or in certain countries. If you access the Website from outside the British Virgin Islands, you do so on your own initiative and are responsible for compliance with local laws."}]]],["p",{},[["strong",{},[["textNode",{"text":"Disclaimer of Warranties"}]]]]],["p",{},[["textNode",{"text":"You understand that the Company cannot and does not guarantee or warrant that files available for downloading from the Internet or the Website will be free of viruses or other destructive code. You are responsible for implementing sufficient procedures and checkpoints to satisfy your particular requirements for anti-virus protection and accuracy of data input and output, and for maintaining a means external to the Website for any reconstruction of any lost data. To the greatest extent provided by law, the Company will not be liable for any loss or damage caused by a distributed denial-of-service attack, viruses, or other technologically harmful material that may infect your computer equipment, computer programs, data, or other proprietary material due to your use of the Website or any services or items obtained through the Website or to your downloading of any material posted on it, or on any website linked to it."}]]],["p",{},[["textNode",{"text":"Your use of the Website, its content, and any services or items obtained through the Website is at your own risk. The Website, its content, and any services or items obtained through the Website are provided “as is” and “as available,” without any warranties of any kind, either express or implied. Neither the Company nor any person associated with the Company is making any warranty or representation with respect to the completeness, security, reliability, quality, accuracy, or availability of the Website. Neither the Company nor anyone associated with the Company represents or warrants that the Website, its content, or any services or items obtained through the Website will be accurate, reliable, error-free, or uninterrupted, that defects will be corrected, that the Website or the server that makes it available are free of viruses or other harmful components, or that the Website or any services or items obtained through the Website will otherwise meet your needs or expectations."}]]],["p",{},[["textNode",{"text":"To the greatest extent provided by law, the Company hereby disclaims all warranties of any kind, whether express or implied, statutory, or otherwise, including but not limited to any warranties of merchantability, noninfringement, and fitness for particular purpose."}]]],["p",{},[["textNode",{"text":"The foregoing does not affect any warranties that cannot be excluded or limited under applicable law."}]]],["p",{},[["strong",{},[["textNode",{"text":"Limitation on Liability"}]]]]],["p",{},[["textNode",{"text":"To the greatest extent provided by law, in no event will the Company, its affiliates, or their licensors, service providers, employees, agents, officers, or directors be liable for damages of any kind, under any legal theory, arising out of or in connection with your use, or inability to use, the Website, any websites linked to it, any content on the Website or those other websites or any services or items obtained through the Website or those other websites, including any direct, indirect, special, incidental, consequential, or punitive damages, including personal injury, pain and suffering, emotional distress, loss of revenue, loss of profits, loss of business or anticipated savings, loss of use, loss of goodwill, loss of data, and whether caused by tort (including negligence), breach of contract, or otherwise, even if foreseeable."}]]],["p",{},[["textNode",{"text":"The foregoing does not affect any liability that cannot be excluded or limited under applicable law."}]]],["p",{},[["strong",{},[["textNode",{"text":"Indemnification"}]]]]],["p",{},[["textNode",{"text":"You will defend, indemnify, and hold harmless the Company, its affiliates, licensors, and service providers, and its and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors, and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys’ fees) arising out of or relating to your violation of this agreement or your use of the Website, including your User Contributions, any use of the Website’s content, services, and products other than as expressly authorized in this agreement or your use of any information obtained from the Website."}]]],["p",{},[["strong",{},[["textNode",{"text":"Governing Law and Jurisdiction"}]]]]],["p",{},[["textNode",{"text":"British Virgin Island law governs all matters relating to the Website and this agreement and any dispute or claim arising from or related to it (in each case, including non-contractual disputes or claims) without giving effect to any choice or conflict of law provision or rule (whether of the British Virgin Islands or any other jurisdiction)."}]]],["p",{},[["textNode",{"text":"Any legal suit, action, or proceeding arising out of, or related to, this agreement or the Website not subject to arbitration will be instituted exclusively in the courts of the British Virgin Islands, although the Company may bring any suit, action, or proceeding against you for breach of this agreement in your country of residence or any other relevant country. You waive all objections to the exercise of jurisdiction over you by those courts and to venue in those courts."}]]],["p",{},[["strong",{},[["textNode",{"text":"Arbitration"}]]]]],["p",{},[["textNode",{"text":"At the Company’s sole discretion, it may require you to submit any disputes arising from this agreement or the use of the Website, including disputes arising from or concerning the interpretation, violation, invalidity, nonperformance, or termination of this agreement, to final and binding arbitration by the British Virgin Islands International Arbitration Centre in accordance with the British Virgin Islands Arbitration Act of 2013 and any rules promulgated under it."}]]],["p",{},[["strong",{},[["textNode",{"text":"Class Action Waiver"}]]]]],["p",{},[["strong",{},[["textNode",{"text":"All claims arising out of or relating to this agreement or the Website must be brought in the parties’ individual capacity, and not as a plaintiff or class member in any purported class or representative proceeding, and, unless the Company agrees otherwise, the arbitrator must not consolidate more than one person’s claims."}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Limitation on Time to File Claims"}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Any cause of action or claim you may have arising out of or relating to this agreement or the Website must be commenced within one year after the cause of action accrues, otherwise, that cause of action or claim is permanently barred."}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Waiver and Severability"}]]]]],["p",{},[["textNode",{"text":"No waiver by the Company of any term stated in this agreement will be deemed a further or continuing waiver of that term or a waiver of any other term, and any failure of the Company to assert a right or provision under this agreement will not constitute a waiver of that right or provision."}]]],["p",{},[["textNode",{"text":"If any provision of this agreement is held by a court or other tribunal of competent jurisdiction to be invalid, illegal, or unenforceable for any reason, that provision will be eliminated or limited to the minimum extent so that the remaining provisions of this agreement will continue in full effect."}]]],["p",{},[["strong",{},[["textNode",{"text":"Entire Agreement"}]]]]],["p",{},[["textNode",{"text":"This agreement, the "}],["a",{"href":"https://modelcentro.com/privacyPolicy","target":"_blank","rel":"nofollow"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":", and the "}],["a",{"href":"https://modelcentro.com/operator-agreement","rel":"nofollow","target":"_blank"},[["textNode",{"text":"ModelCentro Operator Agreement"}]]],["textNode",{"text":" constitute the entire agreement between you and the Company regarding the Website and supersede all earlier and contemporaneous understandings, agreements, representations, and warranties, both written and oral, regarding the Website."}]]],["p",{},[["strong",{},[["textNode",{"text":"Feedback"}]]]]],["p",{},[["textNode",{"text":"The Company encourages you to give feedback about the Company or the Website. But the Company will not treat as confidential any suggestion or idea you give, and nothing in this agreement will restrict the Company’s right to use, profit from, disclose, publish, or otherwise exploit any feedback, without payment to you."}]]],["p",{},[["strong",{},[["textNode",{"text":"Your Comments and Concerns"}]]]]],["p",{},[["textNode",{"text":"This Website is operated by Centro Publisher Limited, P.O. Box 3444, Road Town, Tortola VG1110, British Virgin Islands. All feedback, comments, requests for technical support, and other communications relating to the Website should be directed to: "}],["a",{"data-name":"sales","data-domain":"modelcentro","data-tld":"com","class":"crypmail","onclick":"window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld","draggable":"true"}],["textNode",{"text":"."}]]]]],["div",{"class":"col sp-right"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("lambo_terms", [["div",{"class":"layout-width single-page"},[["h2",{"class":"sp-title"},[["span",{},[["textNode",{"text":"Win a Lambo Contest Terms and Conditions"}]]]]],["div",{"class":"sp-main-content-wrapp"},[["div",{"class":"col sp-left"},[["p",{},[["textNode",{"text":"1. CONTEST ENTRY PERIOD: The Contest begins at 4.44pm EST April 4th, 2019 - and concludes at 11:59pm EST on October 10th, 2019 (\"Contest Entry Period\")."}]]],["p",{},[["strong",{},[["textNode",{"text":"Contest is open to FanCentro influencers, affiliates, and users"}]]]]],["p",{},[["textNode",{"text":"2. PRIZE: A Lamborghini Urus"}]]],["p",{},[["textNode",{"text":"3. TO ENTER: Participants must, during the Contest Entry Period: "}],["ul",{"class":"dotted-list marg-left"},[["li",{},[["textNode",{"text":"Accrue gold raffle tickets through affiliate sales on FanCentro. For each $69 earned by influencers through affiliate links, the affiliate will receive one (1) gold ticket."}]]],["li",{},[["textNode",{"text":"There is no limit on the number of raffle tickets accrued. The more tickets you earn, the more chances to win."}]]]]]]],["p",{},[["textNode",{"text":"Winners will be announced October 12, 2019. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Additional rules for entry:"}]]]]],["p",{},[["textNode",{"text":"Winners MUST contact FanCentro to claim their prize. If the winner does not contact us, their prize will be forfeited."}]]],["p",{},[["textNode",{"text":"4. ENTRY REQUIREMENTS. By submitting an Entry in the Contest, you hereby warrant and represent that your entry conforms to the requirements set forth herein. Entries must be in English. Entries must meet the following requirements: Entry cannot be unnecessarily violent or derogatory of any ethnic, racial, gender, religious, professional or age group or profane; Entry cannot promote alcohol, illegal drugs, tobacco, firearms/weapons (or the use of any of the foregoing), any activities that may appear unsafe or dangerous, or any particular political agenda or message; Entry cannot be obscene or offensive, endorse any form of hate or hate group; Entry cannot defame, misrepresent or contain disparaging remarks about Sponsor or its products, or other people, products or companies; Entry cannot contain trademarks, logos or trade dress owned by others or advertise or promote any brand or product of any kind, without permission, or contain any personal identification, such as license plate numbers, personal names, e-mail addresses or street addresses; Entry cannot contain copyrighted materials owned by others (including photographs, sculptures, paintings and other works of art or images published on or in websites, television, movies or other media or musical \"samples\") without permission; and Entry cannot depict, and cannot itself, be in violation of any law. BY SUBMITTING AN ENTRY, ENTRANT ACKNOWLEDGES THAT HIS/HER ENTRY MAY BE POSTED ON SPONSOR’S WEBSITE, IN SPONSOR’S DISCRETION. Sponsor reserves the right to, and may or may not, monitor/screen entries prior to posting them to the Website. By entering, you acknowledge that Sponsor has no obligation to use or post any Entry you submit. Submission of an Entry grants Sponsor and its agents an unlimited, worldwide, perpetual, license and right to publish, use, publicly perform the Entry in any way, in any and all media, without limitation, and without consideration to the entrant. ENTRIES ARE THE VIEWS/OPINIONS OF THE INDIVIDUAL ENTRANT AND DO NOT REFLECT THE VIEWS OF SPONSOR IN ANY MANNER. Any waiver of any obligation hereunder by Sponsor does not constitute a general waiver of any obligation to entrants."}]]],["p",{},[["textNode",{"text":"5. PRIZE DETAILS: The contest winner will receive a Lamborghini Urus or a cash prize of a similar value. There will be one winner chosen via live raffle drawing the day after the close of the contest. Winner must contact Fancentro within 24 hours of winning to claim their prize. Winner must accept prize as specified by Sponsor and on dates designated by Sponsor, or prize will be forfeited. Prize cannot be assigned, transferred, or substituted except by Sponsor who may, at its sole discretion, substitute any prize with one of comparable value if the advertised prize becomes unavailable for any reason."}]]],["p",{},[["textNode",{"text":"6. CONDITIONS OF PARTICIPATION: Participants agree (a) to these Official Rules and the decisions of Sponsor which are final and binding, (b) that Sponsor, its parent, subsidiary and affiliated companies, advertising and promotion agencies, and all of their officers, directors, employees, representatives and agents will have no liability whatsoever for, are released and shall be held harmless by participants against any liability for any injuries, losses or damages of any kind to persons, including death, or property resulting in whole or in part, directly or indirectly, from acceptance, possession, misuse or use of any prize or participation in this Contest or Contest-related activities and (c) except where legally prohibited, winner grants (and agrees to confirm that grant in writing) permission to Sponsor and those acting under Sponsor’s authority the right to the use of his/her scenic name, photograph, likeness, voice, image and statements and the Entry for advertising, trade, publicity and promotional purposes without additional compensation, in all media now known or hereafter discovered, worldwide and on the Internet and World Wide Web, without notice, review or approval."}]]],["p",{},[["textNode",{"text":"7. GENERAL PROVISIONS: Neither Sponsor nor its agencies are responsible for not receiving entries, no matter what the reason even if known in advance, or other errors of any kind whether human, mechanical, electronic or network or the incorrect or inaccurate capture of entry or the failure to capture any such information. Persons who tamper with any aspect of the Contest, as solely determined by the Sponsor, or who attempt to participate with multiple email addresses or under multiple identities will be disqualified. Any use of robotic, automatic, macro, programmed or like entry methods will void all such entries and disqualify any entrant using such methods. Should any portion of the Contest be, in Sponsor’s sole opinion, compromised by virus, worms, bugs, non-authorized human intervention, technical failures or other causes which, in the sole opinion of the Sponsor, corrupt or impair the administration, security, fairness or proper play, or submission of entries, Sponsor reserves the right at its sole discretion to suspend, modify or terminate the Contest. In case of dispute, the authorized subscriber of the email account used to enter the Contest at the actual time of entry will be deemed to be the participant, and must comply with these Official Rules."}]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(76);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_style.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_style.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".mc-layout-footer,.mc-layout-header .header-content,.page-wrapper{max-width:1200px}.mc-layout-header .header-content,.page-wrapper{width:auto}.page-wrapper .mc-page-container{max-width:100%}.mc-layout-header .header-content{margin-left:20px;margin-right:20px}.two-cols .lt-col{width:calc(100% - 200px);min-width:440px}.two-cols .service-block{padding:30px 0 0 30px}.native-scrollbar .fixed-sidebar.slide{top:95px!important}.clearfix:after{content:\"\";display:table;height:0;visibility:hidden;clear:both}.empty-dashboard{display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center;padding-top:40px}.affiliates-block .rt-col{border-bottom:none!important}.affiliates-block .amc-styled-table td{padding-right:5px}.aff-programs-block .content-pager{margin-top:20px}.aff-programs-body .model-avatar{border-radius:50%;overflow:hidden;display:inline-block;vertical-align:middle;width:30px;height:30px;margin-right:5px}.aff-programs-body .model-avatar img{max-width:100%;height:100%}.logo-wrapper .birthday+.affiliate-indication-container .launch-my-site{margin-left:196px}.title-with-button{margin-bottom:20px}.title-with-button,.title-with-button *,.title-with-button:after,.title-with-button:before{-ms-box-sizing:border-box;box-sizing:border-box}.title-with-button .mc-form-field-wrapper .field-icon,.title-with-button .mc-form-field-wrapper .mc-form-field{top:2px}.title-with-button .date-picker-wrapper,.title-with-button .date-picker-wrapper *,.title-with-button .date-picker-wrapper:after,.title-with-button .date-picker-wrapper:before{-ms-box-sizing:content-box;box-sizing:content-box}.title-with-button .date-picker-wrapper .mc-btn,.title-with-button .date-picker-wrapper .mc-btn *,.title-with-button .date-picker-wrapper .mc-btn:after,.title-with-button .date-picker-wrapper .mc-btn:before{-ms-box-sizing:border-box;box-sizing:border-box}.title-with-button .date-picker-wrapper .gui-c-select{height:16px;padding-top:7px;padding-bottom:7px}.title-with-button .date-picker-wrapper.new-select .mc-form-field,.title-with-button .date-picker-wrapper.new-select .mc-form-field *,.title-with-button .date-picker-wrapper.new-select .mc-form-field:after,.title-with-button .date-picker-wrapper.new-select .mc-form-field:before{-ms-box-sizing:border-box;box-sizing:border-box}.title-with-button .date-picker-wrapper.new-select .datepicker-header{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.title-with-button .date-picker-wrapper.new-select .datepicker-header .mc-form-field{min-width:120px}.title-with-button .period-selector{margin-left:20px;margin-top:0;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center}.title-with-button .period-selector .date-container{padding-right:0}.title-with-button .period-selector .date-container:after{display:none}.title-with-button .group-view{margin-left:20px;margin-top:12px}.title-with-button .group-view .current-value{line-height:22px}.title-with-button .group-view.block{display:block}.title-with-button .gui-c-select,.title-with-button .mc-form-field{height:40px;padding-top:10px;padding-bottom:10px}.title-with-button .gui-c-select .current-value,.title-with-button .gui-c-select .select-value,.title-with-button .mc-form-field .current-value,.title-with-button .mc-form-field .select-value{line-height:18px}.title-with-button .gui-c-select .current-value,.title-with-button .mc-form-field .current-value{top:11px}.title-with-button .item{margin-left:15px}.aff-programs-block .gui-mc-datatable,.aff-programs-block .gui-mc-datatable *,.aff-programs-block .gui-mc-datatable:after,.aff-programs-block .gui-mc-datatable:before{-ms-box-sizing:border-box;box-sizing:border-box}.aff-programs-block .gui-mc-datatable tr td{max-width:none;padding:15px 12px}.aff-programs-block .aff-programs-body td:first-child{white-space:nowrap}.aff-edit-form-container .general-properties .value-block{margin-left:170px}.basic-properties .property-item{padding:12px 0;cursor:defoult}.basic-properties .property-item .value-block{margin-left:240px}.property-item .mp-prop-hint{line-height:20px}.property-item .label{width:240px;line-height:20px}.property-item .label strong{position:relative;padding-left:30px}.property-item .label strong:before{content:\"\";position:absolute;left:0;top:-4px;width:23px;height:23px;display:block}.property-item .label.statsremote strong:before{background:url(" + __webpack_require__(77) + ") no-repeat}.property-item .label.nifty strong:before{background:url(" + __webpack_require__(78) + ") no-repeat}.basic-properties.content-properties .value-block{margin-left:145px}.gui-c-select.dropdown.mc-form-field select{display:block}.ui-dialog.dlg-amc .ui-dialog-titlebar-close{background-position:-52px 0}.ui-dialog .link-generation-form{max-width:310px}.ui-dialog .link-generation-form .code-wrapper{min-width:310px;max-width:100%}.ui-dialog .link-generation-form .campaigns-list-row .gui-c-select.dropdown{max-width:173px}.ui-dialog .link-generation-form .campaigns-list-row .sep{line-height:31px}.ui-dialog .link-generation-form .campaigns-list-row .select-value.long-title{margin-right:0;padding-right:30px;max-width:117px}.ui-dialog .link-generation-form .default-render{left:6px}.ui-dialog.dlg-amc .ui-dialog-titlebar-close{font-family:mc-icons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:none;color:#fff}.ui-dialog.dlg-amc .ui-dialog-titlebar-close:after{content:\"\\E72D\"}.banner.thumb .release-date,.overlay .data .release-date{display:none}@media (min-width:1200px){.mc-layout-header .header-content,.page-wrapper{margin-left:auto;margin-right:auto}}.sp-main-content-wrapp .dotted-list li{list-style:inherit;list-style-type:disc;padding:5px 0}.sp-main-content-wrapp .hashtag{color:#3b5998 c}.sp-main-content-wrapp p{line-height:24px;margin:20px 0;position:relative}.marg-left{position:relative;margin-left:40px!important}", ""]);

// exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/area/affiliate/global/member/images/StatsRemote.png", __webpack_require__.p + "_/_/global/member/images/StatsRemote.png");

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/area/affiliate/global/member/images/NiftyStats.png", __webpack_require__.p + "_/_/global/member/images/NiftyStats.png");

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";

	fox.registerWidget('Unsubscribe', {

		configure: function(options) {
			this.registerOptions('', {
				'!autoRender': false,
				template: 'unsubscribe_form',
				newSelect: true,
				widgets: {
					weeklyUpdatesSelect: {
						widget: 'Control_Select',
						container: '.weekly-updates',
						template: 'control_select_new',
						currentValuePlace :'.current-value',
						select: {
							container: '.mc-form-field',
							options: [
								{title: 'Send me updates only for models i subscribe', value: 1},
								{title: 'Send me all models updates', value: 2}
							]
						}
					},
					getSettingsApi: {
						widget: 'Api',
						method: 'Site.getAvailiableInteractionFeatures'
					},
					setSettingsApi: {
						widget: 'Api',
						method: 'Site.getAvailiableInteractionFeatures'
					}
				},
				handleDom: {
					form: {
						target: 'form',
						event: 'submit',
						callback: '_submit'	
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function (argument) {
			var hash = fox.Navigator.get(1);

			this.getSettings(hash);
			this.callParent('running', arguments);
		},

		getSettings: function(hash) {
			this.wom1('#getSettingsApi')
				.psend({hash: hash})
				.then(function(e, params, performer) {
					this.setData({
						weekly: 1,
						newModel: 1
					});
					this.render();
				}.bind(this))
				.catch(function() {

				}.bind(this));
		},

		setSettings: function() {
			var data = {
				hash: fox.Navigator.get(1),
				weekly: this.wom1('#weeklyUpdatesSelect').getValue(),
				newModel: this.dom1('[name="new_model"]').checked
			};

			this.wom1('#getSettingsApi')
				.psend({data: data})
				.then(this.handleUpdateSuccess.bind(this))
				.catch(function() {

				}.bind(this));
		},

		setData: function(data) {
			this.wom1('#weeklyUpdatesSelect').setValue(data.weekly);

			this.setTemplateOptions({newModel: data.newModel});
			this.render();
		},

		_submit: function(el, w, alias, e) {
			e.preventDefault();

			this.setSettings();

			return false;
		},

		handleUpdateSuccess: function() {
			console.log('SUCCESS!!!');
		}

	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
    'use strict';

    __webpack_require__(81);
    __webpack_require__(21);
    __webpack_require__(83)(fox);

    var _script = {
        generate: function generate(mode, slider) {
            var modeString = 'mode: \'' + mode + '\', // available values: \'centrobill\' or \'prejoin\',';
            var type = 'tour';

            if (mode === 'own-billing') {
                modeString = 'serverEndpoint: \'fake\',';
                type = 'member';
            }

            return '<script>\n    (function (w, d, t, u, a, m) {\n    a = d.createElement(t);\n    m = d.getElementsByTagName(t)[0];\n    a.async = 1;\n    a.onload = function () {\n        w.UMModels.init({\n        container: \'#root\', // css selector or dom node\n        apiKey: \'p4mt94k3hqabv38d9cks93h8902djsiw\', // affiliate api key\n        ' + modeString + '\n        showHeaderSlides: ' + slider + ' // show header slider, default value: true\n        });\n    }\n    a.src = u;\n    m.parentNode.insertBefore(a, m);\n    })(window, document, \'script\', \'https://ec-st.centrofiles.com/mcst/ummodels/0.2.1/js/ummodels.' + type + '.js\');\n</script>';
        }
    };

    var VERSION = '0.2.6';

    fox.registerWidget('Promo_Iframe', {
        configure: function configure() {
            this.registerOptions('', {
                autoRender: true,
                template: 'promo_iframe_settings',
                container: '.iframe-preview-wrapper',
                handleDom: {
                    change: {
                        target: 'input[type="checkbox"], input[type="radio"]',
                        event: 'change',
                        callback: '_change'
                    },
                    paste: {
                        target: '.paste',
                        callback: 'paste'
                    }
                }
            });

            this.callParent('configure', arguments);
        },

        init: function init() {
            this.callParent('init', arguments);
        },

        running: function running() {
            this.start();

            this.bindTemplateVariables(this._bindData, ['script', 'previewUrl']);
        },

        activate: function activate() {
            this.start();

            this.callParent('activate', arguments);
        },

        start: function start() {
            this._scriptParams = { mode: 'centrobill', slider: true };
            this.buildScript();

            this._bindData = {
                script: this._script,
                previewUrl: this.generatePreviewUrl(true)
            };

            this.bindTemplateVariables(this._bindData, ['script', 'previewUrl']);
        },

        addedToDom: function addedToDom() {
            this.clipboard = new ClipboardJS('.copy-to-cp', {
                text: function (trigger) {
                    return this._script;
                }.bind(this)
            });

            this.clipboard.on('success', function (e) {
                this.switchState('copied');
                //e.clearSelection();
            }.bind(this));

            this.pasteBlock = this.dom1('#paste-block');
            this.pasteBlock.value = this._script;

            $(this.element).tooltip({
                position: { my: 'left-20% bottom-30', at: 'left bottom', collision: 'flipfit' },
                tooltipClass: 'gui-tooltip-type-1 bottom',
                items: '.mc-radiobutton.row',
                content: function content() {
                    return $(this).find('.tt-content').html();
                }
            });
        },

        _change: function _change(elm) {
            var name = elm.name;
            var val = elm.value;

            if (name === 'slider') {
                val = elm.checked;
            }

            this._scriptParams[name] = val;
            this.buildScript();
            this._bindData.script = this._script;

            this.switchState();
        },

        buildScript: function buildScript() {
            this._script = this.getScript(this._scriptParams.mode, this._scriptParams.slider);
        },

        getScript: function getScript(mode, slider) {
            return _script.generate(mode, slider);
        },

        paste: function paste() {
            this.pasteBlock.value = this.clipboard.text();

            this.showPreview();
            this.switchState('paste');
        },

        switchState: function switchState(state) {
            var srcBlock = this.dom1('.copy-to-cp');
            var targetBlock = this.dom1('.paste');

            if (state === 'copied') {
                fox.dom.addClass('btn-major', srcBlock);

                srcBlock.innerHTML = 'COPIED';

                fox.dom.addClass('btn-primary', targetBlock);
                fox.dom.removeClass('btn-grey', targetBlock);
                fox.dom.removeClass('btn-major', targetBlock);

                return;
            }

            if (state === 'paste') {
                fox.dom.addClass('btn-major', targetBlock);
                fox.dom.removeClass('btn-grey', targetBlock);

                return;
            }

            srcBlock.innerHTML = 'COPY';
            fox.dom.removeClass('btn-major', srcBlock);

            fox.dom.removeClass('btn-primary', targetBlock);
            fox.dom.removeClass('btn-major', targetBlock);
            fox.dom.addClass('btn-grey', targetBlock);
        },

        generatePreviewUrl: function generatePreviewUrl(empty) {
            var params = function () {
                var str = 'mode=' + this._scriptParams.mode + '&slider=' + Number(this._scriptParams.slider) + '&version=' + VERSION;

                if (empty === true) {
                    str = '';
                }

                return str;
            }.bind(this)();
            return 'https://ec-st.centrofiles.com/mcst/mcp-iframe/i3.html?' + params + '#/';
        },

        showPreview: function showPreview() {
            this._bindData.previewUrl = this.generatePreviewUrl();
        }
    });
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(82);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_index.styl", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_index.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".promo-iframe-wrapper{max-width:1090px;margin:0 auto;padding:130px 6% 30px}.promo-iframe-wrapper a{color:#748ed7}.promo-iframe-wrapper .ws-nowrap{white-space:nowrap}.promo-iframe-wrapper .bdr{border:1px solid #e7e7e7;border-radius:2px}.promo-iframe-wrapper h1{line-height:28px;font-size:28px;margin-bottom:35px;text-align:center}.promo-iframe-wrapper h1 img{vertical-align:middle}.promo-iframe-wrapper .how-to-img .p2,.promo-iframe-wrapper h1{line-height:28px;font-size:28px}.promo-iframe-wrapper .how-to-img{margin-bottom:30px;text-align:center}.promo-iframe-wrapper .how-to-img .p1{font-size:20px;margin-bottom:20px}.promo-iframe-wrapper .how-to-img .comix{margin:0 auto 30px}.promo-iframe-wrapper .how-to-img .comix img{display:block;margin:0 auto}.promo-iframe-wrapper .how-to-img .comix .small{display:block}.promo-iframe-wrapper .how-to-img .comix .large{display:none}.promo-iframe-wrapper .how-to-img .p2{margin-bottom:20px}.promo-iframe-wrapper .how-to-img .p3{font-size:16px;line-height:24px}.promo-iframe-wrapper .iframe-preview{margin-bottom:30px;display:-ms-flexbox;display:flex;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-flow:row;flex-flow:row;-ms-flex-line-pack:stretch;align-content:stretch;-ms-flex-flow:column;flex-flow:column}.promo-iframe-wrapper .iframe-preview .block{width:100%;margin-bottom:30px}.promo-iframe-wrapper .iframe-preview .block .title{font-size:20px;line-height:40px;padding:17px 30px;border-bottom:1px solid #e7e7e7}.promo-iframe-wrapper .iframe-preview .block .title a{text-transform:uppercase;text-decoration:none;color:#748ed7;font-size:15px}.promo-iframe-wrapper .iframe-preview .block .inner{padding:30px}.promo-iframe-wrapper .iframe-preview .block .inner.p-0{padding:0}.promo-iframe-wrapper .iframe-preview .block .settings-form .code{padding:10px 15px;margin-bottom:10px;font-size:14px;line-height:20px;max-height:130px;overflow:auto}.promo-iframe-wrapper .iframe-preview .block .settings-form .code pre{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=60)\";filter:alpha(opacity=60);opacity:.6}.promo-iframe-wrapper .iframe-preview .block .settings-form .copy-to-cp{margin-bottom:20px}.promo-iframe-wrapper .iframe-preview .block .settings-form .type-title{font-size:16px;margin-bottom:20px;border:none;margin-top:20px}.promo-iframe-wrapper .iframe-preview .block .settings-form .rows .row{margin-bottom:20px;display:block}.promo-iframe-wrapper .iframe-preview .block .settings-form .rows .row:last-child{margin-bottom:0}.promo-iframe-wrapper .iframe-preview .block .settings-form .rows .row .gui-tooltip-link{display:inline-block;margin-left:2px;top:-7px}.promo-iframe-wrapper .iframe-preview .block .settings-form .mc-radiobutton{overflow:inherit}.promo-iframe-wrapper .iframe-preview .block .settings-form .mc-radiobutton .label,.promo-iframe-wrapper .iframe-preview .block .settings-form .mc-radiobutton .radio-btn-wrap{display:inline-block;vertical-align:middle;line-height:17px}.promo-iframe-wrapper .iframe-preview .block .settings-form .mc-radiobutton .radio-btn-wrap{margin-right:5px}.promo-iframe-wrapper .iframe-preview .block .settings-form.code-form{position:relative}.promo-iframe-wrapper .iframe-preview .block .settings-form.code-form .overlay{position:absolute;left:0;right:0;bottom:0;top:0;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:column;flex-flow:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}.promo-iframe-wrapper .iframe-preview .block .settings-form.code-form .overlay .btn{width:170px;margin:0 auto}.promo-iframe-wrapper .iframe-preview .block .settings-form.code-form .code{height:450px;margin-bottom:0;max-height:none;width:100%;resize:none;background-color:#f2f2f2;color:#d3d3d3}.promo-iframe-wrapper .iframe-preview .block .preview-block{height:508px;overflow:hidden}.promo-iframe-wrapper .iframe-preview .block:last-child{margin-bottom:0}.promo-iframe-wrapper .action{text-align:center}.promo-iframe-wrapper .action .btn{margin-bottom:25px}.promo-iframe-wrapper .action p a{color:#748ed7}@media (min-width:1024px){.promo-iframe-wrapper{padding-top:110px}.promo-iframe-wrapper .how-to-img .comix .large{display:block}.promo-iframe-wrapper .how-to-img .comix .small{display:none}.promo-iframe-wrapper .iframe-preview{-ms-flex-flow:row nowrap;flex-flow:row nowrap;margin-bottom:60px}.promo-iframe-wrapper .iframe-preview .block{max-width:31.5%;height:585px;margin-bottom:0}}@media (min-width:1150px){.promo-iframe-wrapper{padding-top:150px}}", ""]);

// exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_iframe_base", [["div",{"class":"contest-page-wrapper"},[["div",{"class":"promo-iframe-wrapper"},[["h1",{},[["textNode",{"text":"Promote all sites "}],["span",{"class":"ws-nowrap"},[["span",{},[["img",{"src":"" + __webpack_require__(84) + ""}]]],["textNode",{"text":" by ModelCentro"}]]],["textNode",{"text":" with the new iframe!"}]]],["div",{"class":"how-to-img"},[["p",{"class":"p1"},[["textNode",{"text":"How to become an affiliate:"}]]],["div",{"class":"comix"},[["img",{"src":"" + __webpack_require__(85) + "","class":"small"}],["img",{"src":"" + __webpack_require__(21) + "","class":"large"}]]],["p",{"class":"p2 tt-u"},[["textNode",{"text":"or"}]]],["p",{"class":"p3"},[["textNode",{"text":" Copy-paste our code in your site and start monetizing your traffic…"}],["br"],["textNode",{"text":" You can either use your own billing solution or keep the billing on us on our side and not worry about a thing."}],["br"],["textNode",{"text":" The new iframe will automatically update itself every time a new models is added to the program. "}]]]]],["div",{"class":"iframe-preview-wrapper"}],["div",{"class":"action"},[["div",{},[["a",{"href":"mailto:affiliates@mcprofits.com?subject=MCP Iframe request","class":"btn btn-mcolor btn-big"},[["textNode",{"text":"Request yours HERE"}]]]]],["p",{},[["textNode",{"text":" Check out integration guide in our "}],["a",{"href":"/faq"},[["textNode",{"text":"FAQ"}]]],["textNode",{"text":" section. "}]]]]]]]]]]);
fox.registerTemplate("promo_iframe_settings", [["div",{"class":"iframe-preview"},[["div",{"class":"block bdr"},[["div",{"class":"title"},[["textNode",{"text":"Take this code"}]]],["div",{"class":"inner"},[["div",{"class":"settings-form"},[["div",{"class":"code bdr"},[["pre",{},[["span",{},[],[["script","__text",true,[],"bind"]]]]]]],["a",{"class":"btn btn-primary copy-to-cp ds-block w-100p"},[["textNode",{"text":"COPY"}]]],["div",{"class":"slider-control"},[["label",{"class":"checkbox"},[["input",{"type":"checkbox","name":"slider","checked":""}],["i",{"class":"bdr"}],["textNode",{"text":" Enable slider-control "}]]]]],["div",{"class":"iframe-type rows"},[["p",{"class":"type-title"},[["textNode",{"text":"Choose one:"}]]],["label",{"for":"type","class":"mc-radiobutton row"},[["input",{"type":"radio","name":"mode","value":"prejoin","class":"field-input"}],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["span",{"class":"label"},[["textNode",{"text":"Model’s site redirect"}]]],["div",{"class":"gui-tooltip-link"},[["div",{"class":"tt-link"}],["div",{"class":"tt-content"},[["span",{"class":"tt-arrow"}],["p",{"class":"tt-body"},[["textNode",{"text":" This iFrame will redirect users to a performer’s website once they click the Join Now button. This option is ideal for popunders and sites that serve as a layer between different projects. "}]]]]]]]]],["label",{"for":"type","class":"mc-radiobutton row"},[["input",{"type":"radio","name":"mode","value":"centrobill","checked":"","class":"field-input"}],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["span",{"class":"label"},[["textNode",{"text":"Self-billing"}]]],["div",{"class":"gui-tooltip-link"},[["div",{"class":"tt-link"}],["div",{"class":"tt-content"},[["span",{"class":"tt-arrow"}],["p",{"class":"tt-body"},[["textNode",{"text":" This iFrame will offer users to pay directly inside the iFrame via Centrobill biller. Once the transaction is complete, the user will be redirected to performer’s website and automatically logged in. This is perfect for the site that doesn't want to extend purchase funnel but also doesn't want to spend resources integrating their own billing. "}]]]]]]]]],["label",{"for":"type","class":"mc-radiobutton row"},[["input",{"type":"radio","name":"mode","value":"own-billing","class":"field-input"}],["div",{"class":"radio-btn-wrap"},[["span",{"class":"radio-btn-dot"}]]],["span",{"class":"label"},[["textNode",{"text":"My own billing"}]]],["div",{"class":"gui-tooltip-link"},[["div",{"class":"tt-link"}],["div",{"class":"tt-content"},[["span",{"class":"tt-arrow"}],["p",{"class":"tt-body"},[["textNode",{"text":" This iFrame allows you to integrate your own billing (and one-click options) in order to bill your members immediately. Ideal for large projects oriented on one-clicks and cross-sales. NOTE: Selecting this option here won’t affect demo visual as you need to integrate your endpoint for this type to work properly. "}]]]]]]]]]]]]]]]]],["div",{"class":"block bdr"},[["div",{"class":"title"},[["textNode",{"text":"Site’s Code"}]]],["div",{"class":"inner"},[["div",{"class":"settings-form code-form"},[["div",{"class":"overlay"},[["button",{"class":"btn btn-grey paste ds-block w-100p"},[["textNode",{"text":"PASTE HERE"}]]]]],["textarea",{"id":"paste-block","class":"code bdr"}]]]]]]],["div",{"class":"block bdr"},[["div",{"class":"title flex-wide"},[["span",{},[["textNode",{"text":"Your Site"}]]],["a",{"href":"","target":"_blank"},[["textNode",{"text":"Preview"}]],[["previewUrl","href",true,[],"bind"]]]]],["div",{"class":"inner p-0 preview-block"},[["iframe",{"src":"","style":"width: 100%; height: inherit"},[],[["previewUrl","src",true,[],"bind"]]]]]]]]]]);
fox.registerTemplate("promo_iframe_preview", [["iframe",{"src":"","style":"width: 100%; height: inherit"},[],[["src","src",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/iframe/images/powered-by.png", __webpack_require__.p + "components/iframe/images/powered-by.png");

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/iframe/images/promo-iframe-comix-320.jpg", __webpack_require__.p + "components/iframe/images/promo-iframe-comix-320.jpg");

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(87))

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "/*!\n * clipboard.js v2.0.4\n * https://zenorocha.github.io/clipboard.js\n * \n * Licensed MIT © Zeno Rocha\n */\n(function webpackUniversalModuleDefinition(root, factory) {\n\tif(typeof exports === 'object' && typeof module === 'object')\n\t\tmodule.exports = factory();\n\telse if(typeof define === 'function' && define.amd)\n\t\tdefine([], factory);\n\telse if(typeof exports === 'object')\n\t\texports[\"ClipboardJS\"] = factory();\n\telse\n\t\troot[\"ClipboardJS\"] = factory();\n})(this, function() {\nreturn /******/ (function(modules) { // webpackBootstrap\n/******/ \t// The module cache\n/******/ \tvar installedModules = {};\n/******/\n/******/ \t// The require function\n/******/ \tfunction __webpack_require__(moduleId) {\n/******/\n/******/ \t\t// Check if module is in cache\n/******/ \t\tif(installedModules[moduleId]) {\n/******/ \t\t\treturn installedModules[moduleId].exports;\n/******/ \t\t}\n/******/ \t\t// Create a new module (and put it into the cache)\n/******/ \t\tvar module = installedModules[moduleId] = {\n/******/ \t\t\ti: moduleId,\n/******/ \t\t\tl: false,\n/******/ \t\t\texports: {}\n/******/ \t\t};\n/******/\n/******/ \t\t// Execute the module function\n/******/ \t\tmodules[moduleId].call(module.exports, module, module.exports, __webpack_require__);\n/******/\n/******/ \t\t// Flag the module as loaded\n/******/ \t\tmodule.l = true;\n/******/\n/******/ \t\t// Return the exports of the module\n/******/ \t\treturn module.exports;\n/******/ \t}\n/******/\n/******/\n/******/ \t// expose the modules object (__webpack_modules__)\n/******/ \t__webpack_require__.m = modules;\n/******/\n/******/ \t// expose the module cache\n/******/ \t__webpack_require__.c = installedModules;\n/******/\n/******/ \t// define getter function for harmony exports\n/******/ \t__webpack_require__.d = function(exports, name, getter) {\n/******/ \t\tif(!__webpack_require__.o(exports, name)) {\n/******/ \t\t\tObject.defineProperty(exports, name, { enumerable: true, get: getter });\n/******/ \t\t}\n/******/ \t};\n/******/\n/******/ \t// define __esModule on exports\n/******/ \t__webpack_require__.r = function(exports) {\n/******/ \t\tif(typeof Symbol !== 'undefined' && Symbol.toStringTag) {\n/******/ \t\t\tObject.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });\n/******/ \t\t}\n/******/ \t\tObject.defineProperty(exports, '__esModule', { value: true });\n/******/ \t};\n/******/\n/******/ \t// create a fake namespace object\n/******/ \t// mode & 1: value is a module id, require it\n/******/ \t// mode & 2: merge all properties of value into the ns\n/******/ \t// mode & 4: return value when already ns object\n/******/ \t// mode & 8|1: behave like require\n/******/ \t__webpack_require__.t = function(value, mode) {\n/******/ \t\tif(mode & 1) value = __webpack_require__(value);\n/******/ \t\tif(mode & 8) return value;\n/******/ \t\tif((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;\n/******/ \t\tvar ns = Object.create(null);\n/******/ \t\t__webpack_require__.r(ns);\n/******/ \t\tObject.defineProperty(ns, 'default', { enumerable: true, value: value });\n/******/ \t\tif(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));\n/******/ \t\treturn ns;\n/******/ \t};\n/******/\n/******/ \t// getDefaultExport function for compatibility with non-harmony modules\n/******/ \t__webpack_require__.n = function(module) {\n/******/ \t\tvar getter = module && module.__esModule ?\n/******/ \t\t\tfunction getDefault() { return module['default']; } :\n/******/ \t\t\tfunction getModuleExports() { return module; };\n/******/ \t\t__webpack_require__.d(getter, 'a', getter);\n/******/ \t\treturn getter;\n/******/ \t};\n/******/\n/******/ \t// Object.prototype.hasOwnProperty.call\n/******/ \t__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };\n/******/\n/******/ \t// __webpack_public_path__\n/******/ \t__webpack_require__.p = \"\";\n/******/\n/******/\n/******/ \t// Load entry module and return exports\n/******/ \treturn __webpack_require__(__webpack_require__.s = 0);\n/******/ })\n/************************************************************************/\n/******/ ([\n/* 0 */\n/***/ (function(module, exports, __webpack_require__) {\n\n\"use strict\";\n\n\nvar _typeof = typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; };\n\nvar _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();\n\nvar _clipboardAction = __webpack_require__(1);\n\nvar _clipboardAction2 = _interopRequireDefault(_clipboardAction);\n\nvar _tinyEmitter = __webpack_require__(3);\n\nvar _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);\n\nvar _goodListener = __webpack_require__(4);\n\nvar _goodListener2 = _interopRequireDefault(_goodListener);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\nfunction _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\"); } return call && (typeof call === \"object\" || typeof call === \"function\") ? call : self; }\n\nfunction _inherits(subClass, superClass) { if (typeof superClass !== \"function\" && superClass !== null) { throw new TypeError(\"Super expression must either be null or a function, not \" + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }\n\n/**\n * Base class which takes one or more elements, adds event listeners to them,\n * and instantiates a new `ClipboardAction` on each click.\n */\nvar Clipboard = function (_Emitter) {\n    _inherits(Clipboard, _Emitter);\n\n    /**\n     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger\n     * @param {Object} options\n     */\n    function Clipboard(trigger, options) {\n        _classCallCheck(this, Clipboard);\n\n        var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));\n\n        _this.resolveOptions(options);\n        _this.listenClick(trigger);\n        return _this;\n    }\n\n    /**\n     * Defines if attributes would be resolved using internal setter functions\n     * or custom functions that were passed in the constructor.\n     * @param {Object} options\n     */\n\n\n    _createClass(Clipboard, [{\n        key: 'resolveOptions',\n        value: function resolveOptions() {\n            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n\n            this.action = typeof options.action === 'function' ? options.action : this.defaultAction;\n            this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;\n            this.text = typeof options.text === 'function' ? options.text : this.defaultText;\n            this.container = _typeof(options.container) === 'object' ? options.container : document.body;\n        }\n\n        /**\n         * Adds a click event listener to the passed trigger.\n         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger\n         */\n\n    }, {\n        key: 'listenClick',\n        value: function listenClick(trigger) {\n            var _this2 = this;\n\n            this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {\n                return _this2.onClick(e);\n            });\n        }\n\n        /**\n         * Defines a new `ClipboardAction` on each click event.\n         * @param {Event} e\n         */\n\n    }, {\n        key: 'onClick',\n        value: function onClick(e) {\n            var trigger = e.delegateTarget || e.currentTarget;\n\n            if (this.clipboardAction) {\n                this.clipboardAction = null;\n            }\n\n            this.clipboardAction = new _clipboardAction2.default({\n                action: this.action(trigger),\n                target: this.target(trigger),\n                text: this.text(trigger),\n                container: this.container,\n                trigger: trigger,\n                emitter: this\n            });\n        }\n\n        /**\n         * Default `action` lookup function.\n         * @param {Element} trigger\n         */\n\n    }, {\n        key: 'defaultAction',\n        value: function defaultAction(trigger) {\n            return getAttributeValue('action', trigger);\n        }\n\n        /**\n         * Default `target` lookup function.\n         * @param {Element} trigger\n         */\n\n    }, {\n        key: 'defaultTarget',\n        value: function defaultTarget(trigger) {\n            var selector = getAttributeValue('target', trigger);\n\n            if (selector) {\n                return document.querySelector(selector);\n            }\n        }\n\n        /**\n         * Returns the support of the given action, or all actions if no action is\n         * given.\n         * @param {String} [action]\n         */\n\n    }, {\n        key: 'defaultText',\n\n\n        /**\n         * Default `text` lookup function.\n         * @param {Element} trigger\n         */\n        value: function defaultText(trigger) {\n            return getAttributeValue('text', trigger);\n        }\n\n        /**\n         * Destroy lifecycle.\n         */\n\n    }, {\n        key: 'destroy',\n        value: function destroy() {\n            this.listener.destroy();\n\n            if (this.clipboardAction) {\n                this.clipboardAction.destroy();\n                this.clipboardAction = null;\n            }\n        }\n    }], [{\n        key: 'isSupported',\n        value: function isSupported() {\n            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];\n\n            var actions = typeof action === 'string' ? [action] : action;\n            var support = !!document.queryCommandSupported;\n\n            actions.forEach(function (action) {\n                support = support && !!document.queryCommandSupported(action);\n            });\n\n            return support;\n        }\n    }]);\n\n    return Clipboard;\n}(_tinyEmitter2.default);\n\n/**\n * Helper function to retrieve attribute value.\n * @param {String} suffix\n * @param {Element} element\n */\n\n\nfunction getAttributeValue(suffix, element) {\n    var attribute = 'data-clipboard-' + suffix;\n\n    if (!element.hasAttribute(attribute)) {\n        return;\n    }\n\n    return element.getAttribute(attribute);\n}\n\nmodule.exports = Clipboard;\n\n/***/ }),\n/* 1 */\n/***/ (function(module, exports, __webpack_require__) {\n\n\"use strict\";\n\n\nvar _typeof = typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; };\n\nvar _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();\n\nvar _select = __webpack_require__(2);\n\nvar _select2 = _interopRequireDefault(_select);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\n/**\n * Inner class which performs selection from either `text` or `target`\n * properties and then executes copy or cut operations.\n */\nvar ClipboardAction = function () {\n    /**\n     * @param {Object} options\n     */\n    function ClipboardAction(options) {\n        _classCallCheck(this, ClipboardAction);\n\n        this.resolveOptions(options);\n        this.initSelection();\n    }\n\n    /**\n     * Defines base properties passed from constructor.\n     * @param {Object} options\n     */\n\n\n    _createClass(ClipboardAction, [{\n        key: 'resolveOptions',\n        value: function resolveOptions() {\n            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n\n            this.action = options.action;\n            this.container = options.container;\n            this.emitter = options.emitter;\n            this.target = options.target;\n            this.text = options.text;\n            this.trigger = options.trigger;\n\n            this.selectedText = '';\n        }\n\n        /**\n         * Decides which selection strategy is going to be applied based\n         * on the existence of `text` and `target` properties.\n         */\n\n    }, {\n        key: 'initSelection',\n        value: function initSelection() {\n            if (this.text) {\n                this.selectFake();\n            } else if (this.target) {\n                this.selectTarget();\n            }\n        }\n\n        /**\n         * Creates a fake textarea element, sets its value from `text` property,\n         * and makes a selection on it.\n         */\n\n    }, {\n        key: 'selectFake',\n        value: function selectFake() {\n            var _this = this;\n\n            var isRTL = document.documentElement.getAttribute('dir') == 'rtl';\n\n            this.removeFake();\n\n            this.fakeHandlerCallback = function () {\n                return _this.removeFake();\n            };\n            this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;\n\n            this.fakeElem = document.createElement('textarea');\n            // Prevent zooming on iOS\n            this.fakeElem.style.fontSize = '12pt';\n            // Reset box model\n            this.fakeElem.style.border = '0';\n            this.fakeElem.style.padding = '0';\n            this.fakeElem.style.margin = '0';\n            // Move element out of screen horizontally\n            this.fakeElem.style.position = 'absolute';\n            this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';\n            // Move element to the same position vertically\n            var yPosition = window.pageYOffset || document.documentElement.scrollTop;\n            this.fakeElem.style.top = yPosition + 'px';\n\n            this.fakeElem.setAttribute('readonly', '');\n            this.fakeElem.value = this.text;\n\n            this.container.appendChild(this.fakeElem);\n\n            this.selectedText = (0, _select2.default)(this.fakeElem);\n            this.copyText();\n        }\n\n        /**\n         * Only removes the fake element after another click event, that way\n         * a user can hit `Ctrl+C` to copy because selection still exists.\n         */\n\n    }, {\n        key: 'removeFake',\n        value: function removeFake() {\n            if (this.fakeHandler) {\n                this.container.removeEventListener('click', this.fakeHandlerCallback);\n                this.fakeHandler = null;\n                this.fakeHandlerCallback = null;\n            }\n\n            if (this.fakeElem) {\n                this.container.removeChild(this.fakeElem);\n                this.fakeElem = null;\n            }\n        }\n\n        /**\n         * Selects the content from element passed on `target` property.\n         */\n\n    }, {\n        key: 'selectTarget',\n        value: function selectTarget() {\n            this.selectedText = (0, _select2.default)(this.target);\n            this.copyText();\n        }\n\n        /**\n         * Executes the copy operation based on the current selection.\n         */\n\n    }, {\n        key: 'copyText',\n        value: function copyText() {\n            var succeeded = void 0;\n\n            try {\n                succeeded = document.execCommand(this.action);\n            } catch (err) {\n                succeeded = false;\n            }\n\n            this.handleResult(succeeded);\n        }\n\n        /**\n         * Fires an event based on the copy operation result.\n         * @param {Boolean} succeeded\n         */\n\n    }, {\n        key: 'handleResult',\n        value: function handleResult(succeeded) {\n            this.emitter.emit(succeeded ? 'success' : 'error', {\n                action: this.action,\n                text: this.selectedText,\n                trigger: this.trigger,\n                clearSelection: this.clearSelection.bind(this)\n            });\n        }\n\n        /**\n         * Moves focus away from `target` and back to the trigger, removes current selection.\n         */\n\n    }, {\n        key: 'clearSelection',\n        value: function clearSelection() {\n            if (this.trigger) {\n                this.trigger.focus();\n            }\n\n            window.getSelection().removeAllRanges();\n        }\n\n        /**\n         * Sets the `action` to be performed which can be either 'copy' or 'cut'.\n         * @param {String} action\n         */\n\n    }, {\n        key: 'destroy',\n\n\n        /**\n         * Destroy lifecycle.\n         */\n        value: function destroy() {\n            this.removeFake();\n        }\n    }, {\n        key: 'action',\n        set: function set() {\n            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';\n\n            this._action = action;\n\n            if (this._action !== 'copy' && this._action !== 'cut') {\n                throw new Error('Invalid \"action\" value, use either \"copy\" or \"cut\"');\n            }\n        }\n\n        /**\n         * Gets the `action` property.\n         * @return {String}\n         */\n        ,\n        get: function get() {\n            return this._action;\n        }\n\n        /**\n         * Sets the `target` property using an element\n         * that will be have its content copied.\n         * @param {Element} target\n         */\n\n    }, {\n        key: 'target',\n        set: function set(target) {\n            if (target !== undefined) {\n                if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {\n                    if (this.action === 'copy' && target.hasAttribute('disabled')) {\n                        throw new Error('Invalid \"target\" attribute. Please use \"readonly\" instead of \"disabled\" attribute');\n                    }\n\n                    if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {\n                        throw new Error('Invalid \"target\" attribute. You can\\'t cut text from elements with \"readonly\" or \"disabled\" attributes');\n                    }\n\n                    this._target = target;\n                } else {\n                    throw new Error('Invalid \"target\" value, use a valid Element');\n                }\n            }\n        }\n\n        /**\n         * Gets the `target` property.\n         * @return {String|HTMLElement}\n         */\n        ,\n        get: function get() {\n            return this._target;\n        }\n    }]);\n\n    return ClipboardAction;\n}();\n\nmodule.exports = ClipboardAction;\n\n/***/ }),\n/* 2 */\n/***/ (function(module, exports) {\n\nfunction select(element) {\n    var selectedText;\n\n    if (element.nodeName === 'SELECT') {\n        element.focus();\n\n        selectedText = element.value;\n    }\n    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {\n        var isReadOnly = element.hasAttribute('readonly');\n\n        if (!isReadOnly) {\n            element.setAttribute('readonly', '');\n        }\n\n        element.select();\n        element.setSelectionRange(0, element.value.length);\n\n        if (!isReadOnly) {\n            element.removeAttribute('readonly');\n        }\n\n        selectedText = element.value;\n    }\n    else {\n        if (element.hasAttribute('contenteditable')) {\n            element.focus();\n        }\n\n        var selection = window.getSelection();\n        var range = document.createRange();\n\n        range.selectNodeContents(element);\n        selection.removeAllRanges();\n        selection.addRange(range);\n\n        selectedText = selection.toString();\n    }\n\n    return selectedText;\n}\n\nmodule.exports = select;\n\n\n/***/ }),\n/* 3 */\n/***/ (function(module, exports) {\n\nfunction E () {\n  // Keep this empty so it's easier to inherit from\n  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)\n}\n\nE.prototype = {\n  on: function (name, callback, ctx) {\n    var e = this.e || (this.e = {});\n\n    (e[name] || (e[name] = [])).push({\n      fn: callback,\n      ctx: ctx\n    });\n\n    return this;\n  },\n\n  once: function (name, callback, ctx) {\n    var self = this;\n    function listener () {\n      self.off(name, listener);\n      callback.apply(ctx, arguments);\n    };\n\n    listener._ = callback\n    return this.on(name, listener, ctx);\n  },\n\n  emit: function (name) {\n    var data = [].slice.call(arguments, 1);\n    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();\n    var i = 0;\n    var len = evtArr.length;\n\n    for (i; i < len; i++) {\n      evtArr[i].fn.apply(evtArr[i].ctx, data);\n    }\n\n    return this;\n  },\n\n  off: function (name, callback) {\n    var e = this.e || (this.e = {});\n    var evts = e[name];\n    var liveEvents = [];\n\n    if (evts && callback) {\n      for (var i = 0, len = evts.length; i < len; i++) {\n        if (evts[i].fn !== callback && evts[i].fn._ !== callback)\n          liveEvents.push(evts[i]);\n      }\n    }\n\n    // Remove event from queue to prevent memory leak\n    // Suggested by https://github.com/lazd\n    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910\n\n    (liveEvents.length)\n      ? e[name] = liveEvents\n      : delete e[name];\n\n    return this;\n  }\n};\n\nmodule.exports = E;\n\n\n/***/ }),\n/* 4 */\n/***/ (function(module, exports, __webpack_require__) {\n\nvar is = __webpack_require__(5);\nvar delegate = __webpack_require__(6);\n\n/**\n * Validates all params and calls the right\n * listener function based on its target type.\n *\n * @param {String|HTMLElement|HTMLCollection|NodeList} target\n * @param {String} type\n * @param {Function} callback\n * @return {Object}\n */\nfunction listen(target, type, callback) {\n    if (!target && !type && !callback) {\n        throw new Error('Missing required arguments');\n    }\n\n    if (!is.string(type)) {\n        throw new TypeError('Second argument must be a String');\n    }\n\n    if (!is.fn(callback)) {\n        throw new TypeError('Third argument must be a Function');\n    }\n\n    if (is.node(target)) {\n        return listenNode(target, type, callback);\n    }\n    else if (is.nodeList(target)) {\n        return listenNodeList(target, type, callback);\n    }\n    else if (is.string(target)) {\n        return listenSelector(target, type, callback);\n    }\n    else {\n        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');\n    }\n}\n\n/**\n * Adds an event listener to a HTML element\n * and returns a remove listener function.\n *\n * @param {HTMLElement} node\n * @param {String} type\n * @param {Function} callback\n * @return {Object}\n */\nfunction listenNode(node, type, callback) {\n    node.addEventListener(type, callback);\n\n    return {\n        destroy: function() {\n            node.removeEventListener(type, callback);\n        }\n    }\n}\n\n/**\n * Add an event listener to a list of HTML elements\n * and returns a remove listener function.\n *\n * @param {NodeList|HTMLCollection} nodeList\n * @param {String} type\n * @param {Function} callback\n * @return {Object}\n */\nfunction listenNodeList(nodeList, type, callback) {\n    Array.prototype.forEach.call(nodeList, function(node) {\n        node.addEventListener(type, callback);\n    });\n\n    return {\n        destroy: function() {\n            Array.prototype.forEach.call(nodeList, function(node) {\n                node.removeEventListener(type, callback);\n            });\n        }\n    }\n}\n\n/**\n * Add an event listener to a selector\n * and returns a remove listener function.\n *\n * @param {String} selector\n * @param {String} type\n * @param {Function} callback\n * @return {Object}\n */\nfunction listenSelector(selector, type, callback) {\n    return delegate(document.body, selector, type, callback);\n}\n\nmodule.exports = listen;\n\n\n/***/ }),\n/* 5 */\n/***/ (function(module, exports) {\n\n/**\n * Check if argument is a HTML element.\n *\n * @param {Object} value\n * @return {Boolean}\n */\nexports.node = function(value) {\n    return value !== undefined\n        && value instanceof HTMLElement\n        && value.nodeType === 1;\n};\n\n/**\n * Check if argument is a list of HTML elements.\n *\n * @param {Object} value\n * @return {Boolean}\n */\nexports.nodeList = function(value) {\n    var type = Object.prototype.toString.call(value);\n\n    return value !== undefined\n        && (type === '[object NodeList]' || type === '[object HTMLCollection]')\n        && ('length' in value)\n        && (value.length === 0 || exports.node(value[0]));\n};\n\n/**\n * Check if argument is a string.\n *\n * @param {Object} value\n * @return {Boolean}\n */\nexports.string = function(value) {\n    return typeof value === 'string'\n        || value instanceof String;\n};\n\n/**\n * Check if argument is a function.\n *\n * @param {Object} value\n * @return {Boolean}\n */\nexports.fn = function(value) {\n    var type = Object.prototype.toString.call(value);\n\n    return type === '[object Function]';\n};\n\n\n/***/ }),\n/* 6 */\n/***/ (function(module, exports, __webpack_require__) {\n\nvar closest = __webpack_require__(7);\n\n/**\n * Delegates event to a selector.\n *\n * @param {Element} element\n * @param {String} selector\n * @param {String} type\n * @param {Function} callback\n * @param {Boolean} useCapture\n * @return {Object}\n */\nfunction _delegate(element, selector, type, callback, useCapture) {\n    var listenerFn = listener.apply(this, arguments);\n\n    element.addEventListener(type, listenerFn, useCapture);\n\n    return {\n        destroy: function() {\n            element.removeEventListener(type, listenerFn, useCapture);\n        }\n    }\n}\n\n/**\n * Delegates event to a selector.\n *\n * @param {Element|String|Array} [elements]\n * @param {String} selector\n * @param {String} type\n * @param {Function} callback\n * @param {Boolean} useCapture\n * @return {Object}\n */\nfunction delegate(elements, selector, type, callback, useCapture) {\n    // Handle the regular Element usage\n    if (typeof elements.addEventListener === 'function') {\n        return _delegate.apply(null, arguments);\n    }\n\n    // Handle Element-less usage, it defaults to global delegation\n    if (typeof type === 'function') {\n        // Use `document` as the first parameter, then apply arguments\n        // This is a short way to .unshift `arguments` without running into deoptimizations\n        return _delegate.bind(null, document).apply(null, arguments);\n    }\n\n    // Handle Selector-based usage\n    if (typeof elements === 'string') {\n        elements = document.querySelectorAll(elements);\n    }\n\n    // Handle Array-like based usage\n    return Array.prototype.map.call(elements, function (element) {\n        return _delegate(element, selector, type, callback, useCapture);\n    });\n}\n\n/**\n * Finds closest match and invokes callback.\n *\n * @param {Element} element\n * @param {String} selector\n * @param {String} type\n * @param {Function} callback\n * @return {Function}\n */\nfunction listener(element, selector, type, callback) {\n    return function(e) {\n        e.delegateTarget = closest(e.target, selector);\n\n        if (e.delegateTarget) {\n            callback.call(element, e);\n        }\n    }\n}\n\nmodule.exports = delegate;\n\n\n/***/ }),\n/* 7 */\n/***/ (function(module, exports) {\n\nvar DOCUMENT_NODE_TYPE = 9;\n\n/**\n * A polyfill for Element.matches()\n */\nif (typeof Element !== 'undefined' && !Element.prototype.matches) {\n    var proto = Element.prototype;\n\n    proto.matches = proto.matchesSelector ||\n                    proto.mozMatchesSelector ||\n                    proto.msMatchesSelector ||\n                    proto.oMatchesSelector ||\n                    proto.webkitMatchesSelector;\n}\n\n/**\n * Finds the closest parent that matches a selector.\n *\n * @param {Element} element\n * @param {String} selector\n * @return {Function}\n */\nfunction closest (element, selector) {\n    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {\n        if (typeof element.matches === 'function' &&\n            element.matches(selector)) {\n          return element;\n        }\n        element = element.parentNode;\n    }\n}\n\nmodule.exports = closest;\n\n\n/***/ })\n/******/ ]);\n});"

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	'use strict';

	__webpack_require__(89)(fox);
	__webpack_require__(90)(fox);
};

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	fox.registerWidget('PersonalData', {

		configure: function (options) {
			
			this.registerOptions('', {
				autoRender: true,
				'embed.container': '#user-personal-data',
                template: 'user_personal_data',
                widgets: {
                    updateApi: {
                        widget: 'Api',
                        method: 'consent.provideBulk',
                        httpMethod: 'post'
                    },
                    getSettingsApi: {
                        widget: 'Api',
                        method: 'consent.list'
                    },
                },
                handleDom: {
                    required: {
                        target: '.required-checkbox',
                        callback: '_showAttentionPopup'
                    },
                    change: {
                        target: '.communication-checkbox',
                        event: 'change',
                        callback: '_change'
                    }
                }
			});

			this.callParent('configure', arguments);
		},

		running: function() {  
            // var deleteAccount =  fox.site.wom1('#gdprDeleteAccount');
            // var deleteAccountConfirm = deleteAccount.wom1('#GDPR_AccountDeleteConfirm');
            this.getSettings().then(this._renderData.bind(this));
            this.callParent('running', arguments);
        },

        activate: function() {
            this.getSettings().then(this._renderData.bind(this));
            this.callParent('activate', arguments);
        },

		getSettings: function() {
            return this.wom1('#getSettingsApi').psend({});
        },
        
        _renderData: function(resp) {
            var data = resp.params.answer.response;

            data.timestamp *= 1000;
            
            this.setTemplateOptions(fox.merge(data, {modelName: fox.site.getEnv('screenName')})).render();
        },

        _showAttentionPopup: function(elm) {           
            this.showAttentionPopup().then(function(result) {
                if (result === true) {
                    return;
                }
            });
        },

        showAttentionPopup: function() {

            return fox.site.rwom1('#gdprAttentionActions').show()
        },

        _change: function(elm) {
            // var elms = this.dom('#marketing');
            var data = {};

            // fox.each(elms, function(elm) {
                
            // });

            data[elm.name] = Number(elm.checked);

            return this.wom1('#updateApi')
                .psend({aliases: data});
        }

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_personal_data", [["div",{"class":"basic-properties _m-t-25"},[["div",{"class":"flex-wide"},[["h3",{"class":"left"},[["span",{"data-fox-alias":"1","data-fox-context":"user_personal_data"},[["textNode",{"text":"Personal Data Processing"}]]]]]]],["div",{"class":"property-item"},[["label",{"for":"","class":"_flex mc-checkbox required-checkbox"},[["input",{"class":"required-checkbox","style":"display:none","type":"checkbox","name":"tos","id":"tos","checked":""}],["div",{"class":"checkbox-wrap _flex-1"},[["div",{"class":"check-wrap","style":"opacity: 1;"},[["span",{"class":"check-1"}],["textNode",{"text":" "}],["span",{"class":"check-2"}]]]]],["p",{"class":"_fs-12 _m-l-20","data-fox-alias":"3","data-fox-context":"user_personal_data"},[["textNode",{"text":"By checking this box, I certify that I am at least 18-years old, have the capacity to enter into legally binding contracts, and have read and agree to the "}],["span",{"onclick":"event.stopPropagation();"},[["a",{"href":"https://modelcentro.com/terms-of-use","target":"_blank"},[["textNode",{"text":"Terms of Use"}]]],["textNode",{"text":"."}]]]]]]]]],["div",{"class":"flex-wide _m-t-40"},[["h3",{"class":"left"},[["span",{"data-fox-alias":"3","data-fox-context":"user_personal_data"},[["textNode",{"text":"Communication"}]]]]]]],["div",{"class":"property-item"},[["label",{"for":"marketing","class":"mc-checkbox _flex"},[["if",{"notempty":""},[["input",{"class":"communication-checkbox","type":"checkbox","name":"marketing","id":"marketing","checked":""}],["else",{},[["input",{"class":"communication-checkbox","type":"checkbox","name":"marketing","id":"marketing"}]]]],[["marketing","notempty",true,[{"name":"eq","params":["1"]}]]]],["div",{"class":"checkbox-wrap _flex-1"},[["div",{"class":"check-wrap"},[["span",{"class":"check-1"}],["textNode",{"text":" "}],["span",{"class":"check-2"}]]]]],["p",{"class":"_m-l-20 _fs-12","data-fox-alias":"4","data-fox-context":"user_personal_data"},[["textNode",{"text":" I agree to receive e-mails with special offers, news and updates from ModelCentro family of products. "}]]]]]]],["if",{"notempty":""},[["div",{"class":"property-item"},[["label",{"for":"marketingSms","class":"mc-checkbox _flex"},[["if",{"notempty":""},[["input",{"class":"communication-checkbox","type":"checkbox","name":"marketingSms","id":"marketingSms","checked":""}],["else",{},[["input",{"class":"communication-checkbox","type":"checkbox","name":"marketingSms","id":"marketingSms"}]]]],[["marketingSms","notempty",true,[{"name":"eq","params":["1"]}]]]],["div",{"class":"checkbox-wrap _flex-1"},[["div",{"class":"check-wrap"},[["span",{"class":"check-1"}],["textNode",{"text":" "}],["span",{"class":"check-2"}]]]]],["p",{"class":"_m-l-20 _fs-12","data-fox-alias":"5","data-fox-context":"user_personal_data"},[["textNode",{"text":" I agree to receive important system SMS, news, and updates from ModelCentro family of products. "}]]]]]]]],[["showSMSConsent","notempty",true]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check
/**
 * 
 * @param {Fox} fox 
 */
module.exports = function (fox, parentPopupName) {
	//@ts-ignore
	__webpack_require__(92);
	//@ts-ignore
	__webpack_require__(94)(fox);
	//@ts-ignore
	__webpack_require__(95)(fox);
	//@ts-ignore
	__webpack_require__(96)(fox, parentPopupName);

	var _require = __webpack_require__(98),
	    popupsFactory = _require.factory,
	    SettingsCancelTypes = _require.SettingsCancelTypes,
	    PopupWidgetClasses = _require.PopupWidgetClasses;

	var _require2 = __webpack_require__(99),
	    bannerFactory = _require2.factory,
	    BannerClassName = _require2.BannerClassName;

	popupsFactory(fox);
	bannerFactory(fox);

	fox.registerOptions('@root', {
		widgets: {
			gdprMainPopup: {
				widget: PopupWidgetClasses.settings
			},
			gdprDeleteAccount: {
				widget: PopupWidgetClasses.deleteAccount
			},
			gdprRulesActions: {
				widget: PopupWidgetClasses.rulesActions
			},
			gdprCookieBanner: {
				widget: BannerClassName
			},
			gdprAttentionActions: {
				widget: PopupWidgetClasses.attentionActions
			}
		}
	}, true, {});
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(93);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../node_modules/stylus-loader/index.js??ref--6-3!./_index.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../node_modules/stylus-loader/index.js??ref--6-3!./_index.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".mc-site-common-popup.gdpr-popup{background-color:#212023;max-width:655px}.mc-site-common-popup.gdpr-popup a{color:#fff;text-decoration:underline}.mc-site-common-popup.gdpr-popup~.ui-widget-overlay{background-color:rgba(0,0,0,.8)}.mc-site-common-popup.gdpr-popup.gdpr-small{max-width:460px;min-width:300px}.mc-site-common-popup.gdpr-popup .popup-content-wrapper{width:100%}.mc-site-common-popup.gdpr-popup .popup-content-wrapper ._fs-12{line-height:20px}.mc-site-common-popup.gdpr-popup .popup-footer-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}@media (max-width:425px){.mc-site-common-popup.gdpr-popup.gdpr-small{max-width:90%}.mc-site-common-popup.gdpr-popup .popup-content-wrapper ._fs-12{line-height:16px}.mc-site-common-popup.gdpr-popup .mc-common-button .secondary{margin-top:20px;margin-left:0}}@media (max-height:800px){.mc-site-common-popup.gdpr-popup{position:absolute}}.mc-site-common-popup.gdpr-popup .ui-dialog-content{padding:35px;color:#fff;max-width:none}.mc-site-common-popup.gdpr-popup .ui-dialog-content .cancel-close{font-size:16px;position:absolute;top:10px;right:10px;cursor:pointer}.mc-site-common-popup.gdpr-popup .ui-dialog-content .cancel-close:before{content:\"N\"}.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-content-wrapper{font-family:pt_sansregular;text-align:left;background-color:inherit;color:#fff;margin-bottom:0}.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-content-wrapper a{color:#fff;text-decoration:underline}.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-content-wrapper label{max-width:550px}.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-title-wrapper{background-color:inherit;text-align:center;margin:0;margin-bottom:20px;padding:0;border:none}.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-title-wrapper .popup-title{font-size:16px;line-height:24px;font-family:pt_sansbold;text-transform:uppercase;color:#fff}.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-footer-wrapper{border:none;text-align:center;background-color:inherit;padding:0;margin:0;margin-top:30px}.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-footer-wrapper:after,.mc-site-common-popup.gdpr-popup .ui-dialog-content .popup-footer-wrapper:before{display:none}.gdpr-popup .upbs-content a{color:#fff;text-decoration:underline}.gdpr-popup .mc-common-button{color:#fff;height:auto;min-height:35px;font-size:11px;font-weight:700;line-height:14px;padding:9px;font-family:pt_sansbold;transition:transform .2s,background-color .2s,border-color .2s}.gdpr-popup .mc-common-button.spin{padding-left:40px}.gdpr-popup .mc-common-button.spin:before{animation:play 1s steps(28) infinite;-ms-filter:none;filter:none;opacity:1}.gdpr-popup .mc-common-button:active{transform:translateY(1px)}.gdpr-popup .mc-common-button.primary{background-color:#414041;border-color:#414041}.gdpr-popup .mc-common-button.primary:hover{background-color:rgba(65,64,65,.6)}.gdpr-popup .mc-common-button.secondary{background-color:transparent;border:1px solid #fff}.gdpr-popup .mc-common-button.secondary:hover{border-color:hsla(0,0%,100%,.6)}.gdpr-popup .mc-common-button.simple{background-color:transparent;border:1px solid #fff;color:#fff}.gdpr-popup .mc-common-button.simple:hover{color:hsla(0,0%,100%,.6);border-color:hsla(0,0%,100%,.6)}.gdpr-popup .form-label.error span:first-child{color:#ff666d}.gdpr-popup .form-label.error .gdpr-checkbox .shape{border-color:#ff666d}.upbs-wrapper.gdpr-popup .upbs-content .upbs-message{text-align:left}@media (max-width:580px){.upbs-wrapper.gdpr-popup .upbs-content .upbs-message{margin-top:0}.upbs-wrapper.gdpr-popup #form{-ms-flex-flow:column nowrap;flex-flow:column nowrap;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}.upbs-wrapper.gdpr-popup .cookie-button-block,.upbs-wrapper.gdpr-popup .cookie-button-block .mc-common-button{width:100%}.upbs-wrapper.gdpr-popup .cookie-checkboxes{-ms-flex-flow:column nowrap;flex-flow:column nowrap;margin-bottom:20px}.upbs-wrapper.gdpr-popup .cookie-checkboxes label{margin-bottom:15px}}.gdpr-checkbox{position:relative;cursor:pointer;display:-moz-inline-flex;display:-ms-inline-flexbox;display:inline-flex}.gdpr-checkbox [type=checkbox]{position:absolute;top:0;right:0;bottom:0;left:0;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;z-index:2;width:100%;height:100%;cursor:pointer}.gdpr-checkbox .shape{width:18px;height:18px;border:1px solid #fff}.gdpr-checkbox .check{height:7px;width:18px;border:1px solid #fff;border-width:0 0 2px 2px;position:absolute;top:0;left:4px;border-radius:2px;transition:transform .2s,opacity .2s;z-index:1;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;transform:rotate(-35deg)}.gdpr-checkbox [type=checkbox]:checked~.check{-ms-filter:none;filter:none;opacity:1;transform:rotate(-45deg)}.gdpr-checkbox [type=checkbox]:disabled~.shape{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";filter:alpha(opacity=40);opacity:.4}.gdpr-checkbox [type=checkbox]:disabled~.check{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";filter:alpha(opacity=70);opacity:.7}.gdpr-textarea{position:relative;background-color:#1a1a1c;border:1px solid #404042;border-radius:3px;padding:20px;outline:none;resize:none;width:100%;color:#fff;-ms-box-sizing:border-box;box-sizing:border-box}.gdpr-gookie-banner-button{border:none;border-radius:3px;color:#fff;height:auto;min-height:35px;font-size:11px;font-weight:700;line-height:14px;padding:9px;font-family:pt_sansbold;text-transform:uppercase;background-color:hsla(0,0%,100%,.15);cursor:pointer}", ""]);

// exports


/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("gdpr_account_delete_confirm_after_login_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title _tc-err"},[["textNode",{"text":" Attention "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center"},[["div",{"class":"_fs-12 _flex-1","style":"text-align:center;"},[["textNode",{"text":" Under the GDPR law we are obligated to have your consent in order to process your data (username, email, etc). Your account cannot properly function without data processing, therefore by revoking your consent your account will be terminated and all your data will be erased. "}],["span",{"class":"_tc-err"},[["textNode",{"text":"All your purchases will be gone forever"}]]],["textNode",{"text":" Are you sure you wish to revoke your consent and delete your account? "}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary","style":"background-color: #bd4147;"},[["textNode",{"text":"yes, delete my account"}]]],["textNode",{"text":" "}],["button",{"id":"on-cancel","class":"mc-common-button secondary _m-l-10"},[["textNode",{"text":"cancel"}]]]]]]);
fox.registerTemplate("gdpr_account_request_success_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Success "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center"},[["div",{"class":"_fs-12","style":"text-align:center;"},[["textNode",{"text":" Your request has been sent. "}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary"},[["textNode",{"text":"ok"}]]]]]]);
fox.registerTemplate("gdpr_account_rules_action_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Exercise Your Rights Under GDPR "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center"},[["div",{"class":"_fs-12 _m-b-20","style":"text-align:center;"},[["textNode",{"text":" What would you like to do? "}]]],["div",{"id":"actions-select","style":"width:100%;"}],["div",{"class":"_m-t-20 &&0&&","style":"width:100%;"},[["textarea",{"class":"gdpr-textarea","placeholder":"Comment","name":"comment","cols":"30","rows":"5"}]],[["emptyValue","class",false,[{"name":"empty","params":[]},{"name":"hideIfFalse","params":[]}],"bind"]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary"},[["textNode",{"text":"Submit request"}]]]]]]);
fox.registerTemplate("gdpr_account_action_error_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Sorry "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center"},[["div",{"class":"_fs-12","style":"text-align:center;"},[["textNode",{"text":" "}],["span",{},[],[["text","__text",true]]],["textNode",{"text":" "}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary"},[["textNode",{"text":"ok"}]]]]]]);
fox.registerTemplate("gdpr_account_delete_success_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" Success "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center"},[["div",{"class":"_fs-12","style":"text-align:center;"},[["textNode",{"text":" Your account and all your personal data has been deleted. "}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary"},[["textNode",{"text":"ok"}]]]]]]);
fox.registerTemplate("gdpr_account_delete_confirm_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title _tc-err"},[["textNode",{"text":" Warning "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center"},[["div",{"class":"_fs-12","style":"text-align:center; width:100%"},[["textNode",{"text":" You are attempting to delete your account and all your personal data, but you still have an active subscription. I hate to see you go, but if you would like to cancel your subscription, please visit centrobill.com. If you still want to delete your account, please be aware that this action can't be undone. "}]]],["div",{"class":"_fs-12 _tc-err _m-t-20"},[["textNode",{"text":" All your purchases will be gone forever "}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary","style":"background-color: #bd4147;"},[["textNode",{"text":"delete"}]]],["textNode",{"text":" "}],["button",{"id":"on-cancel","class":"mc-common-button secondary _m-l-10"},[["textNode",{"text":"cancel"}]]]]]]);
fox.registerTemplate("gdpr_account_delete_final_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title _tc-err"},[["textNode",{"text":" Deleting Account - Final Step "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center","style":"text-align:center;"},[["div",{"class":"_fs-12","style":"width:100%"},[["textNode",{"text":" This is the final step of deleting your account. Please be aware that this action cannot be undone "}]]],["div",{"class":"_fs-14 _tc-err _m-t-20","style":"width:100%"},[["textNode",{"text":"All your data (paid content, subscriptions, message history) will be deleted."}]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary","style":"background-color: #bd4147;"},[["textNode",{"text":"I understand, delete my account"}]]],["textNode",{"text":" "}],["button",{"id":"on-cancel","class":"mc-common-button secondary _m-l-10"},[["textNode",{"text":"cancel"}]]]]]]);
fox.registerTemplate("gdpr_settings_popup", [["div",{"class":"popup-title-wrapper"},[["strong",{"class":"popup-title"},[["textNode",{"text":" In order to provide you with the best possible experience and get the technical elements up and running, I need your consent to process your personal data. "}]]],["textNode",{"text":" "}],["span",{"class":"icon-au_close-delete cancel-close"}]]],["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-start data-processing"},[["div",{"class":"_fs-14 _m-b-20"},[["textNode",{"text":"Personal Data Processing"}]]],["label",{"for":"checkbox1","class":"form-label _flex _row-n _r-v-center"},[["span",{"class":"_fs-18"},[["textNode",{"text":"*"}]]],["div",{"class":"gdpr-checkbox _m-r-15 _m-l-5 _flex-1"},[["input",{"type":"checkbox","name":"consent_tos","id":"checkbox1","required":""}],["textNode",{"text":" "}],["span",{"class":"shape"}],["textNode",{"text":" "}],["span",{"class":"check"}]]],["span",{"class":"_fs-12"},[["textNode",{"text":"By checking this box, I certify that I am at least 18-years old, have the capacity to enter into legally binding contracts, and have read and agree to the "}],["a",{"target":"_blank","href":"/terms"},[["textNode",{"text":"Terms of Use"}]]]]]]],["textNode",{"text":" "}],["label",{"for":"checkbox2","class":"form-label _flex _row-n _r-v-center _m-t-15"},[["span",{"class":"_fs-18","style":"visibility: hidden;"},[["textNode",{"text":"*"}]]],["div",{"class":"gdpr-checkbox _m-r-15 _m-l-5"},[["input",{"type":"checkbox","name":"consent_marketing","id":"checkbox2"}],["textNode",{"text":" "}],["span",{"class":"shape"}],["textNode",{"text":" "}],["span",{"class":"check"}]]],["span",{"class":"_fs-12"},[["textNode",{"text":"I agree to receive e-mails with special offers, news and updates from ModelCentro family of products"}]]]]],["div",{"class":"_m-t-20 _fs-12","style":"width:100%"},[["strong",{},[["textNode",{"text":" Please note: "}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":" You will be able to request your personal data deletion at any time by clicking Delete my account in the account settings. "}]]]]]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"on-success","class":"mc-common-button primary"},[["textNode",{"text":"proceed"}]]],["textNode",{"text":" "}],["button",{"id":"on-cancel","class":"mc-common-button secondary _m-l-10"},[["textNode",{"text":"cancel"}]]]]]]);
fox.registerTemplate("gdpr_account_attention_popup", [["div"]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("gdpr_cookie_banner", [["div",{"id":"gdpr-cookie-accept","class":"strip-notification-wrapper verification-sent","style":"-webkit-transform: translateY(0px); -ms-transform: translateY(0px); transform: translateY(0px);"},[["div",{"class":"strip-notification-content"},[["p",{},[["textNode",{"text":"Hey there! Cookies are required to use this site. Feel free to check out our Cookie Policy at any time."}]]],["div",{"class":"_flex _row-n _r-h-end _m-l-20 _flex-1"},[["button",{"id":"accept-cookies","class":"gdpr-gookie-banner-button"},[["textNode",{"text":"I don’t mind Cookies"}]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check
/**
 * 
 * @param {Fox} fox
 */
module.exports = function (fox, parentPopupName) {
	__webpack_require__(97)(fox, parentPopupName);

	return fox.registerWidget('GDPR_BasePopup', {
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				preventHideOnShadowClick: true,
				dialog: {
					closeOnEscape: false
				},
				onCancelPress: function onCancelPress() {
					_this.hide();

					return fox.Promise.resolve(false);
				},
				handleWom: {
					blurOnShow: {
						event: 'show',
						widget: '@this',
						callback: function callback() {
							return fox.wom.getRoot().rdom1('.wrapper').classList.add('_opacity-40');
						},
						params: {
							prefix: 'gdpr_popups'
						}
					},
					blurOnHide: {
						event: 'hide',
						widget: '@this',
						callback: function callback() {
							return fox.wom.getRoot().rdom1('.wrapper').classList.remove('_opacity-40');
						},
						params: {
							prefix: 'gdpr_popups'
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},
		init: function init() {
			var _this2 = this;

			var onOkPress = this.requireOption('onOkPress');
			var onCancelPress = this.getOption('onCancelPress');

			this.registerOptions('#content', {
				template: this.getOption('contentTemplate'),
				handleDom: {
					close: {
						target: '.cancel-close'
					},
					onSuccess: {
						target: '#on-success',
						callback: function callback(button, alias, context) {
							return onOkPress(button, context).then(function (resp) {
								return resp !== null && _this2.resolve(resp);
							}, function (error) {
								return _this2.reject(error);
							});
						}
					},
					onCancel: {
						target: '#on-cancel',
						callback: function callback(button, alias, context) {
							return onCancelPress(button, context).then(function (resp) {
								return resp !== null && _this2.resolve(resp);
							}, function (error) {
								return _this2.reject(error);
							});
						}
					}
				}
			});

			window.addEventListener(fox.utils.isTouchDevice() ? 'orientationchange' : 'resize', function () {
				_this2._center();
			});

			this.setOption('dialog.dialogClass', this.getOption('dialog.dialogClass') + ' gdpr-popup');

			this.callParent('init', arguments);
		},
		hide: function hide(mbEl, mbAlias) {
			if (mbAlias === 'close' && fox.dom.isDomNode(mbEl)) {
				this.resolve(false);
			}

			this.callParent('hide', arguments);
		}
	}, 'Popup_PromiseCommon');
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check

//@ts-ignore
var _require = __webpack_require__(22)(fox),
    delay = _require.delay;

/**
 * 
 * @param {Fox} fox 
 */


module.exports = function (fox) {
	var parentPopupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Popup_Common';

	return fox.registerWidget('Popup_PromiseCommon', {
		_center: function _center() {
			var _this = this;

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			var count = 3;
			var promise = fox.Promise.resolve();

			while (count--) {
				promise = promise.then(function () {
					return delay(50);
				}).then(function () {
					return _this.callParent('_center', args);
				});
			}
		},
		show: function show() {
			var _this2 = this;

			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}

			return new fox.Promise(function (resolver, reject) {
				_this2.__resolver = resolver;
				_this2.__rejecter = reject;
				_this2.callParent('show', args);
				_this2._center();
			});
		},
		resolve: function resolve(params) {
			return this.__resolver(params);
		},
		reject: function reject(error) {
			return this.__rejecter(error);
		}
	}, parentPopupName);
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//@ts-check

var ResponseTemplates = {
	deleteSuccess: 'gdpr_account_delete_success_popup',
	actionError: 'gdpr_account_action_error_popup',
	requestSuccess: 'gdpr_account_request_success_popup'
};

var SettingsCancelTypes = {
	guest: 0,
	member: 1
};

var OptionValues = ['Select an option', 'I want to transfer my data to me or a third-party', 'I want to rectify incorrect data this site has about me', 'I want to object to the way this site is using my personal information'];

var PopupWidgetClasses = {
	settings: 'GDPR_SettingsPopup',
	actionResponse: 'GDPR_AccountActionResponse',
	deleteAccount: 'GDPR_AccountDeleteConfirm',
	deleteAccountFinal: 'GDPR_AccountDeleteFinal',
	rulesActions: 'GDPR_AccountRulesActions',
	attentionActions: 'GDPR_AccountAttentionActions'

	/**
  * 
  * @param {HTMLButtonElement} button 
  */
};var changeButtonState = function changeButtonState(button, newText) {
	var text = button.innerText;
	button.innerText = newText;
	button.disabled = true;

	return function () {
		button.disabled = false;
		button.innerText = text;
	};
};

exports.SettingsCancelTypes = SettingsCancelTypes;
exports.PopupWidgetClasses = PopupWidgetClasses;

/**
 * 
 * @param {Fox} fox 
 */
exports.factory = function (fox) {
	// settings popup
	fox.registerWidget(PopupWidgetClasses.settings, {
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				contentTemplate: 'gdpr_settings_popup',
				onOkPress: function onOkPress() {
					return _this.sumbitForm.apply(_this, arguments);
				},
				onCancelPress: function onCancelPress() {
					return _this.onCancel.apply(_this, arguments);
				},
				dialog: {
					close: function close(event) {
						if (event.currentTarget !== undefined && event.currentTarget.id != 'on-success') _this.resolve(false);
					}
				},
				widgets: {
					actionPopup: {
						widget: PopupWidgetClasses.actionResponse
					},
					deletePopup: {
						widget: PopupWidgetClasses.deleteAccount,
						contentTemplate: 'gdpr_account_delete_confirm_after_login_popup'
					},
					form: {
						widget: 'DomForm',
						formSelector: '#form-content',
						validateOnFly: true,
						valuePostProcessing: [function (value) {
							return value === 'on' ? 1 : 0;
						}]
					}
				},
				handleWom: {
					formValidation: {
						widget: '#form',
						event: ['form_valid', 'form_not_valid'],
						callback: function callback(infos, form) {
							return infos.forEach(function (_ref) {
								var field = _ref.field,
								    result = _ref.result;

								var element = form.getElement(field);

								element.nodes.forEach(function (node) {
									var label = node.parentNode.parentNode;

									if (label) {
										return !result ? label.classList.add('error') : label.classList.remove('error');
									}
								});
							});
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},
		showForMember: function showForMember() {
			var _this2 = this;

			return this.show(SettingsCancelTypes.member).then(function (result) {
				if (result) {
					var api = _this2.getApi('saveConsentFlags', {
						method: 'consent.provideBulk',
						httpMethod: 'post'
					});

					api.psend({
						aliases: Object.keys(result).reduce(function (obj, key) {
							obj['' + key.replace('consent_', '')] = result[key];

							return obj;
						}, {})
					});
				}

				return result;
			});
		},
		show: function show() {
			var _this3 = this;

			var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SettingsCancelTypes.guest;

			for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				args[_key - 1] = arguments[_key];
			}

			return this.callParent('show', args).then(function (result) {
				if (!result) {
					if (type === SettingsCancelTypes.guest) {
						return _this3.rwom1('#actionPopup').show(ResponseTemplates.actionError, 'Your request cannot be completed until you approve the Personal Data processing rules.').then(function () {
							return false;
						});
					} else if (type === SettingsCancelTypes.member) {
						return _this3.rwom1('#deletePopup').show().then(function (result) {
							if (result === false) {
								return _this3.showForMember();
							}

							return result;
						});
					}
				}

				return result;
			});
		},
		sumbitForm: function sumbitForm(button) {
			var _this4 = this;

			return this.rwom1('#form').submit().then(function (values) {
				if (values !== false) {
					_this4.hide();
					return values;
				}

				return null;
			});
		},
		onCancel: function onCancel() {
			this.hide();

			return fox.Promise.resolve(false);
		}
	}, 'GDPR_BasePopup');

	// account action response popup
	fox.registerWidget(PopupWidgetClasses.actionResponse, {
		configure: function configure() {
			var _this5 = this;

			this.registerOptions('', {
				additionalClasses: 'gdpr-small',
				hideOnOkPressed: true,
				onOkPress: function onOkPress(button) {
					if (_this5.getOption('hideOnOkPressed')) {
						_this5.hide();
					}

					return fox.Promise.resolve(button);
				}
			});

			this.callParent('configure', arguments);
		},
		show: function show(template) {
			var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

			var content = this.rwom1('#content');
			content.setOption('template', template);
			content.setTemplateOptions('text', text);

			content.render();

			for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
				args[_key2 - 2] = arguments[_key2];
			}

			return this.callParent('show', args);
		}
	}, 'GDPR_BasePopup');

	// account delete final popup
	fox.registerWidget(PopupWidgetClasses.deleteAccountFinal, {
		configure: function configure() {
			var _this6 = this;

			this.registerOptions('', {
				contentTemplate: 'gdpr_account_delete_final_popup',
				additionalClasses: 'gdpr-small',
				onOkPress: function onOkPress() {
					return _this6.removeAccount.apply(_this6, arguments);
				},
				widgets: {
					actionPopup: {
						widget: PopupWidgetClasses.actionResponse,
						hideOnOkPressed: false
					}
				}
			});

			this.callParent('configure', arguments);
		},
		removeAccount: function removeAccount(button) {
			var _this7 = this;

			var deleteApi = this.getApi('deleteApi', {
				method: !!fox.getEnv('site.id') ? 'user.deleteAccount' : 'client.delete',
				httpMethod: !!fox.getEnv('site.id') ? 'get' : 'post'
			});
			var actionPopup = this.rwom1('#actionPopup');

			var restoreButtonState = changeButtonState(button, 'deleting...');
			return deleteApi.psend().then(function (resp) {
				restoreButtonState();
				_this7.hide();

				return actionPopup.show(ResponseTemplates.deleteSuccess).then(
				/** @param {HTMLButtonElement} button */
				function (button) {
					var restoreButtonState = changeButtonState(button, 'please wait...');
					return _this7.getWom().getRoot().logout().then(function () {
						return restoreButtonState;
					});
				}).then(function (restoreButtonState) {
					return restoreButtonState();
				});
			}).catch(function (err) {
				restoreButtonState();
				_this7.hide();
				return actionPopup.show(ResponseTemplates.actionError, err.params.answer.message).then(function () {
					return false;
				});
			});
		}
	}, 'GDPR_BasePopup');

	// account delete confirm popup
	fox.registerWidget(PopupWidgetClasses.deleteAccount, {
		configure: function configure() {
			var _this8 = this;

			this.registerOptions('', {
				contentTemplate: 'gdpr_account_delete_confirm_popup',
				additionalClasses: 'gdpr-small',
				onOkPress: function onOkPress() {
					var _rwom;

					return (_rwom = _this8.rwom1('#deleteAccount')).show.apply(_rwom, arguments);
				},
				widgets: {
					deleteAccount: {
						widget: PopupWidgetClasses.deleteAccountFinal
					}
				}
			});

			this.callParent('configure', arguments);
		}
	}, 'GDPR_BasePopup');

	// account rules manipulation popup
	fox.registerWidget(PopupWidgetClasses.rulesActions, {
		configure: function configure() {
			var _this9 = this;

			this.registerOptions('', {
				contentTemplate: 'gdpr_account_rules_action_popup',
				additionalClasses: 'gdpr-small',
				onOkPress: function onOkPress() {
					return _this9.sumbitForm.apply(_this9, arguments);
				},
				widgets: {
					actionPopup: {
						widget: PopupWidgetClasses.actionResponse
					},
					actions: {
						widget: 'Control_Select',
						embed: {
							widget: '@parent #content'
						},
						'!embed.container': '#actions-select',
						autoRender: true,
						select: {
							options: OptionValues.map(function (value, idx) {
								return {
									title: value,
									selected: idx === 0,
									disabled: idx === 0,
									value: idx
								};
							}),
							attributes: {
								name: 'actions'
							}
						}
					},
					form: {
						widget: 'DomForm',
						formSelector: '#form-content',
						validateOnFly: true,
						elements: {
							actions: {
								womContainer: '@parent #actions',
								validators: [function (value) {
									return { result: Number(value) !== 0 };
								}]
							}
						}
					}
				},
				handleWom: {
					changed: {
						widget: '#form',
						event: 'change',
						callback: function callback(_ref2) {
							var field = _ref2.field,
							    value = _ref2.value;

							if (field === 'actions') {
								_this9._bindData.emptyValue = value === OptionValues[0];

								_this9._center();
							}
						}
					},
					validation: {
						widget: '#form',
						event: ['form_not_valid', 'form_valid'],
						callback: function callback(infos, form) {
							return infos.forEach(function (_ref3) {
								var field = _ref3.field,
								    result = _ref3.result;

								if (field === 'actions') {
									var _form$getElement$getN = form.getElement(field).getNodes(),
									    _form$getElement$getN2 = _slicedToArray(_form$getElement$getN, 1),
									    select = _form$getElement$getN2[0];

									var container = select.parentNode;

									if (!result) {
										return container.classList.add('error');
									}

									return container.classList.remove('error');
								}
							});
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},
		prepareEmbeddedWidgets: function prepareEmbeddedWidgets() {
			this._bindData = {
				emptyValue: true
			};

			this.rwom1('#content').bindTemplateVariables(this._bindData, ['emptyValue']);

			this.callParent('prepareEmbeddedWidgets', arguments);
		},
		sumbitForm: function sumbitForm(button) {
			var _this10 = this;

			var sendApi = this.getApi('sendApi', {
				method: 'site.gdprRequest',
				encodePost: true,
				httpMethod: 'post'
			});
			var actionPopup = this.rwom1('#actionPopup');
			var form = this.rwom1('#form');

			return form.submit().then(function (values) {
				if (values === false) {
					return null;
				}

				var restoreButtonState = changeButtonState(button, 'submiting...');

				return sendApi.psend({
					subject: OptionValues[values.actions],
					comment: values.comment
				}).then(function (resp) {
					restoreButtonState();
					_this10._resetForm();
					_this10.hide();
					return actionPopup.show(ResponseTemplates.requestSuccess).then(function () {
						return true;
					});
				}).catch(function (err) {
					restoreButtonState();
					_this10._resetForm();
					_this10.hide();
					return actionPopup.show(ResponseTemplates.actionError, err.params.answer.message).then(function () {
						return false;
					});
				});
			});
		},
		_resetForm: function _resetForm() {
			var form = this.rwom1('#form');

			form.setValue('actions', '0');
			form.setValue('comment', '');

			form.getElement('actions').womContainer.change();
		}
	}, 'GDPR_BasePopup');

	fox.registerWidget(PopupWidgetClasses.attentionActions, {
		configure: function configure() {
			var _this11 = this;

			this.registerOptions('', {
				contentTemplate: 'gdpr_account_attention_popup',
				additionalClasses: 'gdpr-small',
				onOkPress: function onOkPress() {
					return _this11.onCancel();
				},
				dialog: {
					close: function close() {
						return _this11.onCancel();
					}
				}
			}), this.callParent('configure', arguments);
		},
		onCancel: function onCancel() {
			this.hide();

			return fox.Promise.resolve(false);
		}
	}, 'GDPR_BasePopup');
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check

var _require = __webpack_require__(100),
    ENV_VAR_NAME_COOKIE = _require.ENV_VAR_NAME_COOKIE,
    SESSION_VAR_NAME_COOKIE = _require.SESSION_VAR_NAME_COOKIE;

var ENV_VAR_NAME = ENV_VAR_NAME_COOKIE;
var SESSION_VAR_NAME = SESSION_VAR_NAME_COOKIE;

var BannerClassName = exports.BannerClassName = 'GDPR_CookieBanner';

var BannerSelector = '#gdpr-cookie-accept';

/** @param {Fox} fox */
exports.factory = function (fox) {
	//@ts-ignore
	var _require2 = __webpack_require__(22)(fox),
	    delay = _require2.delay;

	var $ = fox.jQuery;

	fox.registerWidget(BannerClassName, {
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				autoRender: true,
				embed: {
					container: '#notification-container'
				},
				template: 'gdpr_cookie_banner',
				showBannerPredicat: function showBannerPredicat() {
					if (fox.site.getClass() === "FanApp") return false;
					var sessionFlag = localStorage.getItem(SESSION_VAR_NAME);

					if (!_this.userAccess) {
						return !sessionFlag;
					}

					return !fox.getEnv(ENV_VAR_NAME + '.cookiesStrict');
				},
				handleDom: {
					accept: {
						target: '#accept-cookies',
						callback: function callback() {
							return _this.acceptCookies();
						}
					},
					scroll: {
						event: 'scroll',
						target: document,
						eventChecker: function eventChecker(_) {
							return _this.isEmbedded();
						},
						callback: function callback() {
							var bar = $(fox.dom.selectFirst(BannerSelector));
							var barHeight = bar.height();
							var scrollTop = $(window).scrollTop();

							if (scrollTop > 30) {
								bar.css('top', _this._getBannerYPos(false) - 2);
								bar.addClass('sticky');
							} else {
								bar.css('top', '0');
								bar.removeClass('sticky');
							}
						}
					}
				},
				handleWom: {
					onLayoutChanged: {
						event: 'addedToDom',
						widget: '@root .Site_Layout',
						callback: function callback() {
							return !_this.isEmbedded() && _this.render();
						}
					}
				}
			});
			this.callParent('configure', arguments);
		},
		init: function init() {
			this.showBannerPredicat = this.requireOption('showBannerPredicat');
			this.userAccess = this.wom1('@root #permissionManager') ? !this.rwom1('@root #permissionManager').hasAccess('guestActual') : fox.isObject(fox.site.member);
		},
		activate: function activate() {
			var _this2 = this,
			    _arguments = arguments;

			if (this.showBannerPredicat()) {
				return delay(2000).then(function () {
					return _this2.callParent('activate', _arguments);
				});
			}
		},
		prepareEmbeddedWidgets: function prepareEmbeddedWidgets() {
			this._bindData = {
				position: '-300%'
			};

			this.bindTemplateVariables(this._bindData, ['position']);

			this.callParent('prepareEmbeddedWidgets', arguments);
		},
		_getBannerYPos: function _getBannerYPos() {
			var skipNodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			var anotherBanners = fox.dom.select('.strip-notification-wrapper');
			var myNode = fox.dom.selectFirst(BannerSelector);

			if (anotherBanners.length > 1) {
				return anotherBanners.reduce(function (acc, bannerNode) {
					if (bannerNode === myNode) return acc;

					return acc + (skipNodes ? 0 : bannerNode.clientHeight);
				}, 2);
			}

			return 0;
		},
		addedToDom: function addedToDom() {
			var _this3 = this;

			this.callParent('addedToDom', arguments);

			delay(100).then(function () {
				_this3._bindData.position = _this3._getBannerYPos() + 'px';
			});
		},
		acceptCookies: function acceptCookies() {
			var api = this.getApi('_cookieConsent', {
				method: 'consent.provideBulk',
				httpMethod: 'post'
			});

			this.closeBanner();

			if (this.userAccess) {
				api.psend({
					aliases: {
						cookiesFunctional: 1,
						cookiesPerformance: 1,
						cookiesStrict: 1
					}
				});
			} else {
				localStorage.setItem(SESSION_VAR_NAME, new Date().getTime().toString());
			}
		},
		closeBanner: function closeBanner() {
			this._bindData.position = '-300%';
			this.removeFromDom();
		},
		beforeEmbed: function beforeEmbed() {
			var _this4 = this,
			    _arguments2 = arguments;

			if (this.showBannerPredicat()) {
				return delay(2000).then(function () {
					return _this4.callParent('beforeEmbed', _arguments2);
				});
			}
		},
		removeFromDom: function removeFromDom() {
			delay(410).then(function () {
				var myNode = fox.dom.selectFirst(BannerSelector);

				if (myNode) {
					myNode.parentNode.removeChild(myNode);
				}
			});
		},
		embedToDom: function embedToDom(container) {
			if (!this.isEmbedded()) {
				container.appendChild(this.fragment);
			}
		},
		isEmbedded: function isEmbedded() {
			return !fox.isEmpty(fox.dom.selectFirst(BannerSelector));
		}
	});
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check

exports.ENV_VAR_NAME_COOKIE = 'cookiesConsents';

exports.SESSION_VAR_NAME_COOKIE = '_scpb_';

exports.ENV_VAR_NAME_TOS = 'getConsents';

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';
	__webpack_require__(102);
	__webpack_require__(19);
	__webpack_require__(104);
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(103);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../node_modules/stylus-loader/index.js??ref--6-3!./_dialog.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../node_modules/stylus-loader/index.js??ref--6-3!./_dialog.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".ui-dialog.dlg-amc{position:fixed;z-index:1000;max-width:96%;min-width:310px}.ui-dialog.dlg-amc.dlg-pos-abs{position:absolute}.ui-dialog.dlg-amc .p-t{padding-top:30px}.ui-dialog.dlg-amc .p-b{padding-bottom:30px}.ui-dialog.dlg-amc .p-l{padding-left:30px}.ui-dialog.dlg-amc .p-r{padding-right:30px}.ui-dialog.dlg-amc .ui-dialog-titlebar{background-color:#5d7bd0;color:#fff;padding:20px 60px 20px 30px;border-radius:5px 5px 0 0;line-height:normal;cursor:move}.ui-dialog.dlg-amc .ui-dialog-titlebar .ui-dialog-title{font-size:20px}.ui-dialog.dlg-amc .ui-dialog-titlebar-close{cursor:pointer;display:inline-block;width:45px;height:40px;margin:0;border:none;position:absolute;right:5px;top:14px}.ui-dialog.dlg-amc .ui-dialog-content{background-color:#fff;border-radius:0 0 5px 5px}.ui-dialog.dlg-amc .ui-dialog-content .ui-dialog-buttonpane{margin-top:0!important}.ui-dialog.dlg-amc .ui-dialog-buttonpane{text-align:center;padding:19px;background:#fbfbfb;border-top:1px solid #d4d4d4;border-radius:0 0 5px 5px;margin-top:-4px}.ui-dialog.dlg-amc .ui-dialog-buttonpane .ui-button{margin:0 5px;padding:0 15px;height:31px}.ui-dialog.dlg-amc~.ui-widget-overlay{position:fixed;top:0;right:0;bottom:0;left:0;background-color:rgba(0,0,0,.75);z-index:999}.ui-dialog.dlg-amc .gui-notice-item{position:relative;animation:none;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;display:none;transition:opacity .2s;border-radius:0}.ui-dialog.dlg-amc .gui-notice-item.open{display:block;-ms-filter:none;filter:none;opacity:1}.ui-dialog.dlg-amc.dlg-amc-success .ui-dialog-titlebar{background-color:#5aac23}.ui-dialog.dlg-amc.dlg-amc-error .ui-dialog-titlebar{background-color:#ed5758}.ui-dialog.dlg-amc .separator{border-color:#ddd;border-style:solid}.ui-dialog.dlg-amc .separator.bottom{border-width:0 0 1px}.ui-dialog.dlg-amc .separator.top{border-width:1px 0 0}.dlg-content{padding:20px}.dlg-footer{border-color:#d4d4d4;background-color:#fbfbfb;border-radius:0 0 5px 5px}.dlg-footer,.dlg-footer .inner{border-width:1px 0 0;border-style:solid}.dlg-footer .inner{border-color:#fff;padding:19px}.dlg-footer .inner:after{content:\"\";display:table;width:100%}.dlg-footer .guiButton{margin-left:5px}.ui-dialog-form .row{margin-bottom:10px}.ui-dialog-form .row .ml{margin-left:10px}.ui-dialog-form .row.pt{padding-top:10px}.ui-dialog-form>.row:last-child{margin-bottom:0}.ui-dialog-form label{margin-bottom:5px;display:block}.ui-dialog-form .block{display:block;width:100%}.ui-dialog-form .code-wrapper{font-size:10px}.ui-dialog-form.inline .row{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.ui-dialog-form.inline .row label{margin-bottom:0;min-width:130px;line-height:31px}.ui-dialog-form.inline .row .field-wrapper{-moz-flex:1 auto;-ms-flex:1 auto;flex:1 auto}.ui-dialog-form.inline .row .field-wrapper .block{width:100%}@media (max-width:767px){.ui-dialog.dlg-amc{width:96%!important}}@media (min-width:768px){.ui-dialog.dlg-amc:not(.no-max-width){max-width:700px}}", ""]);

// exports


/***/ }),
/* 104 */
/***/ (function(module, exports) {

(function (fox, $){
    'use strict';
    fox.registerWidget('PopupWidget', {
        configure: function (options){
            this.registerOptions('', {
                template: '',
                additionalClass: '',
                autoReposition: true,
                repositionTopSpace: 0,
                dialog: {
                    autoOpen: options.autoOpen || false,
                    dialogClass: 'dlg-amc dark-overlay',
                    title: options.title,
                    closeText: '',
                    width: 'auto'
                },
                handleWom: {
                    dOnShow: {
                        event: 'show',
                        widget: '@this',
                        'params.prefix': 'uniqPopEvent',
                        callback: function () {
                            $(fox.dom.selectFirst('.wrapper')).addClass('blured');

                            if (this.getOption('autoReposition') === true) {
                                setTimeout(fox.bind(function (){
                                    this._switchChangeEvents(true);
                                    this.switchPositionPopupClass(true);
                                }, this), 50);
                            }
                        }
                    },
                    dOnHide: {
                        event: 'hide',
                        widget: '@this',
                        'params.prefix': 'uniqPopEvent',
                        callback: function () {
                            $(fox.dom.selectFirst('.wrapper')).removeClass('blured');
                          
                            if (this.getOption('autoReposition') === true) {
                                this._switchChangeEvents(false);
                                this.switchPositionPopupClass(false);
                            }
                        }
                    },
                    centering1: {
                        event: 'addedToDom',
                        widget: '@this ~.Widget',
                        callback: function () {
                            this._center();
                        },
                        'params.prefix': 'centering_popup'
                    },
                    centering2: {
                        event: 'playerRunning',
                        widget: '@this ~.Html5Player',
                        callback: function () {
                            this._center();
                        },
                        'params.prefix': 'centering_popup'
                    }
                }
            });
            
            this.callParent('configure', arguments);
        },

        init: function () {
            this
                .setOption('dialog.dialogClass', this.getOption('dialog.dialogClass') + ' ' + this.getOption('additionalClass'));

            if (this.getOption('autoReposition') === true) {
                var that = this;

                this._callReposition = function(event) {
                    if (that.timerId) {
                        window.clearTimeout(that.timerId);
                        that.timerId = false;
                    }

                    that.timerId = window.setTimeout(function() {
                        that.reposition(event.type);
                    }.bind(that), 300);
                };
            }

            this.callParent('init', arguments);
        },

        embed: function() {
            this.callParent('embed', arguments);

            this.toggleHidden(true);

            if (fox.utils.isTouchDevice()) {
                this.addTouchEvents();
            }
        },

        addTouchEvents: function() {
            this.dialogMethod('widget')
                .find('.ui-dialog-titlebar-close')
                .on('touchend', function(e) {
                    e.preventDefault();
                    this.click();
                });
        },

        setButtonsId: function () {
            if (this.getOption('dialog.buttons')) {
                fox.each(this.getOption('dialog.buttons'), function (val, key) {
                    val.id = val.id ? val.id + '_' + this.getId() : val.text.toLowerCase() + '_' + this.getId();
                }, this);

            } else return;
        },

        dialogDestroy: function () {
            this.dialogMethod('destroy');
           
            return this;
        },

        _switchChangeEvents: function(type) {
            var nameListener = type ? 'addEventListener' : 'removeEventListener';
            var nameEvent = fox.utils.isTouchDevice() ? 'orientationchange' : 'resize';

            window[nameListener](nameEvent, this._callReposition);
        },

        switchPositionPopupClass: function(state) {
            if (state) {
                var isBig = this.popupIsBig();
                fox.dom[isBig ? 'addClass' : 'removeClass']('dlg-pos-abs', this.element);
                this._reposition(isBig);
            } else {
                fox.dom.removeClass('dlg-pos-abs', this.element);
            }
        },

        popupIsBig: function() {
            return window.innerHeight < this.element[0].offsetHeight;
        },

        _reposition: function(state) {
            if (!state) {
                this.toggleHidden(true);
                this._center();
                return;
            }

            this.toggleHidden();

            var top = parseInt(this.getOption('repositionTopSpace'));

            this.element[0].style.top = top + 'px';
            window.scrollTo(0, top);
        },

        reposition: function(eventName) {
            if (this.popupIsBig()) {
                this.switchPositionPopupClass(true);
            } else {
                this._center();
            }
        },

        hide: function() {
			this.callParent('hide', arguments);
            this.toggleHidden();
            
			return this;
        },
        
        toggleHidden: function(state) {
            document.querySelector('html').classList[!!state ? 'add' : 'remove']('hidden-scroll');
        }
        
    }, 'Dialog');
})(fox, fox.jQuery);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//@ts-check
/**
 * 
 * @param {Fox} fox
 */
module.exports = function (fox, parentPopupName) {
    return fox.registerWidget('Popup_Common', {
        configure: function configure() {
            this.registerOptions('', {
                widgets: {
                    content: {
                        widget: 'Widget',
                        template: 'div.popup-content',
                        autoRender: true,
                        container: '#popup-widget-container',
                        'handleDom.close': {
                            target: '.close',
                            callback: '@parent:hide'
                        },
                        'handleDom.cloneOnParent': {
                            target: '.close',
                            targetWidget: '@parent',
                            callback: '@parent:hide'
                        }
                    }
                }
            });

            this.callParent('configure', arguments);
        }
    }, 'PopupWidget');
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';

	__webpack_require__(107)(fox);
	__webpack_require__(108);
	__webpack_require__(110);
	__webpack_require__(112)(fox, fox.jQuery);
};


/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("gdpr_account_delete_confirm_after_login_popup", [["div",{"id":"form-content","class":"popup-content-wrapper _p-a-20"},[["div",{"class":"_fs-12","data-fox-alias":"1","data-fox-context":"gdpr_account_delete_confirm_after_login_popup"},[["textNode",{"text":" Under the GDPR law we are obligated to have your consent in order to process your data (uploaded content, fans, message history, etc). Your account cannot properly function without data processing. "}],["p",{"class":"_tc-err"},[["textNode",{"text":"Therefore, when revoking your consent you must delete your account, after which all your data will be erased."}]]]]]]]]);
fox.registerTemplate("gdpr_account_request_success_popup", [["div",{"id":"form-content","class":"popup-content-wrapper _p-a-20"},[["div",{"class":"_fs-12","style":"line-height:16px","data-fox-alias":"1","data-fox-context":"gdpr_account_request_success_popup"},[["textNode",{"text":" Your request has been sent. An account manager will contact you to confirm and finalize the termination of your account. "}]]]]]]);
fox.registerTemplate("gdpr_account_request_sorry_popup", [["div",{"id":"form-content","class":"popup-content-wrapper _p-a-20"},[["div",{"class":"_fs-12","style":"line-height:16px","data-fox-alias":"1","data-fox-context":"gdpr_account_request_sorry_popup"},[["textNode",{"text":" Your request cannot be completed until you approve the Personal Data processing rules. "}]]]]]]);
fox.registerTemplate("gdpr_account_rules_action_popup", [["div",{"id":"form-content","class":"popup-content-wrapper _p-a-20"},[["div",{"class":"_fs-12 _m-b-20","data-fox-alias":"1","data-fox-context":"gdpr_account_rules_action_popup"},[["textNode",{"text":" What would you like to do? "}]]],["div",{"id":"actions-select","style":"width:100%;"}],["div",{"class":"_m-t-20 &&0&&","style":"width:100%;"},[["textarea",{"class":"gdpr-textarea","placeholder":"Comment","name":"comment","cols":"30","rows":"5"}]],[["emptyValue","class",false,[{"name":"empty","params":[]},{"name":"hideIfFalse","params":[]}],"bind"]]]]]]);
fox.registerTemplate("gdpr_account_action_error_popup", [["div",{"id":"form-content","class":"popup-content-wrapper _p-a-20"},[["div",{"class":"_fs-12"},[["textNode",{"text":" "}],["span",{},[],[["text","__text",true]]],["textNode",{"text":" "}]]]]]]);
fox.registerTemplate("gdpr_account_delete_success_popup", [["div",{"id":"form-content","class":"popup-content-wrapper _p-a-20"},[["div",{"class":"_fs-12","data-fox-alias":"1","data-fox-context":"gdpr_account_delete_success_popup"},[["textNode",{"text":" Your request has been sent. An account manager will contact you to confirm and finalize the termination of your account. "}]]]]]]);
fox.registerTemplate("gdpr_account_delete_confirm_popup", [["div",{"id":"form-content","class":"popup-content-wrapper _p-a-20"},[["div",{"class":"_fs-12","data-fox-alias":"1","data-fox-context":"gdpr_account_delete_confirm_popup"},[["textNode",{"text":" You are attempting to delete your account and all your personal data, but if you still have active premium subscribers - you can’t do that. If you still want to delete your account, please be aware that this action can’t be undone. "}]]],["div",{"class":"_fs-12 _tc-err _m-t-20","data-fox-alias":"2","data-fox-context":"gdpr_account_delete_confirm_popup"},[["textNode",{"text":" All your subscribers will be gone forever "}]]]]]]);
fox.registerTemplate("gdpr_settings_popup", [["div",{"id":"form-content","class":"popup-content-wrapper _p-a-20"},[["div",{"class":"_fs-14 _m-b-20","data-fox-alias":"1","data-fox-context":"gdpr_settings_popup"},[["strong",{},[["textNode",{"text":"In order to provide you with the best possible expirience and get the technical elements up and running, we need your consent to process your personal data."}]]]]],["div",{"class":"_fs-14 _m-b-20","data-fox-alias":"2","data-fox-context":"gdpr_settings_popup"},[["strong",{},[["textNode",{"text":"Personal Data Processing"}]]]]],["label",{"for":"checkbox1","class":"form-label _flex"},[["div",{"class":"gdpr-checkbox _m-r-15 _m-l-5"},[["input",{"type":"checkbox","name":"consent_tos","id":"checkbox1","required":""}],["textNode",{"text":" "}],["span",{"class":"shape"}],["textNode",{"text":" "}],["span",{"class":"check"}]]],["span",{"class":"_fs-12","data-fox-alias":"3","data-fox-context":"gdpr_settings_popup"},[["textNode",{"text":"By checking this box, I certify that I am at least 18-years old, have the capacity to enter into legally binding contracts, and have read and agree to the "}],["span",{"onclick":"event.stopPropagation();"},[["a",{"target":"_blank","href":"/operator-agreement"},[["textNode",{"text":" Operator Agreement"}]]]]]]]]],["div",{"class":"_fs-14 _m-t-20","data-fox-alias":"4","data-fox-context":"gdpr_settings_popup"},[["strong",{},[["textNode",{"text":"Communication"}]]]]],["label",{"for":"checkbox2","class":"form-label _flex  _m-t-15"},[["div",{"class":"gdpr-checkbox _m-r-15 _m-l-5"},[["input",{"type":"checkbox","name":"consent_marketing","id":"checkbox2"}],["textNode",{"text":" "}],["span",{"class":"shape"}],["textNode",{"text":" "}],["span",{"class":"check"}]]],["span",{"class":"_fs-12","data-fox-alias":"5","data-fox-context":"gdpr_settings_popup"},[["textNode",{"text":"I agree to receive e-mails with special offers, news and updates from ModelCentro family of products"}]]]]]]]]);
fox.registerTemplate("gdpr_account_delete_final_popup", [["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center _p-a-20"},[["div",{"class":"_fs-12"},[["textNode",{"text":" This is the final step of deleting your account. Please be aware that this action cannot be undone "}]]],["div",{"class":"_fs-12 _m-t-20"},[["textNode",{"text":"All your data (paid content, subscriptions, message history) will be deleted."}]]],["div",{"class":"_fs-12 _m-t-20","style":"width:100%","data-fox-alias":"4"},[["textNode",{"text":"Please type \"DELETE\" to confirm"}]]],["div",{"class":"_fs-14 _m-t-10","style":"width:100%"},[["input",{"type":"text","class":"mc-form-field confirmDelete","placeholder":"DELETE","name":"confirmDelete"}]]]]]]);
fox.registerTemplate("gdpr_cookie_banner", [["div",{"id":"gdpr-cookie-accept","class":"strip-notification-wrapper not-verified","style":"transform: translateY(0);"},[["div",{"class":"strip-notification-content"},[["p",{"class":""},[["textNode",{"text":"Hey there! Cookies are required to use this site. Feel free to check out our Cookie Policy at any time."}]]],["div",{"class":"_flex-1 _flex _row-n _r-h-end _m-l-20"},[["button",{"id":"accept-cookies","class":"gdpr-gookie-banner-button"},[["textNode",{"text":"I don’t mind Cookies"}]]]]]]]]]]);
fox.registerTemplate("gdpr_account_attention_popup", [["div",{"id":"form-content","class":"popup-content-wrapper _flex _col-n _c-h-center _p-a-20"},[["div",{"class":"_fs-12"},[["textNode",{"text":" Under the GDPR law we are obligated to have your consent in order to process your data (uploaded content, fans, message history, etc). Your account cannot properly function without data processing. "}],["p",{},[["textNode",{"text":"Therefore, when revoking your consent you must delete your account, after which all your data will be erased."}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(109);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./gdpr.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./gdpr.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".gdpr-checkbox .shape{border-color:#ddd}.gdpr-checkbox .check{height:10px;width:16px;border-color:#424242}.gdpr-textarea{background-color:#fff;border:1px solid #ddd;padding:8px 12px;color:#464646}.mc-checkbox .checkbox-wrap{max-width:17px}", ""]);

// exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(111);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./stripNotification.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?minimize!../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../node_modules/stylus-loader/index.js??ref--6-3!./stripNotification.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".strip-notification-wrapper{position:relative;width:100%;box-shadow:0;padding:15px 20px;min-height:54px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;transition:transform .4s;transform:translateY(-100%);z-index:16;-ms-box-sizing:border-box;box-sizing:border-box}.strip-notification-wrapper.sticky{position:fixed;left:0;right:0}.strip-notification-wrapper.opened{transform:translate(0)}.strip-notification-wrapper.verified{background-color:#6cb758}.strip-notification-wrapper.not-verified{background-color:#f3c045}.strip-notification-wrapper.verification-sent{background-color:#516dbd}.strip-notification-wrapper.verification-failed{background-color:#ee4949}.strip-notification-wrapper .strip-notification-icon-wrapper{display:inline-block}.strip-notification-wrapper .strip-notification-content{max-width:960px;margin:0 auto;min-height:100%;color:#fff;font-size:12px;line-height:14px;font-family:Arial,Helvetica,sans-serif}.strip-notification-wrapper .strip-notification-content,.strip-notification-wrapper .strip-notification-content .email-verification-item{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row;flex-flow:row;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center}@media screen and (max-width:768px){.strip-notification-wrapper .strip-notification-content{font-size:11px}}.strip-notification-wrapper .strip-notification-content a{text-decoration:underline;cursor:pointer;color:#fff}.strip-notification-wrapper .strip-notification-content p{text-shadow:0;margin:0}.strip-notification-wrapper .strip-notification-content i{margin-right:15px}.gdpr-gookie-banner-button{font-family:Arial}", ""]);

// exports


/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root #home":{"handleDom.exersizeRights.target":[{"value":".exersise-rights","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"@root #home","_fox_":1}],"handleDom.exersizeRights.callback":[{"value":function () {
fox.site.rwom1('#gdprRulesActions').show().then(function (result) {
console.log(result);
}.bind(this));
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101011},"path":"@root #home","_fox_":1}]},"@root ~.GDPR_BasePopup #content":{"handleDom.onSuccess.targetWidget":[{"value":"@parent","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101017},"path":"@root ~.GDPR_BasePopup #content","_fox_":1}],"handleDom.onCancel.targetWidget":[{"value":"@parent","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101019},"path":"@root ~.GDPR_BasePopup #content","_fox_":1}]},"@root #gdprMainPopup":{"dialog.title":[{"value":"Attention","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101037},"path":"@root #gdprMainPopup","_fox_":1}],"dialog.width":[{"value":"390px","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101037},"path":"@root #gdprMainPopup","_fox_":1}],"dialog.buttons":[{"value":[{"text":"Proceed","click":function () {},"class":"button-with-spinner mc-btn btn-small btn-casual","id":"on-success"},{"text":"Cancel","click":function () {},"class":"mc-btn btn-small btn-minor","id":"on-cancel"}],"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101037},"path":"@root #gdprMainPopup","_fox_":1}],"darkOverlay":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101039},"path":"@root #gdprMainPopup","_fox_":1}],"widgets.deletePopup.widget":[{"value":"GDPR_AccountAttentionActions","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101043},"path":"@root #gdprMainPopup","_fox_":1}],"widgets.deletePopup.contentTemplate":[{"value":"gdpr_account_request_sorry_popup","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101044},"path":"@root #gdprMainPopup","_fox_":1}],"widgets.deletePopup.dialog.title":[{"value":"Sorry","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101050},"path":"@root #gdprMainPopup","_fox_":1}],"widgets.deletePopup.dialog.close":[{"value":function () {
fox.wom.selectFirst('~#gdprMainPopup').show(1);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101050},"path":"@root #gdprMainPopup","_fox_":1}]},"@root #gdprMainPopup #content":{"targetWidget":[{"value":"@parent","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":"@root #gdprMainPopup #content","_fox_":1}]},"@root ~.GDPR_AccountActionResponse":{"darkOverlay":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101053},"path":"@root ~.GDPR_AccountActionResponse","_fox_":1}],"dialog.title":[{"value":"Success","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101063},"path":"@root ~.GDPR_AccountActionResponse","_fox_":1}],"dialog.width":[{"value":"450px","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101063},"path":"@root ~.GDPR_AccountActionResponse","_fox_":1}],"dialog.buttons":[{"value":[{"text":"Ok","click":function () {},"class":"mc-btn btn-small btn-minor btn-casual","id":"on-cancel"}],"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101063},"path":"@root ~.GDPR_AccountActionResponse","_fox_":1}]},"@root ~.GDPR_AccountActionResponse #content":{"targetWidget":[{"value":"@parent","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101067},"path":"@root ~.GDPR_AccountActionResponse #content","_fox_":1}]},"@root ~.GDPR_AccountDeleteFinal":{"additionalClass":[{"value":"dlg-amc-error","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101069},"path":"@root ~.GDPR_AccountDeleteFinal","_fox_":1}],"dialog.title":[{"value":"Deleting Account - Final Step","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101089},"path":"@root ~.GDPR_AccountDeleteFinal","_fox_":1}],"dialog.width":[{"value":"390px","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101089},"path":"@root ~.GDPR_AccountDeleteFinal","_fox_":1}],"dialog.buttons":[{"value":[{"text":"Delete","click":function () {},"class":"button-with-spinner mc-btn btn-small btn-critical delete-final","id":"on-success"},{"text":"Cancel","click":function () {},"class":"mc-btn btn-small btn-minor","id":"on-cancel"}],"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101089},"path":"@root ~.GDPR_AccountDeleteFinal","_fox_":1}],"dialog.open":[{"value":function (event, ui) {
var button = fox.dom.selectFirst('.delete-final');
button.setAttribute('disabled', 1);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101089},"path":"@root ~.GDPR_AccountDeleteFinal","_fox_":1}],"darkOverlay":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101091},"path":"@root ~.GDPR_AccountDeleteFinal","_fox_":1}],"handleDom.deleteKeyup.targetWidget":[{"value":"#content","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101093},"path":"@root ~.GDPR_AccountDeleteFinal","_fox_":1}],"handleDom.deleteKeyup.target":[{"value":".confirmDelete","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101094},"path":"@root ~.GDPR_AccountDeleteFinal","_fox_":1}],"handleDom.deleteKeyup.event":[{"value":"keyup","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101095},"path":"@root ~.GDPR_AccountDeleteFinal","_fox_":1}],"handleDom.deleteKeyup.callback":[{"value":function (el, e) {
var button = fox.dom.selectFirst('.delete-final');
if (el.value === 'DELETE') button.removeAttribute('disabled');
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101099},"path":"@root ~.GDPR_AccountDeleteFinal","_fox_":1}]},"@root ~.GDPR_AccountDeleteFinal #content":{"targetWidget":[{"value":"@parent","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101102},"path":"@root ~.GDPR_AccountDeleteFinal #content","_fox_":1}]},"@root ~.GDPR_AccountDeleteConfirm":{"additionalClass":[{"value":"dlg-amc-error","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101104},"path":"@root ~.GDPR_AccountDeleteConfirm","_fox_":1}],"dialog.title":[{"value":"Warning","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101120},"path":"@root ~.GDPR_AccountDeleteConfirm","_fox_":1}],"dialog.width":[{"value":"390px","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101120},"path":"@root ~.GDPR_AccountDeleteConfirm","_fox_":1}],"dialog.buttons":[{"value":[{"text":"Delete","click":function () {},"class":"button-with-spinner mc-btn btn-small btn-critical","id":"on-success"},{"text":"Cancel","click":function () {},"class":"mc-btn btn-small btn-minor","id":"on-cancel"}],"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101120},"path":"@root ~.GDPR_AccountDeleteConfirm","_fox_":1}],"darkOverlay":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101126},"path":"@root ~.GDPR_AccountDeleteConfirm","_fox_":1}]},"@root ~.GDPR_AccountDeleteConfirm #content":{"targetWidget":[{"value":"@parent","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101125},"path":"@root ~.GDPR_AccountDeleteConfirm #content","_fox_":1}]},"@root ~.GDPR_AccountRulesActions":{"dialog.title":[{"value":"Exercise Your Rights Under GDPR","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101142},"path":"@root ~.GDPR_AccountRulesActions","_fox_":1}],"dialog.width":[{"value":"450px","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101142},"path":"@root ~.GDPR_AccountRulesActions","_fox_":1}],"dialog.buttons":[{"value":[{"text":"Submit Request","click":function () {},"class":"button-with-spinner mc-btn btn-small btn-casual","id":"on-success"},{"text":"Cancel","click":function () {},"class":"mc-btn btn-small btn-minor","id":"on-cancel"}],"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101142},"path":"@root ~.GDPR_AccountRulesActions","_fox_":1}]},"@root ~.GDPR_AccountRulesActions #content":{"targetWidget":[{"value":"@parent","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101146},"path":"@root ~.GDPR_AccountRulesActions #content","_fox_":1}]},"@root ~.GDPR_AccountAttentionActions":{"dialog.title":[{"value":"Attention","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101157},"path":"@root ~.GDPR_AccountAttentionActions","_fox_":1}],"dialog.width":[{"value":"390px","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101157},"path":"@root ~.GDPR_AccountAttentionActions","_fox_":1}],"dialog.buttons":[{"value":[{"text":"Ok","click":function () {},"class":"button-with-spinner mc-btn btn-small btn-casual","id":"on-success"}],"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101157},"path":"@root ~.GDPR_AccountAttentionActions","_fox_":1}],"darkOverlay":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101159},"path":"@root ~.GDPR_AccountAttentionActions","_fox_":1}]},"@root ~.GDPR_AccountAttentionActions #content":{"targetWidget":[{"value":"@parent","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101161},"path":"@root ~.GDPR_AccountAttentionActions #content","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
    'use strict';

    var require__template = __webpack_require__(114);
    var require__js = __webpack_require__(121);

    __webpack_require__(125)(fox);

    require__template.keys().forEach(function (_module) {
        return require__template(_module)(fox);
    });
    require__js.keys().forEach(function (_module) {
        return require__js(_module)(fox, fox.jQuery);
    });
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./error.tpl": 115,
	"./forgot-form.tpl": 117,
	"./login-form.tpl": 118,
	"./verification-form.tpl": 119
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 114;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("login_verification_form_error_en", [["div",{"class":"auth-page"},[["div",{"class":"box auth-form verification-form error"},[["div",{"class":"title"},[["textNode",{"text":"2-Step verification"}]]],["div",{"class":"container"},[["div",{"class":"verification-data error-sate"},[["p",{},[["span",{"data-fox-alias":"2"},[["textNode",{"text":"Your device is blocked for"}]]],["textNode",{"text":" "}],["span",{},[],[["cooldown","__text",true,[],"bind"]]],["textNode",{"text":" "}],["span",{"data-fox-alias":"3"},[["textNode",{"text":"minutes"}]]],["textNode",{"text":"."}]]],["p",{},[["strong",{},[["span",{"data-fox-alias":"4"},[["textNode",{"text":"Please try again later"}]]]]]]],["img",{"src":"" + __webpack_require__(116) + ""}]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/login-wizard/images/login-denied.png", __webpack_require__.p + "components/login-wizard/images/login-denied.png");

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("forgot_form", [["div",{"class":"auth-page"},[["div",{"class":"box auth-form login-form"},[["div",{"class":"title"},[["textNode",{"text":" password recovery "}]]],["div",{"class":"container"},[["form",{"id":"forgot-form"},[["div",{"class":"row"},[["label",{"class":"input fill"},[["input",{"type":"text","name":"email","placeholder":"Your email"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]]]],["div",{"class":"row btns"},[["div",{"class":"action-btns"},[["a",{"id":"change-form-login","class":"btn btn-primary-simple"},[["textNode",{"text":"Cancel"}]]],["textNode",{"text":" "}],["button",{"id":"send-forgot","type":"submit","class":"btn btn-primary button-with-spinner"},[["textNode",{"text":"Send"}]]]]]]]]]]]]]]]]);
fox.registerTemplate("passrecovery_form", [["div",{"class":"auth-page"},[["div",{"class":"box auth-form changepass-form"},[["div",{"class":"title"},[["textNode",{"text":" Change Password "}]]],["p",{"class":"info-text"}],["div",{"class":"container"},[["p",{"id":"info-forgot"}],["form",{"id":"recovery-form"},[["if",{"notempty":""},[["div",{"class":"fields"},[["div",{"class":"row"},[["label",{"class":"input fill"},[["input",{"type":"password","id":"password","placeholder":"New password"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]]]],["div",{"class":"row"},[["label",{"class":"input fill"},[["input",{"type":"password","id":"confirm","placeholder":"Confirm password"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]]]]]],["div",{"class":"row btns buttons"},[["div",{"class":"action-btns"},[["a",{"id":"form-submit","class":"btn btn-primary button-with-spinner"},[["textNode",{"text":"Change "}]]]]]]],["else",{},[["div",{"class":"notice-container","style":"display:block"},[["p",{"id":"info-forgot","data-fox-alias":"6"},[["textNode",{"text":" The password reset request has expired, please click "}],["a",{"href":"/login"},[["textNode",{"text":"here"}]]],["textNode",{"text":" to make another request. "}]]]]]]]],[["success","notempty",true,[{"name":"notEmpty","params":[]}]]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("member_login", [["div",{"class":"auth-page"},[["div",{"class":"box auth-form login-form"},[["div",{"class":"title"},[["textNode",{"text":" login "}]]],["div",{"class":"container"},[["form",{"id":"login-form"},[["div",{"class":"row"},[["label",{"class":"input fill"},[["input",{"type":"text","name":"email","placeholder":"Your email"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]]]],["div",{"class":"row"},[["label",{"class":"input fill"},[["input",{"type":"password","name":"passwd","placeholder":"Password"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]]]],["div",{"class":"row btns"},[["div",{"class":"action-btns"},[["a",{"href":"/registration","class":"btn btn-primary-simple"},[["textNode",{"text":"Signup"}]]],["textNode",{"text":" "}],["button",{"type":"submit","id":"form-submit","class":"btn btn-primary button-with-spinner"},[["textNode",{"text":"Login"}]]]]],["div",{"class":"simple pass-recovery-wrapper"},[["a",{"id":"change-form-forgot"},[["textNode",{"text":" Forgot Password? "}]]]]]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("verification_form", [["div",{"class":"auth-page"},[["div",{"class":"box auth-form verification-form"},[["div",{"class":"title"},[["textNode",{"text":"2-Step verification"}]]],["div",{"class":"container"},[["form",{"id":"verification-form"},[["div",{"class":"verification-data"},[["p",{"data-fox-alias":"2"},[["textNode",{"text":"A text message with your code has been sent to:"}]]],["p",{"class":"phone-number-mask"},[["span",{},[],[["phone.number","__text",true]]]]],["p",{},[["a",{"href":"http://help.modelcentro.com/account-and-profile/how-do-i-change-my-verified-phone-number","target":"_blank"},[["textNode",{"text":"Incorrect number?"}]]]]]]],["div",{"class":"row flex-wide"},[["label",{"data-fox-alias":"3"},[["textNode",{"text":"Enter received code:"}]]]]],["div",{"class":"row"},[["label",{"class":"input fill"},[["input",{"type":"text","name":"verificationCode"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]]]],["div",{"class":"row flex-wide actions"},[["div",{"class":"action-wrapper"}],["a",{"style":"line-height: 16px;","href":"http://help.modelcentro.com/account-and-profile/i-didnt-receive-sms-verification-code-what-do-i-do","target":"_blank","data-fox-alias":"4"},[["textNode",{"text":"Didn’t receive it?"}]]]]],["div",{"class":"row btns"},[["button",{"id":"form-submit","class":"btn btn-primary button-with-spinner"},[["span",{"data-fox-alias":"6"},[["textNode",{"text":"Login"}]]]]]]]]]]]]]]]]);
fox.registerTemplate("login_verification_form_action", [["if",{"notempty":""},[["div",{"class":"state success"},[["span",{"class":"icon"},[["img",{"src":"" + __webpack_require__(120) + ""}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Code was sent"}]]]]]],[["state","notempty",true,[{"name":"eq","params":["success"]}]]]],["if",{"notempty":""},[["div",{"class":"state cooldown"},[["textNode",{"text":" Resend new code ("}],["span",{"class":"counter"},[["span",{},[],[["cooldown","__text",true,[],"bind"]]]]],["textNode",{"text":") "}]]]],[["state","notempty",true,[{"name":"eq","params":["cooldown"]}]]]],["if",{"notempty":""},[["div",{"class":"state available"},[["a",{"id":"send-new-code"},[["textNode",{"text":"Resend new code"}]]]]]],[["state","notempty",true,[{"name":"eq","params":["available"]}]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("components/login-wizard/images/icon-sms-success.png", __webpack_require__.p + "components/login-wizard/images/icon-sms-success.png");

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./forgot-form.es.js": 122,
	"./login-form.es.js": 123,
	"./verification-form.es.js": 124
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 121;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
    'use strict';

    fox.registerWidget('MCP_Login_Wizard_ForgotForm', {
        configure: function configure() {
            this.registerOptions('', {
                template: 'forgot_form'
            });

            return this.callParent('configure', arguments);
        },
        getTextMessage: function getTextMessage(alias) {
            var msg = '';

            switch (alias) {
                case 'emailNotValid':
                    msg = 'Email is not valid';
                case 'fieldNotEmpty':
                    msg = 'Fields shouldn\'t be empty';
                    break;
            }

            return msg;
        },
        showErrorMessage: function showErrorMessage(msg, fieldName) {
            //console.log(msg, fieldName)
            var $elm = $(this.dom1('[name="' + fieldName + '"]')).parent().find('.error-container');

            $elm.text(msg);
        },
        answerSendRecoveryMail: function answerSendRecoveryMail(response) {
            this.togglePreloader(false);

            if (!response.success) {
                this.notices.pushNotification({
                    noticeTemplate: 'new_notice',
                    noticeType: 'error',
                    noticeMessage: response.text,
                    noticeAlias: 'loginError',
                    delayClose: 3000
                });
                var button = fox.dom.selectFirst('.button-with-spinner', this.element);
                fox.dom.removeClass('spin', button);
            } else {
                $('.fill').text(response.text);
                $('.action-btns').html('<a href="/" class="btn btn-primary">OK</a>').css({ 'justify-content': 'center' });
            }
        }
    }, 'Login_Wizard_ForgotForm');
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
    'use strict';

    fox.registerWidget('MCP_Login_Wizard_LoginForm', {
        configure: function configure() {
            this.registerOptions('', {
                '--widgets.snManager': 1,
                redirectUrl: 'models'
                // 'widgets.authApi': {
                //     method: 'Affiliate.authorizer.auth',
                // }
            });

            return this.callParent('configure', arguments);
        },
        running: function running() {
            this.rwom1('#authApi').setOption('method', 'Affiliate.authorizer.securedAuth');

            this.callParent('running', arguments);

            this.notices = fox.wom.selectFirst('~.Layout_Promo_Auth ~#throughNotifications');
        },
        formSubmitError: function formSubmitError(err) {
            //this.showErrorMessage(err.answer.reason);
            //this.togglePreloader(false);

            this.notices.pushNotification({
                noticeTemplate: 'new_notice',
                noticeType: 'error',
                noticeMessage: err.answer.reason,
                noticeAlias: 'loginError',
                delayClose: 3000
            });

            this.togglePreloader(false);
        },
        getTextMessage: function getTextMessage(alias) {
            var msg = '';

            switch (alias) {
                case 'emailNotValid':
                    msg = 'Email is not valid';
                    break;
                case 'fieldNotEmpty':
                    msg = 'Fields shouldn\'t be empty';
                    break;
            }

            return msg;
        },
        showErrorMessage: function showErrorMessage(msg, fieldName) {
            //console.log(msg, fieldName)
            var $elm = $(this.dom1('[name="' + fieldName + '"]')).parent().find('.error-container');

            $elm.text(msg);
        },
        login: function login(response) {
            var redirectUrl = this.getOption('redirectUrl');

            if (redirectUrl) {
                fox.Navigator.update({ 0: redirectUrl }, true);
            }

            window.location.reload(true);
        }
    }, 'Login_Wizard_LoginForm');
};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	'use strict';

	fox.registerWidget('MCP_Verification_Form', {
		configure: function configure() {
			this.registerOptions('', {
				'!template': 'verification_form',
				templateOptions: { phone: { number: 'xxxxxxx11' } }
			});

			this.callParent('configure', arguments);
		},


		// _handleFormValidation(formData) {
		// 	var isValid = true;

		//     formData.forEach(resp => {
		// 		var $elm = $(this.dom1(''.concat('[name="', resp.field, '"]'))).parent();

		// 		if (resp.result === false) {
		// 			$elm.addClass('error');
		// 			$elm.find('.message').text(resp.message);
		// 			isValid = false;

		// 			return;
		// 		}

		// 		$elm.removeClass('error');
		// 		$elm.find('.message').text('');
		// 	});
		// },

		toggleFieldError: function toggleFieldError(name, state, msg) {
			var $elm = $('[name="' + name + '"]').parent();

			if (state === true) {
				$elm.removeClass('error');
				$elm.find('.error-container').text('');

				return;
			}

			$elm.addClass('error');
			$elm.find('.error-container').text(msg);
		}
	}, 'Verification_Form');
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';

	__webpack_require__(126);

	var require__template = __webpack_require__(128);

	require__template.keys().forEach(function (module) {
		require__template(module)(fox);
	});

	var require__js = __webpack_require__(133);

	require__js.keys().forEach(function (module) {
		require__js(module)(fox);
	});
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(127);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_style.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_style.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./forgot-password-form.tpl": 129,
	"./login-verification-error.tpl": 130,
	"./login-verification-form.tpl": 132
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 128;

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("login_verification_forgot_form_en", [["div",{"class":"guest-form guest-login-form"},[["form",{"class":"form login-form","id":"forgot-form"},[["div",{"class":"form-content"},[["div",{"class":"title"},[["span",{"data-fox-alias":"1","data-fox-context":"login_verification_forgot_form_en"},[["textNode",{"text":"Password Recovery"}]]]]],["div",{"class":"notice-container"},[["p",{"id":"info-forgot"},[["span",{"data-fox-alias":"2","data-fox-context":"login_verification_forgot_form_en"},[["textNode",{"text":"Please enter your registration e-mail address."}]]]]]]],["div",{"class":"notice-container error","style":"display: none","id":"errors"},[["strong",{"data-fox-alias":"promoModelErrorsTitle","data-fox-context":"login_verification_forgot_form_en"},[["span",{"data-fox-alias":"3","data-fox-context":"login_verification_forgot_form_en"},[["textNode",{"text":"Errors found"}]]]]],["div",{"class":"txt"},[["p"]]]]],["div",{"class":"fields"},[["div",{"class":"row"},[["label",{},[["span",{"data-fox-alias":"4","data-fox-context":"login_verification_forgot_form_en"},[["textNode",{"text":"Your Email Address"}]]],["textNode",{"text":":"}]]],["div",{"class":"guiInput2 amc-styled-form-field"},[["input",{"name":"email","id":"email-forgot","type":"text","placeholder":"example@mail.com","class":"field-forgot"}]]]]]]],["div",{"class":"buttons no-marg-bot"},[["a",{"id":"change-form-login","class":"fleft guiButton guiMiddle guiColorMinor"},[["span",{"data-fox-alias":"5","data-fox-context":"login_verification_forgot_form_en"},[["textNode",{"text":"Cancel"}]]]]],["a",{"id":"send-forgot","class":"fright guiButton guiMiddle guiColorMajor white button-with-spinner"},[["span",{"data-fox-alias":"6","data-fox-context":"login_verification_forgot_form_en"},[["textNode",{"text":"Send"}]]]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("login_verification_form_error_en", [["div",{"class":"guest-form"},[["form",{"class":"form login-form verification-form","id":"verification-form"},[["div",{"class":"form-content"},[["div",{"class":"title"},[["span",{"data-fox-alias":"1"},[["textNode",{"text":"2-Step verification"}]]]]],["div",{"class":"verification-data error-sate"},[["p",{},[["span",{"data-fox-alias":"2"},[["textNode",{"text":"Your device is blocked for"}]]],["textNode",{"text":" "}],["span",{},[],[["cooldown","__text",true,[],"bind"]]],["textNode",{"text":" "}],["span",{"data-fox-alias":"3"},[["textNode",{"text":"minutes"}]]],["textNode",{"text":"."}]]],["p",{},[["strong",{},[["span",{"data-fox-alias":"4"},[["textNode",{"text":"Please try again later"}]]]]]]],["img",{"src":"" + __webpack_require__(131) + ""}]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/area/model/promo2/components/login-wizard/images/login-denied.png", __webpack_require__.p + "_/_/_/model/promo2/components/login-wizard/images/login-denied.png");

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("login_verification_form_en", [["div",{"class":"guest-form"},[["form",{"class":"form login-form verification-form","id":"verification-form"},[["div",{"class":"form-content"},[["div",{"class":"title","data-fox-alias":"1","data-fox-context":"login_verification_form_en"},[["textNode",{"text":"2-Step verification"}]]],["div",{"class":"verification-data"},[["p",{"data-fox-alias":"2","data-fox-context":"login_verification_form_en"},[["textNode",{"text":"A text message with your code has been sent to:"}]]],["p",{"class":"phone-number-mask"},[["span",{},[],[["phone.number","__text",true]]]]],["p",{},[["a",{"href":"http://help.modelcentro.com/account-and-profile/how-do-i-change-my-verified-phone-number","target":"_blank"},[["textNode",{"text":"Incorrect number?"}]]]]]]],["div",{"class":"fields"},[["div",{"class":"row"},[["div",{"class":"flex-wide"},[["label",{"data-fox-alias":"3","data-fox-context":"login_verification_form_en"},[["textNode",{"text":"Enter received code:"}]]]]],["div",{"class":"guiInput2 amc-styled-form-field"},[["input",{"type":"text","name":"verificationCode","class":"fields2send not-empty"}],["textNode",{"text":" "}],["span",{"class":"valid-ico"},[["i",{"class":"i_attention_20"}]]],["div",{"class":"tooltip validation-error-box"},[["div",{"class":"css3-holder message"}]]]]]]],["div",{"class":"row flex-wide"},[["div",{"class":"action-wrapper"}],["a",{"style":"line-height: 16px;","href":"http://help.modelcentro.com/account-and-profile/i-didnt-receive-sms-verification-code-what-do-i-do","target":"_blank","data-fox-alias":"4","data-fox-context":"login_verification_form_en"},[["textNode",{"text":"Didn’t receive it?"}]]]]]]],["div",{"class":"buttons"},[["a",{"id":"form-submit","class":"fright guiButton guiMiddle guiColorMajor button-with-spinner white-spin","tabindex":"3"},[["span",{"data-fox-alias":"6","data-fox-context":"login_verification_form_en"},[["textNode",{"text":"Login"}]]]]]]]]]]]]]]);
fox.registerTemplate("login_verification_form_action_en", [["if",{"notempty":""},[["div",{"class":"state success"},[["i",{"class":"i_done_16"}],["textNode",{"text":" "}],["span",{"data-fox-alias":"1","data-fox-context":"login_verification_form_action_en"},[["textNode",{"text":"Code was sent"}]]]]]],[["state","notempty",true,[{"name":"eq","params":["success"]}]]]],["if",{"notempty":""},[["div",{"class":"state cooldown"},[["span",{"data-fox-alias":"2","data-fox-context":"login_verification_form_action_en"},[["textNode",{"text":"Resend new code"}]]],["textNode",{"text":" ("}],["span",{"class":"counter"},[["span",{},[],[["cooldown","__text",true,[],"bind"]]]]],["textNode",{"text":") "}]]]],[["state","notempty",true,[{"name":"eq","params":["cooldown"]}]]]],["if",{"notempty":""},[["div",{"class":"state available"},[["a",{"id":"send-new-code"},[["span",{"data-fox-alias":"3","data-fox-context":"login_verification_form_action_en"},[["textNode",{"text":"Resend new code"}]]]]]]]],[["state","notempty",true,[{"name":"eq","params":["available"]}]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./forgot-form.es.js": 134,
	"./login-form.es.js": 135,
	"./wizard.es.js": 137
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 133;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	'use strict';

	var _ = {
		getTranslation: function getTranslation(alias) {
			var translation = {
				'emailNotValid': function emailNotValid() {
					return fox.i18n.getTranslation('emailNotValid', 'Email is not valid', 'tooltip');
				},
				'fieldNotEmpty': function fieldNotEmpty() {
					return fox.i18n.getTranslation('fieldNotEmpty', 'Fields shouldn\'t be empty', 'tooltip');
				}
			};

			return translation[alias] || '';
		}
	};

	fox.registerWidget('Login_Wizard_ForgotForm', {
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				template: 'login_verification_forgot_form_en',
				widgets: {
					forgotPassword: {
						widget: 'PasswordRecovery'
					},
					form: {
						widget: 'DomForm',
						formSelector: '#forgot-form',
						elements: {
							email: {
								validators: [{
									validator: 'regexp',
									options: { type: 'email' },
									message: this.getTextMessage('emailNotValid')
								}, function (value) {
									return {
										result: value.length > 0,
										message: _this.getTextMessage('fieldNotEmpty')
									};
								}]
							}
						}
					}
				},
				handleWom: {
					formInvaliadate: {
						widget: '#form',
						event: ['form_valid', 'form_not_valid'],
						callback: this._handleFormValidation.bind(this)
					},

					sendRecoveryMail: {
						widget: '#forgotPassword',
						event: 'sendRecoveryMail',
						callback: 'answerSendRecoveryMail'
					}
				},
				handleDom: {
					formButtonSubmit: {
						target: '#send-forgot',
						callback: '_submit'
					},
					formSubmit: {
						target: '#forgot-form',
						event: 'submit',
						callback: '_submit'
					},
					cancel: {
						target: '#change-form-login',
						callback: '@parent:showLoginForm'
					},
					focus: {
						target: 'input[name="email"]',
						event: 'focus',
						callback: function callback() {
							$('.notice-container .txt p').text('');
							_this.errorBox.hide();
						}
					}
				}
			});

			return this.callParent('configure', arguments);
		},

		_handleFormValidation: function _handleFormValidation(formData, form) {
			var _this2 = this;

			formData.forEach(function (resp) {
				var $elm = $(_this2.dom1(''.concat('[name="', resp.field, '"]'))).parent();

				if (resp.result === false) {
					_this2.showErrorMessage(resp.message, resp.field);
					$elm.addClass('error');

					return;
				}

				$elm.removeClass('error');
			});
		},
		showErrorMessage: function showErrorMessage(message) {
			var errItem = $('.notice-container .txt p').text(message);
			this.errorsContainer.html('').append(errItem);
			this.errorBox.show();
		},
		rendering: function rendering() {
			this.callParent('rendering', arguments);

			this.errorBox = $(this.dom('#errors'));
			this.errorsContainer = $(this.dom('#errors .txt'));
		},
		_submit: function _submit(el, w, alias, e) {
			var _this3 = this;

			fox.jQuery.Event(e).preventDefault();

			this.wom1('#form').submit().then(function (result) {
				if (result === false) {
					return;
				}

				_this3.togglePreloader(true);

				_this3.submit(result.email);
			});

			return false;
		},
		togglePreloader: function togglePreloader(state) {
			var btn = this.dom1('#send-forgot');

			if (!btn) {
				return;
			}

			fox.dom[state ? 'addClass' : 'removeClass']('spin', btn);
		},
		submit: function submit(email) {
			var input = fox.dom.selectFirst('#email-forgot', this.element);

			this.wom1('#forgotPassword').sendRecoveryMail(email);

			input.readonly = true;
			input.parentNode.style.opacity = 0.5;
		},
		answerSendRecoveryMail: function answerSendRecoveryMail(answer) {
			var infoForgotElm = fox.dom.selectFirst('#info-forgot', this.element);
			var input = fox.dom.selectFirst('#email-forgot', this.element);

			this.togglePreloader(false);

			infoForgotElm.parentElement.style.display = 'block';
			infoForgotElm.innerHTML = answer.text;

			input.readonly = false;
			input.parentNode.style.opacity = 1;
		},
		getTextMessage: function getTextMessage(alias) {
			return _.getTranslation(alias);
		}
	});
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	'use strict';

	var UA_PARSER = __webpack_require__(136);

	var _ = {
		getTranslation: function getTranslation(alias) {
			var translation = {
				'emailNotValid': function emailNotValid() {
					return fox.i18n.getTranslation('emailNotValid', 'Email is not valid', 'tooltip');
				},
				'fieldNotEmpty': function fieldNotEmpty() {
					return fox.i18n.getTranslation('fieldNotEmpty', 'Fields shouldn\'t be empty', 'tooltip');
				}
			};

			return translation[alias] || '';
		}
	};

	fox.registerWidget('Login_Wizard_LoginForm', {
		configure: function configure() {
			var _this = this;

			this.registerOptions('', {
				template: 'member_login',
				container: '.login-form-wrapper',
				widgets: {
					snManager: {
						widget: 'SocialNetwork_Manager',
						autoRender: true,
						mode: 'signin',
						template: 'socialnetwork_oauth_signin_container',
						'embed.container': '.social-fields',

						list: {
							'tpl.row': 'socialnetwork_oauth_signin',
							'embed.container': '#items-block',
							handleDom: {
								socialClick: {
									target: 'a.soc-button',
									event: 'click',
									callback: '@parent:socialClickHandler'
								}
							},
							'hooks.onStopRendering': '@parent @parent:onNetworksStopRendering'
						},

						'handleWom.successLogin': {
							widget: '@this',
							event: 'successLogin',
							callback: '@parent:snLogin'
						},
						'handleWom.readyForReg': {
							widget: '@this',
							event: 'readyForReg',
							callback: '@parent:snConnect'
						},
						'handleWom.readyFor2FaLogin': {
							widget: '@this',
							event: 'readyFor2FaLogin',
							callback: '@parent:snLogin'
						},
						'handleWom.errorIn2FaLogin': {
							widget: '@this',
							event: 'errorIn2FaLogin',
							callback: '@parent:sn2FaLoginError'
						}
					},

					form: {
						widget: 'DomForm',
						formSelector: '#login-form',
						elements: {
							email: {
								validators: [{
									validator: 'regexp',
									options: { type: 'email' },
									message: this.getTextMessage('emailNotValid')
								}, function (value) {
									return {
										result: value.length > 0,
										message: _this.getTextMessage('fieldNotEmpty')
									};
								}]
							},
							passwd: {
								validators: [function (value) {
									return {
										result: value.length > 0,
										message: _this.getTextMessage('fieldNotEmpty')
									};
								}]
							}
						}
					},

					authApi: {
						widget: 'Api',
						method: 'site.authorizer.securedAuth',
						httpMethod: 'post'
					}
				},

				handleWom: {
					formInvaliadate: {
						widget: '#form',
						event: ['form_valid', 'form_not_valid'],
						callback: this._handleFormValidation.bind(this)
					}
				},
				handleDom: {
					snRegister: {
						target: '#reg-from-login',
						event: 'click',
						callback: 'snRegister'
					},
					formButtonSubmit: {
						target: '#form-submit',
						event: 'click',
						callback: '_submit'
					},
					switchToForgotForm: {
						target: '#change-form-forgot',
						event: 'click',
						callback: 'showForgotPasswordForm'
					},
					submitByEnter: {
						event: 'keyup',
						target: 'input',
						eventChecker: function eventChecker(e) {
							return e.keyCode === 13;
						},
						callback: '_submit'
					}
				}
			});

			return this.callParent('configure', arguments);
		},
		init: function init() {
			return this.callParent('init', arguments);
		},
		running: function running() {
			this.callParent('running', arguments);
		},
		rendering: function rendering() {
			this.callParent('rendering', arguments);

			this.errorBox = $(this.dom('#errors'));
			this.errorsContainer = $(this.dom('#errors .txt'));
		},
		_submit: function _submit(el, w, alias, e) {
			var _this2 = this;

			fox.jQuery.Event(e).preventDefault();

			this.wom1('#form').submit().then(function (result) {
				if (result === false) {
					return;
				}

				_this2.togglePreloader(true);

				_this2.submit().then(function (resp) {
					var response = resp.params.answer.response;

					_this2.togglePreloader(false);

					if (response.authentificationKey) {
						_this2.showVerificationForm(response);

						return;
					}

					_this2.login(response);
				}).catch(function (err) {
					var p = err.params;
					var code = p.answer.code;

					if ([1053, 1054].includes(code)) {

						_this2.show2FaError(p.answer);
						return;
					}

					// if (p.answer.code === 1053) {
					// 	this.wom1('@parent').showError(p.answer.reason);
					// 	return;
					// }

					// if (p.answer.code === 1054) {
					// 	this.wom1('@parent').showError(p.answer.reason);
					// 	return;
					// }

					_this2.formSubmitError(p);
				});
			});
		},
		submit: function submit() {
			var _this3 = this;

			return this.getUDID().then(function (_udid) {
				var data = _this3.wom1('#form').getValues();

				Object.keys(data).forEach(function (key) {
					data[key] = window.encodeURIComponent(data[key]);
				});

				return _this3.wom1('#authApi').psend(fox.merge(data, { udid: _udid, device: _this3.getDeviceData() }));
			});
		},
		formSubmitError: function formSubmitError(err) {
			this.showErrorMessage(err.answer.reason);
			this.togglePreloader(false);
		},
		showErrorMessage: function showErrorMessage(message) {
			var errItem = $('.notice-container .txt p').text(message);
			this.errorsContainer.html('').append(errItem);
			this.errorBox.show();
		},
		snLogin: function snLogin(data) {
			if (!fox.isEmpty(data.twoFactorAuth)) {
				this.showVerificationForm(data.twoFactorAuth);

				return;
			}

			this.login(data);
		},
		snConnect: function snConnect(data, w) {
			this.clientProfile = data;
			this.dom1('#sn-login-' + w.appName + '-notice').style.display = 'block';
		},
		snRegister: function snRegister() {
			fox.cookie.set('snProfile', JSON.stringify(this.clientProfile));
			fox.site.gotoPage('home/registration');
		},
		sn2FaLogin: function sn2FaLogin(eventData) {},
		login: function login(response) {
			var redirectUrl = this.getOption('redirectUrl');

			if (response && response[0] === 'studio') {
				window.location.assign(['http://studio.', window.location.host, '/'].join(''));
			}

			if (!response.member) {
				// error
				return;
			}

			fox.log('logged in, hash: "' + response.hash + '", member: ' + response.member.collection);

			if (redirectUrl) {
				fox.Navigator.update({ 0: redirectUrl }, true);
			}

			window.location.reload(true);
		},
		togglePreloader: function togglePreloader(state) {
			var btn = this.dom1('#form-submit');

			if (!btn) {
				return;
			}

			fox.dom[state ? 'addClass' : 'removeClass']('spin', btn);
		},
		_handleFormValidation: function _handleFormValidation(formData, form) {
			var _this4 = this;

			var msg = '';

			formData.forEach(function (resp) {
				var $elm = $(_this4.dom1(''.concat('[name="', resp.field, '"]'))).parent();

				if (resp.result === false) {
					_this4.showErrorMessage(resp.message, resp.field);
					$elm.addClass('error');

					return;
				}

				$elm.removeClass('error');
			});
		},
		showVerificationForm: function showVerificationForm(data) {
			this.wom1('@parent').showVerificationForm(data);
		},
		getDeviceData: function getDeviceData() {
			var data = new UA_PARSER();
			var _replace = function _replace(obj) {
				fox.each(obj, function (val, key) {
					if (!val) {
						obj[key] = '';
					}
				});

				return obj;
			};

			return {
				device: _replace(data.getDevice()),
				os: _replace(data.getOS()),
				browser: data.getBrowser().name
			};
		},
		getUDID: function getUDID() {
			return this.wom1('@parent').getUDID();
		},
		showForgotPasswordForm: function showForgotPasswordForm() {
			this.wom1('@parent').showForgotPasswordForm();
		},
		getTextMessage: function getTextMessage(alias) {
			return _.getTranslation(alias);
		},
		onNetworksStopRendering: function onNetworksStopRendering() {
			var buttons = this.wom1('#snManager #list').dom('a.soc-button');

			this.getUDID().then(function (_udid) {

				buttons.forEach(function (elm) {
					var reqUrl = elm.getAttribute('data-request-url');

					elm.setAttribute('data-request-url', reqUrl + '&transitParams[udid]=' + _udid);
				});
			});
		},
		sn2FaLoginError: function sn2FaLoginError(data) {
			this.show2FaError(data.error);
		},
		show2FaError: function show2FaError(err) {

			if (err.code === 1053) {
				this.wom1('@parent').showError(err.reason);
				return;
			}

			if (err.code === 1054) {
				this.wom1('@parent').showError(err.reason);
				return;
			}
		}
	});
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.18
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 or MIT
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.18',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var margedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    margedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    margedRegexes[i] = regexes[i];
                }
            }
            return margedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            //var result = {},
            var i = 0, j, k, p, q, matches, match;//, args = arguments;

            /*// construct object barebones
            for (p = 0; p < args[1].length; p++) {
                q = args[1][p];
                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
            }*/

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
            // console.log(this);
            //return this;
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]*)/i,                                             // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
            ], [NAME, VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge|edgios|edgea)\/((\d+)?[\w\.]+)/i                             // Microsoft Edge
            ], [[NAME, 'Edge'], VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(puffin)\/([\w\.]+)/i                                              // Puffin
            ], [[NAME, 'Puffin'], VERSION], [

            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i
                                                                                // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /(qqbrowserlite)\/([\w\.]+)/i                                       // QQBrowserLite
            ], [NAME, VERSION], [

            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
            ], [NAME, VERSION], [

            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
            ], [NAME, VERSION], [

            /(BIDUBrowser)[\/\s]?([\w\.]+)/i                                    // Baidu Browser
            ], [NAME, VERSION], [

            /(2345Explorer)[\/\s]?([\w\.]+)/i                                   // 2345 Browser
            ], [NAME, VERSION], [

            /(MetaSr)[\/\s]?([\w\.]+)/i                                         // SouGouBrowser
            ], [NAME], [

            /(LBBROWSER)/i                                      // LieBao Browser
            ], [NAME], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
            ], [VERSION, [NAME, 'Facebook']], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /((?:oculus|samsung)browser)\/([\w\.]+)/i
            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /(coast)\/([\w\.]+)/i                                               // Opera Coast
            ], [[NAME, 'Opera Coast'], VERSION], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
            ], [[NAME, 'GSA'], VERSION], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,

                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]

            /* /////////////////////
            // Media players BEGIN
            ////////////////////////

            , [

            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
            /(coremedia) v((\d+)[\w\._]+)/i
            ], [NAME, VERSION], [

            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
            ], [NAME, VERSION], [

            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
            ], [NAME, VERSION], [

            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
            ], [NAME, VERSION], [
            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
            ], [NAME, VERSION], [

            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
            ], [[NAME, 'Flip Player'], VERSION], [

            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
            ], [NAME], [

            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                                // Gstreamer
            ], [NAME, VERSION], [

            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                                // Java/urllib/requests/wget/cURL
            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
            ], [NAME, VERSION], [

            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
            ], [[NAME, /_/g, ' '], VERSION], [

            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                                // MPlayer SVN
            ], [NAME, VERSION], [

            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
            ], [NAME, VERSION], [

            /(mplayer)/i,                                                       // MPlayer (no other info)
            /(yourmuze)/i,                                                      // YourMuze
            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
            ], [NAME], [

            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
            ], [NAME, VERSION], [

            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
            ], [NAME, VERSION], [

            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
            ], [NAME, VERSION], [

            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
            /(winamp)\s((\d+)[\w\.-]+)/i,
            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
            ], [NAME, VERSION], [

            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                                // inlight radio
            ], [NAME], [

            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                                // SoundTap/Totem/Stagefright/Streamium
            ], [NAME, VERSION], [

            /(smp)((\d+)[\d\.]+)/i                                              // SMP
            ], [NAME, VERSION], [

            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
            /(vlc)\/((\d+)[\w\.-]+)/i,
            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
            ], [NAME, VERSION], [

            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
            /(windows-media-player)\/((\d+)[\w\.-]+)/i
            ], [[NAME, /-/g, ' '], VERSION], [

            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                                // Windows Media Server
            ], [VERSION, [NAME, 'Windows']], [

            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
            ], [NAME, VERSION], [

            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
            ], [[NAME, 'rad.io'], VERSION]

            //////////////////////
            // Media players END
            ////////////////////*/

        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/.+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i                         // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
            /(zte)-(\w*)/i,                                                     // ZTE
            /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
                                                                                // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /d\/huawei([\w\s-]+)[;\)]/i,
            /(nexus\s6p)/i                                                      // Huawei
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w*)/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w*)/i                                                        // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]*)/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w*)/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+;\s(pixel c)\s/i                                          // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

            /android.+;\s(pixel xl|pixel)\s/i                                   // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            /android.+;\s(\w+)\s+build\/hm\1/i,                                 // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,    // Xiaomi Mi
            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i       // Redmi Phones
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i            // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu Tablet
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [

            /android.+a000(1)\s+build/i,                                        // OnePlus
            /android.+oneplus\s(a\d{4})\s+build/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

            /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i                      // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

            /android.+;\s(k88)\sbuild/i                                         // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

            /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i        // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i                            // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i                    // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

            /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i                     // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i          // Le Pan Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

            /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i                      // Gigaset Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL], [

            /(android[\w\.\s\-]{0,9});.+build/i                                 // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]


        /*//////////////////////////
            // TODO: move to string map
            ////////////////////////////

            /(C6603)/i                                                          // Sony Xperia Z C6603
            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
            /(C6903)/i                                                          // Sony Xperia Z 1
            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [

            /(T3C)/i                                                            // Advan Vandroid T3C
            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [

            /(V972M)/i                                                          // ZTE V972M
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [

            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [

            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [

            /////////////
            // END TODO
            ///////////*/

        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9}).+(gecko)/i                                       // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,                   // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]*)/i,                                     // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i,
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
            /linux;.+(sailfish);/i                                              // Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i                  // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w*)/i,                                            // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]*)/i,                                        // Hurd/Linux
            /(gnu)\s?([\w\.]*)/i                                                // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.\d]*)/i                                            // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i                    // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                   // Haiku
            ], [NAME, VERSION],[

            /cfnetwork\/.+darwin/i,
            /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i             // iOS
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

            /(mac\sos\sx)\s?([\w\s\.]*)/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,                             // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,                                // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
            /(unix)\s?([\w\.]*)/i                                               // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    /*
    var Browser = function (name, version) {
        this[NAME] = name;
        this[VERSION] = version;
    };
    var CPU = function (arch) {
        this[ARCHITECTURE] = arch;
    };
    var Device = function (vendor, model, type) {
        this[VENDOR] = vendor;
        this[MODEL] = model;
        this[TYPE] = type;
    };
    var Engine = Browser;
    var OS = Browser;
    */
    var UAParser = function (uastring, extensions) {

        if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
        //var browser = new Browser();
        //var cpu = new CPU();
        //var device = new Device();
        //var engine = new Engine();
        //var os = new OS();

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            //browser = new Browser();
            //cpu = new CPU();
            //device = new Device();
            //engine = new Engine();
            //os = new OS();
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };
    //UAParser.Utils = util;

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        // TODO: test!!!!!!!!
        /*
        if (require && require.main === module && process) {
            // cli
            var jsonize = function (arr) {
                var res = [];
                for (var i in arr) {
                    res.push(new UAParser(arr[i]).getResult());
                }
                process.stdout.write(JSON.stringify(res, null, 2) + '\n');
            };
            if (process.stdin.isTTY) {
                // via args
                jsonize(process.argv.slice(2));
            } else {
                // via pipe
                var str = '';
                process.stdin.on('readable', function() {
                    var read = process.stdin.read();
                    if (read !== null) {
                        str += read;
                    }
                });
                process.stdin.on('end', function () {
                    jsonize(str.replace(/\n$/, '').split('\n'));
                });
            }
        }
        */
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__(25)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if (typeof $ !== UNDEF_TYPE) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {

    'use strict';

    var EXO_UDID = __webpack_require__(16)(fox);

    __webpack_require__(138)(fox);
    __webpack_require__(139)(fox);

    fox.registerWidget('Login_Wizard', {
        configure: function configure() {
            this.registerOptions('', {
                widgets: {
                    login: {
                        widget: 'Login_Wizard_LoginForm',
                        active: true
                    },
                    phoneNumberAuth: {
                        widget: 'Verification_Form',
                        template: 'login_verification_form_en',
                        active: false
                    },
                    forgotPassword: {
                        widget: 'Login_Wizard_ForgotForm',
                        active: false
                    },
                    error: {
                        widget: 'Verification_Error',
                        template: 'login_verification_form_error_en',
                        active: false
                    }
                },

                handleWom: {
                    smsSendingError: {
                        widget: '#phoneNumberAuth',
                        event: 'sms_sending_error',
                        callback: '_handleSmsSendingApiResponse'
                    },
                    smsSendingSuccess: {
                        widget: '#phoneNumberAuth',
                        event: 'sms_sending_success',
                        callback: '_handleSmsSendingApiResponse'
                    },
                    smsVerificationError: {
                        widget: '#phoneNumberAuth',
                        event: 'sms_verification_error',
                        callback: '_handleSmsVerificationError'
                    },
                    smsVerificationSuccess: {
                        widget: '#phoneNumberAuth',
                        event: 'sms_verification_success',
                        callback: '_handleSmsVerificationSuccess'
                    },
                    errorTimerEnd: {
                        widget: '#error',
                        event: 'cooldown_end',
                        callback: '_handleErrorTimerEnd'
                    }
                }
            });

            this.registerOptions('.Widget', {
                group: 'forms',
                autoRender: true,
                embed: {
                    container: '.common-content',
                    widget: '@parent @parent'
                }
            });

            this.callParent('configure', arguments);
        },
        showVerificationForm: function showVerificationForm(data) {
            var w = this.wom1('#phoneNumberAuth');

            w.setData(data);

            w._sendCode();

            //this.switchEmbeddedWidget('phoneNumberAuth');
        },
        login: function login(data) {
            this.wom1('#login').login(data);
        },
        showError: function showError(timeLeft) {
            var widget = this.wom1('#error');

            this.switchEmbeddedWidget('error');

            return this.wait(widget, 'addedToDom', { prefix: 'verificationWizardStep_error' }).then(function () {
                widget.countdown(Number(timeLeft));
            });
        },
        showForgotPasswordForm: function showForgotPasswordForm() {
            this.switchEmbeddedWidget('forgotPassword');
        },
        showLoginForm: function showLoginForm() {
            this.switchEmbeddedWidget('login');
        },
        getUDID: function getUDID() {
            return EXO_UDID.getShortUid();
        },
        _handleSmsSendingApiResponse: function _handleSmsSendingApiResponse(answer) {
            var w = this.wom1('#phoneNumberAuth');

            if (answer.status === true) {
                w.switchActionWidgetState('success', { cooldown: answer.response });
            } else {
                if (answer.code === 1051) {
                    this.showLoginForm();

                    return;
                }

                w.switchActionWidgetState('cooldown', { cooldown: Number(answer.reason) });
            }

            this.switchEmbeddedWidget('phoneNumberAuth');
        },
        _handleErrorTimerEnd: function _handleErrorTimerEnd() {
            this.switchEmbeddedWidget('login');
        },
        _handleSmsVerificationError: function _handleSmsVerificationError(answer, w, alias, e) {
            if (answer.code === 1053) {
                this.showError(answer.reason);

                return;
            }
        },
        _handleSmsVerificationSuccess: function _handleSmsVerificationSuccess(answer) {
            this.login(answer.response);
        }
    }, 'Controller');
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	'use strict';

	var EXO_UDID = __webpack_require__(16)(fox);

	fox.registerWidget('Verification_Form', {
		configure: function configure() {
			this.registerOptions('', {
				template: 'login_verification_form_en',
				submitSelector: '#form-submit',
				widgets: {
					sendMessageApi: {
						widget: 'Api',
						method: 'site.authorizer.twoFactorAuth'
					},
					verifyCodeApi: {
						widget: 'Api',
						method: 'site.authorizer.verifyCode'
					},
					form: {
						widget: 'DomForm',
						formSelector: '#verification-form',
						elements: {
							verificationCode: {
								validators: [{
									validator: 'regexp',
									options: { regexp: /^\d{4}$/ },
									message: 'Entered code is incorrect'
								}, function (value) {
									return {
										result: value.length === 4,
										message: 'Entered code is incorrect'
									};
								}]
							}
						}
					},
					action: {
						widget: 'Widget',
						container: '.action-wrapper',
						template: 'login_verification_form_action_en',
						autoRender: true
					}
				},
				handleWom: {
					formInvaliadate: {
						widget: '#form',
						event: ['form_valid', 'form_not_valid'],
						callback: this._handleFormValidation.bind(this)
					}
				},
				handleDom: {
					formButtonSubmit: {
						target: '#form-submit',
						callback: '_submit'
					},
					formSubmit: {
						target: '#verification-form',
						event: 'submit',
						callback: '_submit'
					},
					focus: {
						target: 'input',
						event: 'focus',
						callback: function callback(elm) {
							this.toggleFieldError(elm.name, true);
						}
					},
					// input: {
					// 	target: 'input[type="text"]',
					// 	event: 'input',
					// 	callback: function(elm) {
					// 		this.wom1('#form').validate();
					// 	}
					// },
					sendCode: {
						targetWidget: '#action',
						target: "#send-new-code",
						callback: '_sendCode'
					}
				}
			});

			this.callParent('configure', arguments);
		},
		init: function init() {
			this._data = {};

			this.callParent('init', arguments);
		},
		prepareEmbeddedWidgets: function prepareEmbeddedWidgets() {
			var w = this.wom1('#action');

			w._bindData = {
				cooldown: 0
			};

			w.bindTemplateVariables(w._bindData, ['cooldown']);

			this.callParent('prepareEmbeddedWidgets', arguments);
		},
		setData: function setData(data) {
			this._data = data;

			this.setTemplateOptions('phone', this._data.phone);
		},
		getAuthKey: function getAuthKey() {
			return this._data.authentificationKey;
		},
		sendMessage: function sendMessage() {
			return this._sendMessage({ authentificationKey: this.getAuthKey() });
		},
		_sendMessage: function _sendMessage(data) {
			return this.wom1('#sendMessageApi').psend(data);
		},
		verifyCode: function verifyCode(params) {
			var _data = { authentificationKey: this.getAuthKey() };

			if (params && fox.isObject(params)) {
				_data = fox.merge(_data, params);
			}

			return this.wom1('#verifyCodeApi').psend(_data);
		},
		_handleFormValidation: function _handleFormValidation(formData) {
			var _this = this;

			var isValid = true;

			formData.forEach(function (resp) {
				var $elm = $(_this.dom1(''.concat('[name="', resp.field, '"]'))).parent();

				if (resp.result === false) {
					//$elm.addClass('error');
					//$elm.find('.message').text(resp.message);
					_this.toggleFieldError(resp.field, false, resp.message);

					return;
				}

				//$elm.removeClass('error');
				//$elm.find('.message').text('');
				_this.toggleFieldError(resp.field, true);
			});
		},
		toggleFieldError: function toggleFieldError(name, state, msg) {
			var $elm = $(this.dom1(''.concat('[name="', name, '"]'))).parent();

			if (state === true) {
				$elm.removeClass('error');
				$elm.find('.message').text('');

				return;
			}

			$elm.addClass('error');
			$elm.find('.message').text(msg);
		},
		_submit: function _submit(el, alias, w, e) {
			var _this2 = this;

			var form = this.wom1('#form');

			fox.jQuery.Event(e).preventDefault();

			form.submit().then(function (result) {

				if (result === false) {
					return;
				}

				_this2.togglePreloader(true);

				_this2.verifyCode(result).then(_this2._handleVerificationApiResponse.bind(_this2)).catch(_this2._handleVerificationApiResponse.bind(_this2));
			});
		},
		_handleVerificationApiResponse: function _handleVerificationApiResponse(resp) {
			var answer = resp.params.answer;

			this.togglePreloader(false);

			if (answer.status === false) {
				this.dispatchSMSVerificationErrorEvent(answer);

				if (answer.code === 1057) {
					this.toggleFieldError('verificationCode', false, 'Entered code is incorrect');
				}

				return;
			}

			fox.site.dispatchEvent('smsCode_successVerifiedPhone');
			this.dispatchSMSVerificationSuccessEvent(answer);
		},
		_sendCode: function _sendCode() {
			return this.sendMessage().then(this._handleSendMessageApiResponse.bind(this)).catch(this._handleSendMessageApiResponse.bind(this));
		},
		_handleSendMessageApiResponse: function _handleSendMessageApiResponse(resp) {
			var answer = resp.params.answer;

			if (answer.status === false) {
				this.dispatchSMSSendingErrorEvent(answer);

				return answer;
			}

			this.dispatchSMSSendingSuccessEvent(answer);

			return answer;
		},


		togglePreloader: function togglePreloader(state, widget) {
			widget = widget || this;

			var btn = widget.dom1(this.getOption('submitSelector'));

			if (!btn) {
				return;
			}

			fox.dom[state ? 'addClass' : 'removeClass']('spin', btn);
		},

		toggleSubmitButtonInactiveState: function toggleSubmitButtonInactiveState(state) {
			var btn = this._getSubmitBtn();

			if (!btn) {
				return;
			}

			fox.dom[state === false ? 'addClass' : 'removeClass']('disabled', btn);
		},
		_getSubmitBtn: function _getSubmitBtn() {
			return this.dom1(this.getOption('submitSelector'));
		},
		getUDID: function getUDID() {
			return EXO_UDID.getShortUid();
		},
		getPhoneNumberParams: function getPhoneNumberParams() {
			var formData = this.phoneNumberForm.getValues();
			var code = formData.phoneType.replace(/^00/, '');

			if (!code.match(/^\+/)) {
				code = '+'.concat(code);
			}

			return { code: code, phone: formData.phoneNumber };
		},
		dispatchSMSSendingErrorEvent: function dispatchSMSSendingErrorEvent(answer) {
			this.dispatchEvent('sms_sending_error', answer);
		},
		dispatchSMSSendingSuccessEvent: function dispatchSMSSendingSuccessEvent(answer) {
			this.dispatchEvent('sms_sending_success', answer);
		},
		dispatchSMSVerificationErrorEvent: function dispatchSMSVerificationErrorEvent(answer) {
			this.dispatchEvent('sms_verification_error', answer);
		},
		dispatchSMSVerificationSuccessEvent: function dispatchSMSVerificationSuccessEvent(answer) {
			this.dispatchEvent('sms_verification_success', answer);
		},
		switchActionWidgetState: function switchActionWidgetState(state, params) {
			var _this3 = this;

			var w = this.wom1('#action');
			var SUCCESS_STATE_TIME = 5;

			w.setTemplateOptions({ state: state });
			w.render();

			this.wait(w, 'addedToDom', { prefix: 'action_widget_render' }).then(function () {

				if (state === 'success') {
					_this3.runCountDown(SUCCESS_STATE_TIME).then(function () {
						var cooldown = params.cooldown - SUCCESS_STATE_TIME;

						if (cooldown > 0) {
							_this3.switchActionWidgetState('cooldown', { cooldown: cooldown });
							_this3.updateCooldown(cooldown);
						}
					});
				}

				if (state === 'cooldown') {
					_this3.updateCooldown(params.cooldown);

					_this3.runCountDown(params.cooldown, function (timeLeft) {
						_this3.updateCooldown(timeLeft);
					}).then(function () {
						_this3.switchActionWidgetState('available');
					});
				}
			});
		},
		runCountDown: function runCountDown(cooldown, periodCallback) {
			var w = this.wom1('#action');

			// if (w._indom === false) {
			// 	this.wait(w, 'addedToDom', {prefix: 'action_widget_render'}).then(() => {
			// 		this.runCountDown(cooldown, periodCallback);
			// 	});

			// 	return fox.Promise.reject();
			// }

			return this.startCountDown(cooldown, periodCallback).catch(console.error);
		},
		stopCountDown: function stopCountDown() {
			window.clearInterval(this.countDownInt);

			delete this.countDownInt;
		},
		startCountDown: function startCountDown(seconds, periodCallback) {
			var _this4 = this;

			this.stopCountDown();

			return new fox.Promise(function (resolve) {
				var i = 0;
				_this4.countDownInt = window.setInterval(function () {
					++i;

					if (i === seconds) {
						_this4.stopCountDown();

						return resolve(true);;
					}

					if (fox.isFunction(periodCallback)) {
						periodCallback(seconds - i);
					}
				}, 1000);
			});
		},
		transformSecondsToMinutes: function transformSecondsToMinutes(s) {
			return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
		},
		updateCooldown: function updateCooldown(time) {
			var w = this.wom1('#action');

			w._bindData.cooldown = this.transformSecondsToMinutes(time);
		}
	});
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
    'use strict';

    fox.registerWidget('Verification_Error', {
        configure: function configure() {

            this.registerOptions('', {
                autoRender: true
            });

            this.callParent('configure', arguments);
        },
        prepareEmbeddedWidgets: function prepareEmbeddedWidgets() {
            this._bindData = {
                cooldown: 0
            };

            this.bindTemplateVariables(this._bindData, ['cooldown']);

            this.callParent('prepareEmbeddedWidgets', arguments);
        },
        countdown: function countdown(cooldown) {
            var _this = this;

            var fmtMSS = function fmtMSS(s) {
                return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
            };

            this._bindData.cooldown = fmtMSS(cooldown);

            this.stop();

            return new fox.Promise(function (resolve, reject) {
                _this.timer = window.setInterval(function () {
                    --cooldown;

                    if (cooldown) {
                        _this._bindData.cooldown = fmtMSS(cooldown);
                    } else {
                        _this.stop();
                        _this.dispatchEvent('cooldown_end');
                        resolve(true);
                    }
                }, 1000);
            });
        },
        stop: function stop() {
            if (this.timer) {
                window.clearInterval(this.timer);
            }
        }
    });
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	"use strict";
	__webpack_require__(141)(fox);
	__webpack_require__(143)(fox);
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	__webpack_require__(142)(fox);

	fox.registerWidget('Copyright', {
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				startDate: 2013,
				container: '.cp-container',
				template: 'copyright'
			});
			
			this.callParent('configure', arguments);
		},

		rendering: function () {
			this.setTemplateOptions({
				startDate: this.getOption('startDate'),
				endDate: new Date().getFullYear()
			});

			this.callParent('rendering', arguments);
		}

	}, 'Widget');
})(fox);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("copyright", [["span",{"class":"cp-dates"},[["textNode",{"text":" "}],["span",{},[],[["startDate","__text",true]]],["textNode",{"text":" - "}],["span",{},[],[["endDate","__text",true]]],["textNode",{"text":" "}]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Captcha

(function (fox) {
	'use strict';
	__webpack_require__(144)(fox);

	fox.registerWidget('Captcha', {
		configure: function () {
			this.registerOptions('', {
				getCaptchaMethod: 'captcha.genId',
				template: 'captchaimg',
				captchaAlias: 'brettrossi',
				autoRender: false,
				'widgets.captchaApi': {
					widget: 'Api',
					'handleWom.captchaApiSuccessHandler': {
						widget: '@this',
						event: 'success',
						callback: '@parent:captchaApiSuccessHandler'
					}
				},
				'handleWom.putCaptcha': {
					widget: '@parent',
					event: 'addedToDom',
					callback: 'loadCaptcha'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('#captchaApi', {
				method: this.getOption('getCaptchaMethod')
			});

			this.visualParent = this.getParent();

			this.callParent('init', arguments);
		},

		embed: function () {
			this
				.fragment
				.childNodes[0]
				.setAttribute('src', this._captchaSrc);

			this.callParent('embed', arguments);
		},

		captchaApiSuccessHandler: function (data) {
			this.captchaId = this.getOption('captchaAlias') + ':' + data.answer.response.sid;
			var secure = this.getOption('secure'), address;
			if (secure) {
				address = '/sapi/' + secure[0] + '/' + secure[1] + '/captcha.show';
			} else {
				address = '/api/captcha.show';
			}

			this._captchaSrc = address + '?params={"id":"' + this.captchaId + '"}&rand=' + Math.random();
			this.render();
		},

		loadCaptcha: function () {
			this
				.rwom1('#captchaApi')
				.send({alias: this.getOption('captchaAlias')}, false);
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("captchaimg", [["img",{"class":"captcha-img"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';

	__webpack_require__(146);
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(147);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-stylus"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_promo-entry.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../node_modules/autoprefixer-loader/index.js?{browsers:[\"last 3 versions\"],cascade:false}!../../../../../../node_modules/stylus-loader/index.js??ref--6-3!./_promo-entry.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "abbr,address,article,aside,audio,b,blockquote,body,body div,caption,cite,code,dd,del,details,dfn,dl,dt,em,fieldset,figure,footer,form,h1,h2,h3,h4,h5,h6,header,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,p,pre,q,samp,section,small,span,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,ul,var,video{margin:0;padding:0;border:0;font-size:100%;font-weight:400;vertical-align:baseline;background:transparent}article,aside,details,figure,footer,header,nav,section,summary{display:block}html{-ms-box-sizing:border-box;box-sizing:border-box}*,:after,:before{-ms-box-sizing:inherit;box-sizing:inherit}embed,img,object{max-width:100%}html{overflow-y:scroll}ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\";content:none}a{margin:0;padding:0;font-size:100%;vertical-align:baseline;background:transparent;text-decoration:none}del{text-decoration:line-through}abbr[title],dfn[title]{border-bottom:1px dotted #000;cursor:help}table{border-collapse:collapse;border-spacing:0}th{font-weight:700;vertical-align:bottom}td{font-weight:400;vertical-align:top}hr{display:block;height:1px;border:0;border-top:1px solid #ccc;margin:1em 0;padding:0}input,select{vertical-align:middle}pre{white-space:pre;white-space:pre-wrap;white-space:pre-line;word-wrap:break-word}input[type=radio]{vertical-align:text-bottom}input[type=checkbox]{vertical-align:bottom}.ie7 input[type=checkbox]{vertical-align:baseline}.ie6 input{vertical-align:text-bottom}input,select,textarea{font:99% sans-serif}table{font-size:inherit;font:100%}small{font-size:85%}strong{font-weight:700}td,td img{vertical-align:top}sub,sup{font-size:75%;line-height:0;position:relative}sup{top:-.5em}sub{bottom:-.25em}code,kbd,pre,samp{font-family:monospace,sans-serif}.clickable,button,input[type=button],input[type=file],input[type=submit],label{cursor:pointer}button,input,select,textarea{margin:0}button,input[type=button]{width:auto;overflow:visible}.ie7 img{-ms-interpolation-mode:bicubic}.clearfix:after,.clearfix:before{content:\" \";display:block;height:0;overflow:hidden}.clearfix:after{clear:both}.clearfix{zoom:1}@font-face{font-family:montserrat_hairline;src:url(" + __webpack_require__(3) + ") format(\"woff\"),url(" + __webpack_require__(4) + ") format(\"truetype\"),url(" + __webpack_require__(5) + "#montserrat_hairline) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_italic;src:url(" + __webpack_require__(6) + ") format(\"woff\"),url(" + __webpack_require__(7) + ") format(\"truetype\"),url(" + __webpack_require__(8) + "#woodfordbourne_italic) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_regular;src:url(" + __webpack_require__(9) + ") format(\"woff\"),url(" + __webpack_require__(10) + ") format(\"truetype\"),url(" + __webpack_require__(11) + "#woodfordbourne_regular) format(\"svg\");font-weight:400;font-style:\"normal\"}.ui-helper-hidden-accessible{display:none!important}.ui-tooltip{padding:8px;position:absolute;z-index:9999;max-width:300px}body .ui-tooltip{border-width:2px}.gui-tooltip-type-1,.gui-tooltip-type-2{background-color:#5d7bd0;box-shadow:0 0 5px 1px rgba(0,0,0,.2);color:#fff;padding:20px;max-width:220px;font-size:11px;border-radius:3px}.gui-tooltip-type-1 .tt-arrow,.gui-tooltip-type-2 .tt-arrow{width:15px;height:15px;overflow:hidden;position:absolute;left:23%;margin-left:-8px;top:-8px}.gui-tooltip-type-1 .tt-arrow:after,.gui-tooltip-type-2 .tt-arrow:after{background:#5d7bd0;content:\"\";position:absolute;left:3px;top:3px;width:10px;height:10px;transform:rotate(45deg)}.gui-tooltip-type-1.bottom .tt-arrow,.gui-tooltip-type-2.bottom .tt-arrow{top:auto;bottom:-7px}.gui-tooltip-type-1.right .tt-arrow,.gui-tooltip-type-2.right .tt-arrow{left:0;top:50%;margin-top:-8px}.gui-tooltip-type-1.right-20 .tt-arrow,.gui-tooltip-type-2.right-20 .tt-arrow{left:auto;right:20px}.gui-tooltip-type-1.max-width-470px,.gui-tooltip-type-2.max-width-470px{max-width:470px}.gui-tooltip-type-1 .tt-body,.gui-tooltip-type-2 .tt-body{line-height:14px}.gui-tooltip-type-1 .tt-body a,.gui-tooltip-type-2 .tt-body a{color:inherit;text-decoration:underline!important}.gui-tooltip-type-1 .tt-body a:hover,.gui-tooltip-type-2 .tt-body a:hover{text-decoration:none}.gui-tooltip-type-1 .tt-body ul li,.gui-tooltip-type-2 .tt-body ul li{padding-left:10px}.gui-tooltip-type-1 .tt-body strong,.gui-tooltip-type-2 .tt-body strong{font-size:13px;line-height:22px}.gui-tooltip-type-1 .tt-head,.gui-tooltip-type-2 .tt-head{margin-bottom:20px;font-weight:700;font-size:14px}.gui-tooltip-type-1 .tt-head.i-mb0,.gui-tooltip-type-2 .tt-head.i-mb0{margin-bottom:0}.gui-tooltip-type-1.color-white,.gui-tooltip-type-2.color-white{background-color:#fff;color:#464646;border:1px solid #999}.gui-tooltip-type-1.color-white .tt-arrow,.gui-tooltip-type-2.color-white .tt-arrow{bottom:-8px}.gui-tooltip-type-1.color-white .tt-arrow:after,.gui-tooltip-type-2.color-white .tt-arrow:after{background-color:#fff;border-width:0 1px 1px 0;border-style:solid;border-color:#999;width:9px;height:9px}.gui-tooltip-type-1.color-white.no-border,.gui-tooltip-type-2.color-white.no-border{border-width:0;box-shadow:0 5px 10px rgba(0,0,0,.1)}.gui-tooltip-type-1.color-white.no-border .tt-arrow:after,.gui-tooltip-type-2.color-white.no-border .tt-arrow:after{border-width:0}.gui-tooltip-type-1.color-red,.gui-tooltip-type-2.color-red{background-color:#d35853;color:#fff;border:1px solid transparent}.gui-tooltip-type-1.color-red .tt-arrow,.gui-tooltip-type-2.color-red .tt-arrow{bottom:-8px}.gui-tooltip-type-1.color-red .tt-arrow:after,.gui-tooltip-type-2.color-red .tt-arrow:after{background-color:#d35853;border-width:0 1px 1px 0;border-style:solid;border-color:#d35853;width:9px;height:9px}.gui-tooltip-type-1.counters .tt-body .tt-head,.gui-tooltip-type-2.counters .tt-body .tt-head{font-weight:400}.gui-tooltip-type-1.counters .tt-body .tt-head strong,.gui-tooltip-type-2.counters .tt-body .tt-head strong{margin-right:5px}.gui-tooltip-type-1.counters .tt-body .tt-head:last-child,.gui-tooltip-type-2.counters .tt-body .tt-head:last-child{margin-bottom:0}.gui-tooltip-type-2{padding:15px 20px;text-align:left;margin-left:0;left:auto;right:0}.gui-tooltip-type-2 .close{position:absolute;right:10px;top:10px;cursor:pointer}.gui-tooltip-type-2 .tt-body .title{font-size:14px;font-weight:700;margin-bottom:20px}.gui-tooltip-type-2 .tt-body p{font-size:11px;line-height:normal;word-break:break-word}.gui-tooltip-type-2.text-capitalize .tt-body{text-transform:capitalize}.gui-tooltip-link{width:11px;min-width:11px;height:12px;position:relative}.gui-tooltip-link .tt-content{display:none;position:relative}.gui-tooltip-link .tt-link{width:100%;height:100%;border:1px solid #c3c3c3;cursor:pointer;text-decoration:none;border-radius:2px;background-image:linear-gradient(180deg,#fefefe 0,#f1f1f1);transition:border-color .2s}.gui-tooltip-link .tt-link:hover{border-color:#464646}.gui-tooltip-link .tt-link:after{content:\"?\";font-size:9px;color:#636363;line-height:12px;text-align:center;display:block}.gui-tooltip-link.default-link-style{width:auto;height:auto;position:relative}.gui-tooltip-error{width:16px;height:16px;position:relative}.gui-tooltip-error .tt-link{width:100%;height:100%;text-decoration:none}.gui-tooltip-error .tt-link i{display:block;font-size:16px;color:#d35853}.gui-tooltip-error .tt-content{display:none}.mc-copy-to-clipoard-simple-link .ui-tooltip.gui-tooltip-type-1{padding:5px 10px;bottom:100%;width:60px;left:50%;margin-left:-30px;margin-bottom:7px;transform:translateY(15px) scale(.8);transition:opacity .3s,transform .1s;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;text-align:center;visibility:hidden}.mc-copy-to-clipoard-simple-link .ui-tooltip.gui-tooltip-type-1 .tt-arrow{left:50%}.mc-copy-to-clipoard-simple-link.copied{-ms-filter:none;filter:none;opacity:1}.mc-copy-to-clipoard-simple-link.copied .ui-tooltip.gui-tooltip-type-1{visibility:visible;transform:translateY(0) scale(1);-ms-filter:none;filter:none;opacity:1}body{font-family:woodfordbourne_regular;line-height:1;font:15px/1 woodfordbourne_regular}body,html{height:100%}.btn,a:link,button,checkbox,label{-webkit-tap-highlight-color:rgba(0,0,0,0)}[data-widget-class=Layout_Promo] a,a{color:#fff}.w-100p{width:100%}.tt-u{text-transform:uppercase}.wrapper{position:relative;min-height:100vh;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.sitepage-container{-moz-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;overflow:hidden}.auth-page-container{padding-top:120px;padding-bottom:20px}.content-block{max-width:1150px;margin:0 auto;position:relative}.content-section h1{text-align:center;color:#151718;text-transform:uppercase}.content-section h2{font-size:36px}.btn{border-radius:4px;display:inline-block;margin-bottom:0;text-align:center;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;background-image:none;background:transparent;border:1px solid transparent;white-space:nowrap;padding:0 18px;height:43px;line-height:43px;-webkit-user-select:none;-khtml-user-drag:none;-moz-user-select:none;-moz-user-select:-moz-none;-ms-user-select:none;user-select:none;font-size:15px;color:#151718;font-family:inherit;outline:none;text-decoration:none}.btn a{text-decoration:inherit}.btn.disabled{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5;pointer-events:none}.btn-default{color:#fff;border-color:#fff}.btn-primary{color:#fff;background-color:#5d7bd0}.btn-major{color:#fff;background-color:#3fa88f}.btn-trans{color:#fff;background-color:hsla(0,0%,100%,.2)}.btn-grey{color:#fff;background-color:#b4b4b4}.btn-primary-simple{color:#5d7bd0;background-color:transparent;border-color:#5d7bd0}.btn-mcolor{color:#fff;background-image:linear-gradient(90deg,#5882c5 0,#518db6 25%,#479ca0 50%,#3fa88f 75%,#3fa88f);border:0}.btn-sm{height:34px;line-height:34px;padding:0 14px}.btn-big{height:58px;line-height:58px;padding:0 30px}.btn-group{display:inline-block}.btn-group>.btn{float:left}.btn-f-group{display:-moz-flex;display:-ms-flexbox;display:flex}.btn-f-group,.btn-group{position:relative}.btn-f-group .btn,.btn-group .btn{position:relative;padding:0 16px;border-color:#c6c6c6}.btn-f-group .btn:first-child,.btn-group .btn:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.btn-f-group .btn:last-child,.btn-group .btn:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-f-group .btn:not(:first-child):not(:last-child),.btn-group .btn:not(:first-child):not(:last-child){border-radius:0}.btn-f-group .btn+.btn,.btn-group .btn+.btn{margin-left:-1px}.input{position:relative;display:inline-block}.input input{display:block;width:100%;height:43px;line-height:43px;padding:0 15px;outline:0;border:1px solid #c6c6c6;border-radius:3px;background:transparent;font-family:inherit;font-size:inherit;color:#000;-webkit-appearance:normal;-moz-appearance:normal;appearance:normal;transition:border-color .5s ease}.input.error input{border-color:red}.input.error .error-icon{-ms-filter:none;filter:none;opacity:1}.input.error .error-icon .error-container{transform:scale(1) translateY(0)}.input.fill{display:block}.input-white input{background:#fff;border-color:transparent}.select{position:relative;display:inline-block}.select select{display:block;width:100%;height:43px;line-height:43px;padding:0 25px 0 15px;outline:0;border:1px solid #c6c6c6;border-radius:3px;background:transparent;font-family:inherit;font-size:inherit;color:#000;-webkit-appearance:none;-moz-appearance:none;appearance:none}.select select::-ms-expand{display:none}.select i{position:absolute;width:11px;height:11px;right:15px;top:50%;margin-top:-9px;display:block;border:1px solid #2a2c2d;border-width:0 1px 1px 0;transform:rotate(45deg);cursor:default}.checkbox{position:relative;display:inline-block;font-family:inherit;font-size:inherit;padding-left:35px;line-height:25px;text-align:left}.checkbox input{position:absolute;left:-9999px}.checkbox input+i{position:absolute;top:0;left:0;display:block;width:23px;height:23px;outline:0;border:1px solid transparent;background:#fff;border-radius:3px}.checkbox input+i:after{content:\"\";position:absolute;top:-3px;left:2px;display:block;background-image:url(" + __webpack_require__(0) + ");background-position:-672px -311px;width:26px;height:18px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;transition:opacity .3s}.checkbox input:checked+i:after{-ms-filter:none;filter:none;opacity:1}.checkbox .error-icon{right:auto;left:5px;margin-top:-15px;background-color:transparent}label{max-width:100%;vertical-align:middle}.inline-group,label{display:inline-block}.inline-group .btn,.inline-group .input,.inline-group .select{float:left;margin-right:10px}.inline-group .btn:last-child,.inline-group .input:last-child,.inline-group .select:last-child{margin-right:0}.inline-group.mr-18 .btn,.inline-group.mr-18 .input,.inline-group.mr-18 .select{margin-right:18px}.fleft{float:left}.fright{float:right}.dnone{display:none}.dnone-i{display:none!important}.ds-block{display:block}.iblock{display:inline-block}.tcenter{text-align:center}.link-icon{color:#151718;font-size:17px;position:relative;display:inline-block}.link-icon i{display:block;position:absolute;top:0;left:0}.link-icon.icon-tools{line-height:27px;padding-left:38px}.link-icon.icon-tools i{background-image:url(" + __webpack_require__(0) + ");background-position:-648px -311px;width:24px;height:24px}.link-icon.icon-list{line-height:16px;padding-left:31px}.link-icon.icon-list i{background-image:url(" + __webpack_require__(0) + ");background-position:-789px -274px;width:17px;height:13px}.blue-color{color:#5d7bd0}.white-color{color:#fff}.error-icon{width:14px;height:14px;border-radius:50%;background-color:red;position:absolute;top:50%;right:15px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;margin-top:-7px;transition:opacity .2s}.error-icon .error-container{position:absolute;width:200px;background-color:red;color:#fff;font-size:14px;line-height:14px;padding:6px 10px;bottom:100%;margin-bottom:10px;left:50%;margin-left:-100px;transition:transform .3s .1s;transform:scale(.9) translateY(20px);border-radius:2px}.error-icon .error-container:after{content:\"\";display:block;position:absolute;top:100%;width:0;height:0;border-style:solid;border-width:7px 5px 0;border-color:red transparent transparent;left:50%;margin-left:-5px}.checkbox.error .error-icon,.input.error .error-icon{-ms-filter:none;filter:none;opacity:1}.checkbox.error .error-icon .error-container,.input.error .error-icon .error-container{transform:scale(1) translateY(0)}.simple-page .sp-left{width:80%;margin-right:4%;position:relative}.simple-page .sp-right{width:15%;position:relative}.simple-page .sp-col{display:inline-block;vertical-align:top}.simple-page .sp-part{padding:20px 0}.simple-page .sp-part .num{float:left;padding-right:10px;position:relative;display:block;border-bottom:2px solid #ececec;width:auto}.simple-page .sp-part .num.numbers{font-size:24px}.simple-page .sp-part .list{padding:0 0 20px 30px}.simple-page .sp-part .list li{list-style-type:disc;line-height:24px;margin-left:20px}.simple-page .sp-part p{line-height:27px;margin:20px 0 20px 34px}.simple-page .sup-ip-time{font-size:12px;color:#a3a3a3}.simple-page .padd-left{padding-left:55px}.simple-page .sp-part-title{font-size:24px;margin-bottom:20px;color:#333;position:relative;font-weight:700}.simple-page .sp-part-title .num{position:relative;display:inline-block;left:0}.simple-page .sp-part-p{line-height:24px;margin:20px 0;position:relative}.simple-page .sp-part-bold{font-weight:700}.simple-page .sp-part-italic{font-style:italic}.simple-page .sp-part-uppercase{text-transform:uppercase}.simple-page .marg-left{margin-left:40px;position:relative;margin-left:-10px}.simple-page .marg-left .num{padding:6px 0}.box{border:1px solid #e7e7e7;padding:50px 6%}.box .title{color:#151718}.auth-form{width:320px;padding-top:40px;border-radius:2px;margin-left:auto;margin-right:auto}.auth-form .title{padding-bottom:40px;line-height:35px;font-size:25px;margin-left:-50px;margin-right:-50px;text-transform:uppercase;border-bottom:1px solid #e7e7e7;text-align:center;margin-bottom:50px}.auth-form .notice-container{font-size:16px;line-height:20px}.auth-form .notice-container a{color:#5d7bd0}.auth-form .row{margin-bottom:10px}.auth-form .row:last-child{margin-bottom:0}.auth-form .row.btns{margin-top:30px}.auth-form .row .action-btns{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}.auth-form .row .simple{margin-top:15px;text-align:right}.auth-form .row .simple a{color:#5d7bd0}.auth-form.changepass-form{font-size:16px;line-height:20px}.auth-form.changepass-form a{color:#5d7bd0}.auth-form.changepass-form a#form-submit{color:#fff}.auth-form.verification-form{padding-bottom:30px;width:375px}.auth-form.verification-form .title{margin-bottom:20px}.auth-form.verification-form .verification-data{font-size:13px;text-align:center;margin-bottom:45px}.auth-form.verification-form .verification-data p:first-child{margin-bottom:15px}.auth-form.verification-form .verification-data .phone-number-mask{font-size:17px;line-height:17px;text-transform:uppercase;margin-bottom:10px}.auth-form.verification-form .verification-data a{color:#7e8eb5}.auth-form.verification-form .row.actions{font-size:12px;line-height:16px;margin-top:5px}.auth-form.verification-form .row.actions a{color:#5d7bd0}.auth-form.verification-form .row.btns{text-align:center}.auth-form.verification-form .action-wrapper .state>*{display:inline-block;vertical-align:middle}.auth-form.verification-form .action-wrapper .state>* img{display:block}.auth-form.verification-form .action-wrapper .state.success{color:#64af50}.auth-form.verification-form .action-wrapper .state.cooldown{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.auth-form.verification-form .action-wrapper .state .icon{margin-right:5px}.auth-form.error .verification-data{margin-bottom:25px}.auth-form.error img{display:inline-block;margin-top:50px}.button-with-spinner{position:relative;transition:padding .4s}.button-with-spinner:after{content:\"\";display:block;width:19px;height:19px;position:absolute;left:-10px;top:50%;margin-top:-10px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;visibility:hidden;background-image:url(" + __webpack_require__(148) + ");background-repeat:no-repeat;background-position:0 0;transition:all .3s ease}.button-with-spinner.spin{padding-left:50px!important}.button-with-spinner.spin:after{visibility:visible;left:20px;-ms-filter:none;filter:none;opacity:1;animation:play 1s steps(28) infinite}.faq-title{padding:120px 0 0}@media (min-width:320px) and (max-width:767px){.content-section h1{font-size:30px;padding-top:35px}.simple-page{padding-top:70px}.simple-page .sp-col.sp-left{width:100%;margin-right:0}.simple-page .sp-col.sp-right{display:none}}@media (min-width:768px){.auth-page-container{padding-top:75px;padding-bottom:0;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}.box{padding-left:50px;padding-right:50px}}@media (min-width:768px) and (max-width:1149px){.content-section h1{font-size:42px;padding-top:55px}.simple-page{padding-top:75px}.simple-page .sp-navigator.slide{top:120px}.sp-col.sp-left{width:70%}.sp-col.sp-right{width:25%}}@media (min-width:1150px){.content-section h1{font-size:60px;padding-top:98px}.simple-page{padding-top:105px}.auth-page-container{padding-top:135px;padding-bottom:30px}.faq-title{padding:150px 0 0}}.crypmail:after{content:attr(data-name) \"@\" attr(data-domain) \".\" attr(data-tld)}.flex-wide{display:-ms-flexbox;display:flex;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-flow:row;flex-flow:row;-ms-flex-line-pack:stretch;align-content:stretch}.gui-tooltip-type-1,.gui-tooltip-type-2{font-size:14px}@keyframes play{0%{background-position:0 0}to{background-position:0 -560px}}.mc-radiobutton{position:relative;overflow:hidden;display:inline-block;vertical-align:middle}.mc-radiobutton,.mc-radiobutton *,.mc-radiobutton:after,.mc-radiobutton:before{box-sizing:border-box}.mc-radiobutton .radio-btn-wrap{position:relative;width:17px;height:17px;border-radius:50%;background-color:#fff;border:1px solid #ddd;text-align:center;z-index:1;display:inline-block;vertical-align:middle;transition:background-color .2s}.mc-radiobutton .radio-btn-wrap .radio-btn-dot{border-radius:50%;background-color:#424242;position:absolute;display:inline-block;top:2px;right:2px;bottom:2px;left:2px;margin:auto;transition:transform .15s,background-color .2s;transform:scale(0)}.mc-radiobutton input[type=radio]{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;z-index:2;cursor:pointer}.mc-radiobutton input[type=radio]:checked+.radio-btn-wrap .radio-btn-dot{transform:scale(1)}.mc-radiobutton input[type=radio]:hover+.radio-btn-wrap{background-color:#f2f2f2}.mc-radiobutton input[type=radio]:disabled+.radio-btn-wrap{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.mc-radiobutton input[type=radio]:disabled:hover+.radio-btn-wrap{background-color:#fff}.mc-checkbox{position:relative;display:inline-block;vertical-align:middle}.mc-checkbox,.mc-checkbox *,.mc-checkbox:after,.mc-checkbox:before{box-sizing:border-box}.mc-checkbox .checkbox-wrap{width:17px;height:17px;border-radius:1px;border:1px solid #ddd;background-color:#fff;display:inline-block;vertical-align:middle;transition:background-color .2s}.mc-checkbox .check-wrap{position:relative;z-index:1;top:4px;left:0;transition:opacity .2s,transform .2s;transform:rotateX(90deg);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}.mc-checkbox .check-wrap .check-1,.mc-checkbox .check-wrap .check-2{position:absolute;border-bottom:2px solid #424242;display:inline-block;border-radius:1px}.mc-checkbox .check-wrap .check-1{transform:rotate(45deg);top:1px;left:1px;width:0;width:8px}.mc-checkbox .check-wrap .check-2{transform:rotate(-45deg);width:0;top:-1px;left:5px;width:15px}.mc-checkbox input[type=checkbox]{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;cursor:pointer;z-index:2}.mc-checkbox input[type=checkbox]:hover+.checkbox-wrap{background-color:#f2f2f2}.mc-checkbox input[type=checkbox]:checked+.checkbox-wrap .check-wrap{transform:rotateX(0);-ms-filter:none;filter:none;opacity:1}.mc-checkbox input[type=checkbox]:disabled+.checkbox-wrap{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.mc-checkbox input[type=checkbox]:disabled:hover+.checkbox-wrap{background-color:#fff}.mc-checkbox.error .check-wrap{border-color:#d35853;box-shadow:0}.mc-slide-switcher{position:relative;display:inline-block;vertical-align:middle}.mc-slide-switcher,.mc-slide-switcher *,.mc-slide-switcher:after,.mc-slide-switcher:before{box-sizing:border-box}.mc-slide-switcher input[type=checkbox]{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;position:absolute;top:0;bottom:0;right:0;width:100%;height:100%;z-index:2;cursor:pointer}.mc-slide-switcher.inverted .switcher-fill .switcher,.mc-slide-switcher input[type=checkbox]:checked+.switcher-fill .switcher{margin-left:21px}.mc-slide-switcher.inverted input[type=checkbox]:checked+.switcher-fill .switcher{margin-left:0}.mc-slide-switcher.sl-green input[type=checkbox]:checked+.switcher-fill{background-color:#6cb758}.mc-slide-switcher.sl-pink input[type=checkbox]:checked+.switcher-fill{background-color:#d19292}.mc-slide-switcher.sl-blue input[type=checkbox]:checked+.switcher-fill{background-color:#5d7bd0}.mc-slide-switcher.sl-yellow input[type=checkbox]:checked+.switcher-fill{background-color:#ffe462}.mc-slide-switcher.sl-cyan input[type=checkbox]:checked+.switcher-fill{background-color:#629eb7}.mc-slide-switcher.sl-dark input[type=checkbox]:checked+.switcher-fill{background-color:#424242}.mc-slide-switcher.sl-red input[type=checkbox]:checked+.switcher-fill{background-color:#d35853}.mc-slide-switcher .switcher-fill{position:relative;width:41px;height:20px;background-color:#969696;border-radius:10px;padding:1px;transition:background-color .2s}.mc-slide-switcher .switcher-fill .switcher{height:18px;width:18px;display:block;border-radius:50%;background-color:#fff;transition:margin .2s;box-shadow:0 3px 0 0 rgba(0,0,0,.2)}textarea.mc-form-field{position:relative;border-radius:2px;background-color:#fff;display:inline-block;border:1px solid #ddd;box-sizing:border-box;transition:border-color .2s;color:#424242;padding:9px 10px;resize:none;min-width:300px;min-height:50px;overflow:hidden}textarea.mc-form-field *,textarea.mc-form-field:after,textarea.mc-form-field:before{box-sizing:border-box}textarea.mc-form-field.error{border-color:#d35853}textarea.mc-form-field.error,textarea.mc-form-field.error:hover{box-shadow:0 0 5px 0 rgba(211,88,83,.4)}textarea.mc-form-field.success{border-color:#6cb758}textarea.mc-form-field.success,textarea.mc-form-field.success:hover{box-shadow:0 0 5px 0 rgba(108,183,88,.4)}textarea.mc-form-field.disabled,textarea.mc-form-field.inactive{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=60)\";filter:alpha(opacity=60);opacity:.6}textarea.mc-form-field:hover{box-shadow:0 0 5px 0 hsla(0,0%,87%,.4)}textarea.mc-form-field:focus:not(.error):not(.success):not(.disabled):not(.inactive){border-color:#969696;box-shadow:0 0 5px 0 hsla(0,0%,59%,.4)}textarea.mc-form-field:focus:not(.error):not(.success):not(.disabled):not(.inactive) .field-icon{border-left-color:#969696}textarea.mc-form-field.not-empty{border-color:#969696;box-shadow:0 0 5px 0 hsla(0,0%,59%,.4)}textarea.mc-form-field.not-empty .field-icon{border-left-color:#969696}textarea.mc-form-field::-webkit-input-placeholder{color:#969696}textarea.mc-form-field:-moz-placeholder,textarea.mc-form-field::-moz-placeholder{color:#969696}textarea.mc-form-field:-ms-input-placeholder{color:#969696}input[type=email].mc-form-field,input[type=password].mc-form-field,input[type=text].mc-form-field{position:relative;border-radius:2px;background-color:#fff;display:inline-block;border:1px solid #ddd;box-sizing:border-box;transition:border-color .2s;color:#424242;height:31px;padding:9px 12px;min-width:190px}input[type=email].mc-form-field *,input[type=email].mc-form-field:after,input[type=email].mc-form-field:before,input[type=password].mc-form-field *,input[type=password].mc-form-field:after,input[type=password].mc-form-field:before,input[type=text].mc-form-field *,input[type=text].mc-form-field:after,input[type=text].mc-form-field:before{box-sizing:border-box}input[type=email].mc-form-field.error,input[type=password].mc-form-field.error,input[type=text].mc-form-field.error{border-color:#d35853;box-shadow:0 0 5px 0 rgba(211,88,83,.4)}input[type=email].mc-form-field.error:hover,input[type=password].mc-form-field.error:hover,input[type=text].mc-form-field.error:hover{box-shadow:0 0 5px 0 rgba(211,88,83,.4)}input[type=email].mc-form-field.success,input[type=password].mc-form-field.success,input[type=text].mc-form-field.success{border-color:#6cb758;box-shadow:0 0 5px 0 rgba(108,183,88,.4)}input[type=email].mc-form-field.success:hover,input[type=password].mc-form-field.success:hover,input[type=text].mc-form-field.success:hover{box-shadow:0 0 5px 0 rgba(108,183,88,.4)}input[type=email].mc-form-field.disabled,input[type=email].mc-form-field.inactive,input[type=password].mc-form-field.disabled,input[type=password].mc-form-field.inactive,input[type=text].mc-form-field.disabled,input[type=text].mc-form-field.inactive{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=60)\";filter:alpha(opacity=60);opacity:.6}input[type=email].mc-form-field:hover,input[type=password].mc-form-field:hover,input[type=text].mc-form-field:hover{box-shadow:0 0 5px 0 hsla(0,0%,87%,.4)}input[type=email].mc-form-field:focus:not(.error):not(.success):not(.disabled):not(.inactive),input[type=password].mc-form-field:focus:not(.error):not(.success):not(.disabled):not(.inactive),input[type=text].mc-form-field:focus:not(.error):not(.success):not(.disabled):not(.inactive){border-color:#969696;box-shadow:0 0 5px 0 hsla(0,0%,59%,.4)}input[type=email].mc-form-field:focus:not(.error):not(.success):not(.disabled):not(.inactive) .field-icon,input[type=password].mc-form-field:focus:not(.error):not(.success):not(.disabled):not(.inactive) .field-icon,input[type=text].mc-form-field:focus:not(.error):not(.success):not(.disabled):not(.inactive) .field-icon{border-left-color:#969696}input[type=email].mc-form-field.not-empty,input[type=password].mc-form-field.not-empty,input[type=text].mc-form-field.not-empty{border-color:#969696;box-shadow:0 0 5px 0 hsla(0,0%,59%,.4)}input[type=email].mc-form-field.not-empty .field-icon,input[type=password].mc-form-field.not-empty .field-icon,input[type=text].mc-form-field.not-empty .field-icon{border-left-color:#969696}input[type=email].mc-form-field::-webkit-input-placeholder,input[type=password].mc-form-field::-webkit-input-placeholder,input[type=text].mc-form-field::-webkit-input-placeholder{color:#969696}input[type=email].mc-form-field:-moz-placeholder,input[type=email].mc-form-field::-moz-placeholder,input[type=password].mc-form-field:-moz-placeholder,input[type=password].mc-form-field::-moz-placeholder,input[type=text].mc-form-field:-moz-placeholder,input[type=text].mc-form-field::-moz-placeholder{color:#969696}input[type=email].mc-form-field:-ms-input-placeholder,input[type=password].mc-form-field:-ms-input-placeholder,input[type=text].mc-form-field:-ms-input-placeholder{color:#969696}input[type=email].mc-form-field.size-medium,input[type=password].mc-form-field.size-medium,input[type=text].mc-form-field.size-medium{height:40px}input[type=email].mc-form-field.size-medium~.field-icon,input[type=password].mc-form-field.size-medium~.field-icon,input[type=text].mc-form-field.size-medium~.field-icon{height:38px;width:38px}input[type=email].mc-form-field.size-medium:focus~.field-icon,input[type=password].mc-form-field.size-medium:focus~.field-icon,input[type=text].mc-form-field.size-medium:focus~.field-icon{color:#969696;border-left-color:#969696}input[type=email].mc-form-field~.field-icon,input[type=password].mc-form-field~.field-icon,input[type=text].mc-form-field~.field-icon{font-size:15px;position:absolute;top:0;bottom:0;right:0;width:31px;height:31px;z-index:1;cursor:pointer;border-left:1px solid #ddd;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;color:#969696;transition:color .2s,border-color .2s;height:29px;top:1px}input[type=email].mc-form-field~.clear-field,input[type=password].mc-form-field~.clear-field,input[type=text].mc-form-field~.clear-field{display:block;width:16px;height:16px;position:absolute;right:9px;top:50%;margin-top:-8px;border-radius:50%;background-color:hsla(0,0%,59%,.4);color:#fff;font-size:8px;text-align:center;vertical-align:middle;cursor:pointer;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;visibility:hidden;transition:background-color .2s,transform .2s,opacity .2s;transform:translateY(-100%)}input[type=email].mc-form-field~.clear-field i,input[type=password].mc-form-field~.clear-field i,input[type=text].mc-form-field~.clear-field i{position:relative;left:0;width:9px;height:9px;display:block;overflow:hidden;top:4px;left:4px}input[type=email].mc-form-field~.clear-field:hover,input[type=password].mc-form-field~.clear-field:hover,input[type=text].mc-form-field~.clear-field:hover{background-color:hsla(0,0%,59%,.7)}input[type=email].mc-form-field~.clear-field:active,input[type=password].mc-form-field~.clear-field:active,input[type=text].mc-form-field~.clear-field:active{background-color:#969696}input[type=email].with-icon,input[type=password].with-icon,input[type=text].with-icon{padding-right:35px}input[type=email].with-icon.size-medium,input[type=password].with-icon.size-medium,input[type=text].with-icon.size-medium{padding-right:45px}input[type=email].with-icon.size-medium.with-clear,input[type=password].with-icon.size-medium.with-clear,input[type=text].with-icon.size-medium.with-clear{padding-right:77px}input[type=email].with-icon.size-medium.with-clear~.clear-field,input[type=password].with-icon.size-medium.with-clear~.clear-field,input[type=text].with-icon.size-medium.with-clear~.clear-field{right:51px}input[type=email].with-icon.with-clear,input[type=password].with-icon.with-clear,input[type=text].with-icon.with-clear{padding-right:67px}input[type=email].with-icon.with-clear~.clear-field,input[type=password].with-icon.with-clear~.clear-field,input[type=text].with-icon.with-clear~.clear-field{right:41px}input[type=email].with-icon.not-empty~.field-icon,input[type=password].with-icon.not-empty~.field-icon,input[type=text].with-icon.not-empty~.field-icon{border-left-color:#969696}input[type=email].with-clear,input[type=password].with-clear,input[type=text].with-clear{padding-right:36px}input[type=email].with-clear.not-empty~.clear-field,input[type=password].with-clear.not-empty~.clear-field,input[type=text].with-clear.not-empty~.clear-field{visibility:visible;display:block;transform:translateY(0);-ms-filter:none;filter:none;opacity:1}.mc-form-field-wrapper{position:relative;display:inline-block}.mc-form-field-wrapper .field-icon{font-size:15px;position:absolute;top:0;bottom:0;right:0;width:31px;height:31px;z-index:1;cursor:pointer;border-left:1px solid #ddd;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;color:#969696;transition:color .2s,border-color .2s}.mc-form-field-wrapper.with-icon input[type=email],.mc-form-field-wrapper.with-icon input[type=password],.mc-form-field-wrapper.with-icon input[type=text]{padding-right:35px}.mc-form-field-wrapper input[type=email]:focus+.field-icon,.mc-form-field-wrapper input[type=email]:hover+.field-icon,.mc-form-field-wrapper input[type=password]:focus+.field-icon,.mc-form-field-wrapper input[type=password]:hover+.field-icon,.mc-form-field-wrapper input[type=text]:focus+.field-icon,.mc-form-field-wrapper input[type=text]:hover+.field-icon{color:#424242}.mc-form-field-wrapper input[type=email]:focus+.field-icon,.mc-form-field-wrapper input[type=password]:focus+.field-icon,.mc-form-field-wrapper input[type=text]:focus+.field-icon{border-color:#969696}.mc-form-field-wrapper input[type=email]:focus+.field-icon:hover,.mc-form-field-wrapper input[type=password]:focus+.field-icon:hover,.mc-form-field-wrapper input[type=text]:focus+.field-icon:hover{color:#516dbd}.dropdown .select-value{display:block;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=60)\";filter:alpha(opacity=60);opacity:.6;font-size:12px}.dropdown .select-value.long-title{margin-right:30px;white-space:nowrap;overflow:hidden}.dropdown .select-value.selected{color:#424242;-ms-filter:none;filter:none;opacity:1}.dropdown.mc-form-field{position:relative;border-radius:2px;background-color:#fff;display:inline-block;border:1px solid #ddd;box-sizing:border-box;transition:border-color .2s;height:31px;padding:8px 12px;min-width:150px;text-align:left;cursor:pointer}.dropdown.mc-form-field *,.dropdown.mc-form-field:after,.dropdown.mc-form-field:before{box-sizing:border-box}.dropdown.mc-form-field.error{border-color:#d35853}.dropdown.mc-form-field.error,.dropdown.mc-form-field.error:hover{box-shadow:0 0 5px 0 rgba(211,88,83,.4)}.dropdown.mc-form-field.success{border-color:#6cb758}.dropdown.mc-form-field.success,.dropdown.mc-form-field.success:hover{box-shadow:0 0 5px 0 rgba(108,183,88,.4)}.dropdown.mc-form-field.disabled,.dropdown.mc-form-field.inactive{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=60)\";filter:alpha(opacity=60);opacity:.6}.dropdown.mc-form-field:hover{box-shadow:0 0 5px 0 hsla(0,0%,87%,.4)}.dropdown.mc-form-field.opened{border-color:#969696;box-shadow:0 0 5px 0 hsla(0,0%,59%,.4)}.dropdown.mc-form-field.opened .field-icon{border-left-color:#969696}.dropdown.mc-form-field .current-value{position:absolute;top:8px;left:12px;right:0;white-space:nowrap;overflow:hidden}.dropdown.mc-form-field .drop-arrow{border-left:1px solid #ddd;background-color:inherit;position:absolute;right:0;top:0;bottom:0;width:30px}.dropdown.mc-form-field .drop-arrow:after{border-color:#c6c6c6}.dropdown.mc-btn{min-width:200px}.dropdown.mc-btn .drop-arrow{width:10px;display:inline-block}.dropdown.mc-btn .drop-arrow:after{position:relative;left:5px;border-color:#fff}.dropdown .drop-arrow{transition:border-color .2s}.dropdown .drop-arrow:after{content:\"\";display:block;position:absolute;margin:auto;top:-1px;right:0;bottom:0;left:0;width:6px;height:6px;border-style:solid;border-width:0 2px 2px 0;transform:rotate(45deg);border-radius:20%;transition:border-color .2s,transform .2s}.dropdown .clear-field{font-size:10px;color:#c6c6c6;position:absolute;right:20px;top:50%;margin-top:-7px;z-index:3;display:block;transition:transform .2s,tranwsform .2s;width:14px;height:14px;text-align:center}.dropdown .clear-field i{position:relative;top:2px}.dropdown .clear-field:hover{color:#585858}.dropdown .clear-field:active{transform:rotate(90deg)}.dropdown .small-loader{left:auto;right:20px;z-index:2;margin-top:-9px}.dropdown .small-loader.spin+.clear-field{transform:scale(0)}.dropdown.opened .dropdown-list{-ms-filter:none;filter:none;opacity:1;visibility:visible}.dropdown.opened.mc-form-field .drop-arrow{border-left-color:#969696}.dropdown.opened.mc-form-field .drop-arrow:after{border-color:#878787}.dropdown.opened.mc-btn .drop-arrow:after{border-color:inherit}.dropdown.opened .drop-arrow:after{transform:rotate(-45deg) rotateX(180deg);top:0;bottom:-1px}.dropdown.dl-top .dropdown-list{transform:translateY(-110%);top:-2px}.dropdown.dl-top.opened .dropdown-list{transform:translateY(-100%)}.dropdown.dl-bottom.mc-form-field .dropdown-list{bottom:-2px;left:2px;right:2px;border:1px solid #969696}.dropdown.dl-bottom.mc-btn .dropdown-list{bottom:5px;left:15px;right:15px;box-shadow:0 2px 10px -2px rgba(0,0,0,.3);color:#424242;font-size:12px;padding:15px 0}.dropdown.dl-bottom.mc-btn .dropdown-list .option-item{padding-top:5px;padding-bottom:5px;font-weight:400}.dropdown.dl-bottom .dropdown-list{transform:translateY(110%)}.dropdown.dl-bottom.opened .dropdown-list{transform:translateY(100%)}.dropdown .dropdown-list{position:absolute;background-color:#fff;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;transition:transform .2s,opacity .2s,visibility .2s;visibility:hidden;border-radius:2px;max-height:300px;z-index:3;overflow:auto}.dropdown .dropdown-list .option-item{display:block;padding:10px 12px;transition:background-color .2s}.dropdown .dropdown-list .option-item.selected{background-color:hsla(0,0%,87%,.4)}.dropdown .dropdown-list .option-item:hover{background-color:#ddd}.dropdown select{display:none}.dropdown.autocomplete input{padding-right:50px}.dropdown.autocomplete .small-loader{right:37px;margin-top:-9px}.dropdown.autocomplete .clear-field{right:40px}.dropdown.autocomplete .dropdown-list{left:-1px;right:-1px;bottom:0;border-radius:0 0 2px 2px}.dropdown.autocomplete.type-2 .small-loader{right:5px;left:auto}.dropdown.autocomplete.type-2 .small-loader.spin+.drop-arrow{display:none}.dropdown.disabled,.dropdown.inactive{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=60)\";filter:alpha(opacity=60);opacity:.6}.dropdown.mc-tag-selector{padding:4px 36px 0 4px;height:auto;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap}.dropdown.mc-tag-selector.size-medium{height:40px}.dropdown.mc-tag-selector i.arrow{position:absolute;width:11px;height:11px;right:15px;top:50%;margin-top:-9px;display:block;border:1px solid #2a2c2d;border-width:0 1px 1px 0;transform:rotate(45deg);cursor:default}.dropdown.mc-tag-selector .tags-list{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap}.dropdown.mc-tag-selector .tags-list .tag{background-color:#f3f3f3;color:#000;margin-right:5px;line-height:21px;white-space:nowrap;font-weight:700;position:relative;margin-bottom:4px;padding:6px 5px 6px 25px;box-sizing:content-box}.dropdown.mc-tag-selector .tags-list .tag .close{position:absolute;display:block;top:11px;left:10px;bottom:0;text-align:center;cursor:pointer;background-image:url(" + __webpack_require__(0) + ");background-position:-792px -262px;width:9px;height:9px}.dropdown.mc-tag-selector .tags-list .tag i{font-size:10px;cursor:pointer}.dropdown.mc-tag-selector div.input{display:block;-moz-flex:1 auto;-ms-flex:1 auto;flex:1 auto;width:auto;height:20px;line-height:20px;outline:none;padding:9px 4px 8px;box-sizing:content-box}.dropdown.mc-tag-selector.mc-form-field .dropdown-list{left:-1px;right:-1px;bottom:1px;box-shadow:0 0 5px 0 hsla(0,0%,59%,.4)}.code-wrapper{font-size:10px;position:relative;border-radius:2px;background-color:#fff;display:inline-block;border:1px solid #ddd;transition:border-color .2s;padding:10px;color:#424242;word-wrap:break-word}.code-wrapper,.code-wrapper *,.code-wrapper:after,.code-wrapper:before{box-sizing:border-box}.code-wrapper.error{border-color:#d35853}.code-wrapper.error,.code-wrapper.error:hover{box-shadow:0 0 5px 0 rgba(211,88,83,.4)}.code-wrapper.success{border-color:#6cb758}.code-wrapper.success,.code-wrapper.success:hover{box-shadow:0 0 5px 0 rgba(108,183,88,.4)}.code-wrapper.disabled,.code-wrapper.inactive{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=60)\";filter:alpha(opacity=60);opacity:.6}.code-wrapper:hover{box-shadow:0 0 5px 0 hsla(0,0%,87%,.4)}.code-wrapper:focus:not(.error):not(.success):not(.disabled):not(.inactive){border-color:#969696;box-shadow:0 0 5px 0 hsla(0,0%,59%,.4)}.code-wrapper:focus:not(.error):not(.success):not(.disabled):not(.inactive) .field-icon{border-left-color:#969696}.code-wrapper.not-empty{border-color:#969696;box-shadow:0 0 5px 0 hsla(0,0%,59%,.4)}.code-wrapper.not-empty .field-icon{border-left-color:#969696}.code-wrapper::-webkit-input-placeholder{color:#969696}.code-wrapper:-moz-placeholder,.code-wrapper::-moz-placeholder{color:#969696}.code-wrapper:-ms-input-placeholder{color:#969696}.code-wrapper>span{display:block;word-wrap:break-word}.code-wrapper:empty{color:#969696}.code-wrapper:focus{color:#424242}.mc-tag-selector{position:relative;border-radius:2px;background-color:#fff;display:inline-block;border:1px solid #ddd;transition:border-color .2s;color:#424242;padding:4px 4px 0;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap}.mc-tag-selector,.mc-tag-selector *,.mc-tag-selector:after,.mc-tag-selector:before{box-sizing:border-box}.mc-tag-selector.error{border-color:#d35853}.mc-tag-selector.error,.mc-tag-selector.error:hover{box-shadow:0 0 5px 0 rgba(211,88,83,.4)}.mc-tag-selector.success{border-color:#6cb758}.mc-tag-selector.success,.mc-tag-selector.success:hover{box-shadow:0 0 5px 0 rgba(108,183,88,.4)}.mc-tag-selector.disabled,.mc-tag-selector.inactive{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=60)\";filter:alpha(opacity=60);opacity:.6}.mc-tag-selector:hover{box-shadow:0 0 5px 0 hsla(0,0%,87%,.4)}.mc-tag-selector:focus:not(.error):not(.success):not(.disabled):not(.inactive){border-color:#969696;box-shadow:0 0 5px 0 hsla(0,0%,59%,.4)}.mc-tag-selector:focus:not(.error):not(.success):not(.disabled):not(.inactive) .field-icon{border-left-color:#969696}.mc-tag-selector.not-empty{border-color:#969696;box-shadow:0 0 5px 0 hsla(0,0%,59%,.4)}.mc-tag-selector.not-empty .field-icon{border-left-color:#969696}.mc-tag-selector::-webkit-input-placeholder{color:#969696}.mc-tag-selector:-moz-placeholder,.mc-tag-selector::-moz-placeholder{color:#969696}.mc-tag-selector:-ms-input-placeholder{color:#969696}.mc-tag-selector.size-medium{height:40px}.mc-tag-selector .tags-list{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap}.mc-tag-selector .tags-list .tag{height:inherit;background-color:#5d7bd0;color:#fff;border-radius:0;margin-right:5px;height:21px;line-height:21px;padding-left:25px;padding-right:5px;white-space:nowrap;font-weight:700;position:relative;margin-bottom:4px}.mc-tag-selector .tags-list .tag .close{position:absolute;display:block;top:0;left:0;bottom:0;width:25px;text-align:center;cursor:pointer}.mc-tag-selector .tags-list .tag i{font-size:10px;cursor:pointer}.mc-tag-selector div.input{display:block;-moz-flex:1 auto;-ms-flex:1 auto;flex:1 auto;width:auto;height:20px;line-height:20px;min-width:50px}.mc-slider{border:1px solid #ddd}.mc-slider.ui-slider{position:relative;text-align:left}.mc-slider.ui-slider .ui-slider-handle{position:absolute;z-index:2;width:1.2em;height:1.2em;cursor:pointer;-ms-touch-action:none;touch-action:none;background-color:#fff;border:1px solid #a5a5a5}.mc-slider.ui-slider .ui-slider-range{background-color:hsla(0,0%,80%,.4);position:absolute;z-index:1;font-size:.7em;display:block;border:0;background-position:0 0}.mc-slider.ui-slider.ui-state-disabled .ui-slider-handle,.mc-slider.ui-slider.ui-state-disabled .ui-slider-range{filter:inherit}.mc-slider.ui-slider-horizontal{height:8px}.mc-slider.ui-slider-horizontal .ui-slider-handle{top:-.3em;margin-left:-.6em}.mc-slider.ui-slider-horizontal .ui-slider-range{top:0;height:100%}.mc-slider.ui-slider-horizontal .ui-slider-range-min{left:0}.mc-slider.ui-slider-horizontal .ui-slider-range-max{right:0}.mc-slider.ui-slider-vertical{width:.8em;height:100px}.mc-slider.ui-slider-vertical .ui-slider-handle{left:-.3em;margin-left:0;margin-bottom:-.6em}.mc-slider.ui-slider-vertical .ui-slider-range{left:0;width:100%}.mc-slider.ui-slider-vertical .ui-slider-range-min{bottom:0}.mc-slider.ui-slider-vertical .ui-slider-range-max{top:0}.faq-section,.faq-section *{box-sizing:border-box}.wrapper[data-widget-class=Layout_PromoInner] .faq-section{padding-top:87px}.faq-section{position:relative;min-height:100%;background-color:#f1f1f1;padding-top:115px}.faq-section a{text-decoration:none}.faq-section header{position:fixed;left:0;right:0;width:100%;top:0;z-index:2;color:#fff}.faq-section .h-top{height:100px;background-color:#2e7dc9}.faq-section .h-top a,.faq-section .h-top ahover{color:#64c7ed}.faq-section .fq-h-wrapper{max-width:1200px}.faq-section .fq-h-wrapper *{vertical-align:middle}.faq-section .h-bottom{background-color:#f1f1f1;height:50px;position:static;top:112px;left:0;right:0;z-index:4}.faq-section .h-bottom .fq-h-wrapper{padding-bottom:0}.faq-section .h-bottom .back-link{padding-left:40px;color:#2e8fc9;font-size:14px;font-family:kreonbold;line-height:30px;padding:0 0 0 30px;visibility:hidden;position:relative;left:-50px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;background:url(" + __webpack_require__(149) + ") 0 no-repeat;transition:all .3s}.faq-section .h-bottom .back-link.show{left:0;-ms-filter:none;filter:none;opacity:1;visibility:visible}.faq-section .fq-s-link{font-size:24px;font-family:kreonlight;top:5px;position:relative}.faq-section .fq-search{font-size:14px;position:relative;top:10px}.faq-section .fq-search label{font-weight:700}.faq-section .fq-search input{position:relative;height:42px;width:300px;background:rgba(0,0,0,.1);border-radius:20px;padding:0 20px;box-shadow:inset 0 2px 15px -7px #000;color:#64c7ed;font-family:Georgia,Arial;font-style:italic;margin-left:25px}.faq-section .fq-search ::-webkit-input-placeholder{color:#64c7ed}.faq-section .fq-search :-moz-placeholder,.faq-section .fq-search ::-moz-placeholder{color:#64c7ed}.faq-section .fq-search :-ms-input-placeholder{color:#64c7ed}.faq-section .ds-ib{vertical-align:top}.faq-section .container{position:relative;text-align:center;margin:0 auto}.faq-section .main-block{width:70%;float:left}.faq-section .right-sidebar{width:27%;float:right}.faq-section .fq-block{background-color:#fff;margin-bottom:30px;border:1px solid #eaeaea;border-width:0 1px;text-align:left;box-shadow:0 1px 1px 0 #dfdfdf}.faq-section footer{border-top:1px solid #dfdfdf;padding:15px 0 50px;max-width:1200px;position:absolute;margin:0 auto;left:2%;right:2%;bottom:0}.faq-section .fqb-title{font-family:kreonbold;font-size:20px;line-height:20px;padding:20px}.faq-section .fqb-title .exp{font-size:12px;font-family:CalibriRegular,Arial;font-weight:700;position:relative;padding-right:30px;cursor:pointer}.faq-section .fqb-title .exp .ring{display:block;width:24px;height:24px;position:absolute;border-radius:50%;border-width:2px;border-style:solid;right:0;top:-6px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}.faq-section .fqb-title .exp .ring:after,.faq-section .fqb-title .exp .ring:before{position:absolute;content:\"\";width:6px;height:6px;z-index:1;top:0;left:0;border-radius:0 1px 0 1px;display:block;left:7px;top:6px;transform:rotate(45deg);transition:all .2s}.faq-section .fqb-title .exp .ring:after{background-color:#fff;width:6px;height:6px;left:7px;top:4px}.faq-section .fqb-title .exp.opened .ring:before{top:8px}.faq-section .fqb-title .exp.opened .ring:after{top:10px}.fq-p-title{font-family:kreonbold;font-size:16px}.faq-section .green .exp,.faq-section .green .fq-p-title{color:#72a52f}.faq-section .blue .exp,.faq-section .blue .fq-p-title{color:#2e8fc9}.faq-section .fqb-content{padding:0 35px}.faq-section .fqb-content>ol>li{padding:20px 0;border-bottom:1px solid #eaeaea}.faq-section .fqb-content>ol>li:last-child{border-bottom-width:0}.faq-section .fqb-content .fqb-tags-list li{display:block}.faq-section .fqb-content .fqb-tags-list a{display:block;padding:12px 0;color:#2e8fc9;text-decoration:none;font-family:kreonbold;font-size:16px}.faq-section .fqb-content .fqb-tags-list{padding-top:10px}.faq-section .fqb-content .fqb-tags-list a:first-child{color:#72a52f}.faq-section .fq-expander{position:relative;width:10px;display:inline-block;height:10px;vertical-align:middle;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5;transform:rotate(225deg)}.faq-section .fq-expander:before{position:absolute;content:\"\";width:7px;height:7px;z-index:1;top:0;left:0;border-radius:0 1px 0 1px}.faq-section .blue .fq-expander:before{background-color:#2e8fc9;border-color:#2e8fc9}.faq-section .green .fq-expander:before{background-color:#72a52f}.faq-section .green .fqb-title .exp .ring{border-color:#72a52f}.faq-section .green .fqb-title .exp .ring:before{background-color:#72a52f}.faq-section .blue .fqb-title .exp .ring:before{background-color:#2e8fc9}.faq-section .fq-expander:after{position:absolute;content:\"\";width:6px;height:6px;background-color:#fff;z-index:2;top:2px;left:2px}.faq-section .fqb-list .toggle{cursor:pointer}.faq-section .fqb-list .toggle .fq-p-content{overflow:hidden;height:0}.faq-section .fqb-list .toggle.opened .fq-expander{transform:rotate(45deg);top:4px}.faq-section .fqb-list .toggle.opened .fq-p-content{overflow:auto;height:100%;padding-top:20px;padding-bottom:0}.faq-section .fqb-ask-form{padding:30px 0}.faq-section .fqb-ask-form .row{margin:0 0 15px}.faq-section .fqb-success-msg{color:#72a52f;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;overflow:hidden;height:0;padding:0;transition:all .3s}.faq-section .fqb-success-msg.show{-ms-filter:none;filter:none;opacity:1;height:auto}.fqb-input{line-height:35px;position:relative;z-index:1}.fqb-input .styled{position:absolute;left:0;right:0;top:0;bottom:0;background-color:#f2f2f2;border-radius:3px;border-width:1px;border-style:solid;border-color:#e4e4e4 #eee #f2f2f2 #eaeaea;box-shadow:inset 0 1px 3px 0 hsla(0,0%,75%,.3);transition:all .2s}.fqb-input input,.fqb-input textarea{display:block;width:100%;height:37px;line-height:35px;position:relative;z-index:2;background-color:transparent;border:0;padding:0 10px;font-size:13px;font-family:CalibriRegular;color:#737373}.fqb-input textarea{min-height:80px;height:auto;line-height:normal;padding:10px;resize:none}.fqb-input .fqb-field:focus+.styled{box-shadow:inset 0 1px 3px 0 hsla(0,0%,67%,.7);border-color:#ababab}.fqb-input .fqb-field:focus+.styled .cp,.fqb-input .fqb-field:focus+.styled:before{border-color:#ababab}.fqb-input .fqb-field.error+.styled{border-color:red;background-color:#fff0f0}.fqb-input .fqb-field.error+.styled:before{border-color:red}.fqb-input .fqb-field.error{color:red}.fqb-input.icon input{padding-left:50px}.fqb-input.captcha input{padding-left:105px}.fqb-input.icon .styled:before{content:\"\";display:block;position:absolute;left:0;top:0;bottom:0;width:33px;border-right:1px solid #e4e4e4;background-repeat:no-repeat;background-position:50%;z-index:3;transition:all .2s}.fqb-input.icon.name .styled:before{background-image:url(" + __webpack_require__(150) + ")}.fqb-input.icon.email .styled:before{background-image:url(" + __webpack_require__(151) + ")}.fqb-input.icon.search .styled:before{background-image:url(" + __webpack_require__(152) + ")}.fqb-input.captcha .cp{position:absolute;left:0;top:0;height:35px;width:89px;border-right:1px solid #e4e4e4;z-index:3;display:block}.fqb-input.captcha .cp img{max-width:100%}.fqb-btn{border-width:1px;border-style:solid;font-size:12px;font-family:Arial;text-align:center;color:#fff;text-decoration:none;font-weight:700;display:block;border-radius:3px;line-height:34px;cursor:pointer;box-shadow:inset 0 0 0 0 transparent}.fqb-btn.blue{border-color:#2e7dc9;background-color:#2e7dc9}.fqb-btn:hover{border-color:#2b72b7;color:#fff}.fqb-btn:active{border-color:#24609a;box-shadow:inset 0 1px 3px 0 rgba(36,96,154,.7)}.fqb-content.form.success{overflow:hidden}.fqb-content.form .fields{transition:all .3s}.fqb-content.form.success .fields{margin-top:-332px;padding-top:0}.fqb-content.form.success .fqb-success-msg{-ms-filter:none;filter:none;opacity:1;height:auto;padding:30px 0}.main-block+.sep{clear:right}.faq-section.mc-blog{padding-top:140px;color:#4f4f4f;font-family:CalibriRegular,Arial}.faq-section.mc-blog .fq-h-wrapper{max-width:1200px;padding-bottom:10px}.faq-section footer{color:#bebebe}.faq-section,[data-widget-class=Promo_Faq]#sitepage-container{background:#fcfcfc}.faq-section{padding-top:72px}.faq-section .h-bottom{background:none;height:20px}.faq-section .h-bottom .back-link.show{cursor:pointer}.faq-section .h-bottom .fq-h-wrapper{padding:0;margin:10px auto}.faq-section .fq-h-wrapper{margin:0 auto;padding:18px 0;max-width:1090px}.faq-section .main-block,.faq-section .right-sidebar{width:100%;float:none}.faq-section .right-sidebar .fqb-title{border-color:hsla(0,0%,78%,.2)}.faq-section .right-sidebar .fqb-content{padding:0 30px}.faq-section *{font-family:woodfordbourne_regular!important}.faq-title{color:#000;font-size:60px;text-align:center;padding:40px 0 0}.faq-section .search .fqb-ask-form .row{margin:0}.sd-block.fq-block.search .fqb-title{color:#000;font-family:woodfordbourne_regular}.faq-section .fq-block.tags .fqb-title{color:#fff;font-family:woodfordbourne_regular}.faq-section .fq-block.tags{position:relative;background-image:linear-gradient(-45deg,#47a3dc,#47dc9b)}.faq-section .fq-block.tags .tags-wrapper{background:url(" + __webpack_require__(153) + ") no-repeat 100% 100%}.faq-section .fq-block .fqb-content a{color:#2e8fc9}.faq-section .fq-block .fqb-content .fqb-tags-list{padding:15px}.faq-section .fq-block .fqb-content .fqb-tags-list a{color:#fff;font-family:woodfordbourne_regular;font-size:18px}.faq-section .fq-block .fqb-content .fqb-tags-list a:first-child{color:#fff}.faq-section .fq-block.ask{background:#151718 url(" + __webpack_require__(154) + ") no-repeat -10px -20px}.faq-section .fq-block.ask .fqb-title{color:#fff;font-family:woodfordbourne_regular}.faq-section .fq-block.ask .fqb-ask-form .fqb-btn.blue{background:#5d7bd0;color:#fff;font-size:16px;width:180px;margin:0 auto;text-shadow:none;font-weight:400}.fqb-input.icon .styled:before{display:none}.fqb-input.icon input{padding-left:10px;font-size:15px}.fqb-input input,.fqb-input textarea{font-size:15px}.faq-section .fq-expander{top:-4px;left:1px}.faq-section .fqb-title{border-top:1px solid #eaeaea;border-bottom:1px solid #eaeaea;text-transform:uppercase}.faq-section .fqb-list .toggle.opened .fq-expander{top:5px;left:5px}.faq-section .fq-p-title>*{padding-left:15px}.faq-section .fqb-title .exp{text-transform:capitalize;font-size:15px;line-height:1.7}.faq-section .fqb-title .exp .ring{top:0}.faq-section .fq-p-title{font-size:18px;display:inline-block;margin-top:-4px}.faq-section .fqb-list .toggle{list-style-type:decimal;list-style-position:inside}.faq-section .fqb-list .toggle.opened .fq-p-content{overflow:hidden;line-height:1.6}.faq-section .main-block .fqb-content{padding:0 35px 0 20px;font-size:15px}.faq-section .fqb-list .toggle.opened .fq-p-content{padding-left:30px}.tos-text{font-size:12px;line-height:18px;color:#aaa}.validation-error-box{display:none}.faq-section .fqb-ask-form ._flex{display:-moz-flex;display:-ms-flexbox;display:flex}@media (max-width:768px){.faq-title{font-size:50px;text-align:center;padding:20px 0 0}.faq-section .h-bottom{padding-left:30px}.faq-section .h-bottom .main-block,.faq-section .h-bottom .right-sidebar{width:100%;padding:0 30px;box-sizing:border-box;-moz-box-sizing:border-box}.faq-section .h-bottom .right-sidebar{float:right}.fqb-title{padding-left:20px}.fq-block.ask .fqb-title{text-align:center}.ask .fqb-ask-form .row{padding:0 20%}.tags.hide-if-mobile{display:none}.fqb-input input,.fqb-input textarea{height:42px}.sd-block.fq-block.ask{background-color:#151718;background-position:100% 0}}@media (max-width:640px){.faq-section .ask .fqb-ask-form .row{padding:0 10%}}@media (max-width:480px){.faq-title{font-size:40px}.faq-section .ask .fqb-ask-form .row{padding:0}.faq-section .main-block,.faq-section .right-sidebar{padding:0 20px}.faq-section .h-bottom{padding-left:20px}}@media (max-width:414px){.fqb-input.captcha input,.fqb-input.icon input,.fqb-input textarea{font-size:14px}.faq-section .right-sidebar .fqb-content{padding:0 25px}.faq-section .h-bottom{top:155px}}@media (min-width:768px){.faq-section{padding-top:72px}.faq-section .main-block{width:66%;float:left}.faq-section .right-sidebar{width:32%;float:right;min-width:240px}}@media (min-width:1150px){.faq-section{padding-top:105px}}.message-bubble{animation-duration:.3s;animation-fill-mode:both}.message-bubble.slide-right{animation-name:slideRightChat}.message-bubble.slide-left{animation-name:slideLeftChat}.gui-notice-item{position:fixed;top:0;z-index:11;margin:0 auto;right:0;left:0;max-width:980px;padding:20px;min-height:49px;border-radius:2px;color:#fff;margin-bottom:10px;background-color:#5d7bd0;animation-duration:.4s;animation-fill-mode:both;animation-name:slideDown}.gui-notice-item a{color:inherit;text-decoration:underline!important}.gui-notice-item a:hover{text-decoration:none!important}.gui-notice-item.error{background-color:#d35853}.gui-notice-item.attention{background-color:#f3c045}.gui-notice-item.success{color:#fff;background-color:#6cb758}.gui-notice-item.slide-up{animation-name:slideUp}.gui-notice-item.without-header{animation-name:slideDown2}.gui-notice-item.without-header.slide-up{animation-name:slideUp2}.gui-notice-item.connection-notice{text-align:center}.gui-notice-item.connection-notice .reconnect{margin-left:30px;cursor:pointer}.gui-notice-item.connection-notice .small-loader{display:inline-block;position:relative;left:0;top:5px;margin-right:5px}.gui-notice-item .notice-close{position:absolute;right:10px;top:10px;width:8px;height:8px;cursor:pointer;background:url(" + __webpack_require__(0) + ") no-repeat -134px -73px}.gui-notice-item .notice-message,.gui-notice-item .notice-type{display:inline-block;vertical-align:top}.gui-notice-item .notice-message{margin-left:20px;max-width:85%}.mc-through-notifications-container{position:absolute;top:100%;left:0;right:0;z-index:1001;margin-top:10px;transition:all margin-top s .3s linear}.mc-through-notifications-container *,.mc-through-notifications-container :after,.mc-through-notifications-container :before{box-sizing:border-box}.mc-through-notifications-container .list .gui-notice-item{position:static;animation-name:slideDown3}.mc-through-notifications-container .list .gui-notice-item.slide-up{animation-name:slideUp3}@keyframes slideDown{0%{transform:rotate(translate(0,-50%) deg);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}to{transform:rotate(translate(0,80px) deg);-ms-filter:none;filter:none;opacity:1}}@keyframes slideUp{0%{transform:rotate(translate(0,80px) deg);-ms-filter:none;filter:none;opacity:1}to{transform:rotate(translate(0,-50%) deg);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}}@keyframes slideDown2{0%{transform:rotate(translate(0,-100%) deg);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}to{transform:rotate(translate(0,10px) deg);-ms-filter:none;filter:none;opacity:1}}@keyframes slideDown3{0%{transform:rotate(translate(0,-100%) deg);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}to{transform:rotate(translate(0,0) deg);-ms-filter:none;filter:none;opacity:1}}@keyframes slideUp2{0%{transform:rotate(translate(0,0) deg);-ms-filter:none;filter:none;opacity:1}to{transform:rotate(translate(0,-100%) deg);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}}@keyframes slideUp3{0%{transform:rotate(translate(0,10px) deg);-ms-filter:none;filter:none;opacity:1}to{transform:rotate(translate(0,-100%) deg);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}}@keyframes slideRight{0%{transform:rotate(translate(-50%,0) deg);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}60%{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}to{transform:rotate(translate(0,0) deg);-ms-filter:none;filter:none;opacity:1}}@keyframes slideLeft{0%{transform:rotate(translate(50%,0) deg);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}60%{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}to{transform:rotate(translate(0,0) deg);-ms-filter:none;filter:none;opacity:1}}@keyframes slideRightChat{0%{transform:rotate(translate(-50%,0) deg);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}60%{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}to{transform:rotate(translate(0,0) deg);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=60)\";filter:alpha(opacity=60);opacity:.6}}@keyframes slideLeftChat{0%{transform:rotate(translate(50%,0) deg);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30);opacity:.3}60%{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);opacity:.5}to{transform:rotate(translate(0,0) deg);-ms-filter:none;filter:none;opacity:1}}@font-face{font-family:montserrat_hairline;src:url(" + __webpack_require__(3) + ") format(\"woff\"),url(" + __webpack_require__(4) + ") format(\"truetype\"),url(" + __webpack_require__(5) + "#montserrat_hairline) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_italic;src:url(" + __webpack_require__(6) + ") format(\"woff\"),url(" + __webpack_require__(7) + ") format(\"truetype\"),url(" + __webpack_require__(8) + "#woodfordbourne_italic) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_regular;src:url(" + __webpack_require__(9) + ") format(\"woff\"),url(" + __webpack_require__(10) + ") format(\"truetype\"),url(" + __webpack_require__(11) + "#woodfordbourne_regular) format(\"svg\");font-weight:400;font-style:\"normal\"}.promo-header{position:fixed;top:0;left:0;right:0;z-index:1000;width:100%;-ms-flex-negative:0;flex-shrink:0;background-color:transparent;transition:all .5s;transform:rotate(translateZ(0) deg)}.promo-header .logo{background:url(" + __webpack_require__(155) + ") 0 0 no-repeat}.promo-header.bgc,.promo-header.header-bg{background-color:#151718}.promo-header .header-container{position:relative}.promo-header .header-wrapper{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-align:end;-moz-align-items:flex-end;align-items:flex-end;width:100%;max-width:1060px;margin:0 auto;padding:0 6% 10px;position:relative;transition:all .5s}.promo-header .logo{background-size:contain;display:block}.promo-header .menu-action{-moz-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto}.promo-header .menu-close{background-image:url(" + __webpack_require__(0) + ");background-position:-789px -242px;width:17px;height:17px;display:none;cursor:pointer;margin-right:11px}.promo-header .menu-open{background-image:url(" + __webpack_require__(0) + ");background-position:-698px -311px;width:23px;height:18px;display:none;cursor:pointer;margin-right:8px}.promo-header .menu{-moz-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;-ms-flex-wrap:none;flex-wrap:nowrap}.promo-header .action,.promo-header .menu{display:-moz-flex;display:-ms-flexbox;display:flex}.promo-header .action{-moz-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-wrap:none;flex-wrap:nowrap}.promo-header .action-item,.promo-header .menu-item{text-transform:uppercase;white-space:nowrap;color:#fff;position:relative}.promo-header .action-item:last-child,.promo-header .menu-item:last-child{margin-right:0}.promo-header .action-item>a,.promo-header .menu-item>a{cursor:pointer;font-size:inherit}.promo-header .action-item.active .btn,.promo-header .action-item.active a,.promo-header .menu-item.active .btn,.promo-header .menu-item.active a{color:#5d7bd0}#notification-container{transform:rotate(translateY(0) deg)}@media (min-width:320px) and (max-width:767px){.promo-header{top:-385px;transition:all .5s}.promo-header.open{margin-top:385px}.promo-header .header-wrapper{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center;padding-bottom:20px}.promo-header.open .menu-open{display:none}.promo-header.open .menu-close{display:block}.promo-header .logo{width:155px;height:32px;margin-left:2px}.promo-header .menu-action{-moz-order:3;-ms-flex-order:3;order:3;margin-bottom:0;-ms-flex-item-align:stretch;align-self:stretch;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:center;-moz-align-items:center;align-items:center;margin-top:30px}.promo-header .menu-open{display:block}.promo-header .menu{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-moz-order:1;-ms-flex-order:1;order:1;-ms-flex-align:center;-moz-align-items:center;align-items:center;margin-left:0;margin-top:60px}.promo-header .menu-item{margin-right:0;margin-bottom:24px}.promo-header .action{-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-moz-order:2;-ms-flex-order:2;order:2;-ms-flex-align:center;-moz-align-items:center;align-items:center;margin-top:50px}.promo-header .action-item{margin-right:0;margin-bottom:30px}.promo-header .action-item,.promo-header .menu-item{font-size:16px}.promo-header .action-item:last-child,.promo-header .menu-item:last-child{margin-bottom:0}}@media (min-width:768px){.promo-header .action,.promo-header .menu{-ms-grid-row-align:stretch}.promo-header .action,.promo-header .action-item,.promo-header .menu,.promo-header .menu-item{-ms-flex-item-align:stretch;align-self:stretch;-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end}.promo-header .action-item,.promo-header .menu-item{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.promo-header .action-item:before,.promo-header .menu-item:before{content:\"\";position:absolute;top:0;left:50%;margin-left:-23.5px;background-image:url(" + __webpack_require__(0) + ");background-position:-689px -292px;width:47px;height:11px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;transition:all opacity s}.promo-header .action-item.active:before,.promo-header .menu-item.active:before{-ms-filter:none;filter:none;opacity:1}}@media (min-width:768px) and (max-width:1149px){.promo-header .header-wrapper{height:75px}.promo-header .logo{width:155px;height:32px}.promo-header .menu{margin-left:7.5%;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start}.promo-header .menu-action{margin-bottom:11px}.promo-header .action,.promo-header .menu{margin-bottom:19px}.promo-header .action-item,.promo-header .menu-item{font-size:12px}.promo-header .menu-item{margin-right:5.6%}.promo-header .action-item{margin-right:21px}.promo-header .btn-signup{margin-bottom:-10px;height:34px;line-height:34px;padding:0 19px}}@media (min-width:1150px){.promo-header .header-wrapper{height:105px;padding:0 0 10px}.promo-header .logo{width:202px;height:42px}.promo-header .menu{margin-left:12%;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start}.promo-header .menu-action{margin-bottom:23px}.promo-header .action,.promo-header .menu{margin-bottom:31px}.promo-header .action-item,.promo-header .menu-item{font-size:16px}.promo-header .menu-item{margin-right:7.5%}.promo-header .action-item{margin-right:23px}.promo-header .btn-signup{margin-bottom:-12px}}#gdpr-cookie-accept.sticky{margin-top:73px}.open #gdpr-cookie-accept.sticky{margin-top:455px}@media (min-width:1150px){#gdpr-cookie-accept.sticky{margin-top:105px}.open #gdpr-cookie-accept.sticky{margin-top:455px}}@font-face{font-family:montserrat_hairline;src:url(" + __webpack_require__(3) + ") format(\"woff\"),url(" + __webpack_require__(4) + ") format(\"truetype\"),url(" + __webpack_require__(5) + "#montserrat_hairline) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_italic;src:url(" + __webpack_require__(6) + ") format(\"woff\"),url(" + __webpack_require__(7) + ") format(\"truetype\"),url(" + __webpack_require__(8) + "#woodfordbourne_italic) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_regular;src:url(" + __webpack_require__(9) + ") format(\"woff\"),url(" + __webpack_require__(10) + ") format(\"truetype\"),url(" + __webpack_require__(11) + "#woodfordbourne_regular) format(\"svg\");font-weight:400;font-style:\"normal\"}.home-block{background-color:#151718}.home-block .content-block{overflow:hidden}.home-block .slides{width:100%;height:100%}.home-block .slide{width:inherit;height:inherit;overflow:hidden}.home-block .scroll-down{position:absolute;bottom:0;left:50%;margin-left:-42px;text-align:center;z-index:2}.home-block .scroll-down .scroll-down-icon{background-image:url(" + __webpack_require__(0) + ");background-position:-648px -183px;width:59px;height:59px;display:inline-block;cursor:pointer}.home-block .scroll-down .scroll-down-text{color:#fff;font-size:12px;text-transform:uppercase;display:none;white-space:nowrap}.home-block .slide-200models{background:url(" + __webpack_require__(156) + ") 100% 100% repeat-x;background-size:contain}.home-block .slide-200models .slide-block{background-image:linear-gradient(180deg,#254301,rgba(20,36,1,0) 40%);width:100vw;height:75vw;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex:1 0 auto;flex:1 0 auto;-ms-align-items:center;-ms-flex-align:center;align-items:center;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center;max-height:100vh}.home-block .slide-200models .slide-block .counter-models{display:-moz-flex;display:-ms-flexbox;display:flex;width:90vw;max-width:1687px}.home-block .slide-200models .slide-block .top-models{position:absolute;width:55vw;max-width:686px;bottom:16vw;right:9vw}.home-block .slide-home-welcome{background:url(" + __webpack_require__(157) + ") 100% 100% no-repeat;background-size:contain;background-color:#151718;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-align-items:center;-ms-flex-align:center;align-items:center;-ms-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;position:relative;width:100vw;height:75vw;max-height:100vh}.home-block .slide-home-welcome .text2{padding:3vw 0;position:relative;font-size:7vw;margin:0 0 7vw}.home-block .slide-home-welcome .text2 .col-1{color:#298fce}.home-block .slide-home-welcome .text2:after{background-color:#49d1a2;left:32%}.home-block .slide-home-welcome .text2:after,.home-block .slide-home-welcome .text2:before{content:\"\";position:absolute;display:block;height:5px;width:5px;border-radius:50%;bottom:-3px}.home-block .slide-home-welcome .text2:before{background-color:#298fce;right:32%}.home-block .slide-home-welcome .text2 span:after{content:\"\";position:absolute;display:block;height:1px;width:36%;left:32%;bottom:-1px;background-image:linear-gradient(90deg,#49d1a1,#298fce)}.home-block .slide-home-welcome .slide-text-block{color:#fff;text-transform:uppercase;background-size:contain;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center;-ms-align-items:center;-ms-flex-align:center;align-items:center;-ms-flex:0 0 auto;flex:0 0 auto}.home-block .owl-carousel .owl-item,.home-block .owl-carousel .owl-stage,.home-block .owl-carousel .owl-stage-outer{height:inherit}.home-block .owl-carousel .owl-dots{position:absolute}.home-block .owl-carousel .owl-dot{vertical-align:middle}.home-block .owl-theme .owl-dots .owl-dot span{background:#fff;width:10px;height:10px;margin:5px}.home-block .owl-theme .owl-dots .owl-dot.active span{background:transparent;border:1px solid #fff;width:12px;height:12px}.home-block .owl-theme .owl-dots .owl-dot:not(.active):hover span{background:#fff}@media (min-width:500px){.home-block .slide-home-welcome .text1{position:relative}.home-block .slide-home-welcome .text1:before{content:\"\";position:absolute;display:block;height:5px;width:5px;border-radius:50%;background-color:#49d1a2;left:50%;top:-4vw}.home-block .slide-home-welcome .text4{position:relative}.home-block .slide-home-welcome .text4:after{content:\"\";position:absolute;display:block;height:5px;width:5px;border-radius:50%;background-color:#298fce;left:50%;bottom:-4vw}}@media (min-width:320px) and (max-width:767px){.home-block .slide-home-welcome .slide-text-block{margin-left:5%}.home-block .scroll-down{bottom:26px;margin-left:-29px}.home-block .slide-home-welcome{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-align-items:center;-ms-flex-align:center;align-items:center}.home-block .slide-home-welcome .slide-text-block{font-size:3vw;width:auto;height:auto;background:none;margin-top:22vw;margin-left:3vw}.home-block .slide-home-welcome .text3{padding-bottom:10px}.home-block .slide-home-welcome .subscribe-container{bottom:40px}.home-block .slide-home-welcome .subscribe-container h2{max-width:270px;line-height:1.4;font-size:25px;text-shadow:0 0 5px #000}.home-block .slide-home-welcome .subscribe-container .input{margin-right:0;margin-bottom:10px;width:233px}.home-block .slide-home-welcome .subscribe-container .btn{margin-top:10px}.home-block .slide-home-welcome .subscribe-form,.home-block .slide-home-welcome .subscribe-wrap{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-align-items:center;-ms-flex-align:center;align-items:center}.home-block .owl-carousel .owl-dots{bottom:43px}.home-block .owl-theme .owl-dots .owl-dot span{margin:5px 2px}}@media (min-width:320px) and (max-width:767px){.home-block .scroll-down{bottom:26px;margin-left:-29px}.home-block .slide-home-welcome{-ms-align-items:flex-start;-ms-flex-align:start;align-items:flex-start}.home-block .slide-home-welcome .slide-text-block{font-size:3vw;width:auto;height:auto;margin-top:22vw}}@media (min-width:768px) and (max-width:1024px){.home-block .content-block .slide-home-welcome .slide-text-block{font-size:18px;width:469px;height:325px;padding-bottom:17px;padding-left:43px;position:relative}.home-block .content-block .slide-home-welcome .slide-text-block .text2{font-size:44px}.home-block .scroll-down{bottom:47px;margin-left:-38px}.home-block .subscribe-container{padding:40px 0 40px 40px;background-color:rgba(0,0,0,.75)}.home-block .owl-carousel .owl-dots{bottom:68px}}@media (min-width:1025px){.home-block .slide-home-welcome{height:50vw;max-width:1200px;margin:0 auto}.home-block .slide-200models .slide-block{height:50vw}.home-block .slide-200models .slide-block .top-models{bottom:10vw}.home-block .scroll-down{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-align-items:center;-ms-flex-align:center;align-items:center;bottom:69px}.home-block .scroll-down .scroll-down-icon{margin-bottom:30px}.home-block .scroll-down .scroll-down-text{display:inline}.home-block .slide-text-block{font-size:27px;margin-left:44px;padding-right:40px}.home-block .slide-text-block .text2{padding:27px 0 35px;font-size:92px}.home-block .slide-text-block .text3{padding-bottom:17px}.home-block .slide-text-block .subscribe-container{padding-bottom:100px;padding-left:44px}.home-block .owl-carousel .owl-dots{bottom:103px}}@media (min-width:2000px){.home-block .slide-200models .slide-block .counter-models{max-width:2200px;width:90vw}.home-block .slide-200models .slide-block .top-models{bottom:10vh;max-width:900px}}@font-face{font-family:montserrat_hairline;src:url(" + __webpack_require__(3) + ") format(\"woff\"),url(" + __webpack_require__(4) + ") format(\"truetype\"),url(" + __webpack_require__(5) + "#montserrat_hairline) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_italic;src:url(" + __webpack_require__(6) + ") format(\"woff\"),url(" + __webpack_require__(7) + ") format(\"truetype\"),url(" + __webpack_require__(8) + "#woodfordbourne_italic) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_regular;src:url(" + __webpack_require__(9) + ") format(\"woff\"),url(" + __webpack_require__(10) + ") format(\"truetype\"),url(" + __webpack_require__(11) + "#woodfordbourne_regular) format(\"svg\");font-weight:400;font-style:\"normal\"}.features-block{background-color:#fff}.features-block h3{font-size:25px}.features-block .info-items{width:100%;overflow:hidden;position:relative}.features-block .info-item{text-align:center;position:relative;display:inline-block}.features-block .info-content:after,.features-block .info-referral:after,.features-block .info-revshare:after{content:\"\";display:block;width:1px;height:156px;position:absolute;top:0;background-color:#c2dfec}.features-block .info-revshare:after{display:none}.features-block .info-items:not(.owl-carousel){display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center}.features-block .owl-carousel .owl-item{text-align:center}.features-block .info-icon{display:inline-block;margin-bottom:54px}.features-block .info-content-icon{background-image:url(" + __webpack_require__(0) + ");background-position:-243px -243px;width:162px;height:183px}.features-block .info-revshare-icon{background-image:url(" + __webpack_require__(0) + ");background-position:-648px 0;width:162px;height:183px}.features-block .info-payout-icon{background-image:url(" + __webpack_require__(0) + ");background-position:-486px 0;width:162px;height:183px}.features-block .info-referral-icon{background-image:url(" + __webpack_require__(0) + ");background-position:-486px -183px;width:162px;height:183px}.features-block .info-text{padding-top:21px;line-height:1.6}.features-block .owl-carousel .owl-dot{vertical-align:middle}.features-block .owl-theme .owl-dots .owl-dot span{background:#151718;width:10px;height:10px;margin:5px}.features-block .owl-theme .owl-dots.active span{background:transparent;border:1px solid #151718;width:12px;height:12px}.features-block .owl-theme .owl-dots:not(.active):hover span{background:#151718}.features-block .owl-theme .owl-nav.disabled+.owl-dots{margin-top:30px;margin-bottom:25px}@media (min-width:320px) and (max-width:767px){.features-block .info-items{margin-top:30px}.features-block .info-item{margin:0}.features-block .info-item:after{display:none}.features-block .info-icon{margin-bottom:20px}}@media (min-width:768px) and (max-width:1149px){.features-block .info-items{margin-top:60px}.features-block .info-item{margin:0 50px}.features-block .info-item:after{height:187px;right:-50px}}@media (min-width:1150px){.features-block .info-items{margin-top:0;margin-bottom:75px}.features-block .info-item{margin:0 50px;padding-top:65px}.features-block .info-item:after{height:187px;right:-50px}.features-block .info-content:after,.features-block .info-referral:after{top:65px}.features-block .info-revshare:after{top:35px;height:240px;display:block}}@font-face{font-family:montserrat_hairline;src:url(" + __webpack_require__(3) + ") format(\"woff\"),url(" + __webpack_require__(4) + ") format(\"truetype\"),url(" + __webpack_require__(5) + "#montserrat_hairline) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_italic;src:url(" + __webpack_require__(6) + ") format(\"woff\"),url(" + __webpack_require__(7) + ") format(\"truetype\"),url(" + __webpack_require__(8) + "#woodfordbourne_italic) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_regular;src:url(" + __webpack_require__(9) + ") format(\"woff\"),url(" + __webpack_require__(10) + ") format(\"truetype\"),url(" + __webpack_require__(11) + "#woodfordbourne_regular) format(\"svg\");font-weight:400;font-style:\"normal\"}.models-block{position:relative}.models-block .models-block-bg{background:url(" + __webpack_require__(158) + ") 36% 0 no-repeat;width:100%;height:100%}.models-block:before{background-image:linear-gradient(180deg,#6d82d3 0,#7487d3 25%,#7a8cd4 50%,#808ed5 75%,#8190d5);left:0}.models-block:after,.models-block:before{content:\"\";height:100%;width:50%;position:absolute;top:0;z-index:-1}.models-block:after{background-image:linear-gradient(180deg,#7186d2 0,#7b8dd3 25%,#8d98d6 50%,#969dd7 75%,#959cd7);right:0}.models-block .content-block{max-height:694px;background:url(" + __webpack_require__(159) + ") 91.5% 80% no-repeat}.models-block .models-counter{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-align-items:center;-ms-flex-align:center;align-items:center;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center}.models-block .models-counter>*{-ms-flex:1 0 auto;flex:1 0 auto}.models-block .models-counter .text{text-transform:uppercase;letter-spacing:-1px;line-height:.8}.models-block .models-counter .text.text-first{text-align:right}.models-block .counter,.models-block .counter-item{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center}.models-block .counter-item{max-width:117px;height:198px;background:hsla(0,0%,100%,.2);font-family:montserrat_hairline;margin-right:1px;border-radius:4px;position:relative;-ms-align-items:center;-ms-flex-align:center;align-items:center}.models-block .counter-item:last-child{margin-right:0}.models-block .counter-item.thousand-item{margin-right:5px}.models-block .counter-item .rivets{position:absolute;left:0;width:100%}.models-block .counter-item .rivets:after,.models-block .counter-item .rivets:before{content:\"\";width:4px;height:4px;display:block;border-radius:2px;background-color:#272e44;position:absolute}.models-block .counter-item .rivets:before{left:6px}.models-block .counter-item .rivets:after{right:6px}.models-block .counter-item .rivets-top{top:6px}.models-block .counter-item .rivets-bottom{bottom:10px}.models-block .model-avatar{width:160px;height:160px;border-radius:80px;overflow:hidden;border:10px solid hsla(0,0%,100%,.2);margin:0 25px 15px}.models-block .last-model-site{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-align-items:center;-ms-flex-align:center;align-items:center}.models-block .last-model-site .text{font-size:24px}.models-block .last-model-site .text-model-name{font-size:35px;color:#000}.models-block .model-site-info{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-align-items:center;-ms-flex-align:center;align-items:center}@media (min-width:320px) and (max-width:767px){.models-block .models-block-bg{background-position:30% 10%}.models-block .content-block{height:585px;padding-bottom:40px;background:none}.models-block .models-counter{-ms-flex-direction:column;flex-direction:column;padding:40px 0}.models-block .models-counter .text{font-size:30px}.models-block .counter{margin:25px 0}.models-block .counter-item{width:50px;height:85px;font-size:60px}.models-block .counter-item .rivets:after,.models-block .counter-item .rivets:before,.models-block .counter-item .rivets left 4px{right:4px}.models-block .counter-item .rivets-top{top:4px}.models-block .counter-item .rivets-bottom{bottom:8px}.models-block .model-avatar{-ms-order:3;-ms-flex-order:3;order:3;margin-top:20px}.models-block .last-model-site .text-last{-ms-order:1;-ms-flex-order:1;order:1;padding-bottom:15px}.models-block .last-model-site .text-added-data{-ms-order:2;-ms-flex-order:2;order:2;font-size:18px}.models-block .last-model-site .text-model-name{font-size:24px}.models-block .model-site-info{-ms-flex-direction:column;flex-direction:column}}@media (min-width:768px){.models-block .models-block-bg{background-position-x:25%}.models-block .content-block{height:600px;background-position:102% 100%}.models-block .models-counter{padding:100px 0 77px}.models-block .models-counter>*{width:200px}.models-block .models-counter .text{font-size:30px}.models-block .models-counter .text.text-first{text-align:right}.models-block .models-counter .text-second-w1{display:block}.models-block .models-counter .small-text{font-size:20px}.models-block .counter{margin:0 30px}.models-block .counter-item{width:80px;height:136px;font-size:100px}.models-block .model-site-info>*{min-width:160px}}@media (min-width:1150px){.models-block .content-block{height:694px}.models-block .models-counter{padding:119px 0 75px}.models-block .models-counter .text{font-size:45px}.models-block .models-counter .small-text{font-size:30px}.models-block .counter{margin:0 40px}.models-block .counter-item{width:117px;height:198px;font-size:150px}}@font-face{font-family:montserrat_hairline;src:url(" + __webpack_require__(3) + ") format(\"woff\"),url(" + __webpack_require__(4) + ") format(\"truetype\"),url(" + __webpack_require__(5) + "#montserrat_hairline) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_italic;src:url(" + __webpack_require__(6) + ") format(\"woff\"),url(" + __webpack_require__(7) + ") format(\"truetype\"),url(" + __webpack_require__(8) + "#woodfordbourne_italic) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_regular;src:url(" + __webpack_require__(9) + ") format(\"woff\"),url(" + __webpack_require__(10) + ") format(\"truetype\"),url(" + __webpack_require__(11) + "#woodfordbourne_regular) format(\"svg\");font-weight:400;font-style:\"normal\"}.signup-block{background-color:#0a0b0c;color:#fff}.signup-block h1{color:#fff;position:relative;z-index:2}.signup-block h1 .subhead{font-size:17px}.signup-block .content-block{overflow:hidden;padding-bottom:20px}.signup-block .signup-social{width:100%;text-align:center;margin-bottom:35px}.signup-block .signup-wrap{position:relative;z-index:2}.signup-block .signup-form{width:100%;text-align:center}.signup-block .signup-form .input{width:100%;margin-bottom:20px}.signup-block .signup-form .input:last-child{margin-bottom:0}.signup-block .signup-form .input input{padding:0 25px}.signup-block .signup-form .checkbox a{text-decoration:underline}.signup-block .signup-form .checkbox a:hover{text-decoration:none}.signup-block .btn-submit{width:145px;font-size:20px;margin-top:40px}.signup-block .inline-group{margin-top:15px}.signup-block .inline-group .btn{height:45px;line-height:45px;padding:0 22px}.signup-block .signup-img{background:url(" + __webpack_require__(160) + ") 0 0 no-repeat;width:330px;height:470px;background-size:contain;position:absolute;z-index:1}@media (min-width:320px) and (max-width:767px){.signup-block h1{padding-top:40px}.signup-block .signup-wrap{width:240px;margin:34px auto 0}.signup-block .signup-form .input{margin-bottom:10px}.signup-block .signup-form .input input{height:43px;line-height:43px}.signup-block .signup-form .checkbox{margin-top:10px}.signup-block .btn-submit{margin-top:22px}.signup-block .signup-img{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";filter:alpha(opacity=40);opacity:.4;bottom:0;left:50%}}@media (max-width:320px){.signup-block .signup-img{left:30%}}@media (min-width:320px) and (max-width:567px){.signup-block .content-block{background-position:-60px -80px}}@media (min-width:568px) and (max-width:767px){.signup-block .content-block{background-position:29% -20%}}@media (min-width:768px) and (max-width:1149px){.signup-block h1{padding-top:60px}.signup-block .content-block{background-position:35% -8%}.signup-block .signup-wrap{width:340px;margin-left:69px;margin-top:35px}.signup-block .signup-form .input input{height:58px;line-height:58px}.signup-block .signup-form .checkbox{margin-top:14px}.signup-block .signup-img{width:520px;height:740px;left:40%;bottom:0}}@media (min-width:1150px){.signup-block h1{padding-top:95px}.signup-block .signup-wrap{width:430px;margin-left:110px;margin-top:76px}.signup-block .signup-form .input input{height:58px;line-height:58px}.signup-block .signup-form .checkbox{margin-top:12px}.signup-block .signup-social{margin-bottom:60px}.signup-block .signup-img{width:662px;height:780px;bottom:0;left:48%}}@font-face{font-family:montserrat_hairline;src:url(" + __webpack_require__(3) + ") format(\"woff\"),url(" + __webpack_require__(4) + ") format(\"truetype\"),url(" + __webpack_require__(5) + "#montserrat_hairline) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_italic;src:url(" + __webpack_require__(6) + ") format(\"woff\"),url(" + __webpack_require__(7) + ") format(\"truetype\"),url(" + __webpack_require__(8) + "#woodfordbourne_italic) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_regular;src:url(" + __webpack_require__(9) + ") format(\"woff\"),url(" + __webpack_require__(10) + ") format(\"truetype\"),url(" + __webpack_require__(11) + "#woodfordbourne_regular) format(\"svg\");font-weight:400;font-style:\"normal\"}.sites-block .content-block{max-width:100%}.sites-block .content-block h1{position:absolute;color:#fff;z-index:100;width:100%}.sites-block .link-block{margin:25px 0}.sites-block .filter-models{width:100%;max-width:1084px;font-size:15px;margin-bottom:20px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.sites-block .input{max-width:223px;-ms-flex:1 0 auto;flex:1 0 auto}.sites-block .select-group{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex:1 0 auto;flex:1 0 auto}.sites-block .select-group .select{margin-right:10px}.sites-block .select-group .select:last-child{margin-right:0}.sites-block .select{-ms-flex:1 0 auto;flex:1 0 auto}.sites-block .btn-f-group .btn{padding:0 18px}.sites-block .btn-show{-ms-flex:1 0 auto;flex:1 0 auto}.sites-block .list-models{width:100%;overflow:hidden}.sites-block .model{text-align:center;font-size:16px;line-height:normal;width:100vw;height:75vw;max-height:100vh;background-size:cover;background-position:50%}.sites-block .model figcaption{position:absolute;bottom:50px;width:100%;color:#fff}.sites-block .model figcaption p{font-size:35px}.sites-block .owl-carousel .owl-item{text-align:center;background-color:#151718}.sites-block .owl-carousel .owl-dot{vertical-align:middle}.sites-block .owl-theme .owl-dots{position:absolute;bottom:20px;width:100%}.sites-block .owl-theme .owl-dots .owl-dot span{background:#fff;width:10px;height:10px}.sites-block .owl-theme .owl-dots .owl-dot.active span{background:transparent;border:1px solid #fff;width:12px;height:12px}.sites-block .owl-theme .owl-dots .owl-dot:not(.active):hover span{background:#fff}@media (min-width:320px) and (max-width:767px){.sites-block .content-block h1{display:none}.sites-block .link-block{margin:22px 0 21px}.sites-block .filter-models{-ms-flex-direction:column;flex-direction:column}.sites-block .filter-item{margin-bottom:10px}.sites-block .btn-f-group .btn,.sites-block .btn-show,.sites-block .select-group{-ms-flex:1 0 auto;flex:1 0 auto}.sites-block .owl-theme .owl-nav.disabled+.owl-dots{margin-top:21px}}@media (max-width:1024px){.sites-block .filter-model-name{display:none}}@media (min-width:768px) and (max-width:1149px){.sites-block .content-block h1{padding-bottom:40px}.sites-block .content-block .link-block{margin:34px 0 42px}.sites-block .content-block .filter-models{padding-bottom:10px}.sites-block .content-block .filter-item{margin-right:10px}.sites-block .content-block .select{max-width:260px}.sites-block .content-block .btn-show{max-width:120px}.sites-block .content-block .model figcaption{bottom:80px}.sites-block .content-block .model figcaption p{font-size:60px}.sites-block .content-block .model figcaption a{font-size:25px}}@media (min-width:1024px){.sites-block .content-block .model figcaption{bottom:80px}.sites-block .content-block .model figcaption p{font-size:90px}.sites-block .content-block .model figcaption a{font-size:25px}}@media (min-width:1025px){.sites-block .content-block .model{height:50vw}}@media (min-width:1150px){.sites-block .content-block .link-block{margin:24px 0 60px}.sites-block .content-block .filter-models{padding-bottom:19px}.sites-block .content-block .filter-item,.sites-block .content-block .select-group .select{margin-right:20px}.sites-block .content-block .select{max-width:182px}.sites-block .content-block .btn-show{max-width:138px}.sites-block .content-block .model{font-size:20px}.sites-block .content-block .model figcaption{padding-top:25px}}@font-face{font-family:montserrat_hairline;src:url(" + __webpack_require__(3) + ") format(\"woff\"),url(" + __webpack_require__(4) + ") format(\"truetype\"),url(" + __webpack_require__(5) + "#montserrat_hairline) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_italic;src:url(" + __webpack_require__(6) + ") format(\"woff\"),url(" + __webpack_require__(7) + ") format(\"truetype\"),url(" + __webpack_require__(8) + "#woodfordbourne_italic) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_regular;src:url(" + __webpack_require__(9) + ") format(\"woff\"),url(" + __webpack_require__(10) + ") format(\"truetype\"),url(" + __webpack_require__(11) + "#woodfordbourne_regular) format(\"svg\");font-weight:400;font-style:\"normal\"}.subscribe-container{position:absolute;bottom:0;left:0;right:0}.subscribe-container h2{font-size:30px;padding-bottom:30px;text-align:center}.subscribe-container .input{width:173px;margin-right:15px}.subscribe-container .input input{border-width:2px}.subscribe-container .btn{width:120px}.subscribe-wrap{display:inline-block}.subscribe-agree{max-width:500px;text-align:left;color:hsla(0,0%,100%,.702);margin:10px auto;line-height:16px;font-size:14px;padding:0 20px}.subscribe-block{background-color:#090a0b}.subscribe-block .content-block{background:url(" + __webpack_require__(161) + ") 0 0 no-repeat;background-size:contain;height:218px}.subscribe-block h2{color:#fff;text-align:right}.subscribe-block .input{width:173px;margin-right:15px}.subscribe-block .btn{width:120px}.subscribe-block .subscribe{text-align:right}@media (min-width:320px) and (max-width:767px){.subscribe-block .content-block{height:300px;background:none;padding:34px 0}.subscribe-block h2{padding:0;text-align:center;font-size:25px;padding-bottom:18px;line-height:1.2}.subscribe-block .input{width:100%;margin-right:0;margin-bottom:10px}.subscribe-block .subscribe{text-align:center;width:233px;margin:0 auto}.subscribe-block .btn-subscribe{margin-top:10px}}@media (min-width:768px) and (max-width:1149px){.subscribe-block .content-block{background-position-x:-122px}.subscribe-block h2{padding:55px 30px 31px 0}.subscribe-block .subscribe{margin-right:30px}.subscribe-agree{margin:10px 32px 0 0;float:right;padding:0}}@media (min-width:1150px){.subscribe-block h2{padding:55px 98px 33px 0}.subscribe-block .subscribe{margin-right:98px}.subscribe-agree{margin-right:100px;padding:0}}@font-face{font-family:montserrat_hairline;src:url(" + __webpack_require__(3) + ") format(\"woff\"),url(" + __webpack_require__(4) + ") format(\"truetype\"),url(" + __webpack_require__(5) + "#montserrat_hairline) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_italic;src:url(" + __webpack_require__(6) + ") format(\"woff\"),url(" + __webpack_require__(7) + ") format(\"truetype\"),url(" + __webpack_require__(8) + "#woodfordbourne_italic) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_regular;src:url(" + __webpack_require__(9) + ") format(\"woff\"),url(" + __webpack_require__(10) + ") format(\"truetype\"),url(" + __webpack_require__(11) + "#woodfordbourne_regular) format(\"svg\");font-weight:400;font-style:\"normal\"}.sp-navigator{margin-top:45px;top:0;transition:all .3s}.sp-navigator>li{position:relative;padding:15px 0 15px 20px;border-left:1px solid #e6e6e6;cursor:pointer;color:#000;line-height:1.2;transition:all .2s}.sp-navigator>li:first-child{padding-top:0}.sp-navigator>li:first-child .sp-dot{top:6px}.sp-navigator>li:last-child{padding-bottom:0}.sp-navigator>li.active,.sp-navigator>li:hover{color:#5d7bd0}.sp-navigator>li.active .sp-dot:before,.sp-navigator>li:hover .sp-dot:before{-ms-filter:none;filter:none;opacity:1;transform:scale(1)}.sp-navigator .sp-dot{position:absolute;display:block;width:15px;height:15px;border:1px solid #e6e6e6;border-radius:50%;left:-8px;background-color:#fff;top:23px;margin-top:-8px;transition:all .3s}.sp-navigator .sp-dot:before{content:\"\";display:block;width:7px;height:7px;background-color:#5d7bd0;border-radius:50%;position:absolute;top:3px;left:3px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0;transform:scale(0);transition:all}.sp-navigator.slide{position:fixed;margin-top:0;top:140px}.sp-navigator.slide li{padding-top:5px;padding-bottom:5px}.sp-navigator.slide li .sp-dot{top:14px}.sp-navigator.slide>li:first-child{padding-top:0}.sp-navigator.slide>li:first-child .sp-dot{top:7px}.sp-navigator.slide>li:last-child{padding-bottom:0}.sp-navigator.slide>li:last-child .sp-dot{top:14px}.sp-navigator.slide.bottom-reached{bottom:0;top:auto;margin-bottom:200px}@font-face{font-family:montserrat_hairline;src:url(" + __webpack_require__(3) + ") format(\"woff\"),url(" + __webpack_require__(4) + ") format(\"truetype\"),url(" + __webpack_require__(5) + "#montserrat_hairline) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_italic;src:url(" + __webpack_require__(6) + ") format(\"woff\"),url(" + __webpack_require__(7) + ") format(\"truetype\"),url(" + __webpack_require__(8) + "#woodfordbourne_italic) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_regular;src:url(" + __webpack_require__(9) + ") format(\"woff\"),url(" + __webpack_require__(10) + ") format(\"truetype\"),url(" + __webpack_require__(11) + "#woodfordbourne_regular) format(\"svg\");font-weight:400;font-style:\"normal\"}.promotools-block{position:relative}.promotools-block h1{color:#fff;padding-bottom:40px}.promotools-block h3{font-size:25px}.promotools-block .promotools-block-bg{background:url(" + __webpack_require__(162) + ") 68% -70px no-repeat;width:100%;height:100%}.promotools-block:before{background-image:linear-gradient(180deg,#40aa94 0,#40a99b 25%,#42a9a8 50%,#41a7b6 75%,#41a3c6);width:70%;left:0}.promotools-block:after,.promotools-block:before{content:\"\";height:100%;position:absolute;top:0;z-index:-1}.promotools-block:after{background-image:linear-gradient(180deg,#3899ac 0,#3997bd 25%,#3795cb 50%,#3793d6 75%,#3691d7);width:30%;right:0}.promotools-block .content-block{max-height:798px;overflow:hidden}.promotools-block .link-block{margin:15px 0 25px;position:relative}.promotools-block .link-block .mobile-tools{font-size:14px;color:#fff;text-transform:uppercase;padding:0 0 40px;position:relative}.promotools-block .link-block .mobile-tools:after{content:\"\";position:absolute;top:-28px;left:calc(50% - 22px);display:block;background-image:url(" + __webpack_require__(0) + ");background-position:-648px -242px;width:41px;height:69px}.promotools-block .link-icon{color:#fff}.promotools-block .info-items{width:100%}.promotools-block .info-item{width:280px;position:relative;display:inline-block;text-align:center;color:#fff}.promotools-block .info-items:not(.owl-carousel){display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center}.promotools-block .owl-carousel .owl-item{text-align:center}.promotools-block .info-icon{display:inline-block;margin-bottom:30px}.promotools-block .info-freehosted-icon{background-image:url(" + __webpack_require__(0) + ");background-position:0 0;width:243px;height:243px}.promotools-block .info-embed-icon{background-image:url(" + __webpack_require__(0) + ");background-position:0 -243px;width:243px;height:243px}.promotools-block .info-cards-icon{background-image:url(" + __webpack_require__(0) + ");background-position:-243px 0;width:243px;height:243px}.promotools-block .info-text{padding:20px 0 22px;line-height:1.6}.promotools-block .owl-carousel .owl-dot{vertical-align:middle}.promotools-block .owl-theme .owl-dots .owl-dot span{background:#fff;width:10px;height:10px}.promotools-block .owl-theme .owl-dots .owl-dot.active span{background:transparent;border:1px solid #fff;width:12px;height:12px}.promotools-block .owl-theme .owl-dots .owl-dot:not(.active):hover span{background:#fff}@media (min-width:320px) and (max-width:767px){.promotools-block .content-block{height:640px}.promotools-block .link-block{margin:10px 0 20px}.promotools-block .info-icon{margin-bottom:25px}.promotools-block .info-text{padding:10px 0 20px}.promotools-block .owl-theme .owl-nav.disabled+.owl-dots{margin-top:30px;margin-bottom:25px}}@media (min-width:320px) and (max-width:568px){.promotools-block .promotools-block-bg{background-position:37% 0}}@media (min-width:569px) and (max-width:768px){.promotools-block .promotools-block-bg{background-position:40px 0}}@media (min-width:768px) and (max-width:1149px){.promotools-block .link-block .mobile-tools{font-size:17px}.promotools-block .promotools-block-bg{background-position-y:0}.promotools-block .content-block{max-width:680px}.promotools-block .info-item{margin:0 30px}.promotools-block .owl-theme .owl-nav.disabled+.owl-dots{margin-top:30px;margin-bottom:25px}}@media (min-width:1150px){.promotools-block .link-block .mobile-tools{font-size:17px;padding:20px 0 60px}.promotools-block .link-block .mobile-tools:after{top:-8px}.promotools-block .content-block{height:798px}.promotools-block .info-items:not(.owl-carousel) .info-item:nth-child(odd),.promotools-block .owl-carousel .owl-item:nth-child(odd) .info-item{margin-top:40px}.promotools-block .info-item{margin:0 45px}}@font-face{font-family:montserrat_hairline;src:url(" + __webpack_require__(3) + ") format(\"woff\"),url(" + __webpack_require__(4) + ") format(\"truetype\"),url(" + __webpack_require__(5) + "#montserrat_hairline) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_italic;src:url(" + __webpack_require__(6) + ") format(\"woff\"),url(" + __webpack_require__(7) + ") format(\"truetype\"),url(" + __webpack_require__(8) + "#woodfordbourne_italic) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_regular;src:url(" + __webpack_require__(9) + ") format(\"woff\"),url(" + __webpack_require__(10) + ") format(\"truetype\"),url(" + __webpack_require__(11) + "#woodfordbourne_regular) format(\"svg\");font-weight:400;font-style:\"normal\"}.ui-widget-overlay{position:fixed;top:0;right:0;bottom:0;left:0;background-color:rgba(0,0,0,.75);z-index:9;width:100%;height:100%}.ui-dialog{max-width:405px;min-width:320px;background-color:#fff;margin:0 auto;border-radius:3px;color:#151718;z-index:10}.ui-dialog .ui-dialog-titlebar{text-align:center;padding:45px 0;border-bottom:1px solid #e7e7e7}.ui-dialog .ui-dialog-titlebar .ui-dialog-title{font-size:40px}.ui-dialog .ui-dialog-titlebar .ui-dialog-titlebar-close{cursor:pointer;display:block;border:none;background-color:transparent;position:absolute;top:25px;right:25px;background-image:url(" + __webpack_require__(0) + ");background-position:-789px -259px;width:15px;height:15px}.ui-dialog .ui-dialog-content{font-size:16px;padding:36px 50px}.ui-dialog .ui-dialog-content p{padding:14px 0}.ui-dialog .ui-dialog-content p a{color:#5d7bd0}.mc-tabs.pagination{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center;margin-top:40px}.mc-tabs.pagination .tab-item{font-size:15px;color:#151718;border:1px solid #e7e7e7;padding:12px 17px;margin-left:-1px;cursor:pointer}.mc-tabs.pagination .tab-item.prev{border-radius:4px 0 0 4px;padding:13px 30px 11px}.mc-tabs.pagination .tab-item.prev:after{content:\"\";left:1px;border-radius:1px;position:relative;display:inline-block;width:11px;height:11px;border-style:solid;border-color:#878787;border-width:0 2px 2px 0;transform:rotate(135deg)}.mc-tabs.pagination .tab-item.next{border-radius:0 4px 4px 0;padding:13px 30px 11px}.mc-tabs.pagination .tab-item.next:after{content:\"\";left:1px;border-radius:1px;position:relative;display:inline-block;width:11px;height:11px;border-style:solid;border-color:#878787;border-width:0 2px 2px 0;transform:rotate(-45deg)}.mc-tabs.pagination .tab-item.active{background-color:#f3f3f3}.mc-page-switcher{display:none}.mc-preloader-wrapper{position:relative;height:550px;width:100%}.ui-dialog .mc-preloader-wrapper{height:300px}#spin-wrap,scss.centered{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}#spin-wrap,#spin-wrap #spin,scss.round{border-radius:50%}#spin-wrap{width:180px;height:180px;background:#dedede}#spin-wrap #spin{width:78%;height:78%;margin:11%;background:#fff}#spin-wrap #spin:after,#spin-wrap #spin:before{content:\"\";display:block;position:absolute;top:0;width:50%;height:100%;z-index:-1}#spin-wrap #spin:before{left:50%;border-radius:0 100% 100% 0/50%;background:url(" + __webpack_require__(23) + ") no-repeat 100%;background-size:200% 100%;transform-origin:left center;animation:spin 1.5s linear infinite reverse}#spin-wrap #spin:after{left:0;border-radius:100% 0 0 100%/50%;background:url(" + __webpack_require__(23) + ") no-repeat;background-size:200% 100%;transform-origin:right center;animation:spin 3s linear infinite}#spin-wrap.sm{width:40px;height:40px}#spin-wrap.sm #spin{width:70%;height:70%;margin:15%}#spin-wrap .loading-text{font-weight:700;font-size:18px;height:11%;text-align:center;color:#a1a1a1;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;display:block}.loading-text{animation:opacityload 2s linear infinite}@keyframes opacityload{0%{-ms-filter:none;filter:none;opacity:1}50%{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0);opacity:0}to{-ms-filter:none;filter:none;opacity:1}}@keyframes spin{0%{transform:rotate(90deg)}to{transform:rotate(-270deg)}}@font-face{font-family:montserrat_hairline;src:url(" + __webpack_require__(3) + ") format(\"woff\"),url(" + __webpack_require__(4) + ") format(\"truetype\"),url(" + __webpack_require__(5) + "#montserrat_hairline) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_italic;src:url(" + __webpack_require__(6) + ") format(\"woff\"),url(" + __webpack_require__(7) + ") format(\"truetype\"),url(" + __webpack_require__(8) + "#woodfordbourne_italic) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_regular;src:url(" + __webpack_require__(9) + ") format(\"woff\"),url(" + __webpack_require__(10) + ") format(\"truetype\"),url(" + __webpack_require__(11) + "#woodfordbourne_regular) format(\"svg\");font-weight:400;font-style:\"normal\"}.model-sites-block{background-color:#fff}.model-sites-block .content-block{padding:0 30px}.model-sites-block .link-block{color:#000;margin:0 0 25px}.model-sites-block .link-block a{color:#000}.model-sites-block .filter-models{width:100%;max-width:1084px;font-size:15px;margin-bottom:20px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.model-sites-block .filter-models .select-group,.model-sites-block .filter-models .select-pair{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex:1 0 auto;flex:1 0 auto;-ms-flex-direction:column;flex-direction:column}.model-sites-block .filter-models .select-group .btn-f-group,.model-sites-block .filter-models .select-group .filter-item{margin-bottom:10px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex:1 0 auto;flex:1 0 auto}.model-sites-block .filter-models .select-group .btn-f-group>*,.model-sites-block .filter-models .select-group .filter-item>*{-ms-flex:1 0 auto;flex:1 0 auto}.model-sites-block .filter-models .select-group .btn-f-group label.btn:nth-child(2),.model-sites-block .filter-models .select-group .filter-item label.btn:nth-child(2){border-radius:4px 0 0 4px}.model-sites-block .filter-models .select-group .btn-f-group .dropdown,.model-sites-block .filter-models .select-group .filter-item .dropdown{display:block;height:43px}.model-sites-block .filter-models .select-group .btn-f-group .dropdown .current-value,.model-sites-block .filter-models .select-group .filter-item .dropdown .current-value{top:13px}.model-sites-block .filter-models .select-group .btn-f-group .dropdown .drop-arrow,.model-sites-block .filter-models .select-group .filter-item .dropdown .drop-arrow{border:none}.model-sites-block .filter-models .select-group .btn-f-group .dropdown .drop-arrow:after,.model-sites-block .filter-models .select-group .filter-item .dropdown .drop-arrow:after{height:9px;width:9px}.model-sites-block .filter-models .select-group .select{margin-right:10px}.model-sites-block .filter-models .select-group .select:last-child{margin-right:0}.model-sites-block .filter-models .select-group .button-block{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.model-sites-block .filter-models .select-group .button-block .btn{-ms-flex:0 auto;flex:0 auto;margin-left:10px}.model-sites-block .filter-models .select-group .button-block .btn:first-child{border-radius:4px 0 0 4px}.model-sites-block .filter-models .btn-f-group input[type=checkbox]{display:none}.model-sites-block .filter-models .btn-f-group input:checked+label{background:#f3f3f3}.model-sites-block .filter-models [contentEditable]:empty:not(:focus):before{content:attr(data-placeholder);color:rgba(23,21,24,.6)}.model-sites-block .filter-models .btn-show{-ms-flex:1 0 auto;flex:1 0 auto;padding:0}.model-sites-block .list-models{width:100%;max-width:1084px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center}.model-sites-block .list-models .model{-ms-flex:1 0 auto;flex:1 0 auto;position:relative;text-align:center;margin:0 0 1px 1px;font-size:16px;max-width:300px;min-width:149px;line-height:normal}.model-sites-block .list-models .model div{padding-bottom:160%;background-size:cover;background-position:50%}.model-sites-block .list-models .model figcaption{padding:16px 0;margin:0 20px;border-radius:4px;position:absolute;bottom:20px;width:calc(100% - 40px);background-color:rgba(0,0,0,.4)}@media (min-width:320px) and (max-width:767px){.model-sites-block .content-block{padding:0 20px 36px}.model-sites-block .link-block{margin:15px 0 21px}.model-sites-block .filter-models{-ms-flex-direction:column;flex-direction:column}.model-sites-block .btn-show,.model-sites-block .filter-models .btn-f-group .btn,.model-sites-block .filter-models .select-group{-ms-flex:1 0 auto;flex:1 0 auto}.model-sites-block .owl-theme .owl-nav.disabled+.owl-dots{margin-top:21px}.modelssite-page h1{padding:90px 0 20px}}@media (min-width:500px){.model-sites-block .list-models .model{min-width:214px}.model-sites-block .filter-models{-ms-flex-direction:column;flex-direction:column}.model-sites-block .filter-models .select-group{-ms-flex-direction:row;flex-direction:row}.model-sites-block .filter-models .select-group .filter-item{margin:0;padding:0 6px 6px 0}.model-sites-block .filter-models .select-group .filter-item:last-child{padding:0 0 6px}}@media (min-width:768px){.model-sites-block .list-models .model{min-width:149px}.model-sites-block .content-block{padding-bottom:67px}.model-sites-block h1{padding-bottom:40px}.model-sites-block .link-block{margin:0 0 42px}.model-sites-block .filter-models{padding-bottom:10px}.model-sites-block .filter-models .select-pair{-ms-flex-direction:row;flex-direction:row}.model-sites-block .filter-models .select-pair .select-group:last-child{padding-left:6px}.modelssite-page .list-models .model{min-width:216px}.modelssite-page h1{padding-top:110px}}@media (min-width:1000px){.model-sites-block .filter-models{-ms-flex-direction:row;flex-direction:row}.model-sites-block .filter-models .select-pair{padding-left:6px}.model-sites-block .filter-models .btn-show{padding:0 10px}}@media (min-width:1150px){.model-sites-block .content-block{padding-bottom:91px}.model-sites-block .link-block{margin:0 0 60px}.model-sites-block .filter-models{padding-bottom:19px}.model-sites-block .filter-models .select-group .select{margin-right:20px}.model-sites-block .filter-models .btn-show{max-width:138px}.model-sites-block .model{font-size:20px}.modelssite-page h1{padding-top:155px}}@font-face{font-family:montserrat_hairline;src:url(" + __webpack_require__(3) + ") format(\"woff\"),url(" + __webpack_require__(4) + ") format(\"truetype\"),url(" + __webpack_require__(5) + "#montserrat_hairline) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_italic;src:url(" + __webpack_require__(6) + ") format(\"woff\"),url(" + __webpack_require__(7) + ") format(\"truetype\"),url(" + __webpack_require__(8) + "#woodfordbourne_italic) format(\"svg\");font-weight:400;font-style:\"normal\"}@font-face{font-family:woodfordbourne_regular;src:url(" + __webpack_require__(9) + ") format(\"woff\"),url(" + __webpack_require__(10) + ") format(\"truetype\"),url(" + __webpack_require__(11) + "#woodfordbourne_regular) format(\"svg\");font-weight:400;font-style:\"normal\"}.promo-footer{-ms-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;background-color:#151718;color:#fff;font-size:15px}.promo-footer .footer-wrapper{max-width:1150px;margin:60px auto 50px;display:-moz-flex;display:-ms-flexbox;display:flex}.promo-footer .copyright{line-height:1.5}.promo-footer .copyright a{color:#fff}.promo-footer .menu,.promo-footer .social{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-justify-content:center;-ms-flex-pack:center;justify-content:center}.promo-footer .social{margin-top:28px}.promo-footer .info-link,.promo-footer .menu-item{padding-bottom:5px;border-bottom:1px solid transparent;cursor:pointer;transition:border-bottom-color .3s ease-out}.promo-footer .info-link:hover,.promo-footer .menu-item:hover{border-bottom-color:#2a3134}.promo-footer .menu-item{margin-right:35px}.promo-footer .menu-item:last-child{margin-right:0}.promo-footer .social-item{cursor:pointer;display:block;margin-right:20px}.promo-footer .social-item:last-child{margin-right:0}.promo-footer .social-item.tumblr{background-image:url(" + __webpack_require__(0) + ");background-position:-757px -183px;width:50px;height:50px}.promo-footer .social-item.twitter{background-image:url(" + __webpack_require__(0) + ");background-position:-689px -242px;width:50px;height:50px}.promo-footer .social-item.facebook{background-image:url(" + __webpack_require__(0) + ");background-position:-739px -242px;width:50px;height:50px}.promo-footer .social-item.instagram{background-image:url(" + __webpack_require__(0) + ");background-position:-707px -183px;width:50px;height:50px}.promo-footer .info-link{cursor:pointer;padding-bottom:3px}@media (min-width:320px) and (max-width:767px){.promo-footer .footer-wrapper{margin:23px 0 48px}.promo-footer .copyright{-ms-flex-direction:column;flex-direction:column;-ms-align-items:center;-ms-flex-align:center;align-items:center}.promo-footer .copyright p{padding-right:0;line-height:1.6}.promo-footer .social{margin-bottom:30px}.promo-footer .info-links{font-size:13px;margin-top:24px;margin-right:5px}}@media (max-width:460px){.promo-footer .menu{display:none}.promo-footer .info-links{margin-right:5px}}@media (min-width:768px) and (max-width:1149px){.promo-footer .footer-wrapper{margin-bottom:54px}.promo-footer .links{padding-bottom:10px}.promo-footer .info-links{margin-top:20px}.promo-footer .social{margin-bottom:58px}}@media (max-width:1149px){.promo-footer .footer-wrapper{-ms-flex-direction:column;flex-direction:column;-ms-align-items:center;-ms-flex-align:center;align-items:center}.promo-footer .copyright{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-order:2;-ms-flex-order:2;order:2;line-height:1}.promo-footer .copyright p{padding-right:5px}.promo-footer .links{-ms-order:1;-ms-flex-order:1;order:1}.promo-footer .info-links{-ms-order:3;-ms-flex-order:3;order:3}.promo-footer .info-link{margin-right:7px}.promo-footer .info-link:last-child{margin-right:0}}@media (min-width:1150px){.promo-footer .footer-wrapper{-ms-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;padding:0 5px}.promo-footer .links{margin-right:22px}.promo-footer .info-links{text-align:right}.promo-footer .info-link{margin-right:19px}.promo-footer .info-link.break:after{content:\"\";display:block;margin-bottom:15px}}.affiliate-program-agreement{max-width:1060px;margin:25px auto 0}.affiliate-program-agreement .sp-up-time{font-size:16px}.affiliate-program-agreement h1.apa-title{font-size:45px;width:80%}.affiliate-program-agreement h1.apa-title sup{font-size:14px;vertical-align:super;top:0}.affiliate-program-agreement a{color:#5d7bd0;text-decoration:underline}@media (max-width:767px){.affiliate-program-agreement{margin:25px 10px 0}.affiliate-program-agreement h1.apa-title{font-size:30px;width:100%}.affiliate-program-agreement .sp-part-title{font-weight:700}.affiliate-program-agreement .sp-part-title .num{font-size:20px}}@media (min-width:768px) and (max-width:1149px){.affiliate-program-agreement h1.apa-title{font-size:40px;width:70%}}.single-page{margin:0 auto;max-width:1060px;margin-top:200px}.single-page a{color:#3b5998}.single-page .padd-left{padding-left:55px}.single-page .part-navigator{color:#3b5998;cursor:pointer}.single-page .sp-part .sp-part-title{font-weight:700}.single-page .sp-part .wrapper-cookie-table{max-width:100%;overflow-x:scroll}.single-page .sp-part .wrapper-cookie-table .cookie-table{border-collapse:collapse;margin-bottom:20px}.single-page .sp-part .wrapper-cookie-table .cookie-table td,.single-page .sp-part .wrapper-cookie-table .cookie-table th{padding:10px;border:1px solid #cecece}.sp-title{font-size:25px;margin-bottom:10px}.sp-up-time{font-size:12px;color:#a3a3a3}@media (min-width:1024px){.single-page .sp-part .wrapper-cookie-table{overflow-x:hidden}}.contest-page-wrapper .list,.contest-page-wrapper .submit-block,.contest-page-wrapper .top{padding-left:20px;padding-right:20px}.contest-page-wrapper .top{padding-top:35px;padding-bottom:30px;text-align:center;background:url(" + __webpack_require__(163) + ") 60% 0 no-repeat #0f181c;position:relative;background-size:cover}.contest-page-wrapper .top h1{font-size:30px;line-height:40px;color:#fff;margin-bottom:30px;text-transform:uppercase}.contest-page-wrapper .top h3{font-size:20px;line-height:20px;margin-bottom:25px;color:#fff;text-transform:uppercase}.contest-page-wrapper .top p{color:#ffd804;line-height:28px;font-size:14px}.contest-page-wrapper .top .lines{position:absolute;bottom:-50px;left:5%;display:none}.contest-page-wrapper .list{padding-top:30px;padding-bottom:30px;background-color:#fff}.contest-page-wrapper .list ul{max-width:760px;margin:0 auto}.contest-page-wrapper .list ul li{display:block;padding:0 20px 20px;margin-bottom:50px;border-bottom:1px solid #ffd804;position:relative;text-align:center}.contest-page-wrapper .list ul li:after,.contest-page-wrapper .list ul li:before{content:\"\";display:block;width:7px;height:7px;border-radius:50%;background-color:#ffd804;position:absolute;bottom:-3px}.contest-page-wrapper .list ul li:before{left:0}.contest-page-wrapper .list ul li:after{right:0}.contest-page-wrapper .list ul li:last-child{margin-bottom:0;border-bottom:0;padding-bottom:0}.contest-page-wrapper .list ul li:last-child:after,.contest-page-wrapper .list ul li:last-child:before{display:none}.contest-page-wrapper .list ul li .icon{display:block;margin:0 auto;width:50px;height:33px;background-position:top;background-repeat:no-repeat}.contest-page-wrapper .list ul li .icon.participants{background-image:url(" + __webpack_require__(164) + ")}.contest-page-wrapper .list ul li .icon.prize{background-image:url(" + __webpack_require__(165) + ")}.contest-page-wrapper .list ul li .icon.winners{background-image:url(" + __webpack_require__(166) + ")}.contest-page-wrapper .list ul li .title{font-size:28px;line-height:28px;margin-top:15px;margin-bottom:15px}.contest-page-wrapper .list ul li .text{font-size:16px;line-height:25px}.contest-page-wrapper .submit-block{padding-top:20px;padding-bottom:20px;background-color:#0c0d0e;text-align:center}.contest-page-wrapper .submit-block .reg-button{font-size:30px;color:#fefefe;padding:18px 0;line-height:34px;border-radius:3px;background-image:linear-gradient(90deg,#5d7bd0,#3fa88f);margin:0 auto;display:block;font-weight:400;text-transform:uppercase}@media (min-width:768px){.contest-page-wrapper .list{padding:30px 40px}.contest-page-wrapper .list ul li{padding-left:100px;padding-right:100px}.contest-page-wrapper .submit-block .reg-button{display:inline-block;padding:28px 65px}}@media (min-width:1024px){.contest-page-wrapper .list,.contest-page-wrapper .submit-block,.contest-page-wrapper .top{padding-left:0;padding-right:0}.contest-page-wrapper .top{padding-top:85px;padding-bottom:65px}.contest-page-wrapper .top h1{font-size:60px;line-height:71px;margin-bottom:90px}.contest-page-wrapper .top h3{font-size:30px;line-height:30px}.contest-page-wrapper .top p{line-height:28px;font-size:16px}.contest-page-wrapper .top .lines{display:block}.contest-page-wrapper .list{padding:100px 0}.contest-page-wrapper .list ul li{padding-left:135px;padding-right:135px;padding-bottom:60px}.contest-page-wrapper .list ul li .title{margin-bottom:35px}.contest-page-wrapper .submit-block{padding-top:60px;padding-bottom:60px}}@media (min-width:1200px){.contest-page-wrapper .list ul{max-width:970px}}", ""]);

// exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/sprite-small-preloader-white.png", __webpack_require__.p + "images/sprite-small-preloader-white.png");

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/faq/images/faq-back-arr.png", __webpack_require__.p + "_/_/_/_/common/faq/images/faq-back-arr.png");

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/faq/images/faq-icon-name.png", __webpack_require__.p + "_/_/_/_/common/faq/images/faq-icon-name.png");

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/faq/images/faq-icon-email.png", __webpack_require__.p + "_/_/_/_/common/faq/images/faq-icon-email.png");

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/faq/images/faq-icon-search.png", __webpack_require__.p + "_/_/_/_/common/faq/images/faq-icon-search.png");

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/faq/top5_bg.png", __webpack_require__.p + "images/faq/top5_bg.png");

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/faq/form_bg.jpg", __webpack_require__.p + "images/faq/form_bg.jpg");

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/logo-def.png", __webpack_require__.p + "images/logo-def.png");

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("customizations/mcprofits/images/customslides/200models/backcollage.jpg", __webpack_require__.p + "customizations/mcprofits/images/customslides/200models/backcollage.jpg");

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/home_slide_1_bg_1.jpg", __webpack_require__.p + "images/bg/home_slide_1_bg_1.jpg");

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/models_block_bg.jpg", __webpack_require__.p + "images/bg/models_block_bg.jpg");

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/models_polyline_2.png", __webpack_require__.p + "images/bg/models_polyline_2.png");

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/signup_block_bg.jpg", __webpack_require__.p + "images/bg/signup_block_bg.jpg");

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/subscribe_block_bg.jpg", __webpack_require__.p + "images/bg/subscribe_block_bg.jpg");

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/bg/promotools_block_bg.jpg", __webpack_require__.p + "images/bg/promotools_block_bg.jpg");

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/contest-top-bg.jpg", __webpack_require__.p + "images/contest-top-bg.jpg");

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/icon-1.png", __webpack_require__.p + "images/icon-1.png");

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/icon-2.png", __webpack_require__.p + "images/icon-2.png");

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/icon-3.png", __webpack_require__.p + "images/icon-3.png");

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./maps/guest.js": 168,
	"./root.opt": 169
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 167;

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root .Site_Layout":{"group":[{"value":"pages","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102003},"path":"@root .Site_Layout","_fox_":1}],"active":[{"value":false,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102004},"path":"@root .Site_Layout","_fox_":1}]},"@root ~.Site_Page":{"visual":[{"value":false,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102006},"path":"@root ~.Site_Page","_fox_":1}],"group":[{"value":"pages","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102007},"path":"@root ~.Site_Page","_fox_":1}]},"@root ~.Site_Page .Widget":{"container":[{"value":"#sitepage-container","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102009},"path":"@root ~.Site_Page .Widget","_fox_":1}],"autoRender":[{"value":true,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102010},"path":"@root ~.Site_Page .Widget","_fox_":1}],"handleWom.pageAddedToDom.event":[{"value":"addedToDom","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102013},"path":"@root ~.Site_Page .Widget","_fox_":1}],"handleWom.pageAddedToDom.widget":[{"value":"@this","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102014},"path":"@root ~.Site_Page .Widget","_fox_":1}],"handleWom.pageAddedToDom.callback":[{"value":function () {
window.scroll(0,0);
if (this.getOption('transparentHeader') === true) {
return;
}
$('#promo-header').addClass('header-bg');
},"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102022},"path":"@root ~.Site_Page .Widget","_fox_":1}],"handleWom.pageAddedToDom.params.prefix":[{"value":"addedToDomForAllPages","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102023},"path":"@root ~.Site_Page .Widget","_fox_":1}]},"@root":{"mapGuest.routes.@":[{"value":"#promo #home","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.@home":[{"value":"\u003E\u003E","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.home":[{"value":"\u003E\u003E","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.home(\u002F*tail)":[{"value":"\u003E\u003E","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.@miss":[{"value":"#auth #login","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.affiliate-agreement":[{"value":"#promo #affiliateProgramAgreement","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.terms-of-use":[{"value":"#promo #termsofuse","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.lambo\u002Fterms":[{"value":"#promo #lamboterms","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.cookie-table":[{"value":"#promo #cookietable","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.cookie-policy":[{"value":"#promo #cookiepolicy","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.privacy-policy":[{"value":"#promo #privacypolicy","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.oursites":[{"value":"#promo #ourSites","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.login":[{"value":"#auth #login","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.passrecovery(*hash)":[{"value":"#auth #passRecovery","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.faq":[{"value":"#promo #faq","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.promo":[{"value":"#promo #contest","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.unsubscribe":[{"value":"#auth #unsubscribe","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.features":[{"value":"#promo #home","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.our-sites":[{"value":"#promo #home","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.promo-tools":[{"value":"#promo #home","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.registration":[{"value":"#promo #home","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.routes.promo-iframe":[{"value":"#promo #promoIframe","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102049},"path":"@root","_fox_":1}],"mapGuest.denied.models":[{"value":"membersOnly","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102051},"path":"@root","_fox_":1}],"mapGuest.denied.free-hosted-galleries":[{"value":"membersOnly","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102052},"path":"@root","_fox_":1}],"mapGuest.special.membersOnly":[{"value":"login","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102054},"path":"@root","_fox_":1}],"mapGuest.widgets.intercom.widget":[{"value":"Intercom","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102057},"path":"@root","_fox_":1}],"mapGuest.widgets.intercom.listenWidgets":[{"value":"@root .Site_Layout .Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102058},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widget":[{"value":"Layout_Promo","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102060},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.template":[{"value":"Layout_Promo","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102061},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.faq.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102064},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.faq.title":[{"value":"Faq","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102065},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.faq.widgets.faq.widget":[{"value":"Promo_Faq","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102068},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.faq.widgets.faq.container":[{"value":"#sitepage-container","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102069},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.faq.widgets.faq.titleFaq":[{"value":"FAQ","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102070},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.faq.widgets.faq.hooks.onAddedToDom":[{"value":function () {
$('#promo-header .menu-link').removeClass('active');
$('#promo-header .menu-link[data-name="promo-faq"]').addClass('active');
},"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102074},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.home.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102076},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.home.widgets.promoHome.widget":[{"value":"Promo_Home","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102079},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.ourSites.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102081},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.ourSites.widgets.promoHome.widget":[{"value":"Promo_OurSites","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102084},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.affiliateProgramAgreement.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102086},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.affiliateProgramAgreement.widgets.affiliateProgramAgreement.widget":[{"value":"Widget","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102089},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.affiliateProgramAgreement.widgets.affiliateProgramAgreement.template":[{"value":"affiliate_program_agreement","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102090},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.affiliateProgramAgreement.widgets.affiliateProgramAgreement.widgets.anchorNavigator.widget":[{"value":"AnchorNavigator","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102093},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.affiliateProgramAgreement.widgets.affiliateProgramAgreement.widgets.anchorNavigator.targetWidget":[{"value":"@parent","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102094},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.affiliateProgramAgreement.widgets.affiliateProgramAgreement.widgets.anchorNavigator.clickTarget":[{"value":".sp-navigator li","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102095},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.affiliateProgramAgreement.widgets.affiliateProgramAgreement.widgets.anchorNavigator.dopOffsetTop":[{"value":"#promo-header","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102096},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.affiliateProgramAgreement.widgets.affiliateProgramAgreement.widgets.sidebarSlider.widget":[{"value":"SidebarSlider","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102098},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.affiliateProgramAgreement.widgets.affiliateProgramAgreement.widgets.sidebarSlider.targetWidget":[{"value":"@parent","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102099},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.affiliateProgramAgreement.widgets.affiliateProgramAgreement.widgets.sidebarSlider.targetSelector":[{"value":".sp-navigator","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102100},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.affiliateProgramAgreement.widgets.affiliateProgramAgreement.widgets.sidebarSlider.scrollOffset":[{"value":105,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102101},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.affiliateProgramAgreement.widgets.affiliateProgramAgreement.widgets.sidebarSlider.bottomScrollOffset":[{"value":155,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102102},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.contest.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102104},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.contest.widgets.contest.widget":[{"value":"Widget","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102106},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.contest.widgets.contest.template":[{"value":"sitepage_contest","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102107},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.promoIframe.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102109},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.promoIframe.title":[{"value":"Affiliate Promotional iframe - Start earning big simply by adding our code to your site","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102110},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.promoIframe.description":[{"value":"MCProfits iFrame is a powerful promotional tool that allows you to set up whole site inside of your site in a matter of few clicks. iFrame offers a variety of information about the performers including amount of content, bio text, performer’s stats, content thumbnails, etc.","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102111},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.promoIframe.widgets.base.widget":[{"value":"Widget","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102113},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.promoIframe.widgets.base.autoRender":[{"value":true,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102114},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.promoIframe.widgets.base.template":[{"value":"promo_iframe_base","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102115},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.promoIframe.widgets.base.widgets.promoIframe.widget":[{"value":"Promo_Iframe","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102118},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.termsofuse.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102120},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.termsofuse.group":[{"value":"pages","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102121},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.termsofuse.visual":[{"value":false,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102122},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.termsofuse.title":[{"value":"Terms-of-Use Agreement","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102123},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.termsofuse.widgets.termsofuse.widget":[{"value":"Widget","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102126},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.termsofuse.widgets.termsofuse.template":[{"value":"promo_termsofuse","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102127},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.termsofuse.widgets.termsofuse.container":[{"value":".common-content","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102128},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.termsofuse.widgets.termsofuse.autoRender":[{"value":true,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102129},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.lamboterms.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102131},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.lamboterms.group":[{"value":"pages","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102132},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.lamboterms.visual":[{"value":false,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102133},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.lamboterms.title":[{"value":"Lambo Terms","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102134},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.lamboterms.widgets.lamboterms.widget":[{"value":"Widget","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102137},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.lamboterms.widgets.lamboterms.template":[{"value":"lambo_terms","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102138},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.lamboterms.widgets.lamboterms.container":[{"value":".common-content","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102139},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.lamboterms.widgets.lamboterms.autoRender":[{"value":true,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102140},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookietable.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102142},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookietable.group":[{"value":"pages","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102143},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookietable.visual":[{"value":false,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102144},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookietable.title":[{"value":"Cookie Table","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102145},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookietable.widgets.cookitable.widget":[{"value":"Widget","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102148},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookietable.widgets.cookitable.template":[{"value":"promo_cookietable","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102149},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookietable.widgets.cookitable.container":[{"value":".common-content","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102150},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookietable.widgets.cookitable.autoRender":[{"value":true,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102151},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookiepolicy.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102153},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookiepolicy.group":[{"value":"pages","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102154},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookiepolicy.visual":[{"value":false,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102155},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookiepolicy.title":[{"value":"Cookie Policy","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102156},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookiepolicy.widgets.cookiepolicy.widget":[{"value":"Widget","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102159},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookiepolicy.widgets.cookiepolicy.template":[{"value":"promo_cookiepolicy","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102160},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookiepolicy.widgets.cookiepolicy.container":[{"value":".common-content","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102161},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.cookiepolicy.widgets.cookiepolicy.autoRender":[{"value":true,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102162},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.privacypolicy.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102164},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.privacypolicy.group":[{"value":"pages","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102165},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.privacypolicy.visual":[{"value":false,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102166},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.privacypolicy.title":[{"value":"Privacy Policy","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102167},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.privacypolicy.widgets.privacypolicy.widget":[{"value":"Widget","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102170},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.privacypolicy.widgets.privacypolicy.template":[{"value":"promo_privacypolicy","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102171},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.privacypolicy.widgets.privacypolicy.container":[{"value":".common-content","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102172},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.privacypolicy.widgets.privacypolicy.autoRender":[{"value":true,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102173},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.privacypolicy.widgets.privacypolicy.widgets.anchorNavigator.widget":[{"value":"AnchorNavigator","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102176},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.privacypolicy.widgets.privacypolicy.widgets.anchorNavigator.targetWidget":[{"value":"@parent","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102177},"path":"@root","_fox_":1}],"mapGuest.widgets.promo.widgets.privacypolicy.widgets.privacypolicy.widgets.anchorNavigator.clickTarget":[{"value":".part-navigator","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102179},"path":"@root","_fox_":1}],"mapGuest.widgets.fcPromo.widget":[{"value":"Layout_Promo","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102181},"path":"@root","_fox_":1}],"mapGuest.widgets.fcPromo.template":[{"value":"Layout_Promo","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102182},"path":"@root","_fox_":1}],"mapGuest.widgets.fcPromo.widgets.fancentro.widget":[{"value":"Site_Page_Promo","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102185},"path":"@root","_fox_":1}],"mapGuest.widgets.fcPromo.widgets.fancentro.widgets.fancentro.widget":[{"value":"Widget","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102187},"path":"@root","_fox_":1}],"mapGuest.widgets.fcPromo.widgets.fancentro.widgets.fancentro.transparentHeader":[{"value":true,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102188},"path":"@root","_fox_":1}],"mapGuest.widgets.fcPromo.widgets.fancentro.widgets.fancentro.template":[{"value":"sitepage_fancentro","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102189},"path":"@root","_fox_":1}],"mapGuest.widgets.fcPromo.widgets.fancentro.widgets.fancentro.hooks.onAddedToDom":[{"value":function () {
$('.promo-header').addClass('fc-menu')
},"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102192},"path":"@root","_fox_":1}],"mapGuest.widgets.auth.widget":[{"value":"Layout_Promo_Auth","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102194},"path":"@root","_fox_":1}],"mapGuest.widgets.auth.widgets.login.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102197},"path":"@root","_fox_":1}],"mapGuest.widgets.auth.widgets.login.widgets.login.widget":[{"value":"Login_Forgot_Switcher","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102200},"path":"@root","_fox_":1}],"mapGuest.widgets.auth.widgets.passRecovery.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102202},"path":"@root","_fox_":1}],"mapGuest.widgets.auth.widgets.passRecovery.title":[{"value":"Password Recovery","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102203},"path":"@root","_fox_":1}],"mapGuest.widgets.auth.widgets.passRecovery.widgets.passRecovery.widget":[{"value":"Passrecovery","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102206},"path":"@root","_fox_":1}],"mapGuest.widgets.auth.widgets.passRecovery.widgets.passRecovery.template":[{"value":"passrecovery_form","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102207},"path":"@root","_fox_":1}],"mapGuest.widgets.auth.widgets.passRecovery.widgets.passRecovery.errorContainer":[{"value":".error-container","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102208},"path":"@root","_fox_":1}],"mapGuest.widgets.auth.widgets.unsubscribe.widget":[{"value":"Site_Page","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102210},"path":"@root","_fox_":1}],"mapGuest.widgets.auth.widgets.unsubscribe.title":[{"value":"Unsubscribe","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102211},"path":"@root","_fox_":1}],"mapGuest.widgets.auth.widgets.unsubscribe.widgets.unsubscribe.widget":[{"value":"Unsubscribe","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102214},"path":"@root","_fox_":1}],"mapGuest.widgets.windowScrollHandler.widget":[{"value":"WindowScrollHandler","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102216},"path":"@root","_fox_":1}],"mapGuest.widgets.windowScrollHandler.customEnabling":[{"value":true,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102217},"path":"@root","_fox_":1}],"mapGuest.widgets.windowScrollHandler.topOffset":[{"value":50,"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102218},"path":"@root","_fox_":1}],"mapGuest.widgets.windowScrollHandler.hooks.onStopInit":[{"value":function () {
this.setOption('bottomOffset', $(window).height())
},"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102222},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"handleWom.exoRun.event":[{"value":"running","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102004},"path":"@root","_fox_":1}],"handleWom.exoRun.widget":[{"value":"@root","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102005},"path":"@root","_fox_":1}],"handleWom.exoRun.callback":[{"value":function () {
__webpack_require__(170)(fox);
fox.exodentity.include();
},"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102010},"path":"@root","_fox_":1}],"requireResources":[{"value":function () {
return __webpack_require__(171)(fox);
},"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102013},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox) {
	var UID_LABEL = 'exo_uid';

	fox.registerService('exodentity', {
		_included: false,
		_fingerprint: null,

		include: function include() {
			var _this = this;

			if (this._included) return fox.Promise.resolve(false);

			return new fox.Promise(function (resolve) {
				__webpack_require__.e/* require.ensure */(3).then((function () {
					_this.addExodentityScript();

					return resolve(__webpack_require__(212));
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			});
		},
		getSavedUid: function getSavedUid() {
			return [function () {
				return localStorage.getItem(UID_LABEL);
			}, function () {
				var uid = fox.cookie.get(UID_LABEL);

				if (uid) return decodeURIComponent(unescape(uid));

				return false;
			}].reduce(function (fingerprint, next) {
				if (fingerprint) return fingerprint;

				return next();
			}, this._fingerprint);
		},
		addExodentityScript: function addExodentityScript() {
			var _this2 = this;

			var loadAsync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			window.__exoCallback = function (response) {
				_this2._fingerprint = response;

				fox.site.dispatchEvent('exodentity_fingerprint_recieved', {
					fingerprint: response
				});

				fox.cookie.set(UID_LABEL, window.escape(response));

				try {
					localStorage.setItem(UID_LABEL, response);
				} catch (e) {/* do nothing... */}
			};

			window._axq = {
				'js_callback': '__exoCallback'
			};

			this._included = true;
		}
	});
};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox) {
	'use strict';
	
	return new fox.RSVP.Promise(function (resolve) {
		switch (fox.getEnv('public.area.title')) {
			case 'STUDIO_CRUSH_GIRLS':
				__webpack_require__.e/* require.ensure */(2).then((function () {
					return resolve(__webpack_require__(213)(fox));
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			break;
			case 'MCPROFITS_AREA':
				__webpack_require__.e/* require.ensure */(0).then((function () {
					return resolve(__webpack_require__(214)(fox));
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			break;
			case 'webmastercentro':
				__webpack_require__.e/* require.ensure */(1).then((function () {
					return resolve(__webpack_require__(215)(fox));
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			break;
			default:
				resolve(true);
		}
	});
};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./common/notice.tpl": 173,
	"./common/popuptext.tpl": 174,
	"./docs/cookie-table.tpl": 175,
	"./docs/cookie_policy.tpl": 176,
	"./docs/privacyPolicy.tpl": 177,
	"./docs/terms.tpl": 178,
	"./home/registration.tpl": 179,
	"./layout/auth.tpl": 180,
	"./layout/footer.tpl": 181,
	"./layout/header.tpl": 182,
	"./layout/iframe.tpl": 183,
	"./layout/promo.tpl": 184,
	"./site.tpl": 185,
	"./sitepage/affiliate/affiliateProgram.tpl": 186,
	"./sitepage/contest/contest.tpl": 187,
	"./sitepage/faq/mcBlog_post_faq.tpl": 189,
	"./sitepage/faq/question.tpl": 190,
	"./sitepage/home/oursite.tpl": 191,
	"./sitepage/home/page.tpl": 192
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("new_notice", [["div",{"class":"gui-notice-item &&0&&","notice-alias":""},[["p",{"class":"message"},[["textNode",{"text":" "}],["span",{},[],[["message","__text",true,[{"name":"html","params":[]}]]]],["textNode",{"text":" "}]]]],[["type","class"],["alias","notice-alias",true]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("same_account", [["div",{},[["p",{},[["textNode",{"text":"Looks like you already have an affiliate account with this email on ModelCentro. You might have registered at affiliates.modelcentro.com or on one of the model's sites before."}]]],["p",{},[["textNode",{"text":"You can login directly to MCProfits with the same credentials."}]]],["p",{},[["textNode",{"text":"If you don't remember your account password, please contact our customer support."}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_cookietable", [["div",{"class":"layout-width page-width single-page aff-text-color-2"},[["h2",{"class":"sp-title padd-left"},[["span",{},[["textNode",{"text":"MCProfits.com"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Cookie Table"}]]],["div",{"class":"sp-up-time "},[["textNode",{"text":"Last Modified: July 9, 2018"}]]]]],["div",{"class":"sp-main-content-wrapp"},[["div",{"class":"col sp-left "},[["div",{"class":"sp-part-title  padd-left"},[["textNode",{"text":"Cookies Used on MCProfits.com"}]]],["div",{"class":"sp-part","id":"part-0"},[["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":"The following table lists all cookies potentially in use on the MCProfits.com website. We will update this table as our website changes and evolves, so please check back frequently to review any new cookie uses. Visit our "}],["a",{"href":"/cookie-policy"},[["textNode",{"text":" Cookie Policy"}]]],["textNode",{"text":" for more information and choices about our cookie use, including our contact information and complaint procedures. "}]]]]],["div",{"class":"wrapper-cookie-table"},[["table",{"class":"cookie-table"},[["thead",{},[["tr",{},[["th",{},[["textNode",{"text":"Cookie Category"}]]],["th",{},[["textNode",{"text":"Cookie Name and Owner"}]]],["th",{},[["textNode",{"text":"Purpose"}]]],["th",{},[["textNode",{"text":"Expiry"}]]],["th",{},[["textNode",{"text":"Type"}]]]]]]],["tbody",{},[["tr",{},[["td",{},[["textNode",{"text":"Necessary"}]]],["td",{},[["textNode",{"text":" manager_auth "}],["br"],["textNode",{"text":" mcprofits.com"}]]],["td",{},[["textNode",{"text":"Identifies the user and allows authentication to the server."}]]],["td",{},[["textNode",{"text":" 24 hours"}]]],["td",{},[["textNode",{"text":" HTTPS Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Functional"}]]],["td",{},[["textNode",{"text":" RNLBSERVERID "}],["br"],["textNode",{"text":" mcprofits.com"}]]],["td",{},[["textNode",{"text":"Used to make sure visitor page requests are routed to the same server."}]]],["td",{},[["textNode",{"text":" Session"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Functional"}]]],["td",{},[["textNode",{"text":" exo_uid "}],["br"],["textNode",{"text":" mcprofits.com"}]]],["td",{},[["textNode",{"text":"Security cookie used to prevent unauthorized access or disclosure of the user account. In all cases, these cookies do not store any information that makes you personally identifiable to us."}]]],["td",{},[["textNode",{"text":" Session"}]]],["td",{},[["textNode",{"text":" HTTPS Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Functional"}]]],["td",{},[["textNode",{"text":" __ax "}],["br"],["textNode",{"text":" mcprofits.com"}]]],["td",{},[["textNode",{"text":"Security cookie used to prevent unauthorized access or disclosure of the user account. In all cases, these cookies do not store any information that makes you personally identifiable to us."}]]],["td",{},[["textNode",{"text":" 1 Year"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Functional"}]]],["td",{},[["textNode",{"text":" io "}],["br"],["textNode",{"text":" mcprofits.com"}]]],["td",{},[["textNode",{"text":"Allows the provision of enhancing functionality and personalization, such as file uploading."}]]],["td",{},[["textNode",{"text":" Session"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Functional"}]]],["td",{},[["textNode",{"text":"wizardShownAtSession "}],["br"],["textNode",{"text":" mcprofits.com"}]]],["td",{},[["textNode",{"text":"show\\hide 2-step popup"}]]],["td",{},[["textNode",{"text":" Session"}]]],["td",{},[["textNode",{"text":" HTTPS Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Functional"}]]],["td",{},[["textNode",{"text":"referers "}],["br"],["textNode",{"text":" mcprofits.com"}]]],["td",{},[["textNode",{"text":"Used to store information, such as what time your current visit occurred, whether you have been to the website before, and what website referred you to the web page."}]]],["td",{},[["textNode",{"text":" 1 year"}]]],["td",{},[["textNode",{"text":" HTTPS Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Analytical / Third Party"}]]],["td",{},[["textNode",{"text":" _ga "}],["br"],["textNode",{"text":" Google Analytics"}]]],["td",{},[["textNode",{"text":" Registers a unique ID that is used to generate statistical data on how the visitor uses the website."}]]],["td",{},[["textNode",{"text":" 2 years"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Analytical / Third Party"}]]],["td",{},[["textNode",{"text":"_gid "}],["br"],["textNode",{"text":" Google Analytics"}]]],["td",{},[["textNode",{"text":"Registers a unique ID that is used to generate statistical data on how the visitor uses the website."}]]],["td",{},[["textNode",{"text":" 24 hours"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Analytical / Third Party"}]]],["td",{},[["textNode",{"text":" _gat_tracker0 "}],["br"],["textNode",{"text":" Google Analytics"}]]],["td",{},[["textNode",{"text":"Used by Google Analytics to throttle request rate."}]]],["td",{},[["textNode",{"text":" Session"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"Analytical / Third Party"}]]],["td",{},[["textNode",{"text":"intercom-session-sz14a447 "}],["br"],["textNode",{"text":" mcprofits.com"}]]],["td",{},[["textNode",{"text":"Intercom chat"}]]],["td",{},[["textNode",{"text":" 7 days"}]]],["td",{},[["textNode",{"text":" HTTP Cookie"}]]]]]]]]]]]]],["div",{"class":"sp-part","id":"part-0"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_cookiepolicy", [["div",{"class":"layout-width single-page"},[["h2",{"class":"sp-title"},[["span",{},[["textNode",{"text":"MCProfits.com"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Cookie Use Policy"}]]],["div",{"class":"sp-up-time"},[["textNode",{"text":"Last Modified: July 9, 2018"}]]]]],["div",{"class":"sp-main-content-wrapp"},[["div",{"class":"col sp-left"},[["div",{"class":"sp-part","id":"part-0"},[["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":" Cookies are small files of letters and numbers stored on your browser or device that enable the cookie owner to recognize the device when it visits websites or uses online services. The website you visit may set cookies directly, known as first-party cookies, or may trigger cookies set by other domain names, known as third-party cookies. While we may automatically use some cookies that are strictly necessary to provide the services you request or enable communications, we request your consent for all our other cookie uses. "}]]]]]]],["div",{"class":"sp-part","id":"part-1"},[["div",{"class":"sp-part-title"},[["textNode",{"text":"Types of Cookies We Use"}]]],["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":"We may use the following types of cookies:"}]]],["div",{"class":"marg-left"},[["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Strictly necessary cookies."}]]],["textNode",{"text":" Our website requires the use of these cookies to properly operate or provide necessary functions relating to the services you request. They include, for example, cookies enabling you to securely log into our website."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Analytical/performance cookies. "}]]],["textNode",{"text":" These cookies allow us and our third-party service providers to recognize and count the number of visitors and to see how visitors move around our website when they are using it. This helps us improve how our website works by, for example, ensuring that users can easily find what they need on our website. These cookies generate aggregate statistics that are not associated with an individualized profile."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Functionality cookies. "}]]],["textNode",{"text":" These cookies enable helpful but non-essential website functions that improve your website experience. By recognizing you when you return to our website, they may, for example, allow us to personalize our content for you, greet you by name, or remember your preferences (for example, your choice of language or region). These cookies may enable visitor identification over time, but not across different websites."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Advertising, tracking, or targeting cookies. "}]]],["textNode",{"text":" These cookies enable different advertising related functions. They may allow us to record information about your visit to our website, such as pages visited and links followed so we can make our website more relevant to your interests. These cookies may enable visitor identification over time, but not across different websites."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Third-party cookies. "}]]],["textNode",{"text":" Our website may contain helpful but non-essential features or plug-ins enabling third-party services that use cookies, such as web traffic analysis services. These cookies may enable visitor identification across websites and over time. We do not control the third party’s use of those cookies. Please review each party’s cookie disclosure before consenting to this use category."}]]]]]]]]],["p",{},[["textNode",{"text":" Our "}],["a",{"href":"/privacy-policy","target":"_blank"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":" describes our practices for any personal data that our first-party cookies collect, store, or use. "}]]],["p",{},[["textNode",{"text":" Except for strictly necessary cookies, all first-party cookies set by this site will expire no later than two years after your last website visit. Third-party cookie expiration periods are set by their respective owners. "}]]],["p",{},[["textNode",{"text":" Please see our "}],["a",{"href":"/cookie-table","target":"_blank"},[["textNode",{"text":" Cookie Table"}]]],["textNode",{"text":" for a list of the individual first-party and third-party cookies potentially used on this site and their specific purposes. "}]]]]]]],["div",{"class":"sp-part","id":"part-2"},[["div",{"class":"sp-part-title"},[["textNode",{"text":"Cross-Border Data Transfers"}]]],["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":" The cookies we use may process, store, or transfer personal data in and to a country outside your own, with privacy laws that provide different, possibly lower, protections. You consent to this transfer, storing, or processing when you consent to our cookie use. We are based in the British Virgin Islands, but our servers are located in the Netherlands. Please review the third-party cookie provider’s policy to learn more about its location. "}]]]]]]],["div",{"class":"sp-part","id":"part-3"},[["div",{"class":"sp-part-title"},[["textNode",{"text":"Your Cookie Choices"}]]],["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":"You consent to our use of cookies when you continue using our site."}]]],["p",{},[["textNode",{"text":" You may withdraw your consent for our cookie uses that are not strictly necessary at any time by engaging the consent manager tool "}],["a",{"href":"/cookie-table"},[["textNode",{"text":" Cookie Table"}]]],["textNode",{"text":". "}]]],["p",{},[["textNode",{"text":" Most web browsers allow you to directly block all cookies, or just third-party cookies, through your browser settings. Using your browser settings to block all cookies, including strictly necessary ones, may interfere with proper site operation. "}]]],["p"]]]]],["div",{"class":"sp-part","id":"part-4"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" Changes to Our Cookie Uses "}]]],["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":"We will post any changes to the way we use cookies on this page and indicate on our website that we updated this cookie notice. If the changes materially alter how we use cookies, we will post a notice on our website and request your consent for the materially different use. Please check back frequently to see any updates or changes to our cookie use notice."}]]]]]]],["div",{"class":"sp-part","id":"part-5"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" Contact Information"}]]],["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":" Please submit any questions, comments, or requests regarding this cookie use notice using the process described in our Privacy Policy, located at "}],["a",{"href":"https://mcprofits.com/privacy-policy"},[["textNode",{"text":" https://mcprofits.com/privacy-policy"}]]],["textNode",{"text":". "}]]]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_privacypolicy", [["div",{"class":"layout-width single-page"},[["h2",{"class":"sp-title padd-left"},[["span",{},[["textNode",{"text":"MCProfits.com"}]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Privacy Policy"}]]],["div",{"class":"sp-up-time"},[["textNode",{"text":"Last Updated: July 9, 2018"}]]]]],["div",{"class":"sp-main-content-wrapp"},[["div",{"class":"col sp-left"},[["div",{"class":"sp-part","id":"part_0"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" Introduction"}]]],["p",{},[["textNode",{"text":"Welcome to Centro Publisher Limited’s privacy policy."}]]],["p",{},[["textNode",{"text":"Centro Publisher respects your privacy and is committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website (regardless of where you visit it from) and tell you about your privacy rights and how the law protects you. "}]]],["p",{},[["textNode",{"text":"This privacy policy is provided in a layered format so you can click through to the specific areas set out below. Please also use the "}],["a",{"class":"part-navigator","data-target":"part_13"},[["textNode",{"text":" Glossary"}]]],["textNode",{"text":" to understand the meaning of some of the terms used in this privacy policy. "}]]],["ul",{},[["li",{},[["p",{"class":"part-navigator","data-target":"part_1"},[["textNode",{"text":" 1. Important Information and Who We Are"}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_2"},[["textNode",{"text":" 2. The Data We Collect About You"}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_3"},[["textNode",{"text":" 3. How Is Your Personal Data Collected"}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_4"},[["textNode",{"text":" 4. How We Use Your Personal Data"}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_5"},[["textNode",{"text":" 5. Disclosures of Your Personal Data"}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_6"},[["textNode",{"text":" 6. International Transfers"}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_7"},[["textNode",{"text":" 7. Data Security"}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_8"},[["textNode",{"text":" 8. Data Retention"}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_9"},[["textNode",{"text":" 9. Do Not Track Policy"}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_10"},[["textNode",{"text":" 10. Your California Privacy Rights"}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_11"},[["textNode",{"text":" 11. Your Canadian Privacy Rights"}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_12"},[["textNode",{"text":" 12. Your Legal Rights"}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_13"},[["textNode",{"text":" 13. Glossary"}]]]]]]]]]]],["div",{"class":"sp-part","id":"part_1"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 1. Important Information and Who We Are"}]]],["p",{},[["strong",{},[["textNode",{"text":"Purpose of this Privacy policy"}]]]]],["p",{},[["textNode",{"text":"This privacy policy aims to give you information on how Centro Publisher collects and processes your personal data through your use of this website, including any data you may provide through this website when you sign up as an affiliate. This website is not intended for children and we do not knowingly collect data relating to children. "}]]],["p",{},[["textNode",{"text":"It is important that you read this privacy policy together with any other privacy policy or fair processing policy we may provide on specific occasions when we are collecting or processing personal data about you so that you are fully aware of how and why we are using your data. This privacy policy supplements other notices and privacy policies and is not intended to override them. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Controller"}]]]]],["p",{},[["textNode",{"text":"Centro Publisher Limited is the controller and responsible for your personal data (collectively referred to as \"Centro Publisher”, “we,” “us,” or “our” in this privacy policy)."}]]],["p",{},[["textNode",{"text":"We have appointed a data privacy manager who is responsible for overseeing questions in relation to this privacy policy. If you have any questions about this privacy policy, including any requests to exercise "}],["a",{"class":"part-navigator","data-target":"part_12"},[["textNode",{"text":" your legal rights"}]]],["textNode",{"text":", please contact the data privacy manager using the details set out below. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Contact Details"}]]]]],["p",{},[["textNode",{"text":"If you have any questions about this privacy policy or our privacy practices, please contact our data privacy manager in the following ways: "}],["br"],["textNode",{"text":" Full name of legal entity: Centro Publisher Limited"}],["br"],["textNode",{"text":" Email address: "}],["a",{"data-name":"privacy","data-domain":"mcprofits","data-tld":"com","class":"crypmail","onclick":"window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld","draggable":"true"}],["br"],["textNode",{"text":" Postal address: P.O. Box 3444, Road Town, Tortola VG1110, British Virgin Islands."}]]],["p",{},[["textNode",{"text":"If you reside in the UK, you have the right to make a complaint at any time to the Information Commissioner’s Office (ICO), the UK supervisory authority for data protection issues ("}],["a",{"href":"https://ico.org.uk/","target":"_blank","rel":"nofollow"},[["textNode",{"text":"www.ico.org.uk"}]]],["textNode",{"text":"). "}]]],["p",{},[["textNode",{"text":"If you reside within the EEA, you have the right to make a complaint at any time to the appropriate supervisory authority for your country of residence. See "}],["a",{"href":"http://ec.europa.eu"},[["textNode",{"text":" http://ec.europa.eu"}]]],["textNode",{"text":" for these details. "}]]],["p",{},[["textNode",{"text":"If you reside outside the EEA, we will apply your legal rights as applicable to the data laws in the jurisdiction you are in."}]]],["p",{},[["textNode",{"text":"We would, however, appreciate the chance to deal with your concerns before you approach your supervisory authority so please contact us in the first instance. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Changes to the privacy policy and your duty to inform us of changes "}]]]]],["p",{},[["textNode",{"text":"We keep our privacy policy under regular review. This version was last updated on July 9, 2018. Historic versions can be obtained by contacting us. "}]]],["p",{},[["textNode",{"text":"It is important that the personal data we hold about you is accurate and current. Please keep us informed if your personal data changes during your relationship with us. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Third-Party Links"}]]]]],["p",{},[["textNode",{"text":"This website may include links to third-party websites, plug-ins, and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you. We do not control these third-party websites and are not responsible for their privacy statements. When you leave our website, we encourage you to read the privacy policy of every website you visit. "}]]]]]]],["div",{"class":"sp-part","id":"part_2"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 2. The Data We Collect About You "}]]],["p",{},[["textNode",{"text":"Personal data, or personal information, means any information about an individual from which that person can be identified. It does not include data where the identity has been removed (anonymous data). "}]]],["p",{},[["textNode",{"text":"We may collect, use, store, and transfer different kinds of personal data about you which we have grouped together as follows:"}]]],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Identity Data"}]]],["textNode",{"text":" includes first name, last name, and username or similar identifier. "}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Contact Data"}]]],["textNode",{"text":" includes Twitter/Skype/ICQ username, mailing address, email address, and telephone number."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Financial Data"}]]],["textNode",{"text":" includes bank account and payment information details."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Transaction Data"}]]],["textNode",{"text":" includes details about payments to you and revenue statistics."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Technical Data"}]]],["textNode",{"text":" includes internet protocol (IP) address, cookie ID, affiliate ID, your login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform, and other technology on the devices you use to access this website."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Profile Data"}]]],["textNode",{"text":" includes your username and password, your interests, preferences, feedback, and survey responses. "}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Usage Data"}]]],["textNode",{"text":" includes information about how you use our website, products, and services, including the full Uniform Resource Locators (URLs); clickstream to, through, and from our website (including date and time); information you viewed or searched for; page response times; download errors; length of visits to certain pages; page interaction information (such as scrolling, clicks, and mouse-overs); and methods used to browse away from the page."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Marketing and Communications Data"}]]],["textNode",{"text":" includes your preferences in receiving marketing from us and our third parties and your communication preferences."}]]]]]]],["p",{},[["textNode",{"text":"We also collect, use, and share "}],["strong",{},[["textNode",{"text":"Aggregated Data"}]]],["textNode",{"text":" such as statistical or demographic data for any purpose. Aggregated Data could be derived from your personal data but is not considered personal data in law as this data will not directly or indirectly reveal your identity. For example, we may aggregate your Usage Data to calculate the percentage of users accessing a specific website feature. However, if we combine or connect Aggregated Data with your personal data so that it can directly or indirectly identify you, we treat the combined data as personal data which will be used in accordance with this privacy policy. "}]]],["p",{},[["textNode",{"text":"We do not collect any "}],["strong",{},[["textNode",{"text":"Special Categories of Personal Data"}]]],["textNode",{"text":" about you (this includes details about your race or ethnicity, religious or philosophical beliefs, sex life, sexual orientation, political opinions, trade union membership, information about your health, and genetic and biometric data). Nor do we collect any information about criminal convictions and offenses."}]]],["p",{},[["strong",{},[["textNode",{"text":"If You Fail to Provide Personal Data"}]]]]],["p",{},[["textNode",{"text":"Where we need to collect personal data by law, or under the terms of a contract we have with you and you fail to provide that data when requested, we may not be able to perform the contract we have or are trying to enter into with you (for example, to provide you with goods or services). In this case, we may have to cancel a service you have with us, but we will notify you if this is the case at the time."}]]]]]]],["div",{"class":"sp-part","id":"part_3"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":"3. How Is Your Personal Data Collected? "}]]],["p",{},[["textNode",{"text":"We use different methods to collect data from and about you, including through:"}]]],["ul",{"class":"dotted-list"},[["li",{},[["strong",{},[["textNode",{"text":"Direct interactions"}]]],["textNode",{"text":". You may give us your Identity, Contact, and Financial Data by filling in forms or by corresponding with us by email, or otherwise. This includes personal data you provide when you: "}],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["textNode",{"text":"create an affiliate account on our website; "}]]]]],["li",{},[["p",{},[["textNode",{"text":"request marketing to be sent to you; "}]]]]],["li",{},[["p",{},[["textNode",{"text":"request information about our products or services; or "}]]]]],["li",{},[["p",{},[["textNode",{"text":"give us feedback or contact us. "}]]]]]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Automated technologies or interactions."}]]],["textNode",{"text":" As you interact with our website, we will automatically collect Technical and Usage Data about your equipment, browsing actions, and patterns. We collect this personal data by using cookies, server logs, and other similar technologies. We may also receive Technical and Usage Data about you if you visit other websites employing our cookies. Please see our "}],["a",{"href":"https://mcprofits.com/cookie-policy","target":"_blank"},[["textNode",{"text":"cookie policy"}]]],["textNode",{"text":" for further details. "}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Third parties or publicly available sources."}]]],["textNode",{"text":" We will receive personal data about you from various third parties as set out below: "}],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["textNode",{"text":"Technical Data from the following parties:"}]]],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["textNode",{"text":"analytics providers such as Google based outside the EU; and"}]]]]],["li",{},[["p",{},[["textNode",{"text":"search information providers such as Google based outside the EU. "}]]]]]]]]],["li",{},[["p",{},[["textNode",{"text":"Contact, Financial, and Transaction Data from providers of technical, payment, and delivery services such as CentroBill and Paxum based outside the EU."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Identity and Contact Data from publicly available sources on the Internet."}]]]]]]]]]]]]]]]]],["div",{"class":"sp-part","id":"part_4"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 4. How We Use Your Personal Data "}]]],["p",{},[["textNode",{"text":"We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:"}]]],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["textNode",{"text":"Where we need to perform the contract we are about to enter into or have entered into with you."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Where we need to comply with a legal obligation."}]]]]]]],["p"],["p",{},[["a",{"class":"part-navigator","data-target":"part_13"},[["textNode",{"text":" Click here"}]]],["textNode",{"text":" to find out more about the types of lawful basis that we will rely on to process your personal data. "}]]],["p",{},[["textNode",{"text":"Generally, we do not rely on consent as a legal basis for processing your personal data although we will get your consent before sending third-party direct marketing communications to you via email. You have the right to withdraw consent to marketing at any time by contacting us. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Purposes for Which We Will Use Your Personal Data"}]]]]],["p",{},[["textNode",{"text":"We have set out below, in a table format, a description of all the ways we plan to use your personal data, and which of the legal bases we rely on to do so. We have also identified what our legitimate interests are where appropriate. "}]]],["p",{},[["textNode",{"text":"Note that we may process your personal data for more than one lawful ground depending on the specific purpose for which we are using your data. Please contact us if you need details about the specific legal ground we are relying on to process your personal data where more than one ground has been set out in the table below. "}]]],["div",{"class":"wrapper-cookie-table"},[["table",{"border":"1","cellpadding":"7","cellspacing":"0","class":"cookie-table"},[["tr",{},[["th",{},[["textNode",{"text":"Purpose/Activity"}]]],["th",{},[["textNode",{"text":"Type of data"}]]],["th",{},[["textNode",{"text":"Lawful basis for processing including basis of legitimate interest"}]]]]],["tr",{},[["td",{},[["textNode",{"text":"To register you as a new affiliate and process your application"}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["textNode",{"text":" (b) Contact "}],["br"],["textNode",{"text":" (c) Financial "}],["br"]]],["td",{},[["textNode",{"text":"(a) Performance of a contract with you"}],["br"],["textNode",{"text":" (b) Necessary to comply with a legal obligation"}],["br"]]]]],["tr",{},[["td",{},[["textNode",{"text":" To manage our relationship with you which will include: "}],["br"],["textNode",{"text":" (a) Notifying you about changes to our terms or privacy policy"}],["br"],["textNode",{"text":" (b) Calculating and paying you your revenue share "}]]],["td",{},[["textNode",{"text":" (a) Identity"}],["br"],["textNode",{"text":" (b) Contact"}],["br"],["textNode",{"text":" (c) Financial"}],["br"],["textNode",{"text":" (d) Profile "}]]],["td",{},[["textNode",{"text":" (a) Performance of a contract with you"}],["br"],["textNode",{"text":" (b) Necessary to comply with a legal obligation"}],["br"],["textNode",{"text":" (c) Necessary for our legitimate interests (to keep our records updated)"}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To administer and protect our business and this website (including troubleshooting, data analysis, testing, system maintenance, support, reporting, and hosting of data) "}]]],["td",{},[["textNode",{"text":" (a) Identity (b) Contact (c) Technical "}]]],["td",{},[["textNode",{"text":" (a) Necessary for our legitimate interests (for running our business, provision of administration and IT services, network security, to prevent fraud, and in the context of a business reorganization or group restructuring exercise) "}],["br"],["textNode",{"text":" (b) Necessary to comply with a legal obligation "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To use data analytics to improve our website, products/services, marketing, customer relationships, and experiences "}]]],["td",{},[["textNode",{"text":" (a) Technical (b) Usage "}]]],["td",{},[["textNode",{"text":"Necessary for our legitimate interests (to define types of customers for our products and services, to keep our website updated and relevant, to develop our business, and to inform our marketing strategy) "}]]]]],["tr",{},[["td",{},[["textNode",{"text":" To make suggestions and recommendations to you about goods or services that may be of interest to you "}]]],["td",{},[["textNode",{"text":" (a) Identity "}],["br"],["textNode",{"text":" (b) Contact "}],["br"],["textNode",{"text":" (c) Technical "}],["br"],["textNode",{"text":" (d) Usage "}],["br"],["textNode",{"text":" (e) Profile "}],["br"],["textNode",{"text":" (f) Marketing and Communications "}]]],["td",{},[["textNode",{"text":" Necessary for our legitimate interests (to develop our products/services and grow our business)"}]]]]]]]]],["p",{},[["strong",{},[["textNode",{"text":"Marketing"}]]]]],["p",{},[["textNode",{"text":"We strive to provide you with choices regarding certain personal data uses, particularly around marketing and advertising. We have established the following personal data control mechanisms: "}]]],["p",{},[["strong",{},[["textNode",{"text":"Promotional offers from us"}]]]]],["p",{},[["textNode",{"text":"We may use your Identity, Contact, Technical, Usage, and Profile Data to form a view on what we think you may want or need, or what may be of interest to you. This is how we decide which products, services, and offers may be relevant for you (we call this marketing). "}]]],["p",{},[["textNode",{"text":"You will receive marketing communications from us if you have requested information from us or signed up for an affiliate account and, in each case, you have not opted out of receiving that marketing. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Third-party marketing"}]]]]],["p",{},[["textNode",{"text":"We will get your express opt-in consent before we share your personal data with any third party for marketing purposes. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Opting out"}]]]]],["p",{},[["textNode",{"text":"You can ask us or third parties to stop sending you marketing messages at any time by logging into the website and checking or unchecking relevant boxes to adjust your marketing preferences, by following the opt-out links on any marketing messages sent to you, or by contacting us at any time. "}]]],["p",{},[["textNode",{"text":"Where you opt out of receiving these marketing messages, this will not apply to personal data provided to us as a result of other transactions. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Cookies"}]]]]],["p",{},[["textNode",{"text":"You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access cookies. If you disable or refuse cookies, please note that some parts of this website may become inaccessible or not function properly. For more information about the cookies we use, please see our cookie policy. "}]]],["p",{},[["strong",{},[["textNode",{"text":"Change of purpose"}]]]]],["p",{},[["textNode",{"text":"We will only use your personal data for the purposes for which we collected it, unless we reasonably consider that we need to use it for another reason and that reason is compatible with the original purpose. If you wish to get an explanation as to how the processing for the new purpose is compatible with the original purpose, please contact us. "}]]],["p",{},[["textNode",{"text":"If we need to use your personal data for an unrelated purpose, we will notify you and we will explain the legal basis which allows us to do so. "}]]],["p",{},[["textNode",{"text":"Please note that we may process your personal data without your knowledge or consent, in compliance with the above rules, where this is required or permitted by law. "}]]]]]]],["div",{"class":"sp-part","id":"part_5"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 5. Disclosures of Your Personal Data "}]]],["p",{},[["textNode",{"text":"We may share your personal data with the parties set out below for the purposes stated in the table (Purposes for which we will use your personal data) above. "}]]],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["textNode",{"text":"External Third Parties as set out in the "}],["a",{"class":"part-navigator","data-target":"part_13"},[["textNode",{"text":" Glossary"}]]],["textNode",{"text":"."}]]]]],["li",{},[["p",{},[["textNode",{"text":"Third parties to whom we may choose to sell, transfer, or merge parts of our business or our assets. Alternatively, we may seek to acquire other businesses or merge with them. If a change happens to our business, then the new owners may use your personal data in the same way as set out in this privacy policy. "}]]]]]]],["p",{},[["textNode",{"text":"We require all third parties to respect the security of your personal data and to treat it in accordance with the law. We do not allow our third-party service providers to use your personal data for their own purposes and only permit them to process your personal data for specified purposes and in accordance with our instructions. "}]]]]]]],["div",{"class":"sp-part","id":"part_6"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 6. International Transfers "}]]],["p",{},[["textNode",{"text":"We are based in the British Virgin Islands, but our servers are located in the Netherlands. "}]]],["p",{},[["textNode",{"text":"Many of our external third parties are outside the European Economic Area (EEA) so their processing of your personal data will involve a transfer of data outside the EEA. "}]]],["p",{},[["textNode",{"text":"Whenever we transfer your personal data out of the EEA, we ensure a similar degree of protection is afforded to it by ensuring at least one of the following safeguards is implemented: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":"We will only transfer your personal data to countries that have been deemed to provide an adequate level of protection for personal data by the European Commission. For further details, see European Commission: Adequacy of the protection of personal data in non-EU countries. "}]]],["li",{},[["textNode",{"text":"Where we use certain service providers, we may use specific contracts approved by the European Commission which give personal data the same protection it has in Europe. For further details, see European Commission: Model contracts for the transfer of personal data to third countries. "}]]],["li",{},[["textNode",{"text":"Where we use providers based in the US, we may transfer data to them if they are part of the Privacy Shield which requires them to provide similar protection to personal data shared between Europe and the US. For further details, see European Commission: EU–US Privacy Shield. "}]]]]],["p",{},[["textNode",{"text":"Please contact us if you want further information on the specific mechanism used by us when transferring your personal data out of the EEA. "}]]]]]]],["div",{"class":"sp-part","id":"part_7"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 7. Data Security "}]]],["p",{},[["textNode",{"text":"We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors, and other third parties who have a business need to know. They will only process your personal data on our instructions and they are subject to a duty of confidentiality. "}]]],["p",{},[["textNode",{"text":"We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so. "}]]]]]]],["div",{"class":"sp-part","id":"part_8"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 8. Data Retention "}]]],["p",{},[["strong",{},[["textNode",{"text":"How long will you use my personal data for? "}]]]]],["p",{},[["textNode",{"text":"We will only retain your personal data for as long as reasonably necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, regulatory, tax, accounting, or reporting requirements. We may retain your personal data for a longer period in the event of a complaint or if we reasonably believe there is a prospect of litigation in respect to our relationship with you. "}]]],["p",{},[["textNode",{"text":"To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the personal data, the potential risk of harm from unauthorized use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal, regulatory, tax, accounting, or other requirements. "}]]],["p",{},[["textNode",{"text":"By law we have to keep basic information about our customers (including Contact, Identity, Financial, and Transaction Data) for seven years after they cease being customers for tax purposes. "}]]],["p",{},[["textNode",{"text":"In some circumstances you can ask us to delete your data: see "}],["a",{"class":"part-navigator","data-target":"part_12"},[["textNode",{"text":" your legal rights"}]]],["textNode",{"text":" below for further information. In some circumstances we will anonymize your personal data (so that it can no longer be associated with you) for research or statistical purposes in which case we may use this information indefinitely without further notice to you. "}]]]]]]],["div",{"class":"sp-part","id":"part_9"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 9. Do Not Track Policy"}]]],["p",{},[["textNode",{"text":"Do Not Track (“DNT”) is a privacy preference that you can set in your browser. DNT is a way for you to inform websites and services that you do not want certain information about your webpage visits collected over time and across websites or online services. We are committed to providing you with meaningful choices about the information we collect and that is why we provide you the ability to opt out. But we do not recognize or respond to any DNT signals as the Internet industry works toward defining exactly what DNT means, what it means to comply with DNT, and a common approach to responding to DNT. For more information, visit "}],["a",{"href":"http://www.allaboutdnt.com","target":"_blank","rel":"nofollow"},[["textNode",{"text":"www.allaboutdnt.com"}]]],["textNode",{"text":"."}]]]]]]],["div",{"class":"sp-part","id":"part_10"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 10. Your California Privacy Rights "}]]],["p",{},[["textNode",{"text":"If you are a California resident, you are granted specific rights regarding access to your personal data. California Civil Code Section 1798.83, also known as the “Shine The Light” law, permits our users who are California residents to request and obtain from us, once a year and free of charge, information about categories of personal information (if any) we disclosed to third parties for direct marketing purposes and the name and addresses of all third parties with which we shared personal data in the immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your request in writing to us using the contact information provided above. "}]]]]]]],["div",{"class":"sp-part","id":"part_11"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 11. Your Canadian privacy rights "}]]],["p",{},[["textNode",{"text":"We comply with Canadian Federal and Provincial privacy laws and regulations, including the Personal Information Protection and Electronic Documents Act. "}]]],["p",{},[["textNode",{"text":"We will only use your personal information for the purposes intended and as detailed in this policy unless we have obtained your consent to use it for other purposes. "}]]],["p",{},[["textNode",{"text":"Residents of Canada are notified that the personal data they provide to Centro Publisher is stored in its databases outside of Canada, including in the Netherlands, and may be subject to disclosure to authorized law enforcement or government agencies in response to lawful demand under the laws of that country. "}]]],["p",{},[["textNode",{"text":"You may withdraw your consent to our personal data collection, use, or disclosure, subject to legal and contractual restrictions. "}]]],["p",{},[["textNode",{"text":"You have the right to complain about our personal data handling practices. "}]]],["p",{},[["textNode",{"text":"If you need to contact us about your personal data or believe that we have violated your privacy rights, please contact us at "}],["a",{"data-name":"privacy","data-domain":"mcprofits","data-tld":"com","class":"crypmail","onclick":"window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld","draggable":"true"}],["textNode",{"text":". You may visit "}],["a",{"href":"https://www.priv.gc.ca"},[["textNode",{"text":"www.priv.gc.ca"}]]],["textNode",{"text":" for more information about your privacy rights. "}]]]]]]],["div",{"class":"sp-part","id":"part_12"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 12. Your Legal Rights "}]]],["p",{},[["textNode",{"text":"Under certain circumstances, you have rights under data protection laws in relation to your personal data. "}]]],["ul",{"class":"dotted-list"},[["p",{},[["textNode",{"text":"Please click on the links below to find out more about these rights:"}]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_15"},[["textNode",{"text":"Request access to your personal data."}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_16"},[["textNode",{"text":"Request correction of your personal data."}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_17"},[["textNode",{"text":"Requesterasure of your personal data."}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_18"},[["textNode",{"text":"Object to processing of your personal data."}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_19"},[["textNode",{"text":"Request restriction of processing your personal data."}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_20"},[["textNode",{"text":"Request transfer of your personal data."}]]]]],["li",{},[["p",{"class":"part-navigator","data-target":"part_21"},[["textNode",{"text":"Right to withdraw consent."}]]]]]]],["p",{},[["textNode",{"text":"If you wish to exercise any of the rights set out above, please contact us."}]]],["p",{},[["strong",{},[["textNode",{"text":"No fee usually required"}]]]]],["p",{},[["textNode",{"text":"You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive, or excessive. Alternatively, we could refuse to comply with your request in these circumstances. "}]]],["p",{},[["strong",{},[["textNode",{"text":"What We May Need from You"}]]]]],["p",{},[["textNode",{"text":"We may need to request specific information from you to help us confirm your identity and ensure your right to access your personal data (or to exercise any of your other rights). This is a security measure to ensure that personal data is not disclosed to any person who has no right to receive it. We may also contact you to ask you for further information in relation to your request to speed up our response."}]]],["p",{},[["strong",{},[["textNode",{"text":"Time Limit to Respond"}]]]]],["p",{},[["textNode",{"text":"We try to respond to all legitimate requests within one month. Occasionally it could take us longer than a month if your request is particularly complex or you have made a number of requests. In this case, we will notify you and keep you updated. "}]]]]]]],["div",{"class":"sp-part","id":"part_13"},[["div",{"class":"padd-left"},[["div",{"class":"sp-part-title"},[["textNode",{"text":" 13. Glossary "}]]],["p",{},[["strong",{},[["textNode",{"text":"Lawful Basis"}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Legitimate Interest"}]]],["textNode",{"text":" means the interest of our business in conducting and managing our business to enable us to give you the best service/product and the best and most secure experience. We make sure we consider and balance any potential impact on you (both positive and negative) and your rights before we process your personal data for our legitimate interests. We do not use your personal data for activities where our interests are overridden by the impact on you (unless we have your consent or are otherwise required or permitted to by law). You can obtain further information about how we assess our legitimate interests against any potential impact on you in respect of specific activities by contacting us."}]]],["p",{},[["strong",{},[["textNode",{"text":"Performance of Contract"}]]],["textNode",{"text":" means processing your data where it is necessary for the performance of a contract to which you are a party or to take steps at your request before entering into such a contract."}]]],["p",{},[["strong",{},[["textNode",{"text":"Comply with a legal obligation"}]]],["textNode",{"text":" means processing your personal data where it is necessary for compliance with a legal obligation that we are subject to."}]]],["p",{},[["strong",{},[["textNode",{"text":"Third Parties"}]]]]],["p",{},[["strong",{},[["textNode",{"text":"External Third Parties"}]]]]],["ul",{"class":"dotted-list"},[["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Compliance with Laws "}]]],["textNode",{"text":" We may disclose your information where we are legally required to do so to comply with applicable law, governmental requests, a judicial proceeding, court order, or legal process, such as in response to a court order or a subpoena (including in response to public authorities to meet national security or law enforcement requirements)."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Vital Interests and Legal Rights. "}]]],["textNode",{"text":" We may disclose your information where we believe it is necessary to investigate, prevent, or take action regarding potential violations of our policies, suspected fraud, situations involving potential threats to the safety of any person and illegal activities, or as evidence in litigation in which we are involved."}]]]]],["li",{},[["p",{},[["strong",{},[["textNode",{"text":"Vendors, Consultants, and Other Third-Party Service Providers. "}]]],["textNode",{"text":" We may share your data with third-party vendors, service providers, contractors, or agents who perform services for us or on our behalf and require access to that information to do that work. Examples include: payment processing, data analysis, email delivery, hosting services, customer service, and marketing efforts. We may allow selected third parties to use tracking technology on the Website, which will enable them to collect data about how you interact with the Website over time. This information may be used to, among other things, analyze and track data, determine the popularity of certain content and better understand online activity. For example, we use Google Analytics to help us understand how our customers use the website (you can read more about how Google uses your personal data here: "}],["a",{"href":"https://www.google.com/intl/en/policies/privacy/","target":"_blank","rel":"nofollow"},[["textNode",{"text":"https://www.google.com/intl/en/policies/privacy/"}]]],["textNode",{"text":"). You can also optout of Google Analytics here: "}],["a",{"href":"https://tools.google.com/dlpage/gaoptout","target":"_blank","rel":"nofollow"},[["textNode",{"text":"https://tools.google.com/dlpage/gaoptout"}]]],["textNode",{"text":"."}]]]]],["li",{},[["strong",{},[["textNode",{"text":"Affiliates"}]]],["textNode",{"text":" We may share your information with our affiliates, in which case we will require those affiliates to honor this privacy policy. "}]]]]],["p",{},[["strong",{},[["textNode",{"text":"Your Legal Rights"}]]]]],["p",{},[["textNode",{"text":"You have the right to: "}]]],["p",{},[["strong",{"id":"part_15"},[["textNode",{"text":"Request access"}]]],["textNode",{"text":" to your personal data (commonly known as a “data subject access request”). This enables you to receive a copy of the personal data we hold about you and to check that we are lawfully processing it. "}]]],["p",{},[["strong",{"id":"part_16"},[["textNode",{"text":"Request correction"}]]],["textNode",{"text":" of the personal data that we hold about you. This enables you to have any incomplete or inaccurate data we hold about you corrected, though we may need to verify the accuracy of the new data you provide to us. "}]]],["p",{},[["strong",{"id":"part_17"},[["textNode",{"text":"Request erasure"}]]],["textNode",{"text":" of your personal data. This enables you to ask us to delete or remove personal data where there is no good reason for us continuing to process it. You also have the right to ask us to delete or remove your personal data where you have successfully exercised your right to object to processing (see below), where we may have processed your information unlawfully, or where we are required to erase your personal data to comply with local law. Note, however, that we may not always be able to comply with your request of erasure for specific legal reasons which will be notified to you, if applicable, at the time of your request. "}]]],["p",{},[["strong",{"id":"part_18"},[["textNode",{"text":"Object to processing"}]]],["textNode",{"text":" of your personal data where we are relying on a legitimate interest (or those of a third party) and there is something about your particular situation which makes you want to object to processing on this ground as you feel it impacts on your fundamental rights and freedoms. You also have the right to object where we are processing your personal data for direct marketing purposes. In some cases, we may demonstrate that we have compelling legitimate grounds to process your information which override your rights and freedoms. "}]]],["p",{},[["strong",{"id":"part_19"},[["textNode",{"text":"Request restriction of processing"}]]],["textNode",{"text":" of your personal data. This enables you to ask us to suspend the processing of your personal data in the following scenarios: "}]]],["ul",{"class":"dotted-list"},[["li",{},[["textNode",{"text":"If you want us to establish the data’s accuracy. "}]]],["li",{},[["textNode",{"text":"Where our use of the data is unlawful but you do not want us to erase it. "}]]],["li",{},[["textNode",{"text":"Where you need us to hold the data even if we no longer require it as you need it to establish, exercise, or defend legal claims. "}]]],["li",{},[["textNode",{"text":"You have objected to our use of your data but we need to verify whether we have overriding legitimate grounds to use it. "}]]]]],["p",{},[["strong",{"id":"part_20"},[["textNode",{"text":"Request the transfer"}]]],["textNode",{"text":" of your personal data to you or to a third party. We will provide to you, or a third party you have chosen, your personal data in a structured, commonly used, machine-readable format. Note that this right only applies to automated information which you initially provided consent for us to use or where we used the information to perform a contract with you. "}]]],["p",{},[["strong",{"id":"part_21"},[["textNode",{"text":"Withdraw consent at any time"}]]],["textNode",{"text":" where we are relying on consent to process your personal data. However, this will not affect the lawfulness of any processing carried out before you withdraw your consent. If you withdraw your consent, we may not be able to provide certain products or services to you. We will advise you if this is the case at the time you withdraw your consent."}]]]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("s_affiliate_program_agreement", [["div",{"class":"layout-width page-width single-page aff-text-color-2"},[["h2",{"class":"sp-title padd-left"},[["span",{},[["textNode",{"text":"ModelCentro"}],["sup",{},[["textNode",{"text":"TM"}]]]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Affiliate Agreement"}]]],["div",{"class":"sp-up-time"},[["textNode",{"text":"Created: January 1, 2014"}]]],["div",{"class":"sp-up-time"},[["textNode",{"text":"Last Updated: May 17, 2016"}]]]]],["div",{"class":"sp-main-content-wrapp"},[["div",{"class":"col sp-left"},[["div",{"class":"sp-part","id":"start"},[["p",{"class":"padd-left"},[["textNode",{"text":" This affiliate agreement is between "}],["strong",{},[["textNode",{"text":"CENTRO PUBLISHER LIMITED"}]]],["textNode",{"text":", a British Virgin Islands corporation (the "}],["strong",{},[["textNode",{"text":"\"Company\""}]]],["textNode",{"text":"), and you, the individual or entity signing up to become an affiliate (the "}],["strong",{},[["textNode",{"text":"\"Affiliate\""}]]],["textNode",{"text":"). The Company has developed the ModelCentro™ affiliate program located at "}],["a",{"class":"aff-text-color-1","href":"http://mcprofits.com"},[["textNode",{"text":"mcprofits.com"}]]],["textNode",{"text":" (the "}],["strong",{},[["textNode",{"text":"\"Program\""}]]],["textNode",{"text":") that allows participating affiliates to earn commissions in connection with their referral of end-user consumers ("}],["strong",{},[["textNode",{"text":"\"consumers\""}]]],["textNode",{"text":") interested in purchasing products, services, VIP access, memberships, and other material (collectively, the "}],["strong",{},[["textNode",{"text":"\"model offerings\""}]]],["textNode",{"text":") for a fee from one or more models (the "}],["strong",{},[["textNode",{"text":"\"Models\""}]]],["textNode",{"text":") that operate websites using ModelCentro’s proprietary platform and were made available to the Affiliate through the Program (the "}],["strong",{},[["textNode",{"text":"\"Model Sites\""}]]],["textNode",{"text":"). The Affiliate wants to participate in the Program. The parties therefore agree as follows: "}]]]]],["div",{"class":"sp-part","id":"part-1"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"1."}]]],["textNode",{"text":" Enrollment in the Program "}]]],["div",{"class":"marg-left"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"1.1"}]]],["textNode",{"text":"Eligibility "}]]],["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":" The Affiliate must be at least 18-years old or the age of majority in the Affiliate’s place of residence, whichever is greater, to enroll in the Program. If the Affiliate is an entity, all individuals involved in the entity must be at least 18-years old or the age of majority in their place of residence, whichever is greater. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"1.2"}]]],["textNode",{"text":"Application "}]]],["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":" To begin the enrollment process, the Affiliate must fill out and submit the registration form located at "}],["a",{"class":"aff-text-color-1","href":"http://mcprofits.com"},[["textNode",{"text":"mcprofits.com"}]]],["textNode",{"text":". "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"1.3"}]]],["textNode",{"text":"Evaluation of Application "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" The Company will evaluate the Affiliate’s application. The Company may reject the Affiliate’s application for any reason, including if the Company determines that: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" The Affiliate or its owners are under 18-years old or the age of majority of their place of residence; "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" The application contains inaccurate information; "}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":" The Affiliate’s marketing methods are unsuitable for the Program, including engaging in any of the conduct listed in section 1.3(c); "}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":" One or more affiliate sites incorporate material that is unlawful, defamatory, libelous, infringing, obscene, harassing, or otherwise objectionable; "}]]],["span",{"class":"num"},[["textNode",{"text":"(v)"}]]],["p",{},[["textNode",{"text":" One or more of the Affiliate’s domain names or affiliate sites are identical or confusingly similar to a trademark or service mark in which the Company, one or more Models, or another person has intellectual property or other legal rights; "}]]],["span",{"class":"num"},[["textNode",{"text":"(vi)"}]]],["p",{},[["textNode",{"text":" One or more affiliate sites promotes or facilitates illegal activity, or violates the rights of others, including copyright, trademark, or other intellectual property rights; "}]]],["span",{"class":"num"},[["textNode",{"text":"(vii)"}]]],["p",{},[["textNode",{"text":" One or more affiliate sites encourage password theft or hacking; or "}]]],["span",{"class":"num"},[["textNode",{"text":"(viii)"}]]],["p",{},[["textNode",{"text":" The Affiliate or one or more affiliate sites are not otherwise suitable for the Program for any reason. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" If the Company approves the Affiliate’s application, but later determines that the Affiliate did not comply with section 1.3(a), the Company will terminate the Affiliate’s account. "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" The Company may decline the Affiliate’s application or cancel the Affiliate’s account if the Company determines that the Affiliate or one or more affiliate sites engages in advertising or marketing methods that does any of the following: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" Promotes sexually explicit materials without complying with governing law; "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" Promotes child pornography; "}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":" Promotes violence; "}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":" Promotes discrimination based on race, sex, religion, nationality, disability, sexual orientation, or age; "}]]],["span",{"class":"num"},[["textNode",{"text":"(v)"}]]],["p",{},[["textNode",{"text":" Incorporates any materials that infringe or assist others to infringe any copyright, trademark, or other intellectual property rights or to violate any law; "}]]],["span",{"class":"num"},[["textNode",{"text":"(vi)"}]]],["p",{},[["textNode",{"text":" Is in any way unlawful, harmful, threatening, defamatory, libelous, obscene, harassing, or racially, ethnically, or otherwise objectionable to the Company in its sole discretion; "}]]],["span",{"class":"num"},[["textNode",{"text":"(vii)"}]]],["p",{},[["textNode",{"text":" Contains software downloads that potentially enable diversions of commissions from other affiliates in the Program; or "}]]],["span",{"class":"num"},[["textNode",{"text":"(viii)"}]]],["p",{},[["textNode",{"text":" Leads consumers to mistake the Affiliate for the Company or any other affiliated model or business or otherwise impersonates or tries to impersonate the Company, its employees, the Models, another affiliate, or any other person. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":" The Company is not required to notify any prospective affiliate of its rejection from the Program. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"1.4"}]]],["textNode",{"text":"Reapplication "}]]],["p",{},[["textNode",{"text":" If the Company rejects the Affiliate’s application for any reason, the Affiliate will not reapply to the Program using the same domain name, URL, email address, company name, or personal name; nor will the Affiliate reapply using a different domain name, URL, email address, company name, or personal name. "}]]]]]]],["div",{"class":"sp-part","id":"part-2"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"2."}]]],["textNode",{"text":"License "}]]],["div",{"class":"marg-left"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"2.1"}]]],["textNode",{"text":"Grant "}]]],["p",{},[["textNode",{"text":" Subject to the Company’s approval of the Affiliate in accordance with section 1 and solely for the limited purposes of advertising services on, and directing consumers to, the Model Sites in connection with the Program, the Company hereby grants the Affiliate a nonexclusive, nontransferable, nonsublicensable license to: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" use, copy, and publicly display the licensed material solely on one or more affiliate sites and solely for the purposes stated in this agreement; "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" market, advertise, and promote the Models’ online services and content on one or more affiliate site; and "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" use the Company’s or the Models’ service marks, trademarks, and logos that the Company makes available to the Affiliate as part of the licensed material. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"2.2"}]]],["textNode",{"text":" Limitations "}]]],["p",{},[["textNode",{"text":" The Affiliate will only use the licensed material in accordance with this agreement and not for any other purpose. The Affiliate will only download a single copy of the licensed material and upload a single copy to the affiliate site. The Affiliate will not make any further copies of the licensed material. The following limitations also apply to the Affiliate’s use of the licensed material: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" Use Restrictions All unauthorized access or duplication of the licensed material is a material breach of this agreement and an infringement of the Company’s, the Models’, and potentially others’ trademarks, copyrights, or other rights, including privacy and publicity rights. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" Other Prohibited Actions Unless expressly authorized in advance by the Company in writing, the Affiliate will not: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" Modify, translate, reverse engineer, decompile, or disassemble the licensed material; "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" Create derivative works based on the licensed material; "}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":" Rent, lease, or transfer any rights in the licensed material; "}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":" Remove any proprietary notices or labels on the licensed material; or "}]]],["span",{"class":"num"},[["textNode",{"text":"(v)"}]]],["p",{},[["textNode",{"text":" Make any other unauthorized use of the licensed material. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" Ownership of Licensed Material and Intellectual Property "}]]]]],["p",{},[["textNode",{"text":"Except for material in the public domain or licensed to the Company, the Company owns the licensed material. United States law, international treaties, and other laws and regulations protect the licensed material. The Company retains all rights in the licensed material."}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"2.3"}]]],["textNode",{"text":"No License for Other Material "}]]],["p",{},[["textNode",{"text":" The Company does not grant a license for any other material published on the Model Sites or any other website unless the Company makes that material available to the Affiliate through the Program and the Company designates it as licensed material. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"2.4"}]]],["textNode",{"text":"Reservation of Rights "}]]],["p",{},[["textNode",{"text":" Except as expressly granted in this agreement, the Company does not grant any other rights to the Affiliate. The Company reserves all rights to select, alter, add, or remove all licensed material and promotional links used for the Program. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"2.5"}]]],["textNode",{"text":"Termination or Withdrawal of License "}]]],["p",{},[["textNode",{"text":" On termination of this agreement or the Affiliate’s withdrawal from the Program, the Affiliate’s license to download and use the licensed material will automatically terminate and all rights will automatically revert to the Company. At that time, the Affiliate will promptly delete all copies of the licensed material that might reside on any computer system, storage device, server, affiliate site, or any other website owned by the Affiliate or under its control. "}]]]]]]],["div",{"class":"sp-part","id":"part-3"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"3."}]]],["textNode",{"text":" Program Restrictions "}]]],["div",{"class":"marg-left"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"3.1"}]]],["textNode",{"text":"Compliance with Law "}]]],["p",{},[["textNode",{"text":"The Affiliate will comply with all laws, including the following:"}]]],["ul",{"class":"list"},[["li",{},[["textNode",{"text":" The Federal Record Keeping and Labeling Requirements (18 U.S.C. §§ "}],["a",{"class":"aff-text-color-1","href":"https://www.law.cornell.edu/uscode/text/18/2257"},[["textNode",{"text":"2257"}]]],["textNode",{"text":"–"}],["a",{"class":"aff-text-color-1","href":"https://www.law.cornell.edu/uscode/text/18/2257A"},[["textNode",{"text":"2257A"}]]],["textNode",{"text":") and the regulations codified at "}],["a",{"class":"aff-text-color-1","href":"https://www.law.cornell.edu/cfr/text/28/part-75"},[["textNode",{"text":"28 C.F.R. Part 75"}]]],["textNode",{"text":"; "}]]],["li",{},[["textNode",{"text":" The CAN-SPAM Act of 2003 ("}],["a",{"class":"aff-text-color-1","href":"https://www.law.cornell.edu/uscode/text/15/chapter-103"},[["textNode",{"text":"15 U.S.C. §§ 7701–7713"}]]],["textNode",{"text":") and the regulations codified at "}],["a",{"class":"aff-text-color-1","href":"https://www.law.cornell.edu/cfr/text/16/part-316"},[["textNode",{"text":"16 C.F.R. Part 316"}]]],["textNode",{"text":"; "}]]],["li",{},[["textNode",{"text":" The Restore Online Shoppers’ Confidence Act ("}],["a",{"class":"aff-text-color-1","href":"https://www.law.cornell.edu/uscode/text/15/chapter-110"},[["textNode",{"text":"15 U.S.C. §§ 8401–8405"}]]],["textNode",{"text":"); "}]]],["li",{},[["textNode",{"text":" Guides Against Deceptive Pricing ("}],["a",{"class":"aff-text-color-1","href":"https://www.law.cornell.edu/cfr/text/16/part-233"},[["textNode",{"text":"16 C.F.R. Part 233"}]]],["textNode",{"text":"); "}]]],["li",{},[["textNode",{"text":" Guides Against Bait Advertising ("}],["a",{"class":"aff-text-color-1","href":"https://www.law.cornell.edu/cfr/text/16/part-238"},[["textNode",{"text":"16 C.F.R. Part 238"}]]],["textNode",{"text":"); "}]]],["li",{},[["textNode",{"text":" Guides Concerning Use of the Word \"Free\" and Similar Representations ("}],["a",{"class":"aff-text-color-1","href":"https://www.law.cornell.edu/cfr/text/16/part-251"},[["textNode",{"text":"16 C.F.R. Part 251"}]]],["textNode",{"text":"); "}]]],["li",{},[["textNode",{"text":" Guides Concerning Use of Endorsements and Testimonials in Advertising ("}],["a",{"class":"aff-text-color-1","href":"https://www.law.cornell.edu/cfr/text/16/part-255"},[["textNode",{"text":"16 C.F.R. Part 255"}]]],["textNode",{"text":"); "}]]],["li",{},[["textNode",{"text":" Use of Prenotification Negative Option Plans ("}],["a",{"class":"aff-text-color-1","href":"https://www.law.cornell.edu/cfr/text/16/part-425"},[["textNode",{"text":"16 C.F.R. Part 425"}]]],["textNode",{"text":"); "}]]],["li",{},[["textNode",{"text":" FTC Policy Statement on Deception ("}],["a",{"class":"aff-text-color-1","href":"http://www.ftc.gov/bcp/policystmt/ad-decept.htm"},[["textNode",{"text":"www.ftc.gov/bcp/policystmt/ad-decept.htm"}]]],["textNode",{"text":"); "}]]],["li",{},[["textNode",{"text":" FTC Policy Statement on Advertising Substantiation ("}],["a",{"class":"aff-text-color-1","href":"http://www.ftc.gov/bcp/guides/ad3subst.htm"},[["textNode",{"text":"www.ftc.gov/bcp/guides/ad3subst.htm"}]]],["textNode",{"text":"); "}]]],["li",{},[["textNode",{"text":" FTC Policy Statement on Unfairness ("}],["a",{"class":"aff-text-color-1","href":"http://www.ftc.gov/bcp/policystmt/ad-unfair.htm"},[["textNode",{"text":"www.ftc.gov/bcp/policystmt/ad-unfair.htm"}]]],["textNode",{"text":"); and "}]]],["li",{},[["textNode",{"text":" FTC .com Disclosures: How to Make Effective Disclosures in Digital Advertising ("}],["a",{"class":"aff-text-color-1","href":"https://www.ftc.gov/tips-advice/business-center/guidance/com-disclosures-how-make-effective-disclosures-digital"},[["textNode",{"text":"https://www.ftc.gov/tips-advice/business-center/guidance/com-disclosures-how-make-effective-disclosures-digital"}]]],["textNode",{"text":"). "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"3.2"}]]],["textNode",{"text":"Prohibited Conduct "}]]],["p",{},[["textNode",{"text":" The Affiliate is responsible for all content posted on the affiliate sites. The Company prohibits the Affiliate from engaging in the following prohibited conduct: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["strong",{},[["textNode",{"text":"Depictions of Minors"}]]],["p",{},[["textNode",{"text":" The Affiliate will not disseminate, post on the affiliate sites, or provide links to any matter that involves depictions of nudity or sexuality by an age inappropriate-appearing performer (that is, a performer who looks younger than 18-years old) or by a performer who is portrayed or made to appear as a person under 18-years old by virtue of the script, make-up, costuming, demeanor, setting, etc. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["strong",{},[["textNode",{"text":"Illegal or Objectionable Content"}]]],["p",{},[["textNode",{"text":" The Affiliate will not disseminate, post on the affiliate sites, or provide links to any obscene material, including any material depicting child pornography, incest, scat, defecation, feces, urination, genital mutilation, necrophilia, bestiality, sado-masochistic abuse or bondage, actual or simulated rape, death, sexual violence, actual violence inflected on individuals by themselves or others, menstruation, or torture. Nor will the Affiliate disseminate, post on the affiliate sites, or provide links to any content or materials of the following nature: warez, pirated content, prostitution or escort services, human trafficking, gambling, or illegal drugs and related paraphernalia. "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["strong",{},[["textNode",{"text":"Spam"}]]],["p",{},[["textNode",{"text":" The Affiliate will not disseminate spam in connection with the Program. Although United States federal and state law does not prohibit all forms of spamming, the Company impose a stricter, no-spam policy for affiliates in the Program. What is spamming will evolve over time as new technologies and methodologies emerge for spammers to find new ways to abuse the Program. Some of the facts that the Company takes into account when determining what is spamming include the following: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" If the Affiliate has violated a U.S. federal or state anti-spamming law, including any part of the CAN-SPAM Act of 2003 ("}],["a",{"class":"aff-text-color-1","href":"https://www.law.cornell.edu/uscode/text/15/chapter-103"},[["textNode",{"text":"15 U.S.C. §§ 7701–7713"}]]],["textNode",{"text":") or any of the federal regulations promulgated under the CAN-SPAM Act ("}],["a",{"class":"aff-text-color-1","href":"https://www.law.cornell.edu/cfr/text/16/part-316"},[["textNode",{"text":"16 C.F.R. Part 316"}]]],["textNode",{"text":"); "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" If the Affiliate has violated any nonparty anti-spamming policy; "}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":" If the Affiliate has sent unsolicited bulk messages to nonconsenting recipients; "}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":" If the Affiliate has misleading or false information contained in its messages, subject line, or message-headers; "}]]],["span",{"class":"num"},[["textNode",{"text":"(v)"}]]],["p",{},[["textNode",{"text":" If the Affiliate uses automated means to collect, transmit, or sell the email addresses of others; "}]]],["span",{"class":"num"},[["textNode",{"text":"(vi)"}]]],["p",{},[["textNode",{"text":" If the Affiliate uses a third-party website or program to automatically generate and send messages or content; "}]]],["span",{"class":"num"},[["textNode",{"text":"(vii)"}]]],["p",{},[["textNode",{"text":" If the primary purpose of the Affiliate’s message is commercial in nature; and "}]]],["span",{"class":"num"},[["textNode",{"text":"(viii)"}]]],["p",{},[["textNode",{"text":" The number of spam or abuse complaints that have been lodged against the Affiliate. "}]]]]],["p",{},[["textNode",{"text":" No one factor is controlling, and the Company will look to the particular circumstances of each case to determine what is spamming. The Company recommends that the Affiliate review "}],["a",{"class":"aff-text-color-1","href":"https://www.ftc.gov/tips-advice/business-center/guidance/can-spam-act-compliance-guide-business"},[["textNode",{"text":"CAN-SPAM Act: A Compliance Guide for Business"}]]],["textNode",{"text":". When in doubt, don’t do it—you spam, you’re out. "}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["strong",{},[["textNode",{"text":"Fraudulent and Deceptive Trade Practices"}]]],["p",{},[["textNode",{"text":" The Affiliate will not engage in any fraudulent, deceptive, or unfair transactions or trade practices. The Affiliate will comply with the Federal Trade Commission (FTC) statutes and regulations and any related rules, policies, and advisory opinions in advertising, marketing, and promoting the Model Sites. "}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["strong",{},[["textNode",{"text":"Defamation and Related Conduct"}]]],["p",{},[["textNode",{"text":" The Affiliate will not publish content on the affiliate sites that is defamatory, libelous, threatening, abusive, hateful, derogatory, disparaging, or otherwise injurious to any person or to the reputation of any person. "}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["textNode",{"text":" Federal Record Keeping and Labeling Requirements "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" The Affiliate and the affiliate sites will comply with the federal record keeping and labeling requirements codified at 18 U.S.C. §§ 2257–2257A and the implementing regulations codified at 28 C.F.R. Part 75 (collectively, the "}],["strong",{},[["textNode",{"text":"\"section 2257 requirements\""}]]],["textNode",{"text":"). "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" The Affiliate will act as the required \"Custodian of Records\" in accordance with the section 2257 requirements for all content depicting actual sexually explicit conduct of an actual human being that may be used to promote or market the Model Sites regardless of who produced the content. "}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":" The Affiliate will post a section 2257 statement on the affiliate sites in the manner and locations required by the section 2257 requirements. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["strong",{},[["textNode",{"text":"Intellectual Property Rights"}]]],["p",{},[["textNode",{"text":" The Affiliate will not publish content on the affiliate sites that infringes the intellectual property rights or other legal rights of any person, including copyright, patent, trademark, service mark, trade secret, trade dress, right of privacy, right of publicity, moral rights, or any other proprietary right. "}]]],["span",{"class":"num"},[["textNode",{"text":"(h)"}]]],["strong",{},[["textNode",{"text":"Cybersquatting or Typosquatting"}]]],["p",{},[["textNode",{"text":" The Affiliate will not use or register or try to use or register any domain name (including second-level, third-level, fourth-level, fifth-level, and so on), subdomain name, or directory that is identical or confusingly similar to a trademark or service mark in which the Company, the Models, or another person has intellectual property or other legal rights in, including MODELCENTRO™. "}]]],["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["strong",{},[["textNode",{"text":"Paid Search Advertising Schemes"}]]],["p",{},[["textNode",{"text":" The Affiliate will not bid on or purchase any online paid advertising schemes that incorporate or are confusingly similar to the Company’s or the Models’ trademarks, service marks, domain names, or URLs, including MODELCENTRO™. The prohibited advertising schemes include pay-per-click models, sponsored links, search engine keywords, AdWords, or similar advertising schemes. "}]]],["span",{"class":"num"},[["textNode",{"text":"(j)"}]]],["strong",{},[["textNode",{"text":"Metatags"}]]],["p",{},[["textNode",{"text":" The Affiliate will not use any false, misleading, or infringing metatags tied to the affiliate site. In addition, the Affiliate will not use any metatags that would imply or suggest that underage or illegal content may be found on the affiliate site or the Model Sites. "}]]],["span",{"class":"num"},[["textNode",{"text":"(k)"}]]],["strong",{},[["textNode",{"text":"Unethical Marketing Practices"}]]],["p",{},[["textNode",{"text":" The Affiliate will not try to intercept, direct, re-direct, divert, or usurp traffic (including through the use of user-installed software) from or on, or divert referral fees from, any other participant in the Program. The Affiliate will not directly or indirectly offer consumers any consideration or incentive (including payment of money or granting of any discounts or other benefits) from linking through to the Model Sites through the Affiliate’s referral links; nor will the Affiliate require consumers to join one or more Model Sites as a prerequisite to accessing other products or services. The Affiliate will not try to directly or indirectly obtain screen names of passwords from consumers of the Model Sites, including consumers whom you have referred to the Model Sites. "}]]],["span",{"class":"num"},[["textNode",{"text":"(l)"}]]],["strong",{},[["textNode",{"text":"Misrepresentation of Relationship"}]]],["p",{},[["textNode",{"text":" The Affiliate will not misrepresent its contractual relationship with the Company or the Models or imply that any relationship exists with the Company or the Models except as expressly provided in this agreement. For example, the Affiliate will not publish any statement indicating that the Company or the Models support, endorse, or contribute to the affiliate sites except as expressly provided in this agreement. "}]]],["span",{"class":"num"},[["textNode",{"text":"(m)"}]]],["strong",{},[["textNode",{"text":"Unauthorized Access"}]]],["p",{},[["textNode",{"text":" The Affiliate’s unauthorized access or duplication of any content that the Affiliate obtains directly or indirectly through its participation in the Program is a material breach of this agreement. "}]]],["span",{"class":"num"},[["textNode",{"text":"(n)"}]]],["strong",{},[["textNode",{"text":"Malicious Code, Viruses, Etc."}]]],["p",{},[["textNode",{"text":" The Affiliate will not use or offer for download any material that contains a virus or malicious code, for example a Trojan Horse, that has the potential of causing disruption or damage to any computer system, network, or server. The Affiliate will be liable to the Company for all damage caused by any material of this nature. "}]]],["span",{"class":"num"},[["textNode",{"text":"(o)"}]]],["strong",{},[["textNode",{"text":"Links to and Content of Others"}]]],["p",{},[["textNode",{"text":" The Affiliate will not use the Company’s or the Models’ images, content, or promotional material to promote or link to any other website. "}]]],["span",{"class":"num"},[["textNode",{"text":"(p)"}]]],["strong",{},[["textNode",{"text":"Chat Traffic Advertisements"}]]],["p",{},[["textNode",{"text":" The Affiliate will not use chat traffic advertisements during its participation in the Program. The Company will not accept chat traffic under any circumstances. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"3.3"}]]],["textNode",{"text":"Breach of Program Restrictions "}]]],["p",{},[["textNode",{"text":" The Company may withhold commission fees and terminate this agreement if the Affiliate breaches the program restrictions. "}]]]]]]],["div",{"class":"sp-part","id":"part-4"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"4."}]]],["textNode",{"text":" Affiliate’s Duty to Notify "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"4.1"}]]],["p",{},[["textNode",{"text":"The Affiliate will promptly notify the Company"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" of all URLs where the Affiliate will promote the Model Sites; "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" if there are inquiries or concerns by any person regarding any questionable activities; or "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" if the Affiliate receives any inquiries or requests for information regarding the following subjects: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" obscenity; "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" child pornography or depictions of nudity or sexuality by minors; "}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":" spam complaints; "}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":" copyright infringement; "}]]],["span",{"class":"num"},[["textNode",{"text":"(v)"}]]],["p",{},[["textNode",{"text":" trademark infringement; "}]]],["span",{"class":"num"},[["textNode",{"text":"(vi)"}]]],["p",{},[["textNode",{"text":" patent infringement; "}]]],["span",{"class":"num"},[["textNode",{"text":"(vii)"}]]],["p",{},[["textNode",{"text":" deceptive trade practices; "}]]],["span",{"class":"num"},[["textNode",{"text":"(viii)"}]]],["p",{},[["textNode",{"text":" unfair business practices; "}]]],["span",{"class":"num"},[["textNode",{"text":"(ix)"}]]],["p",{},[["textNode",{"text":" misleading search terms; "}]]],["span",{"class":"num"},[["textNode",{"text":"(x)"}]]],["p",{},[["textNode",{"text":" invasion of publicity or privacy issues; "}]]],["span",{"class":"num"},[["textNode",{"text":"(xi)"}]]],["p",{},[["textNode",{"text":" fraudulent activities, including credit card fraud; "}]]],["span",{"class":"num"},[["textNode",{"text":"(xii)"}]]],["p",{},[["textNode",{"text":" any criminal investigation unless the Affiliate is prohibited by law from notifying the Company; "}]]],["span",{"class":"num"},[["textNode",{"text":"(xiii)"}]]],["p",{},[["textNode",{"text":" any civil investigation that pertains to the Affiliate, even if it does not relate to the Affiliate’s relationship with the Company; or "}]]],["span",{"class":"num"},[["textNode",{"text":"(xiv)"}]]],["p",{},[["textNode",{"text":" any civil or criminal subpoena served on the Affiliate, even if it does not relate to the Affiliate’s relationship with the Company. "}]]]]]]],["span",{"class":"num"},[["textNode",{"text":"4.2"}]]],["p",{},[["textNode",{"text":" Failure to comply with section 4.1 will constitute a breach of this agreement. The Affiliate will be responsible for any damage to the Company based on the Affiliate’s failure to notify the Company as required by section 4.1. "}]]],["span",{"class":"num"},[["textNode",{"text":"4.3"}]]],["p",{},[["textNode",{"text":" The Affiliate will provide the Company the means necessary to monitor the source of traffic that the Affiliate sends to the Model Sites, including any necessary access credentials. The Affiliate will send access credentials to "}],["a",{"herf":"mailto:affiliates@mcprofits.com"},[["textNode",{"text":"affiliates@mcprofits.com"}]]],["textNode",{"text":". The Affiliate will not charge the Company and the Company will not incur any expense from the Affiliate as a result of the Affiliate’s providing the Company with access credentials. The Company is not required to approve or review any content not provided by the Company that appears on an affiliate site. The Affiliate remains solely liable for all content appearing on its affiliate sites. "}]]]]]]],["div",{"class":"sp-part","id":"part-5"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"5."}]]],["textNode",{"text":" Compensation "}]]],["div",{"class":"marg-left"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"5.1"}]]],["textNode",{"text":"Commissions "}]]],["p",{},[["textNode",{"text":"The Company will pay the Affiliate commissions according to the specific payout terms made available to the Affiliate by the Company when the Affiliate registers for participation in the Program. The commissions will be based on a percentage of the revenue derived from the following: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" fees that are paid by referred consumers for membership to the applicable Model Site, where the Company actually collects these fees; plus "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" fees paid for the applicable model products purchased by referred consumers and through the applicable Model Site, where the Company actually collects these fees (collectively, the "}],["strong",{},[["textNode",{"text":"\"model site revenue\""}]]],["textNode",{"text":"); less "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" a transaction fee that is deducted before the calculation of the model site revenue. "}]]]]],["p",{},[["textNode",{"text":"The Affiliate will be able to track its commissions through the affiliate portal available at affiliates.modelcentro.com."}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"5.2"}]]],["textNode",{"text":"Payouts "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["strong",{},[["textNode",{"text":"Minimum Payout Requirement"}]]],["p",{},[["textNode",{"text":" The information about minimum payouts is made available through the Program. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["strong",{},[["textNode",{"text":"Pay Periods"}]]],["p",{},[["textNode",{"text":" Subject to the minimum payout requirement for the payment method selected, the Company will disburse payouts in accordance with the schedule set out in the affiliate portal. The Company will debit payouts for cancelled subscriptions. The Company may change the payout pay periods on one or more occasions. "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["strong",{},[["textNode",{"text":"Processing Fees"}]]],["p",{},[["textNode",{"text":" The Company is not responsible for any third-party fees charged by banks or financial institutions used to receive commissions. The Company may deduct a processing fee if the payment method selected carries a processing fee. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"5.3"}]]],["textNode",{"text":"Payout Limitations "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" The Company will pay the Affiliate for qualified referrals only if its system can track a consumer to the Model Site from the time a consumer clicks on a referral link to the time of sale. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" The Company will not pay the Affiliate a commission if "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" its system cannot process the affiliate code; "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" a consumer does not make full payment; "}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":" the referred consumer previously registered for the applicable Model Site; or "}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":" a referral links directs a consumer to the Model Site, but the consumer leaves the Model Site and later returns to sign up or pay for the model offerings. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" The Company will not pay the Affiliate for any activity that the Company determines is fraudulent, including "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" credit card numbers in a negative bin number database, "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" multiple subscriptions from a single email address, "}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":" multiple subscriptions with the same credit card number, "}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":" subscriptions with past memberships to the applicable Model Site, "}]]],["span",{"class":"num"},[["textNode",{"text":"(v)"}]]],["p",{},[["textNode",{"text":" sequential names or patterns of names, "}]]],["span",{"class":"num"},[["textNode",{"text":"(vi)"}]]],["p",{},[["textNode",{"text":" many subscriptions from a specific Model Site in a short time span, or "}]]],["span",{"class":"num"},[["textNode",{"text":"(vii)"}]]],["p",{},[["textNode",{"text":" multiple attempts to subscribe from the same credit card. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":" The Company may also deny or withhold commissions for any referrals coming from any practices that breach this agreement. If the Company determines that the Affiliate is engaging in practices that breach this agreement, the Affiliate will not receive any credit or payment and will forfeit all credits or payments earned. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"5.4"}]]],["textNode",{"text":"Abnormal Chargebacks or Cancellations and Other Suspicious Behavior "}]]],["p",{},[["textNode",{"text":" The Company may deny or withhold any payment to the Affiliate or terminate the Affiliate’s participation in the Program if there has been an abnormal number of chargebacks or cancellations of memberships or purchases from traffic referred to the Company through one or more affiliate sites. The Company will determine what is an abnormal number of chargebacks or cancellations based on its review of the situation and its experience with other affiliates. In addition, the Company may also deny or withhold payment to the Affiliate or terminate the Affiliate’s participation in the Program due to any other suspicious behavior, including unusual conversion ratios, lack of or low quantity of member logins, or low member usage. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"5.5"}]]],["textNode",{"text":"Account Inactivity; Inactive Account Maintenance Fees "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" To receive any commissions under this agreement, the Affiliate’s account must be active and in compliance with this agreement. If the Affiliate does not actively generate qualifying referrals to the Model Sites for 90 consecutive days, the Affiliate’s account may, at the Company’s sole discretion, no longer be considered active and instead may be designated as inactive. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" If the Affiliate has not earned any commissions for 180 consecutive days, the Company may charge the Affiliate an account maintenance fee that the Company will deduct from the Affiliate’s unpaid accrued commissions. The account maintenance fee will be the lesser of $10 and the amount of unpaid accrued commissions in the Affiliate’s account. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"5.6"}]]],["textNode",{"text":"Commission Forfeiture "}]]],["p",{},[["textNode",{"text":" If the Company is unable to pay the Affiliate for 180 consecutive days and the Company cannot otherwise contact the Affiliate during this period, the Company will consider all unpaid accrued commissions forfeited to the Company. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"5.7"}]]],["textNode",{"text":"Taxes "}]]],["p",{},[["textNode",{"text":" The Affiliate will pay all taxes attributable to commissions earned under this agreement. On one or more occasions, the Company may request the Affiliate to provide tax information depending on the jurisdiction in which the Affiliate resides or is organized. The Affiliate will promptly comply with any request by the Company for tax information. If the Company requests tax information from the Affiliate and the Affiliate fails to it to the Company, the Company may withhold payment from the Affiliate until the Affiliate provides this information or otherwise satisfies the Company that the Affiliate is not a person from whom the Company is required to obtain tax information. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"5.8"}]]],["textNode",{"text":"Disputes "}]]],["p",{},[["textNode",{"text":" If the Affiliate disputes a payment or the calculation of a commission, the Affiliate will notify the Company in writing of any disputes or discrepancies no later than 30 days after the end of the pay period in which the disputed payment occurred. The Affiliate must include in its written notice a detailed statement describing the nature and amount of the dispute and all supporting evidence. The Affiliate will cooperate fully and in good faith with the Company to promptly address and try to resolve the dispute. If the Affiliate fails to timely notify the Company in writing, the parties will consider the Company’s determination correct and binding on the Affiliate and the Affiliate will not dispute the Company’s determination. "}]]]]]]]]],["div",{"class":"sp-part","id":"part-6"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"6."}]]],["textNode",{"text":" Promotional Materials "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"6.1"}]]],["p",{},[["textNode",{"text":" The Affiliate may use its own images, graphics, links, copy, or other promotional material in connection with its referral generating services, on the condition that the Affiliate’s promotional material complies with this agreement. The Affiliate will be fully responsible for all aspects of its promotional materials."}]]],["span",{"class":"num"},[["textNode",{"text":"6.2"}]]],["p",{},[["textNode",{"text":" If the Company wishes to cancel the use of any promotional material (including any part of the promotional material), the Affiliate will stop the distribution and use of it in connection with the affiliate sites no later than 48 hours after the Company’s written request. "}]]]]]]],["div",{"class":"sp-part","id":"part-7"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"7."}]]],["textNode",{"text":" Affiliate Site Obligations "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"7.1"}]]],["p",{},[["textNode",{"text":" The Affiliate will be solely responsible for developing, operating, and maintaining the affiliate sites and for all materials that appear on the affiliate sites. The Affiliate’s responsibilities include: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" The technical operation of the affiliate sites and all related equipment; "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" Displaying the referral links and licensed material on the affiliate sites in compliance with this agreement; "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" Creating, posting, and ensuring the accuracy of materials posted on the affiliate sites, including all materials related to the Model Sites and the model offerings; "}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":" Using the licensed material, the affiliate sites, and the materials on the affiliate sites in a way that does not infringe any of the Company’s or the Models’ rights or those of any other person (including copyrights, trademarks, privacy, publicity, or other intellectual property or proprietary rights); "}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["textNode",{"text":" Disclosing on the affiliate sites accurately and adequately, either through a privacy policy or otherwise, how the Affiliate collects, uses, stores, and discloses data collected from affiliate site visitors, including, where applicable, that nonparties (including the Company and other advertisers) may serve content and advertisements, collect information directly from affiliate site visitors, and place or recognize cookies on affiliate site visitors’ browsers; and "}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["textNode",{"text":" Making sure that any use that the Affiliate makes of the licensed material complies with this agreement. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"7.2"}]]],["p",{},[["textNode",{"text":" The Company may monitor signups through the affiliate sites to evaluate the Affiliate’s compliance with this agreement. If the Company determines that the Affiliate is not in compliance, the Company may terminate the Affiliate from the Program. "}]]],["span",{"class":"num"},[["textNode",{"text":"7.3"}]]],["p",{},[["textNode",{"text":" The Company will not be liable to the Affiliate, the Models, or any nonparty for the Affiliate’s acts or omissions under section 7.1. "}]]]]]]],["div",{"class":"sp-part","id":"part-8"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"8."}]]],["textNode",{"text":" Processing; Statistics and Reporting "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"8.1"}]]],["p",{},[["textNode",{"text":" The Company will process all signups and purchases made by consumers who follow referral links from the affiliate site to the Model Sites. The Company may reject signups or purchases that do not comply with any requirements on the applicable Model Site. "}]]],["span",{"class":"num"},[["textNode",{"text":"8.2"}]]],["p",{},[["textNode",{"text":" The Company will track qualified referrals for reporting and commission accrual purposes. The Company will use reasonable efforts to provide the Affiliate with access to real-time traffic reporting, qualifying referrals, and revenue statistics. The Affiliate acknowledges that in calculating the Affiliate’s commissions, the Company’s good faith determination of any amount owed will be the final and binding determination, subject to section 5.8. The Affiliate will not try to artificially inflate its traffic reporting, qualifying referrals, and revenue statistics by misleading or abusive practices. "}]]]]]]],["div",{"class":"sp-part","id":"part-9"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"9."}]]],["textNode",{"text":" Consumer Policies and Pricing "}]]],["p",{},[["textNode",{"text":" Consumers referred through the Program are customers of the applicable Model with respect to all activities they undertake on the applicable Model Site. Thus, as between the Affiliate and the applicable Model, all pricing, terms, rules, policies, and operating procedures concerning customer signups, purchases, and customer service set out on the applicable Model Site will apply to those customers, and the applicable Model may change them at any time. "}]]]]],["div",{"class":"sp-part","id":"part-10"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"10."}]]],["textNode",{"text":"Statements of Fact "}]]],["div",{"class":"marg-left"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"10.1"}]]],["textNode",{"text":"By Affiliate "}]]],["p",{},[["textNode",{"text":" The Affiliate states that the following facts are accurate and will continue to be accurate during this agreement: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" If the Affiliate is an individual, the Affiliate is at least 18-years old and has the legal capacity to enter into this agreement. If the Affiliate is an entity, it is duly organized, validly existing, and in good standing as a corporation or other entity under the laws of its jurisdiction of incorporation, organization, or chartering. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" The Affiliate has the power to enter into this agreement and to perform the obligations under this agreement. "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" The Affiliate owns or operates each affiliate site that the Affiliate enrolled in the Program. "}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":" The Affiliate owns or has a license for all content found on each affiliate site, including all text, audio, images, and videos displayed on each affiliate site. "}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["textNode",{"text":" The revenue the Affiliate earns through the Program is and will be directed solely to the Affiliate, and the Affiliate is not authorized to transfer the Affiliate’s checks to or deposit the Affiliate’s checks with any nonparties other than bona fide financial institutions. "}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["textNode",{"text":" The Affiliate is not an individual, organization, or entity listed on The Office of Foreign Assets Control Specially Designated Nationals or Blocked Persons list, as published and updated by the United States Department of Treasury. "}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["textNode",{"text":" Each affiliate site and the content on each affiliate site "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" does not infringe the Company’s or any other person’s intellectual property rights; "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" does not violate nonparty publicity or privacy rights; "}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":" does not promote violence, racial intolerance, or illegal activities; "}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":" does not depict bestiality, necrophilia, genital mutilation, sado-masochistic abuse or bondage, defecation, urination, bleeding, enema play, rape, extreme violence, torture, incest, or any other obscene material; "}]]],["span",{"class":"num"},[["textNode",{"text":"(v)"}]]],["p",{},[["textNode",{"text":" does not depict minors in adult or sexual situations or otherwise target persons under 18-years old or the age of majority, whichever is higher; "}]]],["span",{"class":"num"},[["textNode",{"text":"(vi)"}]]],["p",{},[["textNode",{"text":" does not violate any law governing false or deceptive advertising, sweepstakes, gambling, comparative advertising, or trade disparagement; "}]]],["span",{"class":"num"},[["textNode",{"text":"(vii)"}]]],["p",{},[["textNode",{"text":" is free of any \"worm,\" \"virus,\" or other device that could impair or injure any person or any person’s property; "}]]],["span",{"class":"num"},[["textNode",{"text":"(viii)"}]]],["p",{},[["textNode",{"text":" is not otherwise defamatory, vulgar, or obscene; and "}]]],["span",{"class":"num"},[["textNode",{"text":"(ix)"}]]],["p",{},[["textNode",{"text":" complies with the program restrictions set out in section 3. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"(h)"}]]],["p",{},[["textNode",{"text":" The Affiliate is generally familiar with the nature of the Internet and complies with all laws and industry standards. "}]]],["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" The Affiliate’s performance under this agreement does not breach any agreement or obligation between the Affiliate and a nonparty or violate any law. "}]]],["span",{"class":"num"},[["textNode",{"text":"(j)"}]]],["p",{},[["textNode",{"text":" The Affiliate’s performance under this agreement does not breach any agreement or obligation between the Company and a nonparty or violate any law. "}]]],["span",{"class":"num"},[["textNode",{"text":"(k)"}]]],["p",{},[["textNode",{"text":" The Affiliate’s collection and use of personally identifiable information does not breach the privacy policy or violate any law that governs the Affiliate’s collection and use of personal information. "}]]],["span",{"class":"num"},[["textNode",{"text":"(l)"}]]],["p",{},[["textNode",{"text":" The Affiliate and each affiliate site complies with 18 U.S.C. §§ 2257–2257A and the implementing regulations codified at 28 C.F.R. Part 75. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"10.2"}]]],["textNode",{"text":"By Company "}]]],["p",{},[["textNode",{"text":" The Company states that the following facts are accurate:"}]]],["p"],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" It is duly organized, validly existing, and in good standing as a corporation under the laws of the British Virgin Islands. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" It has the power to enter into this agreement and to perform the obligations under this agreement. "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" It owns or has the right to operate the Program. "}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":" It owns or has the right to license the licensed material. "}]]]]]]]]],["div",{"class":"sp-part","id":"part-11"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11."}]]],["textNode",{"text":"Confidentiality "}]]],["div",{"class":"marg-left"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.1"}]]],["textNode",{"text":"Maintaining Confidentiality "}]]],["p",{},[["textNode",{"text":" For as long as it remains confidential information, the Affiliate will not (1) disclose that confidential information except as contemplated in this agreement or (2) use that confidential information other than for purposes of this agreement. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.2"}]]],["textNode",{"text":"Permitted Disclosure "}]]],["p",{},[["textNode",{"text":" The Affiliate will disclose confidential information to only those of its representatives who"}]]],["p"],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" require the confidential information to perform under this agreement (but to the extent practicable, only the part that is required); "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" are informed in writing by the Affiliate of the confidential nature of the confidential information; and "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" agree in writing to be bound by the obligations of this section. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.3"}]]],["textNode",{"text":"Precautions against Unauthorized Disclosure or Use "}]]],["p",{},[["textNode",{"text":" The Affiliate will take precautions to prevent disclosure or use of confidential information other than as authorized in this agreement. Those precautions must be at least as effective as those taken by the Affiliate to protect its own confidential information or those that would be taken by a reasonable person in the position of the Affiliate, whichever are greater. If the Affiliate complies with its obligations under this section, the Affiliate will not be liable for any losses or liabilities of the Company arising out of misappropriation of confidential information from the Affiliate by any nonparty. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.4"}]]],["textNode",{"text":"Unauthorized Disclosure or Use by Representatives "}]]],["p",{},[["textNode",{"text":" If any one or more representatives of the Affiliate disclose or use confidential information other than as authorized in this agreement, the Affiliate will be liable to the Company for that disclosure or use to the same extent that it would have been had the Affiliate disclosed or used that confidential information. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.5"}]]],["textNode",{"text":"Notification of Unauthorized Disclosure or Use "}]]],["p",{},[["textNode",{"text":" If the Affiliate becomes aware of disclosure or use of confidential information other than as authorized in this agreement, the Affiliate will promptly notify the Company of that disclosure or use and will cooperate with the Company in mitigating any adverse consequences to the Company of that disclosure or use. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.6"}]]],["textNode",{"text":"Nondisclosure of Agreement "}]]],["p",{},[["textNode",{"text":" During this agreement and afterwards until that information becomes public other than because of breach of this section, each party will not disclose to any other person the existence of this agreement and its terms and the nature of the relationship, except to the extent disclosure is required by law. If disclosure is required by law, that disclosure will not constitute a breach of the party in question’s obligations under this section, on condition that it has complied with section 11.8, as if section 11.8 applied to that disclosure besides disclosure of confidential information. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.7"}]]],["textNode",{"text":"Return of Confidential Information "}]]],["p",{},[["textNode",{"text":" On the termination of this agreement, the Affiliate will promptly, but no later than 30 days after the termination of this agreement: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" Return to the Company all copies of confidential information that, on disclosure, the Company had instructed the Affiliate to return on the termination of this agreement; and "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" Destroy all remaining copies of confidential information disclosed to the Affiliate under this agreement. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.8"}]]],["textNode",{"text":"Disclosure Required by Law "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" If any proceeding is brought to compel the Affiliate or any of its representatives to disclose confidential information, or if the Affiliate or any of its representatives is otherwise required by law to disclose any confidential information, the Affiliate will do the following: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" Unless by doing so the Affiliate would violate any law or an order of a government body, notify the Company of that proceeding or that requirement, as the case may be, promptly after learning of it, taking into account for purposes of determining the Affiliate’s promptness any time constraints that the Company would face in bringing a proceeding to prevent that disclosure or to protect the confidentiality of any information that is disclosed; and "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" At the Affiliate’s expense, cooperate with the Company in any proceeding that the Company brings to prevent that disclosure or to protect the confidentiality of any information that is disclosed. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" It will not constitute a breach of the Affiliate’s obligations under this agreement for the Affiliate or any of its representatives to disclose confidential information as required by law, on condition that the Affiliate has complied with its obligations under section 11.8(a) for that disclosure and has delivered to the Company a written opinion of the Affiliate’s legal counsel prepared at the Affiliate’s expense stating that the disclosure is required by law and that opinion is reasonably acceptable to the Company. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.9"}]]],["textNode",{"text":"Nondisclosure of Restricted Information "}]]],["p",{},[["textNode",{"text":" The Company will not disclose to the Affiliate or any of its representatives any information if doing so would cause the Company to breach a duty to any other person to keep that information confidential or would cause the Company to violate any law or any order of a government body. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.10"}]]],["textNode",{"text":"Export Controls "}]]],["p",{},[["textNode",{"text":" The Affiliate will not export or re-export any confidential information, directly or indirectly, without first obtaining any license required under any export control laws. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.11"}]]],["textNode",{"text":"No License "}]]],["p",{},[["textNode",{"text":" The Company’s disclosure of confidential information will not constitute a grant to the Affiliate or any of its representatives of a license to, or any other interest in, any intellectual property of the Company unless stated in this agreement. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.12"}]]],["textNode",{"text":"No Statement about Accuracy "}]]],["p",{},[["textNode",{"text":" The Company is not making in this agreement any statement about accuracy of any confidential information. The Affiliate acknowledges that because it has not relied on, and will not be relying on, any statements made by the Company to the Affiliate about accuracy of any confidential information, the Affiliate will have no basis for bringing any claim for fraud about those statements. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.13"}]]],["textNode",{"text":"Reverse Engineering "}]]],["p",{},[["textNode",{"text":" The Affiliate will not reverse engineer, disassemble, or create other works from any software or hardware constituting or included in any confidential information. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.14"}]]],["textNode",{"text":"Residual Information "}]]],["p",{},[["textNode",{"text":" Use of residual information for the Affiliate’s benefit by any representatives of the Affiliate to whom confidential information was disclosed in accordance with this agreement will not constitute a breach of the Affiliate’s obligations under this agreement, on condition that the Affiliate did not have its representatives intentionally commit to memory the confidential information in question and on condition that the Affiliate complies with its obligations under section 11.7. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.15"}]]],["textNode",{"text":"Publicity "}]]],["p",{},[["textNode",{"text":" The Company may use the Affiliate’s trade names, trademarks, service marks, or logos in presentations, marketing materials, affiliate lists, financial reports, website listings of affiliates, or advertisements without advance written approval. The Affiliate may use the Company’s or the Models’ trade names, trademarks, service marks, logos, domain names, and other distinctive brand features so long as the Affiliate complies with this agreement. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"11.16"}]]],["textNode",{"text":" Definitions "}]]],["p",{},[["textNode",{"text":" For purposes of this section, the following definitions apply: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Confidential information\""}]]],["textNode",{"text":" means the following: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" Information (other than excluded information) relating to the Company and its business that the Company discloses to the Affiliate during this agreement (including individual contact information and information about the Company’s marketing, plans, pricing, products, services, and technical environment); and "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" Derived information. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Derived information\""}]]],["textNode",{"text":" means information (including notes, analyses, compilations, and summaries) that is in writing or embodied in an electronic medium and that the Affiliate or any of its representatives derive, in whole or in part, from any information described in section 11.16(a)(i). "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Excluded information\""}]]],["textNode",{"text":" means information that comes within any of the following categories, with the Affiliate having the burden of establishing that any information constitutes excluded information: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" Other than personally identifiable information, information that is or becomes public other than as a result of breach of any obligation under this agreement; "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" Information that, when it is disclosed, is already in the possession of the Affiliate or any of its representatives as the result of disclosure by a person that was not under an obligation to the Company to keep that information confidential; "}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":" Information that, after it is disclosed under this agreement, is disclosed to the Affiliate or any of its representatives by a person that was not then under an obligation to the Company to keep that information confidential; and "}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":" Information that the Affiliate develops independently before the Company discloses equivalent information to the Affiliate. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Government body\""}]]],["textNode",{"text":" means (1) the government of a country or of a political subdivision of a country; (2) an instrumentality of any government; (3) any other individual, entity, or organization authorized by law to perform any executive, legislative, judicial, regulatory, administrative, military, or police functions of any government; or (4) an intergovernmental organization. "}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Person\""}]]],["textNode",{"text":" means an individual, corporation, partnership, limited liability company, association, trust, unincorporated organization, or other legal entity or organization, or government body. "}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Representative\""}]]],["textNode",{"text":" means, as to an entity, any of that entity’s directors, officers, employees, agents, consultants, advisors, and other representatives. "}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Residual information\""}]]],["textNode",{"text":" means, as to any individual, any confidential information that the individual remembers without any need to refer to that confidential information as fixed in a tangible medium. "}]]]]]]]]],["div",{"class":"sp-part","id":"part-12"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"12."}]]],["textNode",{"text":"Nondisparagement "}]]],["p",{},[["textNode",{"text":" During this agreement and for two years after its termination, the Affiliate will not take any action that is intended, or would reasonably be expected, to harm the Company or its reputation or that would reasonably be expected to lead to unwanted or unfavorable publicity to the Company. But nothing will prevent the Affiliate from making any truthful statement in connection with any legal proceeding or investigation by the Company or any governmental body. "}]]],["p"]]],["div",{"class":"sp-part","id":"part-13"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"13."}]]],["textNode",{"text":"Disclaimer of Warranties "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"13.1"}]]],["p",{},[["textNode",{"text":" The Company is not making any guarantee of profitability or about the amount of money the Affiliate will earn through the Program. The Affiliate acknowledges that past affiliate earnings does not guarantee or suggest similar future earnings. "}]]],["span",{"class":"num"},[["textNode",{"text":"13.2"}]]],["p",{},[["textNode",{"text":" The Company is not making any warranty—express, implied, oral, or otherwise—that "}]]],["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" the Program, the Model Sites, the model offerings, or the licensed material will be timely, uninterrupted, or error-free (whether as a result of technical failure, acts or omissions of nonparties, or other causes) or will operate in combination with any other hardware, software, system, or data; "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" the Program, the Model Sites, the model offerings, or the licensed material will be suitable or otherwise meet the Affiliate’s requirements or expectations; "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" the Program, the Model Sites, the model offerings, or the licensed material will be accurate or reliable; "}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":" errors or defects in the Program, the Model Sites, the model offerings, or the licensed material will be corrected; or "}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["textNode",{"text":" the servers that make the Program, the Model Sites, the model offerings, and the licensed material available are free of viruses or other harmful components. "}]]],["span",{"class":"num"},[["textNode",{"text":"13.3"}]]],["p",{},[["textNode",{"text":" The Company offers the Program, the Model Sites, the model offerings, and the licensed material \"as is\" without warranty, either express or implied. The Company is not making any warranty, either express or implied, including implied warranty of merchantability, fitness for a particular purpose, title, privacy, and noninfringement for the Program, the Model Sites, the model offerings, and the licensed material. No advice or information, whether oral or written, obtained from the Company or elsewhere will create any warranty not expressly stated in this agreement. "}]]]]]]],["div",{"class":"sp-part","id":"part-14"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"14."}]]],["textNode",{"text":" Limit of Liability "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"14.1"}]]],["p",{},[["textNode",{"text":" The Program, the Model Sites, or the licensed material may be subject to limitations, delays, and other problems inherent in the use of the Internet and electronic communications. The Company is not liable for any delays, delivery failures, or other damage resulting from these problems. "}]]],["span",{"class":"num"},[["textNode",{"text":"14.2"}]]],["p",{},[["textNode",{"text":" The Company will not be liable to the Affiliate for any of the following: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" Errors, mistakes, or inaccuracies in the Program, the Model Sites, or the licensed material; "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" Content or conduct that is infringing, inaccurate, obscene, indecent, offensive, threatening, harassing, defamatory, libelous, abusive, invasive of privacy, or illegal; "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" Unauthorized access to or use of the Company’s servers and any personal or financial information stored in them, including unauthorized access or changes to the Affiliate’s account, transmissions, or data; "}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":" Interruption or cessation of transmission to or from the Program or the Model Sites; "}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["textNode",{"text":" Denial-of-service attack (DoS) or distributed denial-of-service attack (DDoS); "}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["textNode",{"text":" Bugs, viruses, Trojan horses, malware, ransomware, or other disabling code that may be transmitted to or through the Program, the Model Sites, or the licensed material by any person or that might infect the Affiliate’s computer or affect the Affiliate’s access to or use of the Program, the Model Sites, the licensed material, or the Affiliate’s other services, hardware, or software; "}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["textNode",{"text":" Incompatibility between the Program, the Model Sites, or the licensed material and the Affiliate’s other services, hardware, or software; "}]]],["span",{"class":"num"},[["textNode",{"text":"(h)"}]]],["p",{},[["textNode",{"text":" Delays or failures the Affiliate might experience in starting, conducting, or completing any transmissions to or transactions through or with the Program, the Model Sites, or the licensed material; or "}]]],["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" Loss or damage incurred because of the use of any content posted, emailed, sent, or otherwise made available through the Program or the Model Sites. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"14.3"}]]],["p",{},[["textNode",{"text":" The Company will not be liable to the Affiliate for breach-of-contract damages that the Company could not reasonably have foreseen on entry into this agreement. The Company also will not be liable to the Affiliate—regardless of theory of liability and even if the Affiliate advised the Company of the possibility of these damages—for any damages for any of the following: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" loss of use; "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" loss of services; "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" loss of profits; "}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":" loss of revenue; "}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["textNode",{"text":" loss of goodwill; "}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["textNode",{"text":" loss of contracts; "}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["textNode",{"text":" loss of data; "}]]],["span",{"class":"num"},[["textNode",{"text":"(h)"}]]],["p",{},[["textNode",{"text":" loss of privacy; "}]]],["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" loss of business or opportunity; or "}]]],["span",{"class":"num"},[["textNode",{"text":"(j)"}]]],["p",{},[["textNode",{"text":" cost of obtaining substitute services related to the Program, the Model Sites, the model offerings, or the licensed material. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"14.4"}]]],["p",{},[["textNode",{"text":" Except as stated in this agreement, neither party will be liable to the other party for indirect, incidental, special (including consequential), statutory, exemplary, or punitive damages arising from or relating to this agreement, regardless of theory of liability and even if that party knew or should have known of the possibility of these damages, including loss of revenue or anticipated profits or lost business."}]]],["span",{"class":"num"},[["textNode",{"text":"14.5"}]]],["p",{},[["textNode",{"text":" The Company’s total cumulative liability to the Affiliate will not exceed the greater of the total amount owed to the Affiliate under this agreement and $250. "}]]]]]]],["div",{"class":"sp-part","id":"part-15"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"15."}]]],["textNode",{"text":" Loss Payment (aka Indemnification) "}]]],["div",{"class":"marg-left"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"15.1"}]]],["textNode",{"text":"In General "}]]],["p",{},[["textNode",{"text":" The Affiliate will pay the Company for any loss of the Company’s that is caused by the Affiliate’s actual or alleged "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" Use of the Program, the Model Sites, or the licensed material; "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" Failure to pay taxes in connection with the revenues earned under this agreement; "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" Dispute with any customer, model, studio, affiliate, or other person; "}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":" breach of this agreement; "}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["textNode",{"text":" infringement of nonparty intellectual property rights; "}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["textNode",{"text":" violation of any third party rights; "}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["textNode",{"text":" violation of any law; "}]]],["span",{"class":"num"},[["textNode",{"text":"(h)"}]]],["p",{},[["textNode",{"text":" fraudulent or deceptive conduct or trade practices; "}]]],["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" negligent conduct; "}]]],["span",{"class":"num"},[["textNode",{"text":"(j)"}]]],["p",{},[["textNode",{"text":" intentional conduct; or "}]]],["span",{"class":"num"},[["textNode",{"text":"(k)"}]]],["p",{},[["textNode",{"text":"criminal conduct."}]]]]],["p",{},[["textNode",{"text":"But the Affiliate is not required to pay if the loss was caused by the Company’s intentional misconduct."}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"15.2"}]]],["textNode",{"text":"Definitions "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Loss\""}]]],["textNode",{"text":" means an amount that the Company is legally responsible for or pays in any form. Amounts include, for example, a judgment, a settlement, a fine, damages, injunctive relief, staff compensation, a decrease in property value, and expenses for defending against a claim for a loss (including fees for legal counsel, expert witnesses, and other advisers). A loss can be tangible or intangible; can arise from bodily injury, property damage, or other causes; can be based on tort, breach of contract, or any other theory of recovery; and includes incidental, direct, and consequential damages. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" A loss is "}],["strong",{},[["textNode",{"text":"\"caused by\""}]]],["textNode",{"text":" an event if the loss would not have occurred without the event, even if the event is not a proximate cause of the loss. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"15.3"}]]],["textNode",{"text":"Company’s Duty to Notify "}]]],["p",{},[["textNode",{"text":" The Company will notify the Affiliate before the 15th business day after the Company knows or should reasonably have known of a claim for a loss that the Affiliate might be obligated to pay. The Company’s failure to give the Affiliate timely notice does not terminate the Affiliate’s obligation, except to the extent that the failure prejudices the Affiliate’s ability to defend the claim or mitigate losses. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"15.4"}]]],["textNode",{"text":"Legal Defense of a Claim "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["strong",{},[["textNode",{"text":"Company’s Control"}]]],["p",{},[["textNode",{"text":" The Company has control over defending a claim for a loss (including settling it), unless the Company directs the Affiliate to control the defense. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["strong",{},[["textNode",{"text":"Direction to Control "}]]],["p",{},[["textNode",{"text":" If the Company directs the Affiliate to control the defense, each of the following applies: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" The Affiliate may choose and retain legal counsel. "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" The Company may retain its own legal counsel at its expense. "}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":" The Affiliate will not settle any litigation without the Company’s written consent if the settlement "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(1)"}]]],["p",{},[["textNode",{"text":" imposes a penalty or limitation on the Company, "}]]],["span",{"class":"num"},[["textNode",{"text":"(2)"}]]],["p",{},[["textNode",{"text":" admits the Company’s fault, or "}]]],["span",{"class":"num"},[["textNode",{"text":"(3)"}]]],["p",{},[["textNode",{"text":" does not fully release the Company from liability. "}]]]]]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["strong",{},[["textNode",{"text":"Good Faith"}]]],["p",{},[["textNode",{"text":" The Affiliate and the Company will cooperate with each other in good faith on a claim. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"15.5"}]]],["textNode",{"text":"No Exclusivity "}]]],["p",{},[["textNode",{"text":" The Company’s rights under this section 15 do not affect other rights that the Company might have. "}]]],["p"]]]]],["div",{"class":"sp-part","id":"part-16"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"16."}]]],["textNode",{"text":"Dispute Resolution "}]]],["div",{"class":"marg-left"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"16.1"}]]],["textNode",{"text":"Litigation Election "}]]],["p",{},[["textNode",{"text":" Either party may elect to litigate the following type of case or controversy: (1) an action seeking injunctive relief, or (2) a suit to compel compliance with this dispute resolution provision. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"16.2"}]]],["textNode",{"text":"Negotiation "}]]],["p",{},[["textNode",{"text":" Each party will give the other a reasonable opportunity to comply before it claims that the other has not met its obligations under this agreement. The parties will first meet and negotiate with each other in good faith to try to resolve all disputes between the parties relating to this agreement. The party raising a dispute will submit to the other party a written notice and supporting material describing all issues and circumstances related to the dispute (a "}],["strong",{},[["textNode",{"text":"\"dispute notice\""}]]],["textNode",{"text":"). A primary representative designated by each party will try to resolve the dispute. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"16.3"}]]],["textNode",{"text":"Mediation "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" If the parties’ primary representatives are unable to resolve the dispute no later than 30 days after receiving the dispute notice, either party may, by notice to the other party and the British Virgin Islands International Arbitration Centre, demand mediation under the mediation rules of the British Virgin Islands International Arbitration Centre. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" Mediation will take place in Road Town, Tortola, British Virgin Islands, and the language of the mediation will be English. Each party will bear its own costs in mediation and the parties will share equally between them all third-party mediation costs unless the parties agree otherwise in writing. "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" Each party will participate actively and constructively in mediation proceedings once started and will attend at least one joint meeting between the mediator and the parties. Any party may terminate mediation at any time after an initial meeting between the mediator and the parties. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"16.4"}]]],["textNode",{"text":"Arbitration "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" If the parties fail to settle a dispute through mediation, the parties will settle any unresolved dispute arising out of or relating to this agreement, or the breach of it, by arbitration administered by the British Virgin Islands International Arbitration Centre in accordance with the British Virgin Islands Arbitration Act of 2013 and any rules promulgated under it. The arbitrator, and not any court or agency, will have exclusive authority to resolve any dispute arising under or relating to the interpretation, applicability, enforceability, or formation of this agreement, including any claim that any part of this agreement is void or voidable. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" A single arbitrator will preside over the arbitration and issue a final award on all issues submitted to the arbitrator. The arbitrator may grant whatever relief would be available in a court, except that the arbitrator will not award punitive or exemplary damages, or damages otherwise limited or excluded in this agreement. The arbitrator’s award will be binding on the parties and may be entered as a judgment in any court of competent jurisdiction. "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" Arbitration will take place in Road Town, Tortola, British Virgin Islands, and the language of the arbitration will be English. Subject to section 16.7, the parties will bear equally the costs of arbitration, including the fees and expenses of the arbitrator, and each party will bear the costs associated with its case. "}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":" Unless required by law, neither a party nor an arbitrator will disclose the existence, content, or results of any arbitration under this agreement without the advance written consent of both parties. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"16.5"}]]],["textNode",{"text":"Injunctive Relief "}]]],["p",{},[["textNode",{"text":"The Affiliate acknowledges that breach by it of its obligations under this agreement could cause irreparable harm for which damages would be an inadequate remedy. If any breach occurs or is threatened, the Company may seek an injunction or a restraining order without posting a bond or other security."}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"16.6"}]]],["textNode",{"text":"Jurisdiction "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" If a party brings any proceeding seeking an injunction or a restraining order, that party will bring that proceeding only in the courts located in Road Town, Tortola, British Virgin Islands, and each party hereby submits to the exclusive jurisdiction and venue of those courts for purposes of any proceeding. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" Each party hereby waives any claim that any proceeding brought in accordance with section 16.6 (a) has been brought in an inconvenient forum or that the venue of that proceeding is improper. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"16.7"}]]],["textNode",{"text":"Recovery of Expenses "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" In any proceedings between the parties arising out of this agreement or relating to the subject matter of this agreement, the prevailing party will be entitled to recover from the other party, in addition to any other relief awarded, all expenses that the prevailing party incurs in those proceedings, including legal fees and expenses. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" For purposes of section 16.7(a), "}],["strong",{},[["textNode",{"text":"\"prevailing party\""}]]],["textNode",{"text":" means, for any proceedings, the party in whose favor an award is rendered, except that if in those proceedings the award finds in favor of one party on one or more claims or counterclaims and in favor of the other party on one or more other claims or counterclaims, neither party will be the prevailing party. If any proceedings are voluntarily dismissed or are dismissed as part of settlement of that dispute, neither party will be the prevailing party in those proceedings. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"16.8"}]]],["textNode",{"text":"Jury Trial Waiver "}]]],["p",{},[["textNode",{"text":" Each party hereby waives its right to a trial by jury in any proceedings arising out of or related to the subject matter of this agreement. Either party may enforce this waiver up to and including the first day of trial. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"16.9"}]]],["textNode",{"text":"Class Action Waiver "}]]],["p",{},[["textNode",{"text":" The parties will conduct all proceedings to resolve a dispute in any forum on an individual basis only. Neither the Affiliate nor the Company will seek to have any dispute heard as a class action or participate in any other proceeding in which either party acts or proposes to act in a representative capacity. The parties will not combine any proceeding with another without the advanced written consent of all parties to all affected proceedings. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"16.10"}]]],["textNode",{"text":"Limited Time to Bring Claims "}]]],["p",{},[["textNode",{"text":" A party will not bring a claim arising out of, or related to the subject matter of, this agreement more than one year after the cause of action first arose. Any claim brought after one year is barred. "}]]]]]]],["div",{"class":"sp-part","id":"part-17"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"17."}]]],["textNode",{"text":" Term and Termination "}]]],["div",{"class":"marg-left"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"17.1"}]]],["textNode",{"text":"Term "}]]],["p",{},[["textNode",{"text":" This agreement will begin on the Company’s approval of the Affiliate’s application and will end when terminated by either the Affiliate or the Company. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"17.2"}]]],["textNode",{"text":"Termination "}]]],["p",{},[["textNode",{"text":" Either party may terminate this agreement for any reason by giving the other party written notice of termination. The Affiliate’s breach of this agreement may result in the Affiliate’s immediate dismissal from the Program, with no obligation to the Company except to pay for earned commissions up to the point of termination unless this agreement provides otherwise. The Affiliate will forfeit all commissions due if the Company terminates the Affiliate from the Program because of the Affiliate’s fraudulent activity or for any breach of the program restrictions set out in section 3. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"17.3"}]]],["textNode",{"text":"Effect "}]]],["p",{},[["textNode",{"text":" On termination of this agreement: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" All licenses and rights granted under this agreement terminate and the Affiliate will promptly remove the licensed content from each affiliate site; "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" Unless otherwise provided in this agreement, the Company will pay all unpaid commissions due through the effective date of termination, except that the Company may withhold final payment of commissions for a reasonable time to make sure that all qualified referrals are valid; and "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" Neither party will be liable to the other for any damages sustained or arising out of, or alleged to have arisen out of, the termination, whether because of a party’s loss of present or prospective profits, commissions, or payments on anticipated services, or in connection with the establishment, development, or maintenance of the Affiliate’s business, or otherwise. "}]]]]],["p",{},[["textNode",{"text":"Termination will not affect the right of either party to receive or recover (1) damages sustained because of the breach of this agreement by the other party or (2) any payments owed or owing under the terms of this agreement, including payment earned through the date of termination."}]]]]]]],["div",{"class":"sp-part","id":"part-18"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18."}]]],["textNode",{"text":"General "}]]],["div",{"class":"marg-left"},[["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.1"}]]],["textNode",{"text":"Entire Agreement "}]]],["p",{},[["textNode",{"text":" This agreement constitutes the entire agreement of the parties concerning the subject matter. It supersedes all earlier written or oral discussions, negotiations, proposals, undertakings, understandings, and agreements between the parties concerning the transactions contemplated in this agreement. No party may use any of the earlier or contemporaneous negotiations, preliminary drafts, or previous versions of this agreement leading up to its signature and not stated in this agreement to construe or affect the validity of this agreement. Each party acknowledges that no party made or relied on a representation, inducement, or condition not stated in this agreement. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.2"}]]],["textNode",{"text":"Amendment "}]]],["p",{},[["textNode",{"text":" The Company may change the terms of this agreement on one or more occasions, except that changes will not apply to ongoing disputes or to disputes arising out of events occurring before the posted changes. The Company will notify the Affiliate through the affiliate portal of any changes to this agreement. Changes will become effective when posted in the affiliate portal. It is the Affiliate’s responsibility to check the affiliate portal periodically for changes to this agreement. If the Affiliate continues to participate in the Program after any change, the Company will consider the Affiliate’s continued participation as acceptance of the change unless the Affiliate notifies the Company in writing of the Affiliate’s disagreement no later than 15 days after the change. In the Affiliate’s written notice to the Company, the Affiliate must identify each change the Affiliate disagrees with and the nature of the Affiliate’s disagreement with each change identified. The Company will contact the Affiliate no later than seven days after receiving the Affiliate’s written notice to address the Affiliate’s issues and try to reach a mutually amicable resolution. If the Company is unable to resolve the Affiliate’s disagreement with the changes, the Affiliate’s sole remedy is to terminate this agreement. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.3"}]]],["textNode",{"text":"Assignment and Delegation "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["strong",{},[["textNode",{"text":"Assignments"}]]],["p",{},[["textNode",{"text":" The Company may assign its rights under this agreement without the Affiliate’s consent. The Affiliate will not assign any of its rights under this agreement, except with the Company’s advance written consent. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["strong",{},[["textNode",{"text":"Delegations"}]]],["p",{},[["textNode",{"text":"The Company may delegate any performance under this agreement without the Affiliate’s consent. The Affiliate will not delegate any performance under this agreement, except with the Company’s advance written consent. "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["strong",{},[["textNode",{"text":"Ramifications of Purported Assignment or Delegation"}]]],["p",{},[["textNode",{"text":" Any purported assignment of rights or delegation of performance in breach of this section 18.3 is void. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.4"}]]],["textNode",{"text":"Waivers "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["strong",{},[["textNode",{"text":"No Oral Waivers"}]]],["p",{},[["textNode",{"text":" The parties may waive any provision in this agreement only by a writing signed by the party or parties against whom the waiver is sought to be enforced. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["strong",{},[["textNode",{"text":"Effect of Failure, Delay, or Course of Dealing"}]]],["p",{},[["textNode",{"text":" No failure or delay "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" in exercising any right or remedy, or "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" in requiring the satisfaction of any condition, "}]]]]],["p",{},[["textNode",{"text":" under this agreement, and no act, omission, or course of dealing between the parties, operates as a waiver or estoppel of any right, remedy, or condition. "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["textNode",{"text":" Each Waiver for a Specific Purpose "}],["p",{},[["textNode",{"text":" A waiver made in writing on one occasion is effective only in that instance and only for the purpose stated. A waiver once given is not to be construed as a waiver on any future occasion or against any other person. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.5"}]]],["textNode",{"text":"Severability "}]]],["p",{},[["textNode",{"text":"The parties intend as follows:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" that if any provision of this agreement is held to be unenforceable, then that provision will be modified to the minimum extent necessary to make it enforceable, unless that modification is not permitted by law, in which case that provision will be disregarded; "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" that if modifying or disregarding the unenforceable provision would result in failure of an essential purpose of this agreement, the entire agreement will be held unenforceable; "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" that if an unenforceable provision is modified or disregarded in accordance with this section, then the rest of the agreement will remain in effect as written; and "}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":" that any unenforceable provision will remain as written in any circumstances other than those in which the provision is held to be unenforceable. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.6"}]]],["textNode",{"text":"Notices "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["strong",{},[["textNode",{"text":"Form"}]]],["p",{},[["textNode",{"text":" All notices and other communications between the parties will be in writing. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["strong",{},[["textNode",{"text":"Method"}]]],["p",{},[["textNode",{"text":" All notice will be given "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" by delivery in person; "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" by a nationally recognized next day courier service; "}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":" by first class, registered, or certified mail, postage prepaid; or "}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":" by electronic mail "}]]],["p",{},[["textNode",{"text":"to the following addresses (or any other address either party may specify in writing):"}]]],["ul",{"style":"float: left; width:30%"},[["li",{},[["textNode",{"text":"Company:"}]]],["li",{},[["textNode",{"text":"Centro Publisher Limited"}]]],["li",{},[["textNode",{"text":"Portcullis TrustNet Chambers"}]]],["li",{},[["textNode",{"text":"P.O. Box 3444"}]]],["li",{},[["textNode",{"text":"Road Town"}]]],["li",{},[["textNode",{"text":"Tortola VG1110"}]]],["li",{},[["textNode",{"text":"British Virgin Islands"}]]],["li",{},[["textNode",{"text":"affiliates@mcprofits.com"}]]]]],["ul",{},[["li",{},[["textNode",{"text":"Affiliate: "}]]],["li",{},[["textNode",{"text":"________________________________"}]]],["li",{},[["textNode",{"text":"________________________________"}]]],["li",{},[["textNode",{"text":"________________________________"}]]],["li",{},[["textNode",{"text":"________________________________"}]]],["li",{},[["textNode",{"text":"________________________________"}]]],["li",{},[["textNode",{"text":"________________________________"}]]],["li",{},[["textNode",{"text":"________________________________"}]]]]]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["strong",{},[["textNode",{"text":"Receipt"}]]],["p",{},[["textNode",{"text":" All notices will be effective on receipt by the party to which notice is given, or on the fifth day after mailing, whichever occurs first. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.7"}]]],["textNode",{"text":"Rights and Remedies Cumulative "}]]],["p",{},[["textNode",{"text":" A party’s exercise of any right or remedy under this agreement does not preclude the exercise of any other right or remedy. All of the parties’ rights and remedies are cumulative and are in addition to any other right or remedy set out in this agreement, any other agreement between the parties, or which may now or later exist at law or in equity, by statute or otherwise. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.8"}]]],["textNode",{"text":"Governing Law "}]]],["p",{},[["textNode",{"text":" The laws of the British Virgin Islands—without giving effect to its conflicts of law principles—govern all matters arising out of or relating to this agreement, including its validity, interpretation, construction, performance, and enforcement. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.9"}]]],["textNode",{"text":"Force Majeure "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" If a force majeure event prevents a party from complying with any one or more obligations under this agreement, that inability will not constitute a breach if (1) that party uses reasonable efforts to perform those obligations, (2) that party’s inability to perform those obligations is not due to its failure to (A) take reasonable measures to protect itself against events or circumstances of the same type as that force majeure event or (B) develop and keep a reasonable contingency plan to respond to events or circumstances of the same type as that force majeure event, and (3) that party complies with its obligations under section 18.9(c). "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" For purposes of this agreement, "}],["strong",{},[["textNode",{"text":"\"force majeure event\""}]]],["textNode",{"text":" means, for any party, any event or circumstance, whether or not foreseeable, that was not caused by that party (other than a strike or other labor unrest that affects only that party, an increase in prices or other change in general economic conditions, a change in law, or an event or circumstances that results in that party’s not having sufficient funds to comply with an obligation to pay money) and any consequences of that event or circumstance. "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" If a force majeure event occurs, the noncomplying party will promptly notify the other party of occurrence of that force majeure event, its effect on performance, and how long the noncomplying party expects it to last. From then on, the noncomplying party will update that information as reasonably necessary. During a force majeure event, the noncomplying party will use reasonable efforts to limit damages to the other party and to resume its performance under this agreement. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.10"}]]],["textNode",{"text":"No Third-Party Beneficiaries "}]]],["p",{},[["textNode",{"text":" This agreement does not, and the parties do not intend it to, confer any rights or remedies on any person other than the parties to this agreement. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.11"}]]],["textNode",{"text":"Relationship of the Parties "}]]],["p",{},[["textNode",{"text":" The parties intend that their relationship will be that of independent contractors and not business partners. This agreement does not, and the parties do not intend it to, create a partnership, joint venture, agency, franchise, or employment relationship between the parties and the parties expressly disclaim the existence of any of these relationships between them. Neither of the parties is the agent for the other, and neither party has the right to bind the other on any agreement with a third party. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.12"}]]],["textNode",{"text":"Successors and Assigns "}]]],["p",{},[["textNode",{"text":" This agreement binds and inures to the benefit of the parties and their respective successors and assigns. This section 18.12 does not address, directly or indirectly, whether a party may assign its rights or delegate its obligations under this agreement. Section 18.3 addresses these matters. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.13"}]]],["textNode",{"text":"Further Assurances "}]]],["p",{},[["textNode",{"text":" The parties will take any further actions, or sign any further documents, as may be necessary to implement and carry out the intent of this agreement. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.14"}]]],["textNode",{"text":"Counterparts "}]]],["p",{},[["textNode",{"text":"The parties may sign this agreement in any number of counterparts. The parties will consider each counterpart an original, and all counterparts, when taken together, will form the same agreement."}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.15"}]]],["textNode",{"text":"Signatures; Electronic Signatures "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" The parties may sign this agreement by fax or electronically instead of an original signature. The parties will consider fax or electronic signatures as original signatures that bind them to this agreement. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" The Affiliate acknowledges that any affirmation, assent, or agreement the Affiliate sends through the affiliate portal in response to a prompt binds the Affiliate. The Affiliate further acknowledges that when the Affiliate clicks on an \"I agree,\" \"I consent,\" or other similarly worded \"button\" or entry field using a mouse, keystroke, or other computer device, this action is the legal equivalent of the Affiliate’s handwritten signature and binds the Affiliate in the same way. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.16"}]]],["textNode",{"text":"Entity Authority "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" Each individual that signs this agreement for an entity states that the following facts are accurate: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" he or she has full authority to sign this agreement for that entity, and "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" that entity has taken all necessary actions to authorize the signing of this agreement. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" Each entity states that this agreement does not breach that entity’s articles, certificates, bylaws, or any other agreement or law that binds that entity. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.17"}]]],["textNode",{"text":"Voluntary Agreement "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" The parties have signed this agreement voluntarily and for valid reasons. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" The parties acknowledge that they "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" have carefully read this agreement, "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" discussed it with their attorneys or other advisors, "}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":" understand all of the terms, and "}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":" will comply with it. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" The parties have relied on the advice of their attorneys or other advisors about the terms of this agreement and waive any claim that the terms should be construed against the drafter. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.18"}]]],["textNode",{"text":"No Reliance "}]]],["p",{},[["textNode",{"text":" Each party acknowledges that in signing this agreement, that party does not rely and has not relied on any statement by the other party or its agents, except those statements contained in this agreement. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.19"}]]],["textNode",{"text":"Permission to Send Emails to Affiliate "}]]],["p",{},[["textNode",{"text":" The Affiliate hereby grants the Company permission to email notices, advertisements, and other communications to the Affiliate, including emails, advertisements, notices, and other communications containing adult oriented material, sexual content and language, and images of nudity unsuitable for minors. The Affiliate’s permission will continue until the Affiliate asks the Company to remove the Affiliate from the Company’s email list. "}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.20"}]]],["textNode",{"text":"Feedback "}]]],["p",{},[["textNode",{"text":"The Company encourages the Affiliate to give feedback about the Company or the Program. But the Company will not treat as confidential any suggestion or idea the Affiliate gives, and nothing in this agreement will restrict the Company’s right to use, profit from, disclose, publish, or otherwise exploit any feedback, without payment to the Affiliate."}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.21"}]]],["textNode",{"text":"English language "}]]],["p",{},[["textNode",{"text":"The parties have drafted this agreement in the English language and no translation into any other language will be used to interpret or construe this agreement. All services, support, notices, designations, specifications, and communications will be provided in the English language."}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.22"}]]],["textNode",{"text":"Survival "}]]],["p",{},[["textNode",{"text":"Any provision of this agreement that imposes an obligation after termination or expiration of this agreement will survive the termination or expiration of this agreement."}]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.23"}]]],["textNode",{"text":"Definitions "}]]],["p",{},[["textNode",{"text":" As used in this agreement, the following definitions—irrespective of capitalization or plurality—apply: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Affiliate\""}]]],["textNode",{"text":" means a person who markets the model offerings through an independent website in exchange for the payment of a commission based on sales of the model offerings, including the person applying for participation in the Program. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Affiliate code\""}]]],["textNode",{"text":" means a string of alphanumeric text that uniquely identifies an affiliate, advertising campaign, or other tracking metric. "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Affiliate site\""}]]],["textNode",{"text":" means one or more affiliate websites designated by the Affiliate to participate in the Program. "}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Business day\""}]]],["textNode",{"text":" means Monday through Friday, 9:00 a.m. to 5:00 p.m., Atlantic Standard Time (AST), excluding any official public holidays in the British Virgin Islands. "}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Chat traffic advertisement\""}]]],["textNode",{"text":" means a popup message displayed on a website to attract users to other commercial websites. "}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Company\""}]]],["textNode",{"text":" means Centro Publisher Limited, a British Virgin Islands corporation. "}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Intellectual property\""}]]],["textNode",{"text":" means inventions, concepts, techniques, plans, designs, methodologies, procedures, programs, approaches, ideas, know-how, computer software, technology, writings, graphics, other works of authorship, trademarks, service marks, logos, trade names, and (in the case of the last four) the goodwill associated with each. "}]]],["span",{"class":"num"},[["textNode",{"text":"(h)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Intellectual-property right\""}]]],["textNode",{"text":" means any intellectual-property right or industrial-property right existing by law at the relevant time anywhere in the world, including the right to sue for present or past infringement of it. \"Intellectual-property right\" includes: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" all rights (whether registered or unregistered) in trade secrets; confidential information; inventions, patents; trademarks, service marks, and trade names; Internet domain names; copyrights; designs; rights of publicity; and mask works; "}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":" any application then pending for an intellectual-property right, including an application for a patent or to register a copyright or trademark; "}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":" any right to file an application for an intellectual-property right; and "}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":" any right to claim priority for an application for an intellectual-property right. "}]]]]],["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Law\""}]]],["textNode",{"text":" means all provisions of a constitution, statute, regulation, ordinance, rule, judgment, order, or other obligation, requirement, or prohibition having legally binding effect at the relevant time. "}]]],["span",{"class":"num"},[["textNode",{"text":"(j)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Liability\""}]]],["textNode",{"text":" means liability in or for breach of contract, misrepresentation, restitution, or any other cause of action arising out of or related to the subject matter of this agreement. "}]]],["span",{"class":"num"},[["textNode",{"text":"(k)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Licensed material\""}]]],["textNode",{"text":" means any images, text, recordings, data, motion pictures, video clips, audio clips, advertising banners, links, computer script, domains, subdomains, service marks, trademarks, logos, or other promotional materials associated with the Program and the Model Sites that the Company makes available to the Affiliate on one or more occasions. Licensed material does not include the material on the Model Sites unless the Company expressly offers it to the Affiliate for the Program. "}]]],["span",{"class":"num"},[["textNode",{"text":"(l)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Model Sites\""}]]],["textNode",{"text":" means the websites created using ModelCentro’s proprietary platform and made available to the Affiliate through the Program. "}]]],["span",{"class":"num"},[["textNode",{"text":"(m)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Program\""}]]],["textNode",{"text":" means the ModelCentro™ Affiliate Program. "}]]],["span",{"class":"num"},[["textNode",{"text":"(n)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Qualified referral\""}]]],["textNode",{"text":" means a signup or purchase of a valid referral from the Affiliate that (1) does not result in a refund or reversal in the first 24 hours and (2) does not otherwise breach this agreement. "}]]],["span",{"class":"num"},[["textNode",{"text":"(o)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Referral link\""}]]],["textNode",{"text":" means any uniform resource locator (URL) placed on an affiliate site that has an affiliate code and links to the Model Sites or any other website related to the Program. "}]]],["span",{"class":"num"},[["textNode",{"text":"(p)"}]]],["p",{},[["strong",{},[["textNode",{"text":"\"Spam\""}]]],["textNode",{"text":" or "}],["strong",{},[["textNode",{"text":"\"spamming\""}]]],["textNode",{"text":" means using electronic messaging systems to send unsolicited bulk messages without the consent of the recipients, including (1) instant messaging spam; (2) Usenet newsgroup spam; (3) Web search engine spam; (4) spam in blogs; (5) wiki spam; (6) online classified ads spam; (7) mobile phone messaging spam; (8) spam in mobile applications; (9) Internet forum spam; (10) junk fax transmissions; (11) spam on Twitter; (12) spam on Facebook; (13) social networking spam; and (14) file sharing network spam. "}]]]]],["div",{"class":"sp-part-title"},[["span",{"class":"num"},[["textNode",{"text":"18.24"}]]],["textNode",{"text":"Usages "}]]],["p",{},[["textNode",{"text":" In this agreement, the following usages apply: "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" Actions permitted under this agreement may be taken at any time and on one or more occasions in the actor’s sole discretion. "}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" References to a statute will refer to the statute and any successor statute, and to all regulations promulgated under or implementing the statute or successor, as in effect at the relevant time. "}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" References to numbered sections in this agreement also refer to all included sections. For example, references to section 6 also refer to 6.1, 6.1(a), etc. "}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":" References to a governmental or quasi-governmental agency, authority, or instrumentality will also refer to a regulatory body that succeeds to the functions of the agency, authority, or instrumentality. "}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["textNode",{"text":" \"A or B\" means \"A or B or both.\" \"A, B, or C\" means \"one or more of A, B, and C.\" The same construction applies to longer strings. "}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["textNode",{"text":" \"Including\" means \"including, but not limited to.\" "}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["textNode",{"text":" Garner’s Modern American Usage (3d ed. 2009) applies to interpret usage, grammar, and syntax not otherwise addressed by this section. "}]]]]]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("home_registration", [["form",{"id":"signup-form"},[["div",{"class":"signup-form"},[["label",{"class":"input input-white"},[["input",{"type":"text","name":"userName","placeholder":"Username"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]],["textNode",{"text":" "}],["label",{"class":"input input-white"},[["input",{"type":"text","name":"firstName","placeholder":"First name"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]],["textNode",{"text":" "}],["label",{"class":"input input-white"},[["input",{"type":"text","name":"lastName","placeholder":"Last name"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]],["textNode",{"text":" "}],["label",{"class":"input input-white"},[["input",{"type":"text","name":"email","placeholder":"Email"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]],["textNode",{"text":" "}],["label",{"class":"input input-white"},[["input",{"type":"text","name":"affiliateUrl","placeholder":"Website URL"}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]],["textNode",{"text":" "}],["label",{"class":"checkbox"},[["input",{"type":"checkbox","name":"consent_tos"}],["textNode",{"text":" "}],["i"],["textNode",{"text":" By checking this box, I certify that I am at least 18-years old, have the capacity to enter into legally binding contracts, and have read and agree to the "}],["span",{"onclick":"event.stopPropagation();"},[["a",{"href":"/affiliate-agreement","target":"_blank","rel":"nofollow","draggable":"true"},[["textNode",{"text":" Affiliate Agreement"}]]]]],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]],["textNode",{"text":" "}],["label",{"class":"checkbox"},[["input",{"type":"checkbox","name":"consent_marketing"}],["textNode",{"text":" "}],["i"],["textNode",{"text":" I agree to receive e-mails with special offers, news and updates from ModelCentro family of products "}],["div",{"class":"error-icon"},[["div",{"class":"error-container"}]]]]],["p"],["button",{"type":"submit","class":"btn btn-big btn-mcolor btn-submit button-with-spinner"},[["textNode",{"text":"Submit"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_promo_auth", [["header",{"id":"promo-header","class":"promo-header"},[["div",{"class":"header-container"},[["div",{"id":"notification-container"}],["div",{"class":"mc-through-notifications-container"}]]]]],["div",{"id":"sitepage-container","class":"sitepage-container auth-page-container"}],["footer",{"id":"promo-footer","class":"promo-footer"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_footer", [["div",{"class":"footer-wrapper"},[["div",{"class":"copyright"},[["p",{},[["textNode",{"text":"MC Profits "}],["span",{},[],[["empty","__text",true,[{"name":"formatCurrentDate","params":["%Y"]}]]]],["textNode",{"text":" &copy; All rights reserved."}]]],["p",{},[["textNode",{"text":"Powered by "}],["a",{"href":"http://modelcentro.com","target":"_blank"},[["textNode",{"text":"ModelCentro"}]]],["textNode",{"text":" team"}]]]]],["div",{"class":"links"},[["div",{"class":"menu"},[["a",{"class":"menu-item menu-link","data-name":"home","href":"/"},[["textNode",{"text":"Home"}]]],["textNode",{"text":" "}],["a",{"class":"menu-item menu-link","data-name":"features","href":"/features"},[["textNode",{"text":"Tools & Features"}]]],["textNode",{"text":" "}],["a",{"class":"menu-item menu-link","data-name":"our-sites","href":"/our-sites"},[["textNode",{"text":"Our sites"}]]],["textNode",{"text":" "}],["a",{"class":"menu-item menu-link","data-name":"promo-faq","href":"/faq"},[["textNode",{"text":"FAQ"}]]]]],["div",{"class":"social"},[["a",{"href":"https://twitter.com/mc_profits","target":"_blank","class":"social-item twitter"}],["textNode",{"text":" "}],["a",{"href":"https://www.facebook.com/MCProfits-945478358873933/?ref=hl","target":"_blank","class":"social-item facebook"}],["textNode",{"text":" "}],["a",{"href":"https://instagram.com/mcprofits","target":"_blank","class":"social-item instagram"}]]]]],["div",{"class":"info-links"},[["a",{"class":"info-link","href":"/terms-of-use"},[["textNode",{"text":"Terms of Use"}]]],["textNode",{"text":" "}],["a",{"class":"info-link","href":"/privacy-policy"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":" "}],["a",{"class":"info-link","href":"/cookie-policy"},[["textNode",{"text":"Cookie Policy"}]]],["textNode",{"text":" "}],["a",{"class":"info-link","href":"/cookie-table"},[["textNode",{"text":"Cookie Table"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_header", [["div",{"class":"header-wrapper"},[["div",{"class":"menu-action"},[["a",{"id":"mcprofits-logo","class":"logo","data-name":"home","href":"/"}],["div",{"class":"menu-open"}],["div",{"class":"menu-close"}]]],["nav",{"class":"menu"},[["div",{"class":"menu-item menu-link","data-name":"home"},[["a",{"href":"/"},[["textNode",{"text":"home"}]]]]],["div",{"class":"menu-item menu-link","data-name":"features"},[["a",{"href":"/features"},[["textNode",{"text":"features"}]]]]],["div",{"class":"menu-item menu-link","data-name":"our-sites"},[["a",{"href":"/our-sites"},[["textNode",{"text":"our sites"}]]]]],["div",{"class":"menu-item menu-link","data-name":"promo-tools"},[["a",{"href":"/promo-tools"},[["textNode",{"text":"promo tools"}]]]]],["div",{"class":"menu-item menu-link","data-name":"promo-faq"},[["a",{"href":"/faq"},[["textNode",{"text":"faq"}]]]]]]],["nav",{"class":"action"},[["div",{"class":"action-item menu-link","data-name":"registration"},[["a",{"href":"/registration","class":"btn btn-default btn-signup"},[["textNode",{"text":"signup"}]]]]],["div",{"class":"action-item menu-link dnone-i","data-name":"subscribe"},[["a",{"class":"btn btn-default btn-signup"},[["textNode",{"text":"newsletter"}]]]]],["div",{"class":"action-item separate-page"},[["a",{"href":"/login"},[["textNode",{"text":"login"}]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_iframe", [["div",{"id":"root"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_promo", [["header",{"id":"promo-header","class":"promo-header"},[["div",{"class":"header-container"},[["div",{"id":"notification-container"}],["div",{"class":"mc-through-notifications-container"}]]]]],["div",{"id":"sitepage-container","class":"sitepage-container"}],["footer",{"id":"promo-footer","class":"promo-footer"}]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("site", [["html",{},[["head",{},[["title",{},[["span",{},[],[["ogTitle","__text",true,[],"env"]]]]],["meta",{"charset":"utf-8"}],["meta",{"name":"viewport","content":"width=device-width, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"}],["meta",{"name":"description","content":""},[],[["ogDescription","content",true,[],"env"]]],["meta",{"property":"og:title","content":""},[],[["ogTitle","content",true,[],"env"]]],["meta",{"property":"og:url","content":""},[],[["ogUrl","content",true,[],"env"]]],["meta",{"property":"og:image","content":""},[],[["ogImage","content",true,[],"env"]]],["meta",{"property":"og:description","content":""},[],[["ogDescription","content",true,[],"env"]]],["link",{"rel":"icon","href":"require('../images/favicon.ico?skip-fox')","type":"image/x-icon"}],["meta",{"name":"google-site-verification","content":"9BYXwpEr0_IB7s5DzDwiFuLsSwaTSBc7E04EfLh9Z28"}]]],["body"]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("affiliate_program_agreement", [["div",{"class":"affiliate-program-agreement simple-page"},[["h1",{"class":"apa-title padd-left"},[["span",{},[["textNode",{"text":"ModelCentro"}],["sup",{},[["textNode",{"text":"TM"}]]]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"Affiliate Agreement"}]]],["div",{"class":"sp-up-time"},[["textNode",{"text":"Last Updated: May 15, 2018"}]]]]],["div",{"class":"sp-main"},[["div",{"class":"sp-col sp-left"},[["div",{"class":"sp-part","id":"part-warning","style":"border: 1px solid #000; margin: 40px 20px 0 40px; padding: 10px 30px 0 0;"},[["p",{"style":"color:#f00"},[["strong",{},[["textNode",{"text":"This agreement contains disclaimers of warranties, limitations on liability, releases, a class-action waiver, and the requirement to mediate and arbitrate all claims that may arise under this agreement. These provisions are an essential basis of this agreement."}]]]]],["p",{},[["strong",{},[["textNode",{"text":"This is a legally binding agreement between you and the owner and operator of ModelCentro.com, including any successor or affiliated company or entity. You must be at least 18-years old and have reached the age of majority and legal consent in the jurisdiction in which you live or reside to agree to this agreement. By clicking on the words “I agree,” “Submit,” or similar syntax, you are electronically signing this agreement, and therefore agree to be bound by and acknowledge your complete acceptance of all the express and incorporated terms of this agreement. If you do not agree to this agreement or do not meet the age requirements, you must not register."}]]]]],["p",{},[["strong",{"style":"color:#f00"},[["textNode",{"text":"No Prostitution or Sex Trafficking."}]]],["textNode",{"text":" The promotion of prostitution, escort services, personal companions, etc. are contrary to the purposes of ModelCentro.com and will not be tolerated in any fashion. Promoting or offering prostitution or escort services on the ModelCentro.com website is strictly prohibited. Sites or profiles that are used for the promotion of prostitution or escort services in any way will be immediately disabled. This includes the use of hyperlinks to external websites promoting prostitution, URLs promoting prostitution, and any other activity that ModelCentro.com considers as promotions or offers."}]]]]],["div",{"class":"sp-part","id":"part-start"},[["p",{},[["textNode",{"text":"This affiliate marketing agreement is between "}],["strong",{},[["textNode",{"text":"Centro Publisher Limited"}]]],["textNode",{"text":", a British Virgin Islands company (the "}],["strong",{},[["textNode",{"text":"“Company”"}]]],["textNode",{"text":"), and you, the individual or entity signing up to become an affiliate (the "}],["strong",{},[["textNode",{"text":"“Affiliate”"}]]],["textNode",{"text":")."}]]],["p",{},[["textNode",{"text":"The Company has developed the ModelCentro affiliate program (the "}],["strong",{},[["textNode",{"text":"“Program”"}]]],["textNode",{"text":") that allows participating affiliates to earn commissions in connection with their referral of end-user consumers (the "}],["strong",{},[["textNode",{"text":"“Consumers”"}]]],["textNode",{"text":") interested in purchasing products, services, VIP access, memberships, and other material (collectively, the "}],["strong",{},[["textNode",{"text":"“Model Offerings”"}]]],["textNode",{"text":") for a fee from one or more models (the "}],["strong",{},[["textNode",{"text":"“Models”"}]]],["textNode",{"text":") that operator websites or stores using ModelCentro’s proprietary platform and were made available to the Affiliate through the Program (collectively, the "}],["strong",{},[["textNode",{"text":"“Model Sites”"}]]],["textNode",{"text":")."}]]],["p",{},[["textNode",{"text":"The Affiliate wants to participate in the Program through one or more affiliate sites (collectively, the "}],["strong",{},[["textNode",{"text":"“Affiliate Sites”"}]]],["textNode",{"text":")."}]]],["p",{},[["textNode",{"text":"The parties therefore agree as follows:"}]]]]],["div",{"class":"sp-part","id":"part-1"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"1."}]]],["textNode",{"text":" Enrollment in the Program "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"1.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"Eligibility."}]]],["textNode",{"text":"The Affiliate must be at least 18-years old and the age of majority (the age at which the Affiliate can legally consent and enter into contracts) in the Affiliate’s place of residence to enroll in the Program. If the Affiliate is an entity, all individuals involved in the entity must be at least 18-years old and the age of majority in their place of residence."}]]],["span",{"class":"num"},[["textNode",{"text":"1.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Registration."}]]],["textNode",{"text":" To begin the enrollment process, the Affiliate must submit a completed Program application available online at "}],["a",{"href":"https://affiliates.modelcentro.com/","target":"_blank","rel":"nofollow"},[["textNode",{"text":"affiliates.modelcentro.com."}]]]]],["span",{"class":"num"},[["textNode",{"text":"1.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"Evaluation of Application."}]]],["textNode",{"text":" The Company will evaluate the Affiliate’s application and will notify the Affiliate of its acceptance or rejection. Among other reasons for rejection, the Company may reject the Affiliate’s application if it determines, in its sole discretion, that one or more affiliate sites are unsuitable for the Program. Unsuitable affiliate sites include those that:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"promote or facilitate the prostitution of another person or otherwise promote escort services;"}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"promote child pornography;"}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"promote obscene materials;"}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":"promote violence;"}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["textNode",{"text":"promote discrimination based on race, sex, religion, nationality, disability, sexual orientation, or age;"}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["textNode",{"text":"promote illegal activities; or"}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["textNode",{"text":"violate or infringe intellectual-property rights."}]]]]],["span",{"class":"num"},[["textNode",{"text":"1.4"}]]],["p",{},[["strong",{},[["textNode",{"text":"Reapplication."}]]],["textNode",{"text":" If the Company rejects the Affiliate’s application, the Affiliate may reapply to the Program at any time."}]]]]]]],["div",{"class":"sp-part","id":"part-2"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"2."}]]],["textNode",{"text":" License "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"2.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"Grant."}]]],["textNode",{"text":" The Company hereby grants the Affiliate a revocable, nonexclusive, nontransferable, nonsublicensable, worldwide license to use, reproduce, transmit, publicly display, and publicly perform the materials provided by the Company or one or more Models to the Affiliate (collectively, the "}],["strong",{},[["textNode",{"text":"“Licensed Materials”"}]]],["textNode",{"text":") on one or more Affiliate Sites to market, advertise, and promote the Models’ online services and content solely in connection with the Program. This license includes the right to use the Company’s or the Models’ service marks, trademarks, logos, the video content provided by the Company and its partners, and any other Licensed Materials provided by the Company or one or more Models for the Affiliate’s use."}]]],["span",{"class":"num"},[["textNode",{"text":"2.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Limitations."}]]],["textNode",{"text":" The following limitations apply to the Affiliate’s use of the Licensed Materials:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Use Restrictions."}]]],["textNode",{"text":" All unauthorized access or duplication of the Licensed Materials is a material breach of this agreement and an infringement of the Company’s, one or more Models’, and potentially others’ trademarks, copyrights, or other rights, including privacy and publicity rights."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Other Prohibited Actions. "}]]],["textNode",{"text":"Unless the Company expressly authorizes in writing, the Affiliate will not:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":"Modify, translate, reverse engineer, decompile, or disassemble the Licensed Materials;"}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":"Create derivative works based on the Licensed Materials;"}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":"Rent, lease, or transfer any rights in the Licensed Materials;"}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":"Remove any proprietary notices or labels on the Licensed Materials; or"}]]],["span",{"class":"num"},[["textNode",{"text":"(v)"}]]],["p",{},[["textNode",{"text":"Make any other unauthorized use of the Licensed Materials."}]]]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Ownership of Licensed Materials and Intellectual Property."}]]],["textNode",{"text":" Except for material in the public domain or licensed to the Company, the Company owns the Licensed Materials. British Virgin Islands law, international treaties, and other laws and regulations protect the Licensed Materials. The Company retains all rights in the Licensed Materials."}]]]]],["span",{"class":"num"},[["textNode",{"text":"2.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"No License for Other Material."}]]],["textNode",{"text":" The Company does not grant a license for any other material published on the Model Sites or any other website unless the Company or the applicable Model makes that material available to the Affiliate through the Program and the Company or the applicable Model designates it as Licensed Materials."}]]],["span",{"class":"num"},[["textNode",{"text":"2.4"}]]],["p",{},[["strong",{},[["textNode",{"text":"Reservation of Rights."}]]],["textNode",{"text":" Except as expressly granted in this agreement, the Company does not grant any other rights to the Affiliate. The Company reserves all rights to select, alter, add, or remove all Licensed Materials used for the Program."}]]],["span",{"class":"num"},[["textNode",{"text":"2.5"}]]],["p",{},[["strong",{},[["textNode",{"text":"Termination or Withdrawal."}]]],["textNode",{"text":" On termination of this agreement or the Affiliate’s withdrawal from the Program, the Affiliate’s license to download and use the Licensed Materials automatically terminates and all rights automatically revert to the Company. At that time, the Affiliate will promptly delete all copies of the Licensed Materials that might reside on any computer system, storage device, server, or website owned by the Affiliate or under its control."}]]]]]]],["div",{"class":"sp-part","id":"part-3"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"3."}]]],["textNode",{"text":" Promotional Links. "}]]],["p",{},[["textNode",{"text":"The Affiliate may receive—or the Company may make available to the Affiliate—banner, button, or text links one or more Model Sites (the "}],["strong",{},[["textNode",{"text":"“Promotional Links”"}]]],["textNode",{"text":"). The Promotional Links may contain logos or identifying marks. The Affiliate’s use of the Promotional Links will at all times be subject to this agreement. The Affiliate may display the Promotional Links in accordance with its own site design, on condition that the Affiliate does not alter, modify, or expand the Promotional Links in any way without the Company’s advance written consent."}]]]]],["div",{"class":"sp-part","id":"part-4"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"4."}]]],["textNode",{"text":" Program Requirements. "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"4.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"Compliance with Law."}]]],["textNode",{"text":" The Affiliate will comply with all applicable laws and regulations."}]]],["span",{"class":"num"},[["textNode",{"text":"4.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Prohibited Conduct."}]]],["textNode",{"text":" The Affiliate is responsible for all content posted on the Affiliate Sites. The Affiliate will not engage in the following prohibited conduct:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Depictions of Minors."}]]],["textNode",{"text":" The Affiliate will not disseminate, post on the Affiliate Sites, or provide links to any material that involves depictions of nudity or sexuality by an age inappropriate-appearing model (that is, a model who looks younger than 18-years old) or by a model who is portrayed or made to appear as a person under 18-years old by virtue of the script, make-up, costuming, demeanor, setting, etc."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Illegal or Objectionable Content. "}]]],["textNode",{"text":"The Affiliate will not disseminate, post on the Affiliate Sites, or provide links to any obscene material, including any material depicting child pornography, incest, scat, defecation, feces, urination, menstruation, genital mutilation, necrophilia, bestiality, sadomasochistic abuse or bondage, actual or simulated rape, sexual violence, actual violence inflicted on individuals by themselves or others, torture, or death. Nor will the Affiliate disseminate, post on the Affiliate Sites, or provide links to any content or materials of the following nature: warez, distribution of pirated content, prostitution or escort services, human trafficking, gambling, or controlled substances (including related paraphernalia)."}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Spam."}]]],["textNode",{"text":" The Affiliate will not disseminate spam in connection with the Program. The Company imposes a strict, no-spam policy for participants in the Program. What is spamming will evolve over time as new technologies and methodologies emerge for spammers to find new ways to abuse the Program. Some of the facts that the Company takes into account when determining what is spamming include the following: "}],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":"If the Affiliate has violated a U.S. federal or state anti-spamming law, including any part of the CAN-SPAM Act of 2003 ("}],["a",{"href":"https://www.law.cornell.edu/uscode/text/15/chapter-103","rel":"nofollow","target":"_blank"},[["textNode",{"text":"15 U.S.C. §§ 7701–7713"}]]],["textNode",{"text":") or any of the federal regulations promulgated under the CAN-SPAM Act ("}],["a",{"href":"https://www.law.cornell.edu/cfr/text/16/part-316","target":"_blank","rel":"nofollow"},[["textNode",{"text":"16 C.F.R. Part 316"}]]],["textNode",{"text":");"}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":"If the Affiliate has violated another country’s anti-spamming law;"}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":"If the Affiliate has violated any third-party anti-spamming policy;"}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":"If the Affiliate has sent unsolicited bulk messages to nonconsenting recipients;"}]]],["span",{"class":"num"},[["textNode",{"text":"(v)"}]]],["p",{},[["textNode",{"text":"If the Affiliate has misleading or false information contained in its messages, subject line, or message headers;"}]]],["span",{"class":"num"},[["textNode",{"text":"(vi)"}]]],["p",{},[["textNode",{"text":"If the Affiliate uses automated means to collect, transmit, or sell email addresses of others;"}]]],["span",{"class":"num"},[["textNode",{"text":"(vii)"}]]],["p",{},[["textNode",{"text":"If the Affiliate uses a third-party website or program to automatically generate and send messages or content;"}]]],["span",{"class":"num"},[["textNode",{"text":"(viii)"}]]],["p",{},[["textNode",{"text":"If the primary purpose of the Affiliate’s message is commercial in nature; and"}]]],["span",{"class":"num"},[["textNode",{"text":"(ix)"}]]],["p",{},[["textNode",{"text":"The number of spam or abuse complaints that have been lodged against the Affiliate."}]]]]]]],["p",{},[["textNode",{"text":"No one factor is controlling, and the Company will look to the particular circumstances of each case to determine what is spamming. When in doubt, don’t do it—you spam, you’re out."}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Fraudulent and Deceptive Trade Practices."}]]],["textNode",{"text":" The Affiliate will not engage in any fraudulent, deceptive, or unfair transactions or trade practices. The Affiliate will comply with the Federal Trade Commission (FTC) statutes and regulations and all related rules, policies, and advisory opinions in advertising, marketing, and promoting the Program and the Program Site, including the Restore Online Shoppers’ Confidence Act ("}],["a",{"href":"https://www.law.cornell.edu/uscode/text/15/chapter-110","target":"blank","rel":"nofollow"},[["textNode",{"text":"15 U.S.C. §§ 8401–8405"}]]],["textNode",{"text":"); Guides Against Deceptive Pricing ("}],["a",{"href":"https://www.law.cornell.edu/cfr/text/16/part-233","target":"blank","rel":"nofollow"},[["textNode",{"text":" 16 C.F.R. Part 233"}]]],["textNode",{"text":"); Guides Against Bait Advertising ("}],["a",{"target":"blank","rel":"nofollow","href":"https://www.law.cornell.edu/cfr/text/16/part-238"},[["textNode",{"text":" 16 C.F.R. Part 238"}]]],["textNode",{"text":"); Guides Concerning Use of the Word “Free” and Similar Representations ("}],["a",{"target":"blank","rel":"nofollow","href":"https://www.law.cornell.edu/cfr/text/16/part-251"},[["textNode",{"text":" 16 C.F.R. Part 251"}]]],["textNode",{"text":"); Guides Concerning Use of Endorsements and Testimonials in Advertising ("}],["a",{"target":"blank","rel":"nofollow","href":"https://www.law.cornell.edu/cfr/text/16/part-255"},[["textNode",{"text":" 16 C.F.R. Part 255"}]]],["textNode",{"text":"); Use of Pre-Notification Negative Option Plans ("}],["a",{"target":"blank","rel":"nofollow","href":"https://www.law.cornell.edu/cfr/text/16/part-425"},[["textNode",{"text":" 16 C.F.R. Part 425"}]]],["textNode",{"text":"); "}],["a",{"target":"blank","rel":"nofollow","href":"https://www.ftc.gov/bcp/policystmt/ad-decept.htm"}],["textNode",{"text":" FTC Policy Statement on Deception; "}],["a",{"target":"blank","rel":"nofollow","href":"https://www.ftc.gov/bcp/guides/ad3subst.htm"}],["textNode",{"text":"FTC Policy Statement on Advertising Substantiation; "}],["a",{"target":"blank","rel":"nofollow","href":"https://www.ftc.gov/bcp/policystmt/ad-unfair.htm"},[["textNode",{"text":"FTC Policy Statement on Unfairness"}]]],["textNode",{"text":"; and "}],["a",{"target":"blank","rel":"nofollow","href":"https://www.ftc.gov/tips-advice/business-center/guidance/com-disclosures-how-make-effective-disclosures-digital"},[["textNode",{"text":"FTC .com Disclosures: How to Make Effective Disclosures in Digital Advertising."}]]]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Defamation and Related Conduct."}]]],["textNode",{"text":" The Affiliate will not publish content on the Affiliate Sites that is defamatory, libelous, threatening, abusive, hateful, derogatory, disparaging, or otherwise injurious to any person or the reputation of anyone."}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["strong",{},[["textNode",{"text":"United States Federal Record Keeping and Labeling Requirements."}]]],["textNode",{"text":" The Affiliate and the Affiliate Sites will comply with the federal record keeping and labeling requirements codified at 18 U.S.C. §§ "}],["a",{"href":"https://www.law.cornell.edu/uscode/text/18/2257","target":"_blank","rel":"nofollow"},[["textNode",{"text":"2257"}]]],["textNode",{"text":"– "}],["a",{"href":"https://www.law.cornell.edu/uscode/text/18/2257a","target":"_blank","rel":"nofollow"},[["textNode",{"text":"2257A"}]]],["textNode",{"text":" and the implementing regulations codified at "}],["a",{"href":"https://www.law.cornell.edu/cfr/text/28/part-75","target":"_blank","rel":"nofollow"},[["textNode",{"text":"28 C.F.R. Part 75"}]]],["textNode",{"text":" (collectively, the "}],["strong",{},[["textNode",{"text":"“§ 2257 Requirements”"}]]],["textNode",{"text":"). The Affiliate will act as the required “Custodian of Records” under the § 2257 Requirements for all content depicting actual sexually explicit conduct of an actual human being that may be used to promote or market the Program Site regardless of who produced the content. The Affiliate will post a 2257 statement on the Affiliate Sites in the manner and locations required by the § 2257 Requirements."}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Intellectual Property Rights."}]]],["textNode",{"text":" The Affiliate will not publish content on the Affiliate Sites that infringes the intellectual-property rights or other legal rights of any person, including copyright, patent, trademark, service mark, trade secret, trade dress, right of privacy, right of publicity, moral right, and any other proprietary right."}]]],["span",{"class":"num"},[["textNode",{"text":"(h)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Cybersquatting or Typosquatting."}]]],["textNode",{"text":" The Affiliate will not use or register or try to use or register any domain name (including second-level, third-level, fourth-level, fifth-level, and so on), subdomain name, or directory that is identical or confusingly similar to a trademark or service mark in which the Company, one or more Models, or another person has intellectual property or other legal rights, including MODELCENTRO."}]]],["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Paid Search Advertising Schemes."}]]],["textNode",{"text":" The Affiliate will not bid on or purchase any online paid advertising schemes that incorporate or are confusingly similar to the Company’s or one or more Models’ trademarks, service marks, domain names, or URLs, including MODELCENTRO. The prohibited advertising schemes include pay-per-click models, sponsored links, search engine keywords, AdWords, or similar advertising schemes."}]]],["span",{"class":"num"},[["textNode",{"text":"(j)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Metatags."}]]],["textNode",{"text":" The Affiliate will not use any false, misleading, or infringing metatags tied to the Affiliate Sites. In addition, the Affiliate will not use any metatags that would imply or suggest that underage or illegal content may be found on the Affiliate Sites or one or more Model Sites."}]]],["span",{"class":"num"},[["textNode",{"text":"(k)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Unethical Marketing Practices."}]]],["textNode",{"text":" The Affiliate will not try to intercept, direct, redirect, divert, or usurp traffic (including through user-installed software) from, or divert fees from, any other participant in the Program. The Affiliate will not directly or indirectly offer any person any consideration or incentive (including payment of money or granting of any discounts or other benefits) to go to one or more Model Sites using the Promotional Links on the Affiliate Sites; nor will the Affiliate require any person to join or buy products from one or more Model Sites as a prerequisite to accessing other products or services. The Affiliate will not try to directly or indirectly obtain usernames or passwords from Consumers, including Consumers whom the Affiliate referred to one or more Model Sites."}]]],["span",{"class":"num"},[["textNode",{"text":"(l)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Misrepresentation of Relationship."}]]],["textNode",{"text":" The Affiliate will not misrepresent the Affiliate’s contractual relationship with the Company or one or more Models or imply that any relationship exists with the Company or one or more Models except as expressly provided in this agreement. For example, the Affiliate will not publish any statement indicating that the Company or one or more Models supports, endorses, or contributes to the Affiliate Sites except as expressly provided in this agreement."}]]],["span",{"class":"num"},[["textNode",{"text":"(m)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Unauthorized Access."}]]],["textNode",{"text":" The Affiliate’s unauthorized access or duplication of any content that the Affiliate obtains directly or indirectly through its participation in the Program is a material breach of this agreement."}]]],["span",{"class":"num"},[["textNode",{"text":"(n)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Malicious Code, Viruses, Etc."}]]],["textNode",{"text":" The Affiliate will not use or offer for download any material that contains a virus malware, or malicious code, for example, a trojan horse, that has the potential of causing disruption or damage to any computer system, network, or server. The Affiliate will be liable to the Company for all damage caused by any program of this nature."}]]],["span",{"class":"num"},[["textNode",{"text":"(o)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Links to and Content of Others."}]]],["textNode",{"text":" The Affiliate will not use the Licensed Materials, the Company marks, or any other of the Company’s intellectual property to promote or link to any other website. No links to other sites are permitted on pages where the licensed content is used."}]]],["span",{"class":"num"},[["textNode",{"text":"(p)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Use of Unapproved Promotional Materials."}]]],["textNode",{"text":" The Affiliate will only use the Licensed Materials provided by the Company or one or more Models unless the Company or the applicable Model states otherwise in writing. The Affiliate will not use any other material, whether created by the Affiliate or others, to promote the Program or one or more Model Sites unless the Company or the applicable Model states otherwise in writing."}]]],["span",{"class":"num"},[["textNode",{"text":"(q)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Abuse of Promotional Links. "}]]],["textNode",{"text":"The Affiliate will not abuse the Promotional Links, including by using the Promotional Links to purchase memberships or products on one or more Model Sites; sharing, posting, or spamming the Promotional Links in any area of the Model Sites; and recruiting existing Customers to create a new user account via the Promotional Links."}]]]]],["span",{"class":"num"},[["textNode",{"text":"4.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"Breach of Program Requirements."}]]],["textNode",{"text":" The Company may withhold payments or terminate this agreement if the Affiliate breaches or otherwise violates this section 4."}]]]]]]],["div",{"class":"sp-part","id":"part-5"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"5."}]]],["textNode",{"text":" Affiliate’s Duty to Notify."}]]],["p",{},[["textNode",{"text":"The Affiliate will promptly notify the Company (a) of all URLs where the Affiliate will use the Licensed Materials or otherwise promote one or more Model Sites; (b) whenever there are inquiries or concerns by any person regarding any questionable activities; or (c) if the Affiliate receives any inquiries or requests for information regarding any of the following: (i) prostitution; (ii) obscenity; (iii) child pornography or depictions of nudity or sexuality by minors; (iv) spam complaints; (v) infringement of intellectual-property rights; (vi) deceptive trade or unfair business practices; (vii) misleading search terms; (viii) invasion of publicity or privacy issues; (ix) fraudulent activities, including credit card fraud; and (x) any civil or criminal investigation or subpoena that pertains to the Affiliate unless applicable law prohibits the Affiliate from notifying the Company. The Affiliate’s failure to comply with section 5 will constitute a material breach of this agreement. The Affiliate will be responsible for any damages the Company incurs based on the Affiliate’s failure to notify the Company as required by this section 5."}]]]]],["div",{"class":"sp-part","id":"part-6"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"6."}]]],["textNode",{"text":" Compensation. "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"6.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"Commissions."}]]],["textNode",{"text":" The Company will pay the Affiliate commissions according to the specific payout terms made available to the Affiliate by the Company when the Affiliate registers for participation in the Program. The Commissions will be based on a percentage of the revenue derived from the following:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"fees that are paid by referred Consumers for membership to the applicable Model Site; plus"}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"purchase price paid by referred Consumers for Model products purchased through the applicable Model Site (collectively, the "}],["strong",{},[["textNode",{"text":"“Model Site Revenues”"}]]],["textNode",{"text":"); less"}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"a transaction fee that is deducted before the calculation of the Model Site Revenue."}]]]]],["p",{},[["textNode",{"text":"The Affiliate may track commissions through the affiliate portal located at "}],["a",{"target":"blank","rel":"nofollow","href":"https://affiliates.modelcentro.com"},[["textNode",{"text":"affiliates.modelcentro.com"}]]],["textNode",{"text":"."}]]],["span",{"class":"num"},[["textNode",{"text":"6.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Payout Requirements"}]]]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Minimum Payout Requirement."}]]],["textNode",{"text":" The information about minimum payouts is made available through the Program."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Payout Periods."}]]],["textNode",{"text":" Subject to the minimum payout requirement for the payment method selected, the Company will disburse payouts in accordance with the schedule stated in the affiliate portal. The Company will debit payouts for cancelled subscriptions. The Company may change the payout pay periods from time to time."}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Processing Fees."}]]],["textNode",{"text":" The Company is not responsible for any third-party fees charged by banks or financial institutions used to receive commissions. The Company may deduct a processing fee if the payment method selected carries a processing fee."}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Account Inactivity; Inactive Account Maintenance Fees"}]]]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":"To receive any commissions under this agreement, the Affiliate’s account must be active and in compliance with this agreement. If the Affiliate does not actively generate qualifying referrals to a Model Site for 90-consecutive days, the Affiliate’s account may, at the Company’s sole discretion, no longer be considered active and instead may be designated as inactive."}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":"If the Affiliate has not earned any commissions for 180-consecutive days, the Company may charge the Affiliate an inactive account maintenance fee that the Company will deduct from the Affiliate’s unpaid accrued commissions. The inactive account maintenance fee will be the lesser of $10 USD and the amount of unpaid accrued commissions in the Affiliate’s account."}]]]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Commission Forfeiture."}]]],["textNode",{"text":" If the Company is unable to pay the Affiliate for 180-consecutive days and the Company cannot otherwise contact the Affiliate during this period, the Company will consider all unpaid accrued commissions forfeited to the Company without further notice."}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Taxes."}]]],["textNode",{"text":" The Affiliate will pay all taxes attributable to commissions earned under this agreement. From time to time, the Company may request the Affiliate to provide tax information depending on the jurisdiction in which the Affiliate resides or is organized. The Affiliate will promptly comply with any request by the Company for tax information. If the Company requests tax information from the Affiliate and the Affiliate fails to provide it to the Company, the Company may withhold payment from the Affiliate until the Affiliate provides this information or otherwise satisfies the Company that the Affiliate is not a person from whom the Company is required to obtain tax information."}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Disputes."}]]],["textNode",{"text":" If the Affiliate disputes a payment or the calculation of a commission, the Affiliate will notify the Company in writing of the dispute or discrepancy no later than 30 days after the end of the pay period in which the disputed payment occurred. The Affiliate will include in its written notice a detailed statement describing the nature and amount of the dispute and all supporting evidence. The Affiliate will cooperate fully and in good faith with the Company to promptly address and try to resolve the dispute. If the Affiliate fails to timely notify the Company in writing, the parties will consider the Company’s determination correct and binding on the Affiliate, and the Affiliate will not dispute the Company’s determination."}]]]]],["span",{"class":"num"},[["textNode",{"text":"6.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"Payout Limitations"}]]]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"The Company will pay the Affiliate for qualified purchases only, that is the Company will only pay the Affiliate commissions if its system can track a Consumer to the applicable Model Site from the time the Consumer clicks on a Promotional Link to the time of sale."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"The Company will not pay the Affiliate a commission if (i) its system cannot process the Promotional Link; (ii) the referred Consumer does not pay in full; (iii) the referred Consumer previously registered for the applicable Model Site; or (iv) if a Promotional Link directs a Consumer to a Model Site, but that Consumer leaves that Model Site and returns to that Model Site over 24 hours later to buy a Model Offering without going through the Promotional Link again."}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"The Company will not pay the Affiliate for any activity that the Company considers fraudulent, including (i) credit card numbers in a negative bin number database, (ii) multiple subscriptions/purchases from a single email address, (iii) multiple subscriptions/purchases with the same credit card number, (iv) subscriptions with past memberships to the applicable Model Site, (v) sequential names or patterns of names, (vi) many subscriptions/purchases from a specific Model Site in a short time span, and (vii) multiple attempts to subscribe/purchase from the same credit card. The Company reserves sole judgment in determining fraud and all determinations bind the Affiliate. The Company may also deny or withhold commissions for any purchases coming from any practices that breach this agreement. If the Company determines that the Affiliate is engaging in practices that breach this agreement, the Affiliate will not receive any credit or payment and will forfeit all credits or payments earned."}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":"The Company may deny or withhold any payment to the Affiliate or terminate the Affiliate’s participation in the Program if there has been an abnormal number of chargebacks, refunds, or cancellations of memberships from Consumers referred to the Company through the Affiliate’s Promotional Links. The Company will determine what is an abnormal number of chargebacks, refunds, or cancellations based on its review of the situation and its experience with other affiliates. In addition, the Company may also deny or withhold payment to the Affiliate or terminate the Affiliate’s participation in the Program due to any other suspicious behavior, including unusual conversion ratios, lack of or low quantity of referred Consumer logins, or low referred Consumer usage."}]]]]]]]]],["div",{"class":"sp-part","id":"part-7"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"7."}]]],["textNode",{"text":"Affiliate’s Actions and Responsibilities."}]]],["div",{"class":"marg-left"},[["p",{},[["textNode",{"text":"The Affiliate will be solely responsible for developing, operating, and maintaining the Affiliate Sites and for all materials that appear on the Affiliate Sites. The Affiliate’s responsibilities include:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"7.1"}]]],["p",{},[["textNode",{"text":"The technical operation of the Affiliate Sites and all related equipment;"}]]],["span",{"class":"num"},[["textNode",{"text":"7.2"}]]],["p",{},[["textNode",{"text":"Displaying the Promotional Links and Licensed Materials on the Affiliate Sites in compliance with this agreement;"}]]],["span",{"class":"num"},[["textNode",{"text":"7.3"}]]],["p",{},[["textNode",{"text":"Creating, posting, and ensuring the accuracy of materials posted on the Affiliate Sites, including all materials related to the Model Sites and the Model Offerings;"}]]],["span",{"class":"num"},[["textNode",{"text":"7.4"}]]],["p",{},[["textNode",{"text":"Using the Licensed Materials, the Affiliate Sites, and the materials on the Affiliate Sites in a way that does not infringe any of the Company’s or a Model’s rights or those of any other person (including copyrights, trademarks, privacy, publicity, or other intellectual property or proprietary rights);"}]]],["span",{"class":"num"},[["textNode",{"text":"7.5"}]]],["p",{},[["textNode",{"text":"Disclosing on the Affiliate Sites accurately and adequately, either through a privacy policy or otherwise, how the Affiliate collects, uses, stores, and discloses data collected from Affiliate Site visitors, including, where applicable, that third parties (including the Company and other advertisers) may serve content and advertisements, collect information directly from Affiliate Site visitors, and place or recognize cookies on Affiliate Site visitors’ browsers; and"}]]],["span",{"class":"num"},[["textNode",{"text":"7.6"}]]],["p",{},[["textNode",{"text":"Making sure that any use that the Affiliate makes of the Licensed Materials complies with this agreement."}]]]]],["p",{},[["textNode",{"text":"The Company may monitor referrals through the Affiliate Sites to evaluate the Affiliate’s compliance with this agreement. If the Company determines that the Company is not in compliance, the Company may terminate the Affiliate from the Program. The Company will not be liable to the Affiliate or any other person for the Affiliate’s acts or omissions under this section 7."}]]]]]]],["div",{"class":"sp-part","id":"part-8"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"8."}]]],["textNode",{"text":" Processing; Statistics and Reporting."}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"8.1"}]]],["p",{},[["textNode",{"text":"The Company will process all spurchases from Consumers who follow the Promotional Links on the Affiliate Sites to one or more Model Sites. The Company may reject purchases that do not comply with the applicable Model Site’s requirements, which may change from time to time."}]]],["span",{"class":"num"},[["textNode",{"text":"8.2"}]]],["p",{},[["textNode",{"text":"The Company will track qualified purchases for reporting and commission accrual purposes. The Company will use reasonable efforts to provide the Affiliate with access to real-time traffic reporting, qualified purchaes, and revenue statistics. The Affiliate acknowledges that in calculating the Affiliate’s earnings, the Company’s good faith determination of any amount owed will be the final and binding determination, subject to section 6.2(g). The Affiliate will not try to artificially inflate its traffic reporting, qualified purchases, and revenue statistics by misleading or abusive practices."}]]]]]]],["div",{"class":"sp-part","id":"part-9"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"9."}]]],["textNode",{"text":" Consumer Policies and Pricing."}]]],["p",{},[["textNode",{"text":"Consumers referred through the Promotional Links are the Consumers of the applicable Model with respect to all activities they undertake on the applicable Model Site. Thus, as between the Affiliate and the applicable Model, all pricing, terms, rules, policies, and operating procedures concerning Consumer purchases and customer service stated on the applicable Model Site will apply to those Consumers, and the applicable Model may change them at any time without notifying the Affiliate."}]]]]],["div",{"class":"sp-part","id":"part-10"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"10."}]]],["textNode",{"text":"Data Ownership."}]]],["p",{},[["textNode",{"text":" The Company will have sole ownership of and full right to use all Consumer information generated by the Affiliate in connection with this agreement. The Affiliate will not have any rights in and to any Consumer information or data behind that Consumer information. The Affiliate will not (a) transfer, export, display, forward, or otherwise share any Consumer information or data contained in it to or with any third party; or (b) use any Consunmer information or data contained in it on the Affiliate’s own behalf in any way not expressly authorized by the Company in writing."}]]]]],["div",{"class":"sp-part","id":"part-11"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"11."}]]],["textNode",{"text":"Affiliate Site Privacy Requirements."}]]],["p",{},[["textNode",{"text":" The Affiliate will conspicuously post a privacy notice on the Affiliate Sites. The Affiliate’s privacy notice must fully, accurately, and concisely describe (1) what peronal data the Affiliate collects; (2) the purpose of collection; (3) how the Affiliate uses and shares that personal data; and (4) that other parties (i.e., ModelCentro, ad networks, analytics providers, etc.) may collect personal data about an individual consumer’s online activities over time and across different websites when the individual uses the Affiliate Sites or services. The Affiliate’s privacy notice must comply with the EU General Data Protection Regulation (GDPR) if the Affiliate solicits Consumers from the European Economic Area (EEA). The Affiliate’s privacy and data security practices must make sure that email, telephone, and other marketing practices, and applicable opt in and opt out policies and procedures, comply with all applicable laws."}]]]]],["div",{"class":"sp-part","id":"part-12"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"12."}]]],["textNode",{"text":"Electronic Consent."}]]],["p",{},[["textNode",{"text":" The Affiliate will conspicuously post an electronic consent policy to the Affiliate Sites. The Affiliate will obtain consent to provide required disclosures, documents, and information to the Affiliate’s end users electronically."}]]]]],["div",{"class":"sp-part","id":"part-13"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"13."}]]],["textNode",{"text":" Statements of Fact "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"13.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"By the Affiliate."}]]],["textNode",{"text":" The Affiliate states that the following facts are accurate and will continue to be accurate during this agreement:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"If the Affiliate is an individual, the Affiliate is at least 18-years old and has the legal capacity to enter into this agreement. If the Affiliate is an entity, it is duly organized, validly existing, and in good standing as a legal entity under the laws of its jurisdiction of incorporation, organization, or chartering."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"The Affiliate has the power to enter into this agreement and to perform its obligations under this agreement."}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"The Affiliate owns or has the right to operate each Affiliate Site."}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":"The Affiliate owns or has a license for all content found on each Affiliate Site, including all text, audio, images, and videos displayed on each Affiliate Site."}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["textNode",{"text":"The Affiliate has independently evaluated the desirability of participating in the Program."}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["textNode",{"text":"The revenue the Affiliate earns through the Program is and will be directed solely to the Affiliate, and the Affiliate is not authorized to transfer the Affiliate’s checks to or deposit the Affiliate’s checks with any third parties other than bona fide financial institutions."}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["textNode",{"text":"The Affiliate is not an individual, organization, or entity listed on The Office of Foreign Assets Control Specially Designated Nationals or Blocked Persons list, as published and updated by the United States Department of Treasury."}]]],["span",{"class":"num"},[["textNode",{"text":"(h)"}]]],["p",{},[["textNode",{"text":"Each Affiliate Site and the content on each Affiliate Site"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":"does not infringe the Company’s or any other person’s intellectual property rights;"}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":"does not violate third-party publicity or privacy rights;"}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":"does not promote violence, racial intolerance, or illegal activities;"}]]],["span",{"class":"num"},[["textNode",{"text":"(iv)"}]]],["p",{},[["textNode",{"text":"does not promote or facilitate the prostitution of another person or otherwise promote escort services;"}]]],["span",{"class":"num"},[["textNode",{"text":"(v)"}]]],["p",{},[["textNode",{"text":"does not depict bestiality, necrophilia, genital mutilation, sadomasochistic abuse or bondage, defecation, urination, bleeding, enema play, menstruation, rape, extreme violence, torture, incest, or any other obscene material;"}]]],["span",{"class":"num"},[["textNode",{"text":"(vi)"}]]],["p",{},[["textNode",{"text":"does not depict minors in adult or sexual situations or otherwise target persons under 18-years old or the age of majority, whichever is greater;"}]]],["span",{"class":"num"},[["textNode",{"text":"(vii)"}]]],["p",{},[["textNode",{"text":"does not violate any law governing false or deceptive advertising, sweepstakes, gambling, comparative advertising, or trade disparagement;"}]]],["span",{"class":"num"},[["textNode",{"text":"(viii)"}]]],["p",{},[["textNode",{"text":"is free of any “worm,” “virus,” malware, or other device or code that could impair or injure any person or any person’s property;"}]]],["span",{"class":"num"},[["textNode",{"text":"(ix)"}]]],["p",{},[["textNode",{"text":"is not otherwise defamatory, vulgar, or obscene; and"}]]],["span",{"class":"num"},[["textNode",{"text":"(x)"}]]],["p",{},[["textNode",{"text":"complies with the program requirements set out in section 4."}]]]]],["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":"The Affiliate is generally familiar with the nature of the Internet and complies with all laws and industry standards."}]]],["span",{"class":"num"},[["textNode",{"text":"(j)"}]]],["p",{},[["textNode",{"text":"The Affiliate’s performance under this agreement does not breach any agreement or obligation between the Affiliate and a third party or violate any applicable law."}]]],["span",{"class":"num"},[["textNode",{"text":"(k)"}]]],["p",{},[["textNode",{"text":"The Affiliate’s collection and use of personal data does not violate the Affiliate Sites’ privacy policy or violate any law that governs the Affiliate’s collection and use of personal data, including the GDPR."}]]],["span",{"class":"num"},[["textNode",{"text":"(l)"}]]],["p",{},[["textNode",{"text":"The Affiliate has obtained opt-in consent from any individual whose information the Affiliate transfers to the Company for that individual to be contacted by and marketed to by the Affiliate and third parties."}]]],["span",{"class":"num"},[["textNode",{"text":"(m)"}]]],["p",{},[["textNode",{"text":"The Affiliate and each Affiliate Site complies with 18 U.S.C. §§ 2257–2257A and the implementing regulations codified at 28 C.F.R. Part 75."}]]]]],["span",{"class":"num"},[["textNode",{"text":"13.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"By the Company."}]]],["textNode",{"text":"The Company states that the following facts are accurate:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"It is duly organized, validly existing, and in good standing as a corporation under the laws of the British Virgin Islands."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"It has the power to enter into this agreement and to perform its obligations under this agreement."}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"It owns or has the right to operate the Program."}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":"It owns or has the right to license the Licensed Materials."}]]]]]]]]],["div",{"class":"sp-part","id":"part-14"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"14."}]]],["textNode",{"text":" Confidentiality "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"14.1"}]]],["p",{},[["textNode",{"text":"Neither party will use or disclose to any third party the other party’s Confidential Information except as necessary for the performance of this agreement or to enforce this agreement. The confidentiality obligations will not restrict either party from disclosing Confidential Information of the other party in accordance with a court order from a court of competent jurisdiction, on condition that the party required to make the disclosure gives reasonable advance written notice to the other party so that it may contest the order and if that disclosure is required, only discloses the part of the Confidential Information that its legal counsel advises is legally required."}]]],["span",{"class":"num"},[["textNode",{"text":"14.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"“Confidential Information”"}]]],["textNode",{"text":" consists of (a) any technical information or plans concerning the Program or any software or other technology of the Company; (b) any financial information of the other party; (c) other information disclosed by one party to the other party that is marked as confidential or should reasonably be assumed to be confidential under the circumstances; and (d) the content of this agreement. Confidential Information does not include information that: (i) is or becomes generally known to the public through no fault of or breach of the receiving party; (ii) is rightfully known by the receiving party at the time of disclosure without an obligation of confidentiality; (iii) is independently developed by the receiving party without use of the disclosing party’s Confidential Information; or (iv) is obtained by the receiving party rightfully from a third party who has no duty of confidentiality to the disclosing party."}]]]]]]],["div",{"class":"sp-part","id":"part-15"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"15."}]]],["textNode",{"text":"Publicity. "}]]],["p",{},[["textNode",{"text":"The Company may use the Affiliate’s trade names, trademarks, service marks, or logos in presentations, marketing materials, affiliate lists, financial reports, website listings of affiliates, or advertisements without advance written approval. The Affiliate may use the Company’s or the applicable Model’s trade names, trademarks, service marks, logos, domain names, and other distinctive brand features solely in connection with performing under this agreement so long as the Affiliate complies with this agreement."}]]]]],["div",{"class":"sp-part","id":"part-16"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"16."}]]],["textNode",{"text":"Privacy. "}]]],["p",{},[["textNode",{"text":"For information about how the Company collects, uses, and shares the Affiliate’s information, please review the "}],["a",{"href":"https://modelcentro.com/privacyPolicy","target":"_blank"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":". The Affiliate acknowledges that by participating in the Program, the Affiliate consents to the Company’s collection, use, and sharing of this information (including the transfer of this information to the United States or other countries for the Company’s storage, processing, and use)."}]]]]],["div",{"class":"sp-part","id":"part-17"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"17."}]]],["textNode",{"text":" Nondisparagement. "}]]],["p",{},[["textNode",{"text":" During this agreement and for two years after its termination, the Affiliate will not take any action that is intended, or would reasonably be expected, to harm the Company, the Models, or their reputation or that would reasonably be expected to lead to unwanted or unfavorable publicity to the Company or the Models. But nothing will prevent the Affiliate from making any truthful statement in connection with any legal proceeding or investigation by the Company or any government body."}]]]]],["div",{"class":"sp-part","id":"part-18"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"18."}]]],["textNode",{"text":" Term and Termination; Survival "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"18.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"Term."}]]],["textNode",{"text":" This agreement begins on the Affiliate’s signup and ends when terminated by either party."}]]],["span",{"class":"num"},[["textNode",{"text":"18.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Termination."}]]],["textNode",{"text":" Either party may terminate this agreement for any reason by giving the other party a written notice of termination. The Affiliate’s breach of this agreement may result in the Affiliate’s immediate dismissal from the Program, with no obligation to the Company except to pay for earned commissions up to the point of termination unless this agreement provides otherwise. The Affiliate will forfeit all commissions due if the Company terminates the Affiliate from the Program because of the Affiliate’s fraudulent activity or for any breach of the program requirements set out in section 4."}]]],["span",{"class":"num"},[["textNode",{"text":"18.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"Survival."}]]],["textNode",{"text":" Any part of this agreement that imposes an obligation after termination will survive the termination, including all disclaimers and limitations of liability."}]]]]]]],["div",{"class":"sp-part","id":"part-19"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"19."}]]],["textNode",{"text":" Warranty Disclaimers "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"19.1"}]]],["p",{},[["textNode",{"text":"The Company is not making any guarantee of profitability or about the amount of money the Affiliate will earn through the Program. The Affiliate acknowledges that past affiliate earnings do not guarantee or suggest similar future earnings."}]]],["span",{"class":"num"},[["textNode",{"text":"19.2"}]]],["p",{},[["textNode",{"text":"The Company is not making any warranty—express, implied, oral, or otherwise—that"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"the Program, the Model Sites, the Model Offerings, or the Licensed Materials will be timely, uninterrupted, or error-free (whether as a result of technical failure, acts or omissions of third parties, or other causes) or will operate in combination with any other hardware, software, system, or data;"}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"the Program, the Model Sites, the Model Offerings, or the Licensed Materials will be suitable or otherwise meet the Affiliate’s requirements or expectations;"}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"the Program, the Model Sites, the Model Offerings, or the Licensed Materials will be accurate or reliable;"}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":"errors or defects in the Program, the Model Sites, the Model Offerings, or the Licensed Materials will be corrected; or"}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["textNode",{"text":"the servers that make the Program, the Model Sites, the Model Offerings, and the Licensed Materials available are free of viruses and other harmful components."}]]]]],["span",{"class":"num"},[["textNode",{"text":"19.3"}]]],["p",{},[["textNode",{"text":"The Company offers the Program, the Model Sites, the Model Offerings, and the Licensed Materials “as is.” The Company is not making any warranty, either express or implied, including the implied warranty of merchantability, fitness for a particular purpose, and noninfringement for the Program, the Model Sites, the Model Offerings, and the Licensed Materials. No advice or information, whether oral or written, obtained from the Company or elsewhere will create any warranty not expressly stated in this agreement."}]]]]]]],["div",{"class":"sp-part","id":"part-20"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"20."}]]],["textNode",{"text":"Limit of Liability "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"20.1"}]]],["p",{},[["textNode",{"text":"The Program, the Model Sites, the Model Offerings, and the Licensed Materials may be subject to limitations, delays, and other problems inherent in the use of the Internet and electronic communications. The Company is not liable for any delays, delivery failures, or other damage resulting from those problems."}]]],["span",{"class":"num"},[["textNode",{"text":"20.2"}]]],["p",{},[["textNode",{"text":"The Company will not be liable to the Affiliate for any of the following:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" Errors, mistakes, or inaccuracies in the Program, the Model Sites, the Model Offerings, or the Licensed Materials;"}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" Content or conduct that is infringing, inaccurate, obscene, indecent, offensive, threatening, harassing, defamatory, libelous, abusive, invasive of privacy, or illegal;"}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" Unauthorized access to or use of the Company’s servers and any personal or financial information stored in them, including unauthorized access or changes to the Affiliate’s account, transmissions, or data;"}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":" Interruption or cessation of transmission to or from the Program or the Model Sites;"}]]],["span",{"class":"num"},[["textNode",{"text":"(e)"}]]],["p",{},[["textNode",{"text":" Denial-of-service attack (DoS) or distributed denial-of-service attack (DDoS);"}]]],["span",{"class":"num"},[["textNode",{"text":"(f)"}]]],["p",{},[["textNode",{"text":" Bugs, viruses, trojan horses, malware, ransomware, or other disabling code that may be transmitted to or through the Program, the Model Sites, the Model Offerings, or the Licensed Materials by any person or that might infect the Affiliate’s computer or affect the Affiliate’s access to or use of the Program, the Model Sites, the Model Offerings, the Licensed Materials, or the Affiliate’s other services, hardware, or software;"}]]],["span",{"class":"num"},[["textNode",{"text":"(g)"}]]],["p",{},[["textNode",{"text":" Incompatibility between the Program, the Model Sites, the Model Offerings, or the Licensed Materials and the Affiliate’s other services, hardware, or software;"}]]],["span",{"class":"num"},[["textNode",{"text":"(h)"}]]],["p",{},[["textNode",{"text":" Delays or failures the Affiliate might experience in starting, conducting, or completing any transmissions to or transactions through or with the Program, the Model Sites, or the Licensed Materials; or"}]]],["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":" Loss or damage incurred because of the use of any content posted, emailed, sent, or otherwise made available through the Program or the Model Sites."}]]]]],["span",{"class":"num"},[["textNode",{"text":"20.3"}]]],["p",{},[["textNode",{"text":"The Company will not be liable to the Affiliate for breach-of-contract damages that the Company could not reasonably have foreseen on entry into this agreement. The Company also will not be liable to the Affiliate—regardless of theory of liability and even if the Affiliate advised the Company of the possibility of these damages—for any damages for: (a) loss of use; (b) loss of services; (c) loss of profits; (d) loss of revenue; (e) loss of goodwill; (f) loss of contracts; (g) loss of data; (h) loss of privacy; (i) loss of business or opportunity; or (j) cost of obtaining substitute services related to the Program, the Model Sites, the Model Offerings, or the Licensed Materials."}]]],["span",{"class":"num"},[["textNode",{"text":"20.4"}]]],["p",{},[["textNode",{"text":"Except as stated in this agreement, neither party will be liable to the other party for indirect, incidental, special, statutory, exemplary, or punitive damages arising from or relating to this agreement, regardless of theory of liability and even if that party knew or should have known of the possibility of these damages, including loss of revenue or anticipated profits or lost business."}]]],["span",{"class":"num"},[["textNode",{"text":"20.5"}]]],["p",{},[["textNode",{"text":" The Company’s total cumulative liability to the Affiliate for any breach of this agreement will not exceed the greater of the total amount owed to the Affiliate under this agreement and $500 USD. "}]]]]]]],["div",{"class":"sp-part","id":"part-22"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"21."}]]],["textNode",{"text":" Scope of Disclaimers and Limitations. "}]]],["p",{},[["textNode",{"text":" The disclaimers and limits stated in sections 19 and 20 apply to the greatest extent allowed by law, but no more. The Company does not intend to deprive the Affiliate of any mandatory protections provided to the Affiliate by law. Because some jurisdictions may prohibit the disclaimer of some warranties, the limitation of some damages or other matters, one or more of the disclaimers or limitations might not apply to the Affiliate."}]]]]],["div",{"class":"sp-part","id":"part-22"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"22."}]]],["textNode",{"text":" Indemnification "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"22.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"In General."}]]],["textNode",{"text":" The Affiliate will pay the Company for any loss of the Company’s that is caused by the Affiliate’s (a) use of the Program, the Model Sites, the Model Offerings, or the Licensed Materials; (b) failure to pay taxes in connection with revenues earned under this agreement; (c) dispute with any affiliate, model, consumer, or any other person; (d) breach of this agreement, including any statement of fact in section 13.1; (e) infringement of any person’s intellectual-property rights; (f) violation of any applicable law; (g) fraudulent or deceptive conduct or trade practices; or (h) tortious or criminal acts or omissions. But the Affiliate is not required to pay if the loss was caused by the Company’s intentional misconduct."}]]],["span",{"class":"num"},[["textNode",{"text":"22.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Definitions"}]]]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["strong",{},[["textNode",{"text":"“Loss”"}]]],["textNode",{"text":" means an amount that the Company is legally responsible for or pays in any form. Amounts include, for example, a judgment, a settlement, a fine, damages, injunctive relief, staff compensation, a decrease in property value, and expenses for defending against a claim for a loss (including fees for legal counsel, expert witnesses, and other advisers). A loss can be tangible or intangible; can arise from bodily injury, property damage, or other causes; can be based on tort, breach of contract, or any other theory of recovery; and includes incidental, direct, and consequential damages."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"A loss is "}],["strong",{},[["textNode",{"text":"“caused by”"}]]],["textNode",{"text":" an event if the loss would not have occurred without the event, even if the event is not a proximate cause of the loss."}]]]]],["span",{"class":"num"},[["textNode",{"text":"22.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"Company’s Duty to Notify."}]]],["textNode",{"text":" The Company will notify the Affiliate before the 15th business day after the Company knows or should reasonably have known of a claim for a loss that the Affiliate might be obligated to pay. The Company’s failure to give the Affiliate timely notice does not terminate the Affiliate’s obligation, except to the extent that the failure prejudices the Affiliate’s ability to defend the claim or mitigate losses."}]]],["span",{"class":"num"},[["textNode",{"text":"22.4"}]]],["p",{},[["strong",{},[["textNode",{"text":"Legal Defense of a Claim"}]]]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["strong",{},[["textNode",{"text":" Company’s Control. "}]]],["textNode",{"text":" The Company has control over defending a claim for a loss (including settling it) unless the Company directs the Affiliate to control the defense."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["strong",{},[["textNode",{"text":" Direction to Control."}]]],["textNode",{"text":" If the Company directs the Affiliate to control the defense, each of the following applies:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(i)"}]]],["p",{},[["textNode",{"text":"The Affiliate may choose and retain legal counsel."}]]],["span",{"class":"num"},[["textNode",{"text":"(ii)"}]]],["p",{},[["textNode",{"text":"The Company may retain its own legal counsel at its expense."}]]],["span",{"class":"num"},[["textNode",{"text":"(iii)"}]]],["p",{},[["textNode",{"text":"The Affiliate will not settle any litigation without the Company’s written consent if the settlement (1) imposes a penalty or limitation on the Company, (2) admits the Company’s fault, or (3) does not fully release the Company from liability."}]]]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["strong",{},[["textNode",{"text":"Good Faith."}]]],["textNode",{"text":" The Company and the Affiliate will cooperate with each other in good faith on a claim."}]]]]],["span",{"class":"num"},[["textNode",{"text":"22.5"}]]],["p",{},[["strong",{},[["textNode",{"text":"No Exclusivity."}]]],["textNode",{"text":" The Company’s rights under this section 22 do not affect other rights that the Company might have."}]]]]]]],["div",{"class":"sp-part","id":"part-23"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"23."}]]],["textNode",{"text":" Dispute Resolution"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"23.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"Litigation Election."}]]],["textNode",{"text":" Either party may elect to litigate the following type of case or controversy: (a) an action seeking injunctive relief; (b) an action seeking to enforce or protect intellectual-property rights; (c) a dispute related to claims subject to indemnification under section 22; or (d) a suit to compel compliance with this dispute resolution provision."}]]],["span",{"class":"num"},[["textNode",{"text":"23.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Negotiation."}]]],["textNode",{"text":" Each party will give the other a reasonable opportunity to comply before it claims that the other has not met its obligations under this agreement. The parties will first meet and negotiate with each other in good faith to try to resolve all disputes between the parties relating to this agreement. The party raising a dispute will submit to the other party a written notice and supporting material describing all issues and circumstances related to the dispute (a "}],["strong",{},[["textNode",{"text":"“Dispute Notice”"}]]],["textNode",{"text":"). A primary representative designated by each party will try to resolve the dispute."}]]],["span",{"class":"num"},[["textNode",{"text":"23.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"Mediation."}]]],["textNode",{"text":" If the parties’ primary representatives are unable to resolve the dispute within 30 days after receiving a Dispute Notice, either party may, by notice to the other party and the British Virgin Islands International Arbitration Centre, demand mediation under the mediation rules of the British Virgin Islands International Arbitration Centre. Mediation will take place in Road Town, Tortola, British Virgin Islands. The mediation will be conducted in the English language. Each party will bear its own costs in mediation, and the parties will share equally between them all third-party mediation costs unless the parties agree differently in writing. Each party will participate actively and constructively in mediation proceedings once started and will attend at least one joint meeting between the mediator and the parties. Any party may terminate mediation at any time after an initial meeting between the mediator and the parties."}]]],["span",{"class":"num"},[["textNode",{"text":"23.4"}]]],["p",{},[["strong",{},[["textNode",{"text":"Arbitration"}]]]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":" If the parties cannot settle a dispute through mediation, the parties will settle any unresolved dispute arising out of or relating to this agreement, or the breach of it, by arbitration administered by the British Virgin Islands International Arbitration Centre in accordance with the British Virgin Islands Arbitration Act of 2013 and any rules promulgated under it. The arbitrator, and not any court or agency, will have exclusive authority to resolve any dispute arising under or relating to the interpretation, applicability, enforceability, or formation of this agreement, including any claim that any part of this agreement is void or voidable."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":" A single arbitrator will preside over the arbitration. The arbitrator may grant whatever relief would be available in a court under law or in equity, except that the arbitrator will not award punitive or exemplary damages, or damages otherwise limited or excluded in this agreement. The arbitrator will issue a final award on all issues submitted to the arbitrator, which award must set out findings of fact and conclusions of law. The arbitrator’s award will bind the parties and may be entered as a judgment in any court of competent jurisdiction."}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":" Arbitration will take place in Road Town, Tortola, British Virgin Islands, and the language of the arbitration will be English. The parties will bear equally the costs of arbitration, including the fees and expenses of the arbitrator, and each party will bear the costs associated with its case, except the arbitrator will award costs and fees to the Prevailing Party in accordance with section 23.7."}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":"Unless required by law, neither a party nor an arbitrator will disclose the existence, content, or results of any arbitration under this agreement without the advance written consent of both parties."}]]]]],["span",{"class":"num"},[["textNode",{"text":"23.5"}]]],["p",{},[["strong",{},[["textNode",{"text":"Injunctive Relief."}]]],["textNode",{"text":" The Affiliate acknowledges that breach by it of its obligations under this agreement could cause irreparable harm for which damages would be an inadequate remedy. If any breach occurs or is threatened, the Company may seek an injunction or a restraining order, in each case without posting a bond or other security."}]]],["span",{"class":"num"},[["textNode",{"text":"23.6"}]]],["p",{},[["strong",{},[["textNode",{"text":"Jurisdiction and Venue"}]]]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"If a party brings any proceeding authorized under section 23.1, that party will bring that proceeding only in the courts located in Road Town, Tortola, British Virgin Islands, and each party hereby submits to the exclusive jurisdiction and venue of those courts for purposes of any proceeding."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"Each party hereby waives any claim that any proceeding brought in accordance with section 23.6(a) has been brought in an inconvenient forum or that the venue of that proceeding is improper."}]]]]],["span",{"class":"num"},[["textNode",{"text":"23.7"}]]],["p",{},[["strong",{},[["textNode",{"text":"Recovery of Expenses."}]]],["textNode",{"text":" In any proceedings between the parties arising out of this agreement or relating to the subject matter of this agreement, the Prevailing Party will be entitled to recover from the other party, in addition to any other relief awarded, all expenses that the Prevailing Party incurs in those proceedings, including legal fees and expenses. For purposes of this section 23.7, "}],["strong",{},[["textNode",{"text":"“Prevailing Party”"}]]],["textNode",{"text":" means, for any proceedings, the party in whose favor an award is rendered, except that if in those proceedings the award finds in favor of one party on one or more claims or counterclaims and in favor of the other party on one or more other claims or counterclaims, neither party will be the Prevailing Party. If any proceedings are voluntarily dismissed or are dismissed as part of settlement of that dispute, neither party will be the Prevailing Party in those proceedings."}]]],["span",{"class":"num"},[["textNode",{"text":"23.8"}]]],["p",{},[["strong",{},[["textNode",{"text":"Jury Trial Waiver."}]]],["textNode",{"text":" Each party hereby waives its right to a trial by jury in any proceedings arising out of or related to the subject matter of this agreement. Either party may enforce this waiver up to and including the first day of trial."}]]],["span",{"class":"num"},[["textNode",{"text":"23.9"}]]],["p",{},[["strong",{},[["textNode",{"text":"Class Action Waiver."}]]],["textNode",{"text":" The parties will conduct all proceedings to resolve a dispute in any forum on an individual basis only. Neither the Affiliate nor the Company will seek to have any dispute heard as a class action or participate in any other proceeding in which either party acts or proposes to act in a representative capacity. The parties will not combine any proceeding with another without the advanced written consent of all parties to all affected proceedings."}]]],["span",{"class":"num"},[["textNode",{"text":"23.10"}]]],["p",{},[["strong",{},[["textNode",{"text":"Limited Time to Bring Claims."}]]],["textNode",{"text":" A party will not bring a claim arising out of, or related to the subject matter of, this agreement more than one year after the cause of action first arose. Any claim brought after one year is barred."}]]]]],["div",{"class":"sp-part","id":"part-24"},[["div",{"class":"sp-part-title"},[["span",{"class":"num numbers"},[["textNode",{"text":"24."}]]],["textNode",{"text":" General "}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"24.1"}]]],["p",{},[["strong",{},[["textNode",{"text":"Entire Agreement."}]]],["textNode",{"text":" This agreement and the "}],["a",{"href":"https://modelcentro.com/terms-of-use","rel":"nofollow","target":"_blank"},[["textNode",{"text":"Terms-of-Use Agreement"}]]],["textNode",{"text":"Terms-of-Use Agreement constitutes the entire agreement of the parties concerning the subject matter and supersedes all earlier written or oral discussions, negotiations, proposals, undertakings, understandings, and agreements between the parties concerning the subject matter. If any conflict or inconsistent exists between this agreement and the "}],["a",{"href":"https://modelcentro.com/terms-of-use","rel":"nofollow","target":"_blank"},[["textNode",{"text":"Terms-of-Use Agreement"}]]],["textNode",{"text":", this agreement will govern. "}]]],["span",{"class":"num"},[["textNode",{"text":"24.2"}]]],["p",{},[["strong",{},[["textNode",{"text":"Amendment."}]]],["textNode",{"text":" The Company may change this agreement on one or more occasions, except that changes will not apply to ongoing disputes or to disputes arising out of events occurring before the posted changes. The Company will notify the Affiliate through the affiliate portal of any changes to this agreement. Changes will become effective when posted in the affiliate portal. It is the Affiliate’s responsibility to check the affiliate portal periodically for changes to this agreement. If the Affiliate continues to participate in the Program after any change, the Company will consider the Affiliate’s continued participation as acceptance of the change unless the Affiliate notifies the Company in writing of the Affiliate’s disagreement and the reasons for the Affiliate’s disagreement no later than 15 days after the change. The Company will contact the Affiliate no later than 15 days after receiving the Affiliate’s written notice to try to reach a mutually amicable resolution. If the Company is unable to resolve the Affiliate’s disagreement with the changes, the Affiliate’s sole remedy is to terminate this agreement."}]]],["span",{"class":"num"},[["textNode",{"text":"24.3"}]]],["p",{},[["strong",{},[["textNode",{"text":"Assignment and Delegation."}]]],["textNode",{"text":" The Affiliate will not assign any of its rights or delegate any performance under this agreement, except with the Company’s advance written consent. The Company may assign its rights or delegate its performances under this agreement without the Affiliate’s consent. Any purported assignment of rights or delegation of performance in breach of this section 24.3 is void."}]]],["span",{"class":"num"},[["textNode",{"text":"24.4"}]]],["p",{},[["strong",{},[["textNode",{"text":"Waivers."}]]],["textNode",{"text":" The parties may waive any provision in this agreement only by a writing signed by the party or parties against whom the waiver is sought to be enforced. No failure or delay in exercising any right or remedy, or in requiring the satisfaction of any condition, under this agreement, and no act, omission, or course of dealing between the parties, operate as a waiver or estoppel of any right, remedy, or condition. A waiver made in writing on one occasion is effective only in that instance and only for the purpose stated. A waiver once given is not to be construed as a waiver on any future occasion or against any other person."}]]],["span",{"class":"num"},[["textNode",{"text":"24.5"}]]],["p",{},[["strong",{},[["textNode",{"text":"Severability."}]]],["textNode",{"text":" The parties intend as follows:"}]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"that if any provision of this agreement is held to be unenforceable, then that provision will be modified to the minimum extent necessary to make it enforceable, unless that modification is not permitted by law, in which case that provision will be disregarded;"}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"that if modifying or disregarding the unenforceable provision would result in failure of an essential purpose of this agreement, the entire agreement will be held unenforceable;"}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"that if an unenforceable provision is modified or disregarded in accordance with this section 24.5, then the rest of the agreement will remain in effect as written; and"}]]],["span",{"class":"num"},[["textNode",{"text":"(d)"}]]],["p",{},[["textNode",{"text":"that any unenforceable provision will remain as written inany circumstances other than those in which the provision is held to be unenforceable."}]]]]],["span",{"class":"num"},[["textNode",{"text":"24.6"}]]],["p",{},[["strong",{},[["textNode",{"text":"Notices."}]]],["textNode",{"text":" All notices and other communications between the parties will be in writing. The Affiliate may send notice to the Company by email at sales@modelcentro.com. The Company may notify the Affiliate by email using email address identified in the Affiliate’s account. The Company will consider an email notice received by it only when the Company’s server sends a return message to the Affiliate acknowledging receipt. The Company will consider notices sent to the Affiliate by email received when the Company’s email service shows transmission to the Affiliate’s email address. All other notices will be effective on receipt by the party to which notice is given, or on the fifth day after mailing, whichever occurs first."}]]],["span",{"class":"num"},[["textNode",{"text":"24.7"}]]],["p",{},[["strong",{},[["textNode",{"text":"Governing Law."}]]],["textNode",{"text":" British Virgin Islands law, without giving effect to its conflicts of law principles, governs all matters arising out of or relating to this agreement, including its validity, interpretation, construction, performance, and enforcement."}]]],["span",{"class":"num"},[["textNode",{"text":"24.8"}]]],["p",{},[["strong",{},[["textNode",{"text":"Force Majeure"}]]]]],["div",{"class":"marg-left"},[["span",{"class":"num"},[["textNode",{"text":"(a)"}]]],["p",{},[["textNode",{"text":"If a Force Majeure Event prevents a party from complying with any one or more obligations under this agreement, that inability will not constitute a breach if (1) that party uses reasonable efforts to perform those obligations, (2) that party’s inability to perform those obligations is not due to its failure to (A) take reasonable measures to protect itself against events or circumstances of the same type as that Force Majeure Event or (B) develop and keep a reasonable contingency plan to respond to events or circumstances of the same type as that Force Majeure Event, and (3) that party complies with its obligations under section 24.8(c)."}]]],["span",{"class":"num"},[["textNode",{"text":"(b)"}]]],["p",{},[["textNode",{"text":"For purposes of this agreement, "}],["strong",{},[["textNode",{"text":"“Force Majeure Event”"}]]],["textNode",{"text":" means, for any party, any event or circumstance, whether or not foreseeable, that was not caused by that party (other than a strike or other labor unrest that affects only that party, an increase in prices or other change in general economic conditions, a change in law, or an event or circumstances that results in that party’s not having sufficient funds to comply with an obligation to pay money) and any consequences of that event or circumstance."}]]],["span",{"class":"num"},[["textNode",{"text":"(c)"}]]],["p",{},[["textNode",{"text":"If a Force Majeure Event occurs, the noncomplying party will promptly notify the other party of occurrence of that Force Majeure Event, its effect on performance, and how long the noncomplying party expects it to last. From then on, the noncomplying party will update that information as reasonably necessary. During a Force Majeure Event, the noncomplying party will use reasonable efforts to limit damages to the other party and to resume its performance under this agreement."}]]]]],["span",{"class":"num"},[["textNode",{"text":"24.9"}]]],["p",{},[["strong",{},[["textNode",{"text":"No Third-Party Beneficiaries. "}]]],["textNode",{"text":"This agreement does not, and the parties do not intend it to, confer any rights or remedies on any person other than the parties to this agreement."}]]],["span",{"class":"num"},[["textNode",{"text":"24.10"}]]],["p",{},[["strong",{},[["textNode",{"text":"Relationship of the Parties. "}]]],["textNode",{"text":"The parties intend that their relationship will be that of independent contractors and not business partners. This agreement does not, and the parties do not intend it to, create a partnership, joint venture, agency, franchise, or employment relationship between the parties and the parties expressly disclaim the existence of any of these relationships between them. Neither of the parties is the agent for the other, and neither party has the right to bind the other on any agreement with a third party. "}]]],["span",{"class":"num"},[["textNode",{"text":"24.11"}]]],["p",{},[["strong",{},[["textNode",{"text":"Successors and Assigns."}]]],["textNode",{"text":" This agreement binds and inures to the benefit of the parties and their respective successors and assigns. This section 24.11 does not address, directly or indirectly, whether a party may assign its rights or delegate its obligations under this agreement. Section 24.3 addresses these matters. "}]]],["span",{"class":"num"},[["textNode",{"text":"24.12"}]]],["p",{},[["strong",{},[["textNode",{"text":"Electronic Signatures."}]]],["textNode",{"text":" The Affiliate acknowledges that any affirmation, assent, or agreement the Affiliate sends through the affiliate portal in response to a prompt binds the Affiliate. The Affiliate further acknowledges that when the Affiliate clicks on an “I agree,” “I consent,” or other similarly worded “button” or entry field using a finger (for touch enabled devices), mouse, keystroke, or other device, this action is the legal equivalent of the Affiliate’s handwritten signature and binds the Affiliate in the same way. "}]]],["span",{"class":"num"},[["textNode",{"text":"24.13"}]]],["p",{},[["strong",{},[["textNode",{"text":"Voluntary Agreement."}]]],["textNode",{"text":" The Affiliate has entered this agreement voluntarily and for valid reasons. The Affiliate acknowledges that the Affiliate (i) has carefully read this agreement, (ii) discussed it with the Affiliate’s attorneys or other advisors, (iii) understood all the terms, and (iv) will comply with it. The Affiliate has relied on the advice of the Affiliate’s attorneys or other advisors about the terms of this agreement and waives any claim that the terms should be construed against the drafter. "}]]],["span",{"class":"num"},[["textNode",{"text":"24.14"}]]],["p",{},[["strong",{},[["textNode",{"text":"No Reliance."}]]],["textNode",{"text":" The Affiliate acknowledges that in electronically signing this agreement, that the Affiliate does not rely and has not relied on any statement by the Company or its agents, except those statements contained in this agreement. "}]]],["span",{"class":"num"},[["textNode",{"text":"24.15"}]]],["p",{},[["strong",{},[["textNode",{"text":"Permission to Send Emails to the Affiliate."}]]],["textNode",{"text":" The Affiliate grants the Company permission to email the Affiliate notices, advertisements, and other communications, including emails, advertisements, notices, and other communications containing adult-oriented material, sexual content and language, and images of nudity unsuitable for minors. The Affiliate’s permission will continue until the Affiliate asks the Company to remove the Affiliate from the Company’s email list. For more information, please see the "}],["a",{"href":"https://modelcentro.com/privacyPolicy","target":"_blank","rel":"nofollow"},[["textNode",{"text":"Privacy Policy."}]]]]],["span",{"class":"num"},[["textNode",{"text":"24.16"}]]],["p",{},[["strong",{},[["textNode",{"text":"Feedback."}]]],["textNode",{"text":" The Company encourages the Affiliate to give feedback about the Company, the Program, the Model Sites, the Model Offerings, or the Licensed Materials. But the Company will not treat as confidential any suggestion or idea the Affiliate gives, and nothing in this agreement will restrict the Company’s right to use, profit from, disclose, publish, or otherwise exploit any feedback, without payment to the Affiliate. "}]]],["span",{"class":"num"},[["textNode",{"text":"24.17"}]]],["p",{},[["strong",{},[["textNode",{"text":"English Language."}]]],["textNode",{"text":" The Company has drafted this agreement in the English language, and no translation into any other language will be used to interpret or construe this agreement. The Company will provide all services, support, notices, designations, specifications, and communications in the English language. "}]]]]]]]]]]],["div",{"class":"sp-col sp-right"},[["ul",{"class":"sp-navigator"},[["li",{"data-target":"warning"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Warning "}]]],["li",{"data-target":"start"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Start "}]]],["li",{"data-target":"part-1"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Enrollment in the Program "}]]],["li",{"data-target":"part-2"},[["span",{"class":"sp-dot"}],["textNode",{"text":" License "}]]],["li",{"data-target":"part-3"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Promotional Links "}]]],["li",{"data-target":"part-4"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Program Requirements "}]]],["li",{"data-target":"part-5"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Affiliate’s Duty to Notify "}]]],["li",{"data-target":"part-6"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Compensation "}]]],["li",{"data-target":"part-7"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Affiliate’s Actions and Responsibilities "}]]],["li",{"data-target":"part-8"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Processing; Statistics and Reporting "}]]],["li",{"data-target":"part-9"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Consumer Policies and Pricing"}]]],["li",{"data-target":"part-10"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Data Ownership "}]]],["li",{"data-target":"part-11"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Affiliate Site Privacy Requirements "}]]],["li",{"data-target":"part-12"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Electronic Consent "}]]],["li",{"data-target":"part-13"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Statements of Fact "}]]],["li",{"data-target":"part-14"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Confidentiality "}]]],["li",{"data-target":"part-15"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Publicity. "}]]],["li",{"data-target":"part-16"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Privacy. "}]]],["li",{"data-target":"part-17"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Nondisparagement "}]]],["li",{"data-target":"part-18"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Term and Termination; Survival "}]]],["li",{"data-target":"part-19"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Warranty Disclaimers "}]]],["li",{"data-target":"part-20"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Limit of Liability "}]]],["li",{"data-target":"part-21"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Scope of Disclaimers and Limitations "}]]],["li",{"data-target":"part-22"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Indemnification "}]]],["li",{"data-target":"part-23"},[["span",{"class":"sp-dot"}],["textNode",{"text":" Dispute Resolution "}]]],["li",{"data-target":"part-24"},[["span",{"class":"sp-dot"}],["textNode",{"text":" General "}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_contest", [["section",{"class":"simple-page contest-page-wrapper"},[["section",{"class":"top"},[["h1",{},[["textNode",{"text":"MCProfits - Sales bonus!"}]]],["h3",{},[["textNode",{"text":"Sales promotion finished!"}]]],["img",{"src":"" + __webpack_require__(188) + "","class":"lines"}]]],["section",{"class":"list"},[["ul",{},[["li",{},[["span",{"class":"icon participants"}],["p",{"class":"title"},[["textNode",{"text":"Participants"}]]],["p",{"class":"text"},[["textNode",{"text":" Only affiliates who use MCProfits promotional tools and promote MCProfits sites are eligible to partake in this sales promotion. Sales coming from the Global Affiliate Program or models' individual affiliate programs do not qualify for the promotion. If you already have an account in the ModelCentro network your credentials will also work on MCProfits, so there is no need to sign up again. "}]]]]],["li",{},[["span",{"class":"icon prize"}],["p",{"class":"title"},[["textNode",{"text":"Prize"}]]],["p",{"class":"text"},[["textNode",{"text":" MCProfits will pay a $150 Sales Bonus to any affiliate who makes 5 sales during the 30 day sales promotion period. The bonus will be paid when the webmaster reaches the minimum payout limit (the bonus is not counted in the payout limit - only regular sales are counted in order to be paid). "}]]]]],["li",{},[["span",{"class":"icon winners"}],["p",{"class":"title"},[["textNode",{"text":"Winners announcement"}]]],["p",{"class":"text"},[["textNode",{"text":" Winners will be notified via the email used to register the affiliate account. "}]]]]]]]]],["section",{"class":"submit-block"},[["a",{"href":"/registration","class":"reg-button"},[["textNode",{"text":"Sign up now!"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/lines.png", __webpack_require__.p + "images/lines.png");

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("mcblog_post_window", [["div",{},[["div",{"class":"mcb-overlay mcb-fast-animated fadeIn"}],["div",{"class":"mcb-post-window mcb-fast-animated fadeIn"},[["div",{"class":"mcb-post-window-close"},[["span",{"data-fox-alias":"1","data-fox-context":"mcBlog_post_window"},[["textNode",{"text":"Close"}]]],["textNode",{"text":" "}],["i"]]],["div",{"class":"mcb-post-body"}],["div",{"class":"mcb-post-sidebar"},[["div",{"class":"mcb-sidebar-content"},[["div",{"class":"mcb-reporter"},[["div",{"class":"mcb-rep-avatar"},[["img",{"src":"http://dummyimage.com/200x200/4d494d/686a82.gif&text=placeholder+image","alt":"placeholder+image"}]]],["em",{"data-fox-alias":"2","data-fox-context":"mcBlog_post_window"},[["textNode",{"text":"Posted by"}]]],["div",{"class":"mcb-name","data-fox-alias":"3","data-fox-context":"mcBlog_post_window"},[["textNode",{"text":"Jeff Random"}]]]]],["div",{"class":"mcb-post-window-share"},[["span",{"class":"mcb-post-share-x top"}],["textNode",{"text":" "}],["span",{"class":"mcb-post-share-x bottom"}],["textNode",{"text":" "}],["span",{"class":"mcb-post-share-it","data-fox-alias":"4","data-fox-context":"mcBlog_post_window"},[["textNode",{"text":"Share this Post"}]]],["div",{"class":"mcb-post-soc"},[["a",{"data-destanation":"facebook","class":"mcb-post-share-icon fc"}],["textNode",{"text":" "}],["a",{"data-destanation":"twitter","class":"mcb-post-share-icon tw"}]]]]],["div",{"class":"mcb-post-window-info"},[["div",{"class":"mcb-post-window-info-row"},[["span",{"class":"mcb-icon mcb-post-likes"}],["textNode",{"text":" "}],["span",{"id":"sdb-post-likes","class":"ds-ib"},[["textNode",{"text":"0"}]]],["div",{},[["button",{"id":"like-this-post","class":"fqb-btn"},[["span",{"data-fox-alias":"5","data-fox-context":"mcBlog_post_window"},[["textNode",{"text":"I like it"}]]],["if",{"empty":"","addattr":"disabled"},[],[["id","empty",true,[],"member"]]]]]]]]],["div",{"class":"mcb-post-window-info-row"},[["span",{"class":"mcb-icon mcb-post-views"}],["textNode",{"text":" "}],["span",{"id":"sdb-post-comments","class":"ds-ib"},[["textNode",{"text":"0"}]]],["div",{},[["button",{"id":"leave-comment","class":"fqb-btn","data-fox-alias":"6","data-fox-context":"mcBlog_post_window"},[["textNode",{"text":"Leave a comment"}]]]]]]]]]]],["div",{"class":"mcb-post-window-key-control"},[["em",{"data-fox-alias":"7","data-fox-context":"mcBlog_post_window"},[["textNode",{"text":"Prev post"}]]],["div",{"data-keycode":"37","class":"key normal"},[["textNode",{"text":"&larr;"}]]],["div",{"class":"inactive"},[["div",{"class":"key"},[["textNode",{"text":"&uarr;"}]]],["div",{"class":"key"},[["textNode",{"text":"&darr;"}]]]]],["div",{"data-keycode":"39","class":"key normal"},[["textNode",{"text":"&rarr;"}]]],["em",{"data-fox-alias":"8","data-fox-context":"mcBlog_post_window"},[["textNode",{"text":"Next post"}]]]]]]]]]]]]);
fox.registerTemplate("mcblog_post_window_body", [["div",{"class":"mcb-fast-animated"},[["div",{"class":"mcb-post-window-title"},[["textNode",{"text":" "}],["span",{},[],[["title","__text",true]]],["textNode",{"text":" "}],["div",{"class":"mcb-post-window-date-wrap"},[["div",{"class":"mcb-post-window-date"},[["span",{"class":"mcb-icon mcb-post-date-grey"}],["textNode",{"text":" "}],["span",{},[],[["publishDate","__text",true,[{"name":"dateFormat","params":["%e %B, %Y"]}]]]],["textNode",{"text":" "}]]]]]]],["foreach",{"from":"","item":"c"},[["if",{"notempty":""},[["div",{"class":"mcb-post-window-content"},[["textNode",{"text":" "}],["span",{},[],[["c.content","__text",true,[{"name":"html","params":[]}]]]],["textNode",{"text":" "}]]]],[["c.type","notempty",true,[{"name":"eq","params":["1"]}]]]],["if",{"notempty":""},[["div",{"class":"mcb-post-window-media"},[["img",{"src":"","alt":""},[],[["c.content","src",true]]]]]],[["c.type","notempty",true,[{"name":"eq","params":["3"]}]]]]],[["contents","from",true]]],["div",{"class":"mcb-post-window-categories"},[["strong",{},[["span",{"data-fox-alias":"1","data-fox-context":"mcBlog_post_window_body"},[["textNode",{"text":"Categories"}]]],["textNode",{"text":":&nbsp;&nbsp;"}]]],["foreach",{"from":"","item":"tag"},[["em",{"class":"mcb-link"},[["span",{},[],[["tag.title","__text",true]]]]],["if",{"empty":""},[["textNode",{"text":" ,&nbsp; "}]],[["tag._last","empty",true]]]],[["tags","from",true]]]]],["div",{"class":"mcb-post-window-comments"},[["if",{"notempty":""},[["div",{"class":"mcb-comments-title"},[["span",{"data-fox-alias":"2","data-fox-context":"mcBlog_post_window_body"},[["textNode",{"text":"Comments"}]]],["sup",{},[["span",{},[],[["_comments","__text",true,[{"name":"countDl","params":[]}]]]]]]]]],[["_comments","notempty",true,[{"name":"count","params":[]},{"name":"gt","params":["0"]}]]]],["foreach",{"from":"","item":"comment"},[["div",{"class":"mcb-post-window-comment-item"},[["div",{"class":"comment-info"},[["strong",{},[["span",{},[],[["comment.name","__text",true]]]]],["textNode",{"text":" "}],["span",{},[["textNode",{"text":"at "}],["span",{},[],[["comment.date","__text",true,[{"name":"dateFormat","params":["%d %B, %H"]}]]]],["textNode",{"text":":"}],["span",{},[],[["comment.date","__text",true,[{"name":"dateFormat","params":["%M"]}]]]]]]]],["div",{"class":"comment-body"},[["textNode",{"text":" "}],["span",{},[],[["comment.comment","__text",true]]],["textNode",{"text":" "}]]]]]],[["_comments","from",true]]],["div",{"class":"add-comment-form"},[["div",{"class":"mcb-form-title"},[["strong",{"data-fox-alias":"3","data-fox-context":"mcBlog_post_window_body"},[["textNode",{"text":"Leave a comment"}]]]]],["if",{"empty":""},[["div",{"class":"not-logged-fields"},[["div",{"class":"fqb-input icon name"},[["input",{"class":"fqb-field","type":"text","name":"userName","placeholder":"Your name"}],["div",{"class":"styled"}]]],["div",{"class":"fqb-input icon email"},[["input",{"class":"fqb-field","type":"text","name":"email","placeholder":"Your email"}],["div",{"class":"styled"}]]],["div",{"class":"fqb-input captcha"},[["input",{"class":"fqb-field","type":"text","name":"captcha","placeholder":"Enter text from image"}],["div",{"class":"styled"},[["span",{"id":"cpth","class":"cp"}]]]]]]]],[["id","empty",true,[],"member"]]],["div",{"class":"fqb-input mcb-post-window-comment-text"},[["textarea",{"data-el-id":"leave-comment","name":"comment","placeholder":"Enter your comment here","class":"fqb-field"}],["div",{"class":"styled"}]]],["if",{"empty":""},[["div",{"class":"_flex _row-n _m-t-15"},[["div",{"class":"checkbox-wrapp mc-field _m-r-15"},[["input",{"class":"fields2send not-empty","type":"checkbox","name":"consent_tos","id":"consent_tos"}],["textNode",{"text":" "}],["span",{"class":"checkbox"},[["span",{"class":"arr"}]]],["div",{"class":"tooltip validation-error-box"},[["div",{"class":"css3-holder message"},[["textNode",{"text":" You must agree to the Website Operator Agreement "}]]]]]]],["label",{"for":"consent_tos","class":"tos-text"},[["span",{},[["textNode",{"text":" By checking this box, I certify that I am at least 18-years old, have the capacity to enter into legally binding contracts, and have read and agree to the "}]]],["textNode",{"text":" "}],["a",{"target":"_blank","href":"/affiliate-agreement","draggable":"true"},[["span",{},[["span",{},[["textNode",{"text":"Affiliate Agreement"}]]]]]]]]]]]],[["id","empty",true,[],"member"]]],["button",{"id":"add-comment","class":"fqb-btn blue fr","data-fox-alias":"4","data-fox-context":"mcBlog_post_window_body"},[["textNode",{"text":"Add Comment"}]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("faq_question", [["div",{"class":"fqb-title clearfix"},[["span",{"class":"","data-fox-alias":"1","data-fox-context":"faq_question"},[["textNode",{"text":"Ask your question"}]]]]],["div",{"class":"fqb-content form"},[["div",{"class":"fqb-ask-form fields"},[["div",{"class":"row"},[["div",{"class":"fqb-input icon name"},[["input",{"type":"text","name":"name","placeholder":"Your name","class":"fqb-field fields2send"}],["div",{"class":"styled"}]]]]],["div",{"class":"row"},[["div",{"class":"fqb-input icon email"},[["input",{"type":"text","name":"email","placeholder":"Your email","class":"fqb-field fields2send"}],["div",{"class":"styled"}]]]]],["div",{"class":"row"},[["div",{"class":"fqb-input captcha"},[["input",{"type":"text","name":"captcha","placeholder":"Enter text from image","class":"fqb-field fields2send"}],["div",{"class":"styled"},[["span",{"class":"cp"}]]]]]]],["div",{"class":"row"},[["div",{"class":"fqb-input"},[["textarea",{"name":"question","placeholder":"Enter text of your question","class":"fqb-field fields2send"}],["div",{"class":"styled"},[["span",{"class":"cp"}]]]]]]],["div",{"class":"row _flex _row-n"},[["div",{"class":"checkbox-wrapp mc-field _m-r-5"},[["input",{"class":"fields2send not-empty","type":"checkbox","name":"consent_tos","id":"consent_tos"}],["textNode",{"text":" "}],["span",{"class":"checkbox"},[["span",{"class":"arr"}]]],["div",{"class":"tooltip validation-error-box"},[["div",{"class":"css3-holder message"},[["textNode",{"text":" You must agree to the Website Affiliate Agreement "}]]]]]]],["label",{"for":"consent_tos","class":"tos-text","style":"font-size:11px"},[["span",{},[["textNode",{"text":" By checking this box, I certify that I am at least 18-years old, have the capacity to enter into legally binding contracts, and have read and agree to the "}]]],["textNode",{"text":" "}],["span",{"onclick":"event.stopPropagation();"},[["a",{"target":"_blank","href":"/affiliate-agreement"},[["textNode",{"text":"Affiliate Agreement"}]]]]]]]]],["div",{"class":"row"},[["a",{"class":"fqb-btn blue send","data-fox-alias":"2","data-fox-context":"faq_question"},[["textNode",{"text":"Send your question"}]]]]]]],["div",{"class":"fqb-ask-form fqb-success-msg","data-fox-alias":"3","data-fox-context":"faq_question"},[["strong",{},[["textNode",{"text":"Thank you for contacting us!"}]]],["textNode",{"text":" "}],["br"],["br"],["textNode",{"text":" We greatly appreciate you taking the time to write to us. "}],["br"],["textNode",{"text":" Please allow at least 24 hours to process your request. "}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("models_advanced_filter", [["div",{"class":"select-group"},[["div",{"class":"btn-f-group filter-item"},[["input",{"id":"nonnude","type":"checkbox","name":"mcpSubscription_data_restrictionTagId","value":"1","class":"btn grade"}],["textNode",{"text":" "}],["label",{"for":"nonnude","class":"btn"},[["textNode",{"text":"Non Nude"}]]],["input",{"id":"softcore","type":"checkbox","name":"mcpSubscription_data_restrictionTagId","value":"2,3,6","class":"btn grade"}],["textNode",{"text":" "}],["label",{"for":"softcore","class":"btn"},[["textNode",{"text":"Softcore"}]]],["input",{"id":"hardcore","type":"checkbox","name":"mcpSubscription_data_restrictionTagId","value":"4","class":"btn grade"}],["textNode",{"text":" "}],["label",{"for":"hardcore","class":"btn"},[["textNode",{"text":"Hardcore"}]]]]]]],["div",{"class":"select-pair"},[["div",{"class":"select-group"},[["div",{"class":"filter-item niches-wrapper"}],["div",{"class":"filter-item keywords-wrapper"}]]],["div",{"class":"select-group"},[["div",{"class":"filter-item features-wrapper"}],["button",{"type":"button","id":"set-filter","class":"btn btn-primary btn-show"},[["textNode",{"text":"Show results"}]]]]]]]]);
fox.registerTemplate("grid_models", [["div",{"id":"sites-carousel","class":"list-models"}],["div",{"class":"content-pager"}]]);
fox.registerTemplate("promo_oursite_page", [["section",{"id":"model-sites-block","class":"model-sites-block content-section modelssite-page","data-name":"our-sites"},[["div",{"class":"content-block"},[["h1",{},[["textNode",{"text":"Our sites"}]]],["div",{"class":"filter-models"}],["div",{"class":"grid-models"}]]]]]]);
fox.registerTemplate("autocomplete2_multipleselect_selected_list_item", [["div",{"class":"tag"},[["span",{"class":"close delete","fox-autocomplete-filter-result":""},[["i",{"class":"icon-mc_other_close-delete"}]],[["id","fox-autocomplete-filter-result",true]]],["textNode",{"text":" "}],["span",{},[],[["alias","__text",true]]],["textNode",{"text":" "}]]]]);
fox.registerTemplate("autocomplete2_multipleselect_list_item", [["li",{"class":"option-item","fox-autocomplete-result-item":"","fox-autocomplete-search-result":""},[["span",{},[],[["alias","__text",true]]]],[["id","fox-autocomplete-search-result",true]]]]);
fox.registerTemplate("autocomplete2_multipleselect", [["div",{"class":"mc-tag-selector mc-form-field dropdown dl-bottom"},[["div",{"class":"tags-list","fox-autocomplete-selected-list":""}],["div",{"class":"input","contenteditable":"","fox-autocomplete-input":"","data-placeholder":""},[],[["placeholder","data-placeholder",true]]],["ul",{"class":"dropdown-list","fox-autocomplete-result-list":""}],["i",{"class":"arrow"}]]]]);
fox.registerTemplate("autocomplete2_multipleselect_keywords_selected_list_item", [["div",{"class":"tag"},[["span",{"class":"close delete","fox-autocomplete-filter-result":""},[["i",{"class":"icon-mc_other_close-delete"}]],[["id","fox-autocomplete-filter-result",true]]],["textNode",{"text":" "}],["span",{},[],[["name","__text",true]]],["textNode",{"text":" "}]]]]);
fox.registerTemplate("autocomplete2_multipleselect_keywords_list_item", [["li",{"class":"option-item","fox-autocomplete-result-item":"","fox-autocomplete-search-result":""},[["span",{},[],[["name","__text",true]]]],[["id","fox-autocomplete-search-result",true]]]]);
fox.registerTemplate("our_sites_model_empty_item", [["div",{"class":"search-failed","style":"display: block;font-size: 18px; color: #424242; font-weight: bold"},[["p",{},[["textNode",{"text":"More Models coming soon! Stay tuned!"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("counter_thousand_item", [["div",{"class":"counter-item thousand-item"},[["i",{"class":"rivets rivets-top"}],["span",{},[],[["digit","__text",true]]],["i",{"class":"rivets rivets-bottom"}]]]]);
fox.registerTemplate("counter_item", [["div",{"class":"counter-item"},[["i",{"class":"rivets rivets-top"}],["span",{},[],[["digit","__text",true]]],["i",{"class":"rivets rivets-bottom"}]]]]);
fox.registerTemplate("last_model_site", [["span",{"class":"model-site-info"},[["span",{"class":"text text-last"},[["textNode",{"text":"Last site added:"}]]],["div",{"class":"model-avatar"},[["a",{"href":"http://&&0&&","target":"_blank"},[["if",{"notempty":""},[["img",{"src":"","alt":""},[],[["aboutMe._avatarPath","src",true],["clientId.name","alt",true]]],["else",{},[["img",{"src":"" + __webpack_require__(18) + "","alt":""},[],[["clientId.name","alt",true]]]]]],[["aboutMe._avatarPath","notempty",true]]]],[["site.primaryDomain.domain","href"]]]]],["span",{"class":"text text-added-data"},[["span",{},[],[["mcpSubscription.partnerMcp.activateDate","__text",true,[{"name":"dateFormat","params":["%e %b, %Y"]}]]]]]]]],["textNode",{"text":" "}],["a",{"href":"http://&&0&&","class":"text-model-name","target":"_blank"},[["span",{"class":"text-model-name"},[["span",{},[],[["clientId.name","__text",true]]]]]],[["site.primaryDomain.domain","href"]]]]);
fox.registerTemplate("our_sites_model", [["figure",{"class":"model"},[["a",{"href":"http://&&0&&","target":"_blank"},[["if",{"notempty":""},[["div",{"style":"background-image: url(&&0&&)","alt":""},[],[["mcpSubscription._avatar","style"],["clientId.name","alt",true]]],["else",{},[["div",{"style":"background-image: url(" + __webpack_require__(18) + ")","alt":""},[],[["clientId.name","alt",true]]]]]],[["mcpSubscription._avatar","notempty",true]]],["figcaption",{},[["span",{},[],[["clientId.name","__text",true]]]]]],[["site.primaryDomain.domain","href"]]]]]]);
fox.registerTemplate("promo_home_page", [["section",{"id":"home-block","class":"home-block sites-block content-section block-watch block-watch-url","data-name":"home"},[["div",{"class":"content-block"},[["div",{"id":"home-carousel","class":"slides"},[["div",{"class":"slide slide-home slide-home-welcome"},[["div",{"class":"slide-text-block"},[["p",{"class":"text1"},[["textNode",{"text":"Welcome to"}]]],["p",{"class":"text2"},[["span",{"class":"col-1"},[["textNode",{"text":"[PROGRAMM]"}]]]]],["p",{"class":"text3"},[["textNode",{"text":"The next level of solo model"}]]],["p",{"class":"text4"},[["textNode",{"text":"affiliate programs!"}]]]]]]]]],["div",{"class":"scroll-down dnone-i"},[["i",{"class":"scroll-down-icon","data-name":"features"}],["textNode",{"text":" "}],["span",{"class":"scroll-down-text"},[["textNode",{"text":"Scroll down"}]]]]]]]]],["section",{"id":"features-block","class":"features-block content-section block-watch block-watch-url","data-name":"features"},[["div",{"class":"content-block"},[["h1",{},[["textNode",{"text":"Features"}]]],["div",{"id":"features-carousel","class":"info-items"},[["div",{"class":"info-item info-content"},[["div",{"class":"info-icon info-content-icon"}],["h3",{"class":"info-title"},[["textNode",{"text":"Model managed sites"}]]],["p",{"class":"info-text"},[["textNode",{"text":" All our sites are model managed which means: Live Interaction, Candids, Personal Feel, and more Rebills! "}]]]]],["div",{"class":"info-item info-revshare"},[["div",{"class":"info-icon info-revshare-icon"}],["h3",{"class":"info-title"},[["textNode",{"text":"50% from joins & rebills"}]]],["p",{"class":"info-text"},[["textNode",{"text":" Get 50% of all sales and rebills that you send to our sites "}]]]]],["div",{"class":"info-item info-referral"},[["div",{"class":"info-icon info-referral-icon"}],["h3",{"class":"info-title"},[["textNode",{"text":"Model referral"}]]],["p",{"class":"info-text"},[["textNode",{"text":" Invite models to create a fan club and get rewarded with 10% of our share on all sales "}]]]]],["div",{"class":"info-item info-payouts"},[["div",{"class":"info-icon info-payout-icon"}],["h3",{"class":"info-title"},[["textNode",{"text":"Weekly payouts"}]]],["p",{"class":"info-text"},[["textNode",{"text":" Get paid weekly, the way you like - Wire, Check, Paxum, SEPA, ACH "}]]]]]]]]]]],["section",{"id":"our-models-block","class":"models-block content-section block-watch block-watch-url","data-name":"our-sites"},[["div",{"class":"models-block-bg"},[["div",{"class":"content-block"},[["div",{"class":"models-counter"},[["span",{"class":"text text-first"},[["textNode",{"text":"We are"}]]],["div",{"class":"counter"}],["span",{"class":"text text-second"},[["span",{"class":"text-second-w1"},[["textNode",{"text":"models "}]]],["textNode",{"text":" "}],["span",{"class":"small-text text-second-w2"},[["textNode",{"text":"strong!"}]]]]]]],["div",{"class":"last-model-site"}]]]]]]],["section",{"id":"model-sites-block","class":"model-sites-block content-section block-watch block-watch-url","data-name":"our-modelsites"},[["div",{"class":"content-block"},[["h1",{},[["textNode",{"text":"Our sites"}]]],["div",{"class":"link-block tcenter"},[["a",{"href":"../oursites","class":"link-icon icon-list"},[["i"],["textNode",{"text":"View full list"}]]]]],["div",{"class":"filter-models"}],["div",{"id":"sites-carousel","class":"list-models"},[["figure",{"class":"model"},[["a",{},[["div"]]]]],["figure",{"class":"model"},[["a",{},[["div"]]]]],["figure",{"class":"model"},[["a",{},[["div"]]]]],["figure",{"class":"model","style":"padding-bottom:7px"},[["a",{},[["div"],["figcaption"]]]]]]]]]]],["section",{"id":"subscribe-block","class":"subscribe-block content-section","data-name":"subscribe"},[["div",{"class":"content-block"},[["h2",{},[["textNode",{"text":"Subscribe via email"}]]],["div",{"id":"subscribe-form-container","class":"subscribe"},[["form",{"id":"subscribe-form","autocomplete":"off"},[["label",{"class":"input input-white name-subscribe"},[["input",{"id":"subscribe-name","type":"text","name":"name","placeholder":"Your name*"}]]],["textNode",{"text":" "}],["label",{"class":"input input-white email-subscribe"},[["input",{"id":"subscribe-email","type":"text","name":"email","placeholder":"Your email*"}]]],["textNode",{"text":" "}],["input",{"id":"subscribe-group","type":"hidden","name":"group","value":""}],["textNode",{"text":" "}],["button",{"type":"submit","class":"btn btn-primary btn-subscribe","value":"Subscribe"},[["textNode",{"text":"Subscribe"}]]]]],["p",{"class":"subscribe-agree _m-t-5 _fs-12"},[["textNode",{"text":"By subscribing you agree to receive communication and promotional emails from ModelCentro family of products"}]]]]]]]]],["section",{"id":"promo-tools-block","class":"promotools-block content-section block-watch block-watch-url","data-name":"promo-tools"},[["div",{"class":"promotools-block-bg"},[["div",{"class":"content-block"},[["h1",{},[["textNode",{"text":"Promo tools"}]]],["div",{"class":"link-block tcenter"},[["p",{"class":"mobile-tools"},[["textNode",{"text":"All promo tools are mobile friendly"}]]]]],["div",{"id":"promotools-carousel","class":"info-items"},[["div",{"class":"info-item"},[["div",{"class":"info-icon info-freehosted-icon"}],["h3",{"class":"info-title"},[["textNode",{"text":"Free hosted galleries"}]]],["p",{"class":"info-text"},[["textNode",{"text":" Every site has a selection of pre made galleries. Let us do the hosting for you! "}]]],["button",{"type":"button","class":"btn btn-primary btn-sm btn-trans dnone-i"},[["textNode",{"text":"More info &raquo;"}]]]]],["div",{"class":"info-item"},[["div",{"class":"info-icon info-embed-icon"}],["h3",{"class":"info-title"},[["textNode",{"text":"Downloadable content"}]]],["p",{"class":"info-text"},[["textNode",{"text":" Fill your site with pictures of beautiful girls or select galleries by niche to easily find the best photos for your site. "}]]],["button",{"type":"button","class":"btn btn-primary btn-sm btn-trans dnone-i"},[["textNode",{"text":"More info &raquo;"}]]]]],["div",{"class":"info-item"},[["div",{"class":"info-icon info-cards-icon"}],["h3",{"class":"info-title"},[["textNode",{"text":"Banners"}]]],["p",{"class":"info-text"},[["textNode",{"text":" Various hosted and downloadable banners are available for quality promotion. "}]]],["button",{"type":"button","class":"btn btn-primary btn-sm btn-trans dnone-i"},[["textNode",{"text":"More info &raquo;"}]]]]]]]]]]]]],["section",{"id":"signup-block","class":"signup-block content-section block-watch block-watch-url","data-name":"registration"},[["div",{"class":"content-block"},[["h1",{},[["textNode",{"text":" Sign up now! "}],["p",{"class":"subhead"},[["textNode",{"text":"and start making money"}]]]]],["div",{"class":"signup-wrap","id":"signup-form-wrapper"}],["div",{"class":"signup-img"}]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./advancedFilter.js": 194,
	"./home/home/registration.js": 195,
	"./layout/auth.js": 196,
	"./layout/promo.js": 197,
	"./login/switcher.js": 198,
	"./login/wizard.js": 199,
	"./multipleAutocompleteSelect.js": 200,
	"./sitepage/filter.js": 202,
	"./sitepage/home/home.js": 203,
	"./sitepage/oursites/oursites.js": 209,
	"./sitepage/passRecovery/form.js": 210,
	"./sitepage/promo.js": 211
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 193;

/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';

	fox.registerWidget('AdvancedFilter', {

		configure: function () {

			this.registerOptions('', {
				autoRender: true,
				template: 'advancedFilter',
				'embed.container': '.filter-wrapper',
				handleDom: {
					toggle: {
						target: '.filter-title',
						event: 'click',
						callback: 'toggleFilter'
					},
					applyFilters: {
						target: '#set-filter',
						event: 'click',
						callback: 'apply'
					},
					reset: {
						target: '#reset-filter',
						event: 'click',
						callback: 'reset'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		addedToDom: function() {
			this.fromNavigator();
		},

		running: function () {
			this.isOpened = false;
			this.callParent('running', arguments);
		},


		toggleFilter: function (el) {
			fox.dom[(this.isOpened ? 'removeClass' : 'addClass')]('expanded', this.dom1('.advanced-filter'));
			this.isOpened = !this.isOpened;
		},

		collectData: function () {
			this.filters = {};

			fox.each(this.dom('input[name]'), function (input) {
				input = fox.dom.wrap(input);
				if (fox.isEmpty(input.val())) {
					delete this.filters[input.attr('name')];
				}
			}, this);

			fox.each(this.dom('input[name]:checked'), function (input) {
				input = fox.dom.wrap(input);
				this.filters[input.attr('name')] = input.val().split(',');
			}, this);

			fox.each(this.wom('~.Control_Select'), function (w) {
				if (!fox.isEmpty(w.getValue())) {

					this.filters[w.getAlias()] = fox.isArray(w.getValue()) ? 
					w.getValue() :
					w.getValue().split(',');
				} else {
					delete this.filters[w.getAlias()];
				}
			}, this);

			fox.each(this.wom('~.Autocomplete2'), function (w) {
				if (!fox.isEmpty(w.getValue())) {
					this.filters[w.getAlias()] = w.getValue();
				} else {
					delete this.filters[w.getAlias()];
				}
				
			}, this);

			return this.filters;
		},

		apply: function () {
			this.collectData();
			this.toNavigator();
			this.dispatchEvent('apply', this.filters);
		},

		reset: function () {
			this.filters = {};

			fox.each(this.dom('input[name]'), function (input) {
				input.value = '';
			}, this);

			fox.each(this.wom('~.Control_Select'), function (w) {
				w.reset();
			}, this);

			fox.each(this.wom('~.Autocomplete2'), function (w) {
				w.reset();
			}, this);

			this.dispatchEvent('reset');
		},

		setValue: function () {

			if (fox.isObject(arguments[0])) {
				fox.each(arguments[0], function (val, alias) {
					this._setValue(alias, val, (arguments[1] || {}));
				}, this);
				return;
			}

			if (fox.isString(arguments[0]) && !fox.isEmpty(arguments[1])) {
				this._setValue(arguments[0], arguments[1], (arguments[2] || {}));
				return;
			}
		},

		_setValue: function (alias, value, params) {
			var w = this.wom1('#' + alias);

			if (!w) {
				var input = this.dom('input[name]');

				fox.each(input, function(el){
					if (el.type === ('checkbox')) {
						if (el.value === value.join(',')) {
							el.checked = true;
						}
					} else {
						el.value = value;
					}

				}, this);
				return;
			}

			if (fox.oop.instanceOf(w, 'Control_Select')) {
				w.setValue(value);
				return;
			}

			if (fox.oop.instanceOf(w, 'Autocomplete2_MultipleSelect')) {
				if (w.wom1('#list').isEmbedded()){
					w.setValue(value, params);
				} else {
					this.waitEvent(w.wom1('#list'), 'addedToDom', function(){
						w.setValue(value, params);
					}, this);
				}

				return;
			}

			if (fox.oop.instanceOf(w, 'Autocomplete2')) {
				w.fillInput(value);
				w.search(value);

				return;
			}
		},

		toNavigator: function() {
			fox.Navigator.reset();
			fox.Navigator.set(0, 'oursites');
			fox.Navigator.bulkSet(this.filters);
		},
		
		fromNavigator: function () {
			var res = {}; 
			this.filters = {};
			fox.each(fox.Navigator.getAll(), function(val, key) {
				if (!fox.isNumeric(key)) {
					this.setValue(key, val.split(","));
					this.filters[key] = val.split(",");
				}
			}, this);

			this.dispatchEvent('apply', this.filters);

		},

	}, 'Widget');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';

	//var EXO_UDID = require('../../../../../common-components/verification-form/exo-udid')(fox);
	var EXO_UDID = __webpack_require__(16)(fox);

	fox.registerWidget('Home_Registration', {
		configure: function(options) {
			this.registerOptions('', {
				autoRender: true,
				template: 'home_registration',
				container: '#signup-form-wrapper',
				widgets: {
					signupForm: {
						widget: 'Form',
						formContainer: '#signup-form',
						formElements: {
							userName: {
								element: '[name="userName"]',
								defaultValue: ''
							},
							firstName: {
								element: '[name="firstName"]',
								defaultValue: ''
							},
							lastName: {
								element: '[name="lastName"]',
								defaultValue: '',
							},
							affiliateUrl: {
								element: '[name="affiliateUrl"]',
								defaultValue: '',
								validate: [
									{
										validator: 'regexp',
										options: {regexp: fox.regexp.url},
										message: 'Wrong domain name format'
									}
								]
							},
							email: {
								element: '[name="email"]',
								defaultValue: '',
								autoApply: true,
								validate: [{validator: 'regexp', options: {type: 'emailCaseInsensitive'}, message: 'Wrong email format'}]
							},
							consent_tos: {
								element: '[name="consent_tos"]',
								defaultValue: false,
							},
							consent_marketing: {
								element: '[name="consent_marketing"]',
								defaultValue: false,
							}
						},
						methods: {
							send: 'affiliate.whitelabel.register',
							sendMethod: 'post',
							encodePost: true
						},
						submit: {
							target: '#signup-form',
							event: 'submit'
						},
						'widgets.validator': {
							widget: 'Easy_Form_Validator',
							formWidget: '@parent',
							hangClassLocation: 'parentNode',
							requiredFields: ['userName','firstName','lastName','email', 'consent_tos', 'affiliateUrl'],
							defaultValidator: [{
								validator: 'length',
								options: {min: 1},
								message: 'Please fill in required fields'
							}]
						},
						hooks: {
							onResponse: '@parent:formIsSubmitted',
							onSubmit: '@parent:formSubmit',
							// onStopPrepareValues: function(form) {
							// 	form._preparedValues.udid = this._udid;
							// 	console.log('onPreparevalues', form._preparedValues);
							// }.bind(this)
						},
						handleWom: {
							formError: {
								event: 'formNotValid',
								widget: '@this #validator',
								callback: '@parent:formNotValid'
							}
						}
					}
				},
				handleDom: {
					focus: {
						target: 'input[name]',
						event: 'focus',
						callback: '_handleFocus'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function (argument) {
			this.form = this.rwom1('#signupForm');
			this.notices = fox.wom.selectFirst('~#throughNotifications');
			this.callParent('running', arguments);
		},

		_handleFocus: function (el) {
			$(el).parent().removeClass('error').find('.error-container').text('');
		},

		formIsSubmitted: function (response) {
			var button = fox.dom.selectFirst('.button-with-spinner', this.element);
			this.form.ignoreSubmit(false);

			if (response.type === 'error' && response.answer.answer !== '50102') {
				if (Number(response.answer.answer.code) === 50102) {
					this.wom1('@parent #warningPopup').show();
				} else {
					this.notices.pushNotification({
						noticeTemplate: 'new_notice',
						noticeType: 'error',
						noticeMessage: response.answer.answer.reason,
						noticeAlias: 'signupError',
						delayClose: 3000
					});
				}
				fox.dom.removeClass('spin', button);
				return;
			}
			window.location.reload();
		},

		formSubmit: function () {
			this.getUDID().then(function(_udid) {
				var button = fox.dom.selectFirst('.button-with-spinner', this.element);
				this.form._preparedValues.udid = _udid;

				this.form.submit();
				this.form.ignoreSubmit(true);
				
				fox.dom.addClass('spin', button);
			}.bind(this));
		},

		formNotValid: function (errorsObj) {
			fox.each(errorsObj.errorStack, function (arr, name) {
				var err = arr[0];

				$(this.dom1('[name="' + name + '"]'))
					.parent()
					.find('.error-container')
					.text(err.message);
			}, this);
		},

		getUDID: function() {
            return EXO_UDID.getShortUid();
		},

	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {

	fox.registerWidget('Layout_Promo_Auth', {

		configure: function(options) {
			this.registerOptions('', {
				template: 'layout_promo_auth'
			});

			this.callParent('configure', arguments);
		}

	}, 'Layout_Promo');
})(fox, jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	fox.registerWidget('Layout_Promo', {

		configure: function(options) {
			this.registerOptions('', {
				widgets: {
					throughNotifications: {
						widget: 'ThroughNotifications',
						doNotTrackPosNote: true
					},
						
					header: {
						widget: 'Widget',
						autoRender: true,
						embed: {
							container: '.header-container',
							location: 'firstChild'
						},
						template: 'promo_header',
						handleDom: {
							menuOpen: {
								target: '.menu-open',
								event: 'click',
								callback: '@parent:toggleMenu'
							},
							menuClose: {
								target: '.menu-close',
								event: 'click',
								callback: '@parent:toggleMenu'
							},
							menuClick: {
								target: '.menu-link',
								event: 'click',
								callback: '@parent:toggleMenu'
							}
						},
						handleWom: {
							addToDom: {
								event: 'addedToDom',
								widget: '@this',
								callback: '@parent:initHeader'
							}
						}
					},
					footer: {
						widget: 'Widget',
						autoRender: true,
						container: '#promo-footer',
						template: 'promo_footer',
						templateOptions: {
							year: new Date().getFullYear()
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		initHeader: function() {
			var header = this.dom1('#promo-header');
			this.headerWrap = header;

			var transitionEvent = this.whichTransitionEvent();
			header.addEventListener(transitionEvent, function(el) {
				if (!fox.dom.hasClass('open', el.target)) {
					fox.dom.removeClass('bgc', el.target);
				}
			}, false);
		},

		whichTransitionEvent: function() {
			var t,
				el = this.headerWrap;

			var transitions = {
				"transition"      : "transitionend",
				"OTransition"     : "oTransitionEnd",
				"MozTransition"   : "transitionend",
				"WebkitTransition": "webkitTransitionEnd"
			};

			for (t in transitions){
				if (el.style[t] !== undefined){
					return transitions[t];
				}
			}
		},

		toggleMenu: function(el, alias, w, e) {
			fox.dom.event.stop(e);

			if (alias === 'menuOpen') {
				fox.dom.addClass('open', this.headerWrap);
				fox.dom.addClass('bgc', this.headerWrap);
			} else {
				fox.dom.removeClass('open', this.headerWrap);
			}
		}

	}, 'Site_Layout');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";
	fox.registerWidget('Login_Forgot_Switcher', {
		configure: function(options) {
			this.registerOptions('', {
				template: 'div.form-container.common-content',
				widgets: {
					login: {
						widget: 'MCP_Login_Wizard',
						
						// group: 'authForm',
						// autoRender: true,
						// container: '.form-container',
						// template: 'login_form',
						// handleDom: {
							// switchForgotPass: {
								// target: '#change-form-forgot',
								// event: 'click',
								// callback: '@parent:switchToForgot'
							// }
						// }
					},

					// forgotPass: {
					// 	widget: 'PassRecovery_Form',
					// 	active: false,
					// 	group: 'authForm',
					// 	autoRender: true,
					// 	container: '.form-container',
					// 	template: 'forgot_form',
					// 	handleDom: {
					// 		switchLogin: {
					// 			target: '#change-form-login',
					// 			event: 'click',
					// 			callback: '@parent:switchToLogin'
					// 		}
					// 	}
					// }
				}
			});

			this.callParent('configure', arguments);
		},

		switchToForgot: function() {
			this.switchEmbeddedWidget('forgotPass');
		},

		switchToLogin: function() {
			this.switchEmbeddedWidget('login');
		},

		deactivate: function() {
			this.callParent('deactivate', arguments);
			this.switchEmbeddedWidget('login');
		}


	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";
	fox.registerWidget('MCP_Login_Wizard', {

		configure: function(options) {
			this.registerOptions('', {
				'widgets.login.widget': 'MCP_Login_Wizard_LoginForm',
				'widgets.forgotPassword.widget': 'MCP_Login_Wizard_ForgotForm',
				'widgets.phoneNumberAuth.widget': 'MCP_Verification_Form',
				// 'widgets.phoneNumberAuth': {
				// 	template: 'verification_form',
				// 	//test
				// 	templateOptions: {phone: {number: 'xxxxxxx11'}}
				// },
			});

			this.callParent('configure', arguments);
		},

	}, 'Login_Wizard');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	__webpack_require__(201)(fox);
	
	fox.registerWidget('Autocomplete2_MultipleSelect', {

		configure: function () {
			this.filteredData = [];
			this.selectedData = [];

			this.registerOptions('', {
				
				loadAll: true,
				staticFilter: true,
				returnParam: 'id',
				widgets: {
					input: {
						'embed.container': '.niches-wrapper',
						template: 'autocomplete2_multipleSelect',
						templateOptions: {
							placeholder: '',
						}
					},
					'list.tpl.row': 'autocomplete2_multipleSelect_list_item',
					selectedList: {
						widget: 'List',
						embed: {
							widget: '@parent #input',
							container: '[fox-autocomplete-selected-list]'
						},
						'tpl.row': 'autocomplete2_multipleSelect_selected_list_item'
					}
				},

				handleDom: {
					removeSelected: {
						targetWidget: '#selectedList',
						target: '.delete',
						event: 'click',
						callback: '_removeFromSelectedList'
					},
					focusOnClick: {
						targetWidget: '#input',
						target: '.mc-form-field',
						event: 'click',
						callback: '_focus'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.callParent('running', arguments);

			this.selectedList = this.wom1('#selectedList');
		},

		reset: function () {
			this.selectedData = [];
			this.renderSelectedList();

			//this.resultList.setCollection([]);
			//this.filteredData = fox.clone(this.responseData);
			this.renderResultList(this.responseData);
			this.searchStr = '';
			this.fillInput('');
		},

		deactivate: function () {
			this.callParent('deactivate', arguments);
		},

		_bindKeyboardEvents: function () {
			$(window).on('keyup', {widget: this}, this._onKeydown);

			this.callParent('_bindKeyboardEvents', arguments);
		},

		_onKeydown: function (e) {
			var code = e.keyCode;

			if (fox.inArray([13, 8], code)) {
				e.preventDefault();
			}
		},

		select: function (node) {
			node = fox.dom.wrap(node);
			this.dispatchEvent('search_form_submit');

			this.moveToSelectedList(node.attr('fox-autocomplete-search-result'));
			this.renderSelectedList();
		},

		renderResultList: function (data) {
			this.prepareResultList(data);
			this.resultList.setCollection(this.filteredData, true);
		},

		prepareResultList: function (data) {
			this.filteredData = data.filter(function (item) {
				var result = true;

				fox.each(this.selectedData, function (selectedItem) {
					if (selectedItem.id === item.id) {
						result = false;
					}
				}, this);

				return result;
			}.bind(this));
		},

		moveToSelectedList: function (item) {
			var i;

			item = fox.isString(item) && fox.isNumeric(item) ? window.parseInt(item) : item;

			fox.each(this.filteredData, function (data, n) {

				if (data.id === item) {
					this.selectedData.push(data);
					i = n;
				}
			}, this);

			if (!fox.isEmpty(i)) {
				this.filteredData.splice(i, 1);
			}
			
			this.renderResultList(this.filteredData);
		},

		renderSelectedList: function () {
			this.selectedList.setCollection(this.selectedData, true);
		},

		_removeFromSelectedList: function (node) {
			node = fox.dom.wrap(node);//
			var attr = node.attr('fox-autocomplete-filter-result');

			attr = fox.isString(attr) && fox.isNumeric(attr) ? window.parseInt(attr) : attr;

			this.selectedData = this.selectedData.filter(function (data) {
				if (data.id === attr) {
					return false;
				}
				return true;
			}.bind(this));

			this.renderSelectedList();
			this.filterData();
		},

		hideList: function () {
			fox.dom.removeClass('opened', this.input.dom1('.dropdown'));
		},

		showList: function () {
			fox.dom.addClass('opened', this.input.dom1('.dropdown'));
		},

		_focus: function (el, alias, w, e) {
			fox.dom.event.stop(e);

			if (typeof e.stopPropagation !== "undefined") {
				e.stopPropagation();
			} else if (typeof e.cancelBubble !== "undefined") {
				e.cancelBubble = true;
			}

			w.dom1('[fox-autocomplete-input]').focus();
		},

		getValue: function () {
			var param = this.getOption('returnParam');

			if (!param) {
				return this.selectedData;
			}
			
			return this.selectedData.map(function (item){
				return item[param];
			});
		},

		setValue: function (values, returnParam) {
			fox.each(values, function (val) {
				this.moveToSelectedList(val);
			}, this);

			this.renderSelectedList();
		}

	}, 'Autocomplete2');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	fox.registerWidget('Autocomplete2', {

		configure: function (argument) {
			this.searchStr = '';
			this.responseData = [];
			this.inputTimer = null;
			this.filteredData = null;

			this.registerOptions('', {
				//useCache: false,
				searchParam: 'name',
				hightlightSelector: '.name',
				loadAll: false,
				staticFilter: false,
				filterParam: 'alias',

				widgets: {
					api: {
						widget: 'Api',
						method: 'Portal.searchModels'
					},

					input: {
						widget: 'Widget',
						autoRender: true,
						container: '.form-group.search',
						template: 'catalog_search_input'
					},

					list: {
						widget: 'List',
						autoRender: false,
						embed: {
							widget: '@parent #input',
							container: '[fox-autocomplete-result-list]'
						},
						'tpl.row': 'catalog_search_item',
						'hooks.onAddedToDom': fox.bind(function () {
							this._listAdded();
						}, this)
					}
				},

				handleWom: {
					handleApiStateChange: {
						widget: '#api',
						event: ['prepare', 'success', 'failure', 'loading', 'loaded', 'loadError'],
						callback: '_handleApiStateChange'
					},
					searchFailure: {
						widget: '@this',
						event: ['search_failure'],
						callback: '_handleSearchFailure'
					},
					searchSuccess: {
						widget: '@this',
						event: ['search_success'],
						callback: '_handleSearchSuccess'
					},
					itemSelected: {
						widget: '@this',
						event: ['item_selected'],
						callback: '_handleItemSelect'
					},
					inputEmptyState: {
						widget: '@this',
						event: ['inputEmpty', 'inputNotEmpty'],
						callback: '_handleInputEmptyState'
					}
				},

				handleDom: {
					selectFromList: {
						targetWidget: '#list',
						target: '[fox-autocomplete-result-item]',
						event: 'click',
						callback: '_handleSelectClick'
					},
					searchFormSubmit: {
						targetWidget: '#input',
						target: 'form[fox-autocomplete-form]',
						event: 'submit',
						callback: '_onFormSubmit'
					},
					searchFormSubmit2: {
						targetWidget: '#input',
						target: '.icon.search-start',
						event: 'click',
						callback: '_onFormSubmit'
					},
					inputChange: {
						targetWidget: '#input',
						target: '[fox-autocomplete-input]',
						event: 'input',
						callback: '_handleInputChange'
					},
					clear: {
						targetWidget: '#input',
						target: '.icon.clear',
						event: 'click',
						callback: 'clear'
					},
					_bindKeyboardEvents: {
						targetWidget: '#input',
						target: '[fox-autocomplete-input]',
						event: 'focus',
						callback: '_bindKeyboardEvents'
					},
					// _bindKeyboardEvents2: {
					// 	targetWidget: '#input',
					// 	target: '[fox-autocomplete-input]',
					// 	click: 'click',
					// 	callback: function (el, alias, w, e) {
					// 		fox.dom.event.stop(e);

					// 		return false;
					// 	}
					// },
					_unbindKeyboardEvents: {
						targetWidget: '#input',
						target: '[fox-autocomplete-input]',
						event: 'blur',
						callback: '_unbindKeyboardEvents'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.api = this.rwom1('#api');
			this.input = this.rwom1('#input');
			this.resultList = this.rwom1('#list');
			this.hightlightSelector = this.getOption('hightlightSelector');
			this.useCache = false;
			this.isOpened = false;

			this.isFirstLoad = true;

			/*if (this.getOption('useCache')) {
				this.enableCache();
			}*/

			if (this.getOption('loadAll')) {
				this.loadAll();
			}

			//this._bindWindowEvents();

			this.callParent('running', arguments);
		},

		activate: function (argument) {
			//this._bindWindowEvents();

			this.callParent('activate', arguments);
			
			if (this.getOption('loadAll')) {
				this.loadAll();
			}
		},

		deactivate: function (argument) {
			//this._unbindWindowEvents();
			this.reset();
			this._hideList();
			this.callParent('deactivate', arguments);
		},

		reset: function (argument) {
			this.fillInput('');
			this.resultList.setCollection(this.responseData);

			this.searchStr = '';
			this.cachedData = {};

			this.isFirstLoad = true;

			if (!this.getOption('staticFilter')) {
				this.responseData = {};
				this.resultList.setCollection([]);
			}
		},

		enableCache: function () {
			this.clearCache();
			this.useCache = true;
		},

		disableCache: function () {
			delete this.cachedData;

			this.useCache = false;
		},

		clearCache: function () {
			this.cachedData = {};
		},

		getCachedData: function () {
			return this.cachedData;
		},

		prepareSearchParams: function (value) {
			var params = {};
			
			if (this.apiIsDl()) {
				//set params for datalayer

				return {};
			}

			params[this.getOption('searchParam')] = value;

			return params;
		},

		loadData: function (value) {
			var params = this.prepareSearchParams(value);

			if (this.apiIsDl()) {
				this.prepareSearchParams(value);
				this.api.load();

				return;
			}

			this.api.send(params);
		},

		_loadAll: function () {
			this.hookWrapper('loadAll');
		},

		loadAll: function () {
			this.loadData('');
			//this.waitEvent(this, ['search_success'], this._handleLoadAll)
		},

		search: function (value) {
			//this.searchStr = value;

			if (this.useCache && this.isInCache(value)) {
				this.getFromCache(value);

				return;
			}

			this.loadData(value);
		},

		clear: function () {
			this.fillInput('');
			this.clickedNode = null;
			this._hideList();
			this.dispatchEvent('search_form_submit');

			this.isFirstLoad = true;

			if (this.getOption('loadAll')) {
				this.loadAll();
			}
		},

		_onFormSubmit: function (el, w, alias, e) {
			fox.dom.event.stop(e);

			if (this.listPointer < 0) {
				this.dispatchEvent('search_form_submit');
				this.hideList();
			}

			return false;
		},

		getSearchString: function (argument) {
			return this.searchStr;
		},

		isInCache: function (value) {
			return this.cachedData[value] || false;
		},

		getFromCache: function (value) {
			////console.log('from cache', this.cachedData[value]);
			this.responseData = this.cachedData[value];

			this.dispatchEvent('search_success', this.responseData);
		},

		_handleApiStateChange: function (response, api, e) {
			if (fox.inArray(['prepare', 'loading'], e)) {
				this._showLoader();
				this.apiInProgress = true;

				return;
			}

			this._hideLoader();
			this.apiInProgress = false;

			var answer = response.answer;

			if (fox.inArray(['failure', 'error', 'loadError'], e)) {
				this.dispatchEvent('search_failure', answer);

				return;
			}

			if (this.useCache) {
				this.cachedData[this.searchStr] = answer.response;
			}

			this.responseData = this.apiIsDl() ? api.getCollection() : answer.response;

			this.isFirstLoad = false;

			this.hookWrapper('prepareResponse');

			if (!fox.isArray(this.responseData)) {
				this.responseData = fox.toArray(this.responseData);
			}

			if (!this.getOption('staticFilter')) {
				this.dispatchEvent('search_success', this.responseData);

				return;
			}

			this.filteredData = fox.clone(this.responseData);
			this.dispatchEvent('search_success', this.filteredData);
		},

		_showLoader: function () {
			this.dispatchEvent('loader_show');
			this.hookWrapper('toggleLoader', true);
		},

		_hideLoader: function () {
			this.dispatchEvent('loader_hide');
			this.hookWrapper('toggleLoader', false);
		},

		toggleLoader: function (state) {
			var loader = this.input.dom1('.preloader');

			fox.dom[(state ? 'addClass' : 'removeClass')]('spin', loader);
		},

		_showList: function () {
			if (!this.responseData.length) {
				return;
			}

			if (this.getOption('staticFilter') && !this.filteredData.length) {
				return;
			}

			this._bindWindowEvents();
			this.hookWrapper('showList');
			this.isOpened = true;
		},

		showList: function () {
			////console.warn('show list');
			fox.dom.addClass('show', this.input.dom1('.autocomplete-list'));
		},

		_hideList: function () {
			this.hookWrapper('hideList');
			this.isOpened = false;
			this._unbindWindowEvents();
		},

		hideList: function () {
			////console.warn('hide list');
			fox.dom.removeClass('show', this.input.dom1('.autocomplete-list'));
		},

		_handleSearchFailure: function (answer) {
			////console.warn(arguments);
		},

		_handleSearchSuccess: function (data) {
			this.renderResultList(data);
		},

		renderResultList: function (data) {
			this.resultList.setCollection(data, true);
		},

		_handleSelectClick: function (elm, alias, w, e) {
			fox.dom.event.stop(e);

			this.clickedNode = elm;
			this.dispatchEvent('item_selected', elm);

			if (this.getOption('staticFilter')) {
				return;
			}

			this._hideList();
		},

		_handleItemSelect: function (node) {
			this.hookWrapper('select', node);
		},

		_listAdded: function () {
			this.listPointer = -1;

			if (this.getOption('staticFilter')) {
				this._staticListAdded();

				return;
			}

			if (this.responseData && this.responseData.length) {
				this.resultItems = this.resultList.dom('[fox-autocomplete-result-item]');

				if (this.getOption('loadAll') && this.isFirstLoad === true) {
					return;
				}

				if (this.isFocus) {
					this._showList();
				}
				
				this.hightlightResult();

				return;
			}

			this._hideList();
			this.resultItems = [];
		},

		_staticListAdded: function () {
			this.resultItems = [];

			if (!!this.filteredData && this.filteredData.length) {
				this.resultItems = this.resultList.dom('[fox-autocomplete-result-item]');

				return;
			}

			this._hideList();
		},

		select: function (node) {
			this.dispatchEvent('search_form_submit');

			this.fillInput($(this.clickedNode).attr('fox-autocomplete-search-result'));
			this.hideList();
		},

		fillInput: function (str) {
			var elm = this.input.dom1('[fox-autocomplete-input]');
			elm[elm.tagName.toLocaleLowerCase() === 'input' ? 'value' : 'innerText'] = str;
			this.searchStr = str;

			this.dispatchEvent(str.length > 0 ? 'inputNotEmpty' : 'inputEmpty');
		},

		_handleInputChange: function (el) {
			var str = el.tagName.toLocaleLowerCase() === 'input' ? fox.trim(el.value) : fox.trim(el.innerText);

			if (this.apiInProgress) {

				this.waitEvent(this.wom1('#api'), ['success', 'loaded'], fox.bind(function (argument) {
					this._handleInputChange(el);
				}, this));
				
				return;
			}

			this.dispatchEvent(str.length > 0 ? 'inputNotEmpty' : 'inputEmpty');

			this.searchStr = str;

			if (this.getOption('staticFilter')) {
				this.filterData();
				
				return;
			}

			if (!str.length) {
				this._hideList();

				if (this.getOption('loadAll')) {
					this.loadAll();
				}
				
				return;
			}

			if (this.inputTimer) {
				window.clearInterval(this.inputTimer);
			}

			this.inputTimer = window.setTimeout(fox.bind(function (argument) {
				this.search(this.searchStr);
			}, this), 500);
		},

		hightlightResult: function () {
			if (!this.hightlightSelector) {
				return;
			}

			fox.each(this.resultItems, function (elt) {
				var $target = $(elt).find(this.hightlightSelector);
				var txt = $target.text();
				var matches = txt.match(new RegExp(this.searchStr, 'gi'));
				var split = txt.split(new RegExp(this.searchStr, 'gi'));
				var result = '';

				fox.each(matches, function (part, i) {
					result += split[i] + '<span class="hl hl-' + i + '">' + part + '</span>';
				}, this);

				if (matches) {
					result += split[matches.length];	
				}

				$target.html(result);
			}, this);
		},

		_close: function (e) {
			console.log('_close');
			var container = $(e.data.el);

			if (e.type === 'keyup') {
				if (e.keyCode && e.keyCode === 27) {
					e.data.widget._hideList();
				}

				return;
			}

			if (!container.length) {
				e.data.widget._hideList();

				return;
			}

			if (!container.is(e.target) &&
				container.has(e.target).length === 0 &&
				e.data.widget.isOpened) {
					e.data.widget._hideList();
			}

		},

		_bindWindowEvents: function (argument) {
			var data = {widget: this};
			var elm = this.wom1('#input').dom1('form');

			if (elm) {
				data.el = elm;
			}

			$(window).on('click', data, this._close);
			$(window).on('keyup', data, this._close);
		},

		_unbindWindowEvents: function (argument) {
			$(window).off('click', this._close);
			$(window).off('keyup', this._close);
		},

		_bindKeyboardEvents: function () {
			$(window).on('keyup', {widget: this}, this._onKeyup);

			if (this.getOption('staticFilter') && this.filteredData.length) {
				this._showList();
			}

			this.isFocus = true;
		},

		_unbindKeyboardEvents: function (argument) {
			$(window).off('keyup', this._onKeyup);

			this.isFocus = false;
		},

		_onKeyup: function (e) {
			var _this = e.data.widget;
			e.preventDefault();

			if (e.keyCode === 38) {
				_this._kbPrev();
			}

			if (e.keyCode === 40) {
				//down
				_this._kbNext();
			}

			if (e.keyCode === 13) {
				_this._kbSelect();
			}

			return false;
		},

		_kbNext: function () {
			var pointer = ++this.listPointer;

			if (pointer >= this.responseData.length) {
				pointer = 0;
			}

			this._hightlight(pointer);

		},

		_kbPrev: function () {
			var pointer = --this.listPointer;

			if (pointer < 0) {
				pointer = this.responseData.length - 1;
			}

			this._hightlight(pointer);
		},

		_kbSelect: function () {
			if (this.listPointer < 0) {
				return;
			}

			this._handleSelectClick(this.resultItems[this.listPointer]);
		},

		_hightlight: function (ind) {
			this.listPointer = ind;
			this.hookWrapper('hightlight', ind);
		},

		hightlight: function (ind) {

			fox.each(this.resultItems, function (node, i) {
				fox.dom.removeClass('active', node);

				if (i === ind) {
					fox.dom.addClass('active', node);
					this._scrollList(node);
				}
			}, this);
		},

		_scrollList: function (node) {
			var top = $(node).position().top;

			$(this.resultList.element[0].parentNode).scrollTop(top);
		},

		getInputValue: function () {
			return this.wom1('#input').dom1('[fox-autocomplete-input]').value;
		},

		getValue: function () {
			return this.getInputValue();
		},

		apiIsDl: function () {
			return fox.oop.instanceOf(this.api, 'Datalayer');
		},

		filterData: function () {
			if (!this.searchStr.length) {
				this.filteredData = fox.clone(this.responseData);
			} else {
				var param = this.getOption('filterParam');
				this.filteredData = this.responseData.filter(function (obj) {
					if (obj[param] && obj[param].toLocaleLowerCase().match(this.searchStr)) {
						return true;
					}

					return false;
				}.bind(this));
			}

			this.renderResultList(this.filteredData);
		},

		prepareResponse: function () {
			fox.each(this.responseData, function (item) {
				if (fox.isString(item.id) && fox.isNumeric(item.id)) {
					item.id = window.parseInt(item.id);
				}
			});
		},

		_handleInputEmptyState: function (obj, w, e) {
			var cross = this.wom1('#input').dom1('.clear-field');

			if (!cross) {
				return;
			}

			fox.dom[(e === 'inputEmpty' ? 'removeClass' : 'addClass')]('show', cross);
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	fox.registerWidget('AdvancedFilter_ModelsFilter', {

		configure: function () {

			this.registerOptions('', {
				newSelect: true,
				widgets: {
					mcpSubscription_niches_siteNicheId: {
						widget: 'Control_Select_Dynamic',
						container: '.niches-wrapper',
						template: 'control_select_new',
						currentValuePlace :'.current-value',
						customOptions: [{title: 'Niches', value: '', selected: true}],
						'widgets.dl': {
							widget: 'Datalayer',
							method: 'Site.getAvailiableNiches'
						},
						'select.container': '.mc-form-field',
						'hooks.onStopPrepareSelectOptions': function () {
							fox.each(this.selectOptions, function (data) {
								data.title = data.title.ucfirst();
							});
						}
					},

					mcpSubscription_contentCategories_contentCategoryId: {
						widget: 'Control_Select_Dynamic',
						container: '.keywords-wrapper',
						template: 'control_select_new',
						currentValuePlace :'.current-value',
						customOptions: [{title: 'Keywords', value: '', selected: true}],
						'widgets.dl': {
							widget: 'Datalayer',
							method: 'category.get',
							limit: 100,
							transitParameters: {
								preset: 'mcpSite'
							}
						},
						'select.container': '.mc-form-field',
						'hooks.onStopPrepareSelectOptions': function () {
							fox.each(this.selectOptions, function (data) {
								data.title = data.title.ucfirst();
							});
						}
					},
					mcpSubscription_interactionFeatures_interactionFeatureId: {
						widget: 'Control_Select_Dynamic',
						container: '.features-wrapper',
						template: 'control_select_new',
						currentValuePlace :'.current-value',
						customOptions: [{title: 'Features', value: '', selected: true}],
						'widgets.dl': {
							widget: 'Datalayer',
							method: 'Site.getAvailiableInteractionFeatures'
						},
						'select.container': '.mc-form-field',
						'hooks.onStopPrepareSelectOptions': function () {
							fox.each(this.selectOptions, function (data) {
								data.title = data.title.ucfirst();
							});
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.callParent('running', arguments);
		},

		_handleSearchSuccess: function (data, w, e) {
			w.responseData = data[0];
			w.renderResultList(w.responseData);
		},

		_handleInputChange: function (el, alias, w, e) {
			//console.log(arguments)
			var str = fox.trim(el.value);
			var ac = w.wom1('@parent');

			if (!str.length) {
				ac.loadAll();
				ac.clear();
			}
		},

		_searchListAdded: function () {
			var w = this.wom1('#clientId_name');

			w.listPointer = -1;

			if (w.responseData && w.responseData.length) {
				w.resultItems = w.resultList.dom('[fox-autocomplete-result-item]');

				if (w.getOption('loadAll')) {
					return;
				}

				w._showList();
				w.hightlightResult();

				return;
			}

			w._hideList();
			w.resultItems = [];
		},

	}, 'AdvancedFilter');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";
	__webpack_require__(204);

	__webpack_require__(205);
	__webpack_require__(206);
	
	fox.registerWidget('Promo_Home', {
		configure: function(options) {
			this.registerOptions('', {
				template: 'promo_home_page',
				config: {
					owlClass: 'owl-carousel owl-theme',
					blockWatchClass: '.block-watch',
					blockWatchURLClass: '.block-watch-url',
					carousels: {
						features: {
							id: '#features-carousel',
							responsive:{
								320:{
									items:1
								},
								768:{
									items:2,
									slideBy: 2
								},
								1150:{
									items:3
								}
							},
							limitWindowWith: 1150
						},
						promotools: {
							id: '#promotools-carousel',
							responsive:{
								320:{
									items:1
								},
								768:{
									items:2,
									slideBy: 2
								},
								1150:{
									items:3
								}
							},
							limitWindowWith: 1150
						},
						
						sites: {
							id: '#home-carousel',
							margin:0,
							autoplay: true,
							autoplayTimeout:5000,
							autoplaySpeed: 1000,
							/*animateOut: 'fadeOut',*/
							responsive:{
								320:{
									items:1,
									loop:true,
									autoplay:true
								}
							}
						}
					}
				},
				carouselsIsInit: {},
				params: {},
				widgets: {
					subscribeForm: {
						widget: 'Form',
						formContainer: '#subscribe-form',
						formElements: {
							name: {
								element: '[name="name"]',
								defaultValue: ''
							},
							email: {
								element: '[name="email"]',
								defaultValue: '',
								autoApply: true,
								validate: [{validator: 'regexp', options: {type: 'emailCaseInsensitive'}, message: 'Wrong email format'}]
							},
							type: {
								element: '[name="group"]',
								defaultValue: 'mcprofits-subscriber'
							}
						},
						methods: {
							send: 'subscription.subscribe'
						},
						submit: {
							target: '#subscribe-form',
							event: 'submit'
						},
						'widgets.validator': {
							widget: 'Easy_Form_Validator',
							formWidget: '@parent',
							hangClassLocation: 'parentNode',
							requiredFields: ['name', 'email'],
							defaultValidator: [{
								validator: 'length',
								options: {min: 1},
								message: 'Please fill in required fields'
							}]
						},
						hooks: {
							onResponse: '@parent:subscribeFormIsSubmitted',
							onSubmit: '@parent:subscribeFormSubmit'
						},
						handleWom: {
							formError: {
								event: 'formNotValid',
								widget: '@this #validator',
								callback: '@parent:subscribeFormNotValid'
							}
						}
					},
					signupForm: {
						widget: 'Home_Registration'
					},
					warningPopup: {
						widget: 'Dialog',
						template: 'same_account',
						dialog: {
							autoOpen: options.autoOpen || false,
							dialogClass: 'dlg-amc dark-overlay',
							title: 'ERROR',
							closeText: '',
							width: 'auto'
						},
						handleWom: {
							dOnShow: {
								event: 'show',
								widget: '@this',
								'params.prefix': 'uniqPopEvent',
								callback: function () {
									$(fox.dom.selectFirst('.wrapper')).addClass('blured');
								}
							},
							dOnHide: {
								event: 'hide',
								widget: '@this',
								'params.prefix': 'uniqPopEvent',
								callback: function () {
									$(fox.dom.selectFirst('.wrapper')).removeClass('blured');
								}
							}
						}
					},

					sitesDatalayer: {
						widget: 'Datalayer',
						method: 'Partner_McProfits.getModels',
						fields: ['mcpSubscription._avatar', 'site.domain', 'clientId.name', 'aboutMe._avatarPath', 'fcProfile.alias'],
						/*filter: {
							project: {
								fields: ['mcpSubscription.project'],
								values: [1]
							}
						},*/
						metaFields: {
							'totalCount': 1,
							'mcpSubscription.avatar': 1,
							'aboutMe.avatarPath': 1
						},
						limit: 4,
						handleWom: {
							loaded: {
								widget: '@this',
								event: 'loaded',
								callback: function(){
									var lastSite = this.getCollection()[0];
									var totalCount = this.getMetaValue('totalCount');
									this.wom1("@parent #lastSiteAdded").setCollection([lastSite], true);

									this.getParent().renderCounter(totalCount);

								}
							}
						}
					},

					filter: {
						widget: 'AdvancedFilter_ModelsFilter',
						template: 'models_advanced_filter',
						'!embed.container': '.filter-models'
					},
					
					lastSiteAdded: {
						widget: 'List',
						container: '.last-model-site',
						'tpl.row': 'last_model_site'
					},

					siteCounter: {
						widget: 'Widget',
						container: '.counter',
						template: 'counter_item',
						templateThousand: 'counter_thousand_item',

						handleWom: {
							addedToDom: {
								widget: '@this',
								event: 'addedToDom',
								callback: function() {
									var dl = this.wom1('@parent #sitesDatalayer');
									var lastSite = dl.getCollection()[0];
									var totalCount = dl.getMetaValue('totalCount');
									this.getParent().renderCounter(totalCount);
								}
							}
						}
					},

					ourSites:{
						widget: 'Grid',
						dl: '@parent #sitesDatalayer',
						container: '.list-models',
						list: {
							'tpl.row': 'our_sites_model',
						},
					}
				},
				handleWom: {
					scrolling: {
						widget: '@root #windowScrollHandler',
						event: 'topPointReached',
						callback: 'changeHeaderColor'
					},
					addedToDom: {
						widget: '@this',
						event: 'addedToDom',
						callback: 'prepareElements'
					},
					'!pageAddedToDom': {
						event: 'addedToDom',
						widget: '@this',
						callback: function () {}
					}
				},
				handleDom: {
					scrollDown: {
						target: '.scroll-down-icon',
						event: 'click',
						callback: 'scrollTo'
					},
					menuHeaderClick: {
						target: '.menu-link',
						targetWidget: '@parent @parent #header',
						event: 'click',
						callback: 'scrollTo'
					},
					logoClick: {
						target: '#mcprofits-logo',
						targetWidget: '@parent @parent #header',
						event: 'click',
						callback: 'scrollTo'
					},
					menuFooterClick: {
						target: '.menu-link',
						targetWidget: '@parent @parent #footer',
						event: 'click',
						callback: 'scrollTo'
					},
					gradeClick: {
						target: 'label.btn',
						event: 'click',
						targetWidget: '#filter',
						callback: 'checkboxGroup'
					},
					regDown: {
						target: '.features_signup .scroll-down-icon',
						event: 'click',
						callback: 'scrollTo'
					},
				}
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this.startResizeWatcher();
			this.callParent('init', arguments);
		},

		deactivate: function() {
			this.destroyBlocksFollow();
			this.resetStateMenus();
			this.callParent('deactivate', arguments);
		},

		activate: function() {
			this.initBlocksFollow();
			this.callParent('activate', arguments);
		},

		prepareElements: function() {
			var menustate = fox.Navigator.get(0);
			if (menustate !== 'home'){
				this.scrollTo(menustate);
			}
			this.stateHeaderBg();
			this.updateCarousels();
			this.calculateElements();
			this.initBlocksFollow();
			fox.wom.selectFirst("@root #windowScrollHandler").enable();
			this.findSectionNameInURL();
		},

		startResizeWatcher: function() {
			$(window).on('resize.homepage', fox.bind(function(e){
				clearTimeout(this.timer);
				this.timer = setTimeout(fox.bind(function() {
					this.updateCarousels();
					this.calculateElements();
					this.reinitBlocksFollow();
				}, this), 1000);
			}, this));
		},

		stateHeaderBg: function() {
			$('#promo-header').toggleClass('header-bg', $('#promo-header').offset().top > 0);
		},

		findSectionNameInURL: function() {
			var section = fox.Navigator.get(1);

			if (section) {
				this.scrollTo(section);
			}
		},

		needInitCarousel: function(name) {
			var limit = this.getOption('config.carousels.' + name + '.limitWindowWith');

			return !limit ? true : window.innerWidth < this.getOption('config.carousels.' + name + '.limitWindowWith');
		},

		calculateElements: function() {
			this.setOption('params.header_h', $('#promo-header').height());

			if (window.innerWidth < 768) {
				this.setOption('params.header_h', 65);
			}
		},

		updateCarousels: function() {
			var data = this.getOption('config.carousels');

			fox.each(data, function(data, name){
				if (this.needInitCarousel(name)) {
					this.initCarousel(data, name);
				} else if (!this.needInitCarousel(name)) {
					this.destroyCarousel(data, name);
				}
			}, this);
		},

		initCarousel: function(data, name) {
			var carousel = this.dom1(data.id),
				owl = $(carousel);
				//dataForCarousel = {};

			fox.dom.addClass(this.getOption('config.owlClass'), carousel);

			/*if (data.responsive) {
				dataForCarousel.responsive = data.responsive || {};
			}

			if (data.onDragged) {
				dataForCarousel.onDragged = data.onDragged;
			}*/

			owl.owlCarousel(data);
		},

		destroyCarousel: function(data, name) {
			var carousel = this.dom1(data.id);
			var owl = $(carousel);

			owl.trigger('destroy.owl.carousel');

			fox.dom.removeClass(this.getOption('config.owlClass'), carousel);

			
		},

		initBlocksFollow: function() {
			var blocks = $(this.getOption('config.blockWatchClass'));
			var header_h = this.getOption('params.header_h');
			var self = this;

			blocks.each(function(i) {
				var position = $(this).position();
				if(position.top === 0) {self.switchStateMenu('home', true);}
				$(this).scrollspy({
					min: (position.top < header_h) ? 0 : position.top - header_h,
					max: position.top + $(this).height() / 1.5,
					onEnter: function(element, position) {
						if (!self.getOption('params.scrillingIsActive')) {
							var nameMenu = element.getAttribute('data-name');
							self.switchStateMenu(nameMenu, true);
							self.switchHashURL(nameMenu);
						}
					},
					onLeave: function(element, position) {
						self.switchStateMenu(element.getAttribute('data-name'), false);
					}
				});
			});
		},

		reinitBlocksFollow: function() {
			$(window).off('scroll.scrollspy');
			this.initBlocksFollow();
		},

		destroyBlocksFollow: function() {
			$(window).off('scroll.scrollspy');
		},

		switchStateMenu: function(name, type) {
			$('#promo-header .menu-link').removeClass('active');
			$('#promo-header .menu-link[data-name="' + name + '"]').toggleClass('active', type);
		},

		resetStateMenus: function() {
			$('#promo-header .menu-link').removeClass('active');
		},

		switchHashURL: function(name) {
			name = (name === 'home') ? '' : name;
			if (history.pushState) {
				history.pushState(null, null, '/' + name);
			} else {
				fox.Navigator.update({0: '/' + name}, true);
			}
		},

		refreshBlocksFollow: function() {
			var blocks = $(this.getOption('config.blockWatchClass'));
		},

		scrollTo: function(elm) {
			if (elm === undefined) {
				return;
			}

			var target, nameMenu,
				header_h = this.getOption('params.header_h'),
				self = this;

			nameMenu = (typeof elm === "object") ? elm.getAttribute('data-name') : elm;
			target = $('section[data-name="' + nameMenu + '"]');

			if (target.length) {
				this.stateScrilling(true);
				$('html,body').animate({
					scrollTop: target.offset().top - header_h
				}, 1000)
				.promise()
				.done(function(){
					self.stateScrilling(false);
					self.switchStateMenu(nameMenu, true);
				})
				.fail(function(){
					self.stateScrilling(false);
					self.switchStateMenu(nameMenu, true);
				});
			}
		},

		changeHeaderColor: function(param) {
			$('#promo-header').toggleClass('header-bg', param.direction === 1 ? true : false);
		},

		stateScrilling: function(flag) {
			this.setOption('params.scrillingIsActive', !!flag);
		},

		subscribeFormNotValid: function(res) {
			var througthNotifications = fox.wom.selectFirst('~#throughNotifications');

			througthNotifications.pushNotification({
				noticeTemplate: 'new_notice',
				noticeType: 'error',
				noticeMessage: res.msg,
				noticeAlias: 'subscribeFieldNotValid',
				listenWidgetDeactivate: this,
				delayClose: 3000
			});
		},

		subscribeFormSubmit: function() {
			var form = this.wom1('#subscribeForm');
			form.submit();
			form.ignoreSubmit(true);
		},

		subscribeFormIsSubmitted: function(response, type) {
			var form = this.wom1('#subscribeForm');
			
			if (response.answer.answer.status) {
				var througthNotifications = fox.wom.selectFirst('~#throughNotifications');

				througthNotifications.pushNotification({
					noticeTemplate: 'new_notice',
					noticeType: 'success',
					noticeMessage: 'You have successfully subscribed to the Newsletter!',
					noticeAlias: 'subscribeSuccess',
					listenWidgetDeactivate: this,
					delayClose: 3000
				});

				form.resetForm();
			}

			form.ignoreSubmit(false);
		},

		renderCounter: function(totalCount) {
			if (!totalCount) return false;

			var counter = this.wom1('#siteCounter');
			var digits = String(totalCount).split('');
			var counterFragment = document.createDocumentFragment();
			
			if (digits.length < 4) {
				digits.unshift('0');
			}
			
			for (var i = 0; i < digits.length; i++) {
				var template = ((i + 1) % 4 === 0) ? 'counter_thousand_item' : 'counter_item';
				var rowFragment = counter.getTemplater(template).setData([{digit: digits[i]}]).compile();
				counterFragment.appendChild(rowFragment);
			}

			var container =  fox.dom.selectFirst(counter.options.container);
			container.innerHTML = '';
			container.appendChild(counterFragment);
		},

		checkboxGroup: function(el) {
			var elem = $(el).prev();
			var currentCheck = $(elem).prop("checked");
			var group = "input:checkbox[name='mcpSubscription_data_restrictionTagId']";
			$(group).prop("checked",false);
			$(elem).prop("checked", currentCheck);
		}
	}, 'Widget');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};

/***/ }),
/* 204 */
/***/ (function(module, exports) {

/*!
 * jQuery Scrollspy Plugin
 * Author: @sxalexander
 * Licensed under the MIT license
 */
;(function ( $, window, document, undefined ) {

    $.fn.extend({
      scrollspy: function ( options ) {
        
          var defaults = {
            min: 0,
            max: 0,
            mode: 'vertical',
            namespace: 'scrollspy',
            buffer: 0,
            container: window,
            onEnter: options.onEnter ? options.onEnter : [],
            onLeave: options.onLeave ? options.onLeave : [],
            onTick: options.onTick ? options.onTick : []
          }
          
          var options = $.extend( {}, defaults, options );

          return this.each(function (i) {

              var element = this;
              var o = options;
              var $container = $(o.container);
              var mode = o.mode;
              var buffer = o.buffer;
              var enters = leaves = 0;
              var inside = false;
                            
              /* add listener to container */
              $container.bind('scroll.' + o.namespace, function(e){
                  var position = {top: $(this).scrollTop(), left: $(this).scrollLeft()};
                  var xy = (mode == 'vertical') ? position.top + buffer : position.left + buffer;
                  var max = o.max;
                  var min = o.min;
                  
                  /* fix max */
                  if($.isFunction(o.max)){
                    max = o.max();
                  }

                  /* fix max */
                  if($.isFunction(o.min)){
                    min = o.min();
                  }

                  if(max == 0){
                      max = (mode == 'vertical') ? $container.height() : $container.outerWidth() + $(element).outerWidth();
                  }
                  
                  /* if we have reached the minimum bound but are below the max ... */
                  if(xy >= min && xy <= max){
                    /* trigger enter event */
                    if(!inside){
                       inside = true;
                       enters++;
                       
                       /* fire enter event */
                       $(element).trigger('scrollEnter', {position: position})
                       if($.isFunction(o.onEnter)){
                         o.onEnter(element, position);
                       }
                      
                     }
                     
                     /* trigger tick event */
                     $(element).trigger('scrollTick', {position: position, inside: inside, enters: enters, leaves: leaves})
                     if($.isFunction(o.onTick)){
                       o.onTick(element, position, inside, enters, leaves);
                     }
                  }else{
                    
                    if(inside){
                      inside = false;
                      leaves++;
                      /* trigger leave event */
                      $(element).trigger('scrollLeave', {position: position, leaves:leaves})

                      if($.isFunction(o.onLeave)){
                        o.onLeave(element, position);
                      }
                    }
                  }
              }); 

          });
      }

    })

    
})( jQuery, window, document, undefined );


/***/ }),
/* 205 */
/***/ (function(module, exports) {

/**
 * Owl Carousel v2.2.1
 * Copyright 2013-2017 David Deutsch
 * Licensed under  ()
 */
!function(a,b,c,d){function e(b,c){this.settings=null,this.options=a.extend({},e.Defaults,c),this.$element=a(b),this._handlers={},this._plugins={},this._supress={},this._current=null,this._speed=null,this._coordinates=[],this._breakpoint=null,this._width=null,this._items=[],this._clones=[],this._mergers=[],this._widths=[],this._invalidated={},this._pipe=[],this._drag={time:null,target:null,pointer:null,stage:{start:null,current:null},direction:null},this._states={current:{},tags:{initializing:["busy"],animating:["busy"],dragging:["interacting"]}},a.each(["onResize","onThrottledResize"],a.proxy(function(b,c){this._handlers[c]=a.proxy(this[c],this)},this)),a.each(e.Plugins,a.proxy(function(a,b){this._plugins[a.charAt(0).toLowerCase()+a.slice(1)]=new b(this)},this)),a.each(e.Workers,a.proxy(function(b,c){this._pipe.push({filter:c.filter,run:a.proxy(c.run,this)})},this)),this.setup(),this.initialize()}e.Defaults={items:3,loop:!1,center:!1,rewind:!1,mouseDrag:!0,touchDrag:!0,pullDrag:!0,freeDrag:!1,margin:0,stagePadding:0,merge:!1,mergeFit:!0,autoWidth:!1,startPosition:0,rtl:!1,smartSpeed:250,fluidSpeed:!1,dragEndSpeed:!1,responsive:{},responsiveRefreshRate:200,responsiveBaseElement:b,fallbackEasing:"swing",info:!1,nestedItemSelector:!1,itemElement:"div",stageElement:"div",refreshClass:"owl-refresh",loadedClass:"owl-loaded",loadingClass:"owl-loading",rtlClass:"owl-rtl",responsiveClass:"owl-responsive",dragClass:"owl-drag",itemClass:"owl-item",stageClass:"owl-stage",stageOuterClass:"owl-stage-outer",grabClass:"owl-grab"},e.Width={Default:"default",Inner:"inner",Outer:"outer"},e.Type={Event:"event",State:"state"},e.Plugins={},e.Workers=[{filter:["width","settings"],run:function(){this._width=this.$element.width()}},{filter:["width","items","settings"],run:function(a){a.current=this._items&&this._items[this.relative(this._current)]}},{filter:["items","settings"],run:function(){this.$stage.children(".cloned").remove()}},{filter:["width","items","settings"],run:function(a){var b=this.settings.margin||"",c=!this.settings.autoWidth,d=this.settings.rtl,e={width:"auto","margin-left":d?b:"","margin-right":d?"":b};!c&&this.$stage.children().css(e),a.css=e}},{filter:["width","items","settings"],run:function(a){var b=(this.width()/this.settings.items).toFixed(3)-this.settings.margin,c=null,d=this._items.length,e=!this.settings.autoWidth,f=[];for(a.items={merge:!1,width:b};d--;)c=this._mergers[d],c=this.settings.mergeFit&&Math.min(c,this.settings.items)||c,a.items.merge=c>1||a.items.merge,f[d]=e?b*c:this._items[d].width();this._widths=f}},{filter:["items","settings"],run:function(){var b=[],c=this._items,d=this.settings,e=Math.max(2*d.items,4),f=2*Math.ceil(c.length/2),g=d.loop&&c.length?d.rewind?e:Math.max(e,f):0,h="",i="";for(g/=2;g--;)b.push(this.normalize(b.length/2,!0)),h+=c[b[b.length-1]][0].outerHTML,b.push(this.normalize(c.length-1-(b.length-1)/2,!0)),i=c[b[b.length-1]][0].outerHTML+i;this._clones=b,a(h).addClass("cloned").appendTo(this.$stage),a(i).addClass("cloned").prependTo(this.$stage)}},{filter:["width","items","settings"],run:function(){for(var a=this.settings.rtl?1:-1,b=this._clones.length+this._items.length,c=-1,d=0,e=0,f=[];++c<b;)d=f[c-1]||0,e=this._widths[this.relative(c)]+this.settings.margin,f.push(d+e*a);this._coordinates=f}},{filter:["width","items","settings"],run:function(){var a=this.settings.stagePadding,b=this._coordinates,c={width:Math.ceil(Math.abs(b[b.length-1]))+2*a,"padding-left":a||"","padding-right":a||""};this.$stage.css(c)}},{filter:["width","items","settings"],run:function(a){var b=this._coordinates.length,c=!this.settings.autoWidth,d=this.$stage.children();if(c&&a.items.merge)for(;b--;)a.css.width=this._widths[this.relative(b)],d.eq(b).css(a.css);else c&&(a.css.width=a.items.width,d.css(a.css))}},{filter:["items"],run:function(){this._coordinates.length<1&&this.$stage.removeAttr("style")}},{filter:["width","items","settings"],run:function(a){a.current=a.current?this.$stage.children().index(a.current):0,a.current=Math.max(this.minimum(),Math.min(this.maximum(),a.current)),this.reset(a.current)}},{filter:["position"],run:function(){this.animate(this.coordinates(this._current))}},{filter:["width","position","items","settings"],run:function(){var a,b,c,d,e=this.settings.rtl?1:-1,f=2*this.settings.stagePadding,g=this.coordinates(this.current())+f,h=g+this.width()*e,i=[];for(c=0,d=this._coordinates.length;c<d;c++)a=this._coordinates[c-1]||0,b=Math.abs(this._coordinates[c])+f*e,(this.op(a,"<=",g)&&this.op(a,">",h)||this.op(b,"<",g)&&this.op(b,">",h))&&i.push(c);this.$stage.children(".active").removeClass("active"),this.$stage.children(":eq("+i.join("), :eq(")+")").addClass("active"),this.settings.center&&(this.$stage.children(".center").removeClass("center"),this.$stage.children().eq(this.current()).addClass("center"))}}],e.prototype.initialize=function(){if(this.enter("initializing"),this.trigger("initialize"),this.$element.toggleClass(this.settings.rtlClass,this.settings.rtl),this.settings.autoWidth&&!this.is("pre-loading")){var b,c,e;b=this.$element.find("img"),c=this.settings.nestedItemSelector?"."+this.settings.nestedItemSelector:d,e=this.$element.children(c).width(),b.length&&e<=0&&this.preloadAutoWidthImages(b)}this.$element.addClass(this.options.loadingClass),this.$stage=a("<"+this.settings.stageElement+' class="'+this.settings.stageClass+'"/>').wrap('<div class="'+this.settings.stageOuterClass+'"/>'),this.$element.append(this.$stage.parent()),this.replace(this.$element.children().not(this.$stage.parent())),this.$element.is(":visible")?this.refresh():this.invalidate("width"),this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass),this.registerEventHandlers(),this.leave("initializing"),this.trigger("initialized")},e.prototype.setup=function(){var b=this.viewport(),c=this.options.responsive,d=-1,e=null;c?(a.each(c,function(a){a<=b&&a>d&&(d=Number(a))}),e=a.extend({},this.options,c[d]),"function"==typeof e.stagePadding&&(e.stagePadding=e.stagePadding()),delete e.responsive,e.responsiveClass&&this.$element.attr("class",this.$element.attr("class").replace(new RegExp("("+this.options.responsiveClass+"-)\\S+\\s","g"),"$1"+d))):e=a.extend({},this.options),this.trigger("change",{property:{name:"settings",value:e}}),this._breakpoint=d,this.settings=e,this.invalidate("settings"),this.trigger("changed",{property:{name:"settings",value:this.settings}})},e.prototype.optionsLogic=function(){this.settings.autoWidth&&(this.settings.stagePadding=!1,this.settings.merge=!1)},e.prototype.prepare=function(b){var c=this.trigger("prepare",{content:b});return c.data||(c.data=a("<"+this.settings.itemElement+"/>").addClass(this.options.itemClass).append(b)),this.trigger("prepared",{content:c.data}),c.data},e.prototype.update=function(){for(var b=0,c=this._pipe.length,d=a.proxy(function(a){return this[a]},this._invalidated),e={};b<c;)(this._invalidated.all||a.grep(this._pipe[b].filter,d).length>0)&&this._pipe[b].run(e),b++;this._invalidated={},!this.is("valid")&&this.enter("valid")},e.prototype.width=function(a){switch(a=a||e.Width.Default){case e.Width.Inner:case e.Width.Outer:return this._width;default:return this._width-2*this.settings.stagePadding+this.settings.margin}},e.prototype.refresh=function(){this.enter("refreshing"),this.trigger("refresh"),this.setup(),this.optionsLogic(),this.$element.addClass(this.options.refreshClass),this.update(),this.$element.removeClass(this.options.refreshClass),this.leave("refreshing"),this.trigger("refreshed")},e.prototype.onThrottledResize=function(){b.clearTimeout(this.resizeTimer),this.resizeTimer=b.setTimeout(this._handlers.onResize,this.settings.responsiveRefreshRate)},e.prototype.onResize=function(){return!!this._items.length&&(this._width!==this.$element.width()&&(!!this.$element.is(":visible")&&(this.enter("resizing"),this.trigger("resize").isDefaultPrevented()?(this.leave("resizing"),!1):(this.invalidate("width"),this.refresh(),this.leave("resizing"),void this.trigger("resized")))))},e.prototype.registerEventHandlers=function(){a.support.transition&&this.$stage.on(a.support.transition.end+".owl.core",a.proxy(this.onTransitionEnd,this)),this.settings.responsive!==!1&&this.on(b,"resize",this._handlers.onThrottledResize),this.settings.mouseDrag&&(this.$element.addClass(this.options.dragClass),this.$stage.on("mousedown.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("dragstart.owl.core selectstart.owl.core",function(){return!1})),this.settings.touchDrag&&(this.$stage.on("touchstart.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("touchcancel.owl.core",a.proxy(this.onDragEnd,this)))},e.prototype.onDragStart=function(b){var d=null;3!==b.which&&(a.support.transform?(d=this.$stage.css("transform").replace(/.*\(|\)| /g,"").split(","),d={x:d[16===d.length?12:4],y:d[16===d.length?13:5]}):(d=this.$stage.position(),d={x:this.settings.rtl?d.left+this.$stage.width()-this.width()+this.settings.margin:d.left,y:d.top}),this.is("animating")&&(a.support.transform?this.animate(d.x):this.$stage.stop(),this.invalidate("position")),this.$element.toggleClass(this.options.grabClass,"mousedown"===b.type),this.speed(0),this._drag.time=(new Date).getTime(),this._drag.target=a(b.target),this._drag.stage.start=d,this._drag.stage.current=d,this._drag.pointer=this.pointer(b),a(c).on("mouseup.owl.core touchend.owl.core",a.proxy(this.onDragEnd,this)),a(c).one("mousemove.owl.core touchmove.owl.core",a.proxy(function(b){var d=this.difference(this._drag.pointer,this.pointer(b));a(c).on("mousemove.owl.core touchmove.owl.core",a.proxy(this.onDragMove,this)),Math.abs(d.x)<Math.abs(d.y)&&this.is("valid")||(b.preventDefault(),this.enter("dragging"),this.trigger("drag"))},this)))},e.prototype.onDragMove=function(a){var b=null,c=null,d=null,e=this.difference(this._drag.pointer,this.pointer(a)),f=this.difference(this._drag.stage.start,e);this.is("dragging")&&(a.preventDefault(),this.settings.loop?(b=this.coordinates(this.minimum()),c=this.coordinates(this.maximum()+1)-b,f.x=((f.x-b)%c+c)%c+b):(b=this.settings.rtl?this.coordinates(this.maximum()):this.coordinates(this.minimum()),c=this.settings.rtl?this.coordinates(this.minimum()):this.coordinates(this.maximum()),d=this.settings.pullDrag?-1*e.x/5:0,f.x=Math.max(Math.min(f.x,b+d),c+d)),this._drag.stage.current=f,this.animate(f.x))},e.prototype.onDragEnd=function(b){var d=this.difference(this._drag.pointer,this.pointer(b)),e=this._drag.stage.current,f=d.x>0^this.settings.rtl?"left":"right";a(c).off(".owl.core"),this.$element.removeClass(this.options.grabClass),(0!==d.x&&this.is("dragging")||!this.is("valid"))&&(this.speed(this.settings.dragEndSpeed||this.settings.smartSpeed),this.current(this.closest(e.x,0!==d.x?f:this._drag.direction)),this.invalidate("position"),this.update(),this._drag.direction=f,(Math.abs(d.x)>3||(new Date).getTime()-this._drag.time>300)&&this._drag.target.one("click.owl.core",function(){return!1})),this.is("dragging")&&(this.leave("dragging"),this.trigger("dragged"))},e.prototype.closest=function(b,c){var d=-1,e=30,f=this.width(),g=this.coordinates();return this.settings.freeDrag||a.each(g,a.proxy(function(a,h){return"left"===c&&b>h-e&&b<h+e?d=a:"right"===c&&b>h-f-e&&b<h-f+e?d=a+1:this.op(b,"<",h)&&this.op(b,">",g[a+1]||h-f)&&(d="left"===c?a+1:a),d===-1},this)),this.settings.loop||(this.op(b,">",g[this.minimum()])?d=b=this.minimum():this.op(b,"<",g[this.maximum()])&&(d=b=this.maximum())),d},e.prototype.animate=function(b){var c=this.speed()>0;this.is("animating")&&this.onTransitionEnd(),c&&(this.enter("animating"),this.trigger("translate")),a.support.transform3d&&a.support.transition?this.$stage.css({transform:"translate3d("+b+"px,0px,0px)",transition:this.speed()/1e3+"s"}):c?this.$stage.animate({left:b+"px"},this.speed(),this.settings.fallbackEasing,a.proxy(this.onTransitionEnd,this)):this.$stage.css({left:b+"px"})},e.prototype.is=function(a){return this._states.current[a]&&this._states.current[a]>0},e.prototype.current=function(a){if(a===d)return this._current;if(0===this._items.length)return d;if(a=this.normalize(a),this._current!==a){var b=this.trigger("change",{property:{name:"position",value:a}});b.data!==d&&(a=this.normalize(b.data)),this._current=a,this.invalidate("position"),this.trigger("changed",{property:{name:"position",value:this._current}})}return this._current},e.prototype.invalidate=function(b){return"string"===a.type(b)&&(this._invalidated[b]=!0,this.is("valid")&&this.leave("valid")),a.map(this._invalidated,function(a,b){return b})},e.prototype.reset=function(a){a=this.normalize(a),a!==d&&(this._speed=0,this._current=a,this.suppress(["translate","translated"]),this.animate(this.coordinates(a)),this.release(["translate","translated"]))},e.prototype.normalize=function(a,b){var c=this._items.length,e=b?0:this._clones.length;return!this.isNumeric(a)||c<1?a=d:(a<0||a>=c+e)&&(a=((a-e/2)%c+c)%c+e/2),a},e.prototype.relative=function(a){return a-=this._clones.length/2,this.normalize(a,!0)},e.prototype.maximum=function(a){var b,c,d,e=this.settings,f=this._coordinates.length;if(e.loop)f=this._clones.length/2+this._items.length-1;else if(e.autoWidth||e.merge){for(b=this._items.length,c=this._items[--b].width(),d=this.$element.width();b--&&(c+=this._items[b].width()+this.settings.margin,!(c>d)););f=b+1}else f=e.center?this._items.length-1:this._items.length-e.items;return a&&(f-=this._clones.length/2),Math.max(f,0)},e.prototype.minimum=function(a){return a?0:this._clones.length/2},e.prototype.items=function(a){return a===d?this._items.slice():(a=this.normalize(a,!0),this._items[a])},e.prototype.mergers=function(a){return a===d?this._mergers.slice():(a=this.normalize(a,!0),this._mergers[a])},e.prototype.clones=function(b){var c=this._clones.length/2,e=c+this._items.length,f=function(a){return a%2===0?e+a/2:c-(a+1)/2};return b===d?a.map(this._clones,function(a,b){return f(b)}):a.map(this._clones,function(a,c){return a===b?f(c):null})},e.prototype.speed=function(a){return a!==d&&(this._speed=a),this._speed},e.prototype.coordinates=function(b){var c,e=1,f=b-1;return b===d?a.map(this._coordinates,a.proxy(function(a,b){return this.coordinates(b)},this)):(this.settings.center?(this.settings.rtl&&(e=-1,f=b+1),c=this._coordinates[b],c+=(this.width()-c+(this._coordinates[f]||0))/2*e):c=this._coordinates[f]||0,c=Math.ceil(c))},e.prototype.duration=function(a,b,c){return 0===c?0:Math.min(Math.max(Math.abs(b-a),1),6)*Math.abs(c||this.settings.smartSpeed)},e.prototype.to=function(a,b){var c=this.current(),d=null,e=a-this.relative(c),f=(e>0)-(e<0),g=this._items.length,h=this.minimum(),i=this.maximum();this.settings.loop?(!this.settings.rewind&&Math.abs(e)>g/2&&(e+=f*-1*g),a=c+e,d=((a-h)%g+g)%g+h,d!==a&&d-e<=i&&d-e>0&&(c=d-e,a=d,this.reset(c))):this.settings.rewind?(i+=1,a=(a%i+i)%i):a=Math.max(h,Math.min(i,a)),this.speed(this.duration(c,a,b)),this.current(a),this.$element.is(":visible")&&this.update()},e.prototype.next=function(a){a=a||!1,this.to(this.relative(this.current())+1,a)},e.prototype.prev=function(a){a=a||!1,this.to(this.relative(this.current())-1,a)},e.prototype.onTransitionEnd=function(a){if(a!==d&&(a.stopPropagation(),(a.target||a.srcElement||a.originalTarget)!==this.$stage.get(0)))return!1;this.leave("animating"),this.trigger("translated")},e.prototype.viewport=function(){var d;return this.options.responsiveBaseElement!==b?d=a(this.options.responsiveBaseElement).width():b.innerWidth?d=b.innerWidth:c.documentElement&&c.documentElement.clientWidth?d=c.documentElement.clientWidth:console.warn("Can not detect viewport width."),d},e.prototype.replace=function(b){this.$stage.empty(),this._items=[],b&&(b=b instanceof jQuery?b:a(b)),this.settings.nestedItemSelector&&(b=b.find("."+this.settings.nestedItemSelector)),b.filter(function(){return 1===this.nodeType}).each(a.proxy(function(a,b){b=this.prepare(b),this.$stage.append(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)},this)),this.reset(this.isNumeric(this.settings.startPosition)?this.settings.startPosition:0),this.invalidate("items")},e.prototype.add=function(b,c){var e=this.relative(this._current);c=c===d?this._items.length:this.normalize(c,!0),b=b instanceof jQuery?b:a(b),this.trigger("add",{content:b,position:c}),b=this.prepare(b),0===this._items.length||c===this._items.length?(0===this._items.length&&this.$stage.append(b),0!==this._items.length&&this._items[c-1].after(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)):(this._items[c].before(b),this._items.splice(c,0,b),this._mergers.splice(c,0,1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)),this._items[e]&&this.reset(this._items[e].index()),this.invalidate("items"),this.trigger("added",{content:b,position:c})},e.prototype.remove=function(a){a=this.normalize(a,!0),a!==d&&(this.trigger("remove",{content:this._items[a],position:a}),this._items[a].remove(),this._items.splice(a,1),this._mergers.splice(a,1),this.invalidate("items"),this.trigger("removed",{content:null,position:a}))},e.prototype.preloadAutoWidthImages=function(b){b.each(a.proxy(function(b,c){this.enter("pre-loading"),c=a(c),a(new Image).one("load",a.proxy(function(a){c.attr("src",a.target.src),c.css("opacity",1),this.leave("pre-loading"),!this.is("pre-loading")&&!this.is("initializing")&&this.refresh()},this)).attr("src",c.attr("src")||c.attr("data-src")||c.attr("data-src-retina"))},this))},e.prototype.destroy=function(){this.$element.off(".owl.core"),this.$stage.off(".owl.core"),a(c).off(".owl.core"),this.settings.responsive!==!1&&(b.clearTimeout(this.resizeTimer),this.off(b,"resize",this._handlers.onThrottledResize));for(var d in this._plugins)this._plugins[d].destroy();this.$stage.children(".cloned").remove(),this.$stage.unwrap(),this.$stage.children().contents().unwrap(),this.$stage.children().unwrap(),this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class",this.$element.attr("class").replace(new RegExp(this.options.responsiveClass+"-\\S+\\s","g"),"")).removeData("owl.carousel")},e.prototype.op=function(a,b,c){var d=this.settings.rtl;switch(b){case"<":return d?a>c:a<c;case">":return d?a<c:a>c;case">=":return d?a<=c:a>=c;case"<=":return d?a>=c:a<=c}},e.prototype.on=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d):a.attachEvent&&a.attachEvent("on"+b,c)},e.prototype.off=function(a,b,c,d){a.removeEventListener?a.removeEventListener(b,c,d):a.detachEvent&&a.detachEvent("on"+b,c)},e.prototype.trigger=function(b,c,d,f,g){var h={item:{count:this._items.length,index:this.current()}},i=a.camelCase(a.grep(["on",b,d],function(a){return a}).join("-").toLowerCase()),j=a.Event([b,"owl",d||"carousel"].join(".").toLowerCase(),a.extend({relatedTarget:this},h,c));return this._supress[b]||(a.each(this._plugins,function(a,b){b.onTrigger&&b.onTrigger(j)}),this.register({type:e.Type.Event,name:b}),this.$element.trigger(j),this.settings&&"function"==typeof this.settings[i]&&this.settings[i].call(this,j)),j},e.prototype.enter=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]===d&&(this._states.current[b]=0),this._states.current[b]++},this))},e.prototype.leave=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]--},this))},e.prototype.register=function(b){if(b.type===e.Type.Event){if(a.event.special[b.name]||(a.event.special[b.name]={}),!a.event.special[b.name].owl){var c=a.event.special[b.name]._default;a.event.special[b.name]._default=function(a){return!c||!c.apply||a.namespace&&a.namespace.indexOf("owl")!==-1?a.namespace&&a.namespace.indexOf("owl")>-1:c.apply(this,arguments)},a.event.special[b.name].owl=!0}}else b.type===e.Type.State&&(this._states.tags[b.name]?this._states.tags[b.name]=this._states.tags[b.name].concat(b.tags):this._states.tags[b.name]=b.tags,this._states.tags[b.name]=a.grep(this._states.tags[b.name],a.proxy(function(c,d){return a.inArray(c,this._states.tags[b.name])===d},this)))},e.prototype.suppress=function(b){a.each(b,a.proxy(function(a,b){this._supress[b]=!0},this))},e.prototype.release=function(b){a.each(b,a.proxy(function(a,b){delete this._supress[b]},this))},e.prototype.pointer=function(a){var c={x:null,y:null};return a=a.originalEvent||a||b.event,a=a.touches&&a.touches.length?a.touches[0]:a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:a,a.pageX?(c.x=a.pageX,c.y=a.pageY):(c.x=a.clientX,c.y=a.clientY),c},e.prototype.isNumeric=function(a){return!isNaN(parseFloat(a))},e.prototype.difference=function(a,b){return{x:a.x-b.x,y:a.y-b.y}},a.fn.owlCarousel=function(b){var c=Array.prototype.slice.call(arguments,1);return this.each(function(){var d=a(this),f=d.data("owl.carousel");f||(f=new e(this,"object"==typeof b&&b),d.data("owl.carousel",f),a.each(["next","prev","to","destroy","refresh","replace","add","remove"],function(b,c){f.register({type:e.Type.Event,name:c}),f.$element.on(c+".owl.carousel.core",a.proxy(function(a){a.namespace&&a.relatedTarget!==this&&(this.suppress([c]),f[c].apply(this,[].slice.call(arguments,1)),this.release([c]))},f))})),"string"==typeof b&&"_"!==b.charAt(0)&&f[b].apply(f,c)})},a.fn.owlCarousel.Constructor=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._interval=null,this._visible=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoRefresh&&this.watch()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={autoRefresh:!0,autoRefreshInterval:500},e.prototype.watch=function(){this._interval||(this._visible=this._core.$element.is(":visible"),this._interval=b.setInterval(a.proxy(this.refresh,this),this._core.settings.autoRefreshInterval))},e.prototype.refresh=function(){this._core.$element.is(":visible")!==this._visible&&(this._visible=!this._visible,this._core.$element.toggleClass("owl-hidden",!this._visible),this._visible&&this._core.invalidate("width")&&this._core.refresh())},e.prototype.destroy=function(){var a,c;b.clearInterval(this._interval);for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoRefresh=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._loaded=[],this._handlers={"initialized.owl.carousel change.owl.carousel resized.owl.carousel":a.proxy(function(b){if(b.namespace&&this._core.settings&&this._core.settings.lazyLoad&&(b.property&&"position"==b.property.name||"initialized"==b.type))for(var c=this._core.settings,e=c.center&&Math.ceil(c.items/2)||c.items,f=c.center&&e*-1||0,g=(b.property&&b.property.value!==d?b.property.value:this._core.current())+f,h=this._core.clones().length,i=a.proxy(function(a,b){this.load(b)},this);f++<e;)this.load(h/2+this._core.relative(g)),h&&a.each(this._core.clones(this._core.relative(g)),i),g++},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={lazyLoad:!1},e.prototype.load=function(c){var d=this._core.$stage.children().eq(c),e=d&&d.find(".owl-lazy");!e||a.inArray(d.get(0),this._loaded)>-1||(e.each(a.proxy(function(c,d){var e,f=a(d),g=b.devicePixelRatio>1&&f.attr("data-src-retina")||f.attr("data-src");this._core.trigger("load",{element:f,url:g},"lazy"),f.is("img")?f.one("load.owl.lazy",a.proxy(function(){f.css("opacity",1),this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("src",g):(e=new Image,e.onload=a.proxy(function(){f.css({"background-image":'url("'+g+'")',opacity:"1"}),this._core.trigger("loaded",{element:f,url:g},"lazy")},this),e.src=g)},this)),this._loaded.push(d.get(0)))},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this._core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Lazy=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._handlers={"initialized.owl.carousel refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&this.update()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&"position"==a.property.name&&this.update()},this),"loaded.owl.lazy":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&a.element.closest("."+this._core.settings.itemClass).index()===this._core.current()&&this.update()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={autoHeight:!1,autoHeightClass:"owl-height"},e.prototype.update=function(){var b=this._core._current,c=b+this._core.settings.items,d=this._core.$stage.children().toArray().slice(b,c),e=[],f=0;a.each(d,function(b,c){e.push(a(c).height())}),f=Math.max.apply(null,e),this._core.$stage.parent().height(f).addClass(this._core.settings.autoHeightClass)},e.prototype.destroy=function(){var a,b;for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoHeight=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._videos={},this._playing=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.register({type:"state",name:"playing",tags:["interacting"]})},this),"resize.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.video&&this.isInFullScreen()&&a.preventDefault()},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.is("resizing")&&this._core.$stage.find(".cloned .owl-video-frame").remove()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"===a.property.name&&this._playing&&this.stop()},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find(".owl-video");c.length&&(c.css("display","none"),this.fetch(c,a(b.content)))}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers),this._core.$element.on("click.owl.video",".owl-video-play-icon",a.proxy(function(a){this.play(a)},this))};e.Defaults={video:!1,videoHeight:!1,videoWidth:!1},e.prototype.fetch=function(a,b){var c=function(){return a.attr("data-vimeo-id")?"vimeo":a.attr("data-vzaar-id")?"vzaar":"youtube"}(),d=a.attr("data-vimeo-id")||a.attr("data-youtube-id")||a.attr("data-vzaar-id"),e=a.attr("data-width")||this._core.settings.videoWidth,f=a.attr("data-height")||this._core.settings.videoHeight,g=a.attr("href");if(!g)throw new Error("Missing video URL.");if(d=g.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/),d[3].indexOf("youtu")>-1)c="youtube";else if(d[3].indexOf("vimeo")>-1)c="vimeo";else{if(!(d[3].indexOf("vzaar")>-1))throw new Error("Video URL not supported.");c="vzaar"}d=d[6],this._videos[g]={type:c,id:d,width:e,height:f},b.attr("data-video",g),this.thumbnail(a,this._videos[g])},e.prototype.thumbnail=function(b,c){var d,e,f,g=c.width&&c.height?'style="width:'+c.width+"px;height:"+c.height+'px;"':"",h=b.find("img"),i="src",j="",k=this._core.settings,l=function(a){e='<div class="owl-video-play-icon"></div>',d=k.lazyLoad?'<div class="owl-video-tn '+j+'" '+i+'="'+a+'"></div>':'<div class="owl-video-tn" style="opacity:1;background-image:url('+a+')"></div>',b.after(d),b.after(e)};if(b.wrap('<div class="owl-video-wrapper"'+g+"></div>"),this._core.settings.lazyLoad&&(i="data-src",j="owl-lazy"),h.length)return l(h.attr(i)),h.remove(),!1;"youtube"===c.type?(f="//img.youtube.com/vi/"+c.id+"/hqdefault.jpg",l(f)):"vimeo"===c.type?a.ajax({type:"GET",url:"//vimeo.com/api/v2/video/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a[0].thumbnail_large,l(f)}}):"vzaar"===c.type&&a.ajax({type:"GET",url:"//vzaar.com/api/videos/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a.framegrab_url,l(f)}})},e.prototype.stop=function(){this._core.trigger("stop",null,"video"),this._playing.find(".owl-video-frame").remove(),this._playing.removeClass("owl-video-playing"),this._playing=null,this._core.leave("playing"),this._core.trigger("stopped",null,"video")},e.prototype.play=function(b){var c,d=a(b.target),e=d.closest("."+this._core.settings.itemClass),f=this._videos[e.attr("data-video")],g=f.width||"100%",h=f.height||this._core.$stage.height();this._playing||(this._core.enter("playing"),this._core.trigger("play",null,"video"),e=this._core.items(this._core.relative(e.index())),this._core.reset(e.index()),"youtube"===f.type?c='<iframe width="'+g+'" height="'+h+'" src="//www.youtube.com/embed/'+f.id+"?autoplay=1&rel=0&v="+f.id+'" frameborder="0" allowfullscreen></iframe>':"vimeo"===f.type?c='<iframe src="//player.vimeo.com/video/'+f.id+'?autoplay=1" width="'+g+'" height="'+h+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>':"vzaar"===f.type&&(c='<iframe frameborder="0"height="'+h+'"width="'+g+'" allowfullscreen mozallowfullscreen webkitAllowFullScreen src="//view.vzaar.com/'+f.id+'/player?autoplay=true"></iframe>'),a('<div class="owl-video-frame">'+c+"</div>").insertAfter(e.find(".owl-video")),this._playing=e.addClass("owl-video-playing"))},e.prototype.isInFullScreen=function(){var b=c.fullscreenElement||c.mozFullScreenElement||c.webkitFullscreenElement;return b&&a(b).parent().hasClass("owl-video-frame")},e.prototype.destroy=function(){var a,b;this._core.$element.off("click.owl.video");for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Video=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this.core=b,this.core.options=a.extend({},e.Defaults,this.core.options),this.swapping=!0,this.previous=d,this.next=d,this.handlers={"change.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&(this.previous=this.core.current(),this.next=a.property.value)},this),"drag.owl.carousel dragged.owl.carousel translated.owl.carousel":a.proxy(function(a){a.namespace&&(this.swapping="translated"==a.type)},this),"translate.owl.carousel":a.proxy(function(a){a.namespace&&this.swapping&&(this.core.options.animateOut||this.core.options.animateIn)&&this.swap()},this)},this.core.$element.on(this.handlers)};e.Defaults={animateOut:!1,animateIn:!1},e.prototype.swap=function(){if(1===this.core.settings.items&&a.support.animation&&a.support.transition){this.core.speed(0);var b,c=a.proxy(this.clear,this),d=this.core.$stage.children().eq(this.previous),e=this.core.$stage.children().eq(this.next),f=this.core.settings.animateIn,g=this.core.settings.animateOut;this.core.current()!==this.previous&&(g&&(b=this.core.coordinates(this.previous)-this.core.coordinates(this.next),d.one(a.support.animation.end,c).css({left:b+"px"}).addClass("animated owl-animated-out").addClass(g)),f&&e.one(a.support.animation.end,c).addClass("animated owl-animated-in").addClass(f))}},e.prototype.clear=function(b){a(b.target).css({left:""}).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut),this.core.onTransitionEnd()},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this.core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},
a.fn.owlCarousel.Constructor.Plugins.Animate=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._timeout=null,this._paused=!1,this._handlers={"changed.owl.carousel":a.proxy(function(a){a.namespace&&"settings"===a.property.name?this._core.settings.autoplay?this.play():this.stop():a.namespace&&"position"===a.property.name&&this._core.settings.autoplay&&this._setAutoPlayInterval()},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoplay&&this.play()},this),"play.owl.autoplay":a.proxy(function(a,b,c){a.namespace&&this.play(b,c)},this),"stop.owl.autoplay":a.proxy(function(a){a.namespace&&this.stop()},this),"mouseover.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"mouseleave.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.play()},this),"touchstart.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"touchend.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this.play()},this)},this._core.$element.on(this._handlers),this._core.options=a.extend({},e.Defaults,this._core.options)};e.Defaults={autoplay:!1,autoplayTimeout:5e3,autoplayHoverPause:!1,autoplaySpeed:!1},e.prototype.play=function(a,b){this._paused=!1,this._core.is("rotating")||(this._core.enter("rotating"),this._setAutoPlayInterval())},e.prototype._getNextTimeout=function(d,e){return this._timeout&&b.clearTimeout(this._timeout),b.setTimeout(a.proxy(function(){this._paused||this._core.is("busy")||this._core.is("interacting")||c.hidden||this._core.next(e||this._core.settings.autoplaySpeed)},this),d||this._core.settings.autoplayTimeout)},e.prototype._setAutoPlayInterval=function(){this._timeout=this._getNextTimeout()},e.prototype.stop=function(){this._core.is("rotating")&&(b.clearTimeout(this._timeout),this._core.leave("rotating"))},e.prototype.pause=function(){this._core.is("rotating")&&(this._paused=!0)},e.prototype.destroy=function(){var a,b;this.stop();for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.autoplay=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(b){this._core=b,this._initialized=!1,this._pages=[],this._controls={},this._templates=[],this.$element=this._core.$element,this._overrides={next:this._core.next,prev:this._core.prev,to:this._core.to},this._handlers={"prepared.owl.carousel":a.proxy(function(b){b.namespace&&this._core.settings.dotsData&&this._templates.push('<div class="'+this._core.settings.dotClass+'">'+a(b.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot")+"</div>")},this),"added.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,0,this._templates.pop())},this),"remove.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,1)},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&this.draw()},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&!this._initialized&&(this._core.trigger("initialize",null,"navigation"),this.initialize(),this.update(),this.draw(),this._initialized=!0,this._core.trigger("initialized",null,"navigation"))},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._initialized&&(this._core.trigger("refresh",null,"navigation"),this.update(),this.draw(),this._core.trigger("refreshed",null,"navigation"))},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers)};e.Defaults={nav:!1,navText:["prev","next"],navSpeed:!1,navElement:"div",navContainer:!1,navContainerClass:"owl-nav",navClass:["owl-prev","owl-next"],slideBy:1,dotClass:"owl-dot",dotsClass:"owl-dots",dots:!0,dotsEach:!1,dotsData:!1,dotsSpeed:!1,dotsContainer:!1},e.prototype.initialize=function(){var b,c=this._core.settings;this._controls.$relative=(c.navContainer?a(c.navContainer):a("<div>").addClass(c.navContainerClass).appendTo(this.$element)).addClass("disabled"),this._controls.$previous=a("<"+c.navElement+">").addClass(c.navClass[0]).html(c.navText[0]).prependTo(this._controls.$relative).on("click",a.proxy(function(a){this.prev(c.navSpeed)},this)),this._controls.$next=a("<"+c.navElement+">").addClass(c.navClass[1]).html(c.navText[1]).appendTo(this._controls.$relative).on("click",a.proxy(function(a){this.next(c.navSpeed)},this)),c.dotsData||(this._templates=[a("<div>").addClass(c.dotClass).append(a("<span>")).prop("outerHTML")]),this._controls.$absolute=(c.dotsContainer?a(c.dotsContainer):a("<div>").addClass(c.dotsClass).appendTo(this.$element)).addClass("disabled"),this._controls.$absolute.on("click","div",a.proxy(function(b){var d=a(b.target).parent().is(this._controls.$absolute)?a(b.target).index():a(b.target).parent().index();b.preventDefault(),this.to(d,c.dotsSpeed)},this));for(b in this._overrides)this._core[b]=a.proxy(this[b],this)},e.prototype.destroy=function(){var a,b,c,d;for(a in this._handlers)this.$element.off(a,this._handlers[a]);for(b in this._controls)this._controls[b].remove();for(d in this.overides)this._core[d]=this._overrides[d];for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},e.prototype.update=function(){var a,b,c,d=this._core.clones().length/2,e=d+this._core.items().length,f=this._core.maximum(!0),g=this._core.settings,h=g.center||g.autoWidth||g.dotsData?1:g.dotsEach||g.items;if("page"!==g.slideBy&&(g.slideBy=Math.min(g.slideBy,g.items)),g.dots||"page"==g.slideBy)for(this._pages=[],a=d,b=0,c=0;a<e;a++){if(b>=h||0===b){if(this._pages.push({start:Math.min(f,a-d),end:a-d+h-1}),Math.min(f,a-d)===f)break;b=0,++c}b+=this._core.mergers(this._core.relative(a))}},e.prototype.draw=function(){var b,c=this._core.settings,d=this._core.items().length<=c.items,e=this._core.relative(this._core.current()),f=c.loop||c.rewind;this._controls.$relative.toggleClass("disabled",!c.nav||d),c.nav&&(this._controls.$previous.toggleClass("disabled",!f&&e<=this._core.minimum(!0)),this._controls.$next.toggleClass("disabled",!f&&e>=this._core.maximum(!0))),this._controls.$absolute.toggleClass("disabled",!c.dots||d),c.dots&&(b=this._pages.length-this._controls.$absolute.children().length,c.dotsData&&0!==b?this._controls.$absolute.html(this._templates.join("")):b>0?this._controls.$absolute.append(new Array(b+1).join(this._templates[0])):b<0&&this._controls.$absolute.children().slice(b).remove(),this._controls.$absolute.find(".active").removeClass("active"),this._controls.$absolute.children().eq(a.inArray(this.current(),this._pages)).addClass("active"))},e.prototype.onTrigger=function(b){var c=this._core.settings;b.page={index:a.inArray(this.current(),this._pages),count:this._pages.length,size:c&&(c.center||c.autoWidth||c.dotsData?1:c.dotsEach||c.items)}},e.prototype.current=function(){var b=this._core.relative(this._core.current());return a.grep(this._pages,a.proxy(function(a,c){return a.start<=b&&a.end>=b},this)).pop()},e.prototype.getPosition=function(b){var c,d,e=this._core.settings;return"page"==e.slideBy?(c=a.inArray(this.current(),this._pages),d=this._pages.length,b?++c:--c,c=this._pages[(c%d+d)%d].start):(c=this._core.relative(this._core.current()),d=this._core.items().length,b?c+=e.slideBy:c-=e.slideBy),c},e.prototype.next=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!0),b)},e.prototype.prev=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!1),b)},e.prototype.to=function(b,c,d){var e;!d&&this._pages.length?(e=this._pages.length,a.proxy(this._overrides.to,this._core)(this._pages[(b%e+e)%e].start,c)):a.proxy(this._overrides.to,this._core)(b,c)},a.fn.owlCarousel.Constructor.Plugins.Navigation=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(c){this._core=c,this._hashes={},this.$element=this._core.$element,this._handlers={"initialized.owl.carousel":a.proxy(function(c){c.namespace&&"URLHash"===this._core.settings.startPosition&&a(b).trigger("hashchange.owl.navigation")},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");if(!c)return;this._hashes[c]=b.content}},this),"changed.owl.carousel":a.proxy(function(c){if(c.namespace&&"position"===c.property.name){var d=this._core.items(this._core.relative(this._core.current())),e=a.map(this._hashes,function(a,b){return a===d?b:null}).join();if(!e||b.location.hash.slice(1)===e)return;b.location.hash=e}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers),a(b).on("hashchange.owl.navigation",a.proxy(function(a){var c=b.location.hash.substring(1),e=this._core.$stage.children(),f=this._hashes[c]&&e.index(this._hashes[c]);f!==d&&f!==this._core.current()&&this._core.to(this._core.relative(f),!1,!0)},this))};e.Defaults={URLhashListener:!1},e.prototype.destroy=function(){var c,d;a(b).off("hashchange.owl.navigation");for(c in this._handlers)this._core.$element.off(c,this._handlers[c]);for(d in Object.getOwnPropertyNames(this))"function"!=typeof this[d]&&(this[d]=null)},a.fn.owlCarousel.Constructor.Plugins.Hash=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){function e(b,c){var e=!1,f=b.charAt(0).toUpperCase()+b.slice(1);return a.each((b+" "+h.join(f+" ")+f).split(" "),function(a,b){if(g[b]!==d)return e=!c||b,!1}),e}function f(a){return e(a,!0)}var g=a("<support>").get(0).style,h="Webkit Moz O ms".split(" "),i={transition:{end:{WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd",transition:"transitionend"}},animation:{end:{WebkitAnimation:"webkitAnimationEnd",MozAnimation:"animationend",OAnimation:"oAnimationEnd",animation:"animationend"}}},j={csstransforms:function(){return!!e("transform")},csstransforms3d:function(){return!!e("perspective")},csstransitions:function(){return!!e("transition")},cssanimations:function(){return!!e("animation")}};j.csstransitions()&&(a.support.transition=new String(f("transition")),a.support.transition.end=i.transition.end[a.support.transition]),j.cssanimations()&&(a.support.animation=new String(f("animation")),a.support.animation.end=i.animation.end[a.support.animation]),j.csstransforms()&&(a.support.transform=new String(f("transform")),a.support.transform3d=j.csstransforms3d())}(window.Zepto||window.jQuery,window,document);

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(207);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"attrs":{"data-source":"st-css"}});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize!./owl.carousel.min.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize!./owl.carousel.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".owl-carousel,.owl-carousel .owl-item{-webkit-tap-highlight-color:transparent;position:relative}.owl-carousel{display:none;width:100%;z-index:1}.owl-carousel .owl-stage{position:relative;-ms-touch-action:pan-Y;-moz-backface-visibility:hidden}.owl-carousel .owl-stage:after{content:\".\";display:block;clear:both;visibility:hidden;line-height:0;height:0}.owl-carousel .owl-stage-outer{position:relative;overflow:hidden;-webkit-transform:translateZ(0)}.owl-carousel .owl-item,.owl-carousel .owl-wrapper{-webkit-backface-visibility:hidden;-moz-backface-visibility:hidden;-ms-backface-visibility:hidden;-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0)}.owl-carousel .owl-item{min-height:1px;float:left;-webkit-backface-visibility:hidden;-webkit-touch-callout:none}.owl-carousel .owl-item img{display:block;width:100%}.owl-carousel .owl-dots.disabled,.owl-carousel .owl-nav.disabled{display:none}.no-js .owl-carousel,.owl-carousel.owl-loaded{display:block}.owl-carousel .owl-dot,.owl-carousel .owl-nav .owl-next,.owl-carousel .owl-nav .owl-prev{cursor:pointer;cursor:hand;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.owl-carousel.owl-loading{opacity:0;display:block}.owl-carousel.owl-hidden{opacity:0}.owl-carousel.owl-refresh .owl-item{visibility:hidden}.owl-carousel.owl-drag .owl-item{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.owl-carousel.owl-grab{cursor:move;cursor:grab}.owl-carousel.owl-rtl{direction:rtl}.owl-carousel.owl-rtl .owl-item{float:right}.owl-carousel .animated{animation-duration:1s;animation-fill-mode:both}.owl-carousel .owl-animated-in{z-index:0}.owl-carousel .owl-animated-out{z-index:1}.owl-carousel .fadeOut{animation-name:fadeOut}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.owl-height{transition:height .5s ease-in-out}.owl-carousel .owl-item .owl-lazy{opacity:0;transition:opacity .4s ease}.owl-carousel .owl-item img.owl-lazy{transform-style:preserve-3d}.owl-carousel .owl-video-wrapper{position:relative;height:100%;background:#000}.owl-carousel .owl-video-play-icon{position:absolute;height:80px;width:80px;left:50%;top:50%;margin-left:-40px;margin-top:-40px;background:url(" + __webpack_require__(208) + ") no-repeat;cursor:pointer;z-index:1;-webkit-backface-visibility:hidden;transition:transform .1s ease}.owl-carousel .owl-video-play-icon:hover{transform:scale(1.3)}.owl-carousel .owl-video-playing .owl-video-play-icon,.owl-carousel .owl-video-playing .owl-video-tn{display:none}.owl-carousel .owl-video-tn{opacity:0;height:100%;background-position:50%;background-repeat:no-repeat;background-size:contain;transition:opacity .4s ease}.owl-carousel .owl-video-frame{position:relative;z-index:1;height:100%;width:100%}", ""]);

// exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("owl-carousel2/dist/assets/owl.video.play.png", __webpack_require__.p + "_/_/_/_/_/bower_components/owl-carousel2/dist/assets/owl.video.play.png");

/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";
	fox.registerWidget('Promo_OurSites', {
		configure: function(options) {
			this.filterFields = [
				'mcpSubscription_niches_siteNicheId',
				'mcpSubscription_contentCategories_contentCategoryId',
				'mcpSubscription_interactionFeatures_interactionFeatureId',
				'mcpSubscription_data_restrictionTagId'
			];
			this.registerOptions('', {
				template: 'promo_oursite_page',
				widgets: {
					signupForm: {
						widget: 'Home_Registration'
					},
					warningPopup: {
						widget: 'Dialog',
						template: 'same_account',
						dialog: {
							autoOpen: options.autoOpen || false,
							dialogClass: 'dlg-amc dark-overlay',
							title: 'ERROR',
							closeText: '',
							width: 'auto'
						},
						handleWom: {
							dOnShow: {
								event: 'show',
								widget: '@this',
								'params.prefix': 'uniqPopEvent',
								callback: function () {
									$(fox.dom.selectFirst('.wrapper')).addClass('blured');
								}
							},
							dOnHide: {
								event: 'hide',
								widget: '@this',
								'params.prefix': 'uniqPopEvent',
								callback: function () {
									$(fox.dom.selectFirst('.wrapper')).removeClass('blured');
								}
							}
						}
					},

					sitesDatalayer: {
						widget: 'Datalayer',
						method: 'Partner_McProfits.getModels',
						fields: ['mcpSubscription._avatar', 'site.domain', 'clientId.name'],
						metaFields: {
							'totalCount': 1,
							'mcpSubscription.avatar': 1
						},
						limit: 24
					},

					ourSites:{
						widget: 'Grid',
						dl: '@parent #sitesDatalayer',
						externalLoad: true,
						template: 'grid_models',
						container: '.grid-models',
						list: {
							'tpl.row': 'our_sites_model',
							container: '.list-models',
							'tpl.emptyRow': 'our_sites_model_empty_item'
						},
						pager: {
							widget: 'ContentPager',
							'embed.container': '.content-pager',
							ignoreActivate: false,
							navigatorPrefix: 'page'
						}
					},

					preloader: {
						widget: 'PromisePreloader',
						'embed.container': '.list-models',
						'embed.widget': '@parent #ourSites'
					},

					filter: {
						widget: 'AdvancedFilter_ModelsFilter',
						template: 'models_advanced_filter',
						'!embed.container': '.filter-models'
					}
				},
				handleWom: {
					applyFilters: {
						widget: '#filter',
						event: 'apply',
						callback: 'applyFilters'
					}
				},
				handleDom: {
					gradeClick: {
						target: 'label.btn',
						event: 'click',
						targetWidget: '#filter',
						callback: 'checkboxGroup'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		activate: function() {
			this.callParent('activate', arguments);
			this.dlExternalLoad();
		},

		running: function () {
			this.callParent('running', arguments);
			this.dlExternalLoad();
		},

		dlExternalLoad: function() {
			var externalLoad = false;
			fox.each(fox.Navigator.getAll(), function(val, key) {
				if (!fox.isNumeric(key)) {
					externalLoad = true;
				} 
			}, this);

			if (!externalLoad) {
				this.rwom1('#preloader').show(this.wom1('#sitesDatalayer').load());
			}
		},

		_checkFilterValue: function (val) {

			if (fox.isArray(val)) {
				return val.length > 0;
			}

			if (fox.isString(val)) {
				if (fox.isNumeric(val)) {
					return (window.parseInt(val) > 0);
				}

				return val.length > 0;
			}

			return val;
		},

		applyFilters: function (filters) {
			
			var page = this.getFilterValue('page');
			var w = this.wom1('#ourSites');
			w.dl.clearAllFilters();
			var pagerPage = page ? w.dl.setCp(page) : w.dl.setCp(1);

			// if (fox.isEmpty(filters)) {
			// 	return;
			// }

			w.dl.addFilter('project', {fields: ['mcpSubscription.project'], values: [1]});
			fox.each(this.filterFields, function (alias) {
				var fAlias = alias.replace(/\_/g, '.');
				var val = this.getFilterValue(alias);

				var prefix = fox.isArray(val) ? '' : '~';
				var values = fox.isArray(val) ? [val] : ['%' + val + '%'];
				
				if (this._checkFilterValue(val)) {
					console.log(prefix + fAlias, values);
					w.dl.addFilter(fAlias, {fields: [prefix + fAlias], values: values});
				}
			}, this);

			this.rwom1('#preloader').show(w.dl.load());
		},

		getFilterValue: function (filter) {
			var val;
			var values = this.wom1('#filter').filters;

			if (values[filter]) {
				val = values[filter];
			}

			return val;
		},

	
		switchStateMenu: function(name, type) {
			$('#promo-header .menu-link').removeClass('active');
			$('#promo-header .menu-link[data-name="' + name + '"]').toggleClass('active', type);
		},

		resetStateMenus: function() {
			$('#promo-header .menu-link').removeClass('active');
		},

		subscribeFormNotValid: function(res) {
			var througthNotifications = fox.wom.selectFirst('~#throughNotifications');

			througthNotifications.pushNotification({
				noticeTemplate: 'new_notice',
				noticeType: 'error',
				noticeMessage: res.msg,
				noticeAlias: 'subscribeFieldNotValid',
				listenWidgetDeactivate: this,
				delayClose: 3000
			});
		},

		subscribeFormSubmit: function() {
			var form = this.wom1('#subscribeForm');
			form.submit();
			form.ignoreSubmit(true);
		},

		subscribeFormIsSubmitted: function(response, type) {
			var form = this.wom1('#subscribeForm');
			
			if (response.answer.answer.status) {
				var througthNotifications = fox.wom.selectFirst('~#throughNotifications');

				througthNotifications.pushNotification({
					noticeTemplate: 'new_notice',
					noticeType: 'success',
					noticeMessage: 'You have successfully subscribed to the Newsletter!',
					noticeAlias: 'subscribeSuccess',
					listenWidgetDeactivate: this,
					delayClose: 3000
				});

				form.resetForm();
			}

			form.ignoreSubmit(false);
		},

		checkboxGroup: function(el) {
			var elem = $(el).prev();
			var currentCheck = $(elem).prop("checked");
			var group = "input:checkbox[name='mcpSubscription_data_restrictionTagId']";
			$(group).prop("checked",false);
			$(elem).prop("checked", currentCheck);
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";
	fox.registerWidget('PassRecovery_Form', {

		configure: function(options) {
			this.registerOptions('', {
				autoRender: true,
				template: 'forgot_form',
				widgets: {
					forgotPassword: {
						widget: 'PasswordRecovery'
					},
					forgotForm: {
						widget: 'Form',
						formContainer: '#recovery-form',
						formElements: {
							email: {
								element: '[name="email"]',
								defaultValue: '',
								autoApply: true,
								validate: [{validator: 'regexp', options: {type: 'emailCaseInsensitive'}, message: 'Wrong email format'}]
							}
						},
						submit: {
							target: '#recovery-form',
							event: 'submit'
						},
						'widgets.validator': {
							widget: 'Easy_Form_Validator',
							formWidget: '@parent',
							hangClassLocation: 'parentNode',
							requiredFields: ['email'],
							defaultValidator: [{
								validator: 'length',
								options: {min: 1},
								message: 'Please fill in required fields'
							}]
						},
						hooks: {
							onResponse: '@parent:formIsSubmitted',
							onSubmit: '@parent:formSubmit'
						},
						handleWom: {
							formError: {
								event: 'formNotValid',
								widget: '@this #validator',
								callback: '@parent:formNotValid'
							}
						}
					}
				},

				handleDom: {
					focus: {
						target: 'input[name]',
						event: 'focus',
						callback: '_handleFocus'
					}
				},

				handleWom: {
					hashValidation: {
						widget: '#forgotPassword',
						event: 'validateHash',
						callback: '_handleHashValidation'
					},
					recoveryEmailResponse: {
						widget: '#forgotPassword',
						event: 'sendRecoveryMail',
						callback: '_handleRecoveringEmailResponse'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.forgotPassword = this.rwom1('#forgotPassword');
			this.notices = fox.wom.selectFirst('~.Layout_Promo_Auth ~#throughNotifications');
		},

		formSubmit: function (values) {
			this.forgotPassword.sendRecoveryMail(values.email);
			var button = fox.dom.selectFirst('.button-with-spinner', this.element);
			fox.dom.addClass('spin', button);
		},

		formNotValid: function (errorsObj) {
			fox.each(errorsObj.errorStack, function (arr, name) {
				var err = arr[0];

				$(this.dom1('[name="' + name + '"]'))
					.parent()
					.find('.error-container')
					.text(err.message);
			}, this);
		},

		formIsSubmitted: function (response) {
			this.form.ignoreSubmit(false);
		},

		_handleFocus: function (el) {
			$(el).parent().removeClass('error').find('.error-container').text('');
		},

		_handleRecoveringEmailResponse: function (response) {
			if (!response.success) {
				this.notices.pushNotification({
					noticeTemplate: 'new_notice',
					noticeType: 'error',
					noticeMessage: response.text,
					noticeAlias: 'loginError',
					delayClose: 3000
				});
				var button = fox.dom.selectFirst('.button-with-spinner', this.element);
				fox.dom.removeClass('spin', button);
			} else {
				$('.fill').text(response.text);
				$('.action-btns').html('<a href="/" class="btn btn-primary">OK</a>').css({'justify-content': 'center'});
			}
		}

	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ }),
/* 211 */
/***/ (function(module, exports) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	fox.registerWidget('Site_Page_Promo', {

		configure: function(options) {
			this.registerOptions('', {
				handleWom: {
					scrolling: {
						widget: '@root #windowScrollHandler',
						event: 'topPointReached',
						callback: 'changeHeaderColor'
					},
					addedToDom: {
						widget: '.Widget',
						event: 'addedToDom',
						callback: 'prepareElements'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		changeHeaderColor: function(param) {
			$('#promo-header').toggleClass('header-bg', param.direction === 1 ? true : false);
		},

		prepareElements: function() {
			fox.wom.selectFirst("@root #windowScrollHandler").enable();
		},

	}, 'Site_Page');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// pk.0.js